
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebfba"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebfba"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $72b03fdf46effee2$export$8cdaa4703948c5e9, (v) => $72b03fdf46effee2$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $72b03fdf46effee2$export$87c99536b1b8cdd8, (v) => $72b03fdf46effee2$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$8cdaa4703948c5e9;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$87c99536b1b8cdd8;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$startTransition(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
}
function $72b03fdf46effee2$var$addTransitionType(type) {
    var transition = $72b03fdf46effee2$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $72b03fdf46effee2$var$startTransition($72b03fdf46effee2$var$addTransitionType.bind(null, type));
}
var $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$8cdaa4703948c5e9 = $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$87c99536b1b8cdd8 = $72b03fdf46effee2$var$addTransitionType;
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = $72b03fdf46effee2$var$startTransition;
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $dca0ddb82b882518$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(559));
    }
}
var $dca0ddb82b882518$var$searchTarget = null, $dca0ddb82b882518$var$searchBoundary = null;
function $dca0ddb82b882518$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($dca0ddb82b882518$var$searchTarget = child, !0) : !1;
}
function $dca0ddb82b882518$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($dca0ddb82b882518$var$searchBoundary = child, !1) : child === target ? (null !== $dca0ddb82b882518$var$searchBoundary && ($dca0ddb82b882518$var$searchTarget = child), !0) : !1;
}
function $dca0ddb82b882518$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($dca0ddb82b882518$var$HostTransitionContext._currentValue = stateHook.memoizedState, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber));
    stateHook = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalLoadPendingKey = "__reactLoad$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
function $dca0ddb82b882518$var$clearPendingLoadOnNode(node) {
    node[$dca0ddb82b882518$var$internalLoadPendingKey] = void 0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
function $dca0ddb82b882518$var$pushMutationContext() {
    var prev = $dca0ddb82b882518$var$viewTransitionMutationContext;
    $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
    return prev;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(element.value)) : $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName), $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$SubmitEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    submitter: 0
}), $dca0ddb82b882518$var$SyntheticSubmitEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$SubmitEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_474) {
            var $dca0ddb82b882518$var$element$jscomp$inline_475 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_475.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = $dca0ddb82b882518$var$isSupported$jscomp$inline_474;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$globalClientIdCounter$1 = 0;
function $dca0ddb82b882518$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $dca0ddb82b882518$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $dca0ddb82b882518$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $dca0ddb82b882518$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $dca0ddb82b882518$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $dca0ddb82b882518$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $dca0ddb82b882518$var$getClassNameByType(defaultClass);
    eventClass = $dca0ddb82b882518$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $dca0ddb82b882518$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE:
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $dca0ddb82b882518$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $dca0ddb82b882518$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $dca0ddb82b882518$var$entangledTransitionTypes = null;
function $dca0ddb82b882518$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && ($dca0ddb82b882518$var$entangledTransitionTypes = null, null !== $dca0ddb82b882518$var$currentEntangledListeners)) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    if (null !== $dca0ddb82b882518$var$entangledTransitionTypes) for(var root$28 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$28;)$dca0ddb82b882518$var$queueTransitionTypes(root$28, $dca0ddb82b882518$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$29;)$dca0ddb82b882518$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $dca0ddb82b882518$var$currentEntangledLane) {
            root$29 = $dca0ddb82b882518$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $dca0ddb82b882518$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $dca0ddb82b882518$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushSuspenseListContext(fiber, newContext) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newContext);
}
function $dca0ddb82b882518$var$popSuspenseListContext(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
}
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && 0 !== ($dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1);
    $dca0ddb82b882518$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$70);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 106) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$73 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$73, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffectEvent: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack());
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            if (null === $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) {
                nextProps = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
                $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $dca0ddb82b882518$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $dca0ddb82b882518$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER;
        return $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
    }
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($dca0ddb82b882518$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $dca0ddb82b882518$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($dca0ddb82b882518$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $dca0ddb82b882518$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
        $dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(suspenseInstance.nextSibling);
    $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
    $dca0ddb82b882518$var$isHydrating = !0;
    $dca0ddb82b882518$var$hydrationErrors = null;
    $dca0ddb82b882518$var$rootOrSingletonContext = !1;
    null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $dca0ddb82b882518$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($dca0ddb82b882518$var$reverseChildren(current), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $dca0ddb82b882518$var$reverseChildren(current)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $dca0ddb82b882518$var$reverseChildren(workInProgress));
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $dca0ddb82b882518$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (workInProgress.stateNode = $dca0ddb82b882518$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $dca0ddb82b882518$var$maySuspendCommit(type, newProps) : $dca0ddb82b882518$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $dca0ddb82b882518$var$now();
                current.sibling = null;
                nextResource = $dca0ddb82b882518$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, workInProgress), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, renderLanes), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = workInProgress));
                $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $dca0ddb82b882518$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $dca0ddb82b882518$var$FragmentInstance(current);
                        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $dca0ddb82b882518$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $dca0ddb82b882518$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1)), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$shouldStartViewTransition = !1, $dca0ddb82b882518$var$appearingViewTransitions = null;
function $dca0ddb82b882518$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $dca0ddb82b882518$var$shouldStartViewTransition = !0;
}
var $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
function $dca0ddb82b882518$var$pushViewTransitionCancelableScope() {
    var prevChildren = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
    $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
function $dca0ddb82b882518$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
    return $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $dca0ddb82b882518$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $dca0ddb82b882518$var$measureInstance(instance).view && (inViewport = !0);
            $dca0ddb82b882518$var$shouldStartViewTransition = !0;
            $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? name : name + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $dca0ddb82b882518$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
}
function $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $dca0ddb82b882518$var$appearingViewTransitions && 0 !== $dca0ddb82b882518$var$appearingViewTransitions.size) {
        var pairs = $dca0ddb82b882518$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $dca0ddb82b882518$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $dca0ddb82b882518$var$appearingViewTransitions ? $dca0ddb82b882518$var$appearingViewTransitions.get(name) : void 0, className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$appearingViewTransitions.delete(name), $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onExit) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$dca0ddb82b882518$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
}
function $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, changedParent.stateNode);
            props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $dca0ddb82b882518$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $dca0ddb82b882518$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
}
function $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $dca0ddb82b882518$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$dca0ddb82b882518$var$viewTransitionHostInstanceIdx], nextMeasurement = $dca0ddb82b882518$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $dca0ddb82b882518$var$viewTransitionCancelableChildren && ($dca0ddb82b882518$var$viewTransitionCancelableChildren = []), $dca0ddb82b882518$var$viewTransitionCancelableChildren.push(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($dca0ddb82b882518$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
            name = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$viewTransitionContextChanged = !1, $dca0ddb82b882518$var$inUpdateViewTransition = !1, $dca0ddb82b882518$var$rootViewTransitionAffected = !1, $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $dca0ddb82b882518$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $dca0ddb82b882518$var$nextEffect;){
        root = $dca0ddb82b882518$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $dca0ddb82b882518$var$nextEffect = JSCompiler_temp) : (committedLanes && $dca0ddb82b882518$var$commitNestedViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $dca0ddb82b882518$var$appearingViewTransitions = null;
}
function $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $dca0ddb82b882518$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $dca0ddb82b882518$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $dca0ddb82b882518$var$nextEffect = current;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = fiber.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                current = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = current;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$dca0ddb82b882518$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($dca0ddb82b882518$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $dca0ddb82b882518$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$dca0ddb82b882518$var$internalHoistableMarker] || current[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                            $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                    $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(root, ""), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            $dca0ddb82b882518$var$tagCaches = null;
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            current = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext && $dca0ddb82b882518$var$inUpdateViewTransition && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionMutationContext = current;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, lanes = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, current = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, $dca0ddb82b882518$var$offscreenSubtreeIsHidden = ii || $dca0ddb82b882518$var$offscreenSubtreeIsHidden, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = root, $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $dca0ddb82b882518$var$offscreenSubtreeIsHidden = lanes, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = current), !ii && $dca0ddb82b882518$var$offscreenDirectParentIsHidden || $dca0ddb82b882518$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $dca0ddb82b882518$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $dca0ddb82b882518$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $dca0ddb82b882518$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $dca0ddb82b882518$var$inUpdateViewTransition = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($dca0ddb82b882518$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $dca0ddb82b882518$var$_enabled = !0, fiber.reset(), $dca0ddb82b882518$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $dca0ddb82b882518$var$measureNestedViewTransitions(parentFiber, !1);
}
function $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $dca0ddb82b882518$var$rootViewTransitionNameCanceled = $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$dca0ddb82b882518$var$viewTransitionContextChanged && !$dca0ddb82b882518$var$rootViewTransitionAffected) {
                finishedWork = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $dca0ddb82b882518$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !0;
            }
            $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1) : $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            oldName = $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $dca0ddb82b882518$var$getViewTransitionName(props, state);
            state = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, state);
            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0, root = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $dca0ddb82b882518$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($dca0ddb82b882518$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $dca0ddb82b882518$var$viewTransitionCancelableChildren), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName);
            $dca0ddb82b882518$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable($dca0ddb82b882518$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $dca0ddb82b882518$var$restoreNestedViewTransitions(parentFiber);
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $dca0ddb82b882518$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $dca0ddb82b882518$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(flags.child, !0), $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $dca0ddb82b882518$var$appearingViewTransitions && ($dca0ddb82b882518$var$appearingViewTransitions = new Map());
                $dca0ddb82b882518$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$pendingViewTransition = null, $dca0ddb82b882518$var$pendingViewTransitionEvents = null, $dca0ddb82b882518$var$pendingTransitionTypes = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $dca0ddb82b882518$var$createViewTransitionInstance($dca0ddb82b882518$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $dca0ddb82b882518$var$pendingViewTransitionEvents && ($dca0ddb82b882518$var$pendingViewTransitionEvents = []);
        $dca0ddb82b882518$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$completeRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        }, $dca0ddb82b882518$var$appearingViewTransitions = null, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $dca0ddb82b882518$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0, subtreeFlags = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($dca0ddb82b882518$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $dca0ddb82b882518$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$getEntangledLanes(root, lanes);
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $dca0ddb82b882518$var$hydrationParentFiber && ($dca0ddb82b882518$var$isHydrating ? ($dca0ddb82b882518$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($dca0ddb82b882518$var$nextHydratableInstance = fiber.stateNode)) : ($dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0));
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $dca0ddb82b882518$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($dca0ddb82b882518$var$pendingTransitionTypes = $dca0ddb82b882518$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($dca0ddb82b882518$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $dca0ddb82b882518$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $dca0ddb82b882518$var$ReactSharedInternals.T;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        updatedLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        try {
            $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $dca0ddb82b882518$var$executionContext = suspendedRetryLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = updatedLanes, $dca0ddb82b882518$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $dca0ddb82b882518$var$pendingEffectsStatus = 1;
    $dca0ddb82b882518$var$shouldStartViewTransition ? $dca0ddb82b882518$var$pendingViewTransition = $dca0ddb82b882518$var$startViewTransition(suspendedState, root.containerInfo, $dca0ddb82b882518$var$pendingTransitionTypes, $dca0ddb82b882518$var$flushMutationEffects, $dca0ddb82b882518$var$flushLayoutEffects, $dca0ddb82b882518$var$flushAfterMutationEffects, $dca0ddb82b882518$var$flushSpawnedWork, $dca0ddb82b882518$var$flushPassiveEffects, $dca0ddb82b882518$var$reportViewTransitionError, null, null) : ($dca0ddb82b882518$var$flushMutationEffects(), $dca0ddb82b882518$var$flushLayoutEffects(), $dca0ddb82b882518$var$flushSpawnedWork());
}
function $dca0ddb82b882518$var$reportViewTransitionError(error) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus) {
        var onRecoverableError = $dca0ddb82b882518$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $dca0ddb82b882518$var$flushAfterMutationEffects() {
    3 === $dca0ddb82b882518$var$pendingEffectsStatus && ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber($dca0ddb82b882518$var$pendingFinishedWork, $dca0ddb82b882518$var$pendingEffectsRoot), $dca0ddb82b882518$var$pendingEffectsStatus = 4);
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$inUpdateViewTransition = $dca0ddb82b882518$var$rootViewTransitionAffected = !1;
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $dca0ddb82b882518$var$selectionInformation;
                var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var committedViewTransition = $dca0ddb82b882518$var$pendingViewTransition;
        $dca0ddb82b882518$var$pendingViewTransition = null;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            passiveSubtreeMask = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $dca0ddb82b882518$var$pendingViewTransitionEvents;
        onRecoverableError = $dca0ddb82b882518$var$pendingTransitionTypes;
        $dca0ddb82b882518$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($dca0ddb82b882518$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null);
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    null !== $dca0ddb82b882518$var$pendingViewTransition && ($dca0ddb82b882518$var$pendingViewTransition.skipTransition(), $dca0ddb82b882518$var$pendingViewTransition = null);
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) ? $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$190, root$190 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL(actionProp);
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1667 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1667 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1667++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1668 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1667], $dca0ddb82b882518$var$domEventName$jscomp$inline_1669 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1668.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1669, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $dca0ddb82b882518$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $dca0ddb82b882518$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $dca0ddb82b882518$var$getParent) : null;
                        null !== reactName && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $dca0ddb82b882518$var$emptyProps = {};
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$dca0ddb82b882518$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$dca0ddb82b882518$var$internalPropsKey] = props;
    $dca0ddb82b882518$var$setInitialProperties(rootContainerInstance, type, props);
    $dca0ddb82b882518$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $dca0ddb82b882518$var$scheduleTimeout, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $dca0ddb82b882518$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $dca0ddb82b882518$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, instance);
}
function $dca0ddb82b882518$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $dca0ddb82b882518$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $dca0ddb82b882518$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $dca0ddb82b882518$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($dca0ddb82b882518$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $dca0ddb82b882518$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($dca0ddb82b882518$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $dca0ddb82b882518$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $dca0ddb82b882518$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $dca0ddb82b882518$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("old", name),
        new: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("new", name)
    };
}
function $dca0ddb82b882518$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $dca0ddb82b882518$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $dca0ddb82b882518$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $dca0ddb82b882518$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $dca0ddb82b882518$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $dca0ddb82b882518$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $dca0ddb82b882518$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $dca0ddb82b882518$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $dca0ddb82b882518$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $dca0ddb82b882518$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $dca0ddb82b882518$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber);
    return $dca0ddb82b882518$var$setFocusIfFocusable(fiber, focusOptions);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$dca0ddb82b882518$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $dca0ddb82b882518$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $dca0ddb82b882518$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$observeChild, observer, void 0, void 0);
};
function $dca0ddb82b882518$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $dca0ddb82b882518$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $dca0ddb82b882518$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $dca0ddb82b882518$var$pendingIntersectionUnobserves = [], $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
function $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $dca0ddb82b882518$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $dca0ddb82b882518$var$intersectionUnobserveScheduled || ($dca0ddb82b882518$var$intersectionUnobserveScheduled = !0, $dca0ddb82b882518$var$requestPostPaintCallback(function() {
        $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
        var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves;
        $dca0ddb82b882518$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $dca0ddb82b882518$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $dca0ddb82b882518$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[0]);
    result = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $dca0ddb82b882518$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchBoundary = $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $dca0ddb82b882518$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(566));
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
            $dca0ddb82b882518$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), $dca0ddb82b882518$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $dca0ddb82b882518$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $dca0ddb82b882518$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    $dca0ddb82b882518$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $dca0ddb82b882518$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $dca0ddb82b882518$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $dca0ddb82b882518$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $dca0ddb82b882518$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $dca0ddb82b882518$var$requestPostPaintCallback(callback) {
    $dca0ddb82b882518$var$localRequestAnimationFrame(function() {
        $dca0ddb82b882518$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $dca0ddb82b882518$var$setProp(instance, type, propKey, null, $dca0ddb82b882518$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $dca0ddb82b882518$var$noop$1 && (instance.onclick = null);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
function $dca0ddb82b882518$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!($dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $dca0ddb82b882518$var$clearPendingLoadOnNode(instance);
            });
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$268 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $dca0ddb82b882518$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, styles$268)), $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$dca0ddb82b882518$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $dca0ddb82b882518$var$clearPendingLoadOnNode.bind(null, key), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $dca0ddb82b882518$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$274)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $dca0ddb82b882518$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $dca0ddb82b882518$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $dca0ddb82b882518$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
function $dca0ddb82b882518$var$onUnsuspendImg() {
    this.imgCount--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $acw62.version;
if ("19.3.1" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2587.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2587.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2587.inject($dca0ddb82b882518$var$internals$jscomp$inline_2586), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $4433d39f12c5883f$export$3f2684e5d7cb1006, (v) => $4433d39f12c5883f$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$3f2684e5d7cb1006;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY ? $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.3.1";

});



parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("4Z6Nd", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3a1220d25e8f9182$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3a1220d25e8f9182$var$_formatMuiErrorMessage.default;
    }
});

var $3a1220d25e8f9182$var$_formatMuiErrorMessage = $3a1220d25e8f9182$require$_interopRequireDefault((parcelRequire("3goXx")));

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3goXx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $26063a188a6d1521$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $26063a188a6d1521$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("4jPsi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3250d9bb994a2d02$var$_default = module.exports.default = '$$material';

});

parcelRegister("2baoW", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1964ad5a35c9e3e3$var$adaptV4Theme;

var $izOUK = parcelRequire("izOUK");
function $1964ad5a35c9e3e3$var$adaptV4Theme(inputTheme) {
    const { defaultProps: defaultProps = {}, mixins: mixins = {}, overrides: overrides = {}, palette: palette = {}, props: props = {}, styleOverrides: styleOverrides = {}, ...other } = inputTheme;
    const theme = {
        ...other,
        components: {}
    };
    // default props
    Object.keys(defaultProps).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = defaultProps[component];
        theme.components[component] = componentValue;
    });
    Object.keys(props).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.defaultProps = props[component];
        theme.components[component] = componentValue;
    });
    // CSS overrides
    Object.keys(styleOverrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = styleOverrides[component];
        theme.components[component] = componentValue;
    });
    Object.keys(overrides).forEach((component)=>{
        const componentValue = theme.components[component] || {};
        componentValue.styleOverrides = overrides[component];
        theme.components[component] = componentValue;
    });
    // theme.spacing
    theme.spacing = (0, $izOUK.createSpacing)(inputTheme.spacing);
    // theme.mixins.gutters
    const breakpoints = (0, $izOUK.createBreakpoints)(inputTheme.breakpoints || {});
    const spacing = theme.spacing;
    theme.mixins = {
        gutters: (styles = {})=>{
            return {
                paddingLeft: spacing(2),
                paddingRight: spacing(2),
                ...styles,
                [breakpoints.up('sm')]: {
                    paddingLeft: spacing(3),
                    paddingRight: spacing(3),
                    ...styles[breakpoints.up('sm')]
                }
            };
        },
        ...mixins
    };
    const { type: typeInput, mode: modeInput, ...paletteRest } = palette;
    const finalMode = modeInput || typeInput || 'light';
    theme.palette = {
        // theme.palette.text.hint
        text: {
            hint: finalMode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.38)'
        },
        mode: finalMode,
        type: finalMode,
        ...paletteRest
    };
    return theme;
}

});
parcelRegister("izOUK", function(module, exports) {
/**
 * @mui/system v9.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d862fd65d58a79bb$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d862fd65d58a79bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d862fd65d58a79bb$var$_exportNames = {
    experimental_sx: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    GlobalStyles: true,
    borders: true,
    breakpoints: true,
    handleBreakpoints: true,
    mergeBreakpointsInOrder: true,
    unstable_resolveBreakpointValues: true,
    cssContainerQueries: true,
    compose: true,
    display: true,
    flexbox: true,
    grid: true,
    palette: true,
    positions: true,
    shadows: true,
    sizing: true,
    spacing: true,
    style: true,
    getPath: true,
    getStyleValue: true,
    typography: true,
    unstable_styleFunctionSx: true,
    unstable_createStyleFunctionSx: true,
    unstable_extendSxProp: true,
    unstable_defaultSxConfig: true,
    unstable_getThemeValue: true,
    Box: true,
    createBox: true,
    createStyled: true,
    styled: true,
    createTheme: true,
    createBreakpoints: true,
    createSpacing: true,
    shape: true,
    useThemeProps: true,
    getThemeProps: true,
    useTheme: true,
    useThemeWithoutDefault: true,
    useMediaQuery: true,
    ThemeProvider: true,
    unstable_memoTheme: true,
    unstable_createCssVarsProvider: true,
    unstable_createGetCssVar: true,
    unstable_cssVarsParser: true,
    unstable_prepareCssVars: true,
    unstable_createCssVarsTheme: true,
    responsivePropType: true,
    RtlProvider: true,
    createContainer: true,
    Container: true,
    Grid: true,
    Stack: true
};
Object.defineProperty(module.exports, "Box", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Box.default;
    }
});
Object.defineProperty(module.exports, "Container", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Container.default;
    }
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "RtlProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_RtlProvider.default;
    }
});
Object.defineProperty(module.exports, "Stack", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $bOOlK.StyledEngineProvider;
    }
});
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "borders", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_borders.default;
    }
});
Object.defineProperty(module.exports, "breakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.default;
    }
});
Object.defineProperty(module.exports, "compose", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_compose.default;
    }
});
Object.defineProperty(module.exports, "createBox", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createBox.default;
    }
});
Object.defineProperty(module.exports, "createBreakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "createContainer", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createContainer.default;
    }
});
Object.defineProperty(module.exports, "createSpacing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createSpacing.default;
    }
});
Object.defineProperty(module.exports, "createStyled", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createStyled.default;
    }
});
Object.defineProperty(module.exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $bOOlK.css;
    }
});
Object.defineProperty(module.exports, "cssContainerQueries", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "display", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_display.default;
    }
});
module.exports.experimental_sx = $d862fd65d58a79bb$var$experimental_sx;
Object.defineProperty(module.exports, "flexbox", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_flexbox.default;
    }
});
Object.defineProperty(module.exports, "getPath", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.getPath;
    }
});
Object.defineProperty(module.exports, "getStyleValue", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.getStyleValue;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeProps.getThemeProps;
    }
});
Object.defineProperty(module.exports, "grid", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssGrid.default;
    }
});
Object.defineProperty(module.exports, "handleBreakpoints", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.handleBreakpoints;
    }
});
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $bOOlK.keyframes;
    }
});
Object.defineProperty(module.exports, "mergeBreakpointsInOrder", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.mergeBreakpointsInOrder;
    }
});
Object.defineProperty(module.exports, "palette", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_palette.default;
    }
});
Object.defineProperty(module.exports, "positions", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_positions.default;
    }
});
Object.defineProperty(module.exports, "responsivePropType", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_responsivePropType.default;
    }
});
Object.defineProperty(module.exports, "shadows", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_shadows.default;
    }
});
Object.defineProperty(module.exports, "shape", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_shape.default;
    }
});
Object.defineProperty(module.exports, "sizing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_sizing.default;
    }
});
Object.defineProperty(module.exports, "spacing", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_spacing.default;
    }
});
Object.defineProperty(module.exports, "style", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_style.default;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "typography", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_typography.default;
    }
});
Object.defineProperty(module.exports, "unstable_createCssVarsProvider", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_createGetCssVar", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_createGetCssVar.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_cssVarsParser", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_cssVarsParser.default;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.unstable_defaultSxConfig;
    }
});
Object.defineProperty(module.exports, "unstable_extendSxProp", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.extendSxProp;
    }
});
Object.defineProperty(module.exports, "unstable_getThemeValue", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_getThemeValue.default;
    }
});
Object.defineProperty(module.exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_memoTheme.default;
    }
});
Object.defineProperty(module.exports, "unstable_prepareCssVars", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "unstable_resolveBreakpointValues", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_breakpoints.resolveBreakpointValues;
    }
});
Object.defineProperty(module.exports, "unstable_styleFunctionSx", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "useMediaQuery", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useMediaQuery.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useTheme.default;
    }
});
Object.defineProperty(module.exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "useThemeWithoutDefault", {
    enumerable: true,
    get: function() {
        return $d862fd65d58a79bb$var$_useThemeWithoutDefault.default;
    }
});

var $d862fd65d58a79bb$var$_formatMuiErrorMessage = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $bOOlK = parcelRequire("bOOlK");

var $d862fd65d58a79bb$var$_GlobalStyles = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("fJztl")));

var $d862fd65d58a79bb$var$_borders = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("7G2Ky")));
Object.keys($d862fd65d58a79bb$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_borders[key];
        }
    });
});

var $d862fd65d58a79bb$var$_breakpoints = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9mzYC")));

var $d862fd65d58a79bb$var$_cssContainerQueries = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("18kGB")));

var $d862fd65d58a79bb$var$_compose = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $d862fd65d58a79bb$var$_display = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("9p2mw")));

var $d862fd65d58a79bb$var$_flexbox = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("fbcSN")));
Object.keys($d862fd65d58a79bb$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_flexbox[key];
        }
    });
});

var $d862fd65d58a79bb$var$_cssGrid = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("bvdLQ")));
Object.keys($d862fd65d58a79bb$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_cssGrid[key];
        }
    });
});

var $d862fd65d58a79bb$var$_palette = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("7Izgs")));
Object.keys($d862fd65d58a79bb$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_palette[key];
        }
    });
});

var $d862fd65d58a79bb$var$_positions = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9cp7R")));
Object.keys($d862fd65d58a79bb$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_positions[key];
        }
    });
});

var $d862fd65d58a79bb$var$_shadows = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("euxvJ")));

var $d862fd65d58a79bb$var$_sizing = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("lk86k")));
Object.keys($d862fd65d58a79bb$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_sizing[key];
        }
    });
});

var $d862fd65d58a79bb$var$_spacing = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("8ZgMs")));
Object.keys($d862fd65d58a79bb$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_spacing[key];
        }
    });
});

var $d862fd65d58a79bb$var$_style = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("fuavR")));

var $d862fd65d58a79bb$var$_typography = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("6a6uc")));
Object.keys($d862fd65d58a79bb$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_typography[key];
        }
    });
});

var $d862fd65d58a79bb$var$_styleFunctionSx = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $d862fd65d58a79bb$var$_getThemeValue = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("fykTt")));

var $d862fd65d58a79bb$var$_Box = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("8XfTG")));
Object.keys($d862fd65d58a79bb$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_Box[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_Box[key];
        }
    });
});

var $d862fd65d58a79bb$var$_createBox = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("7SBe1")));

var $d862fd65d58a79bb$var$_createStyled = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("bbeCr")));
Object.keys($d862fd65d58a79bb$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_createStyled[key];
        }
    });
});

var $d862fd65d58a79bb$var$_styled = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("kpukb")));

var $d862fd65d58a79bb$var$_createTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $d862fd65d58a79bb$var$_createBreakpoints = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $d862fd65d58a79bb$var$_createSpacing = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5pAhk")));

var $d862fd65d58a79bb$var$_shape = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5H6wp")));

var $d862fd65d58a79bb$var$_useThemeProps = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("2LgDM")));

var $d862fd65d58a79bb$var$_useTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("lywMB")));

var $d862fd65d58a79bb$var$_useThemeWithoutDefault = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("f18iq")));

var $d862fd65d58a79bb$var$_useMediaQuery = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("8h4LK")));

var $h61zw = parcelRequire("h61zw");
Object.keys($h61zw).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $h61zw[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $h61zw[key];
        }
    });
});

var $d862fd65d58a79bb$var$_ThemeProvider = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("ixP4k")));

var $d862fd65d58a79bb$var$_memoTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5Ts1H")));

var $d862fd65d58a79bb$var$_createCssVarsProvider = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("3Vfwq")));

var $d862fd65d58a79bb$var$_createGetCssVar = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("hKuOr")));

var $d862fd65d58a79bb$var$_cssVarsParser = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("ejFX8")));

var $d862fd65d58a79bb$var$_prepareCssVars = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("5magr")));

var $d862fd65d58a79bb$var$_createCssVarsTheme = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("73CWR")));

var $d862fd65d58a79bb$var$_responsivePropType = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $d862fd65d58a79bb$var$_RtlProvider = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("9uEev")));
Object.keys($d862fd65d58a79bb$var$_RtlProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_RtlProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_RtlProvider[key];
        }
    });
});

var $1RRq5 = parcelRequire("1RRq5");
Object.keys($1RRq5).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $1RRq5[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $1RRq5[key];
        }
    });
});

var $d862fd65d58a79bb$var$_createContainer = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("689Qv")));

var $d862fd65d58a79bb$var$_Container = $d862fd65d58a79bb$require$_interopRequireWildcard((parcelRequire("jYQTJ")));
Object.keys($d862fd65d58a79bb$var$_Container).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $d862fd65d58a79bb$var$_Container[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $d862fd65d58a79bb$var$_Container[key];
        }
    });
});

var $d862fd65d58a79bb$var$_Grid = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("dy2yf")));

var $gxueG = parcelRequire("gxueG");
Object.keys($gxueG).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $gxueG[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $gxueG[key];
        }
    });
});

var $d862fd65d58a79bb$var$_Stack = $d862fd65d58a79bb$require$_interopRequireDefault((parcelRequire("kgIUX")));

var $106Hq = parcelRequire("106Hq");
Object.keys($106Hq).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($d862fd65d58a79bb$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $106Hq[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $106Hq[key];
        }
    });
});
/* eslint-disable import/export */ /**
 * The `css` function accepts arrays as values for mobile-first responsive styles.
 * Note that this extends to non-theme values also. For example `display=['none', 'block']`
 * will also work.
 */ // TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
function $d862fd65d58a79bb$var$experimental_sx() {
    throw new Error((0, $d862fd65d58a79bb$var$_formatMuiErrorMessage.default)(19));
} /** ----------------- */  /** Layout components */ 

});
parcelRegister("3pEGv", function(module, exports) {
var $27c3440315f0d929$var$cache;
function $27c3440315f0d929$var$_interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var r, c, a = Object.defineProperty, n = {
        __proto__: null,
        "default": e
    };
    if (Object(e) !== e) return n;
    if ($27c3440315f0d929$var$cache || "function" != typeof WeakMap || ($27c3440315f0d929$var$cache = new WeakMap()), $27c3440315f0d929$var$cache) {
        if ($27c3440315f0d929$var$cache.has(e)) return $27c3440315f0d929$var$cache.get(e);
        $27c3440315f0d929$var$cache.set(e, n);
    }
    for(c in e)"default" !== c && ({}).hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]);
    return n;
}
module.exports = $27c3440315f0d929$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("bOOlK", function(module, exports) {
/**
 * @mui/styled-engine v9.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $89ab6b9e702438b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $89ab6b9e702438b4$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $89ab6b9e702438b4$var$_StyledEngineProvider.default;
    }
});
Object.defineProperty(module.exports, "ThemeContext", {
    enumerable: true,
    get: function() {
        return $eP9YU.T;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $jjlaj.css;
    }
});
module.exports.default = void 0;
module.exports.internal_mutateStyles = $89ab6b9e702438b4$var$internal_mutateStyles;
module.exports.internal_serializeStyles = $89ab6b9e702438b4$var$internal_serializeStyles;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $jjlaj.keyframes;
    }
});

var $89ab6b9e702438b4$var$_styled = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("5rflj")));

var $8rteH = parcelRequire("8rteH");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $89ab6b9e702438b4$var$_StyledEngineProvider = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("dDJuN")));

var $89ab6b9e702438b4$var$_GlobalStyles = $89ab6b9e702438b4$require$_interopRequireDefault((parcelRequire("gfxtG")));
// Re-export the public type surface of `@emotion/styled`. Explicit names rather
// than `export type *`: an `export *` (even type-only) is disallowed by the
// `'use client'` Next.js lint rule. Names locally redeclared below intentionally
// shadow Emotion's and are not re-exported here.
function $89ab6b9e702438b4$var$styled(tag, options) {
    // Emotion's `styled` overloads each expect a specific tag/component shape;
    // none accept the broadened `React.ElementType` union, so cast the passthrough.
    const stylesFactory = (0, $89ab6b9e702438b4$var$_styled.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
var $89ab6b9e702438b4$var$_default = module.exports.default = $89ab6b9e702438b4$var$styled;
/**
 * For internal usage in `@mui/system` package
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $89ab6b9e702438b4$var$internal_mutateStyles(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $89ab6b9e702438b4$var$wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function $89ab6b9e702438b4$var$internal_serializeStyles(styles) {
    $89ab6b9e702438b4$var$wrapper[0] = styles;
    return (0, $8rteH.serializeStyles)($89ab6b9e702438b4$var$wrapper);
} // TODO v6 - check if we can drop the unknown, as it breaks the autocomplete
 // For more info on why it was added, see https://github.com/mui/material-ui/pull/26228
 // TODO v6 - check if we can drop the unknown, as it breaks the autocomplete
 // For more info on why it was added, see https://github.com/mui/material-ui/pull/26228
 // Omit variants as a key, because we have a special handling for it
 /** Same as StyledOptions but shouldForwardProp must be a type guard */  /**
 * @typeparam ComponentProps  Props which will be included when withComponent is called
 * @typeparam SpecificComponentProps  Props which will *not* be included when withComponent is called
 */ 

});
parcelRegister("5rflj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3f5b60245567d758$export$2e2bcd8739ae039);

var $dAzjV = parcelRequire("dAzjV");
parcelRequire("3p9rK");

parcelRequire("8rteH");
parcelRequire("2lACw");
parcelRequire("8ajhZ");
parcelRequire("acw62");
parcelRequire("gd942");
var $3f5b60245567d758$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $3f5b60245567d758$export$2e2bcd8739ae039 = (0, $dAzjV.default).bind(null);
$3f5b60245567d758$var$tags.forEach(function(tagName) {
    $3f5b60245567d758$export$2e2bcd8739ae039[tagName] = $3f5b60245567d758$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("dAzjV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4a09088fdc2ec0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");
parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");

var $8ajhZ = parcelRequire("8ajhZ");

var $acw62 = parcelRequire("acw62");

var $gd942 = parcelRequire("gd942");
var $9e4a09088fdc2ec0$var$isBrowser = typeof document !== 'undefined';
var $9e4a09088fdc2ec0$var$isDevelopment = false;
var $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag = (0, $gd942.default);
var $9e4a09088fdc2ec0$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $9e4a09088fdc2ec0$var$testOmitPropsOnStringTag : $9e4a09088fdc2ec0$var$testOmitPropsOnComponent;
};
var $9e4a09088fdc2ec0$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $9e4a09088fdc2ec0$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$9e4a09088fdc2ec0$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $9e4a09088fdc2ec0$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $9e4a09088fdc2ec0$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $eP9YU.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $eP9YU.T));
            }
            if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $8rteH.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $9e4a09088fdc2ec0$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($9e4a09088fdc2ec0$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $9e4a09088fdc2ec0$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $8nd05.default)({}, options, nextOptions, {
                shouldForwardProp: $9e4a09088fdc2ec0$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("jjlaj", function(module, exports) {

$parcel$export(module.exports, "Global", () => $e0f035ab0866fe47$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $e0f035ab0866fe47$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $e0f035ab0866fe47$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("eP9YU")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("eP9YU")).w);

var $eP9YU = parcelRequire("eP9YU");

var $acw62 = parcelRequire("acw62");

var $8ajhZ = parcelRequire("8ajhZ");

var $2lACw = parcelRequire("2lACw");

var $8rteH = parcelRequire("8rteH");
parcelRequire("a9M6v");
parcelRequire("3p9rK");
parcelRequire("iq6RI");

parcelRequire("9ORqK");
var $e0f035ab0866fe47$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $eP9YU.h).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $eP9YU.E);
    createElementArgArray[1] = (0, $eP9YU.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($e0f035ab0866fe47$export$c8a8987d4410bf2d || ($e0f035ab0866fe47$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $e0f035ab0866fe47$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $8rteH.serializeStyles)([
        styles
    ], undefined, $acw62.useContext((0, $eP9YU.T)));
    if (!(0, $eP9YU.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $2lACw.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $8ajhZ.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $e0f035ab0866fe47$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $8rteH.serializeStyles)(args);
}
function $e0f035ab0866fe47$export$d25ddfdf17c3ad3e() {
    var insertable = $e0f035ab0866fe47$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $e0f035ab0866fe47$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $e0f035ab0866fe47$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $8ajhZ.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $e0f035ab0866fe47$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $8ajhZ.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $eP9YU.i) && res !== undefined) rules += res;
        }
        if (!(0, $eP9YU.i)) return rules;
    });
    if (!(0, $eP9YU.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $e0f035ab0866fe47$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $eP9YU.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $8rteH.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $8ajhZ.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $eP9YU.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $e0f035ab0866fe47$var$merge(cache.registered, css, $e0f035ab0866fe47$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $eP9YU.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($e0f035ab0866fe47$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("eP9YU", function(module, exports) {

$parcel$export(module.exports, "a", () => $acad92301ef10c3f$export$407448d2b89b1813);
$parcel$export(module.exports, "i", () => $acad92301ef10c3f$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $acad92301ef10c3f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $acad92301ef10c3f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $acad92301ef10c3f$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $acad92301ef10c3f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $acad92301ef10c3f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $acad92301ef10c3f$export$a9c23c6ac3fc3eca);

var $acw62 = parcelRequire("acw62");

var $a9M6v = parcelRequire("a9M6v");

var $8nd05 = parcelRequire("8nd05");

var $iq6RI = parcelRequire("iq6RI");

var $apDLo = parcelRequire("apDLo");

var $8ajhZ = parcelRequire("8ajhZ");

var $8rteH = parcelRequire("8rteH");

var $2lACw = parcelRequire("2lACw");
var $acad92301ef10c3f$export$407448d2b89b1813 = false;
var $acad92301ef10c3f$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $acad92301ef10c3f$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $a9M6v.default)({
    key: 'css'
}) : null);
var $acad92301ef10c3f$export$e7094788287c5e9b = $acad92301ef10c3f$var$EmotionCacheContext.Provider;
var $acad92301ef10c3f$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
};
var $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$acad92301ef10c3f$export$23f2a1d2818174ef) $acad92301ef10c3f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $acw62.useContext)($acad92301ef10c3f$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $a9M6v.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $acad92301ef10c3f$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $acad92301ef10c3f$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
};
var $acad92301ef10c3f$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $8nd05.default)({}, outerTheme, theme);
};
var $acad92301ef10c3f$var$createCacheWithTheme = /* #__PURE__ */ (0, $iq6RI.default)(function(outerTheme) {
    return (0, $iq6RI.default)(function(theme) {
        return $acad92301ef10c3f$var$getTheme(outerTheme, theme);
    });
});
var $acad92301ef10c3f$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $acad92301ef10c3f$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $acad92301ef10c3f$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $8nd05.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $apDLo.default)(WithTheme, Component);
}
var $acad92301ef10c3f$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $acad92301ef10c3f$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $acad92301ef10c3f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$acad92301ef10c3f$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $acad92301ef10c3f$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $8ajhZ.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $2lACw.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $8ajhZ.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$acad92301ef10c3f$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $acw62.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $acad92301ef10c3f$var$Emotion = /* #__PURE__ */ $acad92301ef10c3f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$acad92301ef10c3f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $8ajhZ.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $8rteH.serializeStyles)(registeredStyles, undefined, $acw62.useContext($acad92301ef10c3f$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($acad92301ef10c3f$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $acad92301ef10c3f$var$typePropName && !$acad92301ef10c3f$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($acad92301ef10c3f$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $acad92301ef10c3f$export$a9c23c6ac3fc3eca = $acad92301ef10c3f$var$Emotion;

});
parcelRegister("a9M6v", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $76500f1a9bc57c92$export$2e2bcd8739ae039);

var $jmRmf = parcelRequire("jmRmf");

var $fm8kz = parcelRequire("fm8kz");

var $iq6RI = parcelRequire("iq6RI");

var $9ffXE = parcelRequire("9ffXE");
var $76500f1a9bc57c92$var$isBrowser = typeof document !== 'undefined';
var $76500f1a9bc57c92$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $fm8kz.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $fm8kz.token)(character)) break;
        (0, $fm8kz.next)();
    }
    return (0, $fm8kz.slice)(begin, (0, $fm8kz.position));
};
var $76500f1a9bc57c92$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $fm8kz.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $fm8kz.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $76500f1a9bc57c92$var$identifierWithPointTracking((0, $fm8kz.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $fm8kz.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $fm8kz.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $fm8kz.from)(character);
    }
    while (character = (0, $fm8kz.next)());
    return parsed;
};
var $76500f1a9bc57c92$var$getRules = function getRules(value, points) {
    return (0, $fm8kz.dealloc)($76500f1a9bc57c92$var$toRules((0, $fm8kz.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $76500f1a9bc57c92$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $76500f1a9bc57c92$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$76500f1a9bc57c92$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $76500f1a9bc57c92$var$fixedElements.set(element, true);
    var points = [];
    var rules = $76500f1a9bc57c92$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $76500f1a9bc57c92$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $76500f1a9bc57c92$var$prefix(value, length) {
    switch((0, $fm8kz.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $fm8kz.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $fm8kz.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MOZ) + value + (0, $fm8kz.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
        // order
        case 6165:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.replace)(value, /(\w+).+(:[^]+)/, (0, $fm8kz.WEBKIT) + 'box-$1$2' + (0, $fm8kz.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-item-' + (0, $fm8kz.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + 'flex-line-pack' + (0, $fm8kz.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $fm8kz.WEBKIT) + 'box-' + (0, $fm8kz.replace)(value, '-grow', '') + (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $fm8kz.WEBKIT) + (0, $fm8kz.replace)(value, /([^-])(transform)/g, '$1' + (0, $fm8kz.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(zoom-|grab)/, (0, $fm8kz.WEBKIT) + '$1'), /(image-set)/, (0, $fm8kz.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $fm8kz.replace)(value, /(image-set\([^]*)/, (0, $fm8kz.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $fm8kz.replace)((0, $fm8kz.replace)(value, /(.+:)(flex-)?(.*)/, (0, $fm8kz.WEBKIT) + 'box-pack:$3' + (0, $fm8kz.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $fm8kz.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $fm8kz.replace)(value, /(.+)-inline(.+)/, (0, $fm8kz.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $fm8kz.strlen)(value) - 1 - length > 6) switch((0, $fm8kz.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $fm8kz.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $fm8kz.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $fm8kz.WEBKIT) + '$2-$3' + '$1' + (0, $fm8kz.MOZ) + ((0, $fm8kz.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $fm8kz.indexof)(value, 'stretch') ? $76500f1a9bc57c92$var$prefix((0, $fm8kz.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $fm8kz.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $fm8kz.charat)(value, (0, $fm8kz.strlen)(value) - 3 - (~(0, $fm8kz.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $fm8kz.replace)(value, ':', ':' + (0, $fm8kz.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $fm8kz.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $fm8kz.WEBKIT) + ((0, $fm8kz.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $fm8kz.WEBKIT) + '$2$3' + '$1' + (0, $fm8kz.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $fm8kz.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + (0, $fm8kz.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $fm8kz.WEBKIT) + value + (0, $fm8kz.MS) + value + value;
    }
    return value;
}
var $76500f1a9bc57c92$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $fm8kz.DECLARATION:
                element["return"] = $76500f1a9bc57c92$var$prefix(element.value, element.length);
                break;
            case 0, $fm8kz.KEYFRAMES:
                return (0, $fm8kz.serialize)([
                    (0, $fm8kz.copy)(element, {
                        value: (0, $fm8kz.replace)(element.value, '@', '@' + (0, $fm8kz.WEBKIT))
                    })
                ], callback);
            case 0, $fm8kz.RULESET:
                if (element.length) return (0, $fm8kz.combine)(element.props, function(value) {
                    switch((0, $fm8kz.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(read-\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $fm8kz.serialize)([
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, ':' + (0, $fm8kz.MOZ) + '$1')
                                    ]
                                }),
                                (0, $fm8kz.copy)(element, {
                                    props: [
                                        (0, $fm8kz.replace)(value, /:(plac\w+)/, (0, $fm8kz.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $76500f1a9bc57c92$var$getServerStylisCache = $76500f1a9bc57c92$var$isBrowser ? undefined : (0, $iq6RI.default)(function() {
    return (0, $9ffXE.default)(function() {
        return {};
    });
});
var $76500f1a9bc57c92$var$defaultStylisPlugins = [
    $76500f1a9bc57c92$var$prefixer
];
var $76500f1a9bc57c92$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($76500f1a9bc57c92$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $76500f1a9bc57c92$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($76500f1a9bc57c92$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $76500f1a9bc57c92$var$compat,
        $76500f1a9bc57c92$var$removeLabel
    ];
    if (!$76500f1a9bc57c92$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $fm8kz.stringify),
            (0, $fm8kz.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $fm8kz.stringify)
        ];
        var _serializer = (0, $fm8kz.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $fm8kz.serialize)((0, $fm8kz.compile)(styles), _serializer);
        };
        var serverStylisCache = $76500f1a9bc57c92$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $jmRmf.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jmRmf", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $e19976245606d3d7$export$9d753cd7ae895cce);
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("fm8kz", function(module, exports) {

$parcel$export(module.exports, "MS", () => $298fb931ed4fbf8b$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $298fb931ed4fbf8b$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $298fb931ed4fbf8b$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $298fb931ed4fbf8b$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $298fb931ed4fbf8b$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $298fb931ed4fbf8b$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $298fb931ed4fbf8b$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $298fb931ed4fbf8b$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $298fb931ed4fbf8b$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $298fb931ed4fbf8b$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $298fb931ed4fbf8b$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $298fb931ed4fbf8b$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $298fb931ed4fbf8b$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $298fb931ed4fbf8b$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $298fb931ed4fbf8b$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $298fb931ed4fbf8b$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $298fb931ed4fbf8b$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $298fb931ed4fbf8b$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $298fb931ed4fbf8b$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $298fb931ed4fbf8b$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $298fb931ed4fbf8b$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $298fb931ed4fbf8b$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $298fb931ed4fbf8b$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $298fb931ed4fbf8b$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $298fb931ed4fbf8b$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $298fb931ed4fbf8b$export$38bcb760f1d4871c);
var $298fb931ed4fbf8b$export$71ad59f2e432cfe8 = "-ms-";
var $298fb931ed4fbf8b$export$2c0f367103c8d01c = "-moz-";
var $298fb931ed4fbf8b$export$39dfd62a25e0fe93 = "-webkit-";
var $298fb931ed4fbf8b$export$a29989082612d0d9 = "comm";
var $298fb931ed4fbf8b$export$aa3a2e812ca8570d = "rule";
var $298fb931ed4fbf8b$export$527d108ccf083c2b = "decl";
var $298fb931ed4fbf8b$export$d3d35020fa5b54f0 = "@page";
var $298fb931ed4fbf8b$export$500415a86c544f73 = "@media";
var $298fb931ed4fbf8b$export$a763edbf796b780a = "@import";
var $298fb931ed4fbf8b$export$2790aeb8b4e5c826 = "@charset";
var $298fb931ed4fbf8b$export$1cc683e23b84b133 = "@viewport";
var $298fb931ed4fbf8b$export$9447a5efea57e862 = "@supports";
var $298fb931ed4fbf8b$export$ef011b4e114b1fba = "@document";
var $298fb931ed4fbf8b$export$6aad947bda0f3f46 = "@namespace";
var $298fb931ed4fbf8b$export$b44a8529a35fcb60 = "@keyframes";
var $298fb931ed4fbf8b$export$2c16de31893252e6 = "@font-face";
var $298fb931ed4fbf8b$export$3d846dd52e150c6f = "@counter-style";
var $298fb931ed4fbf8b$export$22314bfbb57653fe = "@font-feature-values";
var $298fb931ed4fbf8b$export$d773506282b3cfe6 = "@layer";
var $298fb931ed4fbf8b$export$2335f513bbd82c6d = Math.abs;
var $298fb931ed4fbf8b$export$6788812c4e6611e6 = String.fromCharCode;
var $298fb931ed4fbf8b$export$e6e34fd1f2686227 = Object.assign;
function $298fb931ed4fbf8b$export$d6af199866bfb566(e, r) {
    return $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 0)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 1)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 2)) << 2 ^ $298fb931ed4fbf8b$export$a9db5e087081082d(e, 3) : 0;
}
function $298fb931ed4fbf8b$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $298fb931ed4fbf8b$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $298fb931ed4fbf8b$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $298fb931ed4fbf8b$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $298fb931ed4fbf8b$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $298fb931ed4fbf8b$export$36776f635604f274(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$f9084667e487ed46(e) {
    return e.length;
}
function $298fb931ed4fbf8b$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $298fb931ed4fbf8b$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = 1;
var $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1;
var $298fb931ed4fbf8b$export$f24224f1c91d8156 = 0;
var $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0;
var $298fb931ed4fbf8b$export$c0306caf338ac095 = 0;
var $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "";
function $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $298fb931ed4fbf8b$export$53f1d5ea8de3d7c,
        column: $298fb931ed4fbf8b$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $298fb931ed4fbf8b$export$784d13d8ee351f07(e, r) {
    return $298fb931ed4fbf8b$export$e6e34fd1f2686227($298fb931ed4fbf8b$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $298fb931ed4fbf8b$export$eba6f6f03b0a92e7() {
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$232faf9add678146() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 > 0 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, --$298fb931ed4fbf8b$export$5880b8b5730aff45) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3--, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c--;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$48cfd1e771a65c4f() {
    $298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$5880b8b5730aff45 < $298fb931ed4fbf8b$export$f24224f1c91d8156 ? $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45++) : 0;
    if ($298fb931ed4fbf8b$export$4e0c71f277ca26b3++, $298fb931ed4fbf8b$export$c0306caf338ac095 === 10) $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$53f1d5ea8de3d7c++;
    return $298fb931ed4fbf8b$export$c0306caf338ac095;
}
function $298fb931ed4fbf8b$export$4d3fb11e950abb9e() {
    return $298fb931ed4fbf8b$export$a9db5e087081082d($298fb931ed4fbf8b$export$30a86d91af8ff6e6, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$e88cb2efb12ae807() {
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, r) {
    return $298fb931ed4fbf8b$export$2f35ab04d2335697($298fb931ed4fbf8b$export$30a86d91af8ff6e6, e, r);
}
function $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $298fb931ed4fbf8b$export$2de70f21292aac9e(e) {
    return $298fb931ed4fbf8b$export$53f1d5ea8de3d7c = $298fb931ed4fbf8b$export$4e0c71f277ca26b3 = 1, $298fb931ed4fbf8b$export$f24224f1c91d8156 = $298fb931ed4fbf8b$export$36776f635604f274($298fb931ed4fbf8b$export$30a86d91af8ff6e6 = e), $298fb931ed4fbf8b$export$5880b8b5730aff45 = 0, [];
}
function $298fb931ed4fbf8b$export$45918ac1574455b1(e) {
    return $298fb931ed4fbf8b$export$30a86d91af8ff6e6 = "", e;
}
function $298fb931ed4fbf8b$export$410ac95b9ec204b8(e) {
    return $298fb931ed4fbf8b$export$87c2784dc9fc4ab($298fb931ed4fbf8b$export$58adb3bec8346d0f($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1, $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $298fb931ed4fbf8b$export$660b2ee2d4fb4eff(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$5f8c09e3ae6f64e1($298fb931ed4fbf8b$export$2de70f21292aac9e(e)));
}
function $298fb931ed4fbf8b$export$7af1228ff777d175(e) {
    while($298fb931ed4fbf8b$export$c0306caf338ac095 = $298fb931ed4fbf8b$export$4d3fb11e950abb9e())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 33) $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    else break;
    return $298fb931ed4fbf8b$export$9e1725a4cfeada27(e) > 2 || $298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $298fb931ed4fbf8b$export$5f8c09e3ae6f64e1(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$c0306caf338ac095)){
        case 0:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$c0306caf338ac095), e);
            break;
        default:
            $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$c0306caf338ac095), e);
    }
    return e;
}
function $298fb931ed4fbf8b$export$955ba06d119e085e(e, r) {
    while(--r && $298fb931ed4fbf8b$export$48cfd1e771a65c4f())if ($298fb931ed4fbf8b$export$c0306caf338ac095 < 48 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 102 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 57 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 65 || $298fb931ed4fbf8b$export$c0306caf338ac095 > 70 && $298fb931ed4fbf8b$export$c0306caf338ac095 < 97) break;
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$e88cb2efb12ae807() + (r < 6 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() == 32 && $298fb931ed4fbf8b$export$48cfd1e771a65c4f() == 32));
}
function $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())switch($298fb931ed4fbf8b$export$c0306caf338ac095){
        case e:
            return $298fb931ed4fbf8b$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $298fb931ed4fbf8b$export$c889f2fcc19dbf12($298fb931ed4fbf8b$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $298fb931ed4fbf8b$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $298fb931ed4fbf8b$export$48cfd1e771a65c4f();
            break;
    }
    return $298fb931ed4fbf8b$export$5880b8b5730aff45;
}
function $298fb931ed4fbf8b$export$4254d4e2b3745c4c(e, r) {
    while($298fb931ed4fbf8b$export$48cfd1e771a65c4f())if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 57) break;
    else if (e + $298fb931ed4fbf8b$export$c0306caf338ac095 === 84 && $298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $298fb931ed4fbf8b$export$58adb3bec8346d0f(r, $298fb931ed4fbf8b$export$5880b8b5730aff45 - 1) + "*" + $298fb931ed4fbf8b$export$6788812c4e6611e6(e === 47 ? e : $298fb931ed4fbf8b$export$48cfd1e771a65c4f());
}
function $298fb931ed4fbf8b$export$c2ab62c7bf24634(e) {
    while(!$298fb931ed4fbf8b$export$9e1725a4cfeada27($298fb931ed4fbf8b$export$4d3fb11e950abb9e()))$298fb931ed4fbf8b$export$48cfd1e771a65c4f();
    return $298fb931ed4fbf8b$export$58adb3bec8346d0f(e, $298fb931ed4fbf8b$export$5880b8b5730aff45);
}
function $298fb931ed4fbf8b$export$ef7acd7185315e22(e) {
    return $298fb931ed4fbf8b$export$45918ac1574455b1($298fb931ed4fbf8b$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $298fb931ed4fbf8b$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $298fb931ed4fbf8b$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $298fb931ed4fbf8b$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($298fb931ed4fbf8b$export$f8e21b1e77979a08(j += $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $298fb931ed4fbf8b$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $298fb931ed4fbf8b$export$955ba06d119e085e($298fb931ed4fbf8b$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($298fb931ed4fbf8b$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$4a34f930e789283c($298fb931ed4fbf8b$export$4254d4e2b3745c4c($298fb931ed4fbf8b$export$48cfd1e771a65c4f(), $298fb931ed4fbf8b$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $298fb931ed4fbf8b$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $298fb931ed4fbf8b$export$36776f635604f274(j) - l) $298fb931ed4fbf8b$export$10d8903dec122b9d(p > 32 ? $298fb931ed4fbf8b$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $298fb931ed4fbf8b$export$f8483753829ec8f3($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $298fb931ed4fbf8b$export$10d8903dec122b9d(y = $298fb931ed4fbf8b$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $298fb931ed4fbf8b$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $298fb931ed4fbf8b$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(e, y, y, n && $298fb931ed4fbf8b$export$10d8903dec122b9d($298fb931ed4fbf8b$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $298fb931ed4fbf8b$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $298fb931ed4fbf8b$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $298fb931ed4fbf8b$export$232faf9add678146() == 125) continue;
            }
            switch(j += $298fb931ed4fbf8b$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($298fb931ed4fbf8b$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($298fb931ed4fbf8b$export$4d3fb11e950abb9e() === 45) j += $298fb931ed4fbf8b$export$410ac95b9ec204b8($298fb931ed4fbf8b$export$48cfd1e771a65c4f());
                    v = $298fb931ed4fbf8b$export$4d3fb11e950abb9e(), o = l = $298fb931ed4fbf8b$export$36776f635604f274(g = j += $298fb931ed4fbf8b$export$c2ab62c7bf24634($298fb931ed4fbf8b$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $298fb931ed4fbf8b$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $298fb931ed4fbf8b$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $298fb931ed4fbf8b$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $298fb931ed4fbf8b$export$2f35ab04d2335697(e, v + 1, v = $298fb931ed4fbf8b$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $298fb931ed4fbf8b$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, s === 0 ? $298fb931ed4fbf8b$export$aa3a2e812ca8570d : i, f, o, l);
}
function $298fb931ed4fbf8b$export$4a34f930e789283c(e, r, a) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$a29989082612d0d9, $298fb931ed4fbf8b$export$6788812c4e6611e6($298fb931ed4fbf8b$export$eba6f6f03b0a92e7()), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $298fb931ed4fbf8b$export$f8483753829ec8f3(e, r, a, n) {
    return $298fb931ed4fbf8b$export$35059013cd4a06db(e, r, a, $298fb931ed4fbf8b$export$527d108ccf083c2b, $298fb931ed4fbf8b$export$2f35ab04d2335697(e, 0, n), $298fb931ed4fbf8b$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $298fb931ed4fbf8b$export$82e9f45cca5ba907(n, c, s) {
    switch($298fb931ed4fbf8b$export$d6af199866bfb566(n, c)){
        case 5103:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$2c0f367103c8d01c + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-$1$2" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-item-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-line-pack" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-" + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-grow", "") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "box-pack:$3" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-column-align" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$298fb931ed4fbf8b$export$f8e21b1e77979a08(s, "span") ? $298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) : +$298fb931ed4fbf8b$export$4659b591c19bdf3d(s, /\d+/) - +$298fb931ed4fbf8b$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $298fb931ed4fbf8b$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($298fb931ed4fbf8b$export$36776f635604f274(n) - 1 - c > 6) switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$298fb931ed4fbf8b$export$f8e21b1e77979a08(n, "stretch") ? $298fb931ed4fbf8b$export$82e9f45cca5ba907($298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($298fb931ed4fbf8b$export$a9db5e087081082d(n, c + 6) === 121) return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($298fb931ed4fbf8b$export$a9db5e087081082d(n, $298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + ($298fb931ed4fbf8b$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, ":", ":" + $298fb931ed4fbf8b$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $298fb931ed4fbf8b$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $298fb931ed4fbf8b$export$a763edbf796b780a:
        case $298fb931ed4fbf8b$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $298fb931ed4fbf8b$export$a29989082612d0d9:
            return "";
        case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $298fb931ed4fbf8b$export$36776f635604f274(a = $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $298fb931ed4fbf8b$export$5a7767152ae0305f(e) {
    var r = $298fb931ed4fbf8b$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $298fb931ed4fbf8b$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $298fb931ed4fbf8b$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $298fb931ed4fbf8b$export$527d108ccf083c2b:
                n.return = $298fb931ed4fbf8b$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $298fb931ed4fbf8b$export$b44a8529a35fcb60:
                return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                    $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                        value: $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
                if (n.length) return $298fb931ed4fbf8b$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($298fb931ed4fbf8b$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $298fb931ed4fbf8b$export$dfdc1655ccc5b9cb([
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $298fb931ed4fbf8b$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $298fb931ed4fbf8b$export$784d13d8ee351f07(n, {
                                    props: [
                                        $298fb931ed4fbf8b$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $298fb931ed4fbf8b$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $298fb931ed4fbf8b$export$76a88f7de6507443(e) {
    switch(e.type){
        case $298fb931ed4fbf8b$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $298fb931ed4fbf8b$export$1be1fc439b849fdf($298fb931ed4fbf8b$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($298fb931ed4fbf8b$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $298fb931ed4fbf8b$export$2f35ab04d2335697(r, 1, $298fb931ed4fbf8b$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $298fb931ed4fbf8b$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $298fb931ed4fbf8b$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $298fb931ed4fbf8b$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("iq6RI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d68ffb0773f38e18$export$2e2bcd8739ae039);
var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("9ffXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bb1e54ce1bc6efa$export$2e2bcd8739ae039);
function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("apDLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $794b155aeb6b00fd$export$2e2bcd8739ae039);

var $9ORqK = parcelRequire("9ORqK");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $794b155aeb6b00fd$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(targetComponent, sourceComponent);
};

});
parcelRegister("9ORqK", function(module, exports) {
'use strict';

var $2qzd6 = parcelRequire("2qzd6");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$2qzd6.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($2qzd6.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});
parcelRegister("2qzd6", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dNL7g"));

});
parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});




parcelRegister("8ajhZ", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $5f1e384d41b6dbd9$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $5f1e384d41b6dbd9$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $5f1e384d41b6dbd9$export$6f077d94b33a01aa);
var $5f1e384d41b6dbd9$var$isBrowser = typeof document !== 'undefined';
function $5f1e384d41b6dbd9$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5f1e384d41b6dbd9$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5f1e384d41b6dbd9$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5f1e384d41b6dbd9$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5f1e384d41b6dbd9$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5f1e384d41b6dbd9$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5f1e384d41b6dbd9$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("8rteH", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $62578605b07c8dad$export$6321afa313b251b5);

var $4EiWM = parcelRequire("4EiWM");

var $cEIH4 = parcelRequire("cEIH4");

var $9ffXE = parcelRequire("9ffXE");
var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $9ffXE.default)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cEIH4.default)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4EiWM.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}

});
parcelRegister("4EiWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3629985b3ecf741f$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cEIH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $936be3b045ab836e$export$2e2bcd8739ae039);
var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("2lACw", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $1b59f2f50af460c0$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $1b59f2f50af460c0$export$811a713a7276cb9d);

var $acw62 = parcelRequire("acw62");
var $1b59f2f50af460c0$var$isBrowser = typeof document !== 'undefined';
var $1b59f2f50af460c0$var$syncFallback = function syncFallback(create) {
    return create();
};
var $1b59f2f50af460c0$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $1b59f2f50af460c0$export$db21c7ffa21794e7 = !$1b59f2f50af460c0$var$isBrowser ? $1b59f2f50af460c0$var$syncFallback : $1b59f2f50af460c0$var$useInsertionEffect || $1b59f2f50af460c0$var$syncFallback;
var $1b59f2f50af460c0$export$811a713a7276cb9d = $1b59f2f50af460c0$var$useInsertionEffect || $acw62.useLayoutEffect;

});


parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("gd942", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcd4e42ca4163639$export$2e2bcd8739ae039);

var $9ffXE = parcelRequire("9ffXE");
// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $9ffXE.default)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("dDJuN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9ee2355c3bd069c6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9ee2355c3bd069c6$var$_StyledEngineProvider.default;
    }
});

var $9ee2355c3bd069c6$var$_StyledEngineProvider = $9ee2355c3bd069c6$require$_interopRequireDefault((parcelRequire("2BuCw")));

});
parcelRegister("2BuCw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $1e56ca0825dc344f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $1e56ca0825dc344f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TEST_INTERNALS_DO_NOT_USE = void 0;
module.exports.default = $1e56ca0825dc344f$var$StyledEngineProvider;

var $1e56ca0825dc344f$var$React = $1e56ca0825dc344f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1e56ca0825dc344f$var$_propTypes = $1e56ca0825dc344f$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $eP9YU = parcelRequire("eP9YU");

var $1e56ca0825dc344f$var$_cache = $1e56ca0825dc344f$require$_interopRequireDefault((parcelRequire("a9M6v")));

var $jmRmf = parcelRequire("jmRmf");

var $ayMG0 = parcelRequire("ayMG0");
// To fix [Jest performance](https://github.com/mui/material-ui/issues/45638).
const $1e56ca0825dc344f$var$cacheMap = new Map();
// Need to add a private variable to test the generated CSS from Emotion, this is the simplest way to do it.
// We can't test the CSS from `style` tag easily because the `speedy: true` (produce empty text content) is enabled by Emotion.
// Even if we disable it, JSDOM needs extra configuration to be able to parse `@layer` CSS.
/**
 * @internal
 */ const $1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE = module.exports.TEST_INTERNALS_DO_NOT_USE = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $1e56ca0825dc344f$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $1e56ca0825dc344f$var$_cache.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $1e56ca0825dc344f$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $1e56ca0825dc344f$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$1e56ca0825dc344f$var$insertionPoint) {
        $1e56ca0825dc344f$var$insertionPoint = document.createElement('meta');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $1e56ca0825dc344f$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($1e56ca0825dc344f$var$insertionPoint);
    }
}
function $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends $jmRmf.StyleSheet {
            insert(rule, options) {
                if ($1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE.insert) return $1e56ca0825dc344f$var$TEST_INTERNALS_DO_NOT_USE.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $1e56ca0825dc344f$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $1e56ca0825dc344f$var$createEmotionCache({
            // Use a dedicated key for the cascade-layer cache so its generated class
            // names (e.g. `mui-fyswvn`) can never collide with identically-hashed
            // UNLAYERED classes from the default/`injectFirst` cache (key `css`).
            // A collision lets an unlayered `.css-xxx` rule beat the layered one,
            // defeating MUI's own styles.
            key: enableCssLayer ? 'mui' : 'css',
            insertionPoint: injectFirst ? $1e56ca0825dc344f$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $1e56ca0825dc344f$var$StyledEngineProvider(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $1e56ca0825dc344f$var$React.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $1e56ca0825dc344f$var$cacheMap.has(cacheKey)) return $1e56ca0825dc344f$var$cacheMap.get(cacheKey);
        const fresh = $1e56ca0825dc344f$var$getCache(injectFirst, enableCssLayer);
        $1e56ca0825dc344f$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $ayMG0.jsx)($eP9YU.C, {
        value: cache,
        children: children
    }) : children;
}

});
parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("ayMG0", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8rWe0"));

});



parcelRegister("gfxtG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bd48040d38052821$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bd48040d38052821$var$_GlobalStyles.default;
    }
});

var $bd48040d38052821$var$_GlobalStyles = $bd48040d38052821$require$_interopRequireDefault((parcelRequire("bBbjn")));

});
parcelRegister("bBbjn", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $871beca1e2477cf0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $871beca1e2477cf0$var$GlobalStyles;

var $871beca1e2477cf0$var$_propTypes = $871beca1e2477cf0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
function $871beca1e2477cf0$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $871beca1e2477cf0$var$GlobalStyles(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($871beca1e2477cf0$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($jjlaj.Global, {
        styles: globalStyles
    });
}

});



parcelRegister("fJztl", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b7469308f94dcda5$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b7469308f94dcda5$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b7469308f94dcda5$var$_GlobalStyles.default;
    }
});

var $b7469308f94dcda5$var$_GlobalStyles = $b7469308f94dcda5$require$_interopRequireWildcard((parcelRequire("csO1Z")));
Object.keys($b7469308f94dcda5$var$_GlobalStyles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b7469308f94dcda5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b7469308f94dcda5$var$_GlobalStyles[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b7469308f94dcda5$var$_GlobalStyles[key];
        }
    });
});

});
parcelRegister("csO1Z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $912ee8b2b484e556$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $912ee8b2b484e556$var$_propTypes = $912ee8b2b484e556$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bOOlK = parcelRequire("bOOlK");

var $912ee8b2b484e556$var$_useTheme = $912ee8b2b484e556$require$_interopRequireDefault((parcelRequire("lywMB")));

var $ayMG0 = parcelRequire("ayMG0");
function $912ee8b2b484e556$var$wrapGlobalLayer(styles) {
    const serialized = (0, $bOOlK.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $912ee8b2b484e556$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $912ee8b2b484e556$var$_useTheme.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $912ee8b2b484e556$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $912ee8b2b484e556$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $912ee8b2b484e556$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.GlobalStyles, {
        styles: globalStyles
    });
}
var $912ee8b2b484e556$var$_default = module.exports.default = $912ee8b2b484e556$var$GlobalStyles;

});
parcelRegister("lywMB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $fb1633f194eccc90$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $fb1633f194eccc90$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fb1633f194eccc90$var$_useTheme.default;
    }
});

var $fb1633f194eccc90$var$_useTheme = $fb1633f194eccc90$require$_interopRequireWildcard((parcelRequire("cpDNV")));
Object.keys($fb1633f194eccc90$var$_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($fb1633f194eccc90$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $fb1633f194eccc90$var$_useTheme[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $fb1633f194eccc90$var$_useTheme[key];
        }
    });
});

});
parcelRegister("cpDNV", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9096b21b03fc4ec3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.systemDefaultTheme = module.exports.default = void 0;

var $9096b21b03fc4ec3$var$_createTheme = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $9096b21b03fc4ec3$var$_useThemeWithoutDefault = $9096b21b03fc4ec3$require$_interopRequireDefault((parcelRequire("f18iq")));
const $9096b21b03fc4ec3$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $9096b21b03fc4ec3$var$_createTheme.default)();
function $9096b21b03fc4ec3$var$useTheme(defaultTheme = $9096b21b03fc4ec3$var$systemDefaultTheme) {
    return (0, $9096b21b03fc4ec3$var$_useThemeWithoutDefault.default)(defaultTheme);
}
var $9096b21b03fc4ec3$var$_default = module.exports.default = $9096b21b03fc4ec3$var$useTheme;

});
parcelRegister("1dhnG", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $0e247cd7faad5b27$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $0e247cd7faad5b27$var$_applyStyles.default;
    }
});

var $0e247cd7faad5b27$var$_createTheme = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("i6Yz2")));

var $0e247cd7faad5b27$var$_createBreakpoints = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $0e247cd7faad5b27$var$_applyStyles = $0e247cd7faad5b27$require$_interopRequireDefault((parcelRequire("e1wfH")));

});
parcelRegister("i6Yz2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2f7c454ab1ec68c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2f7c454ab1ec68c$var$_deepmerge = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $d2f7c454ab1ec68c$var$_createBreakpoints = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("hVW0x")));

var $d2f7c454ab1ec68c$var$_cssContainerQueries = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("18kGB")));

var $d2f7c454ab1ec68c$var$_shape = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5H6wp")));

var $d2f7c454ab1ec68c$var$_createSpacing = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("5pAhk")));

var $d2f7c454ab1ec68c$var$_styleFunctionSx = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("jUGyl")));

var $d2f7c454ab1ec68c$var$_defaultSxConfig = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("epNpO")));

var $d2f7c454ab1ec68c$var$_applyStyles = $d2f7c454ab1ec68c$require$_interopRequireDefault((parcelRequire("e1wfH")));
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $d2f7c454ab1ec68c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $d2f7c454ab1ec68c$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $d2f7c454ab1ec68c$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $d2f7c454ab1ec68c$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$d2f7c454ab1ec68c$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $d2f7c454ab1ec68c$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $d2f7c454ab1ec68c$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $d2f7c454ab1ec68c$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$d2f7c454ab1ec68c$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $d2f7c454ab1ec68c$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.internal_cache = {};
    return muiTheme;
}
var $d2f7c454ab1ec68c$var$_default = module.exports.default = $d2f7c454ab1ec68c$var$createTheme;

});
parcelRegister("bQ4jM", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $89e7e67df7bfe402$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $89e7e67df7bfe402$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $89e7e67df7bfe402$var$_deepmerge.default;
    }
});

var $89e7e67df7bfe402$var$_deepmerge = $89e7e67df7bfe402$require$_interopRequireWildcard((parcelRequire("7lnJD")));
Object.keys($89e7e67df7bfe402$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($89e7e67df7bfe402$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $89e7e67df7bfe402$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $89e7e67df7bfe402$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("7lnJD", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $558ce7df2a941302$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $558ce7df2a941302$var$deepmerge;
module.exports.isPlainObject = $558ce7df2a941302$var$isPlainObject;

var $558ce7df2a941302$var$React = $558ce7df2a941302$require$_interopRequireWildcard((parcelRequire("acw62")));

var $4jPKB = parcelRequire("4jPKB");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $558ce7df2a941302$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $558ce7df2a941302$var$deepClone(source) {
    if (/*#__PURE__*/ $558ce7df2a941302$var$React.isValidElement(source) || (0, $4jPKB.isValidElementType)(source) || !$558ce7df2a941302$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $558ce7df2a941302$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $558ce7df2a941302$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($558ce7df2a941302$var$isPlainObject(target) && $558ce7df2a941302$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $558ce7df2a941302$var$React.isValidElement(source[key]) || (0, $4jPKB.isValidElementType)(source[key])) output[key] = source[key];
        else if ($558ce7df2a941302$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $558ce7df2a941302$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $558ce7df2a941302$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $558ce7df2a941302$var$isPlainObject(source[key]) ? $558ce7df2a941302$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("4jPKB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("8ZGCM"));

});
parcelRegister("8ZGCM", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $68c5159438cce3ec$export$a7c73072b1a182ae, (v) => $68c5159438cce3ec$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $68c5159438cce3ec$export$9f27bc3417b4524d, (v) => $68c5159438cce3ec$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $68c5159438cce3ec$export$db77ccec0bb4ccac, (v) => $68c5159438cce3ec$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $68c5159438cce3ec$export$8392c0c9d3dcbd35, (v) => $68c5159438cce3ec$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $68c5159438cce3ec$export$ffb0004e005737fa, (v) => $68c5159438cce3ec$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $68c5159438cce3ec$export$b624eff549462981, (v) => $68c5159438cce3ec$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $68c5159438cce3ec$export$7897aa7841a5380c, (v) => $68c5159438cce3ec$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $68c5159438cce3ec$export$602eac185826482c, (v) => $68c5159438cce3ec$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $68c5159438cce3ec$export$e2c29f18771995cb, (v) => $68c5159438cce3ec$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $68c5159438cce3ec$export$5f8d39834fd61797, (v) => $68c5159438cce3ec$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $68c5159438cce3ec$export$74bf444e3cd11ea5, (v) => $68c5159438cce3ec$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $68c5159438cce3ec$export$998bcd577473dd93, (v) => $68c5159438cce3ec$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $68c5159438cce3ec$export$b706b080d889d2c9, (v) => $68c5159438cce3ec$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $68c5159438cce3ec$export$5be5a87408f70ddc, (v) => $68c5159438cce3ec$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $68c5159438cce3ec$export$45a5e7f76e0caa8d, (v) => $68c5159438cce3ec$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $68c5159438cce3ec$export$455c2e768291efa6, (v) => $68c5159438cce3ec$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $68c5159438cce3ec$export$9522e17588c12572, (v) => $68c5159438cce3ec$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $68c5159438cce3ec$export$2110ac352bb060b9, (v) => $68c5159438cce3ec$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $68c5159438cce3ec$export$56885ab8b9c456ab, (v) => $68c5159438cce3ec$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $68c5159438cce3ec$export$d927fcb6adf8f9de, (v) => $68c5159438cce3ec$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $68c5159438cce3ec$export$b82d16f27459e05a, (v) => $68c5159438cce3ec$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $68c5159438cce3ec$export$522c17b4f5e123e8, (v) => $68c5159438cce3ec$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $68c5159438cce3ec$export$1aabd8a0274ecfd6, (v) => $68c5159438cce3ec$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $68c5159438cce3ec$export$3d6c20d97e46b957, (v) => $68c5159438cce3ec$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $68c5159438cce3ec$export$9b621391a187a31a, (v) => $68c5159438cce3ec$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $68c5159438cce3ec$export$f5bbd400c2f4426f, (v) => $68c5159438cce3ec$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68c5159438cce3ec$export$a7c73072b1a182ae;
var $68c5159438cce3ec$export$9f27bc3417b4524d;
var $68c5159438cce3ec$export$db77ccec0bb4ccac;
var $68c5159438cce3ec$export$8392c0c9d3dcbd35;
var $68c5159438cce3ec$export$ffb0004e005737fa;
var $68c5159438cce3ec$export$b624eff549462981;
var $68c5159438cce3ec$export$7897aa7841a5380c;
var $68c5159438cce3ec$export$602eac185826482c;
var $68c5159438cce3ec$export$e2c29f18771995cb;
var $68c5159438cce3ec$export$5f8d39834fd61797;
var $68c5159438cce3ec$export$74bf444e3cd11ea5;
var $68c5159438cce3ec$export$998bcd577473dd93;
var $68c5159438cce3ec$export$b706b080d889d2c9;
var $68c5159438cce3ec$export$5be5a87408f70ddc;
var $68c5159438cce3ec$export$45a5e7f76e0caa8d;
var $68c5159438cce3ec$export$455c2e768291efa6;
var $68c5159438cce3ec$export$9522e17588c12572;
var $68c5159438cce3ec$export$2110ac352bb060b9;
var $68c5159438cce3ec$export$56885ab8b9c456ab;
var $68c5159438cce3ec$export$d927fcb6adf8f9de;
var $68c5159438cce3ec$export$b82d16f27459e05a;
var $68c5159438cce3ec$export$522c17b4f5e123e8;
var $68c5159438cce3ec$export$1aabd8a0274ecfd6;
var $68c5159438cce3ec$export$3d6c20d97e46b957;
var $68c5159438cce3ec$export$9b621391a187a31a;
var $68c5159438cce3ec$export$f5bbd400c2f4426f;
"use strict";
var $68c5159438cce3ec$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $68c5159438cce3ec$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $68c5159438cce3ec$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $68c5159438cce3ec$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $68c5159438cce3ec$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $68c5159438cce3ec$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $68c5159438cce3ec$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $68c5159438cce3ec$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $68c5159438cce3ec$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE:
                    case $68c5159438cce3ec$var$REACT_PROFILER_TYPE:
                    case $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE:
                    case $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE:
                    case $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $68c5159438cce3ec$var$REACT_CONTEXT_TYPE:
                            case $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE:
                            case $68c5159438cce3ec$var$REACT_LAZY_TYPE:
                            case $68c5159438cce3ec$var$REACT_MEMO_TYPE:
                                return object;
                            case $68c5159438cce3ec$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $68c5159438cce3ec$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$68c5159438cce3ec$export$a7c73072b1a182ae = $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
$68c5159438cce3ec$export$9f27bc3417b4524d = $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
$68c5159438cce3ec$export$db77ccec0bb4ccac = $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
$68c5159438cce3ec$export$8392c0c9d3dcbd35 = $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
$68c5159438cce3ec$export$ffb0004e005737fa = $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
$68c5159438cce3ec$export$b624eff549462981 = $68c5159438cce3ec$var$REACT_LAZY_TYPE;
$68c5159438cce3ec$export$7897aa7841a5380c = $68c5159438cce3ec$var$REACT_MEMO_TYPE;
$68c5159438cce3ec$export$602eac185826482c = $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
$68c5159438cce3ec$export$e2c29f18771995cb = $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
$68c5159438cce3ec$export$5f8d39834fd61797 = $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
$68c5159438cce3ec$export$74bf444e3cd11ea5 = $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
$68c5159438cce3ec$export$998bcd577473dd93 = $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
$68c5159438cce3ec$export$b706b080d889d2c9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE;
};
$68c5159438cce3ec$export$5be5a87408f70ddc = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE;
};
$68c5159438cce3ec$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $68c5159438cce3ec$var$REACT_ELEMENT_TYPE;
};
$68c5159438cce3ec$export$455c2e768291efa6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE;
};
$68c5159438cce3ec$export$9522e17588c12572 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE;
};
$68c5159438cce3ec$export$2110ac352bb060b9 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_LAZY_TYPE;
};
$68c5159438cce3ec$export$56885ab8b9c456ab = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_MEMO_TYPE;
};
$68c5159438cce3ec$export$d927fcb6adf8f9de = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PORTAL_TYPE;
};
$68c5159438cce3ec$export$b82d16f27459e05a = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_PROFILER_TYPE;
};
$68c5159438cce3ec$export$522c17b4f5e123e8 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE;
};
$68c5159438cce3ec$export$1aabd8a0274ecfd6 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE;
};
$68c5159438cce3ec$export$3d6c20d97e46b957 = function(object) {
    return $68c5159438cce3ec$var$typeOf(object) === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE;
};
$68c5159438cce3ec$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $68c5159438cce3ec$var$REACT_FRAGMENT_TYPE || type === $68c5159438cce3ec$var$REACT_PROFILER_TYPE || type === $68c5159438cce3ec$var$REACT_STRICT_MODE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_TYPE || type === $68c5159438cce3ec$var$REACT_SUSPENSE_LIST_TYPE || type === $68c5159438cce3ec$var$REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $68c5159438cce3ec$var$REACT_LAZY_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_MEMO_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONTEXT_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CONSUMER_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $68c5159438cce3ec$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$68c5159438cce3ec$export$f5bbd400c2f4426f = $68c5159438cce3ec$var$typeOf;

});




parcelRegister("hVW0x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $d0e4c1a921a97ae9$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $d0e4c1a921a97ae9$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
// Keep in sync with docs/src/pages/customization/breakpoints/breakpoints.md
// #host-reference
const $d0e4c1a921a97ae9$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $d0e4c1a921a97ae9$var$createBreakpoints(breakpoints) {
    const { values: values = {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $d0e4c1a921a97ae9$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    const mediaKeys = [];
    for(let i = 0; i < keys.length; i += 1)mediaKeys.push(up(keys[i]));
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        internal_mediaKeys: mediaKeys,
        ...other
    };
}

});

parcelRegister("18kGB", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0d3695a183c24848$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $0d3695a183c24848$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $0d3695a183c24848$var$_cssContainerQueries = $0d3695a183c24848$require$_interopRequireWildcard((parcelRequire("hkwSq")));

});
parcelRegister("hkwSq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9ddce8fd7553cea$var$cssContainerQueries;
module.exports.getContainerQuery = $c9ddce8fd7553cea$var$getContainerQuery;
module.exports.isCqShorthand = $c9ddce8fd7553cea$var$isCqShorthand;
module.exports.sortContainerQueries = $c9ddce8fd7553cea$var$sortContainerQueries;
const $c9ddce8fd7553cea$var$MIN_WIDTH_PATTERN = /min-width:\s*([0-9.]+)/;
/**
 * WARN: Mutably updates the `css` object.
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 even though 40rem > 300px
 */ function $c9ddce8fd7553cea$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries || !$c9ddce8fd7553cea$var$hasContainerQuery(css)) return css;
    const keys = [];
    for(const key in css)if (key.startsWith('@container')) keys.push(key);
    keys.sort((a, b)=>{
        return +(a.match($c9ddce8fd7553cea$var$MIN_WIDTH_PATTERN)?.[1] || 0) - +(b.match($c9ddce8fd7553cea$var$MIN_WIDTH_PATTERN)?.[1] || 0);
    });
    const result = css;
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        const value = result[key];
        delete result[key];
        result[key] = value;
    }
    return result;
}
function $c9ddce8fd7553cea$var$hasContainerQuery(css) {
    for(const key in css){
        if (key.startsWith('@container')) return true;
    }
    return false;
}
function $c9ddce8fd7553cea$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $c9ddce8fd7553cea$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $c9ddce8fd7553cea$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("5H6wp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $425606f5c9c02d28$var$shape = {
    borderRadius: 4
};
var $425606f5c9c02d28$var$_default = module.exports.default = $425606f5c9c02d28$var$shape;

});

parcelRegister("5pAhk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f0b6db0539d6afd$var$createSpacing;

var $8ZgMs = parcelRequire("8ZgMs");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $3f0b6db0539d6afd$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $8ZgMs.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("8ZgMs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68b10981a323f192$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68b10981a323f192$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68b10981a323f192$var$_spacing.default;
    }
});

var $68b10981a323f192$var$_spacing = $68b10981a323f192$require$_interopRequireWildcard((parcelRequire("lJr29")));
Object.keys($68b10981a323f192$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68b10981a323f192$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68b10981a323f192$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68b10981a323f192$var$_spacing[key];
        }
    });
});

});
parcelRegister("lJr29", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fd22c53f9de5e49d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $fd22c53f9de5e49d$var$createUnarySpacing;
module.exports.createUnaryUnit = $fd22c53f9de5e49d$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getValue = $fd22c53f9de5e49d$var$getValue;
module.exports.paddingKeys = module.exports.padding = module.exports.marginKeys = module.exports.margin = void 0;

var $fd22c53f9de5e49d$var$_responsivePropType = $fd22c53f9de5e49d$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");

var $fuavR = parcelRequire("fuavR");
/* eslint-disable guard-for-in */ const $fd22c53f9de5e49d$var$EMPTY_THEME = {
    internal_cache: {}
};
const $fd22c53f9de5e49d$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $fd22c53f9de5e49d$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $fd22c53f9de5e49d$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
const $fd22c53f9de5e49d$var$CSS_PROPERTIES = {};
for(const key in $fd22c53f9de5e49d$var$properties)$fd22c53f9de5e49d$var$CSS_PROPERTIES[key] = [
    $fd22c53f9de5e49d$var$properties[key]
];
for(const keyProperty in $fd22c53f9de5e49d$var$properties)for(const keyDirection in $fd22c53f9de5e49d$var$directions){
    const property = $fd22c53f9de5e49d$var$properties[keyProperty];
    const direction = $fd22c53f9de5e49d$var$directions[keyDirection];
    const value = Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
    $fd22c53f9de5e49d$var$CSS_PROPERTIES[keyProperty + keyDirection] = value;
}
for(const key in $fd22c53f9de5e49d$var$aliases)$fd22c53f9de5e49d$var$CSS_PROPERTIES[key] = $fd22c53f9de5e49d$var$CSS_PROPERTIES[$fd22c53f9de5e49d$var$aliases[key]];
/** @internal */ const $fd22c53f9de5e49d$var$marginKeys = module.exports.marginKeys = new Set([
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
]);
/** @internal */ const $fd22c53f9de5e49d$var$paddingKeys = module.exports.paddingKeys = new Set([
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
]);
const $fd22c53f9de5e49d$var$spacingKeys = new Set([
    ...$fd22c53f9de5e49d$var$marginKeys,
    ...$fd22c53f9de5e49d$var$paddingKeys
]);
function $fd22c53f9de5e49d$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $fuavR.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $fd22c53f9de5e49d$var$createUnarySpacing(theme) {
    return $fd22c53f9de5e49d$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $fd22c53f9de5e49d$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
// Avoid allocations
const $fd22c53f9de5e49d$var$container = [
    ''
];
function $fd22c53f9de5e49d$var$style(props, keys) {
    const theme = props.theme ?? $fd22c53f9de5e49d$var$EMPTY_THEME;
    const transformer = theme?.internal_cache?.unarySpacing ?? $fd22c53f9de5e49d$var$createUnarySpacing(theme);
    const result = {};
    for(const prop in props){
        if (!keys.has(prop)) continue;
        const cssProperties = $fd22c53f9de5e49d$var$CSS_PROPERTIES[prop] ?? ($fd22c53f9de5e49d$var$container[0] = prop, $fd22c53f9de5e49d$var$container);
        const propValue = props[prop];
        (0, $9mzYC.iterateBreakpoints)(result, props.theme, propValue, (mediaKey, value)=>{
            const target = mediaKey ? result[mediaKey] : result;
            for(let i = 0; i < cssProperties.length; i += 1)target[cssProperties[i]] = $fd22c53f9de5e49d$var$getValue(transformer, value);
        });
    }
    return result;
}
function $fd22c53f9de5e49d$var$marginFn(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$marginKeys);
}
$fd22c53f9de5e49d$var$marginFn.propTypes = {};
$fd22c53f9de5e49d$var$marginFn.filterProps = $fd22c53f9de5e49d$var$marginKeys;
const $fd22c53f9de5e49d$var$margin = module.exports.margin = $fd22c53f9de5e49d$var$marginFn;
function $fd22c53f9de5e49d$var$paddingFn(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$paddingKeys);
}
$fd22c53f9de5e49d$var$paddingFn.propTypes = {};
$fd22c53f9de5e49d$var$paddingFn.filterProps = $fd22c53f9de5e49d$var$paddingKeys;
const $fd22c53f9de5e49d$var$padding = module.exports.padding = $fd22c53f9de5e49d$var$paddingFn;
function $fd22c53f9de5e49d$var$spacingFn(props) {
    return $fd22c53f9de5e49d$var$style(props, $fd22c53f9de5e49d$var$spacingKeys);
}
$fd22c53f9de5e49d$var$spacingFn.propTypes = {};
$fd22c53f9de5e49d$var$spacingFn.filterProps = $fd22c53f9de5e49d$var$spacingKeys;
const $fd22c53f9de5e49d$var$spacing = $fd22c53f9de5e49d$var$spacingFn;
var $fd22c53f9de5e49d$var$_default = module.exports.default = $fd22c53f9de5e49d$var$spacing;

});
parcelRegister("h7FAc", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c773589584969aa7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c773589584969aa7$var$_responsivePropType.default;
    }
});

var $c773589584969aa7$var$_responsivePropType = $c773589584969aa7$require$_interopRequireDefault((parcelRequire("aLDOi")));

});
parcelRegister("aLDOi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7d6d2ca3605e13f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7d6d2ca3605e13f8$var$_propTypes = $7d6d2ca3605e13f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $7d6d2ca3605e13f8$var$responsivePropType = {};
var $7d6d2ca3605e13f8$var$_default = module.exports.default = $7d6d2ca3605e13f8$var$responsivePropType;

});


parcelRegister("9mzYC", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d12135a7affaa27$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d12135a7affaa27$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d12135a7affaa27$var$_breakpoints.default;
    }
});

var $6d12135a7affaa27$var$_breakpoints = $6d12135a7affaa27$require$_interopRequireWildcard((parcelRequire("1D6M1")));
Object.keys($6d12135a7affaa27$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6d12135a7affaa27$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6d12135a7affaa27$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6d12135a7affaa27$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("1D6M1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $12feb01311e15547$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_BREAKPOINTS = void 0;
module.exports.computeBreakpointsBase = $12feb01311e15547$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $12feb01311e15547$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $12feb01311e15547$var$handleBreakpoints;
module.exports.hasBreakpoint = $12feb01311e15547$var$hasBreakpoint;
module.exports.iterateBreakpoints = $12feb01311e15547$var$iterateBreakpoints;
module.exports.mergeBreakpointsInOrder = $12feb01311e15547$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $12feb01311e15547$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $12feb01311e15547$var$resolveBreakpointValues;
module.exports.values = void 0;

var $12feb01311e15547$var$_propTypes = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $12feb01311e15547$var$_isObjectEmpty = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("80x8u")));

var $12feb01311e15547$var$_fastDeepAssign = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("1VH3v")));

var $12feb01311e15547$var$_deepmerge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $12feb01311e15547$var$_merge = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("3naDD")));

var $18kGB = parcelRequire("18kGB");

var $12feb01311e15547$var$_createBreakpoints = $12feb01311e15547$require$_interopRequireDefault((parcelRequire("hVW0x")));
const $12feb01311e15547$var$EMPTY_THEME = {};
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
/** @internal */ const $12feb01311e15547$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $12feb01311e15547$var$DEFAULT_BREAKPOINTS = module.exports.DEFAULT_BREAKPOINTS = (0, $12feb01311e15547$var$_createBreakpoints.default)({
    values: $12feb01311e15547$var$values
});
const $12feb01311e15547$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $12feb01311e15547$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $12feb01311e15547$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const result = {};
    return $12feb01311e15547$var$iterateBreakpoints(result, props.theme, propValue, (mediaKey, value, initialKey)=>{
        const finalValue = styleFromPropValue(value, initialKey);
        if (mediaKey) result[mediaKey] = finalValue;
        else (0, $12feb01311e15547$var$_fastDeepAssign.default)(result, finalValue);
    });
}
function $12feb01311e15547$var$iterateBreakpoints(target, theme, propValue, callback) {
    theme ?? (theme = $12feb01311e15547$var$EMPTY_THEME);
    if (Array.isArray(propValue)) {
        const breakpoints = theme.breakpoints ?? $12feb01311e15547$var$DEFAULT_BREAKPOINTS;
        for(let i = 0; i < propValue.length; i += 1)$12feb01311e15547$var$buildBreakpoint(target, breakpoints.up(breakpoints.keys[i]), propValue[i], undefined, callback);
        return target;
    }
    if (typeof propValue === 'object') {
        const breakpoints = theme.breakpoints ?? $12feb01311e15547$var$DEFAULT_BREAKPOINTS;
        const breakpointValues = breakpoints.values ?? $12feb01311e15547$var$values;
        for(const key in propValue){
            if ((0, $18kGB.isCqShorthand)(breakpoints.keys, key)) {
                const containerKey = (0, $18kGB.getContainerQuery)(theme.containerQueries ? theme : $12feb01311e15547$var$defaultContainerQueries, key);
                if (containerKey) $12feb01311e15547$var$buildBreakpoint(target, containerKey, propValue[key], key, callback);
            } else if (key in breakpointValues) {
                const mediaKey = breakpoints.up(key);
                $12feb01311e15547$var$buildBreakpoint(target, mediaKey, propValue[key], key, callback);
            } else {
                const cssKey = key;
                target[cssKey] = propValue[cssKey];
            }
        }
        return target;
    }
    callback(undefined, propValue);
    return target;
}
function $12feb01311e15547$var$buildBreakpoint(target, mediaKey, value, initialKey, callback) {
    target[mediaKey] ?? (target[mediaKey] = {});
    callback(mediaKey, value, initialKey);
}
function $12feb01311e15547$var$setupBreakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $12feb01311e15547$var$DEFAULT_BREAKPOINTS;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $12feb01311e15547$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
/** @internal */ function $12feb01311e15547$var$createEmptyBreakpointObject(breakpoints = $12feb01311e15547$var$DEFAULT_BREAKPOINTS) {
    const { internal_mediaKeys: mediaKeys } = breakpoints;
    const result = {};
    for(let i = 0; i < mediaKeys.length; i += 1)result[mediaKeys[i]] = {};
    return result;
}
/** @internal */ function $12feb01311e15547$var$removeUnusedBreakpoints(breakpoints, style) {
    const breakpointKeys = breakpoints.internal_mediaKeys;
    for(let i = 0; i < breakpointKeys.length; i += 1){
        const key = breakpointKeys[i];
        if ((0, $12feb01311e15547$var$_isObjectEmpty.default)(style[key])) delete style[key];
    }
    return style;
}
function $12feb01311e15547$var$mergeBreakpointsInOrder(breakpoints, ...styles) {
    const emptyBreakpoints = $12feb01311e15547$var$createEmptyBreakpointObject(breakpoints);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $12feb01311e15547$var$_deepmerge.default)(prev, next), {});
    return $12feb01311e15547$var$removeUnusedBreakpoints(breakpoints, mergedOutput);
}
/** @internal */ function $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $12feb01311e15547$var$resolveBreakpointValues(options) {
    const { values: breakpointValues, breakpoints: themeBreakpoints, base: customBase } = options;
    const base = customBase || $12feb01311e15547$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object' && breakpointValues) {
            const bv = breakpointValues;
            acc[breakpoint] = bv[breakpoint] != null ? bv[breakpoint] : bv[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
function $12feb01311e15547$var$hasBreakpoint(breakpoints, value) {
    if (Array.isArray(value)) return true;
    if (typeof value === 'object' && value !== null) {
        for(let i = 0; i < breakpoints.keys.length; i += 1){
            if (breakpoints.keys[i] in value) return true;
        }
        const valueKeys = Object.keys(value);
        for(let i = 0; i < valueKeys.length; i += 1){
            if ((0, $18kGB.isCqShorthand)(breakpoints.keys, valueKeys[i])) return true;
        }
    }
    return false;
}
var $12feb01311e15547$var$_default = module.exports.default = $12feb01311e15547$var$setupBreakpoints;

});
parcelRegister("80x8u", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5d4806e6920e8889$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5d4806e6920e8889$var$_isObjectEmpty.default;
    }
});

var $5d4806e6920e8889$var$_isObjectEmpty = $5d4806e6920e8889$require$_interopRequireDefault((parcelRequire("3iHyj")));

});
parcelRegister("3iHyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2674d61de232c627$var$isObjectEmpty;
function $2674d61de232c627$var$isObjectEmpty(object) {
    if (object == null) return true;
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}

});


parcelRegister("1VH3v", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $167c833ed0193025$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $167c833ed0193025$var$_fastDeepAssign.default;
    }
});

var $167c833ed0193025$var$_fastDeepAssign = $167c833ed0193025$require$_interopRequireDefault((parcelRequire("kpHdX")));

});
parcelRegister("kpHdX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edc7abd705ef7237$var$fastDeepAssign;
// Based on https://github.com/TehShrike/deepmerge
// Based on https://github.com/fastify/deepmerge
// MIT License
// Copyright (c) 2012 - 2022 James Halliday, Josh Duff, and other contributors of deepmerge
/* eslint-disable no-else-return */ /**
 * Assigns props from one object to another. Focused on performance, only normal objects with no
 * prototype are supported.
 */ function $edc7abd705ef7237$var$fastDeepAssign(target, source) {
    const sourceIsArray = Array.isArray(source);
    const targetIsArray = Array.isArray(target);
    if ($edc7abd705ef7237$var$isPrimitive(source)) return source;
    else if ($edc7abd705ef7237$var$isPrimitiveOrBuiltIn(target)) return $edc7abd705ef7237$var$clone(source);
    else if (sourceIsArray && targetIsArray) return $edc7abd705ef7237$var$mergeArray(target, source);
    else if (sourceIsArray !== targetIsArray) return $edc7abd705ef7237$var$clone(source);
    else return $edc7abd705ef7237$var$mergeObject(target, source);
}
function $edc7abd705ef7237$var$cloneArray(value) {
    let i = 0;
    const il = value.length;
    const result = new Array(il);
    for(i = 0; i < il; i += 1)result[i] = $edc7abd705ef7237$var$clone(value[i]);
    return result;
}
function $edc7abd705ef7237$var$cloneObject(target) {
    const result = {};
    for(const key in target){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        result[key] = $edc7abd705ef7237$var$clone(target[key]);
    }
    return result;
}
function $edc7abd705ef7237$var$mergeArray(target, source) {
    const tl = target.length;
    for(let i = 0; i < source.length; i += 1)target[tl + i] = $edc7abd705ef7237$var$clone(source[i]);
    return target;
}
function $edc7abd705ef7237$var$isMergeableObject(value) {
    return typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
}
function $edc7abd705ef7237$var$isPrimitive(value) {
    return typeof value !== 'object' || value === null;
}
function $edc7abd705ef7237$var$isPrimitiveOrBuiltIn(value) {
    return typeof value !== 'object' || value === null || value instanceof RegExp || value instanceof Date;
}
function $edc7abd705ef7237$var$clone(entry) {
    // eslint-disable-next-line no-nested-ternary
    return $edc7abd705ef7237$var$isMergeableObject(entry) ? Array.isArray(entry) ? $edc7abd705ef7237$var$cloneArray(entry) : $edc7abd705ef7237$var$cloneObject(entry) : entry;
}
function $edc7abd705ef7237$var$mergeObject(target, source) {
    for(const key in source){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        if (key in target) target[key] = $edc7abd705ef7237$var$fastDeepAssign(target[key], source[key]);
        else target[key] = $edc7abd705ef7237$var$clone(source[key]);
    }
    return target;
}

});


parcelRegister("3naDD", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $274bc59c460c5c83$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $274bc59c460c5c83$var$_merge.default;
    }
});

var $274bc59c460c5c83$var$_merge = $274bc59c460c5c83$require$_interopRequireDefault((parcelRequire("jb2Pw")));

});
parcelRegister("jb2Pw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $df613d60ccca226b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $df613d60ccca226b$var$_deepmerge = $df613d60ccca226b$require$_interopRequireDefault((parcelRequire("bQ4jM")));
const $df613d60ccca226b$var$options = {
    clone: false
};
function $df613d60ccca226b$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $df613d60ccca226b$var$_deepmerge.default)(acc, item, $df613d60ccca226b$var$options);
}
var $df613d60ccca226b$var$_default = module.exports.default = $df613d60ccca226b$var$merge;

});




parcelRegister("fuavR", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b461d00304dae97f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b461d00304dae97f$var$_exportNames = {
    style: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b461d00304dae97f$var$_style.default;
    }
});
Object.defineProperty(module.exports, "style", {
    enumerable: true,
    get: function() {
        return $b461d00304dae97f$var$_style.default;
    }
});

var $b461d00304dae97f$var$_style = $b461d00304dae97f$require$_interopRequireWildcard((parcelRequire("5Wz76")));
Object.keys($b461d00304dae97f$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b461d00304dae97f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b461d00304dae97f$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b461d00304dae97f$var$_style[key];
        }
    });
});

});
parcelRegister("5Wz76", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $453d9b5a5bc206c2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $453d9b5a5bc206c2$var$style;
module.exports.getPath = $453d9b5a5bc206c2$var$getPath;
module.exports.getStyleValue = $453d9b5a5bc206c2$var$getStyleValue;
module.exports.getStyleValue2 = $453d9b5a5bc206c2$var$getStyleValue2;

var $453d9b5a5bc206c2$var$_capitalize = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("4O6za")));

var $453d9b5a5bc206c2$var$_responsivePropType = $453d9b5a5bc206c2$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $9mzYC = parcelRequire("9mzYC");
/**
 * TODO(v7): Keep either this one or `getStyleValue2`
 */ function $453d9b5a5bc206c2$var$getStyleValue(themeMapping, transform, valueFinal, userValue = valueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(valueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[valueFinal] || userValue;
    else if (typeof valueFinal === 'string') value = $453d9b5a5bc206c2$var$getPath(themeMapping, valueFinal) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
/**
 * HACK: The `alternateProp` logic is there because our theme looks like this:
 * {
 *   typography: {
 *     fontFamily: 'comic sans',
 *     fontFamilyCode: 'courrier new',
 *   }
 * }
 * And we support targetting:
 * - `typography.fontFamily`     with `sx={{ fontFamily: 'default' }}`
 * - `typography.fontFamilyCode` with `sx={{ fontFamily: 'code' }}`
 *
 * TODO(v7): Refactor our theme to look like this and remove the horrendous logic:
 * {
 *   typography: {
 *     fontFamily: {
 *       default: 'comic sans',
 *       code: 'courrier new',
 *     }
 *   }
 * }
 */ function $453d9b5a5bc206c2$var$getStyleValue2(themeMapping, transform, userValue, alternateProp) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(userValue);
    else if (Array.isArray(themeMapping)) value = themeMapping[userValue] || userValue;
    else if (typeof userValue === 'string') value = $453d9b5a5bc206c2$var$getPath(themeMapping, userValue, true, alternateProp) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $453d9b5a5bc206c2$var$getPath(obj, pathInput, checkVars = true, alternateProp) {
    if (!obj || !pathInput) return null;
    const path = pathInput.split('.');
    // Check if CSS variables are used
    if (obj.vars && checkVars) {
        const val = $453d9b5a5bc206c2$var$getPathImpl(obj.vars, path, alternateProp);
        if (val != null) return val;
    }
    return $453d9b5a5bc206c2$var$getPathImpl(obj, path, alternateProp);
}
function $453d9b5a5bc206c2$var$getPathImpl(object, path, alternateProp) {
    let lastResult = undefined;
    let result = object;
    let index = 0;
    while(index < path.length){
        if (result === null || result === undefined) return result;
        lastResult = result;
        result = result[path[index]];
        index += 1;
    }
    if (alternateProp && result === undefined) {
        const lastKey = path[path.length - 1];
        const alternateKey = `${alternateProp}${lastKey === 'default' ? '' : (0, $453d9b5a5bc206c2$var$_capitalize.default)(lastKey)}`;
        return lastResult?.[alternateKey];
    }
    return result;
}
function $453d9b5a5bc206c2$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $453d9b5a5bc206c2$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (valueFinal)=>{
            const value = $453d9b5a5bc206c2$var$getStyleValue2(themeMapping, transform, valueFinal, prop);
            return cssProperty === false ? value : {
                [cssProperty]: value
            };
        };
        return (0, $9mzYC.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}

});
parcelRegister("4O6za", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3800ecdd7c2cde61$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3800ecdd7c2cde61$var$_capitalize.default;
    }
});

var $3800ecdd7c2cde61$var$_capitalize = $3800ecdd7c2cde61$require$_interopRequireDefault((parcelRequire("afs59")));

});
parcelRegister("afs59", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $776116989b0b93ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $776116989b0b93ea$var$capitalize;

var $776116989b0b93ea$var$_formatMuiErrorMessage = $776116989b0b93ea$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $776116989b0b93ea$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $776116989b0b93ea$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});







parcelRegister("jUGyl", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e7f4416c1e9a283b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx;

var $e7f4416c1e9a283b$var$_fastDeepAssign = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("1VH3v")));

var $fuavR = parcelRequire("fuavR");

var $9mzYC = parcelRequire("9mzYC");

var $18kGB = parcelRequire("18kGB");

var $e7f4416c1e9a283b$var$_defaultSxConfig = $e7f4416c1e9a283b$require$_interopRequireDefault((parcelRequire("epNpO")));
/**
 * The `css` function accepts arrays as values for mobile-first responsive styles.
 * Note that this extends to non-theme values also. For example `display=['none', 'block']`
 * will also works.
 */ /**
 * Map of all CSS pseudo selectors (`:hover`, `:focus`, ...).
 */ /**
 * Map all nested selectors.
 */ /**
 * Map all nested selectors and CSS variables.
 */ /**
 * Map of all available CSS properties (including aliases) and their raw value.
 * Only used internally to map CSS properties to input types (responsive value,
 * theme function or nested) in `SystemCssProperties`.
 */ /**
 * The `SystemStyleObject` defines custom properties that will be transformed to
 * their corresponding values from the `Theme`. Other valid CSS properties are also allowed.
 */ /**
 * The `SxProps` can be either object or function
 */ /* eslint-disable guard-for-in */ const $e7f4416c1e9a283b$var$EMPTY_THEME = {};
// eslint-disable-next-line @typescript-eslint/naming-convention
function $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx() {
    function styleFunctionSx(props) {
        if (!props.sx) return null;
        const { sx: sx, theme: theme = $e7f4416c1e9a283b$var$EMPTY_THEME, nested: nested } = props;
        const config = theme.unstable_sxConfig ?? $e7f4416c1e9a283b$var$_defaultSxConfig.default;
        // Pass argument without loop allocations
        const wrapper = {
            sx: null,
            theme: theme,
            nested: true
        };
        function process(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const breakpoints = theme.breakpoints ?? $9mzYC.DEFAULT_BREAKPOINTS;
            const css = (0, $9mzYC.createEmptyBreakpointObject)(breakpoints);
            for(const styleKey in sxObject){
                const value = $e7f4416c1e9a283b$var$callIfFn(sxObject[styleKey], theme);
                if (value === null || value === undefined) continue;
                if (typeof value !== 'object') {
                    $e7f4416c1e9a283b$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if (config[styleKey]) {
                    $e7f4416c1e9a283b$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if ((0, $9mzYC.hasBreakpoint)(breakpoints, value)) (0, $9mzYC.iterateBreakpoints)(css, props.theme, value, (mediaKey, finalValue)=>{
                    css[mediaKey][styleKey] = finalValue;
                });
                else {
                    wrapper.sx = value;
                    css[styleKey] = styleFunctionSx(wrapper);
                }
            }
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $18kGB.sortContainerQueries)(theme, (0, $9mzYC.removeUnusedBreakpoints)(breakpoints, css))
            };
            return (0, $18kGB.sortContainerQueries)(theme, (0, $9mzYC.removeUnusedBreakpoints)(breakpoints, css));
        }
        return Array.isArray(sx) ? sx.map(process) : process(sx);
    }
    styleFunctionSx.filterProps = [
        'sx'
    ];
    return styleFunctionSx;
}
var $e7f4416c1e9a283b$var$_default = module.exports.default = $e7f4416c1e9a283b$var$unstable_createStyleFunctionSx();
function $e7f4416c1e9a283b$var$setThemeValue(css, prop, value, theme, config) {
    const options = config[prop];
    if (!options) {
        css[prop] = value;
        return;
    }
    if (value == null) return;
    const { themeKey: themeKey } = options;
    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && value === 'inherit') {
        css[prop] = value;
        return;
    }
    const { style: style } = options;
    if (style) {
        (0, $e7f4416c1e9a283b$var$_fastDeepAssign.default)(css, style({
            [prop]: value,
            theme: theme
        }));
        return;
    }
    const { cssProperty: cssProperty = prop, transform: transform } = options;
    const themeMapping = (0, $fuavR.getPath)(theme, themeKey);
    (0, $9mzYC.iterateBreakpoints)(css, theme, value, (mediaKey, valueFinal)=>{
        const finalValue = (0, $fuavR.getStyleValue2)(themeMapping, transform, valueFinal, prop);
        if (cssProperty === false) {
            if (mediaKey) (0, $e7f4416c1e9a283b$var$_fastDeepAssign.default)(css[mediaKey], finalValue);
            else (0, $e7f4416c1e9a283b$var$_fastDeepAssign.default)(css, finalValue);
        } else // eslint-disable-next-line no-lonely-if
        if (mediaKey) css[mediaKey][cssProperty] = finalValue;
        else css[cssProperty] = finalValue;
    });
}
function $e7f4416c1e9a283b$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

});
parcelRegister("epNpO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ZgMs = parcelRequire("8ZgMs");

var $7G2Ky = parcelRequire("7G2Ky");

var $bvdLQ = parcelRequire("bvdLQ");

var $7Izgs = parcelRequire("7Izgs");

var $lk86k = parcelRequire("lk86k");
const $a7e9bb596240d630$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $7G2Ky.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $7G2Ky.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $7Izgs.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $7Izgs.paletteTransform
    },
    // spacing
    p: {
        style: $8ZgMs.padding
    },
    pt: {
        style: $8ZgMs.padding
    },
    pr: {
        style: $8ZgMs.padding
    },
    pb: {
        style: $8ZgMs.padding
    },
    pl: {
        style: $8ZgMs.padding
    },
    px: {
        style: $8ZgMs.padding
    },
    py: {
        style: $8ZgMs.padding
    },
    padding: {
        style: $8ZgMs.padding
    },
    paddingTop: {
        style: $8ZgMs.padding
    },
    paddingRight: {
        style: $8ZgMs.padding
    },
    paddingBottom: {
        style: $8ZgMs.padding
    },
    paddingLeft: {
        style: $8ZgMs.padding
    },
    paddingX: {
        style: $8ZgMs.padding
    },
    paddingY: {
        style: $8ZgMs.padding
    },
    paddingInline: {
        style: $8ZgMs.padding
    },
    paddingInlineStart: {
        style: $8ZgMs.padding
    },
    paddingInlineEnd: {
        style: $8ZgMs.padding
    },
    paddingBlock: {
        style: $8ZgMs.padding
    },
    paddingBlockStart: {
        style: $8ZgMs.padding
    },
    paddingBlockEnd: {
        style: $8ZgMs.padding
    },
    m: {
        style: $8ZgMs.margin
    },
    mt: {
        style: $8ZgMs.margin
    },
    mr: {
        style: $8ZgMs.margin
    },
    mb: {
        style: $8ZgMs.margin
    },
    ml: {
        style: $8ZgMs.margin
    },
    mx: {
        style: $8ZgMs.margin
    },
    my: {
        style: $8ZgMs.margin
    },
    margin: {
        style: $8ZgMs.margin
    },
    marginTop: {
        style: $8ZgMs.margin
    },
    marginRight: {
        style: $8ZgMs.margin
    },
    marginBottom: {
        style: $8ZgMs.margin
    },
    marginLeft: {
        style: $8ZgMs.margin
    },
    marginX: {
        style: $8ZgMs.margin
    },
    marginY: {
        style: $8ZgMs.margin
    },
    marginInline: {
        style: $8ZgMs.margin
    },
    marginInlineStart: {
        style: $8ZgMs.margin
    },
    marginInlineEnd: {
        style: $8ZgMs.margin
    },
    marginBlock: {
        style: $8ZgMs.margin
    },
    marginBlockStart: {
        style: $8ZgMs.margin
    },
    marginBlockEnd: {
        style: $8ZgMs.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $bvdLQ.gap
    },
    rowGap: {
        style: $bvdLQ.rowGap
    },
    columnGap: {
        style: $bvdLQ.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $lk86k.sizingTransform
    },
    maxWidth: {
        style: $lk86k.maxWidth
    },
    minWidth: {
        transform: $lk86k.sizingTransform
    },
    height: {
        transform: $lk86k.sizingTransform
    },
    maxHeight: {
        transform: $lk86k.sizingTransform
    },
    minHeight: {
        transform: $lk86k.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $a7e9bb596240d630$var$_default = module.exports.default = $a7e9bb596240d630$var$defaultSxConfig;

});
parcelRegister("7G2Ky", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $596e96b5ea46c9bd$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $596e96b5ea46c9bd$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $596e96b5ea46c9bd$var$_borders.default;
    }
});

var $596e96b5ea46c9bd$var$_borders = $596e96b5ea46c9bd$require$_interopRequireWildcard((parcelRequire("ey2Y4")));
Object.keys($596e96b5ea46c9bd$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($596e96b5ea46c9bd$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $596e96b5ea46c9bd$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $596e96b5ea46c9bd$var$_borders[key];
        }
    });
});

});
parcelRegister("ey2Y4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a9768b07cfcbed12$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $a9768b07cfcbed12$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $a9768b07cfcbed12$var$_responsivePropType = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("h7FAc")));

var $a9768b07cfcbed12$var$_style = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("fuavR")));

var $a9768b07cfcbed12$var$_compose = $a9768b07cfcbed12$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");
/** @internal */ function $a9768b07cfcbed12$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $a9768b07cfcbed12$var$createBorderStyle(prop, transform) {
    return (0, $a9768b07cfcbed12$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $a9768b07cfcbed12$var$border = module.exports.border = $a9768b07cfcbed12$var$createBorderStyle('border', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderTop = module.exports.borderTop = $a9768b07cfcbed12$var$createBorderStyle('borderTop', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderRight = module.exports.borderRight = $a9768b07cfcbed12$var$createBorderStyle('borderRight', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderBottom = module.exports.borderBottom = $a9768b07cfcbed12$var$createBorderStyle('borderBottom', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderLeft = module.exports.borderLeft = $a9768b07cfcbed12$var$createBorderStyle('borderLeft', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$borderColor = module.exports.borderColor = $a9768b07cfcbed12$var$createBorderStyle('borderColor');
const $a9768b07cfcbed12$var$borderTopColor = module.exports.borderTopColor = $a9768b07cfcbed12$var$createBorderStyle('borderTopColor');
const $a9768b07cfcbed12$var$borderRightColor = module.exports.borderRightColor = $a9768b07cfcbed12$var$createBorderStyle('borderRightColor');
const $a9768b07cfcbed12$var$borderBottomColor = module.exports.borderBottomColor = $a9768b07cfcbed12$var$createBorderStyle('borderBottomColor');
const $a9768b07cfcbed12$var$borderLeftColor = module.exports.borderLeftColor = $a9768b07cfcbed12$var$createBorderStyle('borderLeftColor');
const $a9768b07cfcbed12$var$outline = module.exports.outline = $a9768b07cfcbed12$var$createBorderStyle('outline', $a9768b07cfcbed12$var$borderTransform);
const $a9768b07cfcbed12$var$outlineColor = module.exports.outlineColor = $a9768b07cfcbed12$var$createBorderStyle('outlineColor');
const $a9768b07cfcbed12$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $a9768b07cfcbed12$var$borderRadius;
$a9768b07cfcbed12$var$borderRadius.propTypes = {};
$a9768b07cfcbed12$var$borderRadius.filterProps = [
    'borderRadius'
];
const $a9768b07cfcbed12$var$borders = (0, $a9768b07cfcbed12$var$_compose.default)($a9768b07cfcbed12$var$border, $a9768b07cfcbed12$var$borderTop, $a9768b07cfcbed12$var$borderRight, $a9768b07cfcbed12$var$borderBottom, $a9768b07cfcbed12$var$borderLeft, $a9768b07cfcbed12$var$borderColor, $a9768b07cfcbed12$var$borderTopColor, $a9768b07cfcbed12$var$borderRightColor, $a9768b07cfcbed12$var$borderBottomColor, $a9768b07cfcbed12$var$borderLeftColor, $a9768b07cfcbed12$var$borderRadius, $a9768b07cfcbed12$var$outline, $a9768b07cfcbed12$var$outlineColor);
var $a9768b07cfcbed12$var$_default = module.exports.default = $a9768b07cfcbed12$var$borders;

});
parcelRegister("79Mi4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $535ed5230f7674fe$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $535ed5230f7674fe$var$_compose.default;
    }
});

var $535ed5230f7674fe$var$_compose = $535ed5230f7674fe$require$_interopRequireDefault((parcelRequire("8J1Q9")));

});
parcelRegister("8J1Q9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65a3f4214179460a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $65a3f4214179460a$var$_fastDeepAssign = $65a3f4214179460a$require$_interopRequireDefault((parcelRequire("1VH3v")));
function $65a3f4214179460a$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        const result = {};
        for(const prop in props)if (handlers[prop]) (0, $65a3f4214179460a$var$_fastDeepAssign.default)(result, handlers[prop](props));
        return result;
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $65a3f4214179460a$var$_default = module.exports.default = $65a3f4214179460a$var$compose;

});




parcelRegister("bvdLQ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85fd458c5ff1d64f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $85fd458c5ff1d64f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85fd458c5ff1d64f$var$_cssGrid.default;
    }
});

var $85fd458c5ff1d64f$var$_cssGrid = $85fd458c5ff1d64f$require$_interopRequireWildcard((parcelRequire("guYP5")));
Object.keys($85fd458c5ff1d64f$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($85fd458c5ff1d64f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $85fd458c5ff1d64f$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $85fd458c5ff1d64f$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("guYP5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c02ea0e0a59e3ff1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $c02ea0e0a59e3ff1$var$_style = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("fuavR")));

var $c02ea0e0a59e3ff1$var$_compose = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $8ZgMs = parcelRequire("8ZgMs");

var $9mzYC = parcelRequire("9mzYC");

var $c02ea0e0a59e3ff1$var$_responsivePropType = $c02ea0e0a59e3ff1$require$_interopRequireDefault((parcelRequire("h7FAc")));
const $c02ea0e0a59e3ff1$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $c02ea0e0a59e3ff1$var$gap;
$c02ea0e0a59e3ff1$var$gap.propTypes = {};
$c02ea0e0a59e3ff1$var$gap.filterProps = [
    'gap'
];
const $c02ea0e0a59e3ff1$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $c02ea0e0a59e3ff1$var$columnGap;
$c02ea0e0a59e3ff1$var$columnGap.propTypes = {};
$c02ea0e0a59e3ff1$var$columnGap.filterProps = [
    'columnGap'
];
const $c02ea0e0a59e3ff1$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $8ZgMs.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $8ZgMs.getValue)(transformer, propValue)
            });
        return (0, $9mzYC.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $c02ea0e0a59e3ff1$var$rowGap;
$c02ea0e0a59e3ff1$var$rowGap.propTypes = {};
$c02ea0e0a59e3ff1$var$rowGap.filterProps = [
    'rowGap'
];
const $c02ea0e0a59e3ff1$var$gridColumn = module.exports.gridColumn = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridColumn'
});
const $c02ea0e0a59e3ff1$var$gridRow = module.exports.gridRow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridRow'
});
const $c02ea0e0a59e3ff1$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $c02ea0e0a59e3ff1$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $c02ea0e0a59e3ff1$var$gridAutoRows = module.exports.gridAutoRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridAutoRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $c02ea0e0a59e3ff1$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $c02ea0e0a59e3ff1$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $c02ea0e0a59e3ff1$var$gridArea = module.exports.gridArea = (0, $c02ea0e0a59e3ff1$var$_style.default)({
    prop: 'gridArea'
});
const $c02ea0e0a59e3ff1$var$grid = (0, $c02ea0e0a59e3ff1$var$_compose.default)($c02ea0e0a59e3ff1$var$gap, $c02ea0e0a59e3ff1$var$columnGap, $c02ea0e0a59e3ff1$var$rowGap, $c02ea0e0a59e3ff1$var$gridColumn, $c02ea0e0a59e3ff1$var$gridRow, $c02ea0e0a59e3ff1$var$gridAutoFlow, $c02ea0e0a59e3ff1$var$gridAutoColumns, $c02ea0e0a59e3ff1$var$gridAutoRows, $c02ea0e0a59e3ff1$var$gridTemplateColumns, $c02ea0e0a59e3ff1$var$gridTemplateRows, $c02ea0e0a59e3ff1$var$gridTemplateAreas, $c02ea0e0a59e3ff1$var$gridArea);
var $c02ea0e0a59e3ff1$var$_default = module.exports.default = $c02ea0e0a59e3ff1$var$grid;

});


parcelRegister("7Izgs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $59e7ff3bb6005a45$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $59e7ff3bb6005a45$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $59e7ff3bb6005a45$var$_palette.default;
    }
});

var $59e7ff3bb6005a45$var$_palette = $59e7ff3bb6005a45$require$_interopRequireWildcard((parcelRequire("hQFW7")));
Object.keys($59e7ff3bb6005a45$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($59e7ff3bb6005a45$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $59e7ff3bb6005a45$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $59e7ff3bb6005a45$var$_palette[key];
        }
    });
});

});
parcelRegister("hQFW7", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cfe7d2b3f50e7c96$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $cfe7d2b3f50e7c96$var$paletteTransform;

var $cfe7d2b3f50e7c96$var$_style = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("fuavR")));

var $cfe7d2b3f50e7c96$var$_compose = $cfe7d2b3f50e7c96$require$_interopRequireDefault((parcelRequire("79Mi4")));
/** @internal */ function $cfe7d2b3f50e7c96$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $cfe7d2b3f50e7c96$var$color = module.exports.color = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$bgcolor = module.exports.bgcolor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$backgroundColor = module.exports.backgroundColor = (0, $cfe7d2b3f50e7c96$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $cfe7d2b3f50e7c96$var$paletteTransform
});
const $cfe7d2b3f50e7c96$var$palette = (0, $cfe7d2b3f50e7c96$var$_compose.default)($cfe7d2b3f50e7c96$var$color, $cfe7d2b3f50e7c96$var$bgcolor, $cfe7d2b3f50e7c96$var$backgroundColor);
var $cfe7d2b3f50e7c96$var$_default = module.exports.default = $cfe7d2b3f50e7c96$var$palette;

});


parcelRegister("lk86k", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $f861bfedd540c484$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f861bfedd540c484$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f861bfedd540c484$var$_sizing.default;
    }
});

var $f861bfedd540c484$var$_sizing = $f861bfedd540c484$require$_interopRequireWildcard((parcelRequire("8hW4G")));
Object.keys($f861bfedd540c484$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($f861bfedd540c484$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $f861bfedd540c484$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $f861bfedd540c484$var$_sizing[key];
        }
    });
});

});
parcelRegister("8hW4G", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $608cf5a5bac56020$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $608cf5a5bac56020$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $608cf5a5bac56020$var$sizingTransform;
module.exports.width = void 0;

var $608cf5a5bac56020$var$_style = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("fuavR")));

var $608cf5a5bac56020$var$_compose = $608cf5a5bac56020$require$_interopRequireDefault((parcelRequire("79Mi4")));

var $608cf5a5bac56020$var$_breakpoints = $608cf5a5bac56020$require$_interopRequireWildcard((parcelRequire("9mzYC")));
var $608cf5a5bac56020$var$breakpointsModule = $608cf5a5bac56020$var$_breakpoints;
const $608cf5a5bac56020$var$breakpointsValues = $608cf5a5bac56020$var$breakpointsModule.values;
/** @internal */ function $608cf5a5bac56020$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $608cf5a5bac56020$var$width = module.exports.width = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $608cf5a5bac56020$var$breakpointsValues[propValue];
            if (!breakpoint) return {
                maxWidth: $608cf5a5bac56020$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $608cf5a5bac56020$var$_breakpoints.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $608cf5a5bac56020$var$maxWidth;
$608cf5a5bac56020$var$maxWidth.filterProps = [
    'maxWidth'
];
const $608cf5a5bac56020$var$minWidth = module.exports.minWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minWidth',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$height = module.exports.height = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$maxHeight = module.exports.maxHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'maxHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$minHeight = module.exports.minHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'minHeight',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeWidth = module.exports.sizeWidth = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$sizeHeight = module.exports.sizeHeight = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $608cf5a5bac56020$var$sizingTransform
});
const $608cf5a5bac56020$var$boxSizing = module.exports.boxSizing = (0, $608cf5a5bac56020$var$_style.default)({
    prop: 'boxSizing'
});
const $608cf5a5bac56020$var$sizing = (0, $608cf5a5bac56020$var$_compose.default)($608cf5a5bac56020$var$width, $608cf5a5bac56020$var$maxWidth, $608cf5a5bac56020$var$minWidth, $608cf5a5bac56020$var$height, $608cf5a5bac56020$var$maxHeight, $608cf5a5bac56020$var$minHeight, $608cf5a5bac56020$var$boxSizing);
var $608cf5a5bac56020$var$_default = module.exports.default = $608cf5a5bac56020$var$sizing;

});




parcelRegister("e1wfH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a35a2d48af09cdf6$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $a35a2d48af09cdf6$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("f18iq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $aeed627b69a58b85$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $aeed627b69a58b85$var$_useThemeWithoutDefault.default;
    }
});

var $aeed627b69a58b85$var$_useThemeWithoutDefault = $aeed627b69a58b85$require$_interopRequireDefault((parcelRequire("7zQRf")));

});
parcelRegister("7zQRf", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5844cdc266ab80c7$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5844cdc266ab80c7$var$React = $5844cdc266ab80c7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bOOlK = parcelRequire("bOOlK");
function $5844cdc266ab80c7$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5844cdc266ab80c7$var$useThemeWithoutDefault(defaultTheme = null) {
    const contextTheme = $5844cdc266ab80c7$var$React.useContext($bOOlK.ThemeContext);
    return !contextTheme || $5844cdc266ab80c7$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5844cdc266ab80c7$var$_default = module.exports.default = $5844cdc266ab80c7$var$useThemeWithoutDefault;

});






parcelRegister("9p2mw", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6d8847f8b6214b1a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6d8847f8b6214b1a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6d8847f8b6214b1a$var$_display.default;
    }
});

var $6d8847f8b6214b1a$var$_display = $6d8847f8b6214b1a$require$_interopRequireWildcard((parcelRequire("71hhb")));
Object.keys($6d8847f8b6214b1a$var$_display).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6d8847f8b6214b1a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6d8847f8b6214b1a$var$_display[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6d8847f8b6214b1a$var$_display[key];
        }
    });
});

});
parcelRegister("71hhb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $51c60716a78df046$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.whiteSpace = module.exports.visibility = module.exports.textOverflow = module.exports.overflow = module.exports.displayRaw = module.exports.displayPrint = module.exports.default = void 0;

var $51c60716a78df046$var$_style = $51c60716a78df046$require$_interopRequireDefault((parcelRequire("fuavR")));

var $51c60716a78df046$var$_compose = $51c60716a78df046$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $51c60716a78df046$var$displayPrint = module.exports.displayPrint = (0, $51c60716a78df046$var$_style.default)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: (value)=>({
            '@media print': {
                display: value
            }
        })
});
const $51c60716a78df046$var$displayRaw = module.exports.displayRaw = (0, $51c60716a78df046$var$_style.default)({
    prop: 'display'
});
const $51c60716a78df046$var$overflow = module.exports.overflow = (0, $51c60716a78df046$var$_style.default)({
    prop: 'overflow'
});
const $51c60716a78df046$var$textOverflow = module.exports.textOverflow = (0, $51c60716a78df046$var$_style.default)({
    prop: 'textOverflow'
});
const $51c60716a78df046$var$visibility = module.exports.visibility = (0, $51c60716a78df046$var$_style.default)({
    prop: 'visibility'
});
const $51c60716a78df046$var$whiteSpace = module.exports.whiteSpace = (0, $51c60716a78df046$var$_style.default)({
    prop: 'whiteSpace'
});
const $51c60716a78df046$var$display = (0, $51c60716a78df046$var$_compose.default)($51c60716a78df046$var$displayPrint, $51c60716a78df046$var$displayRaw, $51c60716a78df046$var$overflow, $51c60716a78df046$var$textOverflow, $51c60716a78df046$var$visibility, $51c60716a78df046$var$whiteSpace);
var $51c60716a78df046$var$_default = module.exports.default = $51c60716a78df046$var$display;

});


parcelRegister("fbcSN", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b0d1e058eea97628$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b0d1e058eea97628$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b0d1e058eea97628$var$_flexbox.default;
    }
});

var $b0d1e058eea97628$var$_flexbox = $b0d1e058eea97628$require$_interopRequireWildcard((parcelRequire("44hET")));
Object.keys($b0d1e058eea97628$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b0d1e058eea97628$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b0d1e058eea97628$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b0d1e058eea97628$var$_flexbox[key];
        }
    });
});

});
parcelRegister("44hET", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2f653bbfbf134bed$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.order = module.exports.justifySelf = module.exports.justifyItems = module.exports.justifyContent = module.exports.flexWrap = module.exports.flexShrink = module.exports.flexGrow = module.exports.flexDirection = module.exports.flexBasis = module.exports.flex = module.exports.default = module.exports.alignSelf = module.exports.alignItems = module.exports.alignContent = void 0;

var $2f653bbfbf134bed$var$_style = $2f653bbfbf134bed$require$_interopRequireDefault((parcelRequire("fuavR")));

var $2f653bbfbf134bed$var$_compose = $2f653bbfbf134bed$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $2f653bbfbf134bed$var$flexBasis = module.exports.flexBasis = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexBasis'
});
const $2f653bbfbf134bed$var$flexDirection = module.exports.flexDirection = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexDirection'
});
const $2f653bbfbf134bed$var$flexWrap = module.exports.flexWrap = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexWrap'
});
const $2f653bbfbf134bed$var$justifyContent = module.exports.justifyContent = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifyContent'
});
const $2f653bbfbf134bed$var$alignItems = module.exports.alignItems = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignItems'
});
const $2f653bbfbf134bed$var$alignContent = module.exports.alignContent = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignContent'
});
const $2f653bbfbf134bed$var$order = module.exports.order = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'order'
});
const $2f653bbfbf134bed$var$flex = module.exports.flex = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flex'
});
const $2f653bbfbf134bed$var$flexGrow = module.exports.flexGrow = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexGrow'
});
const $2f653bbfbf134bed$var$flexShrink = module.exports.flexShrink = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'flexShrink'
});
const $2f653bbfbf134bed$var$alignSelf = module.exports.alignSelf = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'alignSelf'
});
const $2f653bbfbf134bed$var$justifyItems = module.exports.justifyItems = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifyItems'
});
const $2f653bbfbf134bed$var$justifySelf = module.exports.justifySelf = (0, $2f653bbfbf134bed$var$_style.default)({
    prop: 'justifySelf'
});
const $2f653bbfbf134bed$var$flexbox = (0, $2f653bbfbf134bed$var$_compose.default)($2f653bbfbf134bed$var$flexBasis, $2f653bbfbf134bed$var$flexDirection, $2f653bbfbf134bed$var$flexWrap, $2f653bbfbf134bed$var$justifyContent, $2f653bbfbf134bed$var$alignItems, $2f653bbfbf134bed$var$alignContent, $2f653bbfbf134bed$var$order, $2f653bbfbf134bed$var$flex, $2f653bbfbf134bed$var$flexGrow, $2f653bbfbf134bed$var$flexShrink, $2f653bbfbf134bed$var$alignSelf, $2f653bbfbf134bed$var$justifyItems, $2f653bbfbf134bed$var$justifySelf);
var $2f653bbfbf134bed$var$_default = module.exports.default = $2f653bbfbf134bed$var$flexbox;

});


parcelRegister("9cp7R", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6b28b985c7e8e846$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6b28b985c7e8e846$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6b28b985c7e8e846$var$_positions.default;
    }
});

var $6b28b985c7e8e846$var$_positions = $6b28b985c7e8e846$require$_interopRequireWildcard((parcelRequire("ijOcq")));
Object.keys($6b28b985c7e8e846$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($6b28b985c7e8e846$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $6b28b985c7e8e846$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $6b28b985c7e8e846$var$_positions[key];
        }
    });
});

});
parcelRegister("ijOcq", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d560f0ea711888c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zIndex = module.exports.top = module.exports.right = module.exports.position = module.exports.left = module.exports.default = module.exports.bottom = void 0;

var $d560f0ea711888c1$var$_style = $d560f0ea711888c1$require$_interopRequireDefault((parcelRequire("fuavR")));

var $d560f0ea711888c1$var$_compose = $d560f0ea711888c1$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $d560f0ea711888c1$var$position = module.exports.position = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'position'
});
const $d560f0ea711888c1$var$zIndex = module.exports.zIndex = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
const $d560f0ea711888c1$var$top = module.exports.top = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'top'
});
const $d560f0ea711888c1$var$right = module.exports.right = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'right'
});
const $d560f0ea711888c1$var$bottom = module.exports.bottom = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'bottom'
});
const $d560f0ea711888c1$var$left = module.exports.left = (0, $d560f0ea711888c1$var$_style.default)({
    prop: 'left'
});
const $d560f0ea711888c1$var$positions = (0, $d560f0ea711888c1$var$_compose.default)($d560f0ea711888c1$var$position, $d560f0ea711888c1$var$zIndex, $d560f0ea711888c1$var$top, $d560f0ea711888c1$var$right, $d560f0ea711888c1$var$bottom, $d560f0ea711888c1$var$left);
var $d560f0ea711888c1$var$_default = module.exports.default = $d560f0ea711888c1$var$positions;

});


parcelRegister("euxvJ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a8cddc970265def5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a8cddc970265def5$var$_shadows.default;
    }
});

var $a8cddc970265def5$var$_shadows = $a8cddc970265def5$require$_interopRequireDefault((parcelRequire("do9dk")));

});
parcelRegister("do9dk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9bf4a9f1ed138aac$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bf4a9f1ed138aac$var$_style = $9bf4a9f1ed138aac$require$_interopRequireDefault((parcelRequire("fuavR")));
const $9bf4a9f1ed138aac$var$boxShadow = (0, $9bf4a9f1ed138aac$var$_style.default)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var $9bf4a9f1ed138aac$var$_default = module.exports.default = $9bf4a9f1ed138aac$var$boxShadow;

});


parcelRegister("6a6uc", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $47c8b53a4e972b5f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $47c8b53a4e972b5f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $47c8b53a4e972b5f$var$_typography.default;
    }
});

var $47c8b53a4e972b5f$var$_typography = $47c8b53a4e972b5f$require$_interopRequireWildcard((parcelRequire("e7BDK")));
Object.keys($47c8b53a4e972b5f$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($47c8b53a4e972b5f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $47c8b53a4e972b5f$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $47c8b53a4e972b5f$var$_typography[key];
        }
    });
});

});
parcelRegister("e7BDK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a47eeaab0be0bf30$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typographyVariant = module.exports.textTransform = module.exports.textAlign = module.exports.lineHeight = module.exports.letterSpacing = module.exports.fontWeight = module.exports.fontStyle = module.exports.fontSize = module.exports.fontFamily = module.exports.default = void 0;

var $a47eeaab0be0bf30$var$_style = $a47eeaab0be0bf30$require$_interopRequireDefault((parcelRequire("fuavR")));

var $a47eeaab0be0bf30$var$_compose = $a47eeaab0be0bf30$require$_interopRequireDefault((parcelRequire("79Mi4")));
const $a47eeaab0be0bf30$var$fontFamily = module.exports.fontFamily = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontSize = module.exports.fontSize = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontSize',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontStyle = module.exports.fontStyle = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$fontWeight = module.exports.fontWeight = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$letterSpacing = module.exports.letterSpacing = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'letterSpacing'
});
const $a47eeaab0be0bf30$var$textTransform = module.exports.textTransform = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'textTransform'
});
const $a47eeaab0be0bf30$var$lineHeight = module.exports.lineHeight = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'lineHeight'
});
const $a47eeaab0be0bf30$var$textAlign = module.exports.textAlign = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'textAlign'
});
const $a47eeaab0be0bf30$var$typographyVariant = module.exports.typographyVariant = (0, $a47eeaab0be0bf30$var$_style.default)({
    prop: 'typography',
    cssProperty: false,
    themeKey: 'typography'
});
const $a47eeaab0be0bf30$var$typography = (0, $a47eeaab0be0bf30$var$_compose.default)($a47eeaab0be0bf30$var$typographyVariant, $a47eeaab0be0bf30$var$fontFamily, $a47eeaab0be0bf30$var$fontSize, $a47eeaab0be0bf30$var$fontStyle, $a47eeaab0be0bf30$var$fontWeight, $a47eeaab0be0bf30$var$letterSpacing, $a47eeaab0be0bf30$var$lineHeight, $a47eeaab0be0bf30$var$textAlign, $a47eeaab0be0bf30$var$textTransform);
var $a47eeaab0be0bf30$var$_default = module.exports.default = $a47eeaab0be0bf30$var$typography;

});


parcelRegister("l6FST", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f5daa5e44059b221$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $f5daa5e44059b221$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $f5daa5e44059b221$var$_defaultSxConfig.default;
    }
});

var $f5daa5e44059b221$var$_styleFunctionSx = $f5daa5e44059b221$require$_interopRequireWildcard((parcelRequire("jUGyl")));

var $f5daa5e44059b221$var$_extendSxProp = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("i3YEE")));

var $f5daa5e44059b221$var$_defaultSxConfig = $f5daa5e44059b221$require$_interopRequireDefault((parcelRequire("epNpO")));

});
parcelRegister("i3YEE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d2678e896d0416ce$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2678e896d0416ce$var$extendSxProp;

var $bQ4jM = parcelRequire("bQ4jM");

var $d2678e896d0416ce$var$_defaultSxConfig = $d2678e896d0416ce$require$_interopRequireDefault((parcelRequire("epNpO")));
const $d2678e896d0416ce$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $d2678e896d0416ce$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $d2678e896d0416ce$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $d2678e896d0416ce$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $bQ4jM.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("fykTt", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $b52a3d10487329b6$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b52a3d10487329b6$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b52a3d10487329b6$var$_getThemeValue.default;
    }
});

var $b52a3d10487329b6$var$_getThemeValue = $b52a3d10487329b6$require$_interopRequireWildcard((parcelRequire("bbSQf")));
Object.keys($b52a3d10487329b6$var$_getThemeValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b52a3d10487329b6$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b52a3d10487329b6$var$_getThemeValue[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b52a3d10487329b6$var$_getThemeValue[key];
        }
    });
});

});
parcelRegister("bbSQf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $825b4332527bbf7e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.styleFunctionMapping = module.exports.propToStyleFunction = module.exports.default = void 0;

var $825b4332527bbf7e$var$_borders = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("7G2Ky")));

var $825b4332527bbf7e$var$_display = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("9p2mw")));

var $825b4332527bbf7e$var$_flexbox = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("fbcSN")));

var $825b4332527bbf7e$var$_cssGrid = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("bvdLQ")));

var $825b4332527bbf7e$var$_positions = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("9cp7R")));

var $825b4332527bbf7e$var$_palette = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("7Izgs")));

var $825b4332527bbf7e$var$_shadows = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("euxvJ")));

var $825b4332527bbf7e$var$_sizing = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("lk86k")));

var $825b4332527bbf7e$var$_spacing = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("8ZgMs")));

var $825b4332527bbf7e$var$_typography = $825b4332527bbf7e$require$_interopRequireDefault((parcelRequire("6a6uc")));
/** @internal */ const $825b4332527bbf7e$var$styleFunctionMapping = module.exports.styleFunctionMapping = {
    borders: $825b4332527bbf7e$var$_borders.default,
    display: $825b4332527bbf7e$var$_display.default,
    flexbox: $825b4332527bbf7e$var$_flexbox.default,
    grid: $825b4332527bbf7e$var$_cssGrid.default,
    positions: $825b4332527bbf7e$var$_positions.default,
    palette: $825b4332527bbf7e$var$_palette.default,
    shadows: $825b4332527bbf7e$var$_shadows.default,
    sizing: $825b4332527bbf7e$var$_sizing.default,
    spacing: $825b4332527bbf7e$var$_spacing.default,
    typography: $825b4332527bbf7e$var$_typography.default
};
/** @internal */ const $825b4332527bbf7e$var$propToStyleFunction = module.exports.propToStyleFunction = Object.keys($825b4332527bbf7e$var$styleFunctionMapping).reduce((acc, styleFnName)=>{
    const styleFunction = $825b4332527bbf7e$var$styleFunctionMapping[styleFnName];
    for (const propName of styleFunction.filterProps)acc[propName] = styleFunction;
    return acc;
}, {});
function $825b4332527bbf7e$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $825b4332527bbf7e$var$propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $825b4332527bbf7e$var$_default = module.exports.default = $825b4332527bbf7e$var$getThemeValue;

});


parcelRegister("8XfTG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $68502a45a27be93d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $68502a45a27be93d$var$_exportNames = {
    boxClasses: true
};
Object.defineProperty(module.exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return $68502a45a27be93d$var$_boxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $68502a45a27be93d$var$_Box.default;
    }
});

var $68502a45a27be93d$var$_Box = $68502a45a27be93d$require$_interopRequireWildcard((parcelRequire("767bZ")));
Object.keys($68502a45a27be93d$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68502a45a27be93d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68502a45a27be93d$var$_Box[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68502a45a27be93d$var$_Box[key];
        }
    });
});

var $68502a45a27be93d$var$_boxClasses = $68502a45a27be93d$require$_interopRequireWildcard((parcelRequire("7b5dP")));
Object.keys($68502a45a27be93d$var$_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($68502a45a27be93d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $68502a45a27be93d$var$_boxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $68502a45a27be93d$var$_boxClasses[key];
        }
    });
});

});
parcelRegister("767bZ", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $52aeac2e4081d4b0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52aeac2e4081d4b0$var$_propTypes = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $52aeac2e4081d4b0$var$_ClassNameGenerator = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("aYaRV")));

var $52aeac2e4081d4b0$var$_createBox = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("7SBe1")));

var $52aeac2e4081d4b0$var$_boxClasses = $52aeac2e4081d4b0$require$_interopRequireDefault((parcelRequire("7b5dP")));
// The SimpleSystemKeys are subset of the AllSystemCSSProperties, so this should be ok
// This is needed as these are used as keys inside AllSystemCSSProperties
/**
 *
 * Demos:
 *
 * - [Box (Material UI)](https://mui.com/material-ui/react-box/)
 * - [Menubar (Material UI)](https://mui.com/material-ui/react-menubar/)
 * - [Box (MUI System)](https://mui.com/system/react-box/)
 *
 * API:
 *
 * - [Box API](https://mui.com/system/api/box/)
 */ const $52aeac2e4081d4b0$var$Box = (0, $52aeac2e4081d4b0$var$_createBox.default)({
    defaultClassName: $52aeac2e4081d4b0$var$_boxClasses.default.root,
    generateClassName: $52aeac2e4081d4b0$var$_ClassNameGenerator.default.generate
});
var $52aeac2e4081d4b0$var$_default = module.exports.default = $52aeac2e4081d4b0$var$Box;

});
parcelRegister("aYaRV", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7fc7f047a82393ea$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7fc7f047a82393ea$var$_ClassNameGenerator.default;
    }
});

var $7fc7f047a82393ea$var$_ClassNameGenerator = $7fc7f047a82393ea$require$_interopRequireDefault((parcelRequire("jyJSW")));

});
parcelRegister("jyJSW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e3d4c91c63801eeb$var$defaultGenerator = (componentName)=>componentName;
const $e3d4c91c63801eeb$var$createClassNameGenerator = ()=>{
    let generate = $e3d4c91c63801eeb$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $e3d4c91c63801eeb$var$defaultGenerator;
        }
    };
};
const $e3d4c91c63801eeb$var$ClassNameGenerator = $e3d4c91c63801eeb$var$createClassNameGenerator();
var $e3d4c91c63801eeb$var$_default = module.exports.default = $e3d4c91c63801eeb$var$ClassNameGenerator;

});


parcelRegister("7SBe1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5bca73b38b7b68b2$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5bca73b38b7b68b2$var$_createBox.default;
    }
});

var $5bca73b38b7b68b2$var$_createBox = $5bca73b38b7b68b2$require$_interopRequireDefault((parcelRequire("310Oe")));

});
parcelRegister("310Oe", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $232217c4f59982d0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $232217c4f59982d0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $232217c4f59982d0$var$createBox;

var $232217c4f59982d0$var$React = $232217c4f59982d0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $232217c4f59982d0$var$_clsx = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("9QePP")));

var $232217c4f59982d0$var$_styledEngine = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("bOOlK")));

var $232217c4f59982d0$var$_styleFunctionSx = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("l6FST")));

var $232217c4f59982d0$var$_useTheme = $232217c4f59982d0$require$_interopRequireDefault((parcelRequire("lywMB")));

var $ayMG0 = parcelRequire("ayMG0");
function $232217c4f59982d0$var$createBox(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $232217c4f59982d0$var$_styledEngine.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })($232217c4f59982d0$var$_styleFunctionSx.default);
    const Box = /*#__PURE__*/ $232217c4f59982d0$var$React.forwardRef(function Box(inProps, ref) {
        const theme = (0, $232217c4f59982d0$var$_useTheme.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = inProps;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $232217c4f59982d0$var$_clsx.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});
parcelRegister("9QePP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $f2ccb2ae3c8742b7$export$2e2bcd8739ae039);
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;

});



parcelRegister("7b5dP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $539d9c7f6e95ee22$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $539d9c7f6e95ee22$var$_generateUtilityClasses = $539d9c7f6e95ee22$require$_interopRequireDefault((parcelRequire("5nY49")));
const $539d9c7f6e95ee22$var$boxClasses = (0, $539d9c7f6e95ee22$var$_generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var $539d9c7f6e95ee22$var$_default = module.exports.default = $539d9c7f6e95ee22$var$boxClasses;

});
parcelRegister("5nY49", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3ebdb19980d19cf7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3ebdb19980d19cf7$var$_generateUtilityClasses.default;
    }
});

var $3ebdb19980d19cf7$var$_generateUtilityClasses = $3ebdb19980d19cf7$require$_interopRequireDefault((parcelRequire("6q0pz")));

});
parcelRegister("6q0pz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ac57d7e2ab16278$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4ac57d7e2ab16278$var$generateUtilityClasses;

var $4ac57d7e2ab16278$var$_generateUtilityClass = $4ac57d7e2ab16278$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $4ac57d7e2ab16278$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $4ac57d7e2ab16278$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("b14cZ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $80530d69cb5af7b9$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $80530d69cb5af7b9$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80530d69cb5af7b9$var$_generateUtilityClass.default;
    }
});

var $80530d69cb5af7b9$var$_generateUtilityClass = $80530d69cb5af7b9$require$_interopRequireWildcard((parcelRequire("8nnml")));
Object.keys($80530d69cb5af7b9$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($80530d69cb5af7b9$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $80530d69cb5af7b9$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $80530d69cb5af7b9$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("8nnml", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $61929767e33fc474$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $61929767e33fc474$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $61929767e33fc474$var$isGlobalState;

var $61929767e33fc474$var$_ClassNameGenerator = $61929767e33fc474$require$_interopRequireDefault((parcelRequire("aYaRV")));
const $61929767e33fc474$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $61929767e33fc474$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $61929767e33fc474$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$61929767e33fc474$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $61929767e33fc474$var$isGlobalState(slot) {
    return $61929767e33fc474$var$globalStateClasses[slot] !== undefined;
}

});







parcelRegister("bbeCr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $823c0fd313341cc1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $823c0fd313341cc1$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $823c0fd313341cc1$var$_createStyled.default;
    }
});

var $823c0fd313341cc1$var$_createStyled = $823c0fd313341cc1$require$_interopRequireWildcard((parcelRequire("b8EC5")));
Object.keys($823c0fd313341cc1$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($823c0fd313341cc1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $823c0fd313341cc1$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $823c0fd313341cc1$var$_createStyled[key];
        }
    });
});

});
parcelRegister("b8EC5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $81bff209823fdfab$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $81bff209823fdfab$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $81bff209823fdfab$var$createStyled;
module.exports.shouldForwardProp = $81bff209823fdfab$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $81bff209823fdfab$var$_styledEngine = $81bff209823fdfab$require$_interopRequireWildcard((parcelRequire("bOOlK")));

var $81bff209823fdfab$var$_isObjectEmpty = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("80x8u")));

var $bQ4jM = parcelRequire("bQ4jM");

var $81bff209823fdfab$var$_capitalize = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("4O6za")));

var $81bff209823fdfab$var$_getDisplayName = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("3cLs1")));

var $81bff209823fdfab$var$_createTheme = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $81bff209823fdfab$var$_styleFunctionSx = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("l6FST")));

var $81bff209823fdfab$var$_preprocessStyles = $81bff209823fdfab$require$_interopRequireDefault((parcelRequire("4bg7U")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $81bff209823fdfab$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $81bff209823fdfab$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $81bff209823fdfab$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $81bff209823fdfab$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $81bff209823fdfab$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = (0, $81bff209823fdfab$var$_isObjectEmpty.default)(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $81bff209823fdfab$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$81bff209823fdfab$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $81bff209823fdfab$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $81bff209823fdfab$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $81bff209823fdfab$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $81bff209823fdfab$var$shallowLayer((0, $81bff209823fdfab$var$_styledEngine.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $81bff209823fdfab$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $81bff209823fdfab$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $81bff209823fdfab$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $81bff209823fdfab$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $81bff209823fdfab$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $81bff209823fdfab$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $81bff209823fdfab$var$defaultOverridesResolver($81bff209823fdfab$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $81bff209823fdfab$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($81bff209823fdfab$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $81bff209823fdfab$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $81bff209823fdfab$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $bQ4jM.isPlainObject)(style)) {
                const serialized = (0, $81bff209823fdfab$var$_preprocessStyles.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $81bff209823fdfab$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $81bff209823fdfab$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $81bff209823fdfab$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $81bff209823fdfab$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push($81bff209823fdfab$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $81bff209823fdfab$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $81bff209823fdfab$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $81bff209823fdfab$var$_getDisplayName.default)(tag)})`;
}
function $81bff209823fdfab$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $81bff209823fdfab$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $81bff209823fdfab$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("3cLs1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $25574cdde2068c11$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $25574cdde2068c11$var$_getDisplayName.default;
    }
});

var $25574cdde2068c11$var$_getDisplayName = $25574cdde2068c11$require$_interopRequireDefault((parcelRequire("98zty")));

});
parcelRegister("98zty", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6a706129b6f614d1$var$getDisplayName;

var $4jPKB = parcelRequire("4jPKB");
function $6a706129b6f614d1$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $6a706129b6f614d1$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $6a706129b6f614d1$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/react/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $6a706129b6f614d1$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $6a706129b6f614d1$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $4jPKB.ForwardRef:
            return $6a706129b6f614d1$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $4jPKB.Memo:
            return $6a706129b6f614d1$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("4bg7U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30b4b2e6e89e9da3$var$preprocessStyles;

var $bOOlK = parcelRequire("bOOlK");
function $30b4b2e6e89e9da3$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $bOOlK.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $bOOlK.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("kpukb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $edbdaa418a42b560$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $edbdaa418a42b560$var$_styled.default;
    }
});

var $edbdaa418a42b560$var$_styled = $edbdaa418a42b560$require$_interopRequireDefault((parcelRequire("haNZP")));

});
parcelRegister("haNZP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c80a270d52203b73$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c80a270d52203b73$var$_createStyled = $c80a270d52203b73$require$_interopRequireDefault((parcelRequire("bbeCr")));
const $c80a270d52203b73$var$styled = (0, $c80a270d52203b73$var$_createStyled.default)();
var $c80a270d52203b73$var$_default = module.exports.default = $c80a270d52203b73$var$styled;

});


parcelRegister("2LgDM", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $202ce10b3dfaac20$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $202ce10b3dfaac20$var$_getThemeProps.default;
    }
});

var $202ce10b3dfaac20$var$_useThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("lfKzS")));

var $202ce10b3dfaac20$var$_getThemeProps = $202ce10b3dfaac20$require$_interopRequireDefault((parcelRequire("6wACh")));

});
parcelRegister("lfKzS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $f78f2110a61a7e24$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f78f2110a61a7e24$var$useThemeProps;

var $f78f2110a61a7e24$var$_getThemeProps = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("6wACh")));

var $f78f2110a61a7e24$var$_useTheme = $f78f2110a61a7e24$require$_interopRequireDefault((parcelRequire("lywMB")));
function $f78f2110a61a7e24$var$useThemeProps(params) {
    const { props: props, name: name, defaultTheme: defaultTheme, themeId: themeId } = params;
    let theme = (0, $f78f2110a61a7e24$var$_useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $f78f2110a61a7e24$var$_getThemeProps.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("6wACh", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4c022282094d7502$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4c022282094d7502$var$getThemeProps;

var $4c022282094d7502$var$_resolveProps = $4c022282094d7502$require$_interopRequireDefault((parcelRequire("7T9kw")));
function $4c022282094d7502$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $4c022282094d7502$var$_resolveProps.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("7T9kw", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5be4e83746700573$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5be4e83746700573$var$_resolveProps.default;
    }
});

var $5be4e83746700573$var$_resolveProps = $5be4e83746700573$require$_interopRequireDefault((parcelRequire("jgIf5")));

});
parcelRegister("jgIf5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e071d488489a190f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e071d488489a190f$var$resolveProps;

var $e071d488489a190f$var$_clsx = $e071d488489a190f$require$_interopRequireDefault((parcelRequire("9QePP")));
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @param mergeClassNameAndStyle If `true`, merges `className` and `style` props instead of overriding them.
 *   When `false` (default), props override defaultProps. When `true`, `className` values are concatenated
 *   and `style` objects are merged with props taking precedence.
 * @returns resolved props
 */ function $e071d488489a190f$var$resolveProps(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    const defaultSlotPropValue = defaultSlotProps[slotPropName];
                    const slotPropValue = slotProps[slotPropName];
                    if (typeof defaultSlotPropValue === 'function' || typeof slotPropValue === 'function') // Function slot props are resolved later (with `ownerState`), so defer
                    // the merge until then to avoid dropping either side.
                    output[propName][slotPropName] = (...args)=>$e071d488489a190f$var$resolveProps((typeof defaultSlotPropValue === 'function' ? defaultSlotPropValue(...args) : defaultSlotPropValue) ?? {}, (typeof slotPropValue === 'function' ? slotPropValue(...args) : slotPropValue) ?? {}, mergeClassNameAndStyle);
                    else output[propName][slotPropName] = $e071d488489a190f$var$resolveProps(defaultSlotPropValue ?? {}, slotPropValue ?? {}, mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className !== undefined) output.className = (0, $e071d488489a190f$var$_clsx.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});





parcelRegister("8h4LK", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $60639c4e52e8e25a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $60639c4e52e8e25a$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $60639c4e52e8e25a$var$_useMediaQuery.default;
    }
});

var $60639c4e52e8e25a$var$_useMediaQuery = $60639c4e52e8e25a$require$_interopRequireWildcard((parcelRequire("78KYM")));
Object.keys($60639c4e52e8e25a$var$_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($60639c4e52e8e25a$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $60639c4e52e8e25a$var$_useMediaQuery[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $60639c4e52e8e25a$var$_useMediaQuery[key];
        }
    });
});

});
parcelRegister("78KYM", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $532db8df695edb5e$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $532db8df695edb5e$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createUseMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery;

var $532db8df695edb5e$var$React = $532db8df695edb5e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $532db8df695edb5e$var$_useEnhancedEffect = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2LgDM = parcelRequire("2LgDM");

var $532db8df695edb5e$var$_useThemeWithoutDefault = $532db8df695edb5e$require$_interopRequireDefault((parcelRequire("f18iq")));
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $532db8df695edb5e$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $532db8df695edb5e$var$React.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $532db8df695edb5e$var$_useEnhancedEffect.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $532db8df695edb5e$var$safeReact = {
    ...$532db8df695edb5e$var$React
};
const $532db8df695edb5e$var$maybeReactUseSyncExternalStore = $532db8df695edb5e$var$safeReact.useSyncExternalStore;
function $532db8df695edb5e$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $532db8df695edb5e$var$React.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $532db8df695edb5e$var$React.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $532db8df695edb5e$var$React.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $532db8df695edb5e$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $532db8df695edb5e$var$unstable_createUseMediaQuery(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $532db8df695edb5e$var$_useThemeWithoutDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const fallbackMatchMedia = supportMatchMedia ? window.matchMedia : null;
        const { defaultMatches: defaultMatches = false, matchMedia: customMatchMedia, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $2LgDM.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        const matchMedia = $532db8df695edb5e$var$React.useMemo(()=>{
            if (customMatchMedia !== undefined) return customMatchMedia;
            if (fallbackMatchMedia === null) return null;
            return fallbackMatchMedia.bind(window);
        }, [
            customMatchMedia,
            fallbackMatchMedia
        ]);
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $532db8df695edb5e$var$maybeReactUseSyncExternalStore !== undefined ? $532db8df695edb5e$var$useMediaQueryNew : $532db8df695edb5e$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $532db8df695edb5e$var$useMediaQuery = $532db8df695edb5e$var$unstable_createUseMediaQuery();
var $532db8df695edb5e$var$_default = module.exports.default = $532db8df695edb5e$var$useMediaQuery;

});
parcelRegister("jdWO4", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $dfecd8f934112f3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dfecd8f934112f3d$var$_useEnhancedEffect.default;
    }
});

var $dfecd8f934112f3d$var$_useEnhancedEffect = $dfecd8f934112f3d$require$_interopRequireDefault((parcelRequire("89ISn")));

});
parcelRegister("89ISn", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5f01f96cc9bd1b3c$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5f01f96cc9bd1b3c$var$React = $5f01f96cc9bd1b3c$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $5f01f96cc9bd1b3c$var$useEnhancedEffect = typeof window !== 'undefined' ? $5f01f96cc9bd1b3c$var$React.useLayoutEffect : $5f01f96cc9bd1b3c$var$React.useEffect;
var $5f01f96cc9bd1b3c$var$_default = module.exports.default = $5f01f96cc9bd1b3c$var$useEnhancedEffect;

});




parcelRegister("h61zw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i0NBZ = parcelRequire("i0NBZ");
Object.keys($i0NBZ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in module.exports && module.exports[key] === $i0NBZ[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $i0NBZ[key];
        }
    });
});

});
parcelRegister("i0NBZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d1ceb5f718f3f33e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $d1ceb5f718f3f33e$var$alpha;
module.exports.blend = $d1ceb5f718f3f33e$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $d1ceb5f718f3f33e$var$darken;
module.exports.decomposeColor = $d1ceb5f718f3f33e$var$decomposeColor;
module.exports.emphasize = $d1ceb5f718f3f33e$var$emphasize;
module.exports.getContrastRatio = $d1ceb5f718f3f33e$var$getContrastRatio;
module.exports.getLuminance = $d1ceb5f718f3f33e$var$getLuminance;
module.exports.hexToRgb = $d1ceb5f718f3f33e$var$hexToRgb;
module.exports.hslToRgb = $d1ceb5f718f3f33e$var$hslToRgb;
module.exports.lighten = $d1ceb5f718f3f33e$var$lighten;
module.exports.private_safeAlpha = $d1ceb5f718f3f33e$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $d1ceb5f718f3f33e$var$private_safeDarken;
module.exports.private_safeEmphasize = $d1ceb5f718f3f33e$var$private_safeEmphasize;
module.exports.private_safeLighten = $d1ceb5f718f3f33e$var$private_safeLighten;
module.exports.recomposeColor = $d1ceb5f718f3f33e$var$recomposeColor;
module.exports.rgbToHex = $d1ceb5f718f3f33e$var$rgbToHex;

var $d1ceb5f718f3f33e$var$_formatMuiErrorMessage = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $d1ceb5f718f3f33e$var$_clamp = $d1ceb5f718f3f33e$require$_interopRequireDefault((parcelRequire("3zA0b")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $d1ceb5f718f3f33e$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $d1ceb5f718f3f33e$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $d1ceb5f718f3f33e$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $d1ceb5f718f3f33e$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $d1ceb5f718f3f33e$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $d1ceb5f718f3f33e$var$_formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $d1ceb5f718f3f33e$var$_formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $d1ceb5f718f3f33e$var$colorChannel = (color)=>{
    const decomposedColor = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $d1ceb5f718f3f33e$var$colorChannel;
const $d1ceb5f718f3f33e$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $d1ceb5f718f3f33e$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $d1ceb5f718f3f33e$var$private_safeColorChannel;
function $d1ceb5f718f3f33e$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $d1ceb5f718f3f33e$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $d1ceb5f718f3f33e$var$decomposeColor(color);
    return `#${values.map((n, i)=>$d1ceb5f718f3f33e$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $d1ceb5f718f3f33e$var$hslToRgb(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $d1ceb5f718f3f33e$var$getLuminance(color) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $d1ceb5f718f3f33e$var$decomposeColor($d1ceb5f718f3f33e$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $d1ceb5f718f3f33e$var$getContrastRatio(foreground, background) {
    const lumA = $d1ceb5f718f3f33e$var$getLuminance(foreground);
    const lumB = $d1ceb5f718f3f33e$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$alpha(color, value) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    value = $d1ceb5f718f3f33e$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeAlpha(color, value, warning) {
    try {
        return $d1ceb5f718f3f33e$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$darken(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$lighten(color, coefficient) {
    color = $d1ceb5f718f3f33e$var$decomposeColor(color);
    coefficient = $d1ceb5f718f3f33e$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $d1ceb5f718f3f33e$var$recomposeColor(color);
}
function $d1ceb5f718f3f33e$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $d1ceb5f718f3f33e$var$emphasize(color, coefficient = 0.15) {
    return $d1ceb5f718f3f33e$var$getLuminance(color) > 0.5 ? $d1ceb5f718f3f33e$var$darken(color, coefficient) : $d1ceb5f718f3f33e$var$lighten(color, coefficient);
}
function $d1ceb5f718f3f33e$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $d1ceb5f718f3f33e$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $d1ceb5f718f3f33e$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $d1ceb5f718f3f33e$var$decomposeColor(background);
    const overlayColor = $d1ceb5f718f3f33e$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $d1ceb5f718f3f33e$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("3zA0b", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $29a0913aac547ce8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $29a0913aac547ce8$var$_clamp.default;
    }
});

var $29a0913aac547ce8$var$_clamp = $29a0913aac547ce8$require$_interopRequireDefault((parcelRequire("4CRKF")));

});
parcelRegister("4CRKF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $35e4680625b68240$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $35e4680625b68240$var$_default = module.exports.default = $35e4680625b68240$var$clamp;

});




parcelRegister("ixP4k", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d802ec3fa7ccc11e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d802ec3fa7ccc11e$var$_ThemeProvider.default;
    }
});

var $d802ec3fa7ccc11e$var$_ThemeProvider = $d802ec3fa7ccc11e$require$_interopRequireDefault((parcelRequire("411Qv")));

});
parcelRegister("411Qv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2ec8aff4a7c0cf18$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2ec8aff4a7c0cf18$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ec8aff4a7c0cf18$var$React = $2ec8aff4a7c0cf18$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2ec8aff4a7c0cf18$var$_propTypes = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3YuG2 = parcelRequire("3YuG2");

var $2ec8aff4a7c0cf18$var$_exactProp = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $bOOlK = parcelRequire("bOOlK");

var $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("f18iq")));

var $2ec8aff4a7c0cf18$var$_RtlProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("9uEev")));

var $2ec8aff4a7c0cf18$var$_DefaultPropsProvider = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("buuO7")));

var $2ec8aff4a7c0cf18$var$_useLayerOrder = $2ec8aff4a7c0cf18$require$_interopRequireDefault((parcelRequire("66f2w")));

var $ayMG0 = parcelRequire("ayMG0");
const $2ec8aff4a7c0cf18$var$EMPTY_THEME = {};
function $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $2ec8aff4a7c0cf18$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $2ec8aff4a7c0cf18$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $2ec8aff4a7c0cf18$var$_useThemeWithoutDefault.default)($2ec8aff4a7c0cf18$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $3YuG2.useTheme)() || $2ec8aff4a7c0cf18$var$EMPTY_THEME;
    const engineTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $2ec8aff4a7c0cf18$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $2ec8aff4a7c0cf18$var$_useLayerOrder.default)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($3YuG2.ThemeProvider, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.ThemeContext.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($2ec8aff4a7c0cf18$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($2ec8aff4a7c0cf18$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $2ec8aff4a7c0cf18$var$_default = module.exports.default = $2ec8aff4a7c0cf18$var$ThemeProvider;

});
parcelRegister("3YuG2", function(module, exports) {
/**
 * @mui/private-theming v9.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $1jnue = parcelRequire("1jnue");
var $2e4ec584c6273f12$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2e4ec584c6273f12$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2e4ec584c6273f12$var$_exportNames = {
    ThemeProvider: true,
    useTheme: true
};
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $2e4ec584c6273f12$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $2e4ec584c6273f12$var$_useTheme.default;
    }
});

var $2e4ec584c6273f12$var$_ThemeProvider = $2e4ec584c6273f12$require$_interopRequireWildcard((parcelRequire("bAAZQ")));
Object.keys($2e4ec584c6273f12$var$_ThemeProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2e4ec584c6273f12$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2e4ec584c6273f12$var$_ThemeProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2e4ec584c6273f12$var$_ThemeProvider[key];
        }
    });
});

var $2e4ec584c6273f12$var$_useTheme = $2e4ec584c6273f12$require$_interopRequireDefault((parcelRequire("l03D8")));

});
parcelRegister("bAAZQ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $86ffc1375996ef3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $86ffc1375996ef3d$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_nested", {
    enumerable: true,
    get: function() {
        return $86ffc1375996ef3d$var$_nested.default;
    }
});

var $86ffc1375996ef3d$var$_ThemeProvider = $86ffc1375996ef3d$require$_interopRequireDefault((parcelRequire("lYrbz")));

var $86ffc1375996ef3d$var$_nested = $86ffc1375996ef3d$require$_interopRequireDefault((parcelRequire("2NPLA")));

});
parcelRegister("lYrbz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $fff44a152eb20ab0$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $fff44a152eb20ab0$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fff44a152eb20ab0$var$React = $fff44a152eb20ab0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fff44a152eb20ab0$var$_propTypes = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fff44a152eb20ab0$var$_exactProp = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("5S3aN")));

var $fff44a152eb20ab0$var$_ThemeContext = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("fHPaR")));

var $fff44a152eb20ab0$var$_useTheme = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("l03D8")));

var $fff44a152eb20ab0$var$_nested = $fff44a152eb20ab0$require$_interopRequireDefault((parcelRequire("2NPLA")));

var $ayMG0 = parcelRequire("ayMG0");
// To support composition of theme.
function $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $fff44a152eb20ab0$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $fff44a152eb20ab0$var$_useTheme.default)();
    const theme = $fff44a152eb20ab0$var$React.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $fff44a152eb20ab0$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[$fff44a152eb20ab0$var$_nested.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($fff44a152eb20ab0$var$_ThemeContext.default.Provider, {
        value: theme,
        children: children
    });
}
var $fff44a152eb20ab0$var$_default = module.exports.default = $fff44a152eb20ab0$var$ThemeProvider;

});
parcelRegister("5S3aN", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $446475069c751d22$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $446475069c751d22$var$_exactProp.default;
    }
});

var $446475069c751d22$var$_exactProp = $446475069c751d22$require$_interopRequireDefault((parcelRequire("9RGCL")));

});
parcelRegister("9RGCL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72ea20960eca48cd$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $72ea20960eca48cd$var$specialProperty = 'exact-prop: \u200b';
function $72ea20960eca48cd$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("fHPaR", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $b6f2914bcc222460$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b6f2914bcc222460$var$React = $b6f2914bcc222460$require$_interopRequireWildcard((parcelRequire("acw62")));
const $b6f2914bcc222460$var$ThemeContext = /*#__PURE__*/ $b6f2914bcc222460$var$React.createContext(null);
var $b6f2914bcc222460$var$_default = module.exports.default = $b6f2914bcc222460$var$ThemeContext;

});

parcelRegister("l03D8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f49c69f16b6a34af$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $f49c69f16b6a34af$var$_useTheme.default;
    }
});

var $f49c69f16b6a34af$var$_useTheme = $f49c69f16b6a34af$require$_interopRequireDefault((parcelRequire("lT1cX")));

});
parcelRegister("lT1cX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $feefabedf550ce3f$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $feefabedf550ce3f$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $feefabedf550ce3f$var$useTheme;

var $feefabedf550ce3f$var$React = $feefabedf550ce3f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $feefabedf550ce3f$var$_ThemeContext = $feefabedf550ce3f$require$_interopRequireDefault((parcelRequire("fHPaR")));
function $feefabedf550ce3f$var$useTheme() {
    const theme = $feefabedf550ce3f$var$React.useContext($feefabedf550ce3f$var$_ThemeContext.default);
    return theme;
}

});


parcelRegister("2NPLA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $20a8501e6e2f4912$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $20a8501e6e2f4912$var$_default = module.exports.default = $20a8501e6e2f4912$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});




parcelRegister("9uEev", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $6e961fcfc1c15c66$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $6e961fcfc1c15c66$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $6e961fcfc1c15c66$var$React = $6e961fcfc1c15c66$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6e961fcfc1c15c66$var$_propTypes = $6e961fcfc1c15c66$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ayMG0 = parcelRequire("ayMG0");
const $6e961fcfc1c15c66$var$RtlContext = /*#__PURE__*/ $6e961fcfc1c15c66$var$React.createContext(undefined);
function $6e961fcfc1c15c66$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6e961fcfc1c15c66$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $6e961fcfc1c15c66$var$useRtl = ()=>{
    const value = $6e961fcfc1c15c66$var$React.useContext($6e961fcfc1c15c66$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $6e961fcfc1c15c66$var$useRtl;
var $6e961fcfc1c15c66$var$_default = module.exports.default = $6e961fcfc1c15c66$var$RtlProvider;

});

parcelRegister("buuO7", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $85da64c4cc661dcb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $85da64c4cc661dcb$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $85da64c4cc661dcb$var$_DefaultPropsProvider = $85da64c4cc661dcb$require$_interopRequireWildcard((parcelRequire("k3xKF")));

});
parcelRegister("k3xKF", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e99e44d394b0848b$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $e99e44d394b0848b$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $e99e44d394b0848b$var$useDefaultProps;

var $e99e44d394b0848b$var$React = $e99e44d394b0848b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $e99e44d394b0848b$var$_propTypes = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $e99e44d394b0848b$var$_resolveProps = $e99e44d394b0848b$require$_interopRequireDefault((parcelRequire("7T9kw")));

var $ayMG0 = parcelRequire("ayMG0");
const $e99e44d394b0848b$var$PropsContext = /*#__PURE__*/ $e99e44d394b0848b$var$React.createContext(undefined);
function $e99e44d394b0848b$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($e99e44d394b0848b$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $e99e44d394b0848b$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $e99e44d394b0848b$var$_resolveProps.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $e99e44d394b0848b$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $e99e44d394b0848b$var$React.useContext($e99e44d394b0848b$var$PropsContext);
    return $e99e44d394b0848b$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $e99e44d394b0848b$var$_default = module.exports.default = $e99e44d394b0848b$var$DefaultPropsProvider;

});


parcelRegister("66f2w", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $470ef830d3f406b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $470ef830d3f406b4$var$useLayerOrder;

var $470ef830d3f406b4$var$_useEnhancedEffect = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $470ef830d3f406b4$var$_useId = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("hwliF")));

var $470ef830d3f406b4$var$_GlobalStyles = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("fJztl")));

var $470ef830d3f406b4$var$_useThemeWithoutDefault = $470ef830d3f406b4$require$_interopRequireDefault((parcelRequire("f18iq")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */ function $470ef830d3f406b4$var$useLayerOrder(theme) {
    const upperTheme = (0, $470ef830d3f406b4$var$_useThemeWithoutDefault.default)();
    const id = (0, $470ef830d3f406b4$var$_useId.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $470ef830d3f406b4$var$_useEnhancedEffect.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($470ef830d3f406b4$var$_GlobalStyles.default, {
        styles: layerOrder
    });
}

});
parcelRegister("hwliF", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $cc15f294b94b87be$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cc15f294b94b87be$var$_useId.default;
    }
});

var $cc15f294b94b87be$var$_useId = $cc15f294b94b87be$require$_interopRequireDefault((parcelRequire("4NWyA")));

});
parcelRegister("4NWyA", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $37f92932f8526401$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37f92932f8526401$var$useId;

var $37f92932f8526401$var$React = $37f92932f8526401$require$_interopRequireWildcard((parcelRequire("acw62")));
let $37f92932f8526401$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $37f92932f8526401$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $37f92932f8526401$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $37f92932f8526401$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $37f92932f8526401$var$globalId += 1;
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setDefaultId(`mui-${$37f92932f8526401$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $37f92932f8526401$var$safeReact = {
    ...$37f92932f8526401$var$React
};
const $37f92932f8526401$var$maybeReactUseId = $37f92932f8526401$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $37f92932f8526401$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($37f92932f8526401$var$maybeReactUseId !== undefined) {
        const reactId = $37f92932f8526401$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $37f92932f8526401$var$useGlobalId(idOverride);
}

});





parcelRegister("5Ts1H", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $44a7d4485060e536$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $44a7d4485060e536$var$unstable_memoTheme;

var $44a7d4485060e536$var$_preprocessStyles = $44a7d4485060e536$require$_interopRequireDefault((parcelRequire("4bg7U")));
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $44a7d4485060e536$var$arg = {
    theme: undefined
};
/**
 * Memoize style function on theme.
 * Intended to be used in styled() calls that only need access to the theme.
 */ function $44a7d4485060e536$var$unstable_memoTheme(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $44a7d4485060e536$var$arg.theme = props.theme;
            value = (0, $44a7d4485060e536$var$_preprocessStyles.default)(styleFn($44a7d4485060e536$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});

parcelRegister("3Vfwq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $2db2bc563e7e5e69$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $2db2bc563e7e5e69$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $2db2bc563e7e5e69$var$createCssVarsProvider;

var $2db2bc563e7e5e69$var$React = $2db2bc563e7e5e69$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2db2bc563e7e5e69$var$_propTypes = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bOOlK = parcelRequire("bOOlK");

var $3YuG2 = parcelRequire("3YuG2");

var $2db2bc563e7e5e69$var$_useEnhancedEffect = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $2db2bc563e7e5e69$var$_ThemeProvider = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("ixP4k")));

var $79OI6 = parcelRequire("79OI6");

var $2db2bc563e7e5e69$var$_useCurrentColorScheme = $2db2bc563e7e5e69$require$_interopRequireDefault((parcelRequire("srPro")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @internal
 */ const $2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $2db2bc563e7e5e69$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $79OI6.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $79OI6.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $2db2bc563e7e5e69$var$React.createContext(undefined);
    const useColorScheme = ()=>$2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $2db2bc563e7e5e69$var$React.useRef(false);
        const upperTheme = (0, $3YuG2.useTheme)();
        const ctx = $2db2bc563e7e5e69$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $2db2bc563e7e5e69$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $2db2bc563e7e5e69$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $2db2bc563e7e5e69$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $2db2bc563e7e5e69$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($2db2bc563e7e5e69$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $2db2bc563e7e5e69$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $2db2bc563e7e5e69$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($2db2bc563e7e5e69$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($2db2bc563e7e5e69$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)($bOOlK.GlobalStyles, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $79OI6.buildInitColorSchemeScript)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("79OI6", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $5360b5aae8294a93$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.buildInitColorSchemeScript = $5360b5aae8294a93$var$buildInitColorSchemeScript;
module.exports.default = $5360b5aae8294a93$var$InitColorSchemeScript;

var $5360b5aae8294a93$var$React = $5360b5aae8294a93$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
// React 17 has no `useSyncExternalStore`; spread into a plain object so reading the
// missing property returns `undefined` instead of throwing under strict ESM. See #41190 (comment).
const $5360b5aae8294a93$var$safeReact = {
    ...$5360b5aae8294a93$var$React
};
const $5360b5aae8294a93$var$maybeReactUseSyncExternalStore = $5360b5aae8294a93$var$safeReact.useSyncExternalStore;
const $5360b5aae8294a93$var$subscribe = ()=>()=>{};
// Serialize a value into a JS string literal safe to embed in the inline script. JSON.stringify
// escapes quotes and backslashes; the extra replaces handle what it does not: `<` (so `</script>`
// can't close the element) and the U+2028/U+2029 line separators, invalid raw inside a JS string.
function $5360b5aae8294a93$var$serializeScriptValue(value) {
    return JSON.stringify(value).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}
// Insert a runtime scheme variable (`light`, `dark`, or `colorScheme`) into every `%s` placeholder
// of an attribute/selector template.
function $5360b5aae8294a93$var$interpolateScheme(template, variable) {
    const segments = template.split('%s');
    const tokens = [];
    for(let index = 0; index < segments.length; index += 1){
        if (index > 0) tokens.push(variable);
        if (segments[index]) tokens.push($5360b5aae8294a93$var$serializeScriptValue(segments[index]));
    }
    return tokens.join(' + ') || '""';
}
/**
 * `true` during the server render and the matching hydration render, `false`
 * on every client render afterwards. React warns when a `<script>` is
 * created during a client render (such scripts never execute), so the inline
 * script is only emitted on the server pass and dropped after hydration — the
 * attribute it already set on the document persists. React <18 has no
 * `useSyncExternalStore` and no such warning, so the script is always emitted.
 */ function $5360b5aae8294a93$var$useIsServerRender() {
    if ($5360b5aae8294a93$var$maybeReactUseSyncExternalStore === undefined) return true;
    return $5360b5aae8294a93$var$maybeReactUseSyncExternalStore($5360b5aae8294a93$var$subscribe, ()=>false, ()=>true);
}
function $5360b5aae8294a93$var$buildInitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $5360b5aae8294a93$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $5360b5aae8294a93$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $5360b5aae8294a93$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove(${$5360b5aae8294a93$var$interpolateScheme(selector, 'light')}, ${$5360b5aae8294a93$var$interpolateScheme(selector, 'dark')});
      ${colorSchemeNode}.classList.add(${$5360b5aae8294a93$var$interpolateScheme(selector, 'colorScheme')});`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const separator = matches[1].indexOf('=');
        const attr = separator === -1 ? matches[1] : matches[1].slice(0, separator);
        const value = separator === -1 ? undefined : matches[1].slice(separator + 1);
        if (!value) setter += `${colorSchemeNode}.removeAttribute(${$5360b5aae8294a93$var$interpolateScheme(attr, 'light')});
      ${colorSchemeNode}.removeAttribute(${$5360b5aae8294a93$var$interpolateScheme(attr, 'dark')});`;
        const attributeValue = value ? $5360b5aae8294a93$var$interpolateScheme(value.replace(/^(['"])(.*)\1$/, '$2'), 'colorScheme') : '""';
        setter += `
      ${colorSchemeNode}.setAttribute(${$5360b5aae8294a93$var$interpolateScheme(attr, 'colorScheme')}, ${attributeValue});`;
    } else if (!attribute.startsWith('.')) setter += `${colorSchemeNode}.setAttribute(${$5360b5aae8294a93$var$serializeScriptValue(attribute)}, colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem(${$5360b5aae8294a93$var$serializeScriptValue(modeStorageKey)}) || ${$5360b5aae8294a93$var$serializeScriptValue(defaultMode)};
  const dark = localStorage.getItem(${$5360b5aae8294a93$var$serializeScriptValue(`${colorSchemeStorageKey}-dark`)}) || ${$5360b5aae8294a93$var$serializeScriptValue(defaultDarkColorScheme)};
  const light = localStorage.getItem(${$5360b5aae8294a93$var$serializeScriptValue(`${colorSchemeStorageKey}-light`)}) || ${$5360b5aae8294a93$var$serializeScriptValue(defaultLightColorScheme)};
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}
function $5360b5aae8294a93$var$InitColorSchemeScript(options) {
    const isServerRender = $5360b5aae8294a93$var$useIsServerRender();
    if (!isServerRender) return null;
    return $5360b5aae8294a93$var$buildInitColorSchemeScript(options);
}

});

parcelRegister("srPro", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $055833d66b0d6531$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $055833d66b0d6531$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $055833d66b0d6531$var$useCurrentColorScheme;
module.exports.getColorScheme = $055833d66b0d6531$var$getColorScheme;
module.exports.getSystemMode = $055833d66b0d6531$var$getSystemMode;

var $055833d66b0d6531$var$React = $055833d66b0d6531$require$_interopRequireWildcard((parcelRequire("acw62")));

var $79OI6 = parcelRequire("79OI6");

var $055833d66b0d6531$var$_localStorageManager = $055833d66b0d6531$require$_interopRequireDefault((parcelRequire("emFGB")));
function $055833d66b0d6531$var$noop() {}
function $055833d66b0d6531$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $055833d66b0d6531$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $055833d66b0d6531$var$getColorScheme(state) {
    return $055833d66b0d6531$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $055833d66b0d6531$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $79OI6.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $79OI6.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $055833d66b0d6531$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $055833d66b0d6531$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $055833d66b0d6531$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $055833d66b0d6531$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $055833d66b0d6531$var$React.useState(noSsr || !isMultiSchemes);
    $055833d66b0d6531$var$React.useEffect(()=>{
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $055833d66b0d6531$var$getColorScheme(state);
    const setMode = $055833d66b0d6531$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $055833d66b0d6531$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $055833d66b0d6531$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $055833d66b0d6531$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $055833d66b0d6531$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $055833d66b0d6531$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $055833d66b0d6531$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $055833d66b0d6531$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $055833d66b0d6531$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("emFGB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $a75374c871ddabd4$var$noop() {}
const $a75374c871ddabd4$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $a75374c871ddabd4$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $a75374c871ddabd4$var$_default = module.exports.default = $a75374c871ddabd4$var$localStorageManager;

});



parcelRegister("hKuOr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cebea242efdc3891$var$createGetCssVar;
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $cebea242efdc3891$var$createGetCssVar(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("ejFX8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $a6c361fa93759ec5$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
const $a6c361fa93759ec5$var$prototypePollutingKeys = new Set([
    '__proto__',
    'constructor',
    'prototype'
]);
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $a6c361fa93759ec5$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    for(let index = 0; index < keys.length; index += 1){
        const k = keys[index];
        // Prevent prototype pollution: never traverse or write through
        // `__proto__` / `constructor` / `prototype` (e.g. a theme parsed from untrusted JSON).
        if ($a6c361fa93759ec5$var$prototypePollutingKeys.has(k)) break;
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    }
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $a6c361fa93759ec5$var$assignNestedKeys;
const $a6c361fa93759ec5$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $a6c361fa93759ec5$var$walkObjectDeep;
const $a6c361fa93759ec5$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $a6c361fa93759ec5$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $a6c361fa93759ec5$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $a6c361fa93759ec5$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $a6c361fa93759ec5$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $a6c361fa93759ec5$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});

parcelRegister("5magr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3e66f819b409e224$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3e66f819b409e224$var$_deepmerge = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $3e66f819b409e224$var$_cssVarsParser = $3e66f819b409e224$require$_interopRequireDefault((parcelRequire("ejFX8")));
function $3e66f819b409e224$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-expect-error - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $3e66f819b409e224$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $3e66f819b409e224$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $3e66f819b409e224$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $3e66f819b409e224$var$_default = module.exports.default = $3e66f819b409e224$var$prepareCssVars;

});

parcelRegister("73CWR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5237068774af7ee7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5237068774af7ee7$var$_prepareCssVars = $5237068774af7ee7$require$_interopRequireDefault((parcelRequire("5magr")));

var $9wccP = parcelRequire("9wccP");

var $79OI6 = parcelRequire("79OI6");
function $5237068774af7ee7$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$79OI6.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $5237068774af7ee7$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $9wccP.createGetColorSchemeSelector)(colorSchemeSelector);
    output.internal_cache = {};
    return output;
}
var $5237068774af7ee7$var$_default = module.exports.default = $5237068774af7ee7$var$createCssVarsTheme;

});
parcelRegister("9wccP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $6ee0921037829b98$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $6ee0921037829b98$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});


parcelRegister("1RRq5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = module.exports.prerelease = module.exports.patch = module.exports.minor = module.exports.major = module.exports.default = void 0;
const $15c42dbad1fc53b5$var$version = module.exports.version = "9.5.0";
const $15c42dbad1fc53b5$var$major = module.exports.major = Number("9");
const $15c42dbad1fc53b5$var$minor = module.exports.minor = Number("5");
const $15c42dbad1fc53b5$var$patch = module.exports.patch = Number("0");
const $15c42dbad1fc53b5$var$prerelease = module.exports.prerelease = undefined;
var $15c42dbad1fc53b5$var$_default = module.exports.default = $15c42dbad1fc53b5$var$version;

});

parcelRegister("689Qv", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $476b209a249f8c65$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $476b209a249f8c65$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $476b209a249f8c65$var$createContainer;

var $476b209a249f8c65$var$React = $476b209a249f8c65$require$_interopRequireWildcard((parcelRequire("acw62")));

var $476b209a249f8c65$var$_propTypes = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $476b209a249f8c65$var$_clsx = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("9QePP")));

var $476b209a249f8c65$var$_generateUtilityClass = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $476b209a249f8c65$var$_composeClasses = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $476b209a249f8c65$var$_capitalize = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("4O6za")));

var $476b209a249f8c65$var$_useThemeProps = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $476b209a249f8c65$var$_styled = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("kpukb")));

var $476b209a249f8c65$var$_createTheme = $476b209a249f8c65$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $ayMG0 = parcelRequire("ayMG0");
const $476b209a249f8c65$var$defaultTheme = (0, $476b209a249f8c65$var$_createTheme.default)();
const $476b209a249f8c65$var$defaultCreateStyledComponent = (0, $476b209a249f8c65$var$_styled.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $476b209a249f8c65$var$_capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $476b209a249f8c65$var$useThemePropsDefault = (inProps)=>(0, $476b209a249f8c65$var$_useThemeProps.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $476b209a249f8c65$var$defaultTheme
    });
const $476b209a249f8c65$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $476b209a249f8c65$var$_generateUtilityClass.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $476b209a249f8c65$var$_capitalize.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $476b209a249f8c65$var$_composeClasses.default)(slots, getContainerUtilityClass, classes);
};
function $476b209a249f8c65$var$createContainer(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $476b209a249f8c65$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $476b209a249f8c65$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $476b209a249f8c65$var$React.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $476b209a249f8c65$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $476b209a249f8c65$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}

});
parcelRegister("3Hg1x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2b11d13e9f9cf7db$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2b11d13e9f9cf7db$var$_composeClasses.default;
    }
});

var $2b11d13e9f9cf7db$var$_composeClasses = $2b11d13e9f9cf7db$require$_interopRequireDefault((parcelRequire("5m3Us")));

});
parcelRegister("5m3Us", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3e620a2ee867e5d5$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $3e620a2ee867e5d5$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});



parcelRegister("jYQTJ", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $e8bca752eef9579e$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $e8bca752eef9579e$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e8bca752eef9579e$var$_exportNames = {
    containerClasses: true
};
Object.defineProperty(module.exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return $e8bca752eef9579e$var$_containerClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e8bca752eef9579e$var$_Container.default;
    }
});

var $e8bca752eef9579e$var$_Container = $e8bca752eef9579e$require$_interopRequireDefault((parcelRequire("gRSQN")));

var $e8bca752eef9579e$var$_containerClasses = $e8bca752eef9579e$require$_interopRequireWildcard((parcelRequire("brfSx")));
Object.keys($e8bca752eef9579e$var$_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e8bca752eef9579e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e8bca752eef9579e$var$_containerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e8bca752eef9579e$var$_containerClasses[key];
        }
    });
});

});
parcelRegister("gRSQN", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c47c24bbe2a0d6f8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c47c24bbe2a0d6f8$var$_propTypes = $c47c24bbe2a0d6f8$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c47c24bbe2a0d6f8$var$_createContainer = $c47c24bbe2a0d6f8$require$_interopRequireDefault((parcelRequire("689Qv")));
/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */ const $c47c24bbe2a0d6f8$var$Container = (0, $c47c24bbe2a0d6f8$var$_createContainer.default)();
var $c47c24bbe2a0d6f8$var$_default = module.exports.default = $c47c24bbe2a0d6f8$var$Container;

});

parcelRegister("brfSx", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $853e8880b5f4e64d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getContainerUtilityClass = $853e8880b5f4e64d$var$getContainerUtilityClass;

var $853e8880b5f4e64d$var$_generateUtilityClasses = $853e8880b5f4e64d$require$_interopRequireDefault((parcelRequire("5nY49")));

var $853e8880b5f4e64d$var$_generateUtilityClass = $853e8880b5f4e64d$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $853e8880b5f4e64d$var$getContainerUtilityClass(slot) {
    return (0, $853e8880b5f4e64d$var$_generateUtilityClass.default)('MuiContainer', slot);
}
const $853e8880b5f4e64d$var$containerClasses = (0, $853e8880b5f4e64d$var$_generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var $853e8880b5f4e64d$var$_default = module.exports.default = $853e8880b5f4e64d$var$containerClasses;

});


parcelRegister("dy2yf", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $9dd06e03e834ae16$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9dd06e03e834ae16$var$_propTypes = $9dd06e03e834ae16$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9dd06e03e834ae16$var$_createGrid = $9dd06e03e834ae16$require$_interopRequireDefault((parcelRequire("h0TiG")));
/**
 *
 * Demos:
 *
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */ const $9dd06e03e834ae16$var$Grid = (0, $9dd06e03e834ae16$var$_createGrid.default)();
var $9dd06e03e834ae16$var$_default = module.exports.default = $9dd06e03e834ae16$var$Grid;

});
parcelRegister("h0TiG", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c62d554115d846cf$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c62d554115d846cf$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c62d554115d846cf$var$createGrid;

var $c62d554115d846cf$var$React = $c62d554115d846cf$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c62d554115d846cf$var$_propTypes = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $c62d554115d846cf$var$_clsx = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("9QePP")));

var $c62d554115d846cf$var$_isMuiElement = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("5yr9V")));

var $c62d554115d846cf$var$_generateUtilityClass = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $c62d554115d846cf$var$_composeClasses = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $c62d554115d846cf$var$_styled = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("kpukb")));

var $c62d554115d846cf$var$_useThemeProps = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $c62d554115d846cf$var$_useTheme = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("lywMB")));

var $c62d554115d846cf$var$_createTheme = $c62d554115d846cf$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $ggHhD = parcelRequire("ggHhD");

var $ayMG0 = parcelRequire("ayMG0");
const $c62d554115d846cf$var$defaultTheme = (0, $c62d554115d846cf$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $c62d554115d846cf$var$defaultCreateStyledComponent = (0, $c62d554115d846cf$var$_styled.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $c62d554115d846cf$var$useThemePropsDefault(props) {
    return (0, $c62d554115d846cf$var$_useThemeProps.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $c62d554115d846cf$var$defaultTheme
    });
}
function $c62d554115d846cf$var$createGrid(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $c62d554115d846cf$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $c62d554115d846cf$var$useThemePropsDefault, useTheme: useTheme = $c62d554115d846cf$var$_useTheme.default, componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $ggHhD.generateDirectionClasses)(direction),
                ...(0, $ggHhD.generateSizeClassNames)(size),
                ...container ? (0, $ggHhD.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $c62d554115d846cf$var$_composeClasses.default)(slots, (slot)=>(0, $c62d554115d846cf$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent($ggHhD.generateGridColumnsStyles, $ggHhD.generateGridColumnSpacingStyles, $ggHhD.generateGridRowSpacingStyles, $ggHhD.generateGridSizeStyles, $ggHhD.generateGridDirectionStyles, $ggHhD.generateGridStyles, $ggHhD.generateGridOffsetStyles);
    const Grid = /*#__PURE__*/ $c62d554115d846cf$var$React.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = themeProps;
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $c62d554115d846cf$var$_clsx.default)(classes.root, className),
            ...other,
            children: $c62d554115d846cf$var$React.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $c62d554115d846cf$var$React.isValidElement(child) && (0, $c62d554115d846cf$var$_isMuiElement.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $c62d554115d846cf$var$React.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-expect-error internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

});
parcelRegister("5yr9V", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $40b531ef992288aa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $40b531ef992288aa$var$_isMuiElement.default;
    }
});

var $40b531ef992288aa$var$_isMuiElement = $40b531ef992288aa$require$_interopRequireDefault((parcelRequire("cr6gy")));

});
parcelRegister("cr6gy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $90dcddf03243cc11$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90dcddf03243cc11$var$isMuiElement;

var $90dcddf03243cc11$var$React = $90dcddf03243cc11$require$_interopRequireWildcard((parcelRequire("acw62")));
function $90dcddf03243cc11$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $90dcddf03243cc11$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/react/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("ggHhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateSpacingClassNames = module.exports.generateSizeClassNames = module.exports.generateGridStyles = module.exports.generateGridSizeStyles = module.exports.generateGridRowSpacingStyles = module.exports.generateGridOffsetStyles = module.exports.generateGridDirectionStyles = module.exports.generateGridColumnsStyles = module.exports.generateGridColumnSpacingStyles = module.exports.generateDirectionClasses = void 0;

var $99OVR = parcelRequire("99OVR");
function $bd7fb721dfb6dcf0$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $bd7fb721dfb6dcf0$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $bd7fb721dfb6dcf0$var$selfColumnsVar = '--Grid-columns';
const $bd7fb721dfb6dcf0$var$parentColumnsVar = '--Grid-parent-columns';
const $bd7fb721dfb6dcf0$var$generateGridSizeStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) - (var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) - ${value}) * (var(${$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')}) / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridSizeStyles = $bd7fb721dfb6dcf0$var$generateGridSizeStyles;
const $bd7fb721dfb6dcf0$var$generateGridOffsetStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}) + var(${$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')}) * ${value} / var(${$bd7fb721dfb6dcf0$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridOffsetStyles = $bd7fb721dfb6dcf0$var$generateGridOffsetStyles;
const $bd7fb721dfb6dcf0$var$generateGridColumnsStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$bd7fb721dfb6dcf0$var$selfColumnsVar]: 12
    };
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$selfColumnsVar]: columns,
            '> *': {
                [$bd7fb721dfb6dcf0$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnsStyles = $bd7fb721dfb6dcf0$var$generateGridColumnsStyles;
const $bd7fb721dfb6dcf0$var$generateGridRowSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$bd7fb721dfb6dcf0$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridRowSpacingStyles = $bd7fb721dfb6dcf0$var$generateGridRowSpacingStyles;
const $bd7fb721dfb6dcf0$var$generateGridColumnSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$bd7fb721dfb6dcf0$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$bd7fb721dfb6dcf0$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnSpacingStyles = $bd7fb721dfb6dcf0$var$generateGridColumnSpacingStyles;
const $bd7fb721dfb6dcf0$var$generateGridDirectionStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $99OVR.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
module.exports.generateGridDirectionStyles = $bd7fb721dfb6dcf0$var$generateGridDirectionStyles;
const $bd7fb721dfb6dcf0$var$generateGridStyles = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$bd7fb721dfb6dcf0$var$getSelfSpacingVar('row')}) var(${$bd7fb721dfb6dcf0$var$getSelfSpacingVar('column')})`
        }
    };
};
module.exports.generateGridStyles = $bd7fb721dfb6dcf0$var$generateGridStyles;
const $bd7fb721dfb6dcf0$var$generateSizeClassNames = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
module.exports.generateSizeClassNames = $bd7fb721dfb6dcf0$var$generateSizeClassNames;
const $bd7fb721dfb6dcf0$var$generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
module.exports.generateSpacingClassNames = $bd7fb721dfb6dcf0$var$generateSpacingClassNames;
const $bd7fb721dfb6dcf0$var$generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};
module.exports.generateDirectionClasses = $bd7fb721dfb6dcf0$var$generateDirectionClasses;

});
parcelRegister("99OVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.traverseBreakpoints = module.exports.filterBreakpointKeys = void 0;
const $6aac76618a3aa479$var$filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
module.exports.filterBreakpointKeys = $6aac76618a3aa479$var$filterBreakpointKeys;
const $6aac76618a3aa479$var$traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $6aac76618a3aa479$var$filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};
module.exports.traverseBreakpoints = $6aac76618a3aa479$var$traverseBreakpoints;

});




parcelRegister("gxueG", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $c0a72ea334f236a5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $c0a72ea334f236a5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c0a72ea334f236a5$var$_exportNames = {
    createGrid: true,
    gridClasses: true,
    unstable_traverseBreakpoints: true,
    unstable_generateDirectionClasses: true,
    unstable_generateSizeClassNames: true,
    unstable_generateSpacingClassNames: true
};
Object.defineProperty(module.exports, "createGrid", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_createGrid.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_Grid.default;
    }
});
Object.defineProperty(module.exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return $c0a72ea334f236a5$var$_gridClasses.default;
    }
});
Object.defineProperty(module.exports, "unstable_generateDirectionClasses", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateDirectionClasses;
    }
});
Object.defineProperty(module.exports, "unstable_generateSizeClassNames", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateSizeClassNames;
    }
});
Object.defineProperty(module.exports, "unstable_generateSpacingClassNames", {
    enumerable: true,
    get: function() {
        return $ggHhD.generateSpacingClassNames;
    }
});
Object.defineProperty(module.exports, "unstable_traverseBreakpoints", {
    enumerable: true,
    get: function() {
        return $99OVR.traverseBreakpoints;
    }
});

var $c0a72ea334f236a5$var$_Grid = $c0a72ea334f236a5$require$_interopRequireDefault((parcelRequire("dy2yf")));

var $c0a72ea334f236a5$var$_createGrid = $c0a72ea334f236a5$require$_interopRequireDefault((parcelRequire("h0TiG")));

var $9GB8a = parcelRequire("9GB8a");
Object.keys($9GB8a).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c0a72ea334f236a5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9GB8a[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9GB8a[key];
        }
    });
});

var $c0a72ea334f236a5$var$_gridClasses = $c0a72ea334f236a5$require$_interopRequireWildcard((parcelRequire("8HLwS")));
Object.keys($c0a72ea334f236a5$var$_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c0a72ea334f236a5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c0a72ea334f236a5$var$_gridClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c0a72ea334f236a5$var$_gridClasses[key];
        }
    });
});

var $99OVR = parcelRequire("99OVR");

var $ggHhD = parcelRequire("ggHhD");

});
parcelRegister("9GB8a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("8HLwS", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $65673535bf7c146f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridUtilityClass = $65673535bf7c146f$var$getGridUtilityClass;

var $65673535bf7c146f$var$_generateUtilityClasses = $65673535bf7c146f$require$_interopRequireDefault((parcelRequire("5nY49")));

var $65673535bf7c146f$var$_generateUtilityClass = $65673535bf7c146f$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $65673535bf7c146f$var$getGridUtilityClass(slot) {
    return (0, $65673535bf7c146f$var$_generateUtilityClass.default)('MuiGrid', slot);
}
const $65673535bf7c146f$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $65673535bf7c146f$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $65673535bf7c146f$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $65673535bf7c146f$var$GRID_SIZES = [
    'auto',
    'grow',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $65673535bf7c146f$var$gridClasses = (0, $65673535bf7c146f$var$_generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    'item',
    // spacings
    ...$65673535bf7c146f$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$65673535bf7c146f$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$65673535bf7c146f$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$65673535bf7c146f$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $65673535bf7c146f$var$_default = module.exports.default = $65673535bf7c146f$var$gridClasses;

});


parcelRegister("kgIUX", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ec1824feff65c009$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec1824feff65c009$var$_propTypes = $ec1824feff65c009$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ec1824feff65c009$var$_createStack = $ec1824feff65c009$require$_interopRequireDefault((parcelRequire("4N1IS")));
/**
 *
 * Demos:
 *
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const $ec1824feff65c009$var$Stack = (0, $ec1824feff65c009$var$_createStack.default)();
var $ec1824feff65c009$var$_default = module.exports.default = $ec1824feff65c009$var$Stack;

});
parcelRegister("4N1IS", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $37cd131ec442ac03$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $37cd131ec442ac03$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $37cd131ec442ac03$var$createStack;
module.exports.style = void 0;

var $37cd131ec442ac03$var$React = $37cd131ec442ac03$require$_interopRequireWildcard((parcelRequire("acw62")));

var $37cd131ec442ac03$var$_propTypes = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $37cd131ec442ac03$var$_clsx = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("9QePP")));

var $37cd131ec442ac03$var$_deepmerge = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $37cd131ec442ac03$var$_generateUtilityClass = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $37cd131ec442ac03$var$_composeClasses = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $37cd131ec442ac03$var$_styled = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("kpukb")));

var $37cd131ec442ac03$var$_useThemeProps = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $37cd131ec442ac03$var$_createTheme = $37cd131ec442ac03$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $9mzYC = parcelRequire("9mzYC");

var $8ZgMs = parcelRequire("8ZgMs");

var $ayMG0 = parcelRequire("ayMG0");
const $37cd131ec442ac03$var$defaultTheme = (0, $37cd131ec442ac03$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $37cd131ec442ac03$var$defaultCreateStyledComponent = (0, $37cd131ec442ac03$var$_styled.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $37cd131ec442ac03$var$useThemePropsDefault(props) {
    return (0, $37cd131ec442ac03$var$_useThemeProps.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $37cd131ec442ac03$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $37cd131ec442ac03$var$joinChildren(children, separator) {
    const childrenArray = $37cd131ec442ac03$var$React.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $37cd131ec442ac03$var$React.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $37cd131ec442ac03$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $37cd131ec442ac03$var$style = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $9mzYC.handleBreakpoints)({
            theme: theme
        }, (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $8ZgMs.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $9mzYC.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $8ZgMs.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$37cd131ec442ac03$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $8ZgMs.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $37cd131ec442ac03$var$_deepmerge.default)(styles, (0, $9mzYC.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $9mzYC.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
module.exports.style = $37cd131ec442ac03$var$style;
function $37cd131ec442ac03$var$createStack(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $37cd131ec442ac03$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $37cd131ec442ac03$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $37cd131ec442ac03$var$_composeClasses.default)(slots, (slot)=>(0, $37cd131ec442ac03$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($37cd131ec442ac03$var$style);
    const Stack = /*#__PURE__*/ $37cd131ec442ac03$var$React.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = themeProps;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $37cd131ec442ac03$var$_clsx.default)(classes.root, className),
            ...other,
            children: divider ? $37cd131ec442ac03$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});


parcelRegister("106Hq", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $0baafce1ff534af1$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $0baafce1ff534af1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0baafce1ff534af1$var$_exportNames = {
    createStack: true,
    stackClasses: true
};
Object.defineProperty(module.exports, "createStack", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_createStack.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_Stack.default;
    }
});
Object.defineProperty(module.exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return $0baafce1ff534af1$var$_stackClasses.default;
    }
});

var $0baafce1ff534af1$var$_Stack = $0baafce1ff534af1$require$_interopRequireDefault((parcelRequire("kgIUX")));

var $0baafce1ff534af1$var$_createStack = $0baafce1ff534af1$require$_interopRequireDefault((parcelRequire("4N1IS")));

var $19rVF = parcelRequire("19rVF");
Object.keys($19rVF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0baafce1ff534af1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $19rVF[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $19rVF[key];
        }
    });
});

var $0baafce1ff534af1$var$_stackClasses = $0baafce1ff534af1$require$_interopRequireWildcard((parcelRequire("eh1Yu")));
Object.keys($0baafce1ff534af1$var$_stackClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0baafce1ff534af1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0baafce1ff534af1$var$_stackClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0baafce1ff534af1$var$_stackClasses[key];
        }
    });
});

});
parcelRegister("19rVF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eh1Yu", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a6442f55ec27dd44$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStackUtilityClass = $a6442f55ec27dd44$var$getStackUtilityClass;

var $a6442f55ec27dd44$var$_generateUtilityClasses = $a6442f55ec27dd44$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a6442f55ec27dd44$var$_generateUtilityClass = $a6442f55ec27dd44$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a6442f55ec27dd44$var$getStackUtilityClass(slot) {
    return (0, $a6442f55ec27dd44$var$_generateUtilityClass.default)('MuiStack', slot);
}
const $a6442f55ec27dd44$var$stackClasses = (0, $a6442f55ec27dd44$var$_generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var $a6442f55ec27dd44$var$_default = module.exports.default = $a6442f55ec27dd44$var$stackClasses;

});




parcelRegister("ijOKP", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d5615f18e5cd04fc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5615f18e5cd04fc$var$createTheme;

var $d5615f18e5cd04fc$var$_createPalette = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $5YF3H = parcelRequire("5YF3H");

var $d5615f18e5cd04fc$var$_createThemeWithVars = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("eLI0w")));

var $d5615f18e5cd04fc$var$_createThemeNoVars = $d5615f18e5cd04fc$require$_interopRequireDefault((parcelRequire("8v3fy")));
// eslint-disable-next-line consistent-return
function $d5615f18e5cd04fc$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $d5615f18e5cd04fc$var$_createPalette.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $d5615f18e5cd04fc$var$createTheme(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $d5615f18e5cd04fc$var$_createThemeNoVars.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $d5615f18e5cd04fc$var$_createThemeNoVars.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $d5615f18e5cd04fc$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        if (theme.focusVisible != null && theme.focusVisible !== false) {
            let focusVisibleInput = theme.focusVisible;
            const rawFocusVisible = (0, $5YF3H.mergeFocusVisibleInput)(options.focusVisible, args);
            const authoredColor = rawFocusVisible && typeof rawFocusVisible === 'object' ? rawFocusVisible.outlineColor : undefined;
            // A re-composed theme carries a baked default that looks authored, so it falls back to value
            // equality — the one case where a pinned `primary.main` is indistinguishable and gets reset.
            if (!authoredColor || (0, $5YF3H.isResolvedFocusVisible)(rawFocusVisible) && authoredColor === theme.palette.primary.main) {
                const { outlineColor: outlineColor, ...rest } = focusVisibleInput;
                focusVisibleInput = rest;
            }
            Object.keys(theme.colorSchemes).forEach((scheme)=>{
                const schemePalette = theme.colorSchemes?.[scheme]?.palette;
                if (schemePalette?.primary) theme.colorSchemes[scheme].focusVisible = (0, $5YF3H.resolveFocusVisible)(focusVisibleInput, schemePalette.primary.main);
            });
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $d5615f18e5cd04fc$var$_createThemeWithVars.default)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("4Gk6P", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $368aaef25f6a2997$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contrastColor = $368aaef25f6a2997$var$contrastColor;
module.exports.dark = void 0;
module.exports.default = $368aaef25f6a2997$var$createPalette;
module.exports.light = void 0;

var $368aaef25f6a2997$var$_formatMuiErrorMessage = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $368aaef25f6a2997$var$_deepmerge = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $h61zw = parcelRequire("h61zw");

var $368aaef25f6a2997$var$_common = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("dzxhF")));

var $368aaef25f6a2997$var$_grey = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("eU5ou")));

var $368aaef25f6a2997$var$_purple = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("kSXRh")));

var $368aaef25f6a2997$var$_red = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("ln9F4")));

var $368aaef25f6a2997$var$_orange = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("dMYym")));

var $368aaef25f6a2997$var$_blue = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("bKnBV")));

var $368aaef25f6a2997$var$_lightBlue = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("iDVue")));

var $368aaef25f6a2997$var$_green = $368aaef25f6a2997$require$_interopRequireDefault((parcelRequire("e4nxq")));
function $368aaef25f6a2997$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: $368aaef25f6a2997$var$_common.default.white,
            default: $368aaef25f6a2997$var$_common.default.white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $368aaef25f6a2997$var$light = module.exports.light = $368aaef25f6a2997$var$getLight();
function $368aaef25f6a2997$var$getDark() {
    return {
        text: {
            primary: $368aaef25f6a2997$var$_common.default.white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: $368aaef25f6a2997$var$_common.default.white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $368aaef25f6a2997$var$dark = module.exports.dark = $368aaef25f6a2997$var$getDark();
function $368aaef25f6a2997$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $h61zw.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $h61zw.darken)(intent.main, tonalOffsetDark);
    }
}
function $368aaef25f6a2997$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $368aaef25f6a2997$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_blue.default[200],
        light: $368aaef25f6a2997$var$_blue.default[50],
        dark: $368aaef25f6a2997$var$_blue.default[400]
    };
    return {
        main: $368aaef25f6a2997$var$_blue.default[700],
        light: $368aaef25f6a2997$var$_blue.default[400],
        dark: $368aaef25f6a2997$var$_blue.default[800]
    };
}
function $368aaef25f6a2997$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_purple.default[200],
        light: $368aaef25f6a2997$var$_purple.default[50],
        dark: $368aaef25f6a2997$var$_purple.default[400]
    };
    return {
        main: $368aaef25f6a2997$var$_purple.default[500],
        light: $368aaef25f6a2997$var$_purple.default[300],
        dark: $368aaef25f6a2997$var$_purple.default[700]
    };
}
function $368aaef25f6a2997$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_red.default[500],
        light: $368aaef25f6a2997$var$_red.default[300],
        dark: $368aaef25f6a2997$var$_red.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_red.default[700],
        light: $368aaef25f6a2997$var$_red.default[400],
        dark: $368aaef25f6a2997$var$_red.default[800]
    };
}
function $368aaef25f6a2997$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_lightBlue.default[400],
        light: $368aaef25f6a2997$var$_lightBlue.default[300],
        dark: $368aaef25f6a2997$var$_lightBlue.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_lightBlue.default[700],
        light: $368aaef25f6a2997$var$_lightBlue.default[500],
        dark: $368aaef25f6a2997$var$_lightBlue.default[900]
    };
}
function $368aaef25f6a2997$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_green.default[400],
        light: $368aaef25f6a2997$var$_green.default[300],
        dark: $368aaef25f6a2997$var$_green.default[700]
    };
    return {
        main: $368aaef25f6a2997$var$_green.default[800],
        light: $368aaef25f6a2997$var$_green.default[500],
        dark: $368aaef25f6a2997$var$_green.default[900]
    };
}
function $368aaef25f6a2997$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: $368aaef25f6a2997$var$_orange.default[400],
        light: $368aaef25f6a2997$var$_orange.default[300],
        dark: $368aaef25f6a2997$var$_orange.default[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: $368aaef25f6a2997$var$_orange.default[500],
        dark: $368aaef25f6a2997$var$_orange.default[900]
    };
}
// Use the same name as the experimental CSS `contrast-color` function.
function $368aaef25f6a2997$var$contrastColor(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $368aaef25f6a2997$var$createPalette(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $368aaef25f6a2997$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $368aaef25f6a2997$var$getDefaultSecondary(mode);
    const error = palette.error || $368aaef25f6a2997$var$getDefaultError(mode);
    const info = palette.info || $368aaef25f6a2997$var$getDefaultInfo(mode);
    const success = palette.success || $368aaef25f6a2997$var$getDefaultSuccess(mode);
    const warning = palette.warning || $368aaef25f6a2997$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $368aaef25f6a2997$var$contrastColor(background);
        const contrastText = (0, $h61zw.getContrastRatio)(background, $368aaef25f6a2997$var$dark.text.primary) >= contrastThreshold ? $368aaef25f6a2997$var$dark.text.primary : $368aaef25f6a2997$var$light.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $368aaef25f6a2997$var$_formatMuiErrorMessage.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $368aaef25f6a2997$var$_formatMuiErrorMessage.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $368aaef25f6a2997$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $368aaef25f6a2997$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $368aaef25f6a2997$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $368aaef25f6a2997$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $368aaef25f6a2997$var$getLight();
    else if (mode === 'dark') modeHydrated = $368aaef25f6a2997$var$getDark();
    const paletteOutput = (0, $368aaef25f6a2997$var$_deepmerge.default)({
        // A collection of common colors.
        common: {
            ...$368aaef25f6a2997$var$_common.default
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        // The grey colors.
        grey: $368aaef25f6a2997$var$_grey.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("dzxhF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * ![common black](https://mui.com/static/colors-preview/common-black-24x24.png) ![common white](https://mui.com/static/colors-preview/common-white-24x24.png)
 */ const $9e185cbbdd17e0f7$var$common = {
    /**
   * Preview: ![common black](https://mui.com/static/colors-preview/common-black-24x24.png)
   */ black: '#000',
    /**
   * Preview: ![common white](https://mui.com/static/colors-preview/common-white-24x24.png)
   */ white: '#fff'
};
var $9e185cbbdd17e0f7$var$_default = module.exports.default = $9e185cbbdd17e0f7$var$common;

});

parcelRegister("eU5ou", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png) ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png) ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png) ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png) ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png) ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png) ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png) ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png) ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png) ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png) ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png) ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png) ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png) ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
 */ const $ad9a7ac9db04746c$var$grey = {
    /**
   * Preview: ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png)
   */ 50: '#fafafa',
    /**
   * Preview: ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png)
   */ 100: '#f5f5f5',
    /**
   * Preview: ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png)
   */ 200: '#eeeeee',
    /**
   * Preview: ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png)
   */ 300: '#e0e0e0',
    /**
   * Preview: ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png)
   */ 400: '#bdbdbd',
    /**
   * Preview: ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png)
   */ 500: '#9e9e9e',
    /**
   * Preview: ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png)
   */ 600: '#757575',
    /**
   * Preview: ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png)
   */ 700: '#616161',
    /**
   * Preview: ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png)
   */ 800: '#424242',
    /**
   * Preview: ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png)
   */ 900: '#212121',
    /**
   * Preview: ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png)
   */ A100: '#f5f5f5',
    /**
   * Preview: ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png)
   */ A200: '#eeeeee',
    /**
   * Preview: ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png)
   */ A400: '#bdbdbd',
    /**
   * Preview: ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
   */ A700: '#616161'
};
var $ad9a7ac9db04746c$var$_default = module.exports.default = $ad9a7ac9db04746c$var$grey;

});

parcelRegister("kSXRh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * ![purple 50](https://mui.com/static/colors-preview/purple-50-24x24.png) ![purple 100](https://mui.com/static/colors-preview/purple-100-24x24.png) ![purple 200](https://mui.com/static/colors-preview/purple-200-24x24.png) ![purple 300](https://mui.com/static/colors-preview/purple-300-24x24.png) ![purple 400](https://mui.com/static/colors-preview/purple-400-24x24.png) ![purple 500](https://mui.com/static/colors-preview/purple-500-24x24.png) ![purple 600](https://mui.com/static/colors-preview/purple-600-24x24.png) ![purple 700](https://mui.com/static/colors-preview/purple-700-24x24.png) ![purple 800](https://mui.com/static/colors-preview/purple-800-24x24.png) ![purple 900](https://mui.com/static/colors-preview/purple-900-24x24.png) ![purple A100](https://mui.com/static/colors-preview/purple-A100-24x24.png) ![purple A200](https://mui.com/static/colors-preview/purple-A200-24x24.png) ![purple A400](https://mui.com/static/colors-preview/purple-A400-24x24.png) ![purple A700](https://mui.com/static/colors-preview/purple-A700-24x24.png)
 */ const $f34748703626d0dc$var$purple = {
    /**
   * Preview: ![purple 50](https://mui.com/static/colors-preview/purple-50-24x24.png)
   */ 50: '#f3e5f5',
    /**
   * Preview: ![purple 100](https://mui.com/static/colors-preview/purple-100-24x24.png)
   */ 100: '#e1bee7',
    /**
   * Preview: ![purple 200](https://mui.com/static/colors-preview/purple-200-24x24.png)
   */ 200: '#ce93d8',
    /**
   * Preview: ![purple 300](https://mui.com/static/colors-preview/purple-300-24x24.png)
   */ 300: '#ba68c8',
    /**
   * Preview: ![purple 400](https://mui.com/static/colors-preview/purple-400-24x24.png)
   */ 400: '#ab47bc',
    /**
   * Preview: ![purple 500](https://mui.com/static/colors-preview/purple-500-24x24.png)
   */ 500: '#9c27b0',
    /**
   * Preview: ![purple 600](https://mui.com/static/colors-preview/purple-600-24x24.png)
   */ 600: '#8e24aa',
    /**
   * Preview: ![purple 700](https://mui.com/static/colors-preview/purple-700-24x24.png)
   */ 700: '#7b1fa2',
    /**
   * Preview: ![purple 800](https://mui.com/static/colors-preview/purple-800-24x24.png)
   */ 800: '#6a1b9a',
    /**
   * Preview: ![purple 900](https://mui.com/static/colors-preview/purple-900-24x24.png)
   */ 900: '#4a148c',
    /**
   * Preview: ![purple A100](https://mui.com/static/colors-preview/purple-A100-24x24.png)
   */ A100: '#ea80fc',
    /**
   * Preview: ![purple A200](https://mui.com/static/colors-preview/purple-A200-24x24.png)
   */ A200: '#e040fb',
    /**
   * Preview: ![purple A400](https://mui.com/static/colors-preview/purple-A400-24x24.png)
   */ A400: '#d500f9',
    /**
   * Preview: ![purple A700](https://mui.com/static/colors-preview/purple-A700-24x24.png)
   */ A700: '#aa00ff'
};
var $f34748703626d0dc$var$_default = module.exports.default = $f34748703626d0dc$var$purple;

});

parcelRegister("ln9F4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * ![red 50](https://mui.com/static/colors-preview/red-50-24x24.png) ![red 100](https://mui.com/static/colors-preview/red-100-24x24.png) ![red 200](https://mui.com/static/colors-preview/red-200-24x24.png) ![red 300](https://mui.com/static/colors-preview/red-300-24x24.png) ![red 400](https://mui.com/static/colors-preview/red-400-24x24.png) ![red 500](https://mui.com/static/colors-preview/red-500-24x24.png) ![red 600](https://mui.com/static/colors-preview/red-600-24x24.png) ![red 700](https://mui.com/static/colors-preview/red-700-24x24.png) ![red 800](https://mui.com/static/colors-preview/red-800-24x24.png) ![red 900](https://mui.com/static/colors-preview/red-900-24x24.png) ![red A100](https://mui.com/static/colors-preview/red-A100-24x24.png) ![red A200](https://mui.com/static/colors-preview/red-A200-24x24.png) ![red A400](https://mui.com/static/colors-preview/red-A400-24x24.png) ![red A700](https://mui.com/static/colors-preview/red-A700-24x24.png)
 */ const $f8f33d825c71610f$var$red = {
    /**
   * Preview: ![red 50](https://mui.com/static/colors-preview/red-50-24x24.png)
   */ 50: '#ffebee',
    /**
   * Preview: ![red 100](https://mui.com/static/colors-preview/red-100-24x24.png)
   */ 100: '#ffcdd2',
    /**
   * Preview: ![red 200](https://mui.com/static/colors-preview/red-200-24x24.png)
   */ 200: '#ef9a9a',
    /**
   * Preview: ![red 300](https://mui.com/static/colors-preview/red-300-24x24.png)
   */ 300: '#e57373',
    /**
   * Preview: ![red 400](https://mui.com/static/colors-preview/red-400-24x24.png)
   */ 400: '#ef5350',
    /**
   * Preview: ![red 500](https://mui.com/static/colors-preview/red-500-24x24.png)
   */ 500: '#f44336',
    /**
   * Preview: ![red 600](https://mui.com/static/colors-preview/red-600-24x24.png)
   */ 600: '#e53935',
    /**
   * Preview: ![red 700](https://mui.com/static/colors-preview/red-700-24x24.png)
   */ 700: '#d32f2f',
    /**
   * Preview: ![red 800](https://mui.com/static/colors-preview/red-800-24x24.png)
   */ 800: '#c62828',
    /**
   * Preview: ![red 900](https://mui.com/static/colors-preview/red-900-24x24.png)
   */ 900: '#b71c1c',
    /**
   * Preview: ![red A100](https://mui.com/static/colors-preview/red-A100-24x24.png)
   */ A100: '#ff8a80',
    /**
   * Preview: ![red A200](https://mui.com/static/colors-preview/red-A200-24x24.png)
   */ A200: '#ff5252',
    /**
   * Preview: ![red A400](https://mui.com/static/colors-preview/red-A400-24x24.png)
   */ A400: '#ff1744',
    /**
   * Preview: ![red A700](https://mui.com/static/colors-preview/red-A700-24x24.png)
   */ A700: '#d50000'
};
var $f8f33d825c71610f$var$_default = module.exports.default = $f8f33d825c71610f$var$red;

});

parcelRegister("dMYym", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png) ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png) ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png) ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png) ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png) ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png) ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png) ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png) ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png) ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png) ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png) ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png) ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png) ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
 */ const $a09ebaae00c386da$var$orange = {
    /**
   * Preview: ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png)
   */ 50: '#fff3e0',
    /**
   * Preview: ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png)
   */ 100: '#ffe0b2',
    /**
   * Preview: ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png)
   */ 200: '#ffcc80',
    /**
   * Preview: ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png)
   */ 300: '#ffb74d',
    /**
   * Preview: ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png)
   */ 400: '#ffa726',
    /**
   * Preview: ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png)
   */ 500: '#ff9800',
    /**
   * Preview: ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png)
   */ 600: '#fb8c00',
    /**
   * Preview: ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png)
   */ 700: '#f57c00',
    /**
   * Preview: ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png)
   */ 800: '#ef6c00',
    /**
   * Preview: ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png)
   */ 900: '#e65100',
    /**
   * Preview: ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png)
   */ A100: '#ffd180',
    /**
   * Preview: ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png)
   */ A200: '#ffab40',
    /**
   * Preview: ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png)
   */ A400: '#ff9100',
    /**
   * Preview: ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
   */ A700: '#ff6d00'
};
var $a09ebaae00c386da$var$_default = module.exports.default = $a09ebaae00c386da$var$orange;

});

parcelRegister("bKnBV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png) ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png) ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png) ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png) ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png) ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png) ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png) ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png) ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png) ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png) ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png) ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png) ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png) ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
 */ const $88d64e288ac9a70b$var$blue = {
    /**
   * Preview: ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png)
   */ 50: '#e3f2fd',
    /**
   * Preview: ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png)
   */ 100: '#bbdefb',
    /**
   * Preview: ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png)
   */ 200: '#90caf9',
    /**
   * Preview: ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png)
   */ 300: '#64b5f6',
    /**
   * Preview: ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png)
   */ 400: '#42a5f5',
    /**
   * Preview: ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png)
   */ 500: '#2196f3',
    /**
   * Preview: ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png)
   */ 600: '#1e88e5',
    /**
   * Preview: ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png)
   */ 700: '#1976d2',
    /**
   * Preview: ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png)
   */ 800: '#1565c0',
    /**
   * Preview: ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png)
   */ 900: '#0d47a1',
    /**
   * Preview: ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png)
   */ A100: '#82b1ff',
    /**
   * Preview: ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png)
   */ A200: '#448aff',
    /**
   * Preview: ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png)
   */ A400: '#2979ff',
    /**
   * Preview: ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
   */ A700: '#2962ff'
};
var $88d64e288ac9a70b$var$_default = module.exports.default = $88d64e288ac9a70b$var$blue;

});

parcelRegister("iDVue", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png) ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png) ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png) ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png) ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png) ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png) ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png) ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png) ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png) ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png) ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png) ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png) ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png) ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
 */ const $d9287623794ffe70$var$lightBlue = {
    /**
   * Preview: ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png)
   */ 50: '#e1f5fe',
    /**
   * Preview: ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png)
   */ 100: '#b3e5fc',
    /**
   * Preview: ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png)
   */ 200: '#81d4fa',
    /**
   * Preview: ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png)
   */ 300: '#4fc3f7',
    /**
   * Preview: ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png)
   */ 400: '#29b6f6',
    /**
   * Preview: ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png)
   */ 500: '#03a9f4',
    /**
   * Preview: ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png)
   */ 600: '#039be5',
    /**
   * Preview: ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png)
   */ 700: '#0288d1',
    /**
   * Preview: ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png)
   */ 800: '#0277bd',
    /**
   * Preview: ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png)
   */ 900: '#01579b',
    /**
   * Preview: ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png)
   */ A100: '#80d8ff',
    /**
   * Preview: ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png)
   */ A200: '#40c4ff',
    /**
   * Preview: ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png)
   */ A400: '#00b0ff',
    /**
   * Preview: ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
   */ A700: '#0091ea'
};
var $d9287623794ffe70$var$_default = module.exports.default = $d9287623794ffe70$var$lightBlue;

});

parcelRegister("e4nxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * ![green 50](https://mui.com/static/colors-preview/green-50-24x24.png) ![green 100](https://mui.com/static/colors-preview/green-100-24x24.png) ![green 200](https://mui.com/static/colors-preview/green-200-24x24.png) ![green 300](https://mui.com/static/colors-preview/green-300-24x24.png) ![green 400](https://mui.com/static/colors-preview/green-400-24x24.png) ![green 500](https://mui.com/static/colors-preview/green-500-24x24.png) ![green 600](https://mui.com/static/colors-preview/green-600-24x24.png) ![green 700](https://mui.com/static/colors-preview/green-700-24x24.png) ![green 800](https://mui.com/static/colors-preview/green-800-24x24.png) ![green 900](https://mui.com/static/colors-preview/green-900-24x24.png) ![green A100](https://mui.com/static/colors-preview/green-A100-24x24.png) ![green A200](https://mui.com/static/colors-preview/green-A200-24x24.png) ![green A400](https://mui.com/static/colors-preview/green-A400-24x24.png) ![green A700](https://mui.com/static/colors-preview/green-A700-24x24.png)
 */ const $a3e3b29cd31a116f$var$green = {
    /**
   * Preview: ![green 50](https://mui.com/static/colors-preview/green-50-24x24.png)
   */ 50: '#e8f5e9',
    /**
   * Preview: ![green 100](https://mui.com/static/colors-preview/green-100-24x24.png)
   */ 100: '#c8e6c9',
    /**
   * Preview: ![green 200](https://mui.com/static/colors-preview/green-200-24x24.png)
   */ 200: '#a5d6a7',
    /**
   * Preview: ![green 300](https://mui.com/static/colors-preview/green-300-24x24.png)
   */ 300: '#81c784',
    /**
   * Preview: ![green 400](https://mui.com/static/colors-preview/green-400-24x24.png)
   */ 400: '#66bb6a',
    /**
   * Preview: ![green 500](https://mui.com/static/colors-preview/green-500-24x24.png)
   */ 500: '#4caf50',
    /**
   * Preview: ![green 600](https://mui.com/static/colors-preview/green-600-24x24.png)
   */ 600: '#43a047',
    /**
   * Preview: ![green 700](https://mui.com/static/colors-preview/green-700-24x24.png)
   */ 700: '#388e3c',
    /**
   * Preview: ![green 800](https://mui.com/static/colors-preview/green-800-24x24.png)
   */ 800: '#2e7d32',
    /**
   * Preview: ![green 900](https://mui.com/static/colors-preview/green-900-24x24.png)
   */ 900: '#1b5e20',
    /**
   * Preview: ![green A100](https://mui.com/static/colors-preview/green-A100-24x24.png)
   */ A100: '#b9f6ca',
    /**
   * Preview: ![green A200](https://mui.com/static/colors-preview/green-A200-24x24.png)
   */ A200: '#69f0ae',
    /**
   * Preview: ![green A400](https://mui.com/static/colors-preview/green-A400-24x24.png)
   */ A400: '#00e676',
    /**
   * Preview: ![green A700](https://mui.com/static/colors-preview/green-A700-24x24.png)
   */ A700: '#00c853'
};
var $a3e3b29cd31a116f$var$_default = module.exports.default = $a3e3b29cd31a116f$var$green;

});


parcelRegister("5YF3H", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $45a267bfd1cb6e55$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyChildrenFocusVisible = $45a267bfd1cb6e55$var$applyChildrenFocusVisible;
module.exports.applyInsetFocusVisible = $45a267bfd1cb6e55$var$applyInsetFocusVisible;
module.exports.isResolvedFocusVisible = $45a267bfd1cb6e55$var$isResolvedFocusVisible;
module.exports.mergeFocusVisibleInput = $45a267bfd1cb6e55$var$mergeFocusVisibleInput;
module.exports.outsetFocusRing = void 0;
module.exports.resolveFocusVisible = $45a267bfd1cb6e55$var$resolveFocusVisible;
module.exports.wireFocusVisibleVars = $45a267bfd1cb6e55$var$wireFocusVisibleVars;

var $45a267bfd1cb6e55$var$_deepmerge = $45a267bfd1cb6e55$require$_interopRequireDefault((parcelRequire("bQ4jM")));
const $45a267bfd1cb6e55$var$focusVisibleOffsetVar = '--_focusVisible-offset';
const $45a267bfd1cb6e55$var$focusVisibleBehaviorVar = '--_focusVisible-behavior';
const $45a267bfd1cb6e55$var$focusVisibleShadowVar = '--_focusVisible-shadow';
const $45a267bfd1cb6e55$var$offsetValue = `var(${$45a267bfd1cb6e55$var$focusVisibleOffsetVar}, 1)`;
const $45a267bfd1cb6e55$var$behaviorValue = `var(${$45a267bfd1cb6e55$var$focusVisibleBehaviorVar}, )`;
// Spread on a root whose ring must stay outset: the inset vars inherit, so a clip-prone ancestor
// would otherwise inset a descendant's ring too.
const $45a267bfd1cb6e55$var$outsetFocusRing = module.exports.outsetFocusRing = {
    [$45a267bfd1cb6e55$var$focusVisibleOffsetVar]: 1,
    [$45a267bfd1cb6e55$var$focusVisibleBehaviorVar]: 'initial' // reverts the var to guaranteed-invalid so `var(--_focusVisible-behavior, )` falls back to empty — there is no explicit `outset` keyword.
};
// Used by the colored-background surfaces (AppBar, Alert, SnackbarContent) to make the focus visible appear through box-shadow
function $45a267bfd1cb6e55$var$applyChildrenFocusVisible(color) {
    return {
        [$45a267bfd1cb6e55$var$focusVisibleShadowVar]: color
    };
}
// Clip-prone components (Tab, MenuItem, …) spread this on their root to inset the ring, so an
// `overflow: hidden` ancestor cannot clip it — without the component knowing the ring width.
// `offset` multiplies the ring's own outlineOffset, so 1 = mirror it inward.
function $45a267bfd1cb6e55$var$applyInsetFocusVisible(offset) {
    return {
        [$45a267bfd1cb6e55$var$focusVisibleOffsetVar]: -offset,
        [$45a267bfd1cb6e55$var$focusVisibleBehaviorVar]: 'inset'
    };
}
// Merge the raw `focusVisible` input across `createTheme(options, ...args)` with the theme's own
// deep-merge semantics. The single-key wrapper is load-bearing — a raw value hits deepmerge's
// top-level plain-object guard (`deepmerge(true, obj)` drops the object).
function $45a267bfd1cb6e55$var$mergeFocusVisibleInput(optionsFocusVisible, args) {
    return args.reduce((acc, arg)=>arg && 'focusVisible' in arg ? (0, $45a267bfd1cb6e55$var$_deepmerge.default)(acc, {
            focusVisible: arg.focusVisible
        }) : acc, {
        focusVisible: optionsFocusVisible
    }).focusVisible;
}
/**
 * Whether an input is this module's own output. Only `wireFocusVisibleVars` emits the offset calc,
 * so it identifies a ring fed back in by `createTheme(existingTheme, …)`.
 */ function $45a267bfd1cb6e55$var$isResolvedFocusVisible(input) {
    return input != null && typeof input === 'object' && typeof input.outlineOffset === 'string' && input.outlineOffset.includes($45a267bfd1cb6e55$var$focusVisibleOffsetVar);
}
/**
 * Resolve the opt-in ring, wiring in the private inset vars. `outlineColor` is the caller's default
 * — a hex, the palette var, or a scheme's primary — overridden by a user-provided `outlineColor`.
 */ function $45a267bfd1cb6e55$var$resolveFocusVisible(input, outlineColor) {
    return $45a267bfd1cb6e55$var$wireFocusVisibleVars({
        outlineStyle: 'solid',
        outlineColor: outlineColor,
        outlineWidth: 2,
        outlineOffset: 2,
        // invisible shadow for parent component with solid background (AppBar, Snackbar, Alert) can control the ring color.
        boxShadow: `var(${$45a267bfd1cb6e55$var$focusVisibleShadowVar}, 0 0)`,
        ...input === true ? null : input
    });
}
/**
 * Wire the private inset vars into a resolved `theme.focusVisible` so a custom `outlineOffset` or
 * `boxShadow` insets automatically on clip-prone components. Mutates and returns the object.
 */ function $45a267bfd1cb6e55$var$wireFocusVisibleVars(resolved) {
    // Multiply the offset by the sign var so it flips to inset on clip-prone components. Skip if
    // already wired: re-composing a resolved theme must not wrap the calc twice and invert the sign.
    const offset = resolved.outlineOffset ?? 0;
    if (typeof offset !== 'string' || !offset.includes($45a267bfd1cb6e55$var$focusVisibleOffsetVar)) {
        const offsetPx = typeof offset === 'number' ? `${offset}px` : offset;
        resolved.outlineOffset = `calc(${$45a267bfd1cb6e55$var$offsetValue} * ${offsetPx})`;
    }
    // Prefix a box-shadow with the behavior var so it insets there too, unless it already opts in.
    // Standalone keywords are complete values — prefixing would produce an invalid `inset none`.
    const standaloneBoxShadows = new Set([
        'none',
        'initial',
        'inherit',
        'unset',
        'revert',
        'revert-layer'
    ]);
    if (typeof resolved.boxShadow === 'string' && !standaloneBoxShadows.has(resolved.boxShadow.trim().toLowerCase()) && !/\binset\b/.test(resolved.boxShadow) && !resolved.boxShadow.includes($45a267bfd1cb6e55$var$focusVisibleBehaviorVar)) resolved.boxShadow = `${$45a267bfd1cb6e55$var$behaviorValue} ${resolved.boxShadow}`;
    return resolved;
}

});

parcelRegister("eLI0w", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ac07976fc01fdfa9$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $ac07976fc01fdfa9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetCssVar = void 0;
module.exports.default = $ac07976fc01fdfa9$var$createThemeWithVars;

var $ac07976fc01fdfa9$var$_formatMuiErrorMessage = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $ac07976fc01fdfa9$var$_deepmerge = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $izOUK = parcelRequire("izOUK");

var $8ZgMs = parcelRequire("8ZgMs");

var $fckAO = parcelRequire("fckAO");

var $ac07976fc01fdfa9$var$_styleFunctionSx = $ac07976fc01fdfa9$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $h61zw = parcelRequire("h61zw");

var $ac07976fc01fdfa9$var$_createThemeNoVars = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("8v3fy")));

var $ac07976fc01fdfa9$var$_createColorScheme = $ac07976fc01fdfa9$require$_interopRequireWildcard((parcelRequire("2JzIB")));

var $ac07976fc01fdfa9$var$_shouldSkipGeneratingVar = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("fPRn6")));

var $ac07976fc01fdfa9$var$_createGetSelector = $ac07976fc01fdfa9$require$_interopRequireDefault((parcelRequire("9yYvT")));

var $2ICMq = parcelRequire("2ICMq");

var $4Gk6P = parcelRequire("4Gk6P");

var $5YF3H = parcelRequire("5YF3H");
function $ac07976fc01fdfa9$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $ac07976fc01fdfa9$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $ac07976fc01fdfa9$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $h61zw.hslToRgb)(color);
}
function $ac07976fc01fdfa9$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $ac07976fc01fdfa9$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $ac07976fc01fdfa9$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $ac07976fc01fdfa9$var$createGetCssVar = (cssVarPrefix = 'mui')=>(0, $izOUK.unstable_createGetCssVar)(cssVarPrefix);
module.exports.createGetCssVar = $ac07976fc01fdfa9$var$createGetCssVar;
function $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $ac07976fc01fdfa9$var$_createColorScheme.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $ac07976fc01fdfa9$var$_createThemeNoVars.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $ac07976fc01fdfa9$var$_createColorScheme.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $ac07976fc01fdfa9$var$_createColorScheme.getOverlays)(mode)
    };
    return muiTheme;
}
/**
 * A default `createThemeWithVars` comes with a single color scheme, either `light` or `dark` based on the `defaultColorScheme`.
 * This is better suited for apps that only need a single color scheme.
 *
 * To enable built-in `light` and `dark` color schemes, either:
 * 1. provide a `colorSchemeSelector` to define how the color schemes will change.
 * 2. provide `colorSchemes.dark` will set `colorSchemeSelector: 'media'` by default.
 */ function $ac07976fc01fdfa9$var$createThemeWithVars(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = $ac07976fc01fdfa9$var$_shouldSkipGeneratingVar.default, colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $ac07976fc01fdfa9$var$createGetCssVar(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $ac07976fc01fdfa9$var$_formatMuiErrorMessage.default)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $ac07976fc01fdfa9$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $fckAO.prepareTypographyVars)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $ac07976fc01fdfa9$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#fff');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.common, 'background', '#000');
            $ac07976fc01fdfa9$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // Generate `text.primaryChannel` before the component tokens:
        // `palette.Skeleton.bg` uses it as its CSS variable fallback.
        if (!nativeColor) $ac07976fc01fdfa9$var$setColorChannel(palette.text, 'primary');
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === $h61zw.private_safeAlpha) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === $h61zw.private_safeDarken) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === $h61zw.private_safeLighten) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $ac07976fc01fdfa9$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'Input',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.Input, 'autofillWebkitBoxShadow', 'none');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.8);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>colorSpace ? $4Gk6P.dark.text.primary : palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', colorMix($h61zw.private_safeLighten, (0, $h61zw.private_safeAlpha)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.88));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningColor', colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningFilledColor', $ac07976fc01fdfa9$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningStandardBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $ac07976fc01fdfa9$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $ac07976fc01fdfa9$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $ac07976fc01fdfa9$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $ac07976fc01fdfa9$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $ac07976fc01fdfa9$var$setColor(palette.Input, 'autofillWebkitBoxShadow', '0 0 0 100px #266798 inset');
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'primaryBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'errorBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'infoBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'successBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.LinearProgress, 'warningBg', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'primaryTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'secondaryTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'errorTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'infoTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'successTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $ac07976fc01fdfa9$var$setColor(palette.Slider, 'warningTrack', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix($h61zw.private_safeLighten, nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $h61zw.private_safeEmphasize)(palette.background.default, 0.98);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $ac07976fc01fdfa9$var$setColor(palette.SnackbarContent, 'color', $ac07976fc01fdfa9$var$silent(()=>colorSpace ? $4Gk6P.light.text.primary : palette.getContrastText(snackbarContentBackground)));
            $ac07976fc01fdfa9$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h61zw.private_safeEmphasize)(palette.background.paper, 0.15));
            $ac07976fc01fdfa9$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'errorDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'infoDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'successDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.Switch, 'warningDisabledColor', colorMix($h61zw.private_safeDarken, nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.55));
            $ac07976fc01fdfa9$var$setColor(palette.TableCell, 'border', colorMix($h61zw.private_safeDarken, (0, $h61zw.private_safeAlpha)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.68));
            $ac07976fc01fdfa9$var$setColor(palette.Tooltip, 'bg', colorMix($h61zw.private_safeAlpha, nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (!nativeColor) {
            $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'default');
            // added for consistency with the `background.default` token
            $ac07976fc01fdfa9$var$setColorChannel(palette.background, 'paper');
            $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'background');
            $ac07976fc01fdfa9$var$setColorChannel(palette.common, 'onBackground');
            $ac07976fc01fdfa9$var$setColorChannel(palette, 'divider');
        }
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && !nativeColor && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $ac07976fc01fdfa9$var$setColor(palette[color], 'mainChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.main)));
                if (colors.light) $ac07976fc01fdfa9$var$setColor(palette[color], 'lightChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.light)));
                if (colors.dark) $ac07976fc01fdfa9$var$setColor(palette[color], 'darkChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.dark)));
                if (colors.contrastText) $ac07976fc01fdfa9$var$setColor(palette[color], 'contrastTextChannel', (0, $h61zw.private_safeColorChannel)($ac07976fc01fdfa9$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'primary');
                    $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $ac07976fc01fdfa9$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $ac07976fc01fdfa9$var$_deepmerge.default)(acc, argument), theme);
    // Default color is the palette var, not a hex: `focusVisible` is spread inline (skipped from var
    // generation, see `shouldSkipGeneratingVar`), so the var adapts per scheme at the CSS level — no
    // per-scheme copy needed here, unlike the no-vars path in `createTheme`.
    const focusVisibleInput = (0, $5YF3H.mergeFocusVisibleInput)(options.focusVisible, args);
    if (focusVisibleInput != null && focusVisibleInput !== false) theme.focusVisible = (0, $5YF3H.resolveFocusVisible)(focusVisibleInput, getCssVar('palette-primary-main'));
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $ac07976fc01fdfa9$var$_createGetSelector.default)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $fckAO.prepareCssVars)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $izOUK.createSpacing)(input.spacing, (0, $8ZgMs.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $fckAO.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...$ac07976fc01fdfa9$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $ac07976fc01fdfa9$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    theme.internal_cache = {};
    theme.toRuntimeSource = $2ICMq.stringifyTheme; // for Pigment CSS integration
    return theme;
}

});
parcelRegister("fckAO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b107f34b17d36dd1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty(module.exports, "createGetColorSchemeSelector", {
    enumerable: true,
    get: function() {
        return $9wccP.createGetColorSchemeSelector;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty(module.exports, "prepareCssVars", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_prepareCssVars.default;
    }
});
Object.defineProperty(module.exports, "prepareTypographyVars", {
    enumerable: true,
    get: function() {
        return $b107f34b17d36dd1$var$_prepareTypographyVars.default;
    }
});

var $b107f34b17d36dd1$var$_createCssVarsProvider = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("3Vfwq")));

var $b107f34b17d36dd1$var$_prepareCssVars = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("5magr")));

var $b107f34b17d36dd1$var$_prepareTypographyVars = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("ikjX2")));

var $b107f34b17d36dd1$var$_createCssVarsTheme = $b107f34b17d36dd1$require$_interopRequireDefault((parcelRequire("73CWR")));

var $9wccP = parcelRequire("9wccP");

});
parcelRegister("ikjX2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d579922b6de2dbd6$var$prepareTypographyVars;
function $d579922b6de2dbd6$var$prepareTypographyVars(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});


parcelRegister("8v3fy", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $6303bd594dbbe1c5$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $6303bd594dbbe1c5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6303bd594dbbe1c5$var$_formatMuiErrorMessage = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $6303bd594dbbe1c5$var$_deepmerge = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $6303bd594dbbe1c5$var$_styleFunctionSx = $6303bd594dbbe1c5$require$_interopRequireWildcard((parcelRequire("l6FST")));

var $6303bd594dbbe1c5$var$_createTheme = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("1dhnG")));

var $h61zw = parcelRequire("h61zw");

var $6303bd594dbbe1c5$var$_generateUtilityClass = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $6303bd594dbbe1c5$var$_createMixins = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("6plKN")));

var $6303bd594dbbe1c5$var$_createPalette = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $6303bd594dbbe1c5$var$_createTypography = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $6303bd594dbbe1c5$var$_shadows = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("jtCFx")));

var $6303bd594dbbe1c5$var$_createTransitions = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("bmoVh")));

var $6303bd594dbbe1c5$var$_createMotion = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("23bgI")));

var $6303bd594dbbe1c5$var$_zIndex = $6303bd594dbbe1c5$require$_interopRequireDefault((parcelRequire("lhXgK")));

var $2ICMq = parcelRequire("2ICMq");

var $5YF3H = parcelRequire("5YF3H");
function $6303bd594dbbe1c5$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $6303bd594dbbe1c5$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
// `rgba()` takes rgb channels, so `hsl()` is converted like the theme's `*Channel` tokens.
function $6303bd594dbbe1c5$var$toRgb(color) {
    return color.startsWith('hsl') ? (0, $h61zw.hslToRgb)(color) : color;
}
// Replaces the `var()` matches in `alpha()`: `var(--x, #1976d2)` -> `var(--xChannel, 25 118 210)`.
// The fallback keeps the color valid when the CSS variables aren't defined (no `ThemeProvider`).
// It's dropped when it isn't a color `colorChannel()` parses, for example `currentColor` or a nested `var()`,
// or when it's a `color()`, whose channels aren't sRGB.
// More than one level of nested parentheses isn't supported: the match ends at the first run of `)`,
// so the rest of the fallback stays in the output.
function $6303bd594dbbe1c5$var$toChannelVar(match, name, fallback = '') {
    const color = fallback.trim();
    if (color && !color.startsWith('color(')) try {
        const channel = (0, $h61zw.colorChannel)($6303bd594dbbe1c5$var$toRgb(color));
        // Space-separated syntax like `rgb(0 0 0)` doesn't throw but gives a single value, or `NaN`s for `hsl()`.
        if (channel.split(' ').length === 3 && !channel.includes('NaN')) return `var(--${name}Channel, ${channel})`;
    } catch  {
    // Not a supported color.
    }
    return `var(--${name}Channel)`;
}
function $6303bd594dbbe1c5$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) {
                // To preserve the behavior of the CSS theme variables
                // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
                // Raw colors (for example, `theme.palette.*`) have no channel tokens,
                // so they are converted to channels the same way the theme generates `*Channel` tokens,
                // which keeps a CSS coefficient (for example, `theme.vars.palette.action.hoverOpacity`) in `calc()`.
                const alphaValue = typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient;
                // `color()` channels are not sRGB, so only the alpha is replaced to keep any color space and unit.
                if (color.startsWith('color(')) return color.replace(/\s*(?:\/[^)]*)?\)$/, ` / ${alphaValue})`);
                const channels = color.includes('var(') ? color.replace(/var\(--([^,\s)]+)(?:,((?:[^()]|\([^()]*\))+)\)|(?:,[^)]+)?\)+)/g, $6303bd594dbbe1c5$var$toChannelVar) : (0, $h61zw.private_safeColorChannel)($6303bd594dbbe1c5$var$toRgb(color));
                return `rgba(${channels} / ${alphaValue})`;
            }
            return (0, $h61zw.alpha)(color, $6303bd594dbbe1c5$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$6303bd594dbbe1c5$var$coefficientToPercentage(coefficient)})`;
            return (0, $h61zw.lighten)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$6303bd594dbbe1c5$var$coefficientToPercentage(coefficient)})`;
            return (0, $h61zw.darken)(color, coefficient);
        }
    });
}
function $6303bd594dbbe1c5$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, motion: motionInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $6303bd594dbbe1c5$var$_formatMuiErrorMessage.default)(22));
    const palette = (0, $6303bd594dbbe1c5$var$_createPalette.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $6303bd594dbbe1c5$var$_createTheme.default)(options);
    let muiTheme = (0, $6303bd594dbbe1c5$var$_deepmerge.default)(systemTheme, {
        mixins: (0, $6303bd594dbbe1c5$var$_createMixins.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: $6303bd594dbbe1c5$var$_shadows.default.slice(),
        typography: (0, $6303bd594dbbe1c5$var$_createTypography.default)(palette, typographyInput),
        motion: (0, $6303bd594dbbe1c5$var$_createMotion.default)(motionInput),
        transitions: (0, $6303bd594dbbe1c5$var$_createTransitions.default)(transitionsInput),
        zIndex: {
            ...$6303bd594dbbe1c5$var$_zIndex.default
        }
    });
    muiTheme = (0, $6303bd594dbbe1c5$var$_deepmerge.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $6303bd594dbbe1c5$var$_deepmerge.default)(acc, argument), muiTheme);
    // `reducedMotion` is owned by `theme.motion`; remove stale values preserved by systemCreateTheme.
    delete muiTheme.transitions.reducedMotion;
    // Normalize once so components read a resolved object, never the boolean. The color is a hex off
    // this (default) scheme; `createTheme` attaches a per-scheme copy so dark mode stays reactive.
    // Read the palette off `muiTheme` — a merge argument may have recolored it after `palette` was built.
    if (muiTheme.focusVisible != null && muiTheme.focusVisible !== false) muiTheme.focusVisible = (0, $5YF3H.resolveFocusVisible)(muiTheme.focusVisible, muiTheme.palette.primary.main);
    var component;
    muiTheme.unstable_sxConfig = {
        ...$6303bd594dbbe1c5$var$_styleFunctionSx.unstable_defaultSxConfig,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6303bd594dbbe1c5$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = $2ICMq.stringifyTheme; // for Pigment CSS integration
    $6303bd594dbbe1c5$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $6303bd594dbbe1c5$var$_default = module.exports.default = $6303bd594dbbe1c5$var$createThemeNoVars;

});
parcelRegister("6plKN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4aa5f3b4975f3e4c$var$createMixins;
function $4aa5f3b4975f3e4c$var$createMixins(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("d6q8u", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $98a01bf22de9dc59$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $98a01bf22de9dc59$var$createTypography;

var $98a01bf22de9dc59$var$_deepmerge = $98a01bf22de9dc59$require$_interopRequireDefault((parcelRequire("bQ4jM")));
function $98a01bf22de9dc59$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $98a01bf22de9dc59$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $98a01bf22de9dc59$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://m2.material.io/design/typography/the-type-system.html}
 * @see @link{https://m2.material.io/design/typography/understanding-typography.html}
 */ function $98a01bf22de9dc59$var$createTypography(palette, typography) {
    const { fontFamily: fontFamily = $98a01bf22de9dc59$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $98a01bf22de9dc59$var$defaultFontFamily ? {
                letterSpacing: `${$98a01bf22de9dc59$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $98a01bf22de9dc59$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $98a01bf22de9dc59$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $98a01bf22de9dc59$var$_deepmerge.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("jtCFx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity = 0.2;
const $e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity = 0.14;
const $e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity = 0.12;
function $e2deb8a0bbe5ea21$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$e2deb8a0bbe5ea21$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $e2deb8a0bbe5ea21$var$shadows = [
    'none',
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $e2deb8a0bbe5ea21$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $e2deb8a0bbe5ea21$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $e2deb8a0bbe5ea21$var$_default = module.exports.default = $e2deb8a0bbe5ea21$var$shadows;

});

parcelRegister("bmoVh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $845514f3678d3888$var$createTransitions;
module.exports.easing = module.exports.duration = void 0;
const $845514f3678d3888$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $845514f3678d3888$var$EMPTY_OPTIONS = {};
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $845514f3678d3888$var$easing = module.exports.easing = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
// Follow https://m2.material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing
const $845514f3678d3888$var$duration = module.exports.duration = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $845514f3678d3888$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $845514f3678d3888$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $845514f3678d3888$var$createTransitions(inputTransitions) {
    const transitions = {
        ...inputTransitions
    };
    delete transitions.reducedMotion;
    const mergedEasing = {
        ...$845514f3678d3888$var$easing,
        ...transitions.easing
    };
    const mergedDuration = {
        ...$845514f3678d3888$var$duration,
        ...transitions.duration
    };
    const createTransitionValue = (props = $845514f3678d3888$var$DEFAULT_TRANSITION_PROPS, options = $845514f3678d3888$var$EMPTY_OPTIONS)=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $845514f3678d3888$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $845514f3678d3888$var$formatMs(delay)}`).join(',');
    };
    const create = transitions.create ?? createTransitionValue;
    return {
        getAutoHeightDuration: $845514f3678d3888$var$getAutoHeightDuration,
        create: create,
        ...transitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("23bgI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17e49a4bcd7c1a91$var$createMotion;
const $17e49a4bcd7c1a91$var$EMPTY_MOTION = {};
function $17e49a4bcd7c1a91$var$createMotion(inputMotion = $17e49a4bcd7c1a91$var$EMPTY_MOTION) {
    return {
        reducedMotion: 'never',
        ...inputMotion
    };
}

});

parcelRegister("lhXgK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f7f9291b6f07cefb$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f7f9291b6f07cefb$var$_default = module.exports.default = $f7f9291b6f07cefb$var$zIndex;

});

parcelRegister("2ICMq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stringifyTheme = $1fadc5be6a14f8c8$var$stringifyTheme;

var $bQ4jM = parcelRequire("bQ4jM");
/* eslint-disable import/prefer-default-export */ function $1fadc5be6a14f8c8$var$isSerializable(val) {
    return (0, $bQ4jM.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
/**
 * `baseTheme` usually comes from `createTheme()` or `extendTheme()`.
 *
 * This function is intended to be used with zero-runtime CSS-in-JS like Pigment CSS
 * For example, in a Next.js project:
 *
 * ```js
 * // next.config.js
 * const { extendTheme } = require('@mui/material/styles');
 *
 * const theme = extendTheme();
 * // `.toRuntimeSource` is Pigment CSS specific to create a theme that is available at runtime.
 * theme.toRuntimeSource = stringifyTheme;
 *
 * module.exports = withPigment({
 *  theme,
 * });
 * ```
 */ function $1fadc5be6a14f8c8$var$stringifyTheme(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$1fadc5be6a14f8c8$var$isSerializable(value) || key.startsWith('unstable_') || key.startsWith('internal_')) delete object[key];
            else if ((0, $bQ4jM.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.motion = { reducedMotion: 'never', ...theme.motion };
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("2JzIB", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $1fdb7dab8864519b$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1fdb7dab8864519b$var$createColorScheme;
module.exports.getOpacity = $1fdb7dab8864519b$var$getOpacity;
module.exports.getOverlays = $1fdb7dab8864519b$var$getOverlays;

var $1fdb7dab8864519b$var$_createPalette = $1fdb7dab8864519b$require$_interopRequireDefault((parcelRequire("4Gk6P")));

var $1fdb7dab8864519b$var$_getOverlayAlpha = $1fdb7dab8864519b$require$_interopRequireDefault((parcelRequire("35vyj")));
const $1fdb7dab8864519b$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $1fdb7dab8864519b$var$_getOverlayAlpha.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $1fdb7dab8864519b$var$getOpacity(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $1fdb7dab8864519b$var$getOverlays(mode) {
    return mode === 'dark' ? $1fdb7dab8864519b$var$defaultDarkOverlays : [];
}
function $1fdb7dab8864519b$var$createColorScheme(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $1fdb7dab8864519b$var$_createPalette.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$1fdb7dab8864519b$var$getOpacity(palette.mode),
            ...opacity
        },
        overlays: overlays || $1fdb7dab8864519b$var$getOverlays(palette.mode),
        ...other
    };
}

});
parcelRegister("35vyj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23fa506264c010ed$var$getOverlayAlpha;
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $23fa506264c010ed$var$getOverlayAlpha(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("fPRn6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b87504e8f71bd950$var$shouldSkipGeneratingVar;
function $b87504e8f71bd950$var$shouldSkipGeneratingVar(keys) {
    return keys[0] === 'motion' || // Keep `focusVisible` inline: its values reference the per-component private vars
    // (`--_focusVisible-offset`/`-behavior`). Hoisted to a `:root` var they resolve where those
    // vars are unset, silently breaking the inner-ring inset.
    keys[0] === 'focusVisible' || !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("9yYvT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6f663abbabfb57a0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f663abbabfb57a0$var$_excludeVariablesFromRoot = $6f663abbabfb57a0$require$_interopRequireDefault((parcelRequire("kKEhy")));
var $6f663abbabfb57a0$var$_default = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $6f663abbabfb57a0$var$_excludeVariablesFromRoot.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };
module.exports.default = $6f663abbabfb57a0$var$_default;

});
parcelRegister("kKEhy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $f1b759b2363a287f$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $f1b759b2363a287f$var$_default = module.exports.default = $f1b759b2363a287f$var$excludeVariablesFromRoot;

});




parcelRegister("5YvA3", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $459b0d9305cee191$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $459b0d9305cee191$var$enhanceHighContrast;

var $459b0d9305cee191$var$_accordionSummaryClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("ijHn9")));

var $459b0d9305cee191$var$_autocompleteClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("9O25J")));

var $459b0d9305cee191$var$_checkboxClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("9s7Sp")));

var $459b0d9305cee191$var$_filledInputClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("faAxf")));

var $459b0d9305cee191$var$_formControlLabelClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("7Z1x5")));

var $459b0d9305cee191$var$_formHelperTextClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("e7ceb")));

var $459b0d9305cee191$var$_formLabelClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("h2sOW")));

var $459b0d9305cee191$var$_inputClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("b3ugU")));

var $459b0d9305cee191$var$_listItemButtonClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("dUgGz")));

var $459b0d9305cee191$var$_menuItemClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("eWb0W")));

var $459b0d9305cee191$var$_nativeSelectClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("6jVRo")));

var $459b0d9305cee191$var$_outlinedInputClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("96QZi")));

var $459b0d9305cee191$var$_radioClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("iHxWE")));

var $459b0d9305cee191$var$_sliderClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("20dvU")));

var $459b0d9305cee191$var$_toggleButtonClasses = $459b0d9305cee191$require$_interopRequireDefault((parcelRequire("3cuAs")));
// System color keywords used in forced-colors / high contrast mode.
const $459b0d9305cee191$var$defaultHcTokens = {
    disabled: 'GrayText',
    error: 'ActiveText',
    selectedBackground: 'SelectedItem',
    selectedText: 'SelectedItemText',
    activeBackground: 'Highlight',
    activeText: 'HighlightText',
    buttonBorder: 'ButtonBorder',
    buttonText: 'ButtonText',
    canvas: 'Canvas'
};
const $459b0d9305cee191$var$HCM = '@media (forced-colors: active)';
/**
 * Enhances a theme with styles for Windows High Contrast Mode (forced-colors).
 *
 * Accepts a fully-created theme, merges in HCM component overrides using arrays
 * so that Emotion emits each entry as a separate CSS rule and the browser
 * cascade (rather than JS object merging) resolves specificity.
 *
 * @param themeInput - The theme to enhance.
 * @param tokens - Override any of the default system color tokens.
 * @returns The enhanced theme (same type as the input).
 *
 * @example
 * // Use defaults
 * const theme = enhanceHighContrast(createTheme({ palette: { ... } }));
 *
 * @example
 * // Override specific tokens
 * const theme = enhanceHighContrast(createTheme(), { disabled: 'ButtonText' });
 */ function $459b0d9305cee191$var$enhanceHighContrast(themeInput, tokens) {
    const hcTokens = {
        disabled: tokens?.disabled ?? $459b0d9305cee191$var$defaultHcTokens.disabled,
        error: tokens?.error ?? $459b0d9305cee191$var$defaultHcTokens.error,
        selectedBackground: tokens?.selectedBackground ?? $459b0d9305cee191$var$defaultHcTokens.selectedBackground,
        selectedText: tokens?.selectedText ?? $459b0d9305cee191$var$defaultHcTokens.selectedText,
        activeBackground: tokens?.activeBackground ?? $459b0d9305cee191$var$defaultHcTokens.activeBackground,
        activeText: tokens?.activeText ?? $459b0d9305cee191$var$defaultHcTokens.activeText,
        buttonBorder: tokens?.buttonBorder ?? $459b0d9305cee191$var$defaultHcTokens.buttonBorder,
        buttonText: tokens?.buttonText ?? $459b0d9305cee191$var$defaultHcTokens.buttonText,
        canvas: tokens?.canvas ?? $459b0d9305cee191$var$defaultHcTokens.canvas
    };
    const theme = {
        ...themeInput
    };
    const c = theme.components;
    theme.components = {
        ...c,
        MuiAccordionSummary: {
            ...c?.MuiAccordionSummary,
            styleOverrides: {
                ...c?.MuiAccordionSummary?.styleOverrides,
                root: [
                    c?.MuiAccordionSummary?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_accordionSummaryClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                opacity: 1
                            }
                        }
                    }
                ]
            }
        },
        MuiAutocomplete: {
            ...c?.MuiAutocomplete,
            styleOverrides: {
                ...c?.MuiAutocomplete?.styleOverrides,
                listbox: [
                    c?.MuiAutocomplete?.styleOverrides?.listbox,
                    {
                        [`& .${$459b0d9305cee191$var$_autocompleteClasses.default.option}`]: {
                            '&[aria-disabled="true"]': {
                                [$459b0d9305cee191$var$HCM]: {
                                    color: hcTokens.disabled,
                                    opacity: 1
                                }
                            },
                            [`&.${$459b0d9305cee191$var$_autocompleteClasses.default.focused}, &.${$459b0d9305cee191$var$_autocompleteClasses.default.focusVisible}`]: {
                                [$459b0d9305cee191$var$HCM]: {
                                    forcedColorAdjust: 'none',
                                    color: hcTokens.activeText,
                                    backgroundColor: hcTokens.activeBackground
                                }
                            },
                            '&[aria-selected="true"]': {
                                [$459b0d9305cee191$var$HCM]: {
                                    forcedColorAdjust: 'none',
                                    color: hcTokens.selectedText,
                                    backgroundColor: hcTokens.selectedBackground
                                },
                                [`&.${$459b0d9305cee191$var$_autocompleteClasses.default.focused}`]: {
                                    [$459b0d9305cee191$var$HCM]: {
                                        color: hcTokens.activeText,
                                        backgroundColor: hcTokens.activeBackground
                                    }
                                }
                            }
                        }
                    }
                ]
            }
        },
        MuiCheckbox: {
            ...c?.MuiCheckbox,
            styleOverrides: {
                ...c?.MuiCheckbox?.styleOverrides,
                root: [
                    c?.MuiCheckbox?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_checkboxClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiFilledInput: {
            ...c?.MuiFilledInput,
            styleOverrides: {
                ...c?.MuiFilledInput?.styleOverrides,
                root: [
                    c?.MuiFilledInput?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_filledInputClasses.default.error}`]: {
                            '&::before, &::after': {
                                [$459b0d9305cee191$var$HCM]: {
                                    borderBottomColor: hcTokens.error
                                }
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_filledInputClasses.default.disabled}:before`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                borderBottomStyle: 'solid',
                                borderBottomColor: hcTokens.disabled
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_filledInputClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiFormControlLabel: {
            ...c?.MuiFormControlLabel,
            styleOverrides: {
                ...c?.MuiFormControlLabel?.styleOverrides,
                root: [
                    c?.MuiFormControlLabel?.styleOverrides?.root,
                    {
                        [`& .${$459b0d9305cee191$var$_formControlLabelClasses.default.label}.${$459b0d9305cee191$var$_formControlLabelClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiFormHelperText: {
            ...c?.MuiFormHelperText,
            styleOverrides: {
                ...c?.MuiFormHelperText?.styleOverrides,
                root: [
                    c?.MuiFormHelperText?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_formHelperTextClasses.default.error}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.error
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_formHelperTextClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiFormLabel: {
            ...c?.MuiFormLabel,
            styleOverrides: {
                ...c?.MuiFormLabel?.styleOverrides,
                root: [
                    c?.MuiFormLabel?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_formLabelClasses.default.error}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.error
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_formLabelClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiInput: {
            ...c?.MuiInput,
            styleOverrides: {
                ...c?.MuiInput?.styleOverrides,
                root: [
                    c?.MuiInput?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_inputClasses.default.error}`]: {
                            '&::before, &::after': {
                                [$459b0d9305cee191$var$HCM]: {
                                    borderBottomColor: hcTokens.error
                                }
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_inputClasses.default.disabled}:before`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                borderBottomStyle: 'solid',
                                borderBottomColor: hcTokens.disabled
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_inputClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiLinearProgress: {
            ...c?.MuiLinearProgress,
            styleOverrides: {
                ...c?.MuiLinearProgress?.styleOverrides,
                root: [
                    c?.MuiLinearProgress?.styleOverrides?.root,
                    {
                        [$459b0d9305cee191$var$HCM]: {
                            forcedColorAdjust: 'none',
                            outline: `1px solid ${hcTokens.buttonBorder}`,
                            backgroundColor: hcTokens.canvas
                        }
                    }
                ],
                bar: [
                    c?.MuiLinearProgress?.styleOverrides?.bar,
                    {
                        [$459b0d9305cee191$var$HCM]: {
                            backgroundColor: hcTokens.buttonText
                        }
                    }
                ],
                bar2: [
                    c?.MuiLinearProgress?.styleOverrides?.bar2,
                    {
                        variants: [
                            {
                                props: {
                                    variant: 'buffer'
                                },
                                style: {
                                    [$459b0d9305cee191$var$HCM]: {
                                        backgroundColor: hcTokens.disabled
                                    }
                                }
                            }
                        ]
                    }
                ]
            }
        },
        MuiInputBase: {
            ...c?.MuiInputBase,
            styleOverrides: {
                ...c?.MuiInputBase?.styleOverrides,
                input: [
                    c?.MuiInputBase?.styleOverrides?.input,
                    {
                        [$459b0d9305cee191$var$HCM]: {
                            '&::placeholder': {
                                opacity: 1
                            }
                        }
                    }
                ]
            }
        },
        MuiMenuItem: {
            ...c?.MuiMenuItem,
            styleOverrides: {
                ...c?.MuiMenuItem?.styleOverrides,
                root: [
                    c?.MuiMenuItem?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_menuItemClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled,
                                opacity: 1
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_menuItemClasses.default.focusVisible}, &:hover`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                forcedColorAdjust: 'none',
                                color: hcTokens.activeText,
                                backgroundColor: hcTokens.activeBackground,
                                outline: 'none'
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_menuItemClasses.default.selected}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                forcedColorAdjust: 'none',
                                color: hcTokens.selectedText,
                                backgroundColor: hcTokens.selectedBackground
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_menuItemClasses.default.selected}.${$459b0d9305cee191$var$_menuItemClasses.default.focusVisible}, &.${$459b0d9305cee191$var$_menuItemClasses.default.selected}:hover`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.activeText,
                                backgroundColor: hcTokens.activeBackground
                            }
                        }
                    }
                ]
            }
        },
        MuiListItemIcon: {
            ...c?.MuiListItemIcon,
            styleOverrides: {
                ...c?.MuiListItemIcon?.styleOverrides,
                root: [
                    c?.MuiListItemIcon?.styleOverrides?.root,
                    {
                        [$459b0d9305cee191$var$HCM]: {
                            color: 'inherit'
                        }
                    }
                ]
            }
        },
        MuiListItemButton: {
            ...c?.MuiListItemButton,
            styleOverrides: {
                ...c?.MuiListItemButton?.styleOverrides,
                root: [
                    c?.MuiListItemButton?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_listItemButtonClasses.default.focusVisible}, &:hover`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                forcedColorAdjust: 'none',
                                color: hcTokens.activeText,
                                backgroundColor: hcTokens.activeBackground
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_listItemButtonClasses.default.selected}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                forcedColorAdjust: 'none',
                                color: hcTokens.selectedText,
                                backgroundColor: hcTokens.selectedBackground
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_listItemButtonClasses.default.selected}.${$459b0d9305cee191$var$_listItemButtonClasses.default.focusVisible}, &.${$459b0d9305cee191$var$_listItemButtonClasses.default.selected}:hover`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.activeText,
                                backgroundColor: hcTokens.activeBackground
                            }
                        }
                    }
                ]
            }
        },
        MuiNativeSelect: {
            ...c?.MuiNativeSelect,
            styleOverrides: {
                ...c?.MuiNativeSelect?.styleOverrides,
                icon: [
                    c?.MuiNativeSelect?.styleOverrides?.icon,
                    {
                        [`&.${$459b0d9305cee191$var$_nativeSelectClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiOutlinedInput: {
            ...c?.MuiOutlinedInput,
            styleOverrides: {
                ...c?.MuiOutlinedInput?.styleOverrides,
                root: [
                    c?.MuiOutlinedInput?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_outlinedInputClasses.default.error} .${$459b0d9305cee191$var$_outlinedInputClasses.default.notchedOutline}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                borderColor: hcTokens.error
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_outlinedInputClasses.default.disabled} .${$459b0d9305cee191$var$_outlinedInputClasses.default.notchedOutline}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                borderColor: hcTokens.disabled
                            }
                        },
                        [`&.${$459b0d9305cee191$var$_outlinedInputClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiRadio: {
            ...c?.MuiRadio,
            styleOverrides: {
                ...c?.MuiRadio?.styleOverrides,
                root: [
                    c?.MuiRadio?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_radioClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                color: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiSlider: {
            ...c?.MuiSlider,
            styleOverrides: {
                ...c?.MuiSlider?.styleOverrides,
                // track doesn't receive the disabled class — use ownerState
                track: [
                    c?.MuiSlider?.styleOverrides?.track,
                    ({ ownerState: ownerState })=>({
                            ...ownerState.disabled && {
                                [$459b0d9305cee191$var$HCM]: {
                                    borderColor: hcTokens.disabled
                                }
                            }
                        })
                ],
                // thumb receives the disabled class directly
                thumb: [
                    c?.MuiSlider?.styleOverrides?.thumb,
                    {
                        [`&.${$459b0d9305cee191$var$_sliderClasses.default.disabled}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                borderColor: hcTokens.disabled
                            }
                        }
                    }
                ]
            }
        },
        MuiSwitch: {
            ...c?.MuiSwitch,
            styleOverrides: {
                ...c?.MuiSwitch?.styleOverrides,
                // track and thumb don't receive the disabled class — use ownerState
                track: [
                    c?.MuiSwitch?.styleOverrides?.track,
                    ({ ownerState: ownerState })=>({
                            ...ownerState.disabled && {
                                [$459b0d9305cee191$var$HCM]: {
                                    borderColor: hcTokens.disabled
                                }
                            }
                        })
                ],
                thumb: [
                    c?.MuiSwitch?.styleOverrides?.thumb,
                    ({ ownerState: ownerState })=>({
                            ...ownerState.disabled && {
                                [$459b0d9305cee191$var$HCM]: {
                                    borderColor: hcTokens.disabled
                                }
                            }
                        })
                ]
            }
        },
        MuiButtonBase: {
            ...c?.MuiButtonBase,
            styleOverrides: {
                ...c?.MuiButtonBase?.styleOverrides,
                root: [
                    c?.MuiButtonBase?.styleOverrides?.root,
                    {
                        // Restore the focus outline in HCM since the ripple is not visible.
                        // Also handle components where the focusable element is a hidden inner input (Checkbox, Radio, Switch).
                        [$459b0d9305cee191$var$HCM]: {
                            '&:focus-visible, &:focus-within:has(input:focus-visible)': {
                                outline: `5px auto ${hcTokens.activeBackground}`
                            }
                        }
                    }
                ]
            }
        },
        MuiTooltip: {
            ...c?.MuiTooltip,
            styleOverrides: {
                ...c?.MuiTooltip?.styleOverrides,
                tooltip: [
                    c?.MuiTooltip?.styleOverrides?.tooltip,
                    {
                        [$459b0d9305cee191$var$HCM]: {
                            border: `1px solid ${hcTokens.buttonText}`
                        }
                    }
                ]
            }
        },
        MuiToggleButton: {
            ...c?.MuiToggleButton,
            styleOverrides: {
                ...c?.MuiToggleButton?.styleOverrides,
                root: [
                    c?.MuiToggleButton?.styleOverrides?.root,
                    {
                        [`&.${$459b0d9305cee191$var$_toggleButtonClasses.default.selected}`]: {
                            [$459b0d9305cee191$var$HCM]: {
                                forcedColorAdjust: 'none',
                                color: hcTokens.activeText,
                                backgroundColor: hcTokens.activeBackground,
                                borderColor: hcTokens.activeBackground
                            },
                            '&:hover': {
                                [$459b0d9305cee191$var$HCM]: {
                                    backgroundColor: hcTokens.activeBackground,
                                    borderColor: hcTokens.buttonBorder
                                }
                            }
                        }
                    }
                ]
            }
        }
    };
    return theme;
}

});
parcelRegister("ijHn9", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d55ba52db43b55df$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAccordionSummaryUtilityClass = $d55ba52db43b55df$var$getAccordionSummaryUtilityClass;

var $d55ba52db43b55df$var$_generateUtilityClasses = $d55ba52db43b55df$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d55ba52db43b55df$var$_generateUtilityClass = $d55ba52db43b55df$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d55ba52db43b55df$var$getAccordionSummaryUtilityClass(slot) {
    return (0, $d55ba52db43b55df$var$_generateUtilityClass.default)('MuiAccordionSummary', slot);
}
const $d55ba52db43b55df$var$accordionSummaryClasses = (0, $d55ba52db43b55df$var$_generateUtilityClasses.default)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'content',
    'expandIconWrapper'
]);
var $d55ba52db43b55df$var$_default = module.exports.default = $d55ba52db43b55df$var$accordionSummaryClasses;

});

parcelRegister("9O25J", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $723a67e53eb4dc4c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getAutocompleteUtilityClass = $723a67e53eb4dc4c$var$getAutocompleteUtilityClass;

var $723a67e53eb4dc4c$var$_generateUtilityClasses = $723a67e53eb4dc4c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $723a67e53eb4dc4c$var$_generateUtilityClass = $723a67e53eb4dc4c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $723a67e53eb4dc4c$var$getAutocompleteUtilityClass(slot) {
    return (0, $723a67e53eb4dc4c$var$_generateUtilityClass.default)('MuiAutocomplete', slot);
}
const $723a67e53eb4dc4c$var$autocompleteClasses = (0, $723a67e53eb4dc4c$var$_generateUtilityClasses.default)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'status',
    'option',
    'groupLabel',
    'groupUl'
]);
var $723a67e53eb4dc4c$var$_default = module.exports.default = $723a67e53eb4dc4c$var$autocompleteClasses;

});

parcelRegister("9s7Sp", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6e1cd6b997bc70d3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getCheckboxUtilityClass = $6e1cd6b997bc70d3$var$getCheckboxUtilityClass;

var $6e1cd6b997bc70d3$var$_generateUtilityClasses = $6e1cd6b997bc70d3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6e1cd6b997bc70d3$var$_generateUtilityClass = $6e1cd6b997bc70d3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $6e1cd6b997bc70d3$var$getCheckboxUtilityClass(slot) {
    return (0, $6e1cd6b997bc70d3$var$_generateUtilityClass.default)('MuiCheckbox', slot);
}
const $6e1cd6b997bc70d3$var$checkboxClasses = (0, $6e1cd6b997bc70d3$var$_generateUtilityClasses.default)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6e1cd6b997bc70d3$var$_default = module.exports.default = $6e1cd6b997bc70d3$var$checkboxClasses;

});

parcelRegister("faAxf", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $b0b42157daacd8b1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFilledInputUtilityClass = $b0b42157daacd8b1$var$getFilledInputUtilityClass;

var $b0b42157daacd8b1$var$_generateUtilityClasses = $b0b42157daacd8b1$require$_interopRequireDefault((parcelRequire("5nY49")));

var $b0b42157daacd8b1$var$_generateUtilityClass = $b0b42157daacd8b1$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $9MvHs = parcelRequire("9MvHs");
function $b0b42157daacd8b1$var$getFilledInputUtilityClass(slot) {
    return (0, $b0b42157daacd8b1$var$_generateUtilityClass.default)('MuiFilledInput', slot);
}
const $b0b42157daacd8b1$var$filledInputClasses = {
    ...$9MvHs.inputBaseClasses,
    ...(0, $b0b42157daacd8b1$var$_generateUtilityClasses.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $b0b42157daacd8b1$var$_default = module.exports.default = $b0b42157daacd8b1$var$filledInputClasses;

});
parcelRegister("9MvHs", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $71f12fb6991c55a7$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $71f12fb6991c55a7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $71f12fb6991c55a7$var$_exportNames = {
    inputBaseClasses: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $71f12fb6991c55a7$var$_InputBase.default;
    }
});
Object.defineProperty(module.exports, "inputBaseClasses", {
    enumerable: true,
    get: function() {
        return $71f12fb6991c55a7$var$_inputBaseClasses.default;
    }
});

var $71f12fb6991c55a7$var$_InputBase = $71f12fb6991c55a7$require$_interopRequireDefault((parcelRequire("95gUw")));

var $71f12fb6991c55a7$var$_inputBaseClasses = $71f12fb6991c55a7$require$_interopRequireWildcard((parcelRequire("dmljZ")));
Object.keys($71f12fb6991c55a7$var$_inputBaseClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($71f12fb6991c55a7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $71f12fb6991c55a7$var$_inputBaseClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $71f12fb6991c55a7$var$_inputBaseClasses[key];
        }
    });
});

});
parcelRegister("95gUw", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $69d1b2c99a8dc649$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $69d1b2c99a8dc649$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rootOverridesResolver = module.exports.inputOverridesResolver = module.exports.default = module.exports.InputBaseRoot = module.exports.InputBaseInput = void 0;

var $69d1b2c99a8dc649$var$_formatMuiErrorMessage = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $69d1b2c99a8dc649$var$React = $69d1b2c99a8dc649$require$_interopRequireWildcard((parcelRequire("acw62")));

var $69d1b2c99a8dc649$var$_propTypes = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $69d1b2c99a8dc649$var$_clsx = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("9QePP")));

var $69d1b2c99a8dc649$var$_elementTypeAcceptingRef = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("g6PKz")));

var $69d1b2c99a8dc649$var$_refType = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("b3gjr")));

var $69d1b2c99a8dc649$var$_composeClasses = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("3Hg1x")));

var $69d1b2c99a8dc649$var$_isHostComponent = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("7jqh1")));

var $69d1b2c99a8dc649$var$_TextareaAutosize = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("3vH0x")));

var $69d1b2c99a8dc649$var$_FormControlContext = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("blr6C")));

var $cJQfW = parcelRequire("cJQfW");

var $aAbgT = parcelRequire("aAbgT");

var $69d1b2c99a8dc649$var$_memoTheme = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("aeD7H")));

var $hL1nr = parcelRequire("hL1nr");

var $69d1b2c99a8dc649$var$_capitalize = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("jTnBY")));

var $69d1b2c99a8dc649$var$_useForkRef = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("9Rgf1")));

var $69d1b2c99a8dc649$var$_useEnhancedEffect = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("khjmj")));

var $69d1b2c99a8dc649$var$_ownerDocument = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("gzyUk")));

var $69d1b2c99a8dc649$var$_getActiveElement = $69d1b2c99a8dc649$require$_interopRequireDefault((parcelRequire("6uU67")));

var $2BbKU = parcelRequire("2BbKU");

var $69d1b2c99a8dc649$var$_inputBaseClasses = $69d1b2c99a8dc649$require$_interopRequireWildcard((parcelRequire("dmljZ")));

var $hweuE = parcelRequire("hweuE");

var $ayMG0 = parcelRequire("ayMG0");
var $69d1b2c99a8dc649$var$_InputGlobalStyles;
const $69d1b2c99a8dc649$var$MUI_AUTO_FILL = 'mui-auto-fill';
const $69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL = 'mui-auto-fill-cancel';
const $69d1b2c99a8dc649$var$rootOverridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $69d1b2c99a8dc649$var$_capitalize.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
module.exports.rootOverridesResolver = $69d1b2c99a8dc649$var$rootOverridesResolver;
const $69d1b2c99a8dc649$var$inputOverridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.type === 'search' && styles.inputTypeSearch
    ];
};
module.exports.inputOverridesResolver = $69d1b2c99a8dc649$var$inputOverridesResolver;
const $69d1b2c99a8dc649$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $69d1b2c99a8dc649$var$_capitalize.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $69d1b2c99a8dc649$var$_capitalize.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            readOnly && 'readOnly'
        ]
    };
    return (0, $69d1b2c99a8dc649$var$_composeClasses.default)(slots, $69d1b2c99a8dc649$var$_inputBaseClasses.getInputBaseUtilityClass, classes);
};
const $69d1b2c99a8dc649$var$InputBaseRoot = module.exports.InputBaseRoot = (0, $aAbgT.styled)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $69d1b2c99a8dc649$var$rootOverridesResolver
})((0, $69d1b2c99a8dc649$var$_memoTheme.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${$69d1b2c99a8dc649$var$_inputBaseClasses.default.disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $69d1b2c99a8dc649$var$InputBaseInput = module.exports.InputBaseInput = (0, $aAbgT.styled)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $69d1b2c99a8dc649$var$inputOverridesResolver
})((0, $69d1b2c99a8dc649$var$_memoTheme.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        ...(0, $hweuE.getTransitionStyles)(theme, 'opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${$69d1b2c99a8dc649$var$_inputBaseClasses.default.formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${$69d1b2c99a8dc649$var$_inputBaseClasses.default.disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: $69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL,
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: $69d1b2c99a8dc649$var$MUI_AUTO_FILL
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $69d1b2c99a8dc649$var$InputGlobalStyles = (0, $aAbgT.globalCss)({
    // Keep keyframes non-empty for Emotion production builds. Animation properties are ignored
    // inside keyframes, avoiding the visible display animation triggered by Chrome 117+.
    [`@keyframes ${$69d1b2c99a8dc649$var$MUI_AUTO_FILL}`]: {
        from: {
            animationName: $69d1b2c99a8dc649$var$MUI_AUTO_FILL
        }
    },
    [`@keyframes ${$69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL}`]: {
        from: {
            animationName: $69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $69d1b2c99a8dc649$var$InputBase = /*#__PURE__*/ $69d1b2c99a8dc649$var$React.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsBase, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const inputPropsProp = {
        ...inputPropsBase,
        ...slotProps.input
    };
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $69d1b2c99a8dc649$var$React.useRef(value != null);
    const inputRef = $69d1b2c99a8dc649$var$React.useRef();
    const handleInputRefWarning = $69d1b2c99a8dc649$var$React.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $69d1b2c99a8dc649$var$_useForkRef.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $69d1b2c99a8dc649$var$React.useState(false);
    const [fcs, muiFormControl] = (0, $cJQfW.useFormControlState)({
        props: props,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $69d1b2c99a8dc649$var$React.useCallback((obj)=>{
        if ((0, $2BbKU.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $69d1b2c99a8dc649$var$_useEnhancedEffect.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    // Sync focused state when autoFocus is used in SSR.
    // If the browser focused the element before hydration, the onFocus handler never
    // fires. If it did not, React hydration does not call focus() for autoFocus.
    (0, $69d1b2c99a8dc649$var$_useEnhancedEffect.default)(()=>{
        if (!autoFocus) return;
        const input = inputRef.current;
        if (!input) return;
        const doc = (0, $69d1b2c99a8dc649$var$_ownerDocument.default)(input);
        const activeElement = (0, $69d1b2c99a8dc649$var$_getActiveElement.default)(doc);
        const noElementFocused = activeElement == null || activeElement === doc.body || activeElement === doc.documentElement;
        if (input === activeElement) {
            if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus();
            else setFocused(true);
        } else if (noElementFocused) input.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        autoFocus
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $69d1b2c99a8dc649$var$_formatMuiErrorMessage.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = $69d1b2c99a8dc649$var$_TextareaAutosize.default;
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === $69d1b2c99a8dc649$var$MUI_AUTO_FILL_CANCEL ? inputRef.current : {
            value: 'x'
        });
    };
    $69d1b2c99a8dc649$var$React.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $69d1b2c99a8dc649$var$useUtilityClasses(ownerState);
    const Root = slots.root || $69d1b2c99a8dc649$var$InputBaseRoot;
    const rootProps = slotProps.root || {};
    const Input = slots.input || $69d1b2c99a8dc649$var$InputBaseInput;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($69d1b2c99a8dc649$var$React.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $69d1b2c99a8dc649$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($69d1b2c99a8dc649$var$_InputGlobalStyles || ($69d1b2c99a8dc649$var$_InputGlobalStyles = /*#__PURE__*/ (0, $ayMG0.jsx)($69d1b2c99a8dc649$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $ayMG0.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $69d1b2c99a8dc649$var$_isHostComponent.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $69d1b2c99a8dc649$var$_clsx.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $ayMG0.jsx)($69d1b2c99a8dc649$var$_FormControlContext.default.Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            "aria-label": ariaLabel,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $69d1b2c99a8dc649$var$_isHostComponent.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $69d1b2c99a8dc649$var$_clsx.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $69d1b2c99a8dc649$var$_default = module.exports.default = $69d1b2c99a8dc649$var$InputBase;

});
parcelRegister("g6PKz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $bba559669a6b05ba$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $bba559669a6b05ba$var$_elementTypeAcceptingRef.default;
    }
});

var $bba559669a6b05ba$var$_elementTypeAcceptingRef = $bba559669a6b05ba$require$_interopRequireDefault((parcelRequire("ipGOY")));

});
parcelRegister("ipGOY", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $d67bc73532990cfc$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $d67bc73532990cfc$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d67bc73532990cfc$var$_propTypes = $d67bc73532990cfc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $d67bc73532990cfc$var$React = $d67bc73532990cfc$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d67bc73532990cfc$var$_chainPropTypes = $d67bc73532990cfc$require$_interopRequireDefault((parcelRequire("abVWF")));
function $d67bc73532990cfc$var$isClassComponent(elementType) {
    // elementType.prototype?.isReactComponent
    const { prototype: prototype = {} } = elementType;
    return Boolean(prototype.isReactComponent);
}
function $d67bc73532990cfc$var$elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
    const propValue = props[propName];
    const safePropName = propFullName || propName;
    if (propValue == null || // When server-side rendering React doesn't warn either.
    // This is not an accurate check for SSR.
    // This is only in place for emotion compat.
    // TODO: Revisit once https://github.com/react/react/issues/20047 is resolved.
    typeof window === 'undefined') return null;
    let warningHint;
    /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */ if (typeof propValue === 'function' && !$d67bc73532990cfc$var$isClassComponent(propValue)) warningHint = 'Did you accidentally provide a plain function component instead?';
    if (propValue === $d67bc73532990cfc$var$React.Fragment) warningHint = 'Did you accidentally provide a React.Fragment instead?';
    if (warningHint !== undefined) // #host-reference
    return new Error(`Invalid ${location} \`${safePropName}\` supplied to \`${componentName}\`. ` + `Expected an element type that can hold a ref. ${warningHint} ` + 'For more information see https://mui.com/r/caveat-with-refs-guide');
    return null;
}
var $d67bc73532990cfc$var$_default = module.exports.default = (0, $d67bc73532990cfc$var$_chainPropTypes.default)($d67bc73532990cfc$var$_propTypes.default.elementType, $d67bc73532990cfc$var$elementTypeAcceptingRef);

});
parcelRegister("abVWF", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $76b7e12fe7b0c8f4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $76b7e12fe7b0c8f4$var$_chainPropTypes.default;
    }
});

var $76b7e12fe7b0c8f4$var$_chainPropTypes = $76b7e12fe7b0c8f4$require$_interopRequireDefault((parcelRequire("8jTls")));

});
parcelRegister("8jTls", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $60eb0778cff380af$var$chainPropTypes;
function $60eb0778cff380af$var$chainPropTypes(propType1, propType2) {
    return ()=>null;
}

});




parcelRegister("b3gjr", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $80bca0e241370467$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80bca0e241370467$var$_refType.default;
    }
});

var $80bca0e241370467$var$_refType = $80bca0e241370467$require$_interopRequireDefault((parcelRequire("5g2TU")));

});
parcelRegister("5g2TU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d40b2611b4cd7ef$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3d40b2611b4cd7ef$var$_propTypes = $3d40b2611b4cd7ef$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $3d40b2611b4cd7ef$var$refType = $3d40b2611b4cd7ef$var$_propTypes.default.oneOfType([
    $3d40b2611b4cd7ef$var$_propTypes.default.func,
    $3d40b2611b4cd7ef$var$_propTypes.default.object
]);
var $3d40b2611b4cd7ef$var$_default = module.exports.default = $3d40b2611b4cd7ef$var$refType;

});


parcelRegister("7jqh1", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $552eb02447a4b108$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $552eb02447a4b108$var$_isHostComponent.default;
    }
});

var $552eb02447a4b108$var$_isHostComponent = $552eb02447a4b108$require$_interopRequireDefault((parcelRequire("1cVk7")));

});
parcelRegister("1cVk7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $0e1360ab77873eb8$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $0e1360ab77873eb8$var$_default = module.exports.default = $0e1360ab77873eb8$var$isHostComponent;

});


parcelRegister("3vH0x", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $28e5a0c586f490cf$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $28e5a0c586f490cf$var$_TextareaAutosize.default;
    }
});

var $28e5a0c586f490cf$var$_TextareaAutosize = $28e5a0c586f490cf$require$_interopRequireDefault((parcelRequire("gSRTE")));

});
parcelRegister("gSRTE", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $032c0e7078a9cb7d$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $032c0e7078a9cb7d$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $032c0e7078a9cb7d$var$React = $032c0e7078a9cb7d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $032c0e7078a9cb7d$var$_propTypes = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $032c0e7078a9cb7d$var$_debounce = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("9NXOO")));

var $032c0e7078a9cb7d$var$_useForkRef = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("e4pKA")));

var $032c0e7078a9cb7d$var$_useEnhancedEffect = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("jdWO4")));

var $032c0e7078a9cb7d$var$_useEventCallback = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("6Lbjo")));

var $032c0e7078a9cb7d$var$_ownerWindow = $032c0e7078a9cb7d$require$_interopRequireDefault((parcelRequire("4Rhws")));

var $ayMG0 = parcelRequire("ayMG0");
function $032c0e7078a9cb7d$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $032c0e7078a9cb7d$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $032c0e7078a9cb7d$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $032c0e7078a9cb7d$var$isEmpty(obj) {
    return $032c0e7078a9cb7d$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $032c0e7078a9cb7d$var$TextareaAutosize = /*#__PURE__*/ $032c0e7078a9cb7d$var$React.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $032c0e7078a9cb7d$var$React.useRef(value != null);
    const textareaRef = $032c0e7078a9cb7d$var$React.useRef(null);
    const handleRef = (0, $032c0e7078a9cb7d$var$_useForkRef.default)(forwardedRef, textareaRef);
    const heightRef = $032c0e7078a9cb7d$var$React.useRef(null);
    const hiddenTextareaRef = $032c0e7078a9cb7d$var$React.useRef(null);
    const calculateTextareaStyles = $032c0e7078a9cb7d$var$React.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $032c0e7078a9cb7d$var$_ownerWindow.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingBottom) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.paddingTop);
        const border = $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderBottomWidth) + $032c0e7078a9cb7d$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $032c0e7078a9cb7d$var$_useEventCallback.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $032c0e7078a9cb7d$var$React.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $032c0e7078a9cb7d$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $032c0e7078a9cb7d$var$React.useRef(-1);
    (0, $032c0e7078a9cb7d$var$_useEnhancedEffect.default)(()=>{
        const debouncedHandleResize = (0, $032c0e7078a9cb7d$var$_debounce.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $032c0e7078a9cb7d$var$_ownerWindow.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $032c0e7078a9cb7d$var$_useEnhancedEffect.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($032c0e7078a9cb7d$var$React.Fragment, {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$032c0e7078a9cb7d$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $032c0e7078a9cb7d$var$_default = module.exports.default = $032c0e7078a9cb7d$var$TextareaAutosize;

});
parcelRegister("9NXOO", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $723717646d90af53$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $723717646d90af53$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $723717646d90af53$var$_debounce.default;
    }
});

var $723717646d90af53$var$_debounce = $723717646d90af53$require$_interopRequireWildcard((parcelRequire("7VOF5")));
Object.keys($723717646d90af53$var$_debounce).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($723717646d90af53$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $723717646d90af53$var$_debounce[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $723717646d90af53$var$_debounce[key];
        }
    });
});

});
parcelRegister("7VOF5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5c6527a444bb8d00$var$debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $5c6527a444bb8d00$var$debounce(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});


parcelRegister("e4pKA", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a3e569e96d60bae8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a3e569e96d60bae8$var$_useForkRef.default;
    }
});

var $a3e569e96d60bae8$var$_useForkRef = $a3e569e96d60bae8$require$_interopRequireDefault((parcelRequire("kv0Da")));

});
parcelRegister("kv0Da", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $eec73129f1331d63$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eec73129f1331d63$var$useForkRef;

var $eec73129f1331d63$var$React = $eec73129f1331d63$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * Merges refs into a single memoized callback ref or `null`.
 *
 * ```tsx
 * const rootRef = React.useRef<Instance>(null);
 * const refFork = useForkRef(rootRef, props.ref);
 *
 * return (
 *   <Root {...props} ref={refFork} />
 * );
 * ```
 *
 * @param {Array<React.Ref<Instance> | undefined>} refs The ref array.
 * @returns {React.RefCallback<Instance> | null} The new ref callback.
 */ function $eec73129f1331d63$var$useForkRef(...refs) {
    const cleanupRef = $eec73129f1331d63$var$React.useRef(undefined);
    const refEffect = $eec73129f1331d63$var$React.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    }, refs);
    return $eec73129f1331d63$var$React.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    }, refs);
}

});


parcelRegister("6Lbjo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4ebfe8299138c5c5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4ebfe8299138c5c5$var$_useEventCallback.default;
    }
});

var $4ebfe8299138c5c5$var$_useEventCallback = $4ebfe8299138c5c5$require$_interopRequireDefault((parcelRequire("iDWdC")));

});
parcelRegister("iDWdC", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $d9290782162abf54$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $d9290782162abf54$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9290782162abf54$var$React = $d9290782162abf54$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d9290782162abf54$var$_useEnhancedEffect = $d9290782162abf54$require$_interopRequireDefault((parcelRequire("jdWO4")));
/**
 * Inspired by https://github.com/react/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $d9290782162abf54$var$useEventCallback(fn) {
    const ref = $d9290782162abf54$var$React.useRef(fn);
    (0, $d9290782162abf54$var$_useEnhancedEffect.default)(()=>{
        ref.current = fn;
    });
    return $d9290782162abf54$var$React.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $d9290782162abf54$var$_default = module.exports.default = $d9290782162abf54$var$useEventCallback;

});


parcelRegister("4Rhws", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3899b44489cdde78$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3899b44489cdde78$var$_ownerWindow.default;
    }
});

var $3899b44489cdde78$var$_ownerWindow = $3899b44489cdde78$require$_interopRequireDefault((parcelRequire("l4FpR")));

});
parcelRegister("l4FpR", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f57a191378fb6173$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f57a191378fb6173$var$ownerWindow;

var $f57a191378fb6173$var$_ownerDocument = $f57a191378fb6173$require$_interopRequireDefault((parcelRequire("43fuO")));
function $f57a191378fb6173$var$ownerWindow(node) {
    const doc = (0, $f57a191378fb6173$var$_ownerDocument.default)(node);
    return doc.defaultView || window;
}

});
parcelRegister("43fuO", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2f33766ba7c82ed1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2f33766ba7c82ed1$var$_ownerDocument.default;
    }
});

var $2f33766ba7c82ed1$var$_ownerDocument = $2f33766ba7c82ed1$require$_interopRequireDefault((parcelRequire("49EPw")));

});
parcelRegister("49EPw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3067acab6211afec$var$ownerDocument;
function $3067acab6211afec$var$ownerDocument(node) {
    return node && node.ownerDocument || document;
}

});






parcelRegister("blr6C", function(module, exports) {
"use strict";
'use client';

var $3pEGv = parcelRequire("3pEGv");
var $8426ae8303951a73$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8426ae8303951a73$var$React = $8426ae8303951a73$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * @ignore - internal component.
 */ const $8426ae8303951a73$var$FormControlContext = /*#__PURE__*/ $8426ae8303951a73$var$React.createContext(undefined);
var $8426ae8303951a73$var$_default = module.exports.default = $8426ae8303951a73$var$FormControlContext;

});

parcelRegister("cJQfW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $946238fa82894619$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $946238fa82894619$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $946238fa82894619$var$useFormControl;
module.exports.useFormControlState = $946238fa82894619$var$useFormControlState;

var $946238fa82894619$var$React = $946238fa82894619$require$_interopRequireWildcard((parcelRequire("acw62")));

var $946238fa82894619$var$_FormControlContext = $946238fa82894619$require$_interopRequireDefault((parcelRequire("blr6C")));
function $946238fa82894619$var$useFormControl() {
    return $946238fa82894619$var$React.useContext($946238fa82894619$var$_FormControlContext.default);
}
function $946238fa82894619$var$useFormControlState({ props: props, states: states }) {
    const muiFormControl = $946238fa82894619$var$React.useContext($946238fa82894619$var$_FormControlContext.default);
    const result = {};
    states.forEach((state)=>{
        const value = props[state];
        result[state] = value === undefined && muiFormControl ? muiFormControl[state] : value;
    });
    return [
        result,
        muiFormControl
    ];
}

});

parcelRegister("aAbgT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7b460279bb5c09c1$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $izOUK.css;
    }
});
module.exports.globalCss = $7b460279bb5c09c1$var$globalCss;
module.exports.internal_createExtendSxProp = $7b460279bb5c09c1$var$internal_createExtendSxProp;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $izOUK.keyframes;
    }
});
Object.defineProperty(module.exports, "styled", {
    enumerable: true,
    get: function() {
        return $7b460279bb5c09c1$var$_styled.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $7b460279bb5c09c1$var$_useTheme.default;
    }
});

var $l6FST = parcelRequire("l6FST");

var $7b460279bb5c09c1$var$_useTheme = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("14H9o")));

var $7b460279bb5c09c1$var$_GlobalStyles = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("kjVW8")));

var $ayMG0 = parcelRequire("ayMG0");

var $izOUK = parcelRequire("izOUK");

var $7b460279bb5c09c1$var$_styled = $7b460279bb5c09c1$require$_interopRequireDefault((parcelRequire("d8seH")));
function $7b460279bb5c09c1$var$globalCss(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $ayMG0.jsx)($7b460279bb5c09c1$var$_GlobalStyles.default, {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $7b460279bb5c09c1$var$internal_createExtendSxProp() {
    return $l6FST.extendSxProp;
}

});
parcelRegister("14H9o", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0c87a2f38cd49c7a$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0c87a2f38cd49c7a$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0c87a2f38cd49c7a$var$useTheme;

var $0c87a2f38cd49c7a$var$React = $0c87a2f38cd49c7a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $0c87a2f38cd49c7a$var$_defaultTheme = $0c87a2f38cd49c7a$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $0c87a2f38cd49c7a$var$_identifier = $0c87a2f38cd49c7a$require$_interopRequireDefault((parcelRequire("4jPsi")));
function $0c87a2f38cd49c7a$var$useTheme() {
    const theme = (0, $izOUK.useTheme)($0c87a2f38cd49c7a$var$_defaultTheme.default);
    return theme[$0c87a2f38cd49c7a$var$_identifier.default] || theme;
}

});
parcelRegister("jR9F1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $e74a75f0176cf8e3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e74a75f0176cf8e3$var$_createTheme = $e74a75f0176cf8e3$require$_interopRequireDefault((parcelRequire("ijOKP")));
const $e74a75f0176cf8e3$var$defaultTheme = (0, $e74a75f0176cf8e3$var$_createTheme.default)();
var $e74a75f0176cf8e3$var$_default = module.exports.default = $e74a75f0176cf8e3$var$defaultTheme;

});


parcelRegister("kjVW8", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ecb286025e88fbf5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ecb286025e88fbf5$var$_GlobalStyles.default;
    }
});

var $ecb286025e88fbf5$var$_GlobalStyles = $ecb286025e88fbf5$require$_interopRequireDefault((parcelRequire("ldx2z")));

});
parcelRegister("ldx2z", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $03fc756f7adfd498$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03fc756f7adfd498$var$_propTypes = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $izOUK = parcelRequire("izOUK");

var $03fc756f7adfd498$var$_defaultTheme = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $03fc756f7adfd498$var$_identifier = $03fc756f7adfd498$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $03fc756f7adfd498$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($izOUK.GlobalStyles, {
        ...props,
        defaultTheme: $03fc756f7adfd498$var$_defaultTheme.default,
        themeId: $03fc756f7adfd498$var$_identifier.default
    });
}
var $03fc756f7adfd498$var$_default = module.exports.default = $03fc756f7adfd498$var$GlobalStyles;

});


parcelRegister("d8seH", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0277c5e26ff0d56c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
Object.defineProperty(module.exports, "rootShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $0277c5e26ff0d56c$var$_rootShouldForwardProp.default;
    }
});
Object.defineProperty(module.exports, "slotShouldForwardProp", {
    enumerable: true,
    get: function() {
        return $0277c5e26ff0d56c$var$_slotShouldForwardProp.default;
    }
});

var $0277c5e26ff0d56c$var$_createStyled = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("bbeCr")));

var $0277c5e26ff0d56c$var$_defaultTheme = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $0277c5e26ff0d56c$var$_identifier = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $0277c5e26ff0d56c$var$_rootShouldForwardProp = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("8Uq77")));

var $0277c5e26ff0d56c$var$_slotShouldForwardProp = $0277c5e26ff0d56c$require$_interopRequireDefault((parcelRequire("PJRTc")));
const $0277c5e26ff0d56c$var$styled = (0, $0277c5e26ff0d56c$var$_createStyled.default)({
    themeId: $0277c5e26ff0d56c$var$_identifier.default,
    defaultTheme: $0277c5e26ff0d56c$var$_defaultTheme.default,
    rootShouldForwardProp: $0277c5e26ff0d56c$var$_rootShouldForwardProp.default
});
var $0277c5e26ff0d56c$var$_default = module.exports.default = $0277c5e26ff0d56c$var$styled;

});
parcelRegister("8Uq77", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $67c7cf568a060c3d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $67c7cf568a060c3d$var$_slotShouldForwardProp = $67c7cf568a060c3d$require$_interopRequireDefault((parcelRequire("PJRTc")));
const $67c7cf568a060c3d$var$rootShouldForwardProp = (prop)=>(0, $67c7cf568a060c3d$var$_slotShouldForwardProp.default)(prop) && prop !== 'classes';
var $67c7cf568a060c3d$var$_default = module.exports.default = $67c7cf568a060c3d$var$rootShouldForwardProp;

});
parcelRegister("PJRTc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// copied from @mui/system/createStyled
function $09b8580029d7f562$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $09b8580029d7f562$var$_default = module.exports.default = $09b8580029d7f562$var$slotShouldForwardProp;

});




parcelRegister("aeD7H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $izOUK = parcelRequire("izOUK");
const $77398f38c6229912$var$memoTheme = $izOUK.unstable_memoTheme;
var $77398f38c6229912$var$_default = module.exports.default = $77398f38c6229912$var$memoTheme;

});

parcelRegister("hL1nr", function(module, exports) {
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $ced7e4e89ca5cfee$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ced7e4e89ca5cfee$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $ced7e4e89ca5cfee$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $ced7e4e89ca5cfee$var$_DefaultPropsProvider = $ced7e4e89ca5cfee$require$_interopRequireWildcard((parcelRequire("1iOpW")));

});
parcelRegister("1iOpW", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $0f2e94b8fca67639$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $0f2e94b8fca67639$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $0f2e94b8fca67639$var$useDefaultProps;

var $0f2e94b8fca67639$var$React = $0f2e94b8fca67639$require$_interopRequireWildcard((parcelRequire("acw62")));

var $0f2e94b8fca67639$var$_propTypes = $0f2e94b8fca67639$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $0f2e94b8fca67639$var$_DefaultPropsProvider = $0f2e94b8fca67639$require$_interopRequireWildcard((parcelRequire("buuO7")));

var $ayMG0 = parcelRequire("ayMG0");
function $0f2e94b8fca67639$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0f2e94b8fca67639$var$_DefaultPropsProvider.default, {
        ...props
    });
}
var $0f2e94b8fca67639$var$_default = module.exports.default = $0f2e94b8fca67639$var$DefaultPropsProvider;
function $0f2e94b8fca67639$var$useDefaultProps(params) {
    return (0, $0f2e94b8fca67639$var$_DefaultPropsProvider.useDefaultProps)(params);
}

});


parcelRegister("jTnBY", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $e7b578196486f177$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e7b578196486f177$var$_capitalize = $e7b578196486f177$require$_interopRequireDefault((parcelRequire("4O6za")));
var $e7b578196486f177$var$_default = module.exports.default = $e7b578196486f177$var$_capitalize.default;

});

parcelRegister("9Rgf1", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $72d5a979b2ad8bc9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $72d5a979b2ad8bc9$var$_useForkRef = $72d5a979b2ad8bc9$require$_interopRequireDefault((parcelRequire("e4pKA")));
var $72d5a979b2ad8bc9$var$_default = module.exports.default = $72d5a979b2ad8bc9$var$_useForkRef.default;

});

parcelRegister("khjmj", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $ec346974df496fc5$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ec346974df496fc5$var$_useEnhancedEffect = $ec346974df496fc5$require$_interopRequireDefault((parcelRequire("jdWO4")));
var $ec346974df496fc5$var$_default = module.exports.default = $ec346974df496fc5$var$_useEnhancedEffect.default;

});

parcelRegister("gzyUk", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c10afe25107351d9$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c10afe25107351d9$var$_ownerDocument = $c10afe25107351d9$require$_interopRequireDefault((parcelRequire("43fuO")));
var $c10afe25107351d9$var$_default = module.exports.default = $c10afe25107351d9$var$_ownerDocument.default;

});

parcelRegister("6uU67", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $4bb10f3e537aa943$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4bb10f3e537aa943$var$_getActiveElement = $4bb10f3e537aa943$require$_interopRequireDefault((parcelRequire("auqlt")));
var $4bb10f3e537aa943$var$_default = module.exports.default = $4bb10f3e537aa943$var$_getActiveElement.default;

});
parcelRegister("auqlt", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $7a312461c420a305$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7a312461c420a305$var$_getActiveElement.default;
    }
});

var $7a312461c420a305$var$_getActiveElement = $7a312461c420a305$require$_interopRequireDefault((parcelRequire("ffAmm")));

});
parcelRegister("ffAmm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b1a47605ee2f1b8f$var$activeElement;
/**
 * Gets the actual active element, traversing through shadow roots if necessary.
 *
 * When an element inside a shadow root has focus, `document.activeElement` returns
 * the shadow host element. This function recursively traverses shadow roots to find
 * the actual focused element.
 *
 * @param root - The document or shadow root to start the search from.
 * @returns The actual focused element, or null if no element has focus.
 *
 * @example
 * // In a shadow DOM context
 * const activeElement = getActiveElement(document);
 * // Returns the actual focused element inside the shadow root
 *
 * @example
 * // Starting from a specific document
 * const activeElement = getActiveElement(ownerDocument(element));
 */ function $b1a47605ee2f1b8f$var$activeElement(doc) {
    let element = doc.activeElement;
    while(element?.shadowRoot?.activeElement != null)element = element.shadowRoot.activeElement;
    return element;
}

});



parcelRegister("2BbKU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValue = $1e4827e2a850b1f0$var$hasValue;
module.exports.isAdornedStart = $1e4827e2a850b1f0$var$isAdornedStart;
module.exports.isFilled = $1e4827e2a850b1f0$var$isFilled;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $1e4827e2a850b1f0$var$hasValue(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function $1e4827e2a850b1f0$var$isFilled(obj, SSR = false) {
    return obj && ($1e4827e2a850b1f0$var$hasValue(obj.value) && obj.value !== '' || SSR && $1e4827e2a850b1f0$var$hasValue(obj.defaultValue) && obj.defaultValue !== '');
}
// Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.
function $1e4827e2a850b1f0$var$isAdornedStart(obj) {
    return obj.startAdornment;
}

});

parcelRegister("dmljZ", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9b9dde6aa920e08c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputBaseUtilityClass = $9b9dde6aa920e08c$var$getInputBaseUtilityClass;

var $9b9dde6aa920e08c$var$_generateUtilityClasses = $9b9dde6aa920e08c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $9b9dde6aa920e08c$var$_generateUtilityClass = $9b9dde6aa920e08c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $9b9dde6aa920e08c$var$getInputBaseUtilityClass(slot) {
    return (0, $9b9dde6aa920e08c$var$_generateUtilityClass.default)('MuiInputBase', slot);
}
const $9b9dde6aa920e08c$var$inputBaseClasses = (0, $9b9dde6aa920e08c$var$_generateUtilityClasses.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputTypeSearch'
]);
var $9b9dde6aa920e08c$var$_default = module.exports.default = $9b9dde6aa920e08c$var$inputBaseClasses;

});

parcelRegister("hweuE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getReducedMotionStyles = $cc10aae84e3e4b9c$var$getReducedMotionStyles;
module.exports.getTransitionChildStyle = $cc10aae84e3e4b9c$var$getTransitionChildStyle;
module.exports.getTransitionProps = $cc10aae84e3e4b9c$var$getTransitionProps;
module.exports.getTransitionStyles = $cc10aae84e3e4b9c$var$getTransitionStyles;
module.exports.getTranslateOffsets = $cc10aae84e3e4b9c$var$getTranslateOffsets;
module.exports.normalizedTransitionCallback = $cc10aae84e3e4b9c$var$normalizedTransitionCallback;
module.exports.reflow = void 0;

var $fG5eW = parcelRequire("fG5eW");
const $cc10aae84e3e4b9c$var$reflow = (node)=>node.scrollTop;
module.exports.reflow = $cc10aae84e3e4b9c$var$reflow;
const $cc10aae84e3e4b9c$var$DEFAULT_TRANSLATE_OFFSET = {
    offsetX: 0,
    offsetY: 0
};
const $cc10aae84e3e4b9c$var$EMPTY_STYLE = {};
const $cc10aae84e3e4b9c$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $cc10aae84e3e4b9c$var$EMPTY_OPTIONS = {};
const $cc10aae84e3e4b9c$var$transformOffsetIndexes = {
    matrix: [
        4,
        5
    ],
    matrix3d: [
        12,
        13
    ],
    translate: [
        0,
        1
    ],
    translate3d: [
        0,
        1
    ],
    translateX: [
        0,
        null
    ],
    translateY: [
        null,
        0
    ]
};
function $cc10aae84e3e4b9c$var$parseTranslateValue(value) {
    const parsedValue = parseFloat(value ?? '');
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
}
function $cc10aae84e3e4b9c$var$parseTransform(transform) {
    const match = transform.match(/^(matrix|matrix3d|translate|translate3d|translateX|translateY)\((.+)\)$/);
    if (!match) return null;
    return {
        type: match[1],
        values: match[2].split(',').map($cc10aae84e3e4b9c$var$parseTranslateValue)
    };
}
function $cc10aae84e3e4b9c$var$getTranslateOffsetValue(values, index) {
    return index === null ? 0 : values[index] || 0;
}
/**
 * Extracts the x/y translation from a CSS transform string.
 *
 * Transition components use these offsets when calculating off-screen positions:
 * if an element is already translated, the distance needed to hide it must start
 * from that visual position instead of its untransformed layout position.
 *
 * CSSOM commonly serializes translations as matrix() or matrix3d(), while inline
 * gesture styles may use translate(), translate3d(), translateX(), or
 * translateY(). This helper normalizes those supported forms into numeric pixel
 * offsets and returns zero offsets for empty, none, or unsupported transforms.
 */ function $cc10aae84e3e4b9c$var$getTranslateOffsets(transform) {
    if (!transform || transform === 'none') return $cc10aae84e3e4b9c$var$DEFAULT_TRANSLATE_OFFSET;
    const parsedTransform = $cc10aae84e3e4b9c$var$parseTransform(transform);
    if (!parsedTransform) return $cc10aae84e3e4b9c$var$DEFAULT_TRANSLATE_OFFSET;
    const { type: type, values: values } = parsedTransform;
    const offsetIndexes = $cc10aae84e3e4b9c$var$transformOffsetIndexes[type];
    if (!offsetIndexes) return $cc10aae84e3e4b9c$var$DEFAULT_TRANSLATE_OFFSET;
    return {
        offsetX: $cc10aae84e3e4b9c$var$getTranslateOffsetValue(values, offsetIndexes[0]),
        offsetY: $cc10aae84e3e4b9c$var$getTranslateOffsetValue(values, offsetIndexes[1])
    };
}
function $cc10aae84e3e4b9c$var$normalizedTransitionCallback(nodeRef, callback) {
    return (maybeIsAppearing)=>{
        if (callback) {
            const node = nodeRef.current;
            // Enter callbacks receive isAppearing; exit callbacks do not.
            if (maybeIsAppearing === undefined) callback(node);
            else callback(node, maybeIsAppearing);
        }
    };
}
/**
 * Return the child style for a transition. Reuse predefined style objects when
 * no custom styles are present so memoized children see the same object.
 */ function $cc10aae84e3e4b9c$var$getTransitionChildStyle(state, inProp, baseStyles, hiddenStyles, styleProp, childStyle) {
    const base = state === 'exited' && !inProp ? hiddenStyles : baseStyles[state] || baseStyles.exited;
    return styleProp || childStyle ? {
        ...base,
        ...styleProp,
        ...childStyle
    } : base;
}
function $cc10aae84e3e4b9c$var$getTransitionProps(props, options) {
    const { timeout: timeout, easing: easing, style: style = $cc10aae84e3e4b9c$var$EMPTY_STYLE } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}
/**
 * Returns CSS that disables component-owned transitions when reduced motion is active.
 * Pass custom styles only when the default `transition: none` reset is not enough.
 */ function $cc10aae84e3e4b9c$var$getReducedMotionStyles(theme, styles) {
    const resolvedStyles = styles ?? $fG5eW.defaultStyles;
    return (0, $fG5eW.resolveReducedMotionStyles)(theme.motion?.reducedMotion, resolvedStyles);
}
function $cc10aae84e3e4b9c$var$getTransitionStyles(theme, props = $cc10aae84e3e4b9c$var$DEFAULT_TRANSITION_PROPS, options = $cc10aae84e3e4b9c$var$EMPTY_OPTIONS) {
    const transition = theme.transitions?.create?.(props, options);
    const reducedMotionStyles = $cc10aae84e3e4b9c$var$getReducedMotionStyles(theme);
    if (transition === undefined) return reducedMotionStyles ?? $cc10aae84e3e4b9c$var$EMPTY_STYLE;
    const transitionStyles = {
        transition: transition
    };
    return reducedMotionStyles ? {
        ...transitionStyles,
        ...reducedMotionStyles
    } : transitionStyles;
}

});
parcelRegister("fG5eW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultStyles = void 0;
module.exports.resolveReducedMotionStyles = $b69ed7d20902058d$var$resolveReducedMotionStyles;
const $b69ed7d20902058d$var$defaultStyles = module.exports.defaultStyles = {
    transition: 'none'
};
function $b69ed7d20902058d$var$resolveReducedMotionStyles(reducedMotion, styles) {
    if (reducedMotion === 'always') return styles;
    if (reducedMotion === 'system') return {
        '@media (prefers-reduced-motion: reduce)': styles
    };
    return null;
}

});





parcelRegister("7Z1x5", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $5cff6b4166fff27c$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormControlLabelUtilityClasses = $5cff6b4166fff27c$var$getFormControlLabelUtilityClasses;

var $5cff6b4166fff27c$var$_generateUtilityClasses = $5cff6b4166fff27c$require$_interopRequireDefault((parcelRequire("5nY49")));

var $5cff6b4166fff27c$var$_generateUtilityClass = $5cff6b4166fff27c$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $5cff6b4166fff27c$var$getFormControlLabelUtilityClasses(slot) {
    return (0, $5cff6b4166fff27c$var$_generateUtilityClass.default)('MuiFormControlLabel', slot);
}
const $5cff6b4166fff27c$var$formControlLabelClasses = (0, $5cff6b4166fff27c$var$_generateUtilityClasses.default)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementEnd',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $5cff6b4166fff27c$var$_default = module.exports.default = $5cff6b4166fff27c$var$formControlLabelClasses;

});

parcelRegister("e7ceb", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a46b344d341d82c0$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormHelperTextUtilityClasses = $a46b344d341d82c0$var$getFormHelperTextUtilityClasses;

var $a46b344d341d82c0$var$_generateUtilityClasses = $a46b344d341d82c0$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a46b344d341d82c0$var$_generateUtilityClass = $a46b344d341d82c0$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a46b344d341d82c0$var$getFormHelperTextUtilityClasses(slot) {
    return (0, $a46b344d341d82c0$var$_generateUtilityClass.default)('MuiFormHelperText', slot);
}
const $a46b344d341d82c0$var$formHelperTextClasses = (0, $a46b344d341d82c0$var$_generateUtilityClasses.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $a46b344d341d82c0$var$_default = module.exports.default = $a46b344d341d82c0$var$formHelperTextClasses;

});

parcelRegister("h2sOW", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $c678fac155df4fc3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getFormLabelUtilityClasses = $c678fac155df4fc3$var$getFormLabelUtilityClasses;

var $c678fac155df4fc3$var$_generateUtilityClasses = $c678fac155df4fc3$require$_interopRequireDefault((parcelRequire("5nY49")));

var $c678fac155df4fc3$var$_generateUtilityClass = $c678fac155df4fc3$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $c678fac155df4fc3$var$getFormLabelUtilityClasses(slot) {
    return (0, $c678fac155df4fc3$var$_generateUtilityClass.default)('MuiFormLabel', slot);
}
const $c678fac155df4fc3$var$formLabelClasses = (0, $c678fac155df4fc3$var$_generateUtilityClasses.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $c678fac155df4fc3$var$_default = module.exports.default = $c678fac155df4fc3$var$formLabelClasses;

});

parcelRegister("b3ugU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $80c774dd7f29b734$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getInputUtilityClass = $80c774dd7f29b734$var$getInputUtilityClass;

var $80c774dd7f29b734$var$_generateUtilityClasses = $80c774dd7f29b734$require$_interopRequireDefault((parcelRequire("5nY49")));

var $80c774dd7f29b734$var$_generateUtilityClass = $80c774dd7f29b734$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $9MvHs = parcelRequire("9MvHs");
function $80c774dd7f29b734$var$getInputUtilityClass(slot) {
    return (0, $80c774dd7f29b734$var$_generateUtilityClass.default)('MuiInput', slot);
}
const $80c774dd7f29b734$var$inputClasses = {
    ...$9MvHs.inputBaseClasses,
    ...(0, $80c774dd7f29b734$var$_generateUtilityClasses.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $80c774dd7f29b734$var$_default = module.exports.default = $80c774dd7f29b734$var$inputClasses;

});

parcelRegister("dUgGz", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a1fd72c2634274a8$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getListItemButtonUtilityClass = $a1fd72c2634274a8$var$getListItemButtonUtilityClass;

var $a1fd72c2634274a8$var$_generateUtilityClasses = $a1fd72c2634274a8$require$_interopRequireDefault((parcelRequire("5nY49")));

var $a1fd72c2634274a8$var$_generateUtilityClass = $a1fd72c2634274a8$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $a1fd72c2634274a8$var$getListItemButtonUtilityClass(slot) {
    return (0, $a1fd72c2634274a8$var$_generateUtilityClass.default)('MuiListItemButton', slot);
}
const $a1fd72c2634274a8$var$listItemButtonClasses = (0, $a1fd72c2634274a8$var$_generateUtilityClasses.default)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $a1fd72c2634274a8$var$_default = module.exports.default = $a1fd72c2634274a8$var$listItemButtonClasses;

});

parcelRegister("eWb0W", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $adff06ac3b11e066$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getMenuItemUtilityClass = $adff06ac3b11e066$var$getMenuItemUtilityClass;

var $adff06ac3b11e066$var$_generateUtilityClasses = $adff06ac3b11e066$require$_interopRequireDefault((parcelRequire("5nY49")));

var $adff06ac3b11e066$var$_generateUtilityClass = $adff06ac3b11e066$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $adff06ac3b11e066$var$getMenuItemUtilityClass(slot) {
    return (0, $adff06ac3b11e066$var$_generateUtilityClass.default)('MuiMenuItem', slot);
}
const $adff06ac3b11e066$var$menuItemClasses = (0, $adff06ac3b11e066$var$_generateUtilityClasses.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $adff06ac3b11e066$var$_default = module.exports.default = $adff06ac3b11e066$var$menuItemClasses;

});

parcelRegister("6jVRo", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $49a1663d7631a8fa$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getNativeSelectUtilityClasses = $49a1663d7631a8fa$var$getNativeSelectUtilityClasses;

var $49a1663d7631a8fa$var$_generateUtilityClasses = $49a1663d7631a8fa$require$_interopRequireDefault((parcelRequire("5nY49")));

var $49a1663d7631a8fa$var$_generateUtilityClass = $49a1663d7631a8fa$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $49a1663d7631a8fa$var$getNativeSelectUtilityClasses(slot) {
    return (0, $49a1663d7631a8fa$var$_generateUtilityClass.default)('MuiNativeSelect', slot);
}
const $49a1663d7631a8fa$var$nativeSelectClasses = (0, $49a1663d7631a8fa$var$_generateUtilityClasses.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $49a1663d7631a8fa$var$_default = module.exports.default = $49a1663d7631a8fa$var$nativeSelectClasses;

});

parcelRegister("96QZi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $6a1dc6d1d7e1816a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getOutlinedInputUtilityClass = $6a1dc6d1d7e1816a$var$getOutlinedInputUtilityClass;

var $6a1dc6d1d7e1816a$var$_generateUtilityClasses = $6a1dc6d1d7e1816a$require$_interopRequireDefault((parcelRequire("5nY49")));

var $6a1dc6d1d7e1816a$var$_generateUtilityClass = $6a1dc6d1d7e1816a$require$_interopRequireDefault((parcelRequire("b14cZ")));

var $9MvHs = parcelRequire("9MvHs");
function $6a1dc6d1d7e1816a$var$getOutlinedInputUtilityClass(slot) {
    return (0, $6a1dc6d1d7e1816a$var$_generateUtilityClass.default)('MuiOutlinedInput', slot);
}
const $6a1dc6d1d7e1816a$var$outlinedInputClasses = {
    ...$9MvHs.inputBaseClasses,
    ...(0, $6a1dc6d1d7e1816a$var$_generateUtilityClasses.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $6a1dc6d1d7e1816a$var$_default = module.exports.default = $6a1dc6d1d7e1816a$var$outlinedInputClasses;

});

parcelRegister("iHxWE", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $d9d692e9561f6352$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getRadioUtilityClass = $d9d692e9561f6352$var$getRadioUtilityClass;

var $d9d692e9561f6352$var$_generateUtilityClasses = $d9d692e9561f6352$require$_interopRequireDefault((parcelRequire("5nY49")));

var $d9d692e9561f6352$var$_generateUtilityClass = $d9d692e9561f6352$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $d9d692e9561f6352$var$getRadioUtilityClass(slot) {
    return (0, $d9d692e9561f6352$var$_generateUtilityClass.default)('MuiRadio', slot);
}
const $d9d692e9561f6352$var$radioClasses = (0, $d9d692e9561f6352$var$_generateUtilityClasses.default)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $d9d692e9561f6352$var$_default = module.exports.default = $d9d692e9561f6352$var$radioClasses;

});

parcelRegister("20dvU", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $175610683d4083b7$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getSliderUtilityClass = $175610683d4083b7$var$getSliderUtilityClass;

var $175610683d4083b7$var$_generateUtilityClasses = $175610683d4083b7$require$_interopRequireDefault((parcelRequire("5nY49")));

var $175610683d4083b7$var$_generateUtilityClass = $175610683d4083b7$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $175610683d4083b7$var$getSliderUtilityClass(slot) {
    return (0, $175610683d4083b7$var$_generateUtilityClass.default)('MuiSlider', slot);
}
const $175610683d4083b7$var$sliderClasses = (0, $175610683d4083b7$var$_generateUtilityClasses.default)('MuiSlider', [
    'root',
    'active',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'dragging',
    'focusVisible',
    'mark',
    'markActive',
    'marked',
    'markLabel',
    'markLabelActive',
    'rail',
    'sizeSmall',
    'thumb',
    'track',
    'trackInverted',
    'trackFalse',
    'valueLabel',
    'valueLabelOpen',
    'valueLabelCircle',
    'valueLabelLabel',
    'vertical'
]);
var $175610683d4083b7$var$_default = module.exports.default = $175610683d4083b7$var$sliderClasses;

});

parcelRegister("3cuAs", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $254a3802f36599bb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getToggleButtonUtilityClass = $254a3802f36599bb$var$getToggleButtonUtilityClass;

var $254a3802f36599bb$var$_generateUtilityClasses = $254a3802f36599bb$require$_interopRequireDefault((parcelRequire("5nY49")));

var $254a3802f36599bb$var$_generateUtilityClass = $254a3802f36599bb$require$_interopRequireDefault((parcelRequire("b14cZ")));
function $254a3802f36599bb$var$getToggleButtonUtilityClass(slot) {
    return (0, $254a3802f36599bb$var$_generateUtilityClass.default)('MuiToggleButton', slot);
}
const $254a3802f36599bb$var$toggleButtonClasses = (0, $254a3802f36599bb$var$_generateUtilityClasses.default)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $254a3802f36599bb$var$_default = module.exports.default = $254a3802f36599bb$var$toggleButtonClasses;

});


parcelRegister("5fr1m", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $3d23504439aa8524$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3d23504439aa8524$var$createMuiStrictModeTheme;

var $3d23504439aa8524$var$_deepmerge = $3d23504439aa8524$require$_interopRequireDefault((parcelRequire("bQ4jM")));

var $3d23504439aa8524$var$_createTheme = $3d23504439aa8524$require$_interopRequireDefault((parcelRequire("ijOKP")));
function $3d23504439aa8524$var$createMuiStrictModeTheme(options, ...args) {
    return (0, $3d23504439aa8524$var$_createTheme.default)((0, $3d23504439aa8524$var$_deepmerge.default)({
        unstable_strictMode: true
    }, options), ...args);
}

});

parcelRegister("22wy2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $17c504046cb9a64c$var$createStyles;
let $17c504046cb9a64c$var$warnedOnce = false;
// To remove in v6
function $17c504046cb9a64c$var$createStyles(styles) {
    if (!$17c504046cb9a64c$var$warnedOnce) {
        console.warn([
            'MUI: createStyles from @mui/material/styles is deprecated.',
            'Please use @mui/styles/createStyles'
        ].join('\n'));
        $17c504046cb9a64c$var$warnedOnce = true;
    }
    return styles;
}

});

parcelRegister("eoBMT", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $a7b09e624fa460c3$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a7b09e624fa460c3$var$responsiveFontSizes;

var $a7b09e624fa460c3$var$_formatMuiErrorMessage = $a7b09e624fa460c3$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $18jQK = parcelRequire("18jQK");
function $a7b09e624fa460c3$var$responsiveFontSizes(themeInput, options = {}) {
    const { breakpoints: breakpoints = [
        'sm',
        'md',
        'lg'
    ], disableAlign: disableAlign = false, factor: factor = 2, variants: variants = [
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'subtitle1',
        'subtitle2',
        'body1',
        'body2',
        'caption',
        'button',
        'overline'
    ] } = options;
    const theme = {
        ...themeInput
    };
    theme.typography = {
        ...theme.typography
    };
    const typography = theme.typography;
    // Convert between CSS lengths e.g. em->px or px->rem
    // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
    const convert = (0, $18jQK.convertLength)(typography.htmlFontSize);
    const breakpointValues = breakpoints.map((x)=>theme.breakpoints.values[x]);
    variants.forEach((variant)=>{
        const style = typography[variant];
        if (!style) return;
        const remFontSize = parseFloat(convert(style.fontSize, 'rem'));
        if (remFontSize <= 1) return;
        const maxFontSize = remFontSize;
        const minFontSize = 1 + (maxFontSize - 1) / factor;
        let { lineHeight: lineHeight } = style;
        if (!(0, $18jQK.isUnitless)(lineHeight) && !disableAlign) throw new Error((0, $a7b09e624fa460c3$var$_formatMuiErrorMessage.default)(6));
        if (!(0, $18jQK.isUnitless)(lineHeight)) // make it unitless
        lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
        let transform = null;
        if (!disableAlign) transform = (value)=>(0, $18jQK.alignProperty)({
                size: value,
                grid: (0, $18jQK.fontGrid)({
                    pixels: 4,
                    lineHeight: lineHeight,
                    htmlFontSize: typography.htmlFontSize
                })
            });
        const responsive = (0, $18jQK.responsiveProperty)({
            cssProperty: 'fontSize',
            min: minFontSize,
            max: maxFontSize,
            unit: 'rem',
            breakpoints: breakpointValues,
            transform: transform
        });
        // https://github.com/mui/material-ui/issues/40255
        // Preserve the original font size at the largest breakpoint.
        // Grid alignment can snap the max value away from the original designed size.
        if (breakpointValues.length > 0) {
            const lastBreakpoint = breakpointValues[breakpointValues.length - 1];
            responsive[`@media (min-width:${lastBreakpoint}px)`] = {
                fontSize: `${Math.round(maxFontSize * 10000) / 10000}rem`
            };
        }
        typography[variant] = {
            ...style,
            ...responsive
        };
    });
    return theme;
}

});
parcelRegister("18jQK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alignProperty = $0d35ef8a52a98e99$var$alignProperty;
module.exports.convertLength = $0d35ef8a52a98e99$var$convertLength;
module.exports.fontGrid = $0d35ef8a52a98e99$var$fontGrid;
module.exports.getUnit = $0d35ef8a52a98e99$var$getUnit;
module.exports.isUnitless = $0d35ef8a52a98e99$var$isUnitless;
module.exports.responsiveProperty = $0d35ef8a52a98e99$var$responsiveProperty;
module.exports.toUnitless = $0d35ef8a52a98e99$var$toUnitless;
function $0d35ef8a52a98e99$var$isUnitless(value) {
    return String(parseFloat(value)).length === String(value).length;
}
// Ported from Compass
// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"
function $0d35ef8a52a98e99$var$getUnit(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
// Emulate the sass function "unitless"
function $0d35ef8a52a98e99$var$toUnitless(length) {
    return parseFloat(length);
}
// Convert any CSS <length> or <percentage> value to any another.
// From https://github.com/KyleAMathews/convert-css-length
function $0d35ef8a52a98e99$var$convertLength(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $0d35ef8a52a98e99$var$getUnit(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $0d35ef8a52a98e99$var$toUnitless(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $0d35ef8a52a98e99$var$toUnitless(length) * $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $0d35ef8a52a98e99$var$toUnitless(length) * $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $0d35ef8a52a98e99$var$toUnitless(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $0d35ef8a52a98e99$var$alignProperty({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
// fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height
function $0d35ef8a52a98e99$var$fontGrid({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */ function $0d35ef8a52a98e99$var$responsiveProperty({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}

});


parcelRegister("6g9fa", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $48eb684ebe9272b4$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $48eb684ebe9272b4$var$useThemeProps;

var $48eb684ebe9272b4$var$_useThemeProps = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("2LgDM")));

var $48eb684ebe9272b4$var$_defaultTheme = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("jR9F1")));

var $48eb684ebe9272b4$var$_identifier = $48eb684ebe9272b4$require$_interopRequireDefault((parcelRequire("4jPsi")));
function $48eb684ebe9272b4$var$useThemeProps({ props: props, name: name }) {
    return (0, $48eb684ebe9272b4$var$_useThemeProps.default)({
        props: props,
        name: name,
        defaultTheme: $48eb684ebe9272b4$var$_defaultTheme.default,
        themeId: $48eb684ebe9272b4$var$_identifier.default
    });
}

});

parcelRegister("gRp5N", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c4650f6dac4940cb$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c4650f6dac4940cb$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c4650f6dac4940cb$var$ThemeProvider;

var $c4650f6dac4940cb$var$React = $c4650f6dac4940cb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c4650f6dac4940cb$var$_ThemeProviderNoVars = $c4650f6dac4940cb$require$_interopRequireDefault((parcelRequire("6osfi")));

var $b0NgK = parcelRequire("b0NgK");

var $c4650f6dac4940cb$var$_identifier = $c4650f6dac4940cb$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $c4650f6dac4940cb$var$ThemeProvider({ theme: theme, ...props }) {
    const noVarsTheme = $c4650f6dac4940cb$var$React.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = $c4650f6dac4940cb$var$_identifier.default in theme ? theme[$c4650f6dac4940cb$var$_identifier.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $ayMG0.jsx)($c4650f6dac4940cb$var$_ThemeProviderNoVars.default, {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)($b0NgK.CssVarsProvider, {
        theme: theme,
        ...props
    });
}

});
parcelRegister("6osfi", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $4a7ae4f41d656e46$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $4a7ae4f41d656e46$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4a7ae4f41d656e46$var$ThemeProviderNoVars;

var $4a7ae4f41d656e46$var$React = $4a7ae4f41d656e46$require$_interopRequireWildcard((parcelRequire("acw62")));

var $izOUK = parcelRequire("izOUK");

var $4a7ae4f41d656e46$var$_identifier = $4a7ae4f41d656e46$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $ayMG0 = parcelRequire("ayMG0");
function $4a7ae4f41d656e46$var$ThemeProviderNoVars({ theme: themeInput, ...props }) {
    const scopedTheme = $4a7ae4f41d656e46$var$_identifier.default in themeInput ? themeInput[$4a7ae4f41d656e46$var$_identifier.default] : undefined;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($izOUK.ThemeProvider, {
        ...props,
        themeId: scopedTheme ? $4a7ae4f41d656e46$var$_identifier.default : undefined,
        theme: scopedTheme || themeInput
    });
}

});

parcelRegister("b0NgK", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $8045e99d413e4782$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CssVarsProvider = void 0;
module.exports.Experimental_CssVarsProvider = $8045e99d413e4782$var$Experimental_CssVarsProvider;
module.exports.useColorScheme = module.exports.getInitColorSchemeScript = void 0;

var $8045e99d413e4782$var$_styleFunctionSx = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("l6FST")));

var $izOUK = parcelRequire("izOUK");

var $8045e99d413e4782$var$_createTheme = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("ijOKP")));

var $8045e99d413e4782$var$_createTypography = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $8045e99d413e4782$var$_identifier = $8045e99d413e4782$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $3K3i6 = parcelRequire("3K3i6");

var $ayMG0 = parcelRequire("ayMG0");
const { CssVarsProvider: $8045e99d413e4782$var$InternalCssVarsProvider, useColorScheme: $8045e99d413e4782$var$useColorScheme, getInitColorSchemeScript: $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript } = (0, $izOUK.unstable_createCssVarsProvider)({
    themeId: $8045e99d413e4782$var$_identifier.default,
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $8045e99d413e4782$var$_createTheme.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: $3K3i6.defaultConfig.colorSchemeStorageKey,
    modeStorageKey: $3K3i6.defaultConfig.modeStorageKey,
    defaultColorScheme: {
        light: $3K3i6.defaultConfig.defaultLightColorScheme,
        dark: $3K3i6.defaultConfig.defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $8045e99d413e4782$var$_createTypography.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $8045e99d413e4782$var$_styleFunctionSx.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
module.exports.useColorScheme = $8045e99d413e4782$var$useColorScheme;
let $8045e99d413e4782$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $8045e99d413e4782$var$Experimental_CssVarsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($8045e99d413e4782$var$InternalCssVarsProvider, {
        ...props
    });
}
let $8045e99d413e4782$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $8045e99d413e4782$var$getInitColorSchemeScript = (params)=>{
    if (!$8045e99d413e4782$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $8045e99d413e4782$var$warnedInitScriptOnce = true;
    }
    return $8045e99d413e4782$var$deprecatedGetInitColorSchemeScript(params);
};
/**
 * TODO: remove this export in v7
 * @deprecated
 * The `CssVarsProvider` component has been deprecated and ported into `ThemeProvider`.
 *
 * You should use `ThemeProvider` and `createTheme()` instead:
 *
 * ```diff
 * - import { CssVarsProvider, extendTheme } from '@mui/material/styles';
 * + import { ThemeProvider, createTheme } from '@mui/material/styles';
 *
 * - const theme = extendTheme();
 * + const theme = createTheme({
 * +   cssVariables: true,
 * +   colorSchemes: { light: true, dark: true },
 * + });
 *
 * - <CssVarsProvider theme={theme}>
 * + <ThemeProvider theme={theme}>
 * ```
 *
 * To see the full documentation, check out https://mui.com/material-ui/customization/css-theme-variables/usage/.
 */ module.exports.getInitColorSchemeScript = $8045e99d413e4782$var$getInitColorSchemeScript;
const $8045e99d413e4782$var$CssVarsProvider = module.exports.CssVarsProvider = $8045e99d413e4782$var$InternalCssVarsProvider;

});
parcelRegister("3K3i6", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $2b983880bbf899cb$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultConfig = module.exports.default = void 0;

var $2b983880bbf899cb$var$_propTypes = $2b983880bbf899cb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $2b983880bbf899cb$var$_InitColorSchemeScript = $2b983880bbf899cb$require$_interopRequireDefault((parcelRequire("5UPwK")));

var $ayMG0 = parcelRequire("ayMG0");
const $2b983880bbf899cb$var$defaultConfig = module.exports.defaultConfig = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function $2b983880bbf899cb$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $2b983880bbf899cb$var$defaultConfig.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $2b983880bbf899cb$var$defaultConfig.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $2b983880bbf899cb$var$defaultConfig.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $2b983880bbf899cb$var$defaultConfig.colorSchemeStorageKey, attribute: initialAttribute = $2b983880bbf899cb$var$defaultConfig.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($2b983880bbf899cb$var$_InitColorSchemeScript.default, {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var $2b983880bbf899cb$var$_default = module.exports.default = $2b983880bbf899cb$var$InitColorSchemeScript;

});
parcelRegister("5UPwK", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $44ea26ea463a672a$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $44ea26ea463a672a$var$_InitColorSchemeScript.default;
    }
});

var $44ea26ea463a672a$var$_InitColorSchemeScript = $44ea26ea463a672a$require$_interopRequireDefault((parcelRequire("79OI6")));

});




parcelRegister("kLL7M", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $f1ecc062bbad3379$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f1ecc062bbad3379$var$makeStyles;

var $f1ecc062bbad3379$var$_formatMuiErrorMessage = $f1ecc062bbad3379$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $f1ecc062bbad3379$var$makeStyles() {
    throw new Error((0, $f1ecc062bbad3379$var$_formatMuiErrorMessage.default)(14));
}

});

parcelRegister("7i0uy", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $015e9f5cd865f1ca$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $015e9f5cd865f1ca$var$withStyles;

var $015e9f5cd865f1ca$var$_formatMuiErrorMessage = $015e9f5cd865f1ca$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $015e9f5cd865f1ca$var$withStyles() {
    throw new Error((0, $015e9f5cd865f1ca$var$_formatMuiErrorMessage.default)(15));
}

});

parcelRegister("lXubi", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $ffc685059eb0526f$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ffc685059eb0526f$var$withTheme;

var $ffc685059eb0526f$var$_formatMuiErrorMessage = $ffc685059eb0526f$require$_interopRequireDefault((parcelRequire("4Z6Nd")));
function $ffc685059eb0526f$var$withTheme() {
    throw new Error((0, $ffc685059eb0526f$var$_formatMuiErrorMessage.default)(16));
}

});

parcelRegister("dj1n2", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
var $9afe1ce524e8f62d$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9afe1ce524e8f62d$var$deprecatedExtendTheme;

var $9afe1ce524e8f62d$var$_createThemeWithVars = $9afe1ce524e8f62d$require$_interopRequireDefault((parcelRequire("eLI0w")));
let $9afe1ce524e8f62d$var$warnedOnce = false;
function $9afe1ce524e8f62d$var$deprecatedExtendTheme(...args) {
    if (!$9afe1ce524e8f62d$var$warnedOnce) {
        console.warn([
            'MUI: The `experimental_extendTheme` has been stabilized.',
            '',
            "You should use `import { extendTheme } from '@mui/material/styles'`"
        ].join('\n'));
        $9afe1ce524e8f62d$var$warnedOnce = true;
    }
    return (0, $9afe1ce524e8f62d$var$_createThemeWithVars.default)(...args);
}

});

parcelRegister("i6kju", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $d8a8c1679b1cf5c2$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $d8a8c1679b1cf5c2$export$2e2bcd8739ae039);
function $d8a8c1679b1cf5c2$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $d8a8c1679b1cf5c2$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $d8a8c1679b1cf5c2$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $d8a8c1679b1cf5c2$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $d8a8c1679b1cf5c2$export$2e2bcd8739ae039 = $d8a8c1679b1cf5c2$export$4f5d2d50c9deca37;

});

parcelRegister("ivxDX", function(module, exports) {
/**
 * @mui/styled-engine v9.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $d7953822a8784d54$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $d7953822a8784d54$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $d7953822a8784d54$var$_StyledEngineProvider.default;
    }
});
Object.defineProperty(module.exports, "ThemeContext", {
    enumerable: true,
    get: function() {
        return $eP9YU.T;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $jjlaj.css;
    }
});
module.exports.default = void 0;
module.exports.internal_mutateStyles = $d7953822a8784d54$var$internal_mutateStyles;
module.exports.internal_serializeStyles = $d7953822a8784d54$var$internal_serializeStyles;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $jjlaj.keyframes;
    }
});

var $d7953822a8784d54$var$_styled = $d7953822a8784d54$require$_interopRequireDefault((parcelRequire("5rflj")));

var $fjFOC = parcelRequire("fjFOC");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $d7953822a8784d54$var$_StyledEngineProvider = $d7953822a8784d54$require$_interopRequireDefault((parcelRequire("2sWsN")));

var $d7953822a8784d54$var$_GlobalStyles = $d7953822a8784d54$require$_interopRequireDefault((parcelRequire("6qgna")));
// Re-export the public type surface of `@emotion/styled`. Explicit names rather
// than `export type *`: an `export *` (even type-only) is disallowed by the
// `'use client'` Next.js lint rule. Names locally redeclared below intentionally
// shadow Emotion's and are not re-exported here.
function $d7953822a8784d54$var$styled(tag, options) {
    // Emotion's `styled` overloads each expect a specific tag/component shape;
    // none accept the broadened `React.ElementType` union, so cast the passthrough.
    const stylesFactory = (0, $d7953822a8784d54$var$_styled.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
var $d7953822a8784d54$var$_default = module.exports.default = $d7953822a8784d54$var$styled;
/**
 * For internal usage in `@mui/system` package
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $d7953822a8784d54$var$internal_mutateStyles(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $d7953822a8784d54$var$wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function $d7953822a8784d54$var$internal_serializeStyles(styles) {
    $d7953822a8784d54$var$wrapper[0] = styles;
    return (0, $fjFOC.serializeStyles)($d7953822a8784d54$var$wrapper);
} // TODO v6 - check if we can drop the unknown, as it breaks the autocomplete
 // For more info on why it was added, see https://github.com/mui/material-ui/pull/26228
 // TODO v6 - check if we can drop the unknown, as it breaks the autocomplete
 // For more info on why it was added, see https://github.com/mui/material-ui/pull/26228
 // Omit variants as a key, because we have a special handling for it
 /** Same as StyledOptions but shouldForwardProp must be a type guard */  /**
 * @typeparam ComponentProps  Props which will be included when withComponent is called
 * @typeparam SpecificComponentProps  Props which will *not* be included when withComponent is called
 */ 

});
parcelRegister("k8pq4", function(module, exports) {
function $ea8845ce2adaea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $ea8845ce2adaea90$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fjFOC", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $02e0a990a1e74e31$export$6321afa313b251b5);

var $f094K = parcelRequire("f094K");

var $d0bw9 = parcelRequire("d0bw9");

var $4Lyex = parcelRequire("4Lyex");
var $02e0a990a1e74e31$var$isDevelopment = false;
var $02e0a990a1e74e31$var$hyphenateRegex = /[A-Z]|^ms/g;
var $02e0a990a1e74e31$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $02e0a990a1e74e31$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $02e0a990a1e74e31$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $02e0a990a1e74e31$var$processStyleName = /* #__PURE__ */ (0, $4Lyex.default)(function(styleName) {
    return $02e0a990a1e74e31$var$isCustomProperty(styleName) ? styleName : styleName.replace($02e0a990a1e74e31$var$hyphenateRegex, '-$&').toLowerCase();
});
var $02e0a990a1e74e31$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($02e0a990a1e74e31$var$animationRegex, function(match, p1, p2) {
                $02e0a990a1e74e31$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $02e0a990a1e74e31$var$cursor
                };
                return p1;
            });
    }
    if ((0, $d0bw9.default)[key] !== 1 && !$02e0a990a1e74e31$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $02e0a990a1e74e31$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $02e0a990a1e74e31$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $02e0a990a1e74e31$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $02e0a990a1e74e31$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $02e0a990a1e74e31$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $02e0a990a1e74e31$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $02e0a990a1e74e31$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $02e0a990a1e74e31$var$cursor;
                var result = interpolation(mergedProps);
                $02e0a990a1e74e31$var$cursor = previousCursor;
                return $02e0a990a1e74e31$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $02e0a990a1e74e31$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $02e0a990a1e74e31$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($02e0a990a1e74e31$var$isProcessableValue(asString)) string += $02e0a990a1e74e31$var$processStyleName(key) + ":" + $02e0a990a1e74e31$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $02e0a990a1e74e31$var$isDevelopment) throw new Error($02e0a990a1e74e31$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($02e0a990a1e74e31$var$isProcessableValue(value[_i])) string += $02e0a990a1e74e31$var$processStyleName(key) + ":" + $02e0a990a1e74e31$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $02e0a990a1e74e31$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $02e0a990a1e74e31$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $02e0a990a1e74e31$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $02e0a990a1e74e31$var$cursor;
function $02e0a990a1e74e31$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $02e0a990a1e74e31$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $02e0a990a1e74e31$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $02e0a990a1e74e31$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $02e0a990a1e74e31$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $02e0a990a1e74e31$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $f094K.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $02e0a990a1e74e31$var$cursor
    };
}

});
parcelRegister("f094K", function(module, exports) {

$parcel$export(module.exports, "default", () => $aebde550a83c8e21$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $aebde550a83c8e21$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("d0bw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9774359e286545ce$export$2e2bcd8739ae039);
var $9774359e286545ce$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("4Lyex", function(module, exports) {

$parcel$export(module.exports, "default", () => $37861b41b22a143f$export$2e2bcd8739ae039);
function $37861b41b22a143f$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("2sWsN", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $1cbb8be83515b5b5$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1cbb8be83515b5b5$var$_StyledEngineProvider.default;
    }
});

var $1cbb8be83515b5b5$var$_StyledEngineProvider = $1cbb8be83515b5b5$require$_interopRequireDefault((parcelRequire("5uc3d")));

});
parcelRegister("5uc3d", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $3fe91a2b0d311f1c$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $3fe91a2b0d311f1c$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TEST_INTERNALS_DO_NOT_USE = void 0;
module.exports.default = $3fe91a2b0d311f1c$var$StyledEngineProvider;

var $3fe91a2b0d311f1c$var$React = $3fe91a2b0d311f1c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3fe91a2b0d311f1c$var$_propTypes = $3fe91a2b0d311f1c$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $eP9YU = parcelRequire("eP9YU");

var $3fe91a2b0d311f1c$var$_cache = $3fe91a2b0d311f1c$require$_interopRequireDefault((parcelRequire("6U9S1")));

var $6uNJZ = parcelRequire("6uNJZ");

var $ayMG0 = parcelRequire("ayMG0");
// To fix [Jest performance](https://github.com/mui/material-ui/issues/45638).
const $3fe91a2b0d311f1c$var$cacheMap = new Map();
// Need to add a private variable to test the generated CSS from Emotion, this is the simplest way to do it.
// We can't test the CSS from `style` tag easily because the `speedy: true` (produce empty text content) is enabled by Emotion.
// Even if we disable it, JSDOM needs extra configuration to be able to parse `@layer` CSS.
/**
 * @internal
 */ const $3fe91a2b0d311f1c$var$TEST_INTERNALS_DO_NOT_USE = module.exports.TEST_INTERNALS_DO_NOT_USE = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $3fe91a2b0d311f1c$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $3fe91a2b0d311f1c$var$_cache.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $3fe91a2b0d311f1c$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $3fe91a2b0d311f1c$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$3fe91a2b0d311f1c$var$insertionPoint) {
        $3fe91a2b0d311f1c$var$insertionPoint = document.createElement('meta');
        $3fe91a2b0d311f1c$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $3fe91a2b0d311f1c$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($3fe91a2b0d311f1c$var$insertionPoint);
    }
}
function $3fe91a2b0d311f1c$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends $6uNJZ.StyleSheet {
            insert(rule, options) {
                if ($3fe91a2b0d311f1c$var$TEST_INTERNALS_DO_NOT_USE.insert) return $3fe91a2b0d311f1c$var$TEST_INTERNALS_DO_NOT_USE.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $3fe91a2b0d311f1c$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $3fe91a2b0d311f1c$var$createEmotionCache({
            // Use a dedicated key for the cascade-layer cache so its generated class
            // names (e.g. `mui-fyswvn`) can never collide with identically-hashed
            // UNLAYERED classes from the default/`injectFirst` cache (key `css`).
            // A collision lets an unlayered `.css-xxx` rule beat the layered one,
            // defeating MUI's own styles.
            key: enableCssLayer ? 'mui' : 'css',
            insertionPoint: injectFirst ? $3fe91a2b0d311f1c$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $3fe91a2b0d311f1c$var$StyledEngineProvider(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $3fe91a2b0d311f1c$var$React.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $3fe91a2b0d311f1c$var$cacheMap.has(cacheKey)) return $3fe91a2b0d311f1c$var$cacheMap.get(cacheKey);
        const fresh = $3fe91a2b0d311f1c$var$getCache(injectFirst, enableCssLayer);
        $3fe91a2b0d311f1c$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $ayMG0.jsx)($eP9YU.C, {
        value: cache,
        children: children
    }) : children;
}

});
parcelRegister("PT5lT", function(module, exports) {
var $09bf7e555306cf72$var$cache;
function $09bf7e555306cf72$var$_interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var r, c, a = Object.defineProperty, n = {
        __proto__: null,
        "default": e
    };
    if (Object(e) !== e) return n;
    if ($09bf7e555306cf72$var$cache || "function" != typeof WeakMap || ($09bf7e555306cf72$var$cache = new WeakMap()), $09bf7e555306cf72$var$cache) {
        if ($09bf7e555306cf72$var$cache.has(e)) return $09bf7e555306cf72$var$cache.get(e);
        $09bf7e555306cf72$var$cache.set(e, n);
    }
    for(c in e)"default" !== c && ({}).hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]);
    return n;
}
module.exports = $09bf7e555306cf72$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6U9S1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $506fa112c487fbf1$export$2e2bcd8739ae039);

var $6uNJZ = parcelRequire("6uNJZ");

var $Q8yqS = parcelRequire("Q8yqS");

var $1sL4t = parcelRequire("1sL4t");

var $4Lyex = parcelRequire("4Lyex");
var $506fa112c487fbf1$var$isBrowser = typeof document !== 'undefined';
var $506fa112c487fbf1$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $Q8yqS.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $Q8yqS.token)(character)) break;
        (0, $Q8yqS.next)();
    }
    return (0, $Q8yqS.slice)(begin, (0, $Q8yqS.position));
};
var $506fa112c487fbf1$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $Q8yqS.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $Q8yqS.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $506fa112c487fbf1$var$identifierWithPointTracking((0, $Q8yqS.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $Q8yqS.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $Q8yqS.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $Q8yqS.from)(character);
    }
    while (character = (0, $Q8yqS.next)());
    return parsed;
};
var $506fa112c487fbf1$var$getRules = function getRules(value, points) {
    return (0, $Q8yqS.dealloc)($506fa112c487fbf1$var$toRules((0, $Q8yqS.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $506fa112c487fbf1$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $506fa112c487fbf1$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$506fa112c487fbf1$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $506fa112c487fbf1$var$fixedElements.set(element, true);
    var points = [];
    var rules = $506fa112c487fbf1$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $506fa112c487fbf1$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $506fa112c487fbf1$var$prefix(value, length) {
    switch((0, $Q8yqS.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $Q8yqS.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $Q8yqS.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MOZ) + value + (0, $Q8yqS.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + value + value;
        // order
        case 6165:
            return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.replace)(value, /(\w+).+(:[^]+)/, (0, $Q8yqS.WEBKIT) + 'box-$1$2' + (0, $Q8yqS.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + 'flex-item-' + (0, $Q8yqS.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + 'flex-line-pack' + (0, $Q8yqS.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + (0, $Q8yqS.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + (0, $Q8yqS.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $Q8yqS.WEBKIT) + 'box-' + (0, $Q8yqS.replace)(value, '-grow', '') + (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + (0, $Q8yqS.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $Q8yqS.WEBKIT) + (0, $Q8yqS.replace)(value, /([^-])(transform)/g, '$1' + (0, $Q8yqS.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $Q8yqS.replace)((0, $Q8yqS.replace)((0, $Q8yqS.replace)(value, /(zoom-|grab)/, (0, $Q8yqS.WEBKIT) + '$1'), /(image-set)/, (0, $Q8yqS.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $Q8yqS.replace)(value, /(image-set\([^]*)/, (0, $Q8yqS.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $Q8yqS.replace)((0, $Q8yqS.replace)(value, /(.+:)(flex-)?(.*)/, (0, $Q8yqS.WEBKIT) + 'box-pack:$3' + (0, $Q8yqS.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $Q8yqS.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $Q8yqS.replace)(value, /(.+)-inline(.+)/, (0, $Q8yqS.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $Q8yqS.strlen)(value) - 1 - length > 6) switch((0, $Q8yqS.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $Q8yqS.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $Q8yqS.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $Q8yqS.WEBKIT) + '$2-$3' + '$1' + (0, $Q8yqS.MOZ) + ((0, $Q8yqS.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $Q8yqS.indexof)(value, 'stretch') ? $506fa112c487fbf1$var$prefix((0, $Q8yqS.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $Q8yqS.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $Q8yqS.charat)(value, (0, $Q8yqS.strlen)(value) - 3 - (~(0, $Q8yqS.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $Q8yqS.replace)(value, ':', ':' + (0, $Q8yqS.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $Q8yqS.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $Q8yqS.WEBKIT) + ((0, $Q8yqS.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $Q8yqS.WEBKIT) + '$2$3' + '$1' + (0, $Q8yqS.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $Q8yqS.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + (0, $Q8yqS.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + (0, $Q8yqS.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + (0, $Q8yqS.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $Q8yqS.WEBKIT) + value + (0, $Q8yqS.MS) + value + value;
    }
    return value;
}
var $506fa112c487fbf1$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $Q8yqS.DECLARATION:
                element["return"] = $506fa112c487fbf1$var$prefix(element.value, element.length);
                break;
            case 0, $Q8yqS.KEYFRAMES:
                return (0, $Q8yqS.serialize)([
                    (0, $Q8yqS.copy)(element, {
                        value: (0, $Q8yqS.replace)(element.value, '@', '@' + (0, $Q8yqS.WEBKIT))
                    })
                ], callback);
            case 0, $Q8yqS.RULESET:
                if (element.length) return (0, $Q8yqS.combine)(element.props, function(value) {
                    switch((0, $Q8yqS.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $Q8yqS.serialize)([
                                (0, $Q8yqS.copy)(element, {
                                    props: [
                                        (0, $Q8yqS.replace)(value, /:(read-\w+)/, ':' + (0, $Q8yqS.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $Q8yqS.serialize)([
                                (0, $Q8yqS.copy)(element, {
                                    props: [
                                        (0, $Q8yqS.replace)(value, /:(plac\w+)/, ':' + (0, $Q8yqS.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $Q8yqS.copy)(element, {
                                    props: [
                                        (0, $Q8yqS.replace)(value, /:(plac\w+)/, ':' + (0, $Q8yqS.MOZ) + '$1')
                                    ]
                                }),
                                (0, $Q8yqS.copy)(element, {
                                    props: [
                                        (0, $Q8yqS.replace)(value, /:(plac\w+)/, (0, $Q8yqS.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $506fa112c487fbf1$var$getServerStylisCache = $506fa112c487fbf1$var$isBrowser ? undefined : (0, $1sL4t.default)(function() {
    return (0, $4Lyex.default)(function() {
        return {};
    });
});
var $506fa112c487fbf1$var$defaultStylisPlugins = [
    $506fa112c487fbf1$var$prefixer
];
var $506fa112c487fbf1$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($506fa112c487fbf1$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $506fa112c487fbf1$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($506fa112c487fbf1$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $506fa112c487fbf1$var$compat,
        $506fa112c487fbf1$var$removeLabel
    ];
    if (!$506fa112c487fbf1$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $Q8yqS.stringify),
            (0, $Q8yqS.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $Q8yqS.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $Q8yqS.serialize)((0, $Q8yqS.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $Q8yqS.stringify)
        ];
        var _serializer = (0, $Q8yqS.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $Q8yqS.serialize)((0, $Q8yqS.compile)(styles), _serializer);
        };
        var serverStylisCache = $506fa112c487fbf1$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $6uNJZ.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("6uNJZ", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $4bac20e861da692c$export$9d753cd7ae895cce);
var $4bac20e861da692c$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $4bac20e861da692c$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $4bac20e861da692c$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $4bac20e861da692c$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$4bac20e861da692c$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($4bac20e861da692c$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $4bac20e861da692c$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("Q8yqS", function(module, exports) {

$parcel$export(module.exports, "MS", () => $389d1dbb587ea397$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $389d1dbb587ea397$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $389d1dbb587ea397$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $389d1dbb587ea397$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $389d1dbb587ea397$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $389d1dbb587ea397$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $389d1dbb587ea397$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $389d1dbb587ea397$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $389d1dbb587ea397$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $389d1dbb587ea397$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $389d1dbb587ea397$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $389d1dbb587ea397$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $389d1dbb587ea397$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $389d1dbb587ea397$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $389d1dbb587ea397$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $389d1dbb587ea397$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $389d1dbb587ea397$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $389d1dbb587ea397$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $389d1dbb587ea397$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $389d1dbb587ea397$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $389d1dbb587ea397$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $389d1dbb587ea397$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $389d1dbb587ea397$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $389d1dbb587ea397$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $389d1dbb587ea397$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $389d1dbb587ea397$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $389d1dbb587ea397$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $389d1dbb587ea397$export$38bcb760f1d4871c);
var $389d1dbb587ea397$export$71ad59f2e432cfe8 = "-ms-";
var $389d1dbb587ea397$export$2c0f367103c8d01c = "-moz-";
var $389d1dbb587ea397$export$39dfd62a25e0fe93 = "-webkit-";
var $389d1dbb587ea397$export$a29989082612d0d9 = "comm";
var $389d1dbb587ea397$export$aa3a2e812ca8570d = "rule";
var $389d1dbb587ea397$export$527d108ccf083c2b = "decl";
var $389d1dbb587ea397$export$d3d35020fa5b54f0 = "@page";
var $389d1dbb587ea397$export$500415a86c544f73 = "@media";
var $389d1dbb587ea397$export$a763edbf796b780a = "@import";
var $389d1dbb587ea397$export$2790aeb8b4e5c826 = "@charset";
var $389d1dbb587ea397$export$1cc683e23b84b133 = "@viewport";
var $389d1dbb587ea397$export$9447a5efea57e862 = "@supports";
var $389d1dbb587ea397$export$ef011b4e114b1fba = "@document";
var $389d1dbb587ea397$export$6aad947bda0f3f46 = "@namespace";
var $389d1dbb587ea397$export$b44a8529a35fcb60 = "@keyframes";
var $389d1dbb587ea397$export$2c16de31893252e6 = "@font-face";
var $389d1dbb587ea397$export$3d846dd52e150c6f = "@counter-style";
var $389d1dbb587ea397$export$22314bfbb57653fe = "@font-feature-values";
var $389d1dbb587ea397$export$d773506282b3cfe6 = "@layer";
var $389d1dbb587ea397$export$2335f513bbd82c6d = Math.abs;
var $389d1dbb587ea397$export$6788812c4e6611e6 = String.fromCharCode;
var $389d1dbb587ea397$export$e6e34fd1f2686227 = Object.assign;
function $389d1dbb587ea397$export$d6af199866bfb566(e, r) {
    return $389d1dbb587ea397$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $389d1dbb587ea397$export$a9db5e087081082d(e, 0)) << 2 ^ $389d1dbb587ea397$export$a9db5e087081082d(e, 1)) << 2 ^ $389d1dbb587ea397$export$a9db5e087081082d(e, 2)) << 2 ^ $389d1dbb587ea397$export$a9db5e087081082d(e, 3) : 0;
}
function $389d1dbb587ea397$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $389d1dbb587ea397$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $389d1dbb587ea397$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $389d1dbb587ea397$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $389d1dbb587ea397$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $389d1dbb587ea397$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $389d1dbb587ea397$export$36776f635604f274(e) {
    return e.length;
}
function $389d1dbb587ea397$export$f9084667e487ed46(e) {
    return e.length;
}
function $389d1dbb587ea397$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $389d1dbb587ea397$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $389d1dbb587ea397$export$53f1d5ea8de3d7c = 1;
var $389d1dbb587ea397$export$4e0c71f277ca26b3 = 1;
var $389d1dbb587ea397$export$f24224f1c91d8156 = 0;
var $389d1dbb587ea397$export$5880b8b5730aff45 = 0;
var $389d1dbb587ea397$export$c0306caf338ac095 = 0;
var $389d1dbb587ea397$export$30a86d91af8ff6e6 = "";
function $389d1dbb587ea397$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $389d1dbb587ea397$export$53f1d5ea8de3d7c,
        column: $389d1dbb587ea397$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $389d1dbb587ea397$export$784d13d8ee351f07(e, r) {
    return $389d1dbb587ea397$export$e6e34fd1f2686227($389d1dbb587ea397$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $389d1dbb587ea397$export$eba6f6f03b0a92e7() {
    return $389d1dbb587ea397$export$c0306caf338ac095;
}
function $389d1dbb587ea397$export$232faf9add678146() {
    $389d1dbb587ea397$export$c0306caf338ac095 = $389d1dbb587ea397$export$5880b8b5730aff45 > 0 ? $389d1dbb587ea397$export$a9db5e087081082d($389d1dbb587ea397$export$30a86d91af8ff6e6, --$389d1dbb587ea397$export$5880b8b5730aff45) : 0;
    if ($389d1dbb587ea397$export$4e0c71f277ca26b3--, $389d1dbb587ea397$export$c0306caf338ac095 === 10) $389d1dbb587ea397$export$4e0c71f277ca26b3 = 1, $389d1dbb587ea397$export$53f1d5ea8de3d7c--;
    return $389d1dbb587ea397$export$c0306caf338ac095;
}
function $389d1dbb587ea397$export$48cfd1e771a65c4f() {
    $389d1dbb587ea397$export$c0306caf338ac095 = $389d1dbb587ea397$export$5880b8b5730aff45 < $389d1dbb587ea397$export$f24224f1c91d8156 ? $389d1dbb587ea397$export$a9db5e087081082d($389d1dbb587ea397$export$30a86d91af8ff6e6, $389d1dbb587ea397$export$5880b8b5730aff45++) : 0;
    if ($389d1dbb587ea397$export$4e0c71f277ca26b3++, $389d1dbb587ea397$export$c0306caf338ac095 === 10) $389d1dbb587ea397$export$4e0c71f277ca26b3 = 1, $389d1dbb587ea397$export$53f1d5ea8de3d7c++;
    return $389d1dbb587ea397$export$c0306caf338ac095;
}
function $389d1dbb587ea397$export$4d3fb11e950abb9e() {
    return $389d1dbb587ea397$export$a9db5e087081082d($389d1dbb587ea397$export$30a86d91af8ff6e6, $389d1dbb587ea397$export$5880b8b5730aff45);
}
function $389d1dbb587ea397$export$e88cb2efb12ae807() {
    return $389d1dbb587ea397$export$5880b8b5730aff45;
}
function $389d1dbb587ea397$export$58adb3bec8346d0f(e, r) {
    return $389d1dbb587ea397$export$2f35ab04d2335697($389d1dbb587ea397$export$30a86d91af8ff6e6, e, r);
}
function $389d1dbb587ea397$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $389d1dbb587ea397$export$2de70f21292aac9e(e) {
    return $389d1dbb587ea397$export$53f1d5ea8de3d7c = $389d1dbb587ea397$export$4e0c71f277ca26b3 = 1, $389d1dbb587ea397$export$f24224f1c91d8156 = $389d1dbb587ea397$export$36776f635604f274($389d1dbb587ea397$export$30a86d91af8ff6e6 = e), $389d1dbb587ea397$export$5880b8b5730aff45 = 0, [];
}
function $389d1dbb587ea397$export$45918ac1574455b1(e) {
    return $389d1dbb587ea397$export$30a86d91af8ff6e6 = "", e;
}
function $389d1dbb587ea397$export$410ac95b9ec204b8(e) {
    return $389d1dbb587ea397$export$87c2784dc9fc4ab($389d1dbb587ea397$export$58adb3bec8346d0f($389d1dbb587ea397$export$5880b8b5730aff45 - 1, $389d1dbb587ea397$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $389d1dbb587ea397$export$660b2ee2d4fb4eff(e) {
    return $389d1dbb587ea397$export$45918ac1574455b1($389d1dbb587ea397$export$5f8c09e3ae6f64e1($389d1dbb587ea397$export$2de70f21292aac9e(e)));
}
function $389d1dbb587ea397$export$7af1228ff777d175(e) {
    while($389d1dbb587ea397$export$c0306caf338ac095 = $389d1dbb587ea397$export$4d3fb11e950abb9e())if ($389d1dbb587ea397$export$c0306caf338ac095 < 33) $389d1dbb587ea397$export$48cfd1e771a65c4f();
    else break;
    return $389d1dbb587ea397$export$9e1725a4cfeada27(e) > 2 || $389d1dbb587ea397$export$9e1725a4cfeada27($389d1dbb587ea397$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $389d1dbb587ea397$export$5f8c09e3ae6f64e1(e) {
    while($389d1dbb587ea397$export$48cfd1e771a65c4f())switch($389d1dbb587ea397$export$9e1725a4cfeada27($389d1dbb587ea397$export$c0306caf338ac095)){
        case 0:
            $389d1dbb587ea397$export$10d8903dec122b9d($389d1dbb587ea397$export$c2ab62c7bf24634($389d1dbb587ea397$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $389d1dbb587ea397$export$10d8903dec122b9d($389d1dbb587ea397$export$410ac95b9ec204b8($389d1dbb587ea397$export$c0306caf338ac095), e);
            break;
        default:
            $389d1dbb587ea397$export$10d8903dec122b9d($389d1dbb587ea397$export$6788812c4e6611e6($389d1dbb587ea397$export$c0306caf338ac095), e);
    }
    return e;
}
function $389d1dbb587ea397$export$955ba06d119e085e(e, r) {
    while(--r && $389d1dbb587ea397$export$48cfd1e771a65c4f())if ($389d1dbb587ea397$export$c0306caf338ac095 < 48 || $389d1dbb587ea397$export$c0306caf338ac095 > 102 || $389d1dbb587ea397$export$c0306caf338ac095 > 57 && $389d1dbb587ea397$export$c0306caf338ac095 < 65 || $389d1dbb587ea397$export$c0306caf338ac095 > 70 && $389d1dbb587ea397$export$c0306caf338ac095 < 97) break;
    return $389d1dbb587ea397$export$58adb3bec8346d0f(e, $389d1dbb587ea397$export$e88cb2efb12ae807() + (r < 6 && $389d1dbb587ea397$export$4d3fb11e950abb9e() == 32 && $389d1dbb587ea397$export$48cfd1e771a65c4f() == 32));
}
function $389d1dbb587ea397$export$c889f2fcc19dbf12(e) {
    while($389d1dbb587ea397$export$48cfd1e771a65c4f())switch($389d1dbb587ea397$export$c0306caf338ac095){
        case e:
            return $389d1dbb587ea397$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $389d1dbb587ea397$export$c889f2fcc19dbf12($389d1dbb587ea397$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $389d1dbb587ea397$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $389d1dbb587ea397$export$48cfd1e771a65c4f();
            break;
    }
    return $389d1dbb587ea397$export$5880b8b5730aff45;
}
function $389d1dbb587ea397$export$4254d4e2b3745c4c(e, r) {
    while($389d1dbb587ea397$export$48cfd1e771a65c4f())if (e + $389d1dbb587ea397$export$c0306caf338ac095 === 57) break;
    else if (e + $389d1dbb587ea397$export$c0306caf338ac095 === 84 && $389d1dbb587ea397$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $389d1dbb587ea397$export$58adb3bec8346d0f(r, $389d1dbb587ea397$export$5880b8b5730aff45 - 1) + "*" + $389d1dbb587ea397$export$6788812c4e6611e6(e === 47 ? e : $389d1dbb587ea397$export$48cfd1e771a65c4f());
}
function $389d1dbb587ea397$export$c2ab62c7bf24634(e) {
    while(!$389d1dbb587ea397$export$9e1725a4cfeada27($389d1dbb587ea397$export$4d3fb11e950abb9e()))$389d1dbb587ea397$export$48cfd1e771a65c4f();
    return $389d1dbb587ea397$export$58adb3bec8346d0f(e, $389d1dbb587ea397$export$5880b8b5730aff45);
}
function $389d1dbb587ea397$export$ef7acd7185315e22(e) {
    return $389d1dbb587ea397$export$45918ac1574455b1($389d1dbb587ea397$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $389d1dbb587ea397$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $389d1dbb587ea397$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $389d1dbb587ea397$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $389d1dbb587ea397$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($389d1dbb587ea397$export$f8e21b1e77979a08(j += $389d1dbb587ea397$export$77ad94ebf1c2b9ed($389d1dbb587ea397$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $389d1dbb587ea397$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $389d1dbb587ea397$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $389d1dbb587ea397$export$955ba06d119e085e($389d1dbb587ea397$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($389d1dbb587ea397$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $389d1dbb587ea397$export$10d8903dec122b9d($389d1dbb587ea397$export$4a34f930e789283c($389d1dbb587ea397$export$4254d4e2b3745c4c($389d1dbb587ea397$export$48cfd1e771a65c4f(), $389d1dbb587ea397$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $389d1dbb587ea397$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $389d1dbb587ea397$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $389d1dbb587ea397$export$36776f635604f274(j) - l) $389d1dbb587ea397$export$10d8903dec122b9d(p > 32 ? $389d1dbb587ea397$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $389d1dbb587ea397$export$f8483753829ec8f3($389d1dbb587ea397$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $389d1dbb587ea397$export$10d8903dec122b9d(y = $389d1dbb587ea397$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $389d1dbb587ea397$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $389d1dbb587ea397$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $389d1dbb587ea397$export$98e6a39c04603d36(e, y, y, n && $389d1dbb587ea397$export$10d8903dec122b9d($389d1dbb587ea397$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $389d1dbb587ea397$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $389d1dbb587ea397$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $389d1dbb587ea397$export$232faf9add678146() == 125) continue;
            }
            switch(j += $389d1dbb587ea397$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($389d1dbb587ea397$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($389d1dbb587ea397$export$4d3fb11e950abb9e() === 45) j += $389d1dbb587ea397$export$410ac95b9ec204b8($389d1dbb587ea397$export$48cfd1e771a65c4f());
                    v = $389d1dbb587ea397$export$4d3fb11e950abb9e(), o = l = $389d1dbb587ea397$export$36776f635604f274(g = j += $389d1dbb587ea397$export$c2ab62c7bf24634($389d1dbb587ea397$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $389d1dbb587ea397$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $389d1dbb587ea397$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $389d1dbb587ea397$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $389d1dbb587ea397$export$2f35ab04d2335697(e, v + 1, v = $389d1dbb587ea397$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $389d1dbb587ea397$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $389d1dbb587ea397$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $389d1dbb587ea397$export$35059013cd4a06db(e, r, a, s === 0 ? $389d1dbb587ea397$export$aa3a2e812ca8570d : i, f, o, l);
}
function $389d1dbb587ea397$export$4a34f930e789283c(e, r, a) {
    return $389d1dbb587ea397$export$35059013cd4a06db(e, r, a, $389d1dbb587ea397$export$a29989082612d0d9, $389d1dbb587ea397$export$6788812c4e6611e6($389d1dbb587ea397$export$eba6f6f03b0a92e7()), $389d1dbb587ea397$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $389d1dbb587ea397$export$f8483753829ec8f3(e, r, a, n) {
    return $389d1dbb587ea397$export$35059013cd4a06db(e, r, a, $389d1dbb587ea397$export$527d108ccf083c2b, $389d1dbb587ea397$export$2f35ab04d2335697(e, 0, n), $389d1dbb587ea397$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $389d1dbb587ea397$export$82e9f45cca5ba907(n, c, s) {
    switch($389d1dbb587ea397$export$d6af199866bfb566(n, c)){
        case 5103:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $389d1dbb587ea397$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$2c0f367103c8d01c + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($389d1dbb587ea397$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $389d1dbb587ea397$export$39dfd62a25e0fe93 + "box-$1$2" + $389d1dbb587ea397$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + "flex-item-" + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$389d1dbb587ea397$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $389d1dbb587ea397$export$71ad59f2e432cfe8 + "grid-row-" + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + "flex-line-pack" + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + "box-" + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "-grow", "") + $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $389d1dbb587ea397$export$39dfd62a25e0fe93 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $389d1dbb587ea397$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $389d1dbb587ea397$export$77ad94ebf1c2b9ed($389d1dbb587ea397$export$77ad94ebf1c2b9ed($389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $389d1dbb587ea397$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $389d1dbb587ea397$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $389d1dbb587ea397$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $389d1dbb587ea397$export$77ad94ebf1c2b9ed($389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $389d1dbb587ea397$export$39dfd62a25e0fe93 + "box-pack:$3" + $389d1dbb587ea397$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $389d1dbb587ea397$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$389d1dbb587ea397$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $389d1dbb587ea397$export$71ad59f2e432cfe8 + "grid-column-align" + $389d1dbb587ea397$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $389d1dbb587ea397$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$389d1dbb587ea397$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $389d1dbb587ea397$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$389d1dbb587ea397$export$f8e21b1e77979a08(s, "span") ? $389d1dbb587ea397$export$4659b591c19bdf3d(s, /\d+/) : +$389d1dbb587ea397$export$4659b591c19bdf3d(s, /\d+/) - +$389d1dbb587ea397$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $389d1dbb587ea397$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $389d1dbb587ea397$export$71ad59f2e432cfe8 + $389d1dbb587ea397$export$77ad94ebf1c2b9ed($389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $389d1dbb587ea397$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($389d1dbb587ea397$export$36776f635604f274(n) - 1 - c > 6) switch($389d1dbb587ea397$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($389d1dbb587ea397$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $389d1dbb587ea397$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $389d1dbb587ea397$export$2c0f367103c8d01c + ($389d1dbb587ea397$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$389d1dbb587ea397$export$f8e21b1e77979a08(n, "stretch") ? $389d1dbb587ea397$export$82e9f45cca5ba907($389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $389d1dbb587ea397$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $389d1dbb587ea397$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($389d1dbb587ea397$export$a9db5e087081082d(n, c + 6) === 121) return $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, ":", ":" + $389d1dbb587ea397$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($389d1dbb587ea397$export$a9db5e087081082d(n, $389d1dbb587ea397$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $389d1dbb587ea397$export$39dfd62a25e0fe93 + ($389d1dbb587ea397$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $389d1dbb587ea397$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $389d1dbb587ea397$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, ":", ":" + $389d1dbb587ea397$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $389d1dbb587ea397$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $389d1dbb587ea397$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $389d1dbb587ea397$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $389d1dbb587ea397$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $389d1dbb587ea397$export$a763edbf796b780a:
        case $389d1dbb587ea397$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $389d1dbb587ea397$export$a29989082612d0d9:
            return "";
        case $389d1dbb587ea397$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $389d1dbb587ea397$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $389d1dbb587ea397$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $389d1dbb587ea397$export$36776f635604f274(a = $389d1dbb587ea397$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $389d1dbb587ea397$export$5a7767152ae0305f(e) {
    var r = $389d1dbb587ea397$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $389d1dbb587ea397$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $389d1dbb587ea397$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $389d1dbb587ea397$export$527d108ccf083c2b:
                n.return = $389d1dbb587ea397$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $389d1dbb587ea397$export$b44a8529a35fcb60:
                return $389d1dbb587ea397$export$dfdc1655ccc5b9cb([
                    $389d1dbb587ea397$export$784d13d8ee351f07(n, {
                        value: $389d1dbb587ea397$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $389d1dbb587ea397$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $389d1dbb587ea397$export$aa3a2e812ca8570d:
                if (n.length) return $389d1dbb587ea397$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($389d1dbb587ea397$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $389d1dbb587ea397$export$dfdc1655ccc5b9cb([
                                $389d1dbb587ea397$export$784d13d8ee351f07(n, {
                                    props: [
                                        $389d1dbb587ea397$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $389d1dbb587ea397$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $389d1dbb587ea397$export$dfdc1655ccc5b9cb([
                                $389d1dbb587ea397$export$784d13d8ee351f07(n, {
                                    props: [
                                        $389d1dbb587ea397$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $389d1dbb587ea397$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $389d1dbb587ea397$export$784d13d8ee351f07(n, {
                                    props: [
                                        $389d1dbb587ea397$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $389d1dbb587ea397$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $389d1dbb587ea397$export$784d13d8ee351f07(n, {
                                    props: [
                                        $389d1dbb587ea397$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $389d1dbb587ea397$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $389d1dbb587ea397$export$76a88f7de6507443(e) {
    switch(e.type){
        case $389d1dbb587ea397$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $389d1dbb587ea397$export$1be1fc439b849fdf($389d1dbb587ea397$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($389d1dbb587ea397$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $389d1dbb587ea397$export$2f35ab04d2335697(r, 1, $389d1dbb587ea397$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $389d1dbb587ea397$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $389d1dbb587ea397$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $389d1dbb587ea397$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("1sL4t", function(module, exports) {

$parcel$export(module.exports, "default", () => $110ceb5539488848$export$2e2bcd8739ae039);
var $110ceb5539488848$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});




parcelRegister("6qgna", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $4ad1df08172e1b0b$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4ad1df08172e1b0b$var$_GlobalStyles.default;
    }
});

var $4ad1df08172e1b0b$var$_GlobalStyles = $4ad1df08172e1b0b$require$_interopRequireDefault((parcelRequire("eGb98")));

});
parcelRegister("eGb98", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $aafda25e045333e7$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aafda25e045333e7$var$GlobalStyles;

var $aafda25e045333e7$var$_propTypes = $aafda25e045333e7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
function $aafda25e045333e7$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $aafda25e045333e7$var$GlobalStyles(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($aafda25e045333e7$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($jjlaj.Global, {
        styles: globalStyles
    });
}

});



parcelRegister("bBbDC", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $871c2d766d68ea30$export$a7c73072b1a182ae, (v) => $871c2d766d68ea30$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $871c2d766d68ea30$export$9f27bc3417b4524d, (v) => $871c2d766d68ea30$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $871c2d766d68ea30$export$db77ccec0bb4ccac, (v) => $871c2d766d68ea30$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $871c2d766d68ea30$export$8392c0c9d3dcbd35, (v) => $871c2d766d68ea30$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $871c2d766d68ea30$export$ffb0004e005737fa, (v) => $871c2d766d68ea30$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $871c2d766d68ea30$export$b624eff549462981, (v) => $871c2d766d68ea30$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $871c2d766d68ea30$export$7897aa7841a5380c, (v) => $871c2d766d68ea30$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $871c2d766d68ea30$export$602eac185826482c, (v) => $871c2d766d68ea30$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $871c2d766d68ea30$export$e2c29f18771995cb, (v) => $871c2d766d68ea30$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $871c2d766d68ea30$export$5f8d39834fd61797, (v) => $871c2d766d68ea30$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $871c2d766d68ea30$export$74bf444e3cd11ea5, (v) => $871c2d766d68ea30$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $871c2d766d68ea30$export$998bcd577473dd93, (v) => $871c2d766d68ea30$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $871c2d766d68ea30$export$b706b080d889d2c9, (v) => $871c2d766d68ea30$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $871c2d766d68ea30$export$5be5a87408f70ddc, (v) => $871c2d766d68ea30$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $871c2d766d68ea30$export$45a5e7f76e0caa8d, (v) => $871c2d766d68ea30$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $871c2d766d68ea30$export$455c2e768291efa6, (v) => $871c2d766d68ea30$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $871c2d766d68ea30$export$9522e17588c12572, (v) => $871c2d766d68ea30$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $871c2d766d68ea30$export$2110ac352bb060b9, (v) => $871c2d766d68ea30$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $871c2d766d68ea30$export$56885ab8b9c456ab, (v) => $871c2d766d68ea30$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $871c2d766d68ea30$export$d927fcb6adf8f9de, (v) => $871c2d766d68ea30$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $871c2d766d68ea30$export$b82d16f27459e05a, (v) => $871c2d766d68ea30$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $871c2d766d68ea30$export$522c17b4f5e123e8, (v) => $871c2d766d68ea30$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $871c2d766d68ea30$export$1aabd8a0274ecfd6, (v) => $871c2d766d68ea30$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $871c2d766d68ea30$export$3d6c20d97e46b957, (v) => $871c2d766d68ea30$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $871c2d766d68ea30$export$9b621391a187a31a, (v) => $871c2d766d68ea30$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $871c2d766d68ea30$export$f5bbd400c2f4426f, (v) => $871c2d766d68ea30$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $871c2d766d68ea30$export$a7c73072b1a182ae;
var $871c2d766d68ea30$export$9f27bc3417b4524d;
var $871c2d766d68ea30$export$db77ccec0bb4ccac;
var $871c2d766d68ea30$export$8392c0c9d3dcbd35;
var $871c2d766d68ea30$export$ffb0004e005737fa;
var $871c2d766d68ea30$export$b624eff549462981;
var $871c2d766d68ea30$export$7897aa7841a5380c;
var $871c2d766d68ea30$export$602eac185826482c;
var $871c2d766d68ea30$export$e2c29f18771995cb;
var $871c2d766d68ea30$export$5f8d39834fd61797;
var $871c2d766d68ea30$export$74bf444e3cd11ea5;
var $871c2d766d68ea30$export$998bcd577473dd93;
var $871c2d766d68ea30$export$b706b080d889d2c9;
var $871c2d766d68ea30$export$5be5a87408f70ddc;
var $871c2d766d68ea30$export$45a5e7f76e0caa8d;
var $871c2d766d68ea30$export$455c2e768291efa6;
var $871c2d766d68ea30$export$9522e17588c12572;
var $871c2d766d68ea30$export$2110ac352bb060b9;
var $871c2d766d68ea30$export$56885ab8b9c456ab;
var $871c2d766d68ea30$export$d927fcb6adf8f9de;
var $871c2d766d68ea30$export$b82d16f27459e05a;
var $871c2d766d68ea30$export$522c17b4f5e123e8;
var $871c2d766d68ea30$export$1aabd8a0274ecfd6;
var $871c2d766d68ea30$export$3d6c20d97e46b957;
var $871c2d766d68ea30$export$9b621391a187a31a;
var $871c2d766d68ea30$export$f5bbd400c2f4426f;
"use strict";
var $871c2d766d68ea30$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $871c2d766d68ea30$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $871c2d766d68ea30$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $871c2d766d68ea30$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $871c2d766d68ea30$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $871c2d766d68ea30$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $871c2d766d68ea30$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $871c2d766d68ea30$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $871c2d766d68ea30$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $871c2d766d68ea30$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $871c2d766d68ea30$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $871c2d766d68ea30$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $871c2d766d68ea30$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $871c2d766d68ea30$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $871c2d766d68ea30$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $871c2d766d68ea30$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $871c2d766d68ea30$var$REACT_FRAGMENT_TYPE:
                    case $871c2d766d68ea30$var$REACT_PROFILER_TYPE:
                    case $871c2d766d68ea30$var$REACT_STRICT_MODE_TYPE:
                    case $871c2d766d68ea30$var$REACT_SUSPENSE_TYPE:
                    case $871c2d766d68ea30$var$REACT_SUSPENSE_LIST_TYPE:
                    case $871c2d766d68ea30$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $871c2d766d68ea30$var$REACT_CONTEXT_TYPE:
                            case $871c2d766d68ea30$var$REACT_FORWARD_REF_TYPE:
                            case $871c2d766d68ea30$var$REACT_LAZY_TYPE:
                            case $871c2d766d68ea30$var$REACT_MEMO_TYPE:
                                return object;
                            case $871c2d766d68ea30$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $871c2d766d68ea30$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$871c2d766d68ea30$export$a7c73072b1a182ae = $871c2d766d68ea30$var$REACT_CONSUMER_TYPE;
$871c2d766d68ea30$export$9f27bc3417b4524d = $871c2d766d68ea30$var$REACT_CONTEXT_TYPE;
$871c2d766d68ea30$export$db77ccec0bb4ccac = $871c2d766d68ea30$var$REACT_ELEMENT_TYPE;
$871c2d766d68ea30$export$8392c0c9d3dcbd35 = $871c2d766d68ea30$var$REACT_FORWARD_REF_TYPE;
$871c2d766d68ea30$export$ffb0004e005737fa = $871c2d766d68ea30$var$REACT_FRAGMENT_TYPE;
$871c2d766d68ea30$export$b624eff549462981 = $871c2d766d68ea30$var$REACT_LAZY_TYPE;
$871c2d766d68ea30$export$7897aa7841a5380c = $871c2d766d68ea30$var$REACT_MEMO_TYPE;
$871c2d766d68ea30$export$602eac185826482c = $871c2d766d68ea30$var$REACT_PORTAL_TYPE;
$871c2d766d68ea30$export$e2c29f18771995cb = $871c2d766d68ea30$var$REACT_PROFILER_TYPE;
$871c2d766d68ea30$export$5f8d39834fd61797 = $871c2d766d68ea30$var$REACT_STRICT_MODE_TYPE;
$871c2d766d68ea30$export$74bf444e3cd11ea5 = $871c2d766d68ea30$var$REACT_SUSPENSE_TYPE;
$871c2d766d68ea30$export$998bcd577473dd93 = $871c2d766d68ea30$var$REACT_SUSPENSE_LIST_TYPE;
$871c2d766d68ea30$export$b706b080d889d2c9 = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_CONSUMER_TYPE;
};
$871c2d766d68ea30$export$5be5a87408f70ddc = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_CONTEXT_TYPE;
};
$871c2d766d68ea30$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $871c2d766d68ea30$var$REACT_ELEMENT_TYPE;
};
$871c2d766d68ea30$export$455c2e768291efa6 = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_FORWARD_REF_TYPE;
};
$871c2d766d68ea30$export$9522e17588c12572 = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_FRAGMENT_TYPE;
};
$871c2d766d68ea30$export$2110ac352bb060b9 = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_LAZY_TYPE;
};
$871c2d766d68ea30$export$56885ab8b9c456ab = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_MEMO_TYPE;
};
$871c2d766d68ea30$export$d927fcb6adf8f9de = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_PORTAL_TYPE;
};
$871c2d766d68ea30$export$b82d16f27459e05a = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_PROFILER_TYPE;
};
$871c2d766d68ea30$export$522c17b4f5e123e8 = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_STRICT_MODE_TYPE;
};
$871c2d766d68ea30$export$1aabd8a0274ecfd6 = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_SUSPENSE_TYPE;
};
$871c2d766d68ea30$export$3d6c20d97e46b957 = function(object) {
    return $871c2d766d68ea30$var$typeOf(object) === $871c2d766d68ea30$var$REACT_SUSPENSE_LIST_TYPE;
};
$871c2d766d68ea30$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $871c2d766d68ea30$var$REACT_FRAGMENT_TYPE || type === $871c2d766d68ea30$var$REACT_PROFILER_TYPE || type === $871c2d766d68ea30$var$REACT_STRICT_MODE_TYPE || type === $871c2d766d68ea30$var$REACT_SUSPENSE_TYPE || type === $871c2d766d68ea30$var$REACT_SUSPENSE_LIST_TYPE || type === $871c2d766d68ea30$var$REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $871c2d766d68ea30$var$REACT_LAZY_TYPE || type.$$typeof === $871c2d766d68ea30$var$REACT_MEMO_TYPE || type.$$typeof === $871c2d766d68ea30$var$REACT_CONTEXT_TYPE || type.$$typeof === $871c2d766d68ea30$var$REACT_CONSUMER_TYPE || type.$$typeof === $871c2d766d68ea30$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $871c2d766d68ea30$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$871c2d766d68ea30$export$f5bbd400c2f4426f = $871c2d766d68ea30$var$typeOf;

});

parcelRegister("lVHP6", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $ff70ea38ce910761$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ff70ea38ce910761$var$_formatMuiErrorMessage.default;
    }
});

var $ff70ea38ce910761$var$_formatMuiErrorMessage = $ff70ea38ce910761$require$_interopRequireDefault((parcelRequire("56X6S")));

});
parcelRegister("56X6S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b8b5d472aac9f62$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $3b8b5d472aac9f62$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("f47HC", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $af7d344cf468dbe4$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $af7d344cf468dbe4$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $af7d344cf468dbe4$var$_GlobalStyles.default;
    }
});

var $af7d344cf468dbe4$var$_GlobalStyles = $af7d344cf468dbe4$require$_interopRequireWildcard((parcelRequire("4gBdX")));
Object.keys($af7d344cf468dbe4$var$_GlobalStyles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($af7d344cf468dbe4$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $af7d344cf468dbe4$var$_GlobalStyles[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $af7d344cf468dbe4$var$_GlobalStyles[key];
        }
    });
});

});
parcelRegister("4gBdX", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $31b587f65aed8628$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $31b587f65aed8628$var$_propTypes = $31b587f65aed8628$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ivxDX = parcelRequire("ivxDX");

var $31b587f65aed8628$var$_useTheme = $31b587f65aed8628$require$_interopRequireDefault((parcelRequire("dWz7R")));

var $ayMG0 = parcelRequire("ayMG0");
function $31b587f65aed8628$var$wrapGlobalLayer(styles) {
    const serialized = (0, $ivxDX.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $31b587f65aed8628$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $31b587f65aed8628$var$_useTheme.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $31b587f65aed8628$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $31b587f65aed8628$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $31b587f65aed8628$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($ivxDX.GlobalStyles, {
        styles: globalStyles
    });
}
var $31b587f65aed8628$var$_default = module.exports.default = $31b587f65aed8628$var$GlobalStyles;

});
parcelRegister("dWz7R", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $a26bf06589a3faf1$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a26bf06589a3faf1$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a26bf06589a3faf1$var$_useTheme.default;
    }
});

var $a26bf06589a3faf1$var$_useTheme = $a26bf06589a3faf1$require$_interopRequireWildcard((parcelRequire("7Qv9h")));
Object.keys($a26bf06589a3faf1$var$_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a26bf06589a3faf1$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a26bf06589a3faf1$var$_useTheme[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a26bf06589a3faf1$var$_useTheme[key];
        }
    });
});

});
parcelRegister("7Qv9h", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $5b658d3ae592b943$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.systemDefaultTheme = module.exports.default = void 0;

var $5b658d3ae592b943$var$_createTheme = $5b658d3ae592b943$require$_interopRequireDefault((parcelRequire("hDEnZ")));

var $5b658d3ae592b943$var$_useThemeWithoutDefault = $5b658d3ae592b943$require$_interopRequireDefault((parcelRequire("3pEz9")));
const $5b658d3ae592b943$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $5b658d3ae592b943$var$_createTheme.default)();
function $5b658d3ae592b943$var$useTheme(defaultTheme = $5b658d3ae592b943$var$systemDefaultTheme) {
    return (0, $5b658d3ae592b943$var$_useThemeWithoutDefault.default)(defaultTheme);
}
var $5b658d3ae592b943$var$_default = module.exports.default = $5b658d3ae592b943$var$useTheme;

});
parcelRegister("hDEnZ", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $cd7567fcaef37208$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cd7567fcaef37208$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $cd7567fcaef37208$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $cd7567fcaef37208$var$_applyStyles.default;
    }
});

var $cd7567fcaef37208$var$_createTheme = $cd7567fcaef37208$require$_interopRequireDefault((parcelRequire("4Sboi")));

var $cd7567fcaef37208$var$_createBreakpoints = $cd7567fcaef37208$require$_interopRequireDefault((parcelRequire("88q07")));

var $cd7567fcaef37208$var$_applyStyles = $cd7567fcaef37208$require$_interopRequireDefault((parcelRequire("dDK43")));

});
parcelRegister("4Sboi", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $38c50a8bb2c809d4$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38c50a8bb2c809d4$var$_deepmerge = $38c50a8bb2c809d4$require$_interopRequireDefault((parcelRequire("4qPjz")));

var $38c50a8bb2c809d4$var$_createBreakpoints = $38c50a8bb2c809d4$require$_interopRequireDefault((parcelRequire("88q07")));

var $38c50a8bb2c809d4$var$_cssContainerQueries = $38c50a8bb2c809d4$require$_interopRequireDefault((parcelRequire("45d6a")));

var $38c50a8bb2c809d4$var$_shape = $38c50a8bb2c809d4$require$_interopRequireDefault((parcelRequire("9dv5b")));

var $38c50a8bb2c809d4$var$_createSpacing = $38c50a8bb2c809d4$require$_interopRequireDefault((parcelRequire("7BNIa")));

var $38c50a8bb2c809d4$var$_styleFunctionSx = $38c50a8bb2c809d4$require$_interopRequireDefault((parcelRequire("huozX")));

var $38c50a8bb2c809d4$var$_defaultSxConfig = $38c50a8bb2c809d4$require$_interopRequireDefault((parcelRequire("iHU64")));

var $38c50a8bb2c809d4$var$_applyStyles = $38c50a8bb2c809d4$require$_interopRequireDefault((parcelRequire("dDK43")));
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $38c50a8bb2c809d4$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $38c50a8bb2c809d4$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $38c50a8bb2c809d4$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $38c50a8bb2c809d4$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$38c50a8bb2c809d4$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $38c50a8bb2c809d4$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $38c50a8bb2c809d4$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $38c50a8bb2c809d4$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$38c50a8bb2c809d4$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $38c50a8bb2c809d4$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.internal_cache = {};
    return muiTheme;
}
var $38c50a8bb2c809d4$var$_default = module.exports.default = $38c50a8bb2c809d4$var$createTheme;

});
parcelRegister("4qPjz", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $33a1652cda4e0712$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $33a1652cda4e0712$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $33a1652cda4e0712$var$_deepmerge.default;
    }
});

var $33a1652cda4e0712$var$_deepmerge = $33a1652cda4e0712$require$_interopRequireWildcard((parcelRequire("i8Yed")));
Object.keys($33a1652cda4e0712$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($33a1652cda4e0712$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $33a1652cda4e0712$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $33a1652cda4e0712$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("i8Yed", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $d357b170454c6960$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d357b170454c6960$var$deepmerge;
module.exports.isPlainObject = $d357b170454c6960$var$isPlainObject;

var $d357b170454c6960$var$React = $d357b170454c6960$require$_interopRequireWildcard((parcelRequire("acw62")));

var $kD5jZ = parcelRequire("kD5jZ");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $d357b170454c6960$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $d357b170454c6960$var$deepClone(source) {
    if (/*#__PURE__*/ $d357b170454c6960$var$React.isValidElement(source) || (0, $kD5jZ.isValidElementType)(source) || !$d357b170454c6960$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $d357b170454c6960$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $d357b170454c6960$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($d357b170454c6960$var$isPlainObject(target) && $d357b170454c6960$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $d357b170454c6960$var$React.isValidElement(source[key]) || (0, $kD5jZ.isValidElementType)(source[key])) output[key] = source[key];
        else if ($d357b170454c6960$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $d357b170454c6960$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $d357b170454c6960$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $d357b170454c6960$var$isPlainObject(source[key]) ? $d357b170454c6960$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("kD5jZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("bBbDC"));

});



parcelRegister("88q07", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $5ec33d58a38f596c$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $5ec33d58a38f596c$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
// Keep in sync with docs/src/pages/customization/breakpoints/breakpoints.md
// #host-reference
const $5ec33d58a38f596c$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $5ec33d58a38f596c$var$createBreakpoints(breakpoints) {
    const { values: values = {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $5ec33d58a38f596c$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    const mediaKeys = [];
    for(let i = 0; i < keys.length; i += 1)mediaKeys.push(up(keys[i]));
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        internal_mediaKeys: mediaKeys,
        ...other
    };
}

});

parcelRegister("45d6a", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $2f91ca2696788915$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2f91ca2696788915$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $2f91ca2696788915$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $2f91ca2696788915$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $2f91ca2696788915$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $2f91ca2696788915$var$_cssContainerQueries = $2f91ca2696788915$require$_interopRequireWildcard((parcelRequire("gyqPU")));

});
parcelRegister("gyqPU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0d4a37461fa5e56$var$cssContainerQueries;
module.exports.getContainerQuery = $c0d4a37461fa5e56$var$getContainerQuery;
module.exports.isCqShorthand = $c0d4a37461fa5e56$var$isCqShorthand;
module.exports.sortContainerQueries = $c0d4a37461fa5e56$var$sortContainerQueries;
const $c0d4a37461fa5e56$var$MIN_WIDTH_PATTERN = /min-width:\s*([0-9.]+)/;
/**
 * WARN: Mutably updates the `css` object.
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 even though 40rem > 300px
 */ function $c0d4a37461fa5e56$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries || !$c0d4a37461fa5e56$var$hasContainerQuery(css)) return css;
    const keys = [];
    for(const key in css)if (key.startsWith('@container')) keys.push(key);
    keys.sort((a, b)=>{
        return +(a.match($c0d4a37461fa5e56$var$MIN_WIDTH_PATTERN)?.[1] || 0) - +(b.match($c0d4a37461fa5e56$var$MIN_WIDTH_PATTERN)?.[1] || 0);
    });
    const result = css;
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        const value = result[key];
        delete result[key];
        result[key] = value;
    }
    return result;
}
function $c0d4a37461fa5e56$var$hasContainerQuery(css) {
    for(const key in css){
        if (key.startsWith('@container')) return true;
    }
    return false;
}
function $c0d4a37461fa5e56$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $c0d4a37461fa5e56$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $c0d4a37461fa5e56$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("9dv5b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $6b5d70498831a6a6$var$shape = {
    borderRadius: 4
};
var $6b5d70498831a6a6$var$_default = module.exports.default = $6b5d70498831a6a6$var$shape;

});

parcelRegister("7BNIa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58a28cbc57cb705c$var$createSpacing;

var $4b2XU = parcelRequire("4b2XU");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $58a28cbc57cb705c$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $4b2XU.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("4b2XU", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $30aa7d54382f1fc5$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $30aa7d54382f1fc5$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $30aa7d54382f1fc5$var$_spacing.default;
    }
});

var $30aa7d54382f1fc5$var$_spacing = $30aa7d54382f1fc5$require$_interopRequireWildcard((parcelRequire("jcNfI")));
Object.keys($30aa7d54382f1fc5$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($30aa7d54382f1fc5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $30aa7d54382f1fc5$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $30aa7d54382f1fc5$var$_spacing[key];
        }
    });
});

});
parcelRegister("jcNfI", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $dfb557d6d79f9313$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $dfb557d6d79f9313$var$createUnarySpacing;
module.exports.createUnaryUnit = $dfb557d6d79f9313$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getValue = $dfb557d6d79f9313$var$getValue;
module.exports.paddingKeys = module.exports.padding = module.exports.marginKeys = module.exports.margin = void 0;

var $dfb557d6d79f9313$var$_responsivePropType = $dfb557d6d79f9313$require$_interopRequireDefault((parcelRequire("b2nTm")));

var $69BMr = parcelRequire("69BMr");

var $bcPDg = parcelRequire("bcPDg");
/* eslint-disable guard-for-in */ const $dfb557d6d79f9313$var$EMPTY_THEME = {
    internal_cache: {}
};
const $dfb557d6d79f9313$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $dfb557d6d79f9313$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $dfb557d6d79f9313$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
const $dfb557d6d79f9313$var$CSS_PROPERTIES = {};
for(const key in $dfb557d6d79f9313$var$properties)$dfb557d6d79f9313$var$CSS_PROPERTIES[key] = [
    $dfb557d6d79f9313$var$properties[key]
];
for(const keyProperty in $dfb557d6d79f9313$var$properties)for(const keyDirection in $dfb557d6d79f9313$var$directions){
    const property = $dfb557d6d79f9313$var$properties[keyProperty];
    const direction = $dfb557d6d79f9313$var$directions[keyDirection];
    const value = Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
    $dfb557d6d79f9313$var$CSS_PROPERTIES[keyProperty + keyDirection] = value;
}
for(const key in $dfb557d6d79f9313$var$aliases)$dfb557d6d79f9313$var$CSS_PROPERTIES[key] = $dfb557d6d79f9313$var$CSS_PROPERTIES[$dfb557d6d79f9313$var$aliases[key]];
/** @internal */ const $dfb557d6d79f9313$var$marginKeys = module.exports.marginKeys = new Set([
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
]);
/** @internal */ const $dfb557d6d79f9313$var$paddingKeys = module.exports.paddingKeys = new Set([
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
]);
const $dfb557d6d79f9313$var$spacingKeys = new Set([
    ...$dfb557d6d79f9313$var$marginKeys,
    ...$dfb557d6d79f9313$var$paddingKeys
]);
function $dfb557d6d79f9313$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $bcPDg.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $dfb557d6d79f9313$var$createUnarySpacing(theme) {
    return $dfb557d6d79f9313$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $dfb557d6d79f9313$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
// Avoid allocations
const $dfb557d6d79f9313$var$container = [
    ''
];
function $dfb557d6d79f9313$var$style(props, keys) {
    const theme = props.theme ?? $dfb557d6d79f9313$var$EMPTY_THEME;
    const transformer = theme?.internal_cache?.unarySpacing ?? $dfb557d6d79f9313$var$createUnarySpacing(theme);
    const result = {};
    for(const prop in props){
        if (!keys.has(prop)) continue;
        const cssProperties = $dfb557d6d79f9313$var$CSS_PROPERTIES[prop] ?? ($dfb557d6d79f9313$var$container[0] = prop, $dfb557d6d79f9313$var$container);
        const propValue = props[prop];
        (0, $69BMr.iterateBreakpoints)(result, props.theme, propValue, (mediaKey, value)=>{
            const target = mediaKey ? result[mediaKey] : result;
            for(let i = 0; i < cssProperties.length; i += 1)target[cssProperties[i]] = $dfb557d6d79f9313$var$getValue(transformer, value);
        });
    }
    return result;
}
function $dfb557d6d79f9313$var$marginFn(props) {
    return $dfb557d6d79f9313$var$style(props, $dfb557d6d79f9313$var$marginKeys);
}
$dfb557d6d79f9313$var$marginFn.propTypes = {};
$dfb557d6d79f9313$var$marginFn.filterProps = $dfb557d6d79f9313$var$marginKeys;
const $dfb557d6d79f9313$var$margin = module.exports.margin = $dfb557d6d79f9313$var$marginFn;
function $dfb557d6d79f9313$var$paddingFn(props) {
    return $dfb557d6d79f9313$var$style(props, $dfb557d6d79f9313$var$paddingKeys);
}
$dfb557d6d79f9313$var$paddingFn.propTypes = {};
$dfb557d6d79f9313$var$paddingFn.filterProps = $dfb557d6d79f9313$var$paddingKeys;
const $dfb557d6d79f9313$var$padding = module.exports.padding = $dfb557d6d79f9313$var$paddingFn;
function $dfb557d6d79f9313$var$spacingFn(props) {
    return $dfb557d6d79f9313$var$style(props, $dfb557d6d79f9313$var$spacingKeys);
}
$dfb557d6d79f9313$var$spacingFn.propTypes = {};
$dfb557d6d79f9313$var$spacingFn.filterProps = $dfb557d6d79f9313$var$spacingKeys;
const $dfb557d6d79f9313$var$spacing = $dfb557d6d79f9313$var$spacingFn;
var $dfb557d6d79f9313$var$_default = module.exports.default = $dfb557d6d79f9313$var$spacing;

});
parcelRegister("b2nTm", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $80926a1280ab9ff7$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $80926a1280ab9ff7$var$_responsivePropType.default;
    }
});

var $80926a1280ab9ff7$var$_responsivePropType = $80926a1280ab9ff7$require$_interopRequireDefault((parcelRequire("hT2dY")));

});
parcelRegister("hT2dY", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $035c476d127529ca$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $035c476d127529ca$var$_propTypes = $035c476d127529ca$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $035c476d127529ca$var$responsivePropType = {};
var $035c476d127529ca$var$_default = module.exports.default = $035c476d127529ca$var$responsivePropType;

});


parcelRegister("69BMr", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $47b0e3b884890847$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $47b0e3b884890847$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $47b0e3b884890847$var$_breakpoints.default;
    }
});

var $47b0e3b884890847$var$_breakpoints = $47b0e3b884890847$require$_interopRequireWildcard((parcelRequire("5d1LU")));
Object.keys($47b0e3b884890847$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($47b0e3b884890847$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $47b0e3b884890847$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $47b0e3b884890847$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("5d1LU", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $3caf8a7e1bd00f09$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_BREAKPOINTS = void 0;
module.exports.computeBreakpointsBase = $3caf8a7e1bd00f09$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $3caf8a7e1bd00f09$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $3caf8a7e1bd00f09$var$handleBreakpoints;
module.exports.hasBreakpoint = $3caf8a7e1bd00f09$var$hasBreakpoint;
module.exports.iterateBreakpoints = $3caf8a7e1bd00f09$var$iterateBreakpoints;
module.exports.mergeBreakpointsInOrder = $3caf8a7e1bd00f09$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $3caf8a7e1bd00f09$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $3caf8a7e1bd00f09$var$resolveBreakpointValues;
module.exports.values = void 0;

var $3caf8a7e1bd00f09$var$_propTypes = $3caf8a7e1bd00f09$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3caf8a7e1bd00f09$var$_isObjectEmpty = $3caf8a7e1bd00f09$require$_interopRequireDefault((parcelRequire("aDaYU")));

var $3caf8a7e1bd00f09$var$_fastDeepAssign = $3caf8a7e1bd00f09$require$_interopRequireDefault((parcelRequire("6bL1Q")));

var $3caf8a7e1bd00f09$var$_deepmerge = $3caf8a7e1bd00f09$require$_interopRequireDefault((parcelRequire("4qPjz")));

var $3caf8a7e1bd00f09$var$_merge = $3caf8a7e1bd00f09$require$_interopRequireDefault((parcelRequire("e2kej")));

var $45d6a = parcelRequire("45d6a");

var $3caf8a7e1bd00f09$var$_createBreakpoints = $3caf8a7e1bd00f09$require$_interopRequireDefault((parcelRequire("88q07")));
const $3caf8a7e1bd00f09$var$EMPTY_THEME = {};
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
/** @internal */ const $3caf8a7e1bd00f09$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $3caf8a7e1bd00f09$var$DEFAULT_BREAKPOINTS = module.exports.DEFAULT_BREAKPOINTS = (0, $3caf8a7e1bd00f09$var$_createBreakpoints.default)({
    values: $3caf8a7e1bd00f09$var$values
});
const $3caf8a7e1bd00f09$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $3caf8a7e1bd00f09$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $3caf8a7e1bd00f09$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const result = {};
    return $3caf8a7e1bd00f09$var$iterateBreakpoints(result, props.theme, propValue, (mediaKey, value, initialKey)=>{
        const finalValue = styleFromPropValue(value, initialKey);
        if (mediaKey) result[mediaKey] = finalValue;
        else (0, $3caf8a7e1bd00f09$var$_fastDeepAssign.default)(result, finalValue);
    });
}
function $3caf8a7e1bd00f09$var$iterateBreakpoints(target, theme, propValue, callback) {
    theme ?? (theme = $3caf8a7e1bd00f09$var$EMPTY_THEME);
    if (Array.isArray(propValue)) {
        const breakpoints = theme.breakpoints ?? $3caf8a7e1bd00f09$var$DEFAULT_BREAKPOINTS;
        for(let i = 0; i < propValue.length; i += 1)$3caf8a7e1bd00f09$var$buildBreakpoint(target, breakpoints.up(breakpoints.keys[i]), propValue[i], undefined, callback);
        return target;
    }
    if (typeof propValue === 'object') {
        const breakpoints = theme.breakpoints ?? $3caf8a7e1bd00f09$var$DEFAULT_BREAKPOINTS;
        const breakpointValues = breakpoints.values ?? $3caf8a7e1bd00f09$var$values;
        for(const key in propValue){
            if ((0, $45d6a.isCqShorthand)(breakpoints.keys, key)) {
                const containerKey = (0, $45d6a.getContainerQuery)(theme.containerQueries ? theme : $3caf8a7e1bd00f09$var$defaultContainerQueries, key);
                if (containerKey) $3caf8a7e1bd00f09$var$buildBreakpoint(target, containerKey, propValue[key], key, callback);
            } else if (key in breakpointValues) {
                const mediaKey = breakpoints.up(key);
                $3caf8a7e1bd00f09$var$buildBreakpoint(target, mediaKey, propValue[key], key, callback);
            } else {
                const cssKey = key;
                target[cssKey] = propValue[cssKey];
            }
        }
        return target;
    }
    callback(undefined, propValue);
    return target;
}
function $3caf8a7e1bd00f09$var$buildBreakpoint(target, mediaKey, value, initialKey, callback) {
    target[mediaKey] ?? (target[mediaKey] = {});
    callback(mediaKey, value, initialKey);
}
function $3caf8a7e1bd00f09$var$setupBreakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $3caf8a7e1bd00f09$var$DEFAULT_BREAKPOINTS;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $3caf8a7e1bd00f09$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
/** @internal */ function $3caf8a7e1bd00f09$var$createEmptyBreakpointObject(breakpoints = $3caf8a7e1bd00f09$var$DEFAULT_BREAKPOINTS) {
    const { internal_mediaKeys: mediaKeys } = breakpoints;
    const result = {};
    for(let i = 0; i < mediaKeys.length; i += 1)result[mediaKeys[i]] = {};
    return result;
}
/** @internal */ function $3caf8a7e1bd00f09$var$removeUnusedBreakpoints(breakpoints, style) {
    const breakpointKeys = breakpoints.internal_mediaKeys;
    for(let i = 0; i < breakpointKeys.length; i += 1){
        const key = breakpointKeys[i];
        if ((0, $3caf8a7e1bd00f09$var$_isObjectEmpty.default)(style[key])) delete style[key];
    }
    return style;
}
function $3caf8a7e1bd00f09$var$mergeBreakpointsInOrder(breakpoints, ...styles) {
    const emptyBreakpoints = $3caf8a7e1bd00f09$var$createEmptyBreakpointObject(breakpoints);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3caf8a7e1bd00f09$var$_deepmerge.default)(prev, next), {});
    return $3caf8a7e1bd00f09$var$removeUnusedBreakpoints(breakpoints, mergedOutput);
}
/** @internal */ function $3caf8a7e1bd00f09$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $3caf8a7e1bd00f09$var$resolveBreakpointValues(options) {
    const { values: breakpointValues, breakpoints: themeBreakpoints, base: customBase } = options;
    const base = customBase || $3caf8a7e1bd00f09$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object' && breakpointValues) {
            const bv = breakpointValues;
            acc[breakpoint] = bv[breakpoint] != null ? bv[breakpoint] : bv[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
function $3caf8a7e1bd00f09$var$hasBreakpoint(breakpoints, value) {
    if (Array.isArray(value)) return true;
    if (typeof value === 'object' && value !== null) {
        for(let i = 0; i < breakpoints.keys.length; i += 1){
            if (breakpoints.keys[i] in value) return true;
        }
        const valueKeys = Object.keys(value);
        for(let i = 0; i < valueKeys.length; i += 1){
            if ((0, $45d6a.isCqShorthand)(breakpoints.keys, valueKeys[i])) return true;
        }
    }
    return false;
}
var $3caf8a7e1bd00f09$var$_default = module.exports.default = $3caf8a7e1bd00f09$var$setupBreakpoints;

});
parcelRegister("aDaYU", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $7bd6109985ab2383$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7bd6109985ab2383$var$_isObjectEmpty.default;
    }
});

var $7bd6109985ab2383$var$_isObjectEmpty = $7bd6109985ab2383$require$_interopRequireDefault((parcelRequire("adJKM")));

});
parcelRegister("adJKM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $770e9bf566ea26af$var$isObjectEmpty;
function $770e9bf566ea26af$var$isObjectEmpty(object) {
    if (object == null) return true;
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}

});


parcelRegister("6bL1Q", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $481840126ffa62db$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $481840126ffa62db$var$_fastDeepAssign.default;
    }
});

var $481840126ffa62db$var$_fastDeepAssign = $481840126ffa62db$require$_interopRequireDefault((parcelRequire("eV6Rm")));

});
parcelRegister("eV6Rm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adcbb5bad09570ef$var$fastDeepAssign;
// Based on https://github.com/TehShrike/deepmerge
// Based on https://github.com/fastify/deepmerge
// MIT License
// Copyright (c) 2012 - 2022 James Halliday, Josh Duff, and other contributors of deepmerge
/* eslint-disable no-else-return */ /**
 * Assigns props from one object to another. Focused on performance, only normal objects with no
 * prototype are supported.
 */ function $adcbb5bad09570ef$var$fastDeepAssign(target, source) {
    const sourceIsArray = Array.isArray(source);
    const targetIsArray = Array.isArray(target);
    if ($adcbb5bad09570ef$var$isPrimitive(source)) return source;
    else if ($adcbb5bad09570ef$var$isPrimitiveOrBuiltIn(target)) return $adcbb5bad09570ef$var$clone(source);
    else if (sourceIsArray && targetIsArray) return $adcbb5bad09570ef$var$mergeArray(target, source);
    else if (sourceIsArray !== targetIsArray) return $adcbb5bad09570ef$var$clone(source);
    else return $adcbb5bad09570ef$var$mergeObject(target, source);
}
function $adcbb5bad09570ef$var$cloneArray(value) {
    let i = 0;
    const il = value.length;
    const result = new Array(il);
    for(i = 0; i < il; i += 1)result[i] = $adcbb5bad09570ef$var$clone(value[i]);
    return result;
}
function $adcbb5bad09570ef$var$cloneObject(target) {
    const result = {};
    for(const key in target){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        result[key] = $adcbb5bad09570ef$var$clone(target[key]);
    }
    return result;
}
function $adcbb5bad09570ef$var$mergeArray(target, source) {
    const tl = target.length;
    for(let i = 0; i < source.length; i += 1)target[tl + i] = $adcbb5bad09570ef$var$clone(source[i]);
    return target;
}
function $adcbb5bad09570ef$var$isMergeableObject(value) {
    return typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
}
function $adcbb5bad09570ef$var$isPrimitive(value) {
    return typeof value !== 'object' || value === null;
}
function $adcbb5bad09570ef$var$isPrimitiveOrBuiltIn(value) {
    return typeof value !== 'object' || value === null || value instanceof RegExp || value instanceof Date;
}
function $adcbb5bad09570ef$var$clone(entry) {
    // eslint-disable-next-line no-nested-ternary
    return $adcbb5bad09570ef$var$isMergeableObject(entry) ? Array.isArray(entry) ? $adcbb5bad09570ef$var$cloneArray(entry) : $adcbb5bad09570ef$var$cloneObject(entry) : entry;
}
function $adcbb5bad09570ef$var$mergeObject(target, source) {
    for(const key in source){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        if (key in target) target[key] = $adcbb5bad09570ef$var$fastDeepAssign(target[key], source[key]);
        else target[key] = $adcbb5bad09570ef$var$clone(source[key]);
    }
    return target;
}

});


parcelRegister("e2kej", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $a380f1ccb87c21db$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a380f1ccb87c21db$var$_merge.default;
    }
});

var $a380f1ccb87c21db$var$_merge = $a380f1ccb87c21db$require$_interopRequireDefault((parcelRequire("kEFpc")));

});
parcelRegister("kEFpc", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $f097a952650f68ad$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f097a952650f68ad$var$_deepmerge = $f097a952650f68ad$require$_interopRequireDefault((parcelRequire("4qPjz")));
const $f097a952650f68ad$var$options = {
    clone: false
};
function $f097a952650f68ad$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $f097a952650f68ad$var$_deepmerge.default)(acc, item, $f097a952650f68ad$var$options);
}
var $f097a952650f68ad$var$_default = module.exports.default = $f097a952650f68ad$var$merge;

});




parcelRegister("bcPDg", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $8288ddcffe477c86$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8288ddcffe477c86$var$_exportNames = {
    style: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8288ddcffe477c86$var$_style.default;
    }
});
Object.defineProperty(module.exports, "style", {
    enumerable: true,
    get: function() {
        return $8288ddcffe477c86$var$_style.default;
    }
});

var $8288ddcffe477c86$var$_style = $8288ddcffe477c86$require$_interopRequireWildcard((parcelRequire("6pv7T")));
Object.keys($8288ddcffe477c86$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($8288ddcffe477c86$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8288ddcffe477c86$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8288ddcffe477c86$var$_style[key];
        }
    });
});

});
parcelRegister("6pv7T", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $4aad38e6120c1f7c$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4aad38e6120c1f7c$var$style;
module.exports.getPath = $4aad38e6120c1f7c$var$getPath;
module.exports.getStyleValue = $4aad38e6120c1f7c$var$getStyleValue;
module.exports.getStyleValue2 = $4aad38e6120c1f7c$var$getStyleValue2;

var $4aad38e6120c1f7c$var$_capitalize = $4aad38e6120c1f7c$require$_interopRequireDefault((parcelRequire("jV5Vu")));

var $4aad38e6120c1f7c$var$_responsivePropType = $4aad38e6120c1f7c$require$_interopRequireDefault((parcelRequire("b2nTm")));

var $69BMr = parcelRequire("69BMr");
/**
 * TODO(v7): Keep either this one or `getStyleValue2`
 */ function $4aad38e6120c1f7c$var$getStyleValue(themeMapping, transform, valueFinal, userValue = valueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(valueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[valueFinal] || userValue;
    else if (typeof valueFinal === 'string') value = $4aad38e6120c1f7c$var$getPath(themeMapping, valueFinal) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
/**
 * HACK: The `alternateProp` logic is there because our theme looks like this:
 * {
 *   typography: {
 *     fontFamily: 'comic sans',
 *     fontFamilyCode: 'courrier new',
 *   }
 * }
 * And we support targetting:
 * - `typography.fontFamily`     with `sx={{ fontFamily: 'default' }}`
 * - `typography.fontFamilyCode` with `sx={{ fontFamily: 'code' }}`
 *
 * TODO(v7): Refactor our theme to look like this and remove the horrendous logic:
 * {
 *   typography: {
 *     fontFamily: {
 *       default: 'comic sans',
 *       code: 'courrier new',
 *     }
 *   }
 * }
 */ function $4aad38e6120c1f7c$var$getStyleValue2(themeMapping, transform, userValue, alternateProp) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(userValue);
    else if (Array.isArray(themeMapping)) value = themeMapping[userValue] || userValue;
    else if (typeof userValue === 'string') value = $4aad38e6120c1f7c$var$getPath(themeMapping, userValue, true, alternateProp) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $4aad38e6120c1f7c$var$getPath(obj, pathInput, checkVars = true, alternateProp) {
    if (!obj || !pathInput) return null;
    const path = pathInput.split('.');
    // Check if CSS variables are used
    if (obj.vars && checkVars) {
        const val = $4aad38e6120c1f7c$var$getPathImpl(obj.vars, path, alternateProp);
        if (val != null) return val;
    }
    return $4aad38e6120c1f7c$var$getPathImpl(obj, path, alternateProp);
}
function $4aad38e6120c1f7c$var$getPathImpl(object, path, alternateProp) {
    let lastResult = undefined;
    let result = object;
    let index = 0;
    while(index < path.length){
        if (result === null || result === undefined) return result;
        lastResult = result;
        result = result[path[index]];
        index += 1;
    }
    if (alternateProp && result === undefined) {
        const lastKey = path[path.length - 1];
        const alternateKey = `${alternateProp}${lastKey === 'default' ? '' : (0, $4aad38e6120c1f7c$var$_capitalize.default)(lastKey)}`;
        return lastResult?.[alternateKey];
    }
    return result;
}
function $4aad38e6120c1f7c$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $4aad38e6120c1f7c$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (valueFinal)=>{
            const value = $4aad38e6120c1f7c$var$getStyleValue2(themeMapping, transform, valueFinal, prop);
            return cssProperty === false ? value : {
                [cssProperty]: value
            };
        };
        return (0, $69BMr.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}

});
parcelRegister("jV5Vu", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $e807f000cc551f57$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e807f000cc551f57$var$_capitalize.default;
    }
});

var $e807f000cc551f57$var$_capitalize = $e807f000cc551f57$require$_interopRequireDefault((parcelRequire("jyyG4")));

});
parcelRegister("jyyG4", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $e3cc178908efddf5$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e3cc178908efddf5$var$capitalize;

var $e3cc178908efddf5$var$_formatMuiErrorMessage = $e3cc178908efddf5$require$_interopRequireDefault((parcelRequire("lVHP6")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $e3cc178908efddf5$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $e3cc178908efddf5$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});







parcelRegister("huozX", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $cbb84ddbc3b1aeb3$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $cbb84ddbc3b1aeb3$var$unstable_createStyleFunctionSx;

var $cbb84ddbc3b1aeb3$var$_fastDeepAssign = $cbb84ddbc3b1aeb3$require$_interopRequireDefault((parcelRequire("6bL1Q")));

var $bcPDg = parcelRequire("bcPDg");

var $69BMr = parcelRequire("69BMr");

var $45d6a = parcelRequire("45d6a");

var $cbb84ddbc3b1aeb3$var$_defaultSxConfig = $cbb84ddbc3b1aeb3$require$_interopRequireDefault((parcelRequire("iHU64")));
/**
 * The `css` function accepts arrays as values for mobile-first responsive styles.
 * Note that this extends to non-theme values also. For example `display=['none', 'block']`
 * will also works.
 */ /**
 * Map of all CSS pseudo selectors (`:hover`, `:focus`, ...).
 */ /**
 * Map all nested selectors.
 */ /**
 * Map all nested selectors and CSS variables.
 */ /**
 * Map of all available CSS properties (including aliases) and their raw value.
 * Only used internally to map CSS properties to input types (responsive value,
 * theme function or nested) in `SystemCssProperties`.
 */ /**
 * The `SystemStyleObject` defines custom properties that will be transformed to
 * their corresponding values from the `Theme`. Other valid CSS properties are also allowed.
 */ /**
 * The `SxProps` can be either object or function
 */ /* eslint-disable guard-for-in */ const $cbb84ddbc3b1aeb3$var$EMPTY_THEME = {};
// eslint-disable-next-line @typescript-eslint/naming-convention
function $cbb84ddbc3b1aeb3$var$unstable_createStyleFunctionSx() {
    function styleFunctionSx(props) {
        if (!props.sx) return null;
        const { sx: sx, theme: theme = $cbb84ddbc3b1aeb3$var$EMPTY_THEME, nested: nested } = props;
        const config = theme.unstable_sxConfig ?? $cbb84ddbc3b1aeb3$var$_defaultSxConfig.default;
        // Pass argument without loop allocations
        const wrapper = {
            sx: null,
            theme: theme,
            nested: true
        };
        function process(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const breakpoints = theme.breakpoints ?? $69BMr.DEFAULT_BREAKPOINTS;
            const css = (0, $69BMr.createEmptyBreakpointObject)(breakpoints);
            for(const styleKey in sxObject){
                const value = $cbb84ddbc3b1aeb3$var$callIfFn(sxObject[styleKey], theme);
                if (value === null || value === undefined) continue;
                if (typeof value !== 'object') {
                    $cbb84ddbc3b1aeb3$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if (config[styleKey]) {
                    $cbb84ddbc3b1aeb3$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if ((0, $69BMr.hasBreakpoint)(breakpoints, value)) (0, $69BMr.iterateBreakpoints)(css, props.theme, value, (mediaKey, finalValue)=>{
                    css[mediaKey][styleKey] = finalValue;
                });
                else {
                    wrapper.sx = value;
                    css[styleKey] = styleFunctionSx(wrapper);
                }
            }
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $45d6a.sortContainerQueries)(theme, (0, $69BMr.removeUnusedBreakpoints)(breakpoints, css))
            };
            return (0, $45d6a.sortContainerQueries)(theme, (0, $69BMr.removeUnusedBreakpoints)(breakpoints, css));
        }
        return Array.isArray(sx) ? sx.map(process) : process(sx);
    }
    styleFunctionSx.filterProps = [
        'sx'
    ];
    return styleFunctionSx;
}
var $cbb84ddbc3b1aeb3$var$_default = module.exports.default = $cbb84ddbc3b1aeb3$var$unstable_createStyleFunctionSx();
function $cbb84ddbc3b1aeb3$var$setThemeValue(css, prop, value, theme, config) {
    const options = config[prop];
    if (!options) {
        css[prop] = value;
        return;
    }
    if (value == null) return;
    const { themeKey: themeKey } = options;
    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && value === 'inherit') {
        css[prop] = value;
        return;
    }
    const { style: style } = options;
    if (style) {
        (0, $cbb84ddbc3b1aeb3$var$_fastDeepAssign.default)(css, style({
            [prop]: value,
            theme: theme
        }));
        return;
    }
    const { cssProperty: cssProperty = prop, transform: transform } = options;
    const themeMapping = (0, $bcPDg.getPath)(theme, themeKey);
    (0, $69BMr.iterateBreakpoints)(css, theme, value, (mediaKey, valueFinal)=>{
        const finalValue = (0, $bcPDg.getStyleValue2)(themeMapping, transform, valueFinal, prop);
        if (cssProperty === false) {
            if (mediaKey) (0, $cbb84ddbc3b1aeb3$var$_fastDeepAssign.default)(css[mediaKey], finalValue);
            else (0, $cbb84ddbc3b1aeb3$var$_fastDeepAssign.default)(css, finalValue);
        } else // eslint-disable-next-line no-lonely-if
        if (mediaKey) css[mediaKey][cssProperty] = finalValue;
        else css[cssProperty] = finalValue;
    });
}
function $cbb84ddbc3b1aeb3$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

});
parcelRegister("iHU64", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2XU = parcelRequire("4b2XU");

var $dwAab = parcelRequire("dwAab");

var $iXSgY = parcelRequire("iXSgY");

var $6OuH1 = parcelRequire("6OuH1");

var $hrmPC = parcelRequire("hrmPC");
const $d9e7c1d322d1adc6$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $dwAab.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $dwAab.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $dwAab.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $dwAab.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $dwAab.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $dwAab.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $dwAab.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $6OuH1.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $6OuH1.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $6OuH1.paletteTransform
    },
    // spacing
    p: {
        style: $4b2XU.padding
    },
    pt: {
        style: $4b2XU.padding
    },
    pr: {
        style: $4b2XU.padding
    },
    pb: {
        style: $4b2XU.padding
    },
    pl: {
        style: $4b2XU.padding
    },
    px: {
        style: $4b2XU.padding
    },
    py: {
        style: $4b2XU.padding
    },
    padding: {
        style: $4b2XU.padding
    },
    paddingTop: {
        style: $4b2XU.padding
    },
    paddingRight: {
        style: $4b2XU.padding
    },
    paddingBottom: {
        style: $4b2XU.padding
    },
    paddingLeft: {
        style: $4b2XU.padding
    },
    paddingX: {
        style: $4b2XU.padding
    },
    paddingY: {
        style: $4b2XU.padding
    },
    paddingInline: {
        style: $4b2XU.padding
    },
    paddingInlineStart: {
        style: $4b2XU.padding
    },
    paddingInlineEnd: {
        style: $4b2XU.padding
    },
    paddingBlock: {
        style: $4b2XU.padding
    },
    paddingBlockStart: {
        style: $4b2XU.padding
    },
    paddingBlockEnd: {
        style: $4b2XU.padding
    },
    m: {
        style: $4b2XU.margin
    },
    mt: {
        style: $4b2XU.margin
    },
    mr: {
        style: $4b2XU.margin
    },
    mb: {
        style: $4b2XU.margin
    },
    ml: {
        style: $4b2XU.margin
    },
    mx: {
        style: $4b2XU.margin
    },
    my: {
        style: $4b2XU.margin
    },
    margin: {
        style: $4b2XU.margin
    },
    marginTop: {
        style: $4b2XU.margin
    },
    marginRight: {
        style: $4b2XU.margin
    },
    marginBottom: {
        style: $4b2XU.margin
    },
    marginLeft: {
        style: $4b2XU.margin
    },
    marginX: {
        style: $4b2XU.margin
    },
    marginY: {
        style: $4b2XU.margin
    },
    marginInline: {
        style: $4b2XU.margin
    },
    marginInlineStart: {
        style: $4b2XU.margin
    },
    marginInlineEnd: {
        style: $4b2XU.margin
    },
    marginBlock: {
        style: $4b2XU.margin
    },
    marginBlockStart: {
        style: $4b2XU.margin
    },
    marginBlockEnd: {
        style: $4b2XU.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $iXSgY.gap
    },
    rowGap: {
        style: $iXSgY.rowGap
    },
    columnGap: {
        style: $iXSgY.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $hrmPC.sizingTransform
    },
    maxWidth: {
        style: $hrmPC.maxWidth
    },
    minWidth: {
        transform: $hrmPC.sizingTransform
    },
    height: {
        transform: $hrmPC.sizingTransform
    },
    maxHeight: {
        transform: $hrmPC.sizingTransform
    },
    minHeight: {
        transform: $hrmPC.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $d9e7c1d322d1adc6$var$_default = module.exports.default = $d9e7c1d322d1adc6$var$defaultSxConfig;

});
parcelRegister("dwAab", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $9d8a50cae3d4b802$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9d8a50cae3d4b802$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9d8a50cae3d4b802$var$_borders.default;
    }
});

var $9d8a50cae3d4b802$var$_borders = $9d8a50cae3d4b802$require$_interopRequireWildcard((parcelRequire("fJd9N")));
Object.keys($9d8a50cae3d4b802$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($9d8a50cae3d4b802$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $9d8a50cae3d4b802$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $9d8a50cae3d4b802$var$_borders[key];
        }
    });
});

});
parcelRegister("fJd9N", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $b73543ac1212ccf0$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $b73543ac1212ccf0$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $b73543ac1212ccf0$var$_responsivePropType = $b73543ac1212ccf0$require$_interopRequireDefault((parcelRequire("b2nTm")));

var $b73543ac1212ccf0$var$_style = $b73543ac1212ccf0$require$_interopRequireDefault((parcelRequire("bcPDg")));

var $b73543ac1212ccf0$var$_compose = $b73543ac1212ccf0$require$_interopRequireDefault((parcelRequire("8Apkm")));

var $4b2XU = parcelRequire("4b2XU");

var $69BMr = parcelRequire("69BMr");
/** @internal */ function $b73543ac1212ccf0$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $b73543ac1212ccf0$var$createBorderStyle(prop, transform) {
    return (0, $b73543ac1212ccf0$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $b73543ac1212ccf0$var$border = module.exports.border = $b73543ac1212ccf0$var$createBorderStyle('border', $b73543ac1212ccf0$var$borderTransform);
const $b73543ac1212ccf0$var$borderTop = module.exports.borderTop = $b73543ac1212ccf0$var$createBorderStyle('borderTop', $b73543ac1212ccf0$var$borderTransform);
const $b73543ac1212ccf0$var$borderRight = module.exports.borderRight = $b73543ac1212ccf0$var$createBorderStyle('borderRight', $b73543ac1212ccf0$var$borderTransform);
const $b73543ac1212ccf0$var$borderBottom = module.exports.borderBottom = $b73543ac1212ccf0$var$createBorderStyle('borderBottom', $b73543ac1212ccf0$var$borderTransform);
const $b73543ac1212ccf0$var$borderLeft = module.exports.borderLeft = $b73543ac1212ccf0$var$createBorderStyle('borderLeft', $b73543ac1212ccf0$var$borderTransform);
const $b73543ac1212ccf0$var$borderColor = module.exports.borderColor = $b73543ac1212ccf0$var$createBorderStyle('borderColor');
const $b73543ac1212ccf0$var$borderTopColor = module.exports.borderTopColor = $b73543ac1212ccf0$var$createBorderStyle('borderTopColor');
const $b73543ac1212ccf0$var$borderRightColor = module.exports.borderRightColor = $b73543ac1212ccf0$var$createBorderStyle('borderRightColor');
const $b73543ac1212ccf0$var$borderBottomColor = module.exports.borderBottomColor = $b73543ac1212ccf0$var$createBorderStyle('borderBottomColor');
const $b73543ac1212ccf0$var$borderLeftColor = module.exports.borderLeftColor = $b73543ac1212ccf0$var$createBorderStyle('borderLeftColor');
const $b73543ac1212ccf0$var$outline = module.exports.outline = $b73543ac1212ccf0$var$createBorderStyle('outline', $b73543ac1212ccf0$var$borderTransform);
const $b73543ac1212ccf0$var$outlineColor = module.exports.outlineColor = $b73543ac1212ccf0$var$createBorderStyle('outlineColor');
const $b73543ac1212ccf0$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $4b2XU.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $4b2XU.getValue)(transformer, propValue)
            });
        return (0, $69BMr.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $b73543ac1212ccf0$var$borderRadius;
$b73543ac1212ccf0$var$borderRadius.propTypes = {};
$b73543ac1212ccf0$var$borderRadius.filterProps = [
    'borderRadius'
];
const $b73543ac1212ccf0$var$borders = (0, $b73543ac1212ccf0$var$_compose.default)($b73543ac1212ccf0$var$border, $b73543ac1212ccf0$var$borderTop, $b73543ac1212ccf0$var$borderRight, $b73543ac1212ccf0$var$borderBottom, $b73543ac1212ccf0$var$borderLeft, $b73543ac1212ccf0$var$borderColor, $b73543ac1212ccf0$var$borderTopColor, $b73543ac1212ccf0$var$borderRightColor, $b73543ac1212ccf0$var$borderBottomColor, $b73543ac1212ccf0$var$borderLeftColor, $b73543ac1212ccf0$var$borderRadius, $b73543ac1212ccf0$var$outline, $b73543ac1212ccf0$var$outlineColor);
var $b73543ac1212ccf0$var$_default = module.exports.default = $b73543ac1212ccf0$var$borders;

});
parcelRegister("8Apkm", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $6405550033af6bdc$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6405550033af6bdc$var$_compose.default;
    }
});

var $6405550033af6bdc$var$_compose = $6405550033af6bdc$require$_interopRequireDefault((parcelRequire("9OBe6")));

});
parcelRegister("9OBe6", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $7255a8f72449d0af$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7255a8f72449d0af$var$_fastDeepAssign = $7255a8f72449d0af$require$_interopRequireDefault((parcelRequire("6bL1Q")));
function $7255a8f72449d0af$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        const result = {};
        for(const prop in props)if (handlers[prop]) (0, $7255a8f72449d0af$var$_fastDeepAssign.default)(result, handlers[prop](props));
        return result;
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $7255a8f72449d0af$var$_default = module.exports.default = $7255a8f72449d0af$var$compose;

});




parcelRegister("iXSgY", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $dce7d6225afbc087$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dce7d6225afbc087$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $dce7d6225afbc087$var$_cssGrid.default;
    }
});

var $dce7d6225afbc087$var$_cssGrid = $dce7d6225afbc087$require$_interopRequireWildcard((parcelRequire("jZS9h")));
Object.keys($dce7d6225afbc087$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($dce7d6225afbc087$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $dce7d6225afbc087$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $dce7d6225afbc087$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("jZS9h", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $e8edb79e562788da$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $e8edb79e562788da$var$_style = $e8edb79e562788da$require$_interopRequireDefault((parcelRequire("bcPDg")));

var $e8edb79e562788da$var$_compose = $e8edb79e562788da$require$_interopRequireDefault((parcelRequire("8Apkm")));

var $4b2XU = parcelRequire("4b2XU");

var $69BMr = parcelRequire("69BMr");

var $e8edb79e562788da$var$_responsivePropType = $e8edb79e562788da$require$_interopRequireDefault((parcelRequire("b2nTm")));
const $e8edb79e562788da$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $4b2XU.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $4b2XU.getValue)(transformer, propValue)
            });
        return (0, $69BMr.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $e8edb79e562788da$var$gap;
$e8edb79e562788da$var$gap.propTypes = {};
$e8edb79e562788da$var$gap.filterProps = [
    'gap'
];
const $e8edb79e562788da$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $4b2XU.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $4b2XU.getValue)(transformer, propValue)
            });
        return (0, $69BMr.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $e8edb79e562788da$var$columnGap;
$e8edb79e562788da$var$columnGap.propTypes = {};
$e8edb79e562788da$var$columnGap.filterProps = [
    'columnGap'
];
const $e8edb79e562788da$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $4b2XU.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $4b2XU.getValue)(transformer, propValue)
            });
        return (0, $69BMr.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $e8edb79e562788da$var$rowGap;
$e8edb79e562788da$var$rowGap.propTypes = {};
$e8edb79e562788da$var$rowGap.filterProps = [
    'rowGap'
];
const $e8edb79e562788da$var$gridColumn = module.exports.gridColumn = (0, $e8edb79e562788da$var$_style.default)({
    prop: 'gridColumn'
});
const $e8edb79e562788da$var$gridRow = module.exports.gridRow = (0, $e8edb79e562788da$var$_style.default)({
    prop: 'gridRow'
});
const $e8edb79e562788da$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $e8edb79e562788da$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $e8edb79e562788da$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $e8edb79e562788da$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $e8edb79e562788da$var$gridAutoRows = module.exports.gridAutoRows = (0, $e8edb79e562788da$var$_style.default)({
    prop: 'gridAutoRows'
});
const $e8edb79e562788da$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $e8edb79e562788da$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $e8edb79e562788da$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $e8edb79e562788da$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $e8edb79e562788da$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $e8edb79e562788da$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $e8edb79e562788da$var$gridArea = module.exports.gridArea = (0, $e8edb79e562788da$var$_style.default)({
    prop: 'gridArea'
});
const $e8edb79e562788da$var$grid = (0, $e8edb79e562788da$var$_compose.default)($e8edb79e562788da$var$gap, $e8edb79e562788da$var$columnGap, $e8edb79e562788da$var$rowGap, $e8edb79e562788da$var$gridColumn, $e8edb79e562788da$var$gridRow, $e8edb79e562788da$var$gridAutoFlow, $e8edb79e562788da$var$gridAutoColumns, $e8edb79e562788da$var$gridAutoRows, $e8edb79e562788da$var$gridTemplateColumns, $e8edb79e562788da$var$gridTemplateRows, $e8edb79e562788da$var$gridTemplateAreas, $e8edb79e562788da$var$gridArea);
var $e8edb79e562788da$var$_default = module.exports.default = $e8edb79e562788da$var$grid;

});


parcelRegister("6OuH1", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $4f5f388bacfd578d$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4f5f388bacfd578d$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4f5f388bacfd578d$var$_palette.default;
    }
});

var $4f5f388bacfd578d$var$_palette = $4f5f388bacfd578d$require$_interopRequireWildcard((parcelRequire("12CqO")));
Object.keys($4f5f388bacfd578d$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4f5f388bacfd578d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4f5f388bacfd578d$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4f5f388bacfd578d$var$_palette[key];
        }
    });
});

});
parcelRegister("12CqO", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $0c23ca0b6505dd0a$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $0c23ca0b6505dd0a$var$paletteTransform;

var $0c23ca0b6505dd0a$var$_style = $0c23ca0b6505dd0a$require$_interopRequireDefault((parcelRequire("bcPDg")));

var $0c23ca0b6505dd0a$var$_compose = $0c23ca0b6505dd0a$require$_interopRequireDefault((parcelRequire("8Apkm")));
/** @internal */ function $0c23ca0b6505dd0a$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $0c23ca0b6505dd0a$var$color = module.exports.color = (0, $0c23ca0b6505dd0a$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $0c23ca0b6505dd0a$var$paletteTransform
});
const $0c23ca0b6505dd0a$var$bgcolor = module.exports.bgcolor = (0, $0c23ca0b6505dd0a$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $0c23ca0b6505dd0a$var$paletteTransform
});
const $0c23ca0b6505dd0a$var$backgroundColor = module.exports.backgroundColor = (0, $0c23ca0b6505dd0a$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $0c23ca0b6505dd0a$var$paletteTransform
});
const $0c23ca0b6505dd0a$var$palette = (0, $0c23ca0b6505dd0a$var$_compose.default)($0c23ca0b6505dd0a$var$color, $0c23ca0b6505dd0a$var$bgcolor, $0c23ca0b6505dd0a$var$backgroundColor);
var $0c23ca0b6505dd0a$var$_default = module.exports.default = $0c23ca0b6505dd0a$var$palette;

});


parcelRegister("hrmPC", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $cb26ab2c1ab7ef94$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cb26ab2c1ab7ef94$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cb26ab2c1ab7ef94$var$_sizing.default;
    }
});

var $cb26ab2c1ab7ef94$var$_sizing = $cb26ab2c1ab7ef94$require$_interopRequireWildcard((parcelRequire("d6Eu8")));
Object.keys($cb26ab2c1ab7ef94$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($cb26ab2c1ab7ef94$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cb26ab2c1ab7ef94$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cb26ab2c1ab7ef94$var$_sizing[key];
        }
    });
});

});
parcelRegister("d6Eu8", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $98ab3d624f99fd32$require$_interopRequireWildcard = $PT5lT.default;

var $k8pq4 = parcelRequire("k8pq4");
var $98ab3d624f99fd32$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $98ab3d624f99fd32$var$sizingTransform;
module.exports.width = void 0;

var $98ab3d624f99fd32$var$_style = $98ab3d624f99fd32$require$_interopRequireDefault((parcelRequire("bcPDg")));

var $98ab3d624f99fd32$var$_compose = $98ab3d624f99fd32$require$_interopRequireDefault((parcelRequire("8Apkm")));

var $98ab3d624f99fd32$var$_breakpoints = $98ab3d624f99fd32$require$_interopRequireWildcard((parcelRequire("69BMr")));
var $98ab3d624f99fd32$var$breakpointsModule = $98ab3d624f99fd32$var$_breakpoints;
const $98ab3d624f99fd32$var$breakpointsValues = $98ab3d624f99fd32$var$breakpointsModule.values;
/** @internal */ function $98ab3d624f99fd32$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $98ab3d624f99fd32$var$width = module.exports.width = (0, $98ab3d624f99fd32$var$_style.default)({
    prop: 'width',
    transform: $98ab3d624f99fd32$var$sizingTransform
});
const $98ab3d624f99fd32$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $98ab3d624f99fd32$var$breakpointsValues[propValue];
            if (!breakpoint) return {
                maxWidth: $98ab3d624f99fd32$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $98ab3d624f99fd32$var$_breakpoints.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $98ab3d624f99fd32$var$maxWidth;
$98ab3d624f99fd32$var$maxWidth.filterProps = [
    'maxWidth'
];
const $98ab3d624f99fd32$var$minWidth = module.exports.minWidth = (0, $98ab3d624f99fd32$var$_style.default)({
    prop: 'minWidth',
    transform: $98ab3d624f99fd32$var$sizingTransform
});
const $98ab3d624f99fd32$var$height = module.exports.height = (0, $98ab3d624f99fd32$var$_style.default)({
    prop: 'height',
    transform: $98ab3d624f99fd32$var$sizingTransform
});
const $98ab3d624f99fd32$var$maxHeight = module.exports.maxHeight = (0, $98ab3d624f99fd32$var$_style.default)({
    prop: 'maxHeight',
    transform: $98ab3d624f99fd32$var$sizingTransform
});
const $98ab3d624f99fd32$var$minHeight = module.exports.minHeight = (0, $98ab3d624f99fd32$var$_style.default)({
    prop: 'minHeight',
    transform: $98ab3d624f99fd32$var$sizingTransform
});
const $98ab3d624f99fd32$var$sizeWidth = module.exports.sizeWidth = (0, $98ab3d624f99fd32$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $98ab3d624f99fd32$var$sizingTransform
});
const $98ab3d624f99fd32$var$sizeHeight = module.exports.sizeHeight = (0, $98ab3d624f99fd32$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $98ab3d624f99fd32$var$sizingTransform
});
const $98ab3d624f99fd32$var$boxSizing = module.exports.boxSizing = (0, $98ab3d624f99fd32$var$_style.default)({
    prop: 'boxSizing'
});
const $98ab3d624f99fd32$var$sizing = (0, $98ab3d624f99fd32$var$_compose.default)($98ab3d624f99fd32$var$width, $98ab3d624f99fd32$var$maxWidth, $98ab3d624f99fd32$var$minWidth, $98ab3d624f99fd32$var$height, $98ab3d624f99fd32$var$maxHeight, $98ab3d624f99fd32$var$minHeight, $98ab3d624f99fd32$var$boxSizing);
var $98ab3d624f99fd32$var$_default = module.exports.default = $98ab3d624f99fd32$var$sizing;

});




parcelRegister("dDK43", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ee2a65152e2b991$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $9ee2a65152e2b991$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("3pEz9", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $27c32c758abefa74$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $27c32c758abefa74$var$_useThemeWithoutDefault.default;
    }
});

var $27c32c758abefa74$var$_useThemeWithoutDefault = $27c32c758abefa74$require$_interopRequireDefault((parcelRequire("7eUFU")));

});
parcelRegister("7eUFU", function(module, exports) {
"use strict";
'use client';

var $PT5lT = parcelRequire("PT5lT");
var $5455cdae79f324b1$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5455cdae79f324b1$var$React = $5455cdae79f324b1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ivxDX = parcelRequire("ivxDX");
function $5455cdae79f324b1$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5455cdae79f324b1$var$useThemeWithoutDefault(defaultTheme = null) {
    const contextTheme = $5455cdae79f324b1$var$React.useContext($ivxDX.ThemeContext);
    return !contextTheme || $5455cdae79f324b1$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5455cdae79f324b1$var$_default = module.exports.default = $5455cdae79f324b1$var$useThemeWithoutDefault;

});






parcelRegister("hua2v", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $cbad06a2aeee2616$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cbad06a2aeee2616$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cbad06a2aeee2616$var$_display.default;
    }
});

var $cbad06a2aeee2616$var$_display = $cbad06a2aeee2616$require$_interopRequireWildcard((parcelRequire("iRZ2I")));
Object.keys($cbad06a2aeee2616$var$_display).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($cbad06a2aeee2616$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $cbad06a2aeee2616$var$_display[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $cbad06a2aeee2616$var$_display[key];
        }
    });
});

});
parcelRegister("iRZ2I", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $dbcc870d9b0ed7f7$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.whiteSpace = module.exports.visibility = module.exports.textOverflow = module.exports.overflow = module.exports.displayRaw = module.exports.displayPrint = module.exports.default = void 0;

var $dbcc870d9b0ed7f7$var$_style = $dbcc870d9b0ed7f7$require$_interopRequireDefault((parcelRequire("bcPDg")));

var $dbcc870d9b0ed7f7$var$_compose = $dbcc870d9b0ed7f7$require$_interopRequireDefault((parcelRequire("8Apkm")));
const $dbcc870d9b0ed7f7$var$displayPrint = module.exports.displayPrint = (0, $dbcc870d9b0ed7f7$var$_style.default)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: (value)=>({
            '@media print': {
                display: value
            }
        })
});
const $dbcc870d9b0ed7f7$var$displayRaw = module.exports.displayRaw = (0, $dbcc870d9b0ed7f7$var$_style.default)({
    prop: 'display'
});
const $dbcc870d9b0ed7f7$var$overflow = module.exports.overflow = (0, $dbcc870d9b0ed7f7$var$_style.default)({
    prop: 'overflow'
});
const $dbcc870d9b0ed7f7$var$textOverflow = module.exports.textOverflow = (0, $dbcc870d9b0ed7f7$var$_style.default)({
    prop: 'textOverflow'
});
const $dbcc870d9b0ed7f7$var$visibility = module.exports.visibility = (0, $dbcc870d9b0ed7f7$var$_style.default)({
    prop: 'visibility'
});
const $dbcc870d9b0ed7f7$var$whiteSpace = module.exports.whiteSpace = (0, $dbcc870d9b0ed7f7$var$_style.default)({
    prop: 'whiteSpace'
});
const $dbcc870d9b0ed7f7$var$display = (0, $dbcc870d9b0ed7f7$var$_compose.default)($dbcc870d9b0ed7f7$var$displayPrint, $dbcc870d9b0ed7f7$var$displayRaw, $dbcc870d9b0ed7f7$var$overflow, $dbcc870d9b0ed7f7$var$textOverflow, $dbcc870d9b0ed7f7$var$visibility, $dbcc870d9b0ed7f7$var$whiteSpace);
var $dbcc870d9b0ed7f7$var$_default = module.exports.default = $dbcc870d9b0ed7f7$var$display;

});


parcelRegister("e3ZyG", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $a3d118b4af4772aa$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a3d118b4af4772aa$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a3d118b4af4772aa$var$_flexbox.default;
    }
});

var $a3d118b4af4772aa$var$_flexbox = $a3d118b4af4772aa$require$_interopRequireWildcard((parcelRequire("1Ox1u")));
Object.keys($a3d118b4af4772aa$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a3d118b4af4772aa$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a3d118b4af4772aa$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a3d118b4af4772aa$var$_flexbox[key];
        }
    });
});

});
parcelRegister("1Ox1u", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $152413aa13e0a395$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.order = module.exports.justifySelf = module.exports.justifyItems = module.exports.justifyContent = module.exports.flexWrap = module.exports.flexShrink = module.exports.flexGrow = module.exports.flexDirection = module.exports.flexBasis = module.exports.flex = module.exports.default = module.exports.alignSelf = module.exports.alignItems = module.exports.alignContent = void 0;

var $152413aa13e0a395$var$_style = $152413aa13e0a395$require$_interopRequireDefault((parcelRequire("bcPDg")));

var $152413aa13e0a395$var$_compose = $152413aa13e0a395$require$_interopRequireDefault((parcelRequire("8Apkm")));
const $152413aa13e0a395$var$flexBasis = module.exports.flexBasis = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'flexBasis'
});
const $152413aa13e0a395$var$flexDirection = module.exports.flexDirection = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'flexDirection'
});
const $152413aa13e0a395$var$flexWrap = module.exports.flexWrap = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'flexWrap'
});
const $152413aa13e0a395$var$justifyContent = module.exports.justifyContent = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'justifyContent'
});
const $152413aa13e0a395$var$alignItems = module.exports.alignItems = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'alignItems'
});
const $152413aa13e0a395$var$alignContent = module.exports.alignContent = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'alignContent'
});
const $152413aa13e0a395$var$order = module.exports.order = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'order'
});
const $152413aa13e0a395$var$flex = module.exports.flex = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'flex'
});
const $152413aa13e0a395$var$flexGrow = module.exports.flexGrow = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'flexGrow'
});
const $152413aa13e0a395$var$flexShrink = module.exports.flexShrink = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'flexShrink'
});
const $152413aa13e0a395$var$alignSelf = module.exports.alignSelf = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'alignSelf'
});
const $152413aa13e0a395$var$justifyItems = module.exports.justifyItems = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'justifyItems'
});
const $152413aa13e0a395$var$justifySelf = module.exports.justifySelf = (0, $152413aa13e0a395$var$_style.default)({
    prop: 'justifySelf'
});
const $152413aa13e0a395$var$flexbox = (0, $152413aa13e0a395$var$_compose.default)($152413aa13e0a395$var$flexBasis, $152413aa13e0a395$var$flexDirection, $152413aa13e0a395$var$flexWrap, $152413aa13e0a395$var$justifyContent, $152413aa13e0a395$var$alignItems, $152413aa13e0a395$var$alignContent, $152413aa13e0a395$var$order, $152413aa13e0a395$var$flex, $152413aa13e0a395$var$flexGrow, $152413aa13e0a395$var$flexShrink, $152413aa13e0a395$var$alignSelf, $152413aa13e0a395$var$justifyItems, $152413aa13e0a395$var$justifySelf);
var $152413aa13e0a395$var$_default = module.exports.default = $152413aa13e0a395$var$flexbox;

});


parcelRegister("7FnpO", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $594e8685562c89ef$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $594e8685562c89ef$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $594e8685562c89ef$var$_positions.default;
    }
});

var $594e8685562c89ef$var$_positions = $594e8685562c89ef$require$_interopRequireWildcard((parcelRequire("qCNxC")));
Object.keys($594e8685562c89ef$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($594e8685562c89ef$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $594e8685562c89ef$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $594e8685562c89ef$var$_positions[key];
        }
    });
});

});
parcelRegister("qCNxC", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $0500864eb58d7386$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zIndex = module.exports.top = module.exports.right = module.exports.position = module.exports.left = module.exports.default = module.exports.bottom = void 0;

var $0500864eb58d7386$var$_style = $0500864eb58d7386$require$_interopRequireDefault((parcelRequire("bcPDg")));

var $0500864eb58d7386$var$_compose = $0500864eb58d7386$require$_interopRequireDefault((parcelRequire("8Apkm")));
const $0500864eb58d7386$var$position = module.exports.position = (0, $0500864eb58d7386$var$_style.default)({
    prop: 'position'
});
const $0500864eb58d7386$var$zIndex = module.exports.zIndex = (0, $0500864eb58d7386$var$_style.default)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
const $0500864eb58d7386$var$top = module.exports.top = (0, $0500864eb58d7386$var$_style.default)({
    prop: 'top'
});
const $0500864eb58d7386$var$right = module.exports.right = (0, $0500864eb58d7386$var$_style.default)({
    prop: 'right'
});
const $0500864eb58d7386$var$bottom = module.exports.bottom = (0, $0500864eb58d7386$var$_style.default)({
    prop: 'bottom'
});
const $0500864eb58d7386$var$left = module.exports.left = (0, $0500864eb58d7386$var$_style.default)({
    prop: 'left'
});
const $0500864eb58d7386$var$positions = (0, $0500864eb58d7386$var$_compose.default)($0500864eb58d7386$var$position, $0500864eb58d7386$var$zIndex, $0500864eb58d7386$var$top, $0500864eb58d7386$var$right, $0500864eb58d7386$var$bottom, $0500864eb58d7386$var$left);
var $0500864eb58d7386$var$_default = module.exports.default = $0500864eb58d7386$var$positions;

});


parcelRegister("d1eMQ", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $97a6d6b58984b4e8$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $97a6d6b58984b4e8$var$_shadows.default;
    }
});

var $97a6d6b58984b4e8$var$_shadows = $97a6d6b58984b4e8$require$_interopRequireDefault((parcelRequire("epl91")));

});
parcelRegister("epl91", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $a7d3cd5a744d8771$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7d3cd5a744d8771$var$_style = $a7d3cd5a744d8771$require$_interopRequireDefault((parcelRequire("bcPDg")));
const $a7d3cd5a744d8771$var$boxShadow = (0, $a7d3cd5a744d8771$var$_style.default)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var $a7d3cd5a744d8771$var$_default = module.exports.default = $a7d3cd5a744d8771$var$boxShadow;

});


parcelRegister("bO0MO", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $8984f962c1df1b8f$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8984f962c1df1b8f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8984f962c1df1b8f$var$_typography.default;
    }
});

var $8984f962c1df1b8f$var$_typography = $8984f962c1df1b8f$require$_interopRequireWildcard((parcelRequire("8K9XZ")));
Object.keys($8984f962c1df1b8f$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($8984f962c1df1b8f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $8984f962c1df1b8f$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $8984f962c1df1b8f$var$_typography[key];
        }
    });
});

});
parcelRegister("8K9XZ", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $65da59c7cf8b299d$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typographyVariant = module.exports.textTransform = module.exports.textAlign = module.exports.lineHeight = module.exports.letterSpacing = module.exports.fontWeight = module.exports.fontStyle = module.exports.fontSize = module.exports.fontFamily = module.exports.default = void 0;

var $65da59c7cf8b299d$var$_style = $65da59c7cf8b299d$require$_interopRequireDefault((parcelRequire("bcPDg")));

var $65da59c7cf8b299d$var$_compose = $65da59c7cf8b299d$require$_interopRequireDefault((parcelRequire("8Apkm")));
const $65da59c7cf8b299d$var$fontFamily = module.exports.fontFamily = (0, $65da59c7cf8b299d$var$_style.default)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
const $65da59c7cf8b299d$var$fontSize = module.exports.fontSize = (0, $65da59c7cf8b299d$var$_style.default)({
    prop: 'fontSize',
    themeKey: 'typography'
});
const $65da59c7cf8b299d$var$fontStyle = module.exports.fontStyle = (0, $65da59c7cf8b299d$var$_style.default)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
const $65da59c7cf8b299d$var$fontWeight = module.exports.fontWeight = (0, $65da59c7cf8b299d$var$_style.default)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
const $65da59c7cf8b299d$var$letterSpacing = module.exports.letterSpacing = (0, $65da59c7cf8b299d$var$_style.default)({
    prop: 'letterSpacing'
});
const $65da59c7cf8b299d$var$textTransform = module.exports.textTransform = (0, $65da59c7cf8b299d$var$_style.default)({
    prop: 'textTransform'
});
const $65da59c7cf8b299d$var$lineHeight = module.exports.lineHeight = (0, $65da59c7cf8b299d$var$_style.default)({
    prop: 'lineHeight'
});
const $65da59c7cf8b299d$var$textAlign = module.exports.textAlign = (0, $65da59c7cf8b299d$var$_style.default)({
    prop: 'textAlign'
});
const $65da59c7cf8b299d$var$typographyVariant = module.exports.typographyVariant = (0, $65da59c7cf8b299d$var$_style.default)({
    prop: 'typography',
    cssProperty: false,
    themeKey: 'typography'
});
const $65da59c7cf8b299d$var$typography = (0, $65da59c7cf8b299d$var$_compose.default)($65da59c7cf8b299d$var$typographyVariant, $65da59c7cf8b299d$var$fontFamily, $65da59c7cf8b299d$var$fontSize, $65da59c7cf8b299d$var$fontStyle, $65da59c7cf8b299d$var$fontWeight, $65da59c7cf8b299d$var$letterSpacing, $65da59c7cf8b299d$var$lineHeight, $65da59c7cf8b299d$var$textAlign, $65da59c7cf8b299d$var$textTransform);
var $65da59c7cf8b299d$var$_default = module.exports.default = $65da59c7cf8b299d$var$typography;

});


parcelRegister("4aNvf", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $309e7ee00f34c5a5$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $309e7ee00f34c5a5$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $309e7ee00f34c5a5$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $309e7ee00f34c5a5$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $309e7ee00f34c5a5$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $309e7ee00f34c5a5$var$_defaultSxConfig.default;
    }
});

var $309e7ee00f34c5a5$var$_styleFunctionSx = $309e7ee00f34c5a5$require$_interopRequireWildcard((parcelRequire("huozX")));

var $309e7ee00f34c5a5$var$_extendSxProp = $309e7ee00f34c5a5$require$_interopRequireDefault((parcelRequire("1C7uR")));

var $309e7ee00f34c5a5$var$_defaultSxConfig = $309e7ee00f34c5a5$require$_interopRequireDefault((parcelRequire("iHU64")));

});
parcelRegister("1C7uR", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $12cf27be1b4d1044$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $12cf27be1b4d1044$var$extendSxProp;

var $4qPjz = parcelRequire("4qPjz");

var $12cf27be1b4d1044$var$_defaultSxConfig = $12cf27be1b4d1044$require$_interopRequireDefault((parcelRequire("iHU64")));
const $12cf27be1b4d1044$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $12cf27be1b4d1044$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $12cf27be1b4d1044$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $12cf27be1b4d1044$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $4qPjz.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("7uEz0", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $574accd9716efac2$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $574accd9716efac2$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $574accd9716efac2$var$_getThemeValue.default;
    }
});

var $574accd9716efac2$var$_getThemeValue = $574accd9716efac2$require$_interopRequireWildcard((parcelRequire("5Glii")));
Object.keys($574accd9716efac2$var$_getThemeValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($574accd9716efac2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $574accd9716efac2$var$_getThemeValue[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $574accd9716efac2$var$_getThemeValue[key];
        }
    });
});

});
parcelRegister("5Glii", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $423164912f422ea3$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.styleFunctionMapping = module.exports.propToStyleFunction = module.exports.default = void 0;

var $423164912f422ea3$var$_borders = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("dwAab")));

var $423164912f422ea3$var$_display = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("hua2v")));

var $423164912f422ea3$var$_flexbox = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("e3ZyG")));

var $423164912f422ea3$var$_cssGrid = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("iXSgY")));

var $423164912f422ea3$var$_positions = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("7FnpO")));

var $423164912f422ea3$var$_palette = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("6OuH1")));

var $423164912f422ea3$var$_shadows = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("d1eMQ")));

var $423164912f422ea3$var$_sizing = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("hrmPC")));

var $423164912f422ea3$var$_spacing = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("4b2XU")));

var $423164912f422ea3$var$_typography = $423164912f422ea3$require$_interopRequireDefault((parcelRequire("bO0MO")));
/** @internal */ const $423164912f422ea3$var$styleFunctionMapping = module.exports.styleFunctionMapping = {
    borders: $423164912f422ea3$var$_borders.default,
    display: $423164912f422ea3$var$_display.default,
    flexbox: $423164912f422ea3$var$_flexbox.default,
    grid: $423164912f422ea3$var$_cssGrid.default,
    positions: $423164912f422ea3$var$_positions.default,
    palette: $423164912f422ea3$var$_palette.default,
    shadows: $423164912f422ea3$var$_shadows.default,
    sizing: $423164912f422ea3$var$_sizing.default,
    spacing: $423164912f422ea3$var$_spacing.default,
    typography: $423164912f422ea3$var$_typography.default
};
/** @internal */ const $423164912f422ea3$var$propToStyleFunction = module.exports.propToStyleFunction = Object.keys($423164912f422ea3$var$styleFunctionMapping).reduce((acc, styleFnName)=>{
    const styleFunction = $423164912f422ea3$var$styleFunctionMapping[styleFnName];
    for (const propName of styleFunction.filterProps)acc[propName] = styleFunction;
    return acc;
}, {});
function $423164912f422ea3$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $423164912f422ea3$var$propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $423164912f422ea3$var$_default = module.exports.default = $423164912f422ea3$var$getThemeValue;

});


parcelRegister("5YgRw", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $458fa2d48a7f4335$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $458fa2d48a7f4335$var$_exportNames = {
    boxClasses: true
};
Object.defineProperty(module.exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return $458fa2d48a7f4335$var$_boxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $458fa2d48a7f4335$var$_Box.default;
    }
});

var $458fa2d48a7f4335$var$_Box = $458fa2d48a7f4335$require$_interopRequireWildcard((parcelRequire("cNcUQ")));
Object.keys($458fa2d48a7f4335$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($458fa2d48a7f4335$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $458fa2d48a7f4335$var$_Box[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $458fa2d48a7f4335$var$_Box[key];
        }
    });
});

var $458fa2d48a7f4335$var$_boxClasses = $458fa2d48a7f4335$require$_interopRequireWildcard((parcelRequire("18KSj")));
Object.keys($458fa2d48a7f4335$var$_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($458fa2d48a7f4335$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $458fa2d48a7f4335$var$_boxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $458fa2d48a7f4335$var$_boxClasses[key];
        }
    });
});

});
parcelRegister("cNcUQ", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $9504147b75bae0e4$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9504147b75bae0e4$var$_propTypes = $9504147b75bae0e4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $9504147b75bae0e4$var$_ClassNameGenerator = $9504147b75bae0e4$require$_interopRequireDefault((parcelRequire("49mvc")));

var $9504147b75bae0e4$var$_createBox = $9504147b75bae0e4$require$_interopRequireDefault((parcelRequire("hiswr")));

var $9504147b75bae0e4$var$_boxClasses = $9504147b75bae0e4$require$_interopRequireDefault((parcelRequire("18KSj")));
// The SimpleSystemKeys are subset of the AllSystemCSSProperties, so this should be ok
// This is needed as these are used as keys inside AllSystemCSSProperties
/**
 *
 * Demos:
 *
 * - [Box (Material UI)](https://mui.com/material-ui/react-box/)
 * - [Menubar (Material UI)](https://mui.com/material-ui/react-menubar/)
 * - [Box (MUI System)](https://mui.com/system/react-box/)
 *
 * API:
 *
 * - [Box API](https://mui.com/system/api/box/)
 */ const $9504147b75bae0e4$var$Box = (0, $9504147b75bae0e4$var$_createBox.default)({
    defaultClassName: $9504147b75bae0e4$var$_boxClasses.default.root,
    generateClassName: $9504147b75bae0e4$var$_ClassNameGenerator.default.generate
});
var $9504147b75bae0e4$var$_default = module.exports.default = $9504147b75bae0e4$var$Box;

});
parcelRegister("49mvc", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $3059752391c9cbda$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3059752391c9cbda$var$_ClassNameGenerator.default;
    }
});

var $3059752391c9cbda$var$_ClassNameGenerator = $3059752391c9cbda$require$_interopRequireDefault((parcelRequire("jDUdj")));

});
parcelRegister("jDUdj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $e4cd43b4f1024a60$var$defaultGenerator = (componentName)=>componentName;
const $e4cd43b4f1024a60$var$createClassNameGenerator = ()=>{
    let generate = $e4cd43b4f1024a60$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $e4cd43b4f1024a60$var$defaultGenerator;
        }
    };
};
const $e4cd43b4f1024a60$var$ClassNameGenerator = $e4cd43b4f1024a60$var$createClassNameGenerator();
var $e4cd43b4f1024a60$var$_default = module.exports.default = $e4cd43b4f1024a60$var$ClassNameGenerator;

});


parcelRegister("hiswr", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $c97a3e0cc3860b4e$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c97a3e0cc3860b4e$var$_createBox.default;
    }
});

var $c97a3e0cc3860b4e$var$_createBox = $c97a3e0cc3860b4e$require$_interopRequireDefault((parcelRequire("1AMNX")));

});
parcelRegister("1AMNX", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $128f02dd2873d716$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $128f02dd2873d716$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $128f02dd2873d716$var$createBox;

var $128f02dd2873d716$var$React = $128f02dd2873d716$require$_interopRequireWildcard((parcelRequire("acw62")));

var $128f02dd2873d716$var$_clsx = $128f02dd2873d716$require$_interopRequireDefault((parcelRequire("i6kju")));

var $128f02dd2873d716$var$_styledEngine = $128f02dd2873d716$require$_interopRequireDefault((parcelRequire("ivxDX")));

var $128f02dd2873d716$var$_styleFunctionSx = $128f02dd2873d716$require$_interopRequireDefault((parcelRequire("4aNvf")));

var $128f02dd2873d716$var$_useTheme = $128f02dd2873d716$require$_interopRequireDefault((parcelRequire("dWz7R")));

var $ayMG0 = parcelRequire("ayMG0");
function $128f02dd2873d716$var$createBox(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $128f02dd2873d716$var$_styledEngine.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })($128f02dd2873d716$var$_styleFunctionSx.default);
    const Box = /*#__PURE__*/ $128f02dd2873d716$var$React.forwardRef(function Box(inProps, ref) {
        const theme = (0, $128f02dd2873d716$var$_useTheme.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = inProps;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $128f02dd2873d716$var$_clsx.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});


parcelRegister("18KSj", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $0d4ae636875c02f6$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d4ae636875c02f6$var$_generateUtilityClasses = $0d4ae636875c02f6$require$_interopRequireDefault((parcelRequire("lzSOZ")));
const $0d4ae636875c02f6$var$boxClasses = (0, $0d4ae636875c02f6$var$_generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var $0d4ae636875c02f6$var$_default = module.exports.default = $0d4ae636875c02f6$var$boxClasses;

});
parcelRegister("lzSOZ", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $fb5764453e8ab66e$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fb5764453e8ab66e$var$_generateUtilityClasses.default;
    }
});

var $fb5764453e8ab66e$var$_generateUtilityClasses = $fb5764453e8ab66e$require$_interopRequireDefault((parcelRequire("aXBoe")));

});
parcelRegister("aXBoe", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $7fac6aee24a32326$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7fac6aee24a32326$var$generateUtilityClasses;

var $7fac6aee24a32326$var$_generateUtilityClass = $7fac6aee24a32326$require$_interopRequireDefault((parcelRequire("7vfNl")));
function $7fac6aee24a32326$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $7fac6aee24a32326$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("7vfNl", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $5767ae3282a81fab$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5767ae3282a81fab$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5767ae3282a81fab$var$_generateUtilityClass.default;
    }
});

var $5767ae3282a81fab$var$_generateUtilityClass = $5767ae3282a81fab$require$_interopRequireWildcard((parcelRequire("hOTH8")));
Object.keys($5767ae3282a81fab$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5767ae3282a81fab$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5767ae3282a81fab$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5767ae3282a81fab$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("hOTH8", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $cf924f023e9b8553$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cf924f023e9b8553$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $cf924f023e9b8553$var$isGlobalState;

var $cf924f023e9b8553$var$_ClassNameGenerator = $cf924f023e9b8553$require$_interopRequireDefault((parcelRequire("49mvc")));
const $cf924f023e9b8553$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $cf924f023e9b8553$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $cf924f023e9b8553$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$cf924f023e9b8553$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $cf924f023e9b8553$var$isGlobalState(slot) {
    return $cf924f023e9b8553$var$globalStateClasses[slot] !== undefined;
}

});







parcelRegister("76hie", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $52b681fc2c38461d$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $52b681fc2c38461d$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $52b681fc2c38461d$var$_createStyled.default;
    }
});

var $52b681fc2c38461d$var$_createStyled = $52b681fc2c38461d$require$_interopRequireWildcard((parcelRequire("irlvC")));
Object.keys($52b681fc2c38461d$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($52b681fc2c38461d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $52b681fc2c38461d$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $52b681fc2c38461d$var$_createStyled[key];
        }
    });
});

});
parcelRegister("irlvC", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $d6cb6ed53d748500$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $d6cb6ed53d748500$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6cb6ed53d748500$var$createStyled;
module.exports.shouldForwardProp = $d6cb6ed53d748500$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $d6cb6ed53d748500$var$_styledEngine = $d6cb6ed53d748500$require$_interopRequireWildcard((parcelRequire("ivxDX")));

var $d6cb6ed53d748500$var$_isObjectEmpty = $d6cb6ed53d748500$require$_interopRequireDefault((parcelRequire("aDaYU")));

var $4qPjz = parcelRequire("4qPjz");

var $d6cb6ed53d748500$var$_capitalize = $d6cb6ed53d748500$require$_interopRequireDefault((parcelRequire("jV5Vu")));

var $d6cb6ed53d748500$var$_getDisplayName = $d6cb6ed53d748500$require$_interopRequireDefault((parcelRequire("9zYF3")));

var $d6cb6ed53d748500$var$_createTheme = $d6cb6ed53d748500$require$_interopRequireDefault((parcelRequire("hDEnZ")));

var $d6cb6ed53d748500$var$_styleFunctionSx = $d6cb6ed53d748500$require$_interopRequireDefault((parcelRequire("4aNvf")));

var $d6cb6ed53d748500$var$_preprocessStyles = $d6cb6ed53d748500$require$_interopRequireDefault((parcelRequire("2FzE6")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $d6cb6ed53d748500$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $d6cb6ed53d748500$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $d6cb6ed53d748500$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $d6cb6ed53d748500$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $d6cb6ed53d748500$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $d6cb6ed53d748500$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = (0, $d6cb6ed53d748500$var$_isObjectEmpty.default)(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $d6cb6ed53d748500$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$d6cb6ed53d748500$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $d6cb6ed53d748500$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $d6cb6ed53d748500$var$shallowLayer((0, $d6cb6ed53d748500$var$_styledEngine.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $d6cb6ed53d748500$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $d6cb6ed53d748500$var$shallowLayer((0, $d6cb6ed53d748500$var$_styledEngine.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $d6cb6ed53d748500$var$shallowLayer((0, $d6cb6ed53d748500$var$_styledEngine.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $d6cb6ed53d748500$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(layerName ? $d6cb6ed53d748500$var$shallowLayer((0, $d6cb6ed53d748500$var$_styledEngine.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $d6cb6ed53d748500$var$shallowLayer((0, $d6cb6ed53d748500$var$_styledEngine.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $d6cb6ed53d748500$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $d6cb6ed53d748500$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $d6cb6ed53d748500$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $d6cb6ed53d748500$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $d6cb6ed53d748500$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $d6cb6ed53d748500$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $d6cb6ed53d748500$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $d6cb6ed53d748500$var$defaultOverridesResolver($d6cb6ed53d748500$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $d6cb6ed53d748500$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($d6cb6ed53d748500$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $d6cb6ed53d748500$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $d6cb6ed53d748500$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $d6cb6ed53d748500$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $4qPjz.isPlainObject)(style)) {
                const serialized = (0, $d6cb6ed53d748500$var$_preprocessStyles.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $d6cb6ed53d748500$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $d6cb6ed53d748500$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $d6cb6ed53d748500$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $d6cb6ed53d748500$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push($d6cb6ed53d748500$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $d6cb6ed53d748500$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $d6cb6ed53d748500$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $d6cb6ed53d748500$var$_getDisplayName.default)(tag)})`;
}
function $d6cb6ed53d748500$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $d6cb6ed53d748500$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $d6cb6ed53d748500$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("9zYF3", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $6f966ff65a592ee9$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6f966ff65a592ee9$var$_getDisplayName.default;
    }
});

var $6f966ff65a592ee9$var$_getDisplayName = $6f966ff65a592ee9$require$_interopRequireDefault((parcelRequire("eU4FW")));

});
parcelRegister("eU4FW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad99ec1be035b9d4$var$getDisplayName;

var $kD5jZ = parcelRequire("kD5jZ");
function $ad99ec1be035b9d4$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $ad99ec1be035b9d4$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ad99ec1be035b9d4$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/react/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $ad99ec1be035b9d4$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ad99ec1be035b9d4$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $kD5jZ.ForwardRef:
            return $ad99ec1be035b9d4$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $kD5jZ.Memo:
            return $ad99ec1be035b9d4$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("2FzE6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f1b0f9fc845dd7f$var$preprocessStyles;

var $ivxDX = parcelRequire("ivxDX");
function $1f1b0f9fc845dd7f$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $ivxDX.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $ivxDX.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("8e6g8", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $5fd47c7d23f57530$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5fd47c7d23f57530$var$_styled.default;
    }
});

var $5fd47c7d23f57530$var$_styled = $5fd47c7d23f57530$require$_interopRequireDefault((parcelRequire("hDuHk")));

});
parcelRegister("hDuHk", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $cd6de41e98cd425f$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cd6de41e98cd425f$var$_createStyled = $cd6de41e98cd425f$require$_interopRequireDefault((parcelRequire("76hie")));
const $cd6de41e98cd425f$var$styled = (0, $cd6de41e98cd425f$var$_createStyled.default)();
var $cd6de41e98cd425f$var$_default = module.exports.default = $cd6de41e98cd425f$var$styled;

});


parcelRegister("jmjKP", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $e17f65311b8f8a1c$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e17f65311b8f8a1c$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $e17f65311b8f8a1c$var$_getThemeProps.default;
    }
});

var $e17f65311b8f8a1c$var$_useThemeProps = $e17f65311b8f8a1c$require$_interopRequireDefault((parcelRequire("it1Gx")));

var $e17f65311b8f8a1c$var$_getThemeProps = $e17f65311b8f8a1c$require$_interopRequireDefault((parcelRequire("8Srrx")));

});
parcelRegister("it1Gx", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $d71c3e07c55566a2$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d71c3e07c55566a2$var$useThemeProps;

var $d71c3e07c55566a2$var$_getThemeProps = $d71c3e07c55566a2$require$_interopRequireDefault((parcelRequire("8Srrx")));

var $d71c3e07c55566a2$var$_useTheme = $d71c3e07c55566a2$require$_interopRequireDefault((parcelRequire("dWz7R")));
function $d71c3e07c55566a2$var$useThemeProps(params) {
    const { props: props, name: name, defaultTheme: defaultTheme, themeId: themeId } = params;
    let theme = (0, $d71c3e07c55566a2$var$_useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $d71c3e07c55566a2$var$_getThemeProps.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("8Srrx", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $6768a7858d2d37ec$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6768a7858d2d37ec$var$getThemeProps;

var $6768a7858d2d37ec$var$_resolveProps = $6768a7858d2d37ec$require$_interopRequireDefault((parcelRequire("8TlsZ")));
function $6768a7858d2d37ec$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $6768a7858d2d37ec$var$_resolveProps.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("8TlsZ", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $67941c94869a6704$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $67941c94869a6704$var$_resolveProps.default;
    }
});

var $67941c94869a6704$var$_resolveProps = $67941c94869a6704$require$_interopRequireDefault((parcelRequire("ll8HN")));

});
parcelRegister("ll8HN", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $f8924fd936cb090b$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8924fd936cb090b$var$resolveProps;

var $f8924fd936cb090b$var$_clsx = $f8924fd936cb090b$require$_interopRequireDefault((parcelRequire("i6kju")));
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @param mergeClassNameAndStyle If `true`, merges `className` and `style` props instead of overriding them.
 *   When `false` (default), props override defaultProps. When `true`, `className` values are concatenated
 *   and `style` objects are merged with props taking precedence.
 * @returns resolved props
 */ function $f8924fd936cb090b$var$resolveProps(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    const defaultSlotPropValue = defaultSlotProps[slotPropName];
                    const slotPropValue = slotProps[slotPropName];
                    if (typeof defaultSlotPropValue === 'function' || typeof slotPropValue === 'function') // Function slot props are resolved later (with `ownerState`), so defer
                    // the merge until then to avoid dropping either side.
                    output[propName][slotPropName] = (...args)=>$f8924fd936cb090b$var$resolveProps((typeof defaultSlotPropValue === 'function' ? defaultSlotPropValue(...args) : defaultSlotPropValue) ?? {}, (typeof slotPropValue === 'function' ? slotPropValue(...args) : slotPropValue) ?? {}, mergeClassNameAndStyle);
                    else output[propName][slotPropName] = $f8924fd936cb090b$var$resolveProps(defaultSlotPropValue ?? {}, slotPropValue ?? {}, mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className !== undefined) output.className = (0, $f8924fd936cb090b$var$_clsx.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});





parcelRegister("jFDsv", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $e5207452765f82b5$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e5207452765f82b5$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e5207452765f82b5$var$_useMediaQuery.default;
    }
});

var $e5207452765f82b5$var$_useMediaQuery = $e5207452765f82b5$require$_interopRequireWildcard((parcelRequire("i54pt")));
Object.keys($e5207452765f82b5$var$_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e5207452765f82b5$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e5207452765f82b5$var$_useMediaQuery[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e5207452765f82b5$var$_useMediaQuery[key];
        }
    });
});

});
parcelRegister("i54pt", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $d29c1d59a526ee3a$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $d29c1d59a526ee3a$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createUseMediaQuery = $d29c1d59a526ee3a$var$unstable_createUseMediaQuery;

var $d29c1d59a526ee3a$var$React = $d29c1d59a526ee3a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d29c1d59a526ee3a$var$_useEnhancedEffect = $d29c1d59a526ee3a$require$_interopRequireDefault((parcelRequire("eGC44")));

var $jmjKP = parcelRequire("jmjKP");

var $d29c1d59a526ee3a$var$_useThemeWithoutDefault = $d29c1d59a526ee3a$require$_interopRequireDefault((parcelRequire("3pEz9")));
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $d29c1d59a526ee3a$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $d29c1d59a526ee3a$var$React.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $d29c1d59a526ee3a$var$_useEnhancedEffect.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $d29c1d59a526ee3a$var$safeReact = {
    ...$d29c1d59a526ee3a$var$React
};
const $d29c1d59a526ee3a$var$maybeReactUseSyncExternalStore = $d29c1d59a526ee3a$var$safeReact.useSyncExternalStore;
function $d29c1d59a526ee3a$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $d29c1d59a526ee3a$var$React.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $d29c1d59a526ee3a$var$React.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $d29c1d59a526ee3a$var$React.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $d29c1d59a526ee3a$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $d29c1d59a526ee3a$var$unstable_createUseMediaQuery(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $d29c1d59a526ee3a$var$_useThemeWithoutDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const fallbackMatchMedia = supportMatchMedia ? window.matchMedia : null;
        const { defaultMatches: defaultMatches = false, matchMedia: customMatchMedia, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $jmjKP.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        const matchMedia = $d29c1d59a526ee3a$var$React.useMemo(()=>{
            if (customMatchMedia !== undefined) return customMatchMedia;
            if (fallbackMatchMedia === null) return null;
            return fallbackMatchMedia.bind(window);
        }, [
            customMatchMedia,
            fallbackMatchMedia
        ]);
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $d29c1d59a526ee3a$var$maybeReactUseSyncExternalStore !== undefined ? $d29c1d59a526ee3a$var$useMediaQueryNew : $d29c1d59a526ee3a$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $d29c1d59a526ee3a$var$useMediaQuery = $d29c1d59a526ee3a$var$unstable_createUseMediaQuery();
var $d29c1d59a526ee3a$var$_default = module.exports.default = $d29c1d59a526ee3a$var$useMediaQuery;

});
parcelRegister("eGC44", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $ab1283c79a3376a6$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ab1283c79a3376a6$var$_useEnhancedEffect.default;
    }
});

var $ab1283c79a3376a6$var$_useEnhancedEffect = $ab1283c79a3376a6$require$_interopRequireDefault((parcelRequire("64jr7")));

});
parcelRegister("64jr7", function(module, exports) {
"use strict";
'use client';

var $PT5lT = parcelRequire("PT5lT");
var $46b2317a412ca650$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46b2317a412ca650$var$React = $46b2317a412ca650$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $46b2317a412ca650$var$useEnhancedEffect = typeof window !== 'undefined' ? $46b2317a412ca650$var$React.useLayoutEffect : $46b2317a412ca650$var$React.useEffect;
var $46b2317a412ca650$var$_default = module.exports.default = $46b2317a412ca650$var$useEnhancedEffect;

});




parcelRegister("bH02A", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $8833bdf6db08e686$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $8833bdf6db08e686$var$_clamp.default;
    }
});

var $8833bdf6db08e686$var$_clamp = $8833bdf6db08e686$require$_interopRequireDefault((parcelRequire("dUsbk")));

});
parcelRegister("dUsbk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $a2065d9f8bb64e71$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $a2065d9f8bb64e71$var$_default = module.exports.default = $a2065d9f8bb64e71$var$clamp;

});


parcelRegister("bingO", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $83936d22d358d554$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $83936d22d358d554$var$_ThemeProvider.default;
    }
});

var $83936d22d358d554$var$_ThemeProvider = $83936d22d358d554$require$_interopRequireDefault((parcelRequire("hlkbo")));

});
parcelRegister("hlkbo", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $ca040db23917b182$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $ca040db23917b182$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca040db23917b182$var$React = $ca040db23917b182$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ca040db23917b182$var$_propTypes = $ca040db23917b182$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $k0KhS = parcelRequire("k0KhS");

var $ca040db23917b182$var$_exactProp = $ca040db23917b182$require$_interopRequireDefault((parcelRequire("7JgOv")));

var $ivxDX = parcelRequire("ivxDX");

var $ca040db23917b182$var$_useThemeWithoutDefault = $ca040db23917b182$require$_interopRequireDefault((parcelRequire("3pEz9")));

var $ca040db23917b182$var$_RtlProvider = $ca040db23917b182$require$_interopRequireDefault((parcelRequire("i9sFE")));

var $ca040db23917b182$var$_DefaultPropsProvider = $ca040db23917b182$require$_interopRequireDefault((parcelRequire("7ww0G")));

var $ca040db23917b182$var$_useLayerOrder = $ca040db23917b182$require$_interopRequireDefault((parcelRequire("3d7la")));

var $ayMG0 = parcelRequire("ayMG0");
const $ca040db23917b182$var$EMPTY_THEME = {};
function $ca040db23917b182$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $ca040db23917b182$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $ca040db23917b182$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $ca040db23917b182$var$_useThemeWithoutDefault.default)($ca040db23917b182$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $k0KhS.useTheme)() || $ca040db23917b182$var$EMPTY_THEME;
    const engineTheme = $ca040db23917b182$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $ca040db23917b182$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $ca040db23917b182$var$_useLayerOrder.default)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($k0KhS.ThemeProvider, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($ivxDX.ThemeContext.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($ca040db23917b182$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($ca040db23917b182$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $ca040db23917b182$var$_default = module.exports.default = $ca040db23917b182$var$ThemeProvider;

});
parcelRegister("k0KhS", function(module, exports) {
/**
 * @mui/private-theming v9.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $e917b670761c2671$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $e917b670761c2671$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e917b670761c2671$var$_exportNames = {
    ThemeProvider: true,
    useTheme: true
};
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $e917b670761c2671$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $e917b670761c2671$var$_useTheme.default;
    }
});

var $e917b670761c2671$var$_ThemeProvider = $e917b670761c2671$require$_interopRequireWildcard((parcelRequire("6LMFr")));
Object.keys($e917b670761c2671$var$_ThemeProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e917b670761c2671$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e917b670761c2671$var$_ThemeProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e917b670761c2671$var$_ThemeProvider[key];
        }
    });
});

var $e917b670761c2671$var$_useTheme = $e917b670761c2671$require$_interopRequireDefault((parcelRequire("3hMlg")));

});
parcelRegister("6LMFr", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $4edce2364a1b5503$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4edce2364a1b5503$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_nested", {
    enumerable: true,
    get: function() {
        return $4edce2364a1b5503$var$_nested.default;
    }
});

var $4edce2364a1b5503$var$_ThemeProvider = $4edce2364a1b5503$require$_interopRequireDefault((parcelRequire("g7iLQ")));

var $4edce2364a1b5503$var$_nested = $4edce2364a1b5503$require$_interopRequireDefault((parcelRequire("dBVuT")));

});
parcelRegister("g7iLQ", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $bbbbdc40071da306$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $bbbbdc40071da306$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbbbdc40071da306$var$React = $bbbbdc40071da306$require$_interopRequireWildcard((parcelRequire("acw62")));

var $bbbbdc40071da306$var$_propTypes = $bbbbdc40071da306$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bbbbdc40071da306$var$_exactProp = $bbbbdc40071da306$require$_interopRequireDefault((parcelRequire("7JgOv")));

var $bbbbdc40071da306$var$_ThemeContext = $bbbbdc40071da306$require$_interopRequireDefault((parcelRequire("cfNHo")));

var $bbbbdc40071da306$var$_useTheme = $bbbbdc40071da306$require$_interopRequireDefault((parcelRequire("3hMlg")));

var $bbbbdc40071da306$var$_nested = $bbbbdc40071da306$require$_interopRequireDefault((parcelRequire("dBVuT")));

var $ayMG0 = parcelRequire("ayMG0");
// To support composition of theme.
function $bbbbdc40071da306$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $bbbbdc40071da306$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $bbbbdc40071da306$var$_useTheme.default)();
    const theme = $bbbbdc40071da306$var$React.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $bbbbdc40071da306$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[$bbbbdc40071da306$var$_nested.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($bbbbdc40071da306$var$_ThemeContext.default.Provider, {
        value: theme,
        children: children
    });
}
var $bbbbdc40071da306$var$_default = module.exports.default = $bbbbdc40071da306$var$ThemeProvider;

});
parcelRegister("7JgOv", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $5a09c73337843af5$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5a09c73337843af5$var$_exactProp.default;
    }
});

var $5a09c73337843af5$var$_exactProp = $5a09c73337843af5$require$_interopRequireDefault((parcelRequire("dz5UV")));

});
parcelRegister("dz5UV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e032246a2244ff2$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $9e032246a2244ff2$var$specialProperty = 'exact-prop: \u200b';
function $9e032246a2244ff2$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("cfNHo", function(module, exports) {
"use strict";
'use client';

var $PT5lT = parcelRequire("PT5lT");
var $8ebd6fe7fe0ce913$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ebd6fe7fe0ce913$var$React = $8ebd6fe7fe0ce913$require$_interopRequireWildcard((parcelRequire("acw62")));
const $8ebd6fe7fe0ce913$var$ThemeContext = /*#__PURE__*/ $8ebd6fe7fe0ce913$var$React.createContext(null);
var $8ebd6fe7fe0ce913$var$_default = module.exports.default = $8ebd6fe7fe0ce913$var$ThemeContext;

});

parcelRegister("3hMlg", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $264875577be0aa52$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $264875577be0aa52$var$_useTheme.default;
    }
});

var $264875577be0aa52$var$_useTheme = $264875577be0aa52$require$_interopRequireDefault((parcelRequire("9Z4ec")));

});
parcelRegister("9Z4ec", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $744d1722e788beda$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $744d1722e788beda$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $744d1722e788beda$var$useTheme;

var $744d1722e788beda$var$React = $744d1722e788beda$require$_interopRequireWildcard((parcelRequire("acw62")));

var $744d1722e788beda$var$_ThemeContext = $744d1722e788beda$require$_interopRequireDefault((parcelRequire("cfNHo")));
function $744d1722e788beda$var$useTheme() {
    const theme = $744d1722e788beda$var$React.useContext($744d1722e788beda$var$_ThemeContext.default);
    return theme;
}

});


parcelRegister("dBVuT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $9e8b54d533fc2d9c$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $9e8b54d533fc2d9c$var$_default = module.exports.default = $9e8b54d533fc2d9c$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});




parcelRegister("i9sFE", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $d36f4ea9c888c503$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $d36f4ea9c888c503$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $d36f4ea9c888c503$var$React = $d36f4ea9c888c503$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d36f4ea9c888c503$var$_propTypes = $d36f4ea9c888c503$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ayMG0 = parcelRequire("ayMG0");
const $d36f4ea9c888c503$var$RtlContext = /*#__PURE__*/ $d36f4ea9c888c503$var$React.createContext(undefined);
function $d36f4ea9c888c503$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($d36f4ea9c888c503$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $d36f4ea9c888c503$var$useRtl = ()=>{
    const value = $d36f4ea9c888c503$var$React.useContext($d36f4ea9c888c503$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $d36f4ea9c888c503$var$useRtl;
var $d36f4ea9c888c503$var$_default = module.exports.default = $d36f4ea9c888c503$var$RtlProvider;

});

parcelRegister("7ww0G", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $57a45a114c1004e7$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $57a45a114c1004e7$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $57a45a114c1004e7$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $57a45a114c1004e7$var$_DefaultPropsProvider = $57a45a114c1004e7$require$_interopRequireWildcard((parcelRequire("egUdc")));

});
parcelRegister("egUdc", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $a63e29ce34f1fbd2$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $a63e29ce34f1fbd2$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $a63e29ce34f1fbd2$var$useDefaultProps;

var $a63e29ce34f1fbd2$var$React = $a63e29ce34f1fbd2$require$_interopRequireWildcard((parcelRequire("acw62")));

var $a63e29ce34f1fbd2$var$_propTypes = $a63e29ce34f1fbd2$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $a63e29ce34f1fbd2$var$_resolveProps = $a63e29ce34f1fbd2$require$_interopRequireDefault((parcelRequire("8TlsZ")));

var $ayMG0 = parcelRequire("ayMG0");
const $a63e29ce34f1fbd2$var$PropsContext = /*#__PURE__*/ $a63e29ce34f1fbd2$var$React.createContext(undefined);
function $a63e29ce34f1fbd2$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a63e29ce34f1fbd2$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $a63e29ce34f1fbd2$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $a63e29ce34f1fbd2$var$_resolveProps.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $a63e29ce34f1fbd2$var$_resolveProps.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $a63e29ce34f1fbd2$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $a63e29ce34f1fbd2$var$React.useContext($a63e29ce34f1fbd2$var$PropsContext);
    return $a63e29ce34f1fbd2$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $a63e29ce34f1fbd2$var$_default = module.exports.default = $a63e29ce34f1fbd2$var$DefaultPropsProvider;

});


parcelRegister("3d7la", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $256847a6984b3e2a$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $256847a6984b3e2a$var$useLayerOrder;

var $256847a6984b3e2a$var$_useEnhancedEffect = $256847a6984b3e2a$require$_interopRequireDefault((parcelRequire("eGC44")));

var $256847a6984b3e2a$var$_useId = $256847a6984b3e2a$require$_interopRequireDefault((parcelRequire("dzeHu")));

var $256847a6984b3e2a$var$_GlobalStyles = $256847a6984b3e2a$require$_interopRequireDefault((parcelRequire("f47HC")));

var $256847a6984b3e2a$var$_useThemeWithoutDefault = $256847a6984b3e2a$require$_interopRequireDefault((parcelRequire("3pEz9")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */ function $256847a6984b3e2a$var$useLayerOrder(theme) {
    const upperTheme = (0, $256847a6984b3e2a$var$_useThemeWithoutDefault.default)();
    const id = (0, $256847a6984b3e2a$var$_useId.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $256847a6984b3e2a$var$_useEnhancedEffect.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($256847a6984b3e2a$var$_GlobalStyles.default, {
        styles: layerOrder
    });
}

});
parcelRegister("dzeHu", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $9e09f2788e52259c$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9e09f2788e52259c$var$_useId.default;
    }
});

var $9e09f2788e52259c$var$_useId = $9e09f2788e52259c$require$_interopRequireDefault((parcelRequire("69UDq")));

});
parcelRegister("69UDq", function(module, exports) {
"use strict";
'use client';

var $PT5lT = parcelRequire("PT5lT");
var $0128400fe0454ecd$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0128400fe0454ecd$var$useId;

var $0128400fe0454ecd$var$React = $0128400fe0454ecd$require$_interopRequireWildcard((parcelRequire("acw62")));
let $0128400fe0454ecd$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $0128400fe0454ecd$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $0128400fe0454ecd$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $0128400fe0454ecd$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $0128400fe0454ecd$var$globalId += 1;
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setDefaultId(`mui-${$0128400fe0454ecd$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $0128400fe0454ecd$var$safeReact = {
    ...$0128400fe0454ecd$var$React
};
const $0128400fe0454ecd$var$maybeReactUseId = $0128400fe0454ecd$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $0128400fe0454ecd$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($0128400fe0454ecd$var$maybeReactUseId !== undefined) {
        const reactId = $0128400fe0454ecd$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $0128400fe0454ecd$var$useGlobalId(idOverride);
}

});





parcelRegister("k9mt6", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $eab613adb18c0a2a$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $eab613adb18c0a2a$var$unstable_memoTheme;

var $eab613adb18c0a2a$var$_preprocessStyles = $eab613adb18c0a2a$require$_interopRequireDefault((parcelRequire("2FzE6")));
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $eab613adb18c0a2a$var$arg = {
    theme: undefined
};
/**
 * Memoize style function on theme.
 * Intended to be used in styled() calls that only need access to the theme.
 */ function $eab613adb18c0a2a$var$unstable_memoTheme(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $eab613adb18c0a2a$var$arg.theme = props.theme;
            value = (0, $eab613adb18c0a2a$var$_preprocessStyles.default)(styleFn($eab613adb18c0a2a$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});

parcelRegister("9AcZB", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $6fa18ded83b359b0$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $6fa18ded83b359b0$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $6fa18ded83b359b0$var$createCssVarsProvider;

var $6fa18ded83b359b0$var$React = $6fa18ded83b359b0$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6fa18ded83b359b0$var$_propTypes = $6fa18ded83b359b0$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ivxDX = parcelRequire("ivxDX");

var $k0KhS = parcelRequire("k0KhS");

var $6fa18ded83b359b0$var$_useEnhancedEffect = $6fa18ded83b359b0$require$_interopRequireDefault((parcelRequire("eGC44")));

var $6fa18ded83b359b0$var$_ThemeProvider = $6fa18ded83b359b0$require$_interopRequireDefault((parcelRequire("bingO")));

var $8lNbR = parcelRequire("8lNbR");

var $6fa18ded83b359b0$var$_useCurrentColorScheme = $6fa18ded83b359b0$require$_interopRequireDefault((parcelRequire("cV43s")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @internal
 */ const $6fa18ded83b359b0$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $6fa18ded83b359b0$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $8lNbR.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $8lNbR.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $6fa18ded83b359b0$var$React.createContext(undefined);
    const useColorScheme = ()=>$6fa18ded83b359b0$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $6fa18ded83b359b0$var$React.useRef(false);
        const upperTheme = (0, $k0KhS.useTheme)();
        const ctx = $6fa18ded83b359b0$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $6fa18ded83b359b0$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $6fa18ded83b359b0$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $6fa18ded83b359b0$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $6fa18ded83b359b0$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $6fa18ded83b359b0$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $6fa18ded83b359b0$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($6fa18ded83b359b0$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $6fa18ded83b359b0$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $6fa18ded83b359b0$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($6fa18ded83b359b0$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($6fa18ded83b359b0$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)($ivxDX.GlobalStyles, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $8lNbR.buildInitColorSchemeScript)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("8lNbR", function(module, exports) {
"use strict";
'use client';

var $PT5lT = parcelRequire("PT5lT");
var $6146710ce433e70e$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.buildInitColorSchemeScript = $6146710ce433e70e$var$buildInitColorSchemeScript;
module.exports.default = $6146710ce433e70e$var$InitColorSchemeScript;

var $6146710ce433e70e$var$React = $6146710ce433e70e$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $6146710ce433e70e$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $6146710ce433e70e$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $6146710ce433e70e$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
// React 17 has no `useSyncExternalStore`; spread into a plain object so reading the
// missing property returns `undefined` instead of throwing under strict ESM. See #41190 (comment).
const $6146710ce433e70e$var$safeReact = {
    ...$6146710ce433e70e$var$React
};
const $6146710ce433e70e$var$maybeReactUseSyncExternalStore = $6146710ce433e70e$var$safeReact.useSyncExternalStore;
const $6146710ce433e70e$var$subscribe = ()=>()=>{};
// Serialize a value into a JS string literal safe to embed in the inline script. JSON.stringify
// escapes quotes and backslashes; the extra replaces handle what it does not: `<` (so `</script>`
// can't close the element) and the U+2028/U+2029 line separators, invalid raw inside a JS string.
function $6146710ce433e70e$var$serializeScriptValue(value) {
    return JSON.stringify(value).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}
// Insert a runtime scheme variable (`light`, `dark`, or `colorScheme`) into every `%s` placeholder
// of an attribute/selector template.
function $6146710ce433e70e$var$interpolateScheme(template, variable) {
    const segments = template.split('%s');
    const tokens = [];
    for(let index = 0; index < segments.length; index += 1){
        if (index > 0) tokens.push(variable);
        if (segments[index]) tokens.push($6146710ce433e70e$var$serializeScriptValue(segments[index]));
    }
    return tokens.join(' + ') || '""';
}
/**
 * `true` during the server render and the matching hydration render, `false`
 * on every client render afterwards. React warns when a `<script>` is
 * created during a client render (such scripts never execute), so the inline
 * script is only emitted on the server pass and dropped after hydration — the
 * attribute it already set on the document persists. React <18 has no
 * `useSyncExternalStore` and no such warning, so the script is always emitted.
 */ function $6146710ce433e70e$var$useIsServerRender() {
    if ($6146710ce433e70e$var$maybeReactUseSyncExternalStore === undefined) return true;
    return $6146710ce433e70e$var$maybeReactUseSyncExternalStore($6146710ce433e70e$var$subscribe, ()=>false, ()=>true);
}
function $6146710ce433e70e$var$buildInitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $6146710ce433e70e$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $6146710ce433e70e$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $6146710ce433e70e$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove(${$6146710ce433e70e$var$interpolateScheme(selector, 'light')}, ${$6146710ce433e70e$var$interpolateScheme(selector, 'dark')});
      ${colorSchemeNode}.classList.add(${$6146710ce433e70e$var$interpolateScheme(selector, 'colorScheme')});`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const separator = matches[1].indexOf('=');
        const attr = separator === -1 ? matches[1] : matches[1].slice(0, separator);
        const value = separator === -1 ? undefined : matches[1].slice(separator + 1);
        if (!value) setter += `${colorSchemeNode}.removeAttribute(${$6146710ce433e70e$var$interpolateScheme(attr, 'light')});
      ${colorSchemeNode}.removeAttribute(${$6146710ce433e70e$var$interpolateScheme(attr, 'dark')});`;
        const attributeValue = value ? $6146710ce433e70e$var$interpolateScheme(value.replace(/^(['"])(.*)\1$/, '$2'), 'colorScheme') : '""';
        setter += `
      ${colorSchemeNode}.setAttribute(${$6146710ce433e70e$var$interpolateScheme(attr, 'colorScheme')}, ${attributeValue});`;
    } else if (!attribute.startsWith('.')) setter += `${colorSchemeNode}.setAttribute(${$6146710ce433e70e$var$serializeScriptValue(attribute)}, colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem(${$6146710ce433e70e$var$serializeScriptValue(modeStorageKey)}) || ${$6146710ce433e70e$var$serializeScriptValue(defaultMode)};
  const dark = localStorage.getItem(${$6146710ce433e70e$var$serializeScriptValue(`${colorSchemeStorageKey}-dark`)}) || ${$6146710ce433e70e$var$serializeScriptValue(defaultDarkColorScheme)};
  const light = localStorage.getItem(${$6146710ce433e70e$var$serializeScriptValue(`${colorSchemeStorageKey}-light`)}) || ${$6146710ce433e70e$var$serializeScriptValue(defaultLightColorScheme)};
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}
function $6146710ce433e70e$var$InitColorSchemeScript(options) {
    const isServerRender = $6146710ce433e70e$var$useIsServerRender();
    if (!isServerRender) return null;
    return $6146710ce433e70e$var$buildInitColorSchemeScript(options);
}

});

parcelRegister("cV43s", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $967df414ecb39807$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $967df414ecb39807$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $967df414ecb39807$var$useCurrentColorScheme;
module.exports.getColorScheme = $967df414ecb39807$var$getColorScheme;
module.exports.getSystemMode = $967df414ecb39807$var$getSystemMode;

var $967df414ecb39807$var$React = $967df414ecb39807$require$_interopRequireWildcard((parcelRequire("acw62")));

var $8lNbR = parcelRequire("8lNbR");

var $967df414ecb39807$var$_localStorageManager = $967df414ecb39807$require$_interopRequireDefault((parcelRequire("gcXJN")));
function $967df414ecb39807$var$noop() {}
function $967df414ecb39807$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $967df414ecb39807$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $967df414ecb39807$var$getColorScheme(state) {
    return $967df414ecb39807$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $967df414ecb39807$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $8lNbR.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $8lNbR.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $967df414ecb39807$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $967df414ecb39807$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $967df414ecb39807$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $967df414ecb39807$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $967df414ecb39807$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $967df414ecb39807$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $967df414ecb39807$var$React.useState(noSsr || !isMultiSchemes);
    $967df414ecb39807$var$React.useEffect(()=>{
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $967df414ecb39807$var$getColorScheme(state);
    const setMode = $967df414ecb39807$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $967df414ecb39807$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $967df414ecb39807$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $967df414ecb39807$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $967df414ecb39807$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $967df414ecb39807$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $967df414ecb39807$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $967df414ecb39807$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $967df414ecb39807$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $967df414ecb39807$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $967df414ecb39807$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("gcXJN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $bccc1afb3b439594$var$noop() {}
const $bccc1afb3b439594$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $bccc1afb3b439594$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $bccc1afb3b439594$var$_default = module.exports.default = $bccc1afb3b439594$var$localStorageManager;

});



parcelRegister("9ITdn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71430da424b8664a$var$createGetCssVar;
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $71430da424b8664a$var$createGetCssVar(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("h8frB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $c78f29e7d49b20bc$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
const $c78f29e7d49b20bc$var$prototypePollutingKeys = new Set([
    '__proto__',
    'constructor',
    'prototype'
]);
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $c78f29e7d49b20bc$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    for(let index = 0; index < keys.length; index += 1){
        const k = keys[index];
        // Prevent prototype pollution: never traverse or write through
        // `__proto__` / `constructor` / `prototype` (e.g. a theme parsed from untrusted JSON).
        if ($c78f29e7d49b20bc$var$prototypePollutingKeys.has(k)) break;
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    }
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $c78f29e7d49b20bc$var$assignNestedKeys;
const $c78f29e7d49b20bc$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $c78f29e7d49b20bc$var$walkObjectDeep;
const $c78f29e7d49b20bc$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $c78f29e7d49b20bc$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $c78f29e7d49b20bc$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $c78f29e7d49b20bc$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $c78f29e7d49b20bc$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $c78f29e7d49b20bc$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});

parcelRegister("1roNO", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $10cb8d5159657583$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10cb8d5159657583$var$_deepmerge = $10cb8d5159657583$require$_interopRequireDefault((parcelRequire("4qPjz")));

var $10cb8d5159657583$var$_cssVarsParser = $10cb8d5159657583$require$_interopRequireDefault((parcelRequire("h8frB")));
function $10cb8d5159657583$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-expect-error - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $10cb8d5159657583$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $10cb8d5159657583$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $10cb8d5159657583$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $10cb8d5159657583$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $10cb8d5159657583$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $10cb8d5159657583$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $10cb8d5159657583$var$_default = module.exports.default = $10cb8d5159657583$var$prepareCssVars;

});

parcelRegister("6kgR5", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $49b1af6c695b47cc$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $49b1af6c695b47cc$var$_prepareCssVars = $49b1af6c695b47cc$require$_interopRequireDefault((parcelRequire("1roNO")));

var $351zh = parcelRequire("351zh");

var $8lNbR = parcelRequire("8lNbR");
function $49b1af6c695b47cc$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$8lNbR.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $49b1af6c695b47cc$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $351zh.createGetColorSchemeSelector)(colorSchemeSelector);
    output.internal_cache = {};
    return output;
}
var $49b1af6c695b47cc$var$_default = module.exports.default = $49b1af6c695b47cc$var$createCssVarsTheme;

});
parcelRegister("351zh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $23e30e1e6796095f$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $23e30e1e6796095f$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});


parcelRegister("eWibW", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $ae0497ed24018f51$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $ae0497ed24018f51$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ae0497ed24018f51$var$createContainer;

var $ae0497ed24018f51$var$React = $ae0497ed24018f51$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ae0497ed24018f51$var$_propTypes = $ae0497ed24018f51$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ae0497ed24018f51$var$_clsx = $ae0497ed24018f51$require$_interopRequireDefault((parcelRequire("i6kju")));

var $ae0497ed24018f51$var$_generateUtilityClass = $ae0497ed24018f51$require$_interopRequireDefault((parcelRequire("7vfNl")));

var $ae0497ed24018f51$var$_composeClasses = $ae0497ed24018f51$require$_interopRequireDefault((parcelRequire("2mLzX")));

var $ae0497ed24018f51$var$_capitalize = $ae0497ed24018f51$require$_interopRequireDefault((parcelRequire("jV5Vu")));

var $ae0497ed24018f51$var$_useThemeProps = $ae0497ed24018f51$require$_interopRequireDefault((parcelRequire("jmjKP")));

var $ae0497ed24018f51$var$_styled = $ae0497ed24018f51$require$_interopRequireDefault((parcelRequire("8e6g8")));

var $ae0497ed24018f51$var$_createTheme = $ae0497ed24018f51$require$_interopRequireDefault((parcelRequire("hDEnZ")));

var $ayMG0 = parcelRequire("ayMG0");
const $ae0497ed24018f51$var$defaultTheme = (0, $ae0497ed24018f51$var$_createTheme.default)();
const $ae0497ed24018f51$var$defaultCreateStyledComponent = (0, $ae0497ed24018f51$var$_styled.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $ae0497ed24018f51$var$_capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $ae0497ed24018f51$var$useThemePropsDefault = (inProps)=>(0, $ae0497ed24018f51$var$_useThemeProps.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $ae0497ed24018f51$var$defaultTheme
    });
const $ae0497ed24018f51$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $ae0497ed24018f51$var$_generateUtilityClass.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $ae0497ed24018f51$var$_capitalize.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $ae0497ed24018f51$var$_composeClasses.default)(slots, getContainerUtilityClass, classes);
};
function $ae0497ed24018f51$var$createContainer(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $ae0497ed24018f51$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $ae0497ed24018f51$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $ae0497ed24018f51$var$React.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $ae0497ed24018f51$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $ae0497ed24018f51$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}

});
parcelRegister("2mLzX", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $1b928b0a401d8a5a$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $1b928b0a401d8a5a$var$_composeClasses.default;
    }
});

var $1b928b0a401d8a5a$var$_composeClasses = $1b928b0a401d8a5a$require$_interopRequireDefault((parcelRequire("kSgiD")));

});
parcelRegister("kSgiD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f3257e8db26e8352$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $f3257e8db26e8352$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});



parcelRegister("auKEA", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $7a40e52d0342881b$require$_interopRequireWildcard = $PT5lT.default;

var $k8pq4 = parcelRequire("k8pq4");
var $7a40e52d0342881b$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7a40e52d0342881b$var$_exportNames = {
    containerClasses: true
};
Object.defineProperty(module.exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return $7a40e52d0342881b$var$_containerClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7a40e52d0342881b$var$_Container.default;
    }
});

var $7a40e52d0342881b$var$_Container = $7a40e52d0342881b$require$_interopRequireDefault((parcelRequire("cr7jX")));

var $7a40e52d0342881b$var$_containerClasses = $7a40e52d0342881b$require$_interopRequireWildcard((parcelRequire("14itT")));
Object.keys($7a40e52d0342881b$var$_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a40e52d0342881b$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $7a40e52d0342881b$var$_containerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $7a40e52d0342881b$var$_containerClasses[key];
        }
    });
});

});
parcelRegister("cr7jX", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $90ddaf67d244c9fb$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90ddaf67d244c9fb$var$_propTypes = $90ddaf67d244c9fb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $90ddaf67d244c9fb$var$_createContainer = $90ddaf67d244c9fb$require$_interopRequireDefault((parcelRequire("eWibW")));
/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */ const $90ddaf67d244c9fb$var$Container = (0, $90ddaf67d244c9fb$var$_createContainer.default)();
var $90ddaf67d244c9fb$var$_default = module.exports.default = $90ddaf67d244c9fb$var$Container;

});

parcelRegister("14itT", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $0c7480270c53beaf$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getContainerUtilityClass = $0c7480270c53beaf$var$getContainerUtilityClass;

var $0c7480270c53beaf$var$_generateUtilityClasses = $0c7480270c53beaf$require$_interopRequireDefault((parcelRequire("lzSOZ")));

var $0c7480270c53beaf$var$_generateUtilityClass = $0c7480270c53beaf$require$_interopRequireDefault((parcelRequire("7vfNl")));
function $0c7480270c53beaf$var$getContainerUtilityClass(slot) {
    return (0, $0c7480270c53beaf$var$_generateUtilityClass.default)('MuiContainer', slot);
}
const $0c7480270c53beaf$var$containerClasses = (0, $0c7480270c53beaf$var$_generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var $0c7480270c53beaf$var$_default = module.exports.default = $0c7480270c53beaf$var$containerClasses;

});


parcelRegister("3yksz", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $29646af9b637ad38$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $29646af9b637ad38$var$_propTypes = $29646af9b637ad38$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $29646af9b637ad38$var$_createGrid = $29646af9b637ad38$require$_interopRequireDefault((parcelRequire("49AG8")));
/**
 *
 * Demos:
 *
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */ const $29646af9b637ad38$var$Grid = (0, $29646af9b637ad38$var$_createGrid.default)();
var $29646af9b637ad38$var$_default = module.exports.default = $29646af9b637ad38$var$Grid;

});
parcelRegister("49AG8", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $3064744c81aa737d$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $3064744c81aa737d$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3064744c81aa737d$var$createGrid;

var $3064744c81aa737d$var$React = $3064744c81aa737d$require$_interopRequireWildcard((parcelRequire("acw62")));

var $3064744c81aa737d$var$_propTypes = $3064744c81aa737d$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $3064744c81aa737d$var$_clsx = $3064744c81aa737d$require$_interopRequireDefault((parcelRequire("i6kju")));

var $3064744c81aa737d$var$_isMuiElement = $3064744c81aa737d$require$_interopRequireDefault((parcelRequire("3BnkR")));

var $3064744c81aa737d$var$_generateUtilityClass = $3064744c81aa737d$require$_interopRequireDefault((parcelRequire("7vfNl")));

var $3064744c81aa737d$var$_composeClasses = $3064744c81aa737d$require$_interopRequireDefault((parcelRequire("2mLzX")));

var $3064744c81aa737d$var$_styled = $3064744c81aa737d$require$_interopRequireDefault((parcelRequire("8e6g8")));

var $3064744c81aa737d$var$_useThemeProps = $3064744c81aa737d$require$_interopRequireDefault((parcelRequire("jmjKP")));

var $3064744c81aa737d$var$_useTheme = $3064744c81aa737d$require$_interopRequireDefault((parcelRequire("dWz7R")));

var $3064744c81aa737d$var$_createTheme = $3064744c81aa737d$require$_interopRequireDefault((parcelRequire("hDEnZ")));

var $fCwaE = parcelRequire("fCwaE");

var $ayMG0 = parcelRequire("ayMG0");
const $3064744c81aa737d$var$defaultTheme = (0, $3064744c81aa737d$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $3064744c81aa737d$var$defaultCreateStyledComponent = (0, $3064744c81aa737d$var$_styled.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $3064744c81aa737d$var$useThemePropsDefault(props) {
    return (0, $3064744c81aa737d$var$_useThemeProps.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $3064744c81aa737d$var$defaultTheme
    });
}
function $3064744c81aa737d$var$createGrid(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $3064744c81aa737d$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $3064744c81aa737d$var$useThemePropsDefault, useTheme: useTheme = $3064744c81aa737d$var$_useTheme.default, componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $fCwaE.generateDirectionClasses)(direction),
                ...(0, $fCwaE.generateSizeClassNames)(size),
                ...container ? (0, $fCwaE.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $3064744c81aa737d$var$_composeClasses.default)(slots, (slot)=>(0, $3064744c81aa737d$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent($fCwaE.generateGridColumnsStyles, $fCwaE.generateGridColumnSpacingStyles, $fCwaE.generateGridRowSpacingStyles, $fCwaE.generateGridSizeStyles, $fCwaE.generateGridDirectionStyles, $fCwaE.generateGridStyles, $fCwaE.generateGridOffsetStyles);
    const Grid = /*#__PURE__*/ $3064744c81aa737d$var$React.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = themeProps;
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $3064744c81aa737d$var$_clsx.default)(classes.root, className),
            ...other,
            children: $3064744c81aa737d$var$React.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $3064744c81aa737d$var$React.isValidElement(child) && (0, $3064744c81aa737d$var$_isMuiElement.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $3064744c81aa737d$var$React.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-expect-error internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

});
parcelRegister("3BnkR", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $29f6edb8aec51ab9$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $29f6edb8aec51ab9$var$_isMuiElement.default;
    }
});

var $29f6edb8aec51ab9$var$_isMuiElement = $29f6edb8aec51ab9$require$_interopRequireDefault((parcelRequire("8mrYu")));

});
parcelRegister("8mrYu", function(module, exports) {
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $616614003dda2762$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $616614003dda2762$var$isMuiElement;

var $616614003dda2762$var$React = $616614003dda2762$require$_interopRequireWildcard((parcelRequire("acw62")));
function $616614003dda2762$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $616614003dda2762$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/react/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("fCwaE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateSpacingClassNames = module.exports.generateSizeClassNames = module.exports.generateGridStyles = module.exports.generateGridSizeStyles = module.exports.generateGridRowSpacingStyles = module.exports.generateGridOffsetStyles = module.exports.generateGridDirectionStyles = module.exports.generateGridColumnsStyles = module.exports.generateGridColumnSpacingStyles = module.exports.generateDirectionClasses = void 0;

var $51xd2 = parcelRequire("51xd2");
function $b5f35c13c12245ba$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $b5f35c13c12245ba$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $b5f35c13c12245ba$var$selfColumnsVar = '--Grid-columns';
const $b5f35c13c12245ba$var$parentColumnsVar = '--Grid-parent-columns';
const $b5f35c13c12245ba$var$generateGridSizeStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $51xd2.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$b5f35c13c12245ba$var$parentColumnsVar}) - (var(${$b5f35c13c12245ba$var$parentColumnsVar}) - ${value}) * (var(${$b5f35c13c12245ba$var$getParentSpacingVar('column')}) / var(${$b5f35c13c12245ba$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridSizeStyles = $b5f35c13c12245ba$var$generateGridSizeStyles;
const $b5f35c13c12245ba$var$generateGridOffsetStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $51xd2.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$b5f35c13c12245ba$var$parentColumnsVar}) + var(${$b5f35c13c12245ba$var$getParentSpacingVar('column')}) * ${value} / var(${$b5f35c13c12245ba$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridOffsetStyles = $b5f35c13c12245ba$var$generateGridOffsetStyles;
const $b5f35c13c12245ba$var$generateGridColumnsStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$b5f35c13c12245ba$var$selfColumnsVar]: 12
    };
    (0, $51xd2.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$b5f35c13c12245ba$var$selfColumnsVar]: columns,
            '> *': {
                [$b5f35c13c12245ba$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnsStyles = $b5f35c13c12245ba$var$generateGridColumnsStyles;
const $b5f35c13c12245ba$var$generateGridRowSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $51xd2.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$b5f35c13c12245ba$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$b5f35c13c12245ba$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridRowSpacingStyles = $b5f35c13c12245ba$var$generateGridRowSpacingStyles;
const $b5f35c13c12245ba$var$generateGridColumnSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $51xd2.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$b5f35c13c12245ba$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$b5f35c13c12245ba$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnSpacingStyles = $b5f35c13c12245ba$var$generateGridColumnSpacingStyles;
const $b5f35c13c12245ba$var$generateGridDirectionStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $51xd2.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
module.exports.generateGridDirectionStyles = $b5f35c13c12245ba$var$generateGridDirectionStyles;
const $b5f35c13c12245ba$var$generateGridStyles = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$b5f35c13c12245ba$var$getSelfSpacingVar('row')}) var(${$b5f35c13c12245ba$var$getSelfSpacingVar('column')})`
        }
    };
};
module.exports.generateGridStyles = $b5f35c13c12245ba$var$generateGridStyles;
const $b5f35c13c12245ba$var$generateSizeClassNames = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
module.exports.generateSizeClassNames = $b5f35c13c12245ba$var$generateSizeClassNames;
const $b5f35c13c12245ba$var$generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
module.exports.generateSpacingClassNames = $b5f35c13c12245ba$var$generateSpacingClassNames;
const $b5f35c13c12245ba$var$generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};
module.exports.generateDirectionClasses = $b5f35c13c12245ba$var$generateDirectionClasses;

});
parcelRegister("51xd2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.traverseBreakpoints = module.exports.filterBreakpointKeys = void 0;
const $3a86ce65e49745b8$var$filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
module.exports.filterBreakpointKeys = $3a86ce65e49745b8$var$filterBreakpointKeys;
const $3a86ce65e49745b8$var$traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $3a86ce65e49745b8$var$filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};
module.exports.traverseBreakpoints = $3a86ce65e49745b8$var$traverseBreakpoints;

});




parcelRegister("fLJqk", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $b7ae7af7af9c87c5$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridUtilityClass = $b7ae7af7af9c87c5$var$getGridUtilityClass;

var $b7ae7af7af9c87c5$var$_generateUtilityClasses = $b7ae7af7af9c87c5$require$_interopRequireDefault((parcelRequire("lzSOZ")));

var $b7ae7af7af9c87c5$var$_generateUtilityClass = $b7ae7af7af9c87c5$require$_interopRequireDefault((parcelRequire("7vfNl")));
function $b7ae7af7af9c87c5$var$getGridUtilityClass(slot) {
    return (0, $b7ae7af7af9c87c5$var$_generateUtilityClass.default)('MuiGrid', slot);
}
const $b7ae7af7af9c87c5$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $b7ae7af7af9c87c5$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $b7ae7af7af9c87c5$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $b7ae7af7af9c87c5$var$GRID_SIZES = [
    'auto',
    'grow',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $b7ae7af7af9c87c5$var$gridClasses = (0, $b7ae7af7af9c87c5$var$_generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    'item',
    // spacings
    ...$b7ae7af7af9c87c5$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$b7ae7af7af9c87c5$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$b7ae7af7af9c87c5$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$b7ae7af7af9c87c5$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$b7ae7af7af9c87c5$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$b7ae7af7af9c87c5$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$b7ae7af7af9c87c5$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$b7ae7af7af9c87c5$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $b7ae7af7af9c87c5$var$_default = module.exports.default = $b7ae7af7af9c87c5$var$gridClasses;

});

parcelRegister("geOjO", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $bd24fc590d6329e3$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd24fc590d6329e3$var$_propTypes = $bd24fc590d6329e3$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $bd24fc590d6329e3$var$_createStack = $bd24fc590d6329e3$require$_interopRequireDefault((parcelRequire("8yefD")));
/**
 *
 * Demos:
 *
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const $bd24fc590d6329e3$var$Stack = (0, $bd24fc590d6329e3$var$_createStack.default)();
var $bd24fc590d6329e3$var$_default = module.exports.default = $bd24fc590d6329e3$var$Stack;

});
parcelRegister("8yefD", function(module, exports) {
"use strict";
'use client';

var $k8pq4 = parcelRequire("k8pq4");
var $639c8db45ed7d0c6$require$_interopRequireDefault = $k8pq4.default;

var $PT5lT = parcelRequire("PT5lT");
var $639c8db45ed7d0c6$require$_interopRequireWildcard = $PT5lT.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $639c8db45ed7d0c6$var$createStack;
module.exports.style = void 0;

var $639c8db45ed7d0c6$var$React = $639c8db45ed7d0c6$require$_interopRequireWildcard((parcelRequire("acw62")));

var $639c8db45ed7d0c6$var$_propTypes = $639c8db45ed7d0c6$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $639c8db45ed7d0c6$var$_clsx = $639c8db45ed7d0c6$require$_interopRequireDefault((parcelRequire("i6kju")));

var $639c8db45ed7d0c6$var$_deepmerge = $639c8db45ed7d0c6$require$_interopRequireDefault((parcelRequire("4qPjz")));

var $639c8db45ed7d0c6$var$_generateUtilityClass = $639c8db45ed7d0c6$require$_interopRequireDefault((parcelRequire("7vfNl")));

var $639c8db45ed7d0c6$var$_composeClasses = $639c8db45ed7d0c6$require$_interopRequireDefault((parcelRequire("2mLzX")));

var $639c8db45ed7d0c6$var$_styled = $639c8db45ed7d0c6$require$_interopRequireDefault((parcelRequire("8e6g8")));

var $639c8db45ed7d0c6$var$_useThemeProps = $639c8db45ed7d0c6$require$_interopRequireDefault((parcelRequire("jmjKP")));

var $639c8db45ed7d0c6$var$_createTheme = $639c8db45ed7d0c6$require$_interopRequireDefault((parcelRequire("hDEnZ")));

var $69BMr = parcelRequire("69BMr");

var $4b2XU = parcelRequire("4b2XU");

var $ayMG0 = parcelRequire("ayMG0");
const $639c8db45ed7d0c6$var$defaultTheme = (0, $639c8db45ed7d0c6$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $639c8db45ed7d0c6$var$defaultCreateStyledComponent = (0, $639c8db45ed7d0c6$var$_styled.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $639c8db45ed7d0c6$var$useThemePropsDefault(props) {
    return (0, $639c8db45ed7d0c6$var$_useThemeProps.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $639c8db45ed7d0c6$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $639c8db45ed7d0c6$var$joinChildren(children, separator) {
    const childrenArray = $639c8db45ed7d0c6$var$React.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $639c8db45ed7d0c6$var$React.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $639c8db45ed7d0c6$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $639c8db45ed7d0c6$var$style = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $69BMr.handleBreakpoints)({
            theme: theme
        }, (0, $69BMr.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $4b2XU.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $69BMr.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $69BMr.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $4b2XU.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$639c8db45ed7d0c6$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $4b2XU.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $639c8db45ed7d0c6$var$_deepmerge.default)(styles, (0, $69BMr.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $69BMr.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
module.exports.style = $639c8db45ed7d0c6$var$style;
function $639c8db45ed7d0c6$var$createStack(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $639c8db45ed7d0c6$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $639c8db45ed7d0c6$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $639c8db45ed7d0c6$var$_composeClasses.default)(slots, (slot)=>(0, $639c8db45ed7d0c6$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($639c8db45ed7d0c6$var$style);
    const Stack = /*#__PURE__*/ $639c8db45ed7d0c6$var$React.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = themeProps;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $639c8db45ed7d0c6$var$_clsx.default)(classes.root, className),
            ...other,
            children: divider ? $639c8db45ed7d0c6$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});


parcelRegister("2rN3g", function(module, exports) {
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $1c8426ffe5797869$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStackUtilityClass = $1c8426ffe5797869$var$getStackUtilityClass;

var $1c8426ffe5797869$var$_generateUtilityClasses = $1c8426ffe5797869$require$_interopRequireDefault((parcelRequire("lzSOZ")));

var $1c8426ffe5797869$var$_generateUtilityClass = $1c8426ffe5797869$require$_interopRequireDefault((parcelRequire("7vfNl")));
function $1c8426ffe5797869$var$getStackUtilityClass(slot) {
    return (0, $1c8426ffe5797869$var$_generateUtilityClass.default)('MuiStack', slot);
}
const $1c8426ffe5797869$var$stackClasses = (0, $1c8426ffe5797869$var$_generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var $1c8426ffe5797869$var$_default = module.exports.default = $1c8426ffe5797869$var$stackClasses;

});

parcelRegister("bbzhi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "clsx", () => $261912aeb2ff4d34$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $261912aeb2ff4d34$export$2e2bcd8739ae039);
function $261912aeb2ff4d34$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $261912aeb2ff4d34$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $261912aeb2ff4d34$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $261912aeb2ff4d34$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $261912aeb2ff4d34$export$2e2bcd8739ae039 = $261912aeb2ff4d34$export$4f5d2d50c9deca37;

});

parcelRegister("keaWW", function(module, exports) {
/**
 * @mui/styled-engine v9.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $eb9d9bd20564cb0c$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $eb9d9bd20564cb0c$var$_GlobalStyles.default;
    }
});
Object.defineProperty(module.exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $eb9d9bd20564cb0c$var$_StyledEngineProvider.default;
    }
});
Object.defineProperty(module.exports, "ThemeContext", {
    enumerable: true,
    get: function() {
        return $eP9YU.T;
    }
});
Object.defineProperty(module.exports, "css", {
    enumerable: true,
    get: function() {
        return $jjlaj.css;
    }
});
module.exports.default = void 0;
module.exports.internal_mutateStyles = $eb9d9bd20564cb0c$var$internal_mutateStyles;
module.exports.internal_serializeStyles = $eb9d9bd20564cb0c$var$internal_serializeStyles;
Object.defineProperty(module.exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $jjlaj.keyframes;
    }
});

var $eb9d9bd20564cb0c$var$_styled = $eb9d9bd20564cb0c$require$_interopRequireDefault((parcelRequire("5rflj")));

var $19dPQ = parcelRequire("19dPQ");

var $jjlaj = parcelRequire("jjlaj");
var $eP9YU = parcelRequire("eP9YU");

var $eb9d9bd20564cb0c$var$_StyledEngineProvider = $eb9d9bd20564cb0c$require$_interopRequireDefault((parcelRequire("7jFLO")));

var $eb9d9bd20564cb0c$var$_GlobalStyles = $eb9d9bd20564cb0c$require$_interopRequireDefault((parcelRequire("kr1zr")));
// Re-export the public type surface of `@emotion/styled`. Explicit names rather
// than `export type *`: an `export *` (even type-only) is disallowed by the
// `'use client'` Next.js lint rule. Names locally redeclared below intentionally
// shadow Emotion's and are not re-exported here.
function $eb9d9bd20564cb0c$var$styled(tag, options) {
    // Emotion's `styled` overloads each expect a specific tag/component shape;
    // none accept the broadened `React.ElementType` union, so cast the passthrough.
    const stylesFactory = (0, $eb9d9bd20564cb0c$var$_styled.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
var $eb9d9bd20564cb0c$var$_default = module.exports.default = $eb9d9bd20564cb0c$var$styled;
/**
 * For internal usage in `@mui/system` package
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $eb9d9bd20564cb0c$var$internal_mutateStyles(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $eb9d9bd20564cb0c$var$wrapper = [];
// eslint-disable-next-line @typescript-eslint/naming-convention
function $eb9d9bd20564cb0c$var$internal_serializeStyles(styles) {
    $eb9d9bd20564cb0c$var$wrapper[0] = styles;
    return (0, $19dPQ.serializeStyles)($eb9d9bd20564cb0c$var$wrapper);
} // TODO v6 - check if we can drop the unknown, as it breaks the autocomplete
 // For more info on why it was added, see https://github.com/mui/material-ui/pull/26228
 // TODO v6 - check if we can drop the unknown, as it breaks the autocomplete
 // For more info on why it was added, see https://github.com/mui/material-ui/pull/26228
 // Omit variants as a key, because we have a special handling for it
 /** Same as StyledOptions but shouldForwardProp must be a type guard */  /**
 * @typeparam ComponentProps  Props which will be included when withComponent is called
 * @typeparam SpecificComponentProps  Props which will *not* be included when withComponent is called
 */ 

});
parcelRegister("5ULbo", function(module, exports) {
function $44e6c83b5ec1c540$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $44e6c83b5ec1c540$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("19dPQ", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $0d615d1d91087286$export$6321afa313b251b5);

var $O8sh5 = parcelRequire("O8sh5");

var $dkroP = parcelRequire("dkroP");

var $dw6pd = parcelRequire("dw6pd");
var $0d615d1d91087286$var$isDevelopment = false;
var $0d615d1d91087286$var$hyphenateRegex = /[A-Z]|^ms/g;
var $0d615d1d91087286$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $0d615d1d91087286$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $0d615d1d91087286$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $0d615d1d91087286$var$processStyleName = /* #__PURE__ */ (0, $dw6pd.default)(function(styleName) {
    return $0d615d1d91087286$var$isCustomProperty(styleName) ? styleName : styleName.replace($0d615d1d91087286$var$hyphenateRegex, '-$&').toLowerCase();
});
var $0d615d1d91087286$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($0d615d1d91087286$var$animationRegex, function(match, p1, p2) {
                $0d615d1d91087286$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $0d615d1d91087286$var$cursor
                };
                return p1;
            });
    }
    if ((0, $dkroP.default)[key] !== 1 && !$0d615d1d91087286$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $0d615d1d91087286$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $0d615d1d91087286$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $0d615d1d91087286$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $0d615d1d91087286$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $0d615d1d91087286$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $0d615d1d91087286$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $0d615d1d91087286$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $0d615d1d91087286$var$cursor;
                var result = interpolation(mergedProps);
                $0d615d1d91087286$var$cursor = previousCursor;
                return $0d615d1d91087286$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $0d615d1d91087286$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $0d615d1d91087286$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($0d615d1d91087286$var$isProcessableValue(asString)) string += $0d615d1d91087286$var$processStyleName(key) + ":" + $0d615d1d91087286$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $0d615d1d91087286$var$isDevelopment) throw new Error($0d615d1d91087286$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($0d615d1d91087286$var$isProcessableValue(value[_i])) string += $0d615d1d91087286$var$processStyleName(key) + ":" + $0d615d1d91087286$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $0d615d1d91087286$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $0d615d1d91087286$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $0d615d1d91087286$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $0d615d1d91087286$var$cursor;
function $0d615d1d91087286$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $0d615d1d91087286$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $0d615d1d91087286$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $0d615d1d91087286$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $0d615d1d91087286$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $0d615d1d91087286$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $O8sh5.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $0d615d1d91087286$var$cursor
    };
}

});
parcelRegister("O8sh5", function(module, exports) {

$parcel$export(module.exports, "default", () => $096b3a9f3119ecd4$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $096b3a9f3119ecd4$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("dkroP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b42659746ca5871$export$2e2bcd8739ae039);
var $9b42659746ca5871$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("dw6pd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d733b8b97f7eaff$export$2e2bcd8739ae039);
function $9d733b8b97f7eaff$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("7jFLO", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $553ab5728d2ff9c1$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $553ab5728d2ff9c1$var$_StyledEngineProvider.default;
    }
});

var $553ab5728d2ff9c1$var$_StyledEngineProvider = $553ab5728d2ff9c1$require$_interopRequireDefault((parcelRequire("iUVt0")));

});
parcelRegister("iUVt0", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $dc5a08ae6732cac7$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $dc5a08ae6732cac7$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TEST_INTERNALS_DO_NOT_USE = void 0;
module.exports.default = $dc5a08ae6732cac7$var$StyledEngineProvider;

var $dc5a08ae6732cac7$var$React = $dc5a08ae6732cac7$require$_interopRequireWildcard((parcelRequire("acw62")));

var $dc5a08ae6732cac7$var$_propTypes = $dc5a08ae6732cac7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $eP9YU = parcelRequire("eP9YU");

var $dc5a08ae6732cac7$var$_cache = $dc5a08ae6732cac7$require$_interopRequireDefault((parcelRequire("dz0Yz")));

var $kUdyn = parcelRequire("kUdyn");

var $ayMG0 = parcelRequire("ayMG0");
// To fix [Jest performance](https://github.com/mui/material-ui/issues/45638).
const $dc5a08ae6732cac7$var$cacheMap = new Map();
// Need to add a private variable to test the generated CSS from Emotion, this is the simplest way to do it.
// We can't test the CSS from `style` tag easily because the `speedy: true` (produce empty text content) is enabled by Emotion.
// Even if we disable it, JSDOM needs extra configuration to be able to parse `@layer` CSS.
/**
 * @internal
 */ const $dc5a08ae6732cac7$var$TEST_INTERNALS_DO_NOT_USE = module.exports.TEST_INTERNALS_DO_NOT_USE = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $dc5a08ae6732cac7$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $dc5a08ae6732cac7$var$_cache.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $dc5a08ae6732cac7$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $dc5a08ae6732cac7$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$dc5a08ae6732cac7$var$insertionPoint) {
        $dc5a08ae6732cac7$var$insertionPoint = document.createElement('meta');
        $dc5a08ae6732cac7$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $dc5a08ae6732cac7$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($dc5a08ae6732cac7$var$insertionPoint);
    }
}
function $dc5a08ae6732cac7$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends $kUdyn.StyleSheet {
            insert(rule, options) {
                if ($dc5a08ae6732cac7$var$TEST_INTERNALS_DO_NOT_USE.insert) return $dc5a08ae6732cac7$var$TEST_INTERNALS_DO_NOT_USE.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $dc5a08ae6732cac7$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $dc5a08ae6732cac7$var$createEmotionCache({
            // Use a dedicated key for the cascade-layer cache so its generated class
            // names (e.g. `mui-fyswvn`) can never collide with identically-hashed
            // UNLAYERED classes from the default/`injectFirst` cache (key `css`).
            // A collision lets an unlayered `.css-xxx` rule beat the layered one,
            // defeating MUI's own styles.
            key: enableCssLayer ? 'mui' : 'css',
            insertionPoint: injectFirst ? $dc5a08ae6732cac7$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $dc5a08ae6732cac7$var$StyledEngineProvider(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $dc5a08ae6732cac7$var$React.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $dc5a08ae6732cac7$var$cacheMap.has(cacheKey)) return $dc5a08ae6732cac7$var$cacheMap.get(cacheKey);
        const fresh = $dc5a08ae6732cac7$var$getCache(injectFirst, enableCssLayer);
        $dc5a08ae6732cac7$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $ayMG0.jsx)($eP9YU.C, {
        value: cache,
        children: children
    }) : children;
}

});
parcelRegister("c5wSN", function(module, exports) {
var $8ccf758514ff9417$var$cache;
function $8ccf758514ff9417$var$_interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var r, c, a = Object.defineProperty, n = {
        __proto__: null,
        "default": e
    };
    if (Object(e) !== e) return n;
    if ($8ccf758514ff9417$var$cache || "function" != typeof WeakMap || ($8ccf758514ff9417$var$cache = new WeakMap()), $8ccf758514ff9417$var$cache) {
        if ($8ccf758514ff9417$var$cache.has(e)) return $8ccf758514ff9417$var$cache.get(e);
        $8ccf758514ff9417$var$cache.set(e, n);
    }
    for(c in e)"default" !== c && ({}).hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]);
    return n;
}
module.exports = $8ccf758514ff9417$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dz0Yz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9dff4d11506240c8$export$2e2bcd8739ae039);

var $kUdyn = parcelRequire("kUdyn");

var $a4Fmi = parcelRequire("a4Fmi");

var $5Gmxp = parcelRequire("5Gmxp");

var $dw6pd = parcelRequire("dw6pd");
var $9dff4d11506240c8$var$isBrowser = typeof document !== 'undefined';
var $9dff4d11506240c8$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $a4Fmi.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $a4Fmi.token)(character)) break;
        (0, $a4Fmi.next)();
    }
    return (0, $a4Fmi.slice)(begin, (0, $a4Fmi.position));
};
var $9dff4d11506240c8$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $a4Fmi.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $a4Fmi.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $9dff4d11506240c8$var$identifierWithPointTracking((0, $a4Fmi.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $a4Fmi.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $a4Fmi.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $a4Fmi.from)(character);
    }
    while (character = (0, $a4Fmi.next)());
    return parsed;
};
var $9dff4d11506240c8$var$getRules = function getRules(value, points) {
    return (0, $a4Fmi.dealloc)($9dff4d11506240c8$var$toRules((0, $a4Fmi.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $9dff4d11506240c8$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $9dff4d11506240c8$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$9dff4d11506240c8$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $9dff4d11506240c8$var$fixedElements.set(element, true);
    var points = [];
    var rules = $9dff4d11506240c8$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $9dff4d11506240c8$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $9dff4d11506240c8$var$prefix(value, length) {
    switch((0, $a4Fmi.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $a4Fmi.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $a4Fmi.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MOZ) + value + (0, $a4Fmi.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + value + value;
        // order
        case 6165:
            return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.replace)(value, /(\w+).+(:[^]+)/, (0, $a4Fmi.WEBKIT) + 'box-$1$2' + (0, $a4Fmi.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + 'flex-item-' + (0, $a4Fmi.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + 'flex-line-pack' + (0, $a4Fmi.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + (0, $a4Fmi.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + (0, $a4Fmi.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $a4Fmi.WEBKIT) + 'box-' + (0, $a4Fmi.replace)(value, '-grow', '') + (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + (0, $a4Fmi.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $a4Fmi.WEBKIT) + (0, $a4Fmi.replace)(value, /([^-])(transform)/g, '$1' + (0, $a4Fmi.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $a4Fmi.replace)((0, $a4Fmi.replace)((0, $a4Fmi.replace)(value, /(zoom-|grab)/, (0, $a4Fmi.WEBKIT) + '$1'), /(image-set)/, (0, $a4Fmi.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $a4Fmi.replace)(value, /(image-set\([^]*)/, (0, $a4Fmi.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $a4Fmi.replace)((0, $a4Fmi.replace)(value, /(.+:)(flex-)?(.*)/, (0, $a4Fmi.WEBKIT) + 'box-pack:$3' + (0, $a4Fmi.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $a4Fmi.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $a4Fmi.replace)(value, /(.+)-inline(.+)/, (0, $a4Fmi.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $a4Fmi.strlen)(value) - 1 - length > 6) switch((0, $a4Fmi.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $a4Fmi.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $a4Fmi.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $a4Fmi.WEBKIT) + '$2-$3' + '$1' + (0, $a4Fmi.MOZ) + ((0, $a4Fmi.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $a4Fmi.indexof)(value, 'stretch') ? $9dff4d11506240c8$var$prefix((0, $a4Fmi.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $a4Fmi.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $a4Fmi.charat)(value, (0, $a4Fmi.strlen)(value) - 3 - (~(0, $a4Fmi.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $a4Fmi.replace)(value, ':', ':' + (0, $a4Fmi.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $a4Fmi.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $a4Fmi.WEBKIT) + ((0, $a4Fmi.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $a4Fmi.WEBKIT) + '$2$3' + '$1' + (0, $a4Fmi.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $a4Fmi.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + (0, $a4Fmi.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + (0, $a4Fmi.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + (0, $a4Fmi.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $a4Fmi.WEBKIT) + value + (0, $a4Fmi.MS) + value + value;
    }
    return value;
}
var $9dff4d11506240c8$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $a4Fmi.DECLARATION:
                element["return"] = $9dff4d11506240c8$var$prefix(element.value, element.length);
                break;
            case 0, $a4Fmi.KEYFRAMES:
                return (0, $a4Fmi.serialize)([
                    (0, $a4Fmi.copy)(element, {
                        value: (0, $a4Fmi.replace)(element.value, '@', '@' + (0, $a4Fmi.WEBKIT))
                    })
                ], callback);
            case 0, $a4Fmi.RULESET:
                if (element.length) return (0, $a4Fmi.combine)(element.props, function(value) {
                    switch((0, $a4Fmi.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $a4Fmi.serialize)([
                                (0, $a4Fmi.copy)(element, {
                                    props: [
                                        (0, $a4Fmi.replace)(value, /:(read-\w+)/, ':' + (0, $a4Fmi.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $a4Fmi.serialize)([
                                (0, $a4Fmi.copy)(element, {
                                    props: [
                                        (0, $a4Fmi.replace)(value, /:(plac\w+)/, ':' + (0, $a4Fmi.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $a4Fmi.copy)(element, {
                                    props: [
                                        (0, $a4Fmi.replace)(value, /:(plac\w+)/, ':' + (0, $a4Fmi.MOZ) + '$1')
                                    ]
                                }),
                                (0, $a4Fmi.copy)(element, {
                                    props: [
                                        (0, $a4Fmi.replace)(value, /:(plac\w+)/, (0, $a4Fmi.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $9dff4d11506240c8$var$getServerStylisCache = $9dff4d11506240c8$var$isBrowser ? undefined : (0, $5Gmxp.default)(function() {
    return (0, $dw6pd.default)(function() {
        return {};
    });
});
var $9dff4d11506240c8$var$defaultStylisPlugins = [
    $9dff4d11506240c8$var$prefixer
];
var $9dff4d11506240c8$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($9dff4d11506240c8$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $9dff4d11506240c8$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($9dff4d11506240c8$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $9dff4d11506240c8$var$compat,
        $9dff4d11506240c8$var$removeLabel
    ];
    if (!$9dff4d11506240c8$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $a4Fmi.stringify),
            (0, $a4Fmi.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $a4Fmi.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $a4Fmi.serialize)((0, $a4Fmi.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $a4Fmi.stringify)
        ];
        var _serializer = (0, $a4Fmi.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $a4Fmi.serialize)((0, $a4Fmi.compile)(styles), _serializer);
        };
        var serverStylisCache = $9dff4d11506240c8$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $kUdyn.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("kUdyn", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $f3838d09d933695e$export$9d753cd7ae895cce);
var $f3838d09d933695e$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $f3838d09d933695e$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $f3838d09d933695e$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $f3838d09d933695e$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$f3838d09d933695e$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($f3838d09d933695e$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $f3838d09d933695e$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("a4Fmi", function(module, exports) {

$parcel$export(module.exports, "MS", () => $dd6357e5eb72c764$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $dd6357e5eb72c764$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $dd6357e5eb72c764$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "RULESET", () => $dd6357e5eb72c764$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $dd6357e5eb72c764$export$527d108ccf083c2b);
$parcel$export(module.exports, "KEYFRAMES", () => $dd6357e5eb72c764$export$b44a8529a35fcb60);
$parcel$export(module.exports, "from", () => $dd6357e5eb72c764$export$6788812c4e6611e6);
$parcel$export(module.exports, "hash", () => $dd6357e5eb72c764$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $dd6357e5eb72c764$export$a9db5e087081082d);
$parcel$export(module.exports, "match", () => $dd6357e5eb72c764$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $dd6357e5eb72c764$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $dd6357e5eb72c764$export$f8e21b1e77979a08);
$parcel$export(module.exports, "strlen", () => $dd6357e5eb72c764$export$36776f635604f274);
$parcel$export(module.exports, "combine", () => $dd6357e5eb72c764$export$1be1fc439b849fdf);
$parcel$export(module.exports, "position", () => $dd6357e5eb72c764$export$5880b8b5730aff45);
$parcel$export(module.exports, "copy", () => $dd6357e5eb72c764$export$784d13d8ee351f07);
$parcel$export(module.exports, "next", () => $dd6357e5eb72c764$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $dd6357e5eb72c764$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "slice", () => $dd6357e5eb72c764$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $dd6357e5eb72c764$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $dd6357e5eb72c764$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $dd6357e5eb72c764$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $dd6357e5eb72c764$export$410ac95b9ec204b8);
$parcel$export(module.exports, "compile", () => $dd6357e5eb72c764$export$ef7acd7185315e22);
$parcel$export(module.exports, "serialize", () => $dd6357e5eb72c764$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $dd6357e5eb72c764$export$fac44ee5b035f737);
$parcel$export(module.exports, "middleware", () => $dd6357e5eb72c764$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $dd6357e5eb72c764$export$38bcb760f1d4871c);
var $dd6357e5eb72c764$export$71ad59f2e432cfe8 = "-ms-";
var $dd6357e5eb72c764$export$2c0f367103c8d01c = "-moz-";
var $dd6357e5eb72c764$export$39dfd62a25e0fe93 = "-webkit-";
var $dd6357e5eb72c764$export$a29989082612d0d9 = "comm";
var $dd6357e5eb72c764$export$aa3a2e812ca8570d = "rule";
var $dd6357e5eb72c764$export$527d108ccf083c2b = "decl";
var $dd6357e5eb72c764$export$d3d35020fa5b54f0 = "@page";
var $dd6357e5eb72c764$export$500415a86c544f73 = "@media";
var $dd6357e5eb72c764$export$a763edbf796b780a = "@import";
var $dd6357e5eb72c764$export$2790aeb8b4e5c826 = "@charset";
var $dd6357e5eb72c764$export$1cc683e23b84b133 = "@viewport";
var $dd6357e5eb72c764$export$9447a5efea57e862 = "@supports";
var $dd6357e5eb72c764$export$ef011b4e114b1fba = "@document";
var $dd6357e5eb72c764$export$6aad947bda0f3f46 = "@namespace";
var $dd6357e5eb72c764$export$b44a8529a35fcb60 = "@keyframes";
var $dd6357e5eb72c764$export$2c16de31893252e6 = "@font-face";
var $dd6357e5eb72c764$export$3d846dd52e150c6f = "@counter-style";
var $dd6357e5eb72c764$export$22314bfbb57653fe = "@font-feature-values";
var $dd6357e5eb72c764$export$d773506282b3cfe6 = "@layer";
var $dd6357e5eb72c764$export$2335f513bbd82c6d = Math.abs;
var $dd6357e5eb72c764$export$6788812c4e6611e6 = String.fromCharCode;
var $dd6357e5eb72c764$export$e6e34fd1f2686227 = Object.assign;
function $dd6357e5eb72c764$export$d6af199866bfb566(e, r) {
    return $dd6357e5eb72c764$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $dd6357e5eb72c764$export$a9db5e087081082d(e, 0)) << 2 ^ $dd6357e5eb72c764$export$a9db5e087081082d(e, 1)) << 2 ^ $dd6357e5eb72c764$export$a9db5e087081082d(e, 2)) << 2 ^ $dd6357e5eb72c764$export$a9db5e087081082d(e, 3) : 0;
}
function $dd6357e5eb72c764$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $dd6357e5eb72c764$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $dd6357e5eb72c764$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $dd6357e5eb72c764$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $dd6357e5eb72c764$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $dd6357e5eb72c764$export$36776f635604f274(e) {
    return e.length;
}
function $dd6357e5eb72c764$export$f9084667e487ed46(e) {
    return e.length;
}
function $dd6357e5eb72c764$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $dd6357e5eb72c764$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $dd6357e5eb72c764$export$53f1d5ea8de3d7c = 1;
var $dd6357e5eb72c764$export$4e0c71f277ca26b3 = 1;
var $dd6357e5eb72c764$export$f24224f1c91d8156 = 0;
var $dd6357e5eb72c764$export$5880b8b5730aff45 = 0;
var $dd6357e5eb72c764$export$c0306caf338ac095 = 0;
var $dd6357e5eb72c764$export$30a86d91af8ff6e6 = "";
function $dd6357e5eb72c764$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $dd6357e5eb72c764$export$53f1d5ea8de3d7c,
        column: $dd6357e5eb72c764$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $dd6357e5eb72c764$export$784d13d8ee351f07(e, r) {
    return $dd6357e5eb72c764$export$e6e34fd1f2686227($dd6357e5eb72c764$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $dd6357e5eb72c764$export$eba6f6f03b0a92e7() {
    return $dd6357e5eb72c764$export$c0306caf338ac095;
}
function $dd6357e5eb72c764$export$232faf9add678146() {
    $dd6357e5eb72c764$export$c0306caf338ac095 = $dd6357e5eb72c764$export$5880b8b5730aff45 > 0 ? $dd6357e5eb72c764$export$a9db5e087081082d($dd6357e5eb72c764$export$30a86d91af8ff6e6, --$dd6357e5eb72c764$export$5880b8b5730aff45) : 0;
    if ($dd6357e5eb72c764$export$4e0c71f277ca26b3--, $dd6357e5eb72c764$export$c0306caf338ac095 === 10) $dd6357e5eb72c764$export$4e0c71f277ca26b3 = 1, $dd6357e5eb72c764$export$53f1d5ea8de3d7c--;
    return $dd6357e5eb72c764$export$c0306caf338ac095;
}
function $dd6357e5eb72c764$export$48cfd1e771a65c4f() {
    $dd6357e5eb72c764$export$c0306caf338ac095 = $dd6357e5eb72c764$export$5880b8b5730aff45 < $dd6357e5eb72c764$export$f24224f1c91d8156 ? $dd6357e5eb72c764$export$a9db5e087081082d($dd6357e5eb72c764$export$30a86d91af8ff6e6, $dd6357e5eb72c764$export$5880b8b5730aff45++) : 0;
    if ($dd6357e5eb72c764$export$4e0c71f277ca26b3++, $dd6357e5eb72c764$export$c0306caf338ac095 === 10) $dd6357e5eb72c764$export$4e0c71f277ca26b3 = 1, $dd6357e5eb72c764$export$53f1d5ea8de3d7c++;
    return $dd6357e5eb72c764$export$c0306caf338ac095;
}
function $dd6357e5eb72c764$export$4d3fb11e950abb9e() {
    return $dd6357e5eb72c764$export$a9db5e087081082d($dd6357e5eb72c764$export$30a86d91af8ff6e6, $dd6357e5eb72c764$export$5880b8b5730aff45);
}
function $dd6357e5eb72c764$export$e88cb2efb12ae807() {
    return $dd6357e5eb72c764$export$5880b8b5730aff45;
}
function $dd6357e5eb72c764$export$58adb3bec8346d0f(e, r) {
    return $dd6357e5eb72c764$export$2f35ab04d2335697($dd6357e5eb72c764$export$30a86d91af8ff6e6, e, r);
}
function $dd6357e5eb72c764$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $dd6357e5eb72c764$export$2de70f21292aac9e(e) {
    return $dd6357e5eb72c764$export$53f1d5ea8de3d7c = $dd6357e5eb72c764$export$4e0c71f277ca26b3 = 1, $dd6357e5eb72c764$export$f24224f1c91d8156 = $dd6357e5eb72c764$export$36776f635604f274($dd6357e5eb72c764$export$30a86d91af8ff6e6 = e), $dd6357e5eb72c764$export$5880b8b5730aff45 = 0, [];
}
function $dd6357e5eb72c764$export$45918ac1574455b1(e) {
    return $dd6357e5eb72c764$export$30a86d91af8ff6e6 = "", e;
}
function $dd6357e5eb72c764$export$410ac95b9ec204b8(e) {
    return $dd6357e5eb72c764$export$87c2784dc9fc4ab($dd6357e5eb72c764$export$58adb3bec8346d0f($dd6357e5eb72c764$export$5880b8b5730aff45 - 1, $dd6357e5eb72c764$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $dd6357e5eb72c764$export$660b2ee2d4fb4eff(e) {
    return $dd6357e5eb72c764$export$45918ac1574455b1($dd6357e5eb72c764$export$5f8c09e3ae6f64e1($dd6357e5eb72c764$export$2de70f21292aac9e(e)));
}
function $dd6357e5eb72c764$export$7af1228ff777d175(e) {
    while($dd6357e5eb72c764$export$c0306caf338ac095 = $dd6357e5eb72c764$export$4d3fb11e950abb9e())if ($dd6357e5eb72c764$export$c0306caf338ac095 < 33) $dd6357e5eb72c764$export$48cfd1e771a65c4f();
    else break;
    return $dd6357e5eb72c764$export$9e1725a4cfeada27(e) > 2 || $dd6357e5eb72c764$export$9e1725a4cfeada27($dd6357e5eb72c764$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $dd6357e5eb72c764$export$5f8c09e3ae6f64e1(e) {
    while($dd6357e5eb72c764$export$48cfd1e771a65c4f())switch($dd6357e5eb72c764$export$9e1725a4cfeada27($dd6357e5eb72c764$export$c0306caf338ac095)){
        case 0:
            $dd6357e5eb72c764$export$10d8903dec122b9d($dd6357e5eb72c764$export$c2ab62c7bf24634($dd6357e5eb72c764$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $dd6357e5eb72c764$export$10d8903dec122b9d($dd6357e5eb72c764$export$410ac95b9ec204b8($dd6357e5eb72c764$export$c0306caf338ac095), e);
            break;
        default:
            $dd6357e5eb72c764$export$10d8903dec122b9d($dd6357e5eb72c764$export$6788812c4e6611e6($dd6357e5eb72c764$export$c0306caf338ac095), e);
    }
    return e;
}
function $dd6357e5eb72c764$export$955ba06d119e085e(e, r) {
    while(--r && $dd6357e5eb72c764$export$48cfd1e771a65c4f())if ($dd6357e5eb72c764$export$c0306caf338ac095 < 48 || $dd6357e5eb72c764$export$c0306caf338ac095 > 102 || $dd6357e5eb72c764$export$c0306caf338ac095 > 57 && $dd6357e5eb72c764$export$c0306caf338ac095 < 65 || $dd6357e5eb72c764$export$c0306caf338ac095 > 70 && $dd6357e5eb72c764$export$c0306caf338ac095 < 97) break;
    return $dd6357e5eb72c764$export$58adb3bec8346d0f(e, $dd6357e5eb72c764$export$e88cb2efb12ae807() + (r < 6 && $dd6357e5eb72c764$export$4d3fb11e950abb9e() == 32 && $dd6357e5eb72c764$export$48cfd1e771a65c4f() == 32));
}
function $dd6357e5eb72c764$export$c889f2fcc19dbf12(e) {
    while($dd6357e5eb72c764$export$48cfd1e771a65c4f())switch($dd6357e5eb72c764$export$c0306caf338ac095){
        case e:
            return $dd6357e5eb72c764$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $dd6357e5eb72c764$export$c889f2fcc19dbf12($dd6357e5eb72c764$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $dd6357e5eb72c764$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $dd6357e5eb72c764$export$48cfd1e771a65c4f();
            break;
    }
    return $dd6357e5eb72c764$export$5880b8b5730aff45;
}
function $dd6357e5eb72c764$export$4254d4e2b3745c4c(e, r) {
    while($dd6357e5eb72c764$export$48cfd1e771a65c4f())if (e + $dd6357e5eb72c764$export$c0306caf338ac095 === 57) break;
    else if (e + $dd6357e5eb72c764$export$c0306caf338ac095 === 84 && $dd6357e5eb72c764$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $dd6357e5eb72c764$export$58adb3bec8346d0f(r, $dd6357e5eb72c764$export$5880b8b5730aff45 - 1) + "*" + $dd6357e5eb72c764$export$6788812c4e6611e6(e === 47 ? e : $dd6357e5eb72c764$export$48cfd1e771a65c4f());
}
function $dd6357e5eb72c764$export$c2ab62c7bf24634(e) {
    while(!$dd6357e5eb72c764$export$9e1725a4cfeada27($dd6357e5eb72c764$export$4d3fb11e950abb9e()))$dd6357e5eb72c764$export$48cfd1e771a65c4f();
    return $dd6357e5eb72c764$export$58adb3bec8346d0f(e, $dd6357e5eb72c764$export$5880b8b5730aff45);
}
function $dd6357e5eb72c764$export$ef7acd7185315e22(e) {
    return $dd6357e5eb72c764$export$45918ac1574455b1($dd6357e5eb72c764$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $dd6357e5eb72c764$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $dd6357e5eb72c764$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $dd6357e5eb72c764$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $dd6357e5eb72c764$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($dd6357e5eb72c764$export$f8e21b1e77979a08(j += $dd6357e5eb72c764$export$77ad94ebf1c2b9ed($dd6357e5eb72c764$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $dd6357e5eb72c764$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $dd6357e5eb72c764$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $dd6357e5eb72c764$export$955ba06d119e085e($dd6357e5eb72c764$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($dd6357e5eb72c764$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $dd6357e5eb72c764$export$10d8903dec122b9d($dd6357e5eb72c764$export$4a34f930e789283c($dd6357e5eb72c764$export$4254d4e2b3745c4c($dd6357e5eb72c764$export$48cfd1e771a65c4f(), $dd6357e5eb72c764$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $dd6357e5eb72c764$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $dd6357e5eb72c764$export$36776f635604f274(j) - l) $dd6357e5eb72c764$export$10d8903dec122b9d(p > 32 ? $dd6357e5eb72c764$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $dd6357e5eb72c764$export$f8483753829ec8f3($dd6357e5eb72c764$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $dd6357e5eb72c764$export$10d8903dec122b9d(y = $dd6357e5eb72c764$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $dd6357e5eb72c764$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $dd6357e5eb72c764$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $dd6357e5eb72c764$export$98e6a39c04603d36(e, y, y, n && $dd6357e5eb72c764$export$10d8903dec122b9d($dd6357e5eb72c764$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $dd6357e5eb72c764$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $dd6357e5eb72c764$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $dd6357e5eb72c764$export$232faf9add678146() == 125) continue;
            }
            switch(j += $dd6357e5eb72c764$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($dd6357e5eb72c764$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($dd6357e5eb72c764$export$4d3fb11e950abb9e() === 45) j += $dd6357e5eb72c764$export$410ac95b9ec204b8($dd6357e5eb72c764$export$48cfd1e771a65c4f());
                    v = $dd6357e5eb72c764$export$4d3fb11e950abb9e(), o = l = $dd6357e5eb72c764$export$36776f635604f274(g = j += $dd6357e5eb72c764$export$c2ab62c7bf24634($dd6357e5eb72c764$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $dd6357e5eb72c764$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $dd6357e5eb72c764$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $dd6357e5eb72c764$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $dd6357e5eb72c764$export$2f35ab04d2335697(e, v + 1, v = $dd6357e5eb72c764$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $dd6357e5eb72c764$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $dd6357e5eb72c764$export$35059013cd4a06db(e, r, a, s === 0 ? $dd6357e5eb72c764$export$aa3a2e812ca8570d : i, f, o, l);
}
function $dd6357e5eb72c764$export$4a34f930e789283c(e, r, a) {
    return $dd6357e5eb72c764$export$35059013cd4a06db(e, r, a, $dd6357e5eb72c764$export$a29989082612d0d9, $dd6357e5eb72c764$export$6788812c4e6611e6($dd6357e5eb72c764$export$eba6f6f03b0a92e7()), $dd6357e5eb72c764$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $dd6357e5eb72c764$export$f8483753829ec8f3(e, r, a, n) {
    return $dd6357e5eb72c764$export$35059013cd4a06db(e, r, a, $dd6357e5eb72c764$export$527d108ccf083c2b, $dd6357e5eb72c764$export$2f35ab04d2335697(e, 0, n), $dd6357e5eb72c764$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $dd6357e5eb72c764$export$82e9f45cca5ba907(n, c, s) {
    switch($dd6357e5eb72c764$export$d6af199866bfb566(n, c)){
        case 5103:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $dd6357e5eb72c764$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$2c0f367103c8d01c + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($dd6357e5eb72c764$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "box-$1$2" + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "flex-item-" + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$dd6357e5eb72c764$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "grid-row-" + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "flex-line-pack" + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "box-" + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "-grow", "") + $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $dd6357e5eb72c764$export$39dfd62a25e0fe93 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed($dd6357e5eb72c764$export$77ad94ebf1c2b9ed($dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed($dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "box-pack:$3" + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $dd6357e5eb72c764$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$dd6357e5eb72c764$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "grid-column-align" + $dd6357e5eb72c764$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $dd6357e5eb72c764$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$dd6357e5eb72c764$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$dd6357e5eb72c764$export$f8e21b1e77979a08(s, "span") ? $dd6357e5eb72c764$export$4659b591c19bdf3d(s, /\d+/) : +$dd6357e5eb72c764$export$4659b591c19bdf3d(s, /\d+/) - +$dd6357e5eb72c764$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $dd6357e5eb72c764$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $dd6357e5eb72c764$export$71ad59f2e432cfe8 + $dd6357e5eb72c764$export$77ad94ebf1c2b9ed($dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($dd6357e5eb72c764$export$36776f635604f274(n) - 1 - c > 6) switch($dd6357e5eb72c764$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($dd6357e5eb72c764$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $dd6357e5eb72c764$export$2c0f367103c8d01c + ($dd6357e5eb72c764$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$dd6357e5eb72c764$export$f8e21b1e77979a08(n, "stretch") ? $dd6357e5eb72c764$export$82e9f45cca5ba907($dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $dd6357e5eb72c764$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $dd6357e5eb72c764$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($dd6357e5eb72c764$export$a9db5e087081082d(n, c + 6) === 121) return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, ":", ":" + $dd6357e5eb72c764$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($dd6357e5eb72c764$export$a9db5e087081082d(n, $dd6357e5eb72c764$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $dd6357e5eb72c764$export$39dfd62a25e0fe93 + ($dd6357e5eb72c764$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, ":", ":" + $dd6357e5eb72c764$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $dd6357e5eb72c764$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $dd6357e5eb72c764$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $dd6357e5eb72c764$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $dd6357e5eb72c764$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $dd6357e5eb72c764$export$a763edbf796b780a:
        case $dd6357e5eb72c764$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $dd6357e5eb72c764$export$a29989082612d0d9:
            return "";
        case $dd6357e5eb72c764$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $dd6357e5eb72c764$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $dd6357e5eb72c764$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $dd6357e5eb72c764$export$36776f635604f274(a = $dd6357e5eb72c764$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $dd6357e5eb72c764$export$5a7767152ae0305f(e) {
    var r = $dd6357e5eb72c764$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $dd6357e5eb72c764$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $dd6357e5eb72c764$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $dd6357e5eb72c764$export$527d108ccf083c2b:
                n.return = $dd6357e5eb72c764$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $dd6357e5eb72c764$export$b44a8529a35fcb60:
                return $dd6357e5eb72c764$export$dfdc1655ccc5b9cb([
                    $dd6357e5eb72c764$export$784d13d8ee351f07(n, {
                        value: $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $dd6357e5eb72c764$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $dd6357e5eb72c764$export$aa3a2e812ca8570d:
                if (n.length) return $dd6357e5eb72c764$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($dd6357e5eb72c764$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $dd6357e5eb72c764$export$dfdc1655ccc5b9cb([
                                $dd6357e5eb72c764$export$784d13d8ee351f07(n, {
                                    props: [
                                        $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $dd6357e5eb72c764$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $dd6357e5eb72c764$export$dfdc1655ccc5b9cb([
                                $dd6357e5eb72c764$export$784d13d8ee351f07(n, {
                                    props: [
                                        $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $dd6357e5eb72c764$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $dd6357e5eb72c764$export$784d13d8ee351f07(n, {
                                    props: [
                                        $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $dd6357e5eb72c764$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $dd6357e5eb72c764$export$784d13d8ee351f07(n, {
                                    props: [
                                        $dd6357e5eb72c764$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $dd6357e5eb72c764$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $dd6357e5eb72c764$export$76a88f7de6507443(e) {
    switch(e.type){
        case $dd6357e5eb72c764$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $dd6357e5eb72c764$export$1be1fc439b849fdf($dd6357e5eb72c764$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($dd6357e5eb72c764$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $dd6357e5eb72c764$export$2f35ab04d2335697(r, 1, $dd6357e5eb72c764$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $dd6357e5eb72c764$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $dd6357e5eb72c764$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $dd6357e5eb72c764$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("5Gmxp", function(module, exports) {

$parcel$export(module.exports, "default", () => $42325b88f1a774ee$export$2e2bcd8739ae039);
var $42325b88f1a774ee$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});




parcelRegister("kr1zr", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $ee078c25dbe3e9d0$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ee078c25dbe3e9d0$var$_GlobalStyles.default;
    }
});

var $ee078c25dbe3e9d0$var$_GlobalStyles = $ee078c25dbe3e9d0$require$_interopRequireDefault((parcelRequire("jZiJH")));

});
parcelRegister("jZiJH", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $e8d23f677b5b1acc$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e8d23f677b5b1acc$var$GlobalStyles;

var $e8d23f677b5b1acc$var$_propTypes = $e8d23f677b5b1acc$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $jjlaj = parcelRequire("jjlaj");

var $ayMG0 = parcelRequire("ayMG0");
function $e8d23f677b5b1acc$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $e8d23f677b5b1acc$var$GlobalStyles(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($e8d23f677b5b1acc$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($jjlaj.Global, {
        styles: globalStyles
    });
}

});



parcelRegister("i3XwU", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $d266af2c419d0b66$export$a7c73072b1a182ae, (v) => $d266af2c419d0b66$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $d266af2c419d0b66$export$9f27bc3417b4524d, (v) => $d266af2c419d0b66$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $d266af2c419d0b66$export$db77ccec0bb4ccac, (v) => $d266af2c419d0b66$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $d266af2c419d0b66$export$8392c0c9d3dcbd35, (v) => $d266af2c419d0b66$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $d266af2c419d0b66$export$ffb0004e005737fa, (v) => $d266af2c419d0b66$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $d266af2c419d0b66$export$b624eff549462981, (v) => $d266af2c419d0b66$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $d266af2c419d0b66$export$7897aa7841a5380c, (v) => $d266af2c419d0b66$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $d266af2c419d0b66$export$602eac185826482c, (v) => $d266af2c419d0b66$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $d266af2c419d0b66$export$e2c29f18771995cb, (v) => $d266af2c419d0b66$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $d266af2c419d0b66$export$5f8d39834fd61797, (v) => $d266af2c419d0b66$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $d266af2c419d0b66$export$74bf444e3cd11ea5, (v) => $d266af2c419d0b66$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $d266af2c419d0b66$export$998bcd577473dd93, (v) => $d266af2c419d0b66$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $d266af2c419d0b66$export$b706b080d889d2c9, (v) => $d266af2c419d0b66$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $d266af2c419d0b66$export$5be5a87408f70ddc, (v) => $d266af2c419d0b66$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $d266af2c419d0b66$export$45a5e7f76e0caa8d, (v) => $d266af2c419d0b66$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $d266af2c419d0b66$export$455c2e768291efa6, (v) => $d266af2c419d0b66$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $d266af2c419d0b66$export$9522e17588c12572, (v) => $d266af2c419d0b66$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $d266af2c419d0b66$export$2110ac352bb060b9, (v) => $d266af2c419d0b66$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $d266af2c419d0b66$export$56885ab8b9c456ab, (v) => $d266af2c419d0b66$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $d266af2c419d0b66$export$d927fcb6adf8f9de, (v) => $d266af2c419d0b66$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $d266af2c419d0b66$export$b82d16f27459e05a, (v) => $d266af2c419d0b66$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $d266af2c419d0b66$export$522c17b4f5e123e8, (v) => $d266af2c419d0b66$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $d266af2c419d0b66$export$1aabd8a0274ecfd6, (v) => $d266af2c419d0b66$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $d266af2c419d0b66$export$3d6c20d97e46b957, (v) => $d266af2c419d0b66$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $d266af2c419d0b66$export$9b621391a187a31a, (v) => $d266af2c419d0b66$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $d266af2c419d0b66$export$f5bbd400c2f4426f, (v) => $d266af2c419d0b66$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d266af2c419d0b66$export$a7c73072b1a182ae;
var $d266af2c419d0b66$export$9f27bc3417b4524d;
var $d266af2c419d0b66$export$db77ccec0bb4ccac;
var $d266af2c419d0b66$export$8392c0c9d3dcbd35;
var $d266af2c419d0b66$export$ffb0004e005737fa;
var $d266af2c419d0b66$export$b624eff549462981;
var $d266af2c419d0b66$export$7897aa7841a5380c;
var $d266af2c419d0b66$export$602eac185826482c;
var $d266af2c419d0b66$export$e2c29f18771995cb;
var $d266af2c419d0b66$export$5f8d39834fd61797;
var $d266af2c419d0b66$export$74bf444e3cd11ea5;
var $d266af2c419d0b66$export$998bcd577473dd93;
var $d266af2c419d0b66$export$b706b080d889d2c9;
var $d266af2c419d0b66$export$5be5a87408f70ddc;
var $d266af2c419d0b66$export$45a5e7f76e0caa8d;
var $d266af2c419d0b66$export$455c2e768291efa6;
var $d266af2c419d0b66$export$9522e17588c12572;
var $d266af2c419d0b66$export$2110ac352bb060b9;
var $d266af2c419d0b66$export$56885ab8b9c456ab;
var $d266af2c419d0b66$export$d927fcb6adf8f9de;
var $d266af2c419d0b66$export$b82d16f27459e05a;
var $d266af2c419d0b66$export$522c17b4f5e123e8;
var $d266af2c419d0b66$export$1aabd8a0274ecfd6;
var $d266af2c419d0b66$export$3d6c20d97e46b957;
var $d266af2c419d0b66$export$9b621391a187a31a;
var $d266af2c419d0b66$export$f5bbd400c2f4426f;
"use strict";
var $d266af2c419d0b66$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d266af2c419d0b66$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $d266af2c419d0b66$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $d266af2c419d0b66$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $d266af2c419d0b66$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $d266af2c419d0b66$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $d266af2c419d0b66$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $d266af2c419d0b66$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $d266af2c419d0b66$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $d266af2c419d0b66$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $d266af2c419d0b66$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $d266af2c419d0b66$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $d266af2c419d0b66$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $d266af2c419d0b66$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $d266af2c419d0b66$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $d266af2c419d0b66$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $d266af2c419d0b66$var$REACT_FRAGMENT_TYPE:
                    case $d266af2c419d0b66$var$REACT_PROFILER_TYPE:
                    case $d266af2c419d0b66$var$REACT_STRICT_MODE_TYPE:
                    case $d266af2c419d0b66$var$REACT_SUSPENSE_TYPE:
                    case $d266af2c419d0b66$var$REACT_SUSPENSE_LIST_TYPE:
                    case $d266af2c419d0b66$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $d266af2c419d0b66$var$REACT_CONTEXT_TYPE:
                            case $d266af2c419d0b66$var$REACT_FORWARD_REF_TYPE:
                            case $d266af2c419d0b66$var$REACT_LAZY_TYPE:
                            case $d266af2c419d0b66$var$REACT_MEMO_TYPE:
                                return object;
                            case $d266af2c419d0b66$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $d266af2c419d0b66$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$d266af2c419d0b66$export$a7c73072b1a182ae = $d266af2c419d0b66$var$REACT_CONSUMER_TYPE;
$d266af2c419d0b66$export$9f27bc3417b4524d = $d266af2c419d0b66$var$REACT_CONTEXT_TYPE;
$d266af2c419d0b66$export$db77ccec0bb4ccac = $d266af2c419d0b66$var$REACT_ELEMENT_TYPE;
$d266af2c419d0b66$export$8392c0c9d3dcbd35 = $d266af2c419d0b66$var$REACT_FORWARD_REF_TYPE;
$d266af2c419d0b66$export$ffb0004e005737fa = $d266af2c419d0b66$var$REACT_FRAGMENT_TYPE;
$d266af2c419d0b66$export$b624eff549462981 = $d266af2c419d0b66$var$REACT_LAZY_TYPE;
$d266af2c419d0b66$export$7897aa7841a5380c = $d266af2c419d0b66$var$REACT_MEMO_TYPE;
$d266af2c419d0b66$export$602eac185826482c = $d266af2c419d0b66$var$REACT_PORTAL_TYPE;
$d266af2c419d0b66$export$e2c29f18771995cb = $d266af2c419d0b66$var$REACT_PROFILER_TYPE;
$d266af2c419d0b66$export$5f8d39834fd61797 = $d266af2c419d0b66$var$REACT_STRICT_MODE_TYPE;
$d266af2c419d0b66$export$74bf444e3cd11ea5 = $d266af2c419d0b66$var$REACT_SUSPENSE_TYPE;
$d266af2c419d0b66$export$998bcd577473dd93 = $d266af2c419d0b66$var$REACT_SUSPENSE_LIST_TYPE;
$d266af2c419d0b66$export$b706b080d889d2c9 = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_CONSUMER_TYPE;
};
$d266af2c419d0b66$export$5be5a87408f70ddc = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_CONTEXT_TYPE;
};
$d266af2c419d0b66$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $d266af2c419d0b66$var$REACT_ELEMENT_TYPE;
};
$d266af2c419d0b66$export$455c2e768291efa6 = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_FORWARD_REF_TYPE;
};
$d266af2c419d0b66$export$9522e17588c12572 = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_FRAGMENT_TYPE;
};
$d266af2c419d0b66$export$2110ac352bb060b9 = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_LAZY_TYPE;
};
$d266af2c419d0b66$export$56885ab8b9c456ab = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_MEMO_TYPE;
};
$d266af2c419d0b66$export$d927fcb6adf8f9de = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_PORTAL_TYPE;
};
$d266af2c419d0b66$export$b82d16f27459e05a = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_PROFILER_TYPE;
};
$d266af2c419d0b66$export$522c17b4f5e123e8 = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_STRICT_MODE_TYPE;
};
$d266af2c419d0b66$export$1aabd8a0274ecfd6 = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_SUSPENSE_TYPE;
};
$d266af2c419d0b66$export$3d6c20d97e46b957 = function(object) {
    return $d266af2c419d0b66$var$typeOf(object) === $d266af2c419d0b66$var$REACT_SUSPENSE_LIST_TYPE;
};
$d266af2c419d0b66$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $d266af2c419d0b66$var$REACT_FRAGMENT_TYPE || type === $d266af2c419d0b66$var$REACT_PROFILER_TYPE || type === $d266af2c419d0b66$var$REACT_STRICT_MODE_TYPE || type === $d266af2c419d0b66$var$REACT_SUSPENSE_TYPE || type === $d266af2c419d0b66$var$REACT_SUSPENSE_LIST_TYPE || type === $d266af2c419d0b66$var$REACT_VIEW_TRANSITION_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $d266af2c419d0b66$var$REACT_LAZY_TYPE || type.$$typeof === $d266af2c419d0b66$var$REACT_MEMO_TYPE || type.$$typeof === $d266af2c419d0b66$var$REACT_CONTEXT_TYPE || type.$$typeof === $d266af2c419d0b66$var$REACT_CONSUMER_TYPE || type.$$typeof === $d266af2c419d0b66$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $d266af2c419d0b66$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$d266af2c419d0b66$export$f5bbd400c2f4426f = $d266af2c419d0b66$var$typeOf;

});

parcelRegister("eq0W7", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $a7f4385d2aba65d5$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a7f4385d2aba65d5$var$_formatMuiErrorMessage.default;
    }
});

var $a7f4385d2aba65d5$var$_formatMuiErrorMessage = $a7f4385d2aba65d5$require$_interopRequireDefault((parcelRequire("7AAQf")));

});
parcelRegister("7AAQf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $586879313e3e5566$var$formatMuiErrorMessage;
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $586879313e3e5566$var$formatMuiErrorMessage(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});


parcelRegister("joyms", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $e1eae99d2d02058f$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e1eae99d2d02058f$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e1eae99d2d02058f$var$_GlobalStyles.default;
    }
});

var $e1eae99d2d02058f$var$_GlobalStyles = $e1eae99d2d02058f$require$_interopRequireWildcard((parcelRequire("htiPL")));
Object.keys($e1eae99d2d02058f$var$_GlobalStyles).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e1eae99d2d02058f$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e1eae99d2d02058f$var$_GlobalStyles[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e1eae99d2d02058f$var$_GlobalStyles[key];
        }
    });
});

});
parcelRegister("htiPL", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $cb83c119de87f2cd$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb83c119de87f2cd$var$_propTypes = $cb83c119de87f2cd$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $keaWW = parcelRequire("keaWW");

var $cb83c119de87f2cd$var$_useTheme = $cb83c119de87f2cd$require$_interopRequireDefault((parcelRequire("fZXUE")));

var $ayMG0 = parcelRequire("ayMG0");
function $cb83c119de87f2cd$var$wrapGlobalLayer(styles) {
    const serialized = (0, $keaWW.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $cb83c119de87f2cd$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $cb83c119de87f2cd$var$_useTheme.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $cb83c119de87f2cd$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $cb83c119de87f2cd$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $cb83c119de87f2cd$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($keaWW.GlobalStyles, {
        styles: globalStyles
    });
}
var $cb83c119de87f2cd$var$_default = module.exports.default = $cb83c119de87f2cd$var$GlobalStyles;

});
parcelRegister("fZXUE", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $ba5b06ead03e9709$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ba5b06ead03e9709$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ba5b06ead03e9709$var$_useTheme.default;
    }
});

var $ba5b06ead03e9709$var$_useTheme = $ba5b06ead03e9709$require$_interopRequireWildcard((parcelRequire("bxyP4")));
Object.keys($ba5b06ead03e9709$var$_useTheme).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ba5b06ead03e9709$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ba5b06ead03e9709$var$_useTheme[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ba5b06ead03e9709$var$_useTheme[key];
        }
    });
});

});
parcelRegister("bxyP4", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $866dc9d80fa3fbec$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.systemDefaultTheme = module.exports.default = void 0;

var $866dc9d80fa3fbec$var$_createTheme = $866dc9d80fa3fbec$require$_interopRequireDefault((parcelRequire("bFSYU")));

var $866dc9d80fa3fbec$var$_useThemeWithoutDefault = $866dc9d80fa3fbec$require$_interopRequireDefault((parcelRequire("4P3l1")));
const $866dc9d80fa3fbec$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $866dc9d80fa3fbec$var$_createTheme.default)();
function $866dc9d80fa3fbec$var$useTheme(defaultTheme = $866dc9d80fa3fbec$var$systemDefaultTheme) {
    return (0, $866dc9d80fa3fbec$var$_useThemeWithoutDefault.default)(defaultTheme);
}
var $866dc9d80fa3fbec$var$_default = module.exports.default = $866dc9d80fa3fbec$var$useTheme;

});
parcelRegister("bFSYU", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $87fe2c2e59e79ac4$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $87fe2c2e59e79ac4$var$_createTheme.default;
    }
});
Object.defineProperty(module.exports, "private_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $87fe2c2e59e79ac4$var$_createBreakpoints.default;
    }
});
Object.defineProperty(module.exports, "unstable_applyStyles", {
    enumerable: true,
    get: function() {
        return $87fe2c2e59e79ac4$var$_applyStyles.default;
    }
});

var $87fe2c2e59e79ac4$var$_createTheme = $87fe2c2e59e79ac4$require$_interopRequireDefault((parcelRequire("dizxS")));

var $87fe2c2e59e79ac4$var$_createBreakpoints = $87fe2c2e59e79ac4$require$_interopRequireDefault((parcelRequire("3pIg9")));

var $87fe2c2e59e79ac4$var$_applyStyles = $87fe2c2e59e79ac4$require$_interopRequireDefault((parcelRequire("ji50g")));

});
parcelRegister("dizxS", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $9ae8875ad5b18f46$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ae8875ad5b18f46$var$_deepmerge = $9ae8875ad5b18f46$require$_interopRequireDefault((parcelRequire("5nq0S")));

var $9ae8875ad5b18f46$var$_createBreakpoints = $9ae8875ad5b18f46$require$_interopRequireDefault((parcelRequire("3pIg9")));

var $9ae8875ad5b18f46$var$_cssContainerQueries = $9ae8875ad5b18f46$require$_interopRequireDefault((parcelRequire("doSJ6")));

var $9ae8875ad5b18f46$var$_shape = $9ae8875ad5b18f46$require$_interopRequireDefault((parcelRequire("48rpI")));

var $9ae8875ad5b18f46$var$_createSpacing = $9ae8875ad5b18f46$require$_interopRequireDefault((parcelRequire("gzAbx")));

var $9ae8875ad5b18f46$var$_styleFunctionSx = $9ae8875ad5b18f46$require$_interopRequireDefault((parcelRequire("4fSu5")));

var $9ae8875ad5b18f46$var$_defaultSxConfig = $9ae8875ad5b18f46$require$_interopRequireDefault((parcelRequire("lwvds")));

var $9ae8875ad5b18f46$var$_applyStyles = $9ae8875ad5b18f46$require$_interopRequireDefault((parcelRequire("ji50g")));
/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $9ae8875ad5b18f46$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $9ae8875ad5b18f46$var$_createBreakpoints.default)(breakpointsInput);
    const spacing = (0, $9ae8875ad5b18f46$var$_createSpacing.default)(spacingInput);
    let muiTheme = (0, $9ae8875ad5b18f46$var$_deepmerge.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...$9ae8875ad5b18f46$var$_shape.default,
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $9ae8875ad5b18f46$var$_cssContainerQueries.default)(muiTheme);
    muiTheme.applyStyles = $9ae8875ad5b18f46$var$_applyStyles.default;
    muiTheme = args.reduce((acc, argument)=>(0, $9ae8875ad5b18f46$var$_deepmerge.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...$9ae8875ad5b18f46$var$_defaultSxConfig.default,
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $9ae8875ad5b18f46$var$_styleFunctionSx.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.internal_cache = {};
    return muiTheme;
}
var $9ae8875ad5b18f46$var$_default = module.exports.default = $9ae8875ad5b18f46$var$createTheme;

});
parcelRegister("5nq0S", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $3ea34764623d1210$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3ea34764623d1210$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3ea34764623d1210$var$_deepmerge.default;
    }
});

var $3ea34764623d1210$var$_deepmerge = $3ea34764623d1210$require$_interopRequireWildcard((parcelRequire("kMDf4")));
Object.keys($3ea34764623d1210$var$_deepmerge).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($3ea34764623d1210$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $3ea34764623d1210$var$_deepmerge[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $3ea34764623d1210$var$_deepmerge[key];
        }
    });
});

});
parcelRegister("kMDf4", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $f216bafdae06df6c$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f216bafdae06df6c$var$deepmerge;
module.exports.isPlainObject = $f216bafdae06df6c$var$isPlainObject;

var $f216bafdae06df6c$var$React = $f216bafdae06df6c$require$_interopRequireWildcard((parcelRequire("acw62")));

var $iMVQd = parcelRequire("iMVQd");
// https://github.com/sindresorhus/is-plain-obj/blob/main/index.js
function $f216bafdae06df6c$var$isPlainObject(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $f216bafdae06df6c$var$deepClone(source) {
    if (/*#__PURE__*/ $f216bafdae06df6c$var$React.isValidElement(source) || (0, $iMVQd.isValidElementType)(source) || !$f216bafdae06df6c$var$isPlainObject(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $f216bafdae06df6c$var$deepClone(source[key]);
    });
    return output;
}
/**
 * Merge objects deeply.
 * It will shallow copy React elements.
 *
 * If `options.clone` is set to `false` the source object will be merged directly into the target object.
 *
 * @example
 * ```ts
 * deepmerge({ a: { b: 1 }, d: 2 }, { a: { c: 2 }, d: 4 });
 * // => { a: { b: 1, c: 2 }, d: 4 }
 * ````
 *
 * @param target The target object.
 * @param source The source object.
 * @param options The merge options.
 * @param options.clone Set to `false` to merge the source object directly into the target object.
 * @returns The merged object.
 */ function $f216bafdae06df6c$var$deepmerge(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($f216bafdae06df6c$var$isPlainObject(target) && $f216bafdae06df6c$var$isPlainObject(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $f216bafdae06df6c$var$React.isValidElement(source[key]) || (0, $iMVQd.isValidElementType)(source[key])) output[key] = source[key];
        else if ($f216bafdae06df6c$var$isPlainObject(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $f216bafdae06df6c$var$isPlainObject(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $f216bafdae06df6c$var$deepmerge(target[key], source[key], options);
        else if (options.clone) output[key] = $f216bafdae06df6c$var$isPlainObject(source[key]) ? $f216bafdae06df6c$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("iMVQd", function(module, exports) {
'use strict';

module.exports = (parcelRequire("i3XwU"));

});



parcelRegister("3pIg9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.breakpointKeys = void 0;
module.exports.default = $27c609ef6f95e7f6$var$createBreakpoints;
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $27c609ef6f95e7f6$var$breakpointKeys = module.exports.breakpointKeys = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
// Keep in sync with docs/src/pages/customization/breakpoints/breakpoints.md
// #host-reference
const $27c609ef6f95e7f6$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
// Keep in mind that @media is inclusive by the CSS specification.
function $27c609ef6f95e7f6$var$createBreakpoints(breakpoints) {
    const { values: values = {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $27c609ef6f95e7f6$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    const mediaKeys = [];
    for(let i = 0; i < keys.length; i += 1)mediaKeys.push(up(keys[i]));
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        internal_mediaKeys: mediaKeys,
        ...other
    };
}

});

parcelRegister("doSJ6", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $9c17f7cd5af0e46b$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $9c17f7cd5af0e46b$var$_cssContainerQueries.default;
    }
});
Object.defineProperty(module.exports, "getContainerQuery", {
    enumerable: true,
    get: function() {
        return $9c17f7cd5af0e46b$var$_cssContainerQueries.getContainerQuery;
    }
});
Object.defineProperty(module.exports, "isCqShorthand", {
    enumerable: true,
    get: function() {
        return $9c17f7cd5af0e46b$var$_cssContainerQueries.isCqShorthand;
    }
});
Object.defineProperty(module.exports, "sortContainerQueries", {
    enumerable: true,
    get: function() {
        return $9c17f7cd5af0e46b$var$_cssContainerQueries.sortContainerQueries;
    }
});

var $9c17f7cd5af0e46b$var$_cssContainerQueries = $9c17f7cd5af0e46b$require$_interopRequireWildcard((parcelRequire("9rBNe")));

});
parcelRegister("9rBNe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e03f3962e63ddc0$var$cssContainerQueries;
module.exports.getContainerQuery = $6e03f3962e63ddc0$var$getContainerQuery;
module.exports.isCqShorthand = $6e03f3962e63ddc0$var$isCqShorthand;
module.exports.sortContainerQueries = $6e03f3962e63ddc0$var$sortContainerQueries;
const $6e03f3962e63ddc0$var$MIN_WIDTH_PATTERN = /min-width:\s*([0-9.]+)/;
/**
 * WARN: Mutably updates the `css` object.
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 even though 40rem > 300px
 */ function $6e03f3962e63ddc0$var$sortContainerQueries(theme, css) {
    if (!theme.containerQueries || !$6e03f3962e63ddc0$var$hasContainerQuery(css)) return css;
    const keys = [];
    for(const key in css)if (key.startsWith('@container')) keys.push(key);
    keys.sort((a, b)=>{
        return +(a.match($6e03f3962e63ddc0$var$MIN_WIDTH_PATTERN)?.[1] || 0) - +(b.match($6e03f3962e63ddc0$var$MIN_WIDTH_PATTERN)?.[1] || 0);
    });
    const result = css;
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        const value = result[key];
        delete result[key];
        result[key] = value;
    }
    return result;
}
function $6e03f3962e63ddc0$var$hasContainerQuery(css) {
    for(const key in css){
        if (key.startsWith('@container')) return true;
    }
    return false;
}
function $6e03f3962e63ddc0$var$isCqShorthand(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $6e03f3962e63ddc0$var$getContainerQuery(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $6e03f3962e63ddc0$var$cssContainerQueries(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("48rpI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $302d2c9adb9dc7d8$var$shape = {
    borderRadius: 4
};
var $302d2c9adb9dc7d8$var$_default = module.exports.default = $302d2c9adb9dc7d8$var$shape;

});

parcelRegister("gzAbx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c10bfbd3e7e25b8c$var$createSpacing;

var $7GqeV = parcelRequire("7GqeV");
// The different signatures imply different meaning for their arguments that can't be expressed structurally.
// We express the difference with variable names.
function $c10bfbd3e7e25b8c$var$createSpacing(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $7GqeV.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("7GqeV", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $5980cf4fa85a6b4e$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5980cf4fa85a6b4e$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5980cf4fa85a6b4e$var$_spacing.default;
    }
});

var $5980cf4fa85a6b4e$var$_spacing = $5980cf4fa85a6b4e$require$_interopRequireWildcard((parcelRequire("hnxNg")));
Object.keys($5980cf4fa85a6b4e$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($5980cf4fa85a6b4e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $5980cf4fa85a6b4e$var$_spacing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $5980cf4fa85a6b4e$var$_spacing[key];
        }
    });
});

});
parcelRegister("hnxNg", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $ca6ecc564be596a5$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createUnarySpacing = $ca6ecc564be596a5$var$createUnarySpacing;
module.exports.createUnaryUnit = $ca6ecc564be596a5$var$createUnaryUnit;
module.exports.default = void 0;
module.exports.getValue = $ca6ecc564be596a5$var$getValue;
module.exports.paddingKeys = module.exports.padding = module.exports.marginKeys = module.exports.margin = void 0;

var $ca6ecc564be596a5$var$_responsivePropType = $ca6ecc564be596a5$require$_interopRequireDefault((parcelRequire("e6HWG")));

var $3dqBt = parcelRequire("3dqBt");

var $1H8cF = parcelRequire("1H8cF");
/* eslint-disable guard-for-in */ const $ca6ecc564be596a5$var$EMPTY_THEME = {
    internal_cache: {}
};
const $ca6ecc564be596a5$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $ca6ecc564be596a5$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $ca6ecc564be596a5$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
const $ca6ecc564be596a5$var$CSS_PROPERTIES = {};
for(const key in $ca6ecc564be596a5$var$properties)$ca6ecc564be596a5$var$CSS_PROPERTIES[key] = [
    $ca6ecc564be596a5$var$properties[key]
];
for(const keyProperty in $ca6ecc564be596a5$var$properties)for(const keyDirection in $ca6ecc564be596a5$var$directions){
    const property = $ca6ecc564be596a5$var$properties[keyProperty];
    const direction = $ca6ecc564be596a5$var$directions[keyDirection];
    const value = Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
    $ca6ecc564be596a5$var$CSS_PROPERTIES[keyProperty + keyDirection] = value;
}
for(const key in $ca6ecc564be596a5$var$aliases)$ca6ecc564be596a5$var$CSS_PROPERTIES[key] = $ca6ecc564be596a5$var$CSS_PROPERTIES[$ca6ecc564be596a5$var$aliases[key]];
/** @internal */ const $ca6ecc564be596a5$var$marginKeys = module.exports.marginKeys = new Set([
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
]);
/** @internal */ const $ca6ecc564be596a5$var$paddingKeys = module.exports.paddingKeys = new Set([
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
]);
const $ca6ecc564be596a5$var$spacingKeys = new Set([
    ...$ca6ecc564be596a5$var$marginKeys,
    ...$ca6ecc564be596a5$var$paddingKeys
]);
function $ca6ecc564be596a5$var$createUnaryUnit(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $1H8cF.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $ca6ecc564be596a5$var$createUnarySpacing(theme) {
    return $ca6ecc564be596a5$var$createUnaryUnit(theme, 'spacing', 8, 'spacing');
}
function $ca6ecc564be596a5$var$getValue(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
// Avoid allocations
const $ca6ecc564be596a5$var$container = [
    ''
];
function $ca6ecc564be596a5$var$style(props, keys) {
    const theme = props.theme ?? $ca6ecc564be596a5$var$EMPTY_THEME;
    const transformer = theme?.internal_cache?.unarySpacing ?? $ca6ecc564be596a5$var$createUnarySpacing(theme);
    const result = {};
    for(const prop in props){
        if (!keys.has(prop)) continue;
        const cssProperties = $ca6ecc564be596a5$var$CSS_PROPERTIES[prop] ?? ($ca6ecc564be596a5$var$container[0] = prop, $ca6ecc564be596a5$var$container);
        const propValue = props[prop];
        (0, $3dqBt.iterateBreakpoints)(result, props.theme, propValue, (mediaKey, value)=>{
            const target = mediaKey ? result[mediaKey] : result;
            for(let i = 0; i < cssProperties.length; i += 1)target[cssProperties[i]] = $ca6ecc564be596a5$var$getValue(transformer, value);
        });
    }
    return result;
}
function $ca6ecc564be596a5$var$marginFn(props) {
    return $ca6ecc564be596a5$var$style(props, $ca6ecc564be596a5$var$marginKeys);
}
$ca6ecc564be596a5$var$marginFn.propTypes = {};
$ca6ecc564be596a5$var$marginFn.filterProps = $ca6ecc564be596a5$var$marginKeys;
const $ca6ecc564be596a5$var$margin = module.exports.margin = $ca6ecc564be596a5$var$marginFn;
function $ca6ecc564be596a5$var$paddingFn(props) {
    return $ca6ecc564be596a5$var$style(props, $ca6ecc564be596a5$var$paddingKeys);
}
$ca6ecc564be596a5$var$paddingFn.propTypes = {};
$ca6ecc564be596a5$var$paddingFn.filterProps = $ca6ecc564be596a5$var$paddingKeys;
const $ca6ecc564be596a5$var$padding = module.exports.padding = $ca6ecc564be596a5$var$paddingFn;
function $ca6ecc564be596a5$var$spacingFn(props) {
    return $ca6ecc564be596a5$var$style(props, $ca6ecc564be596a5$var$spacingKeys);
}
$ca6ecc564be596a5$var$spacingFn.propTypes = {};
$ca6ecc564be596a5$var$spacingFn.filterProps = $ca6ecc564be596a5$var$spacingKeys;
const $ca6ecc564be596a5$var$spacing = $ca6ecc564be596a5$var$spacingFn;
var $ca6ecc564be596a5$var$_default = module.exports.default = $ca6ecc564be596a5$var$spacing;

});
parcelRegister("e6HWG", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $a453b6e497b1e9de$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a453b6e497b1e9de$var$_responsivePropType.default;
    }
});

var $a453b6e497b1e9de$var$_responsivePropType = $a453b6e497b1e9de$require$_interopRequireDefault((parcelRequire("4oexA")));

});
parcelRegister("4oexA", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $3324aec5fbb99935$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3324aec5fbb99935$var$_propTypes = $3324aec5fbb99935$require$_interopRequireDefault((parcelRequire("c9Z8w")));
const $3324aec5fbb99935$var$responsivePropType = {};
var $3324aec5fbb99935$var$_default = module.exports.default = $3324aec5fbb99935$var$responsivePropType;

});


parcelRegister("3dqBt", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $257738e4796475fc$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $257738e4796475fc$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $257738e4796475fc$var$_breakpoints.default;
    }
});

var $257738e4796475fc$var$_breakpoints = $257738e4796475fc$require$_interopRequireWildcard((parcelRequire("8Dcar")));
Object.keys($257738e4796475fc$var$_breakpoints).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($257738e4796475fc$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $257738e4796475fc$var$_breakpoints[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $257738e4796475fc$var$_breakpoints[key];
        }
    });
});

});
parcelRegister("8Dcar", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $648b6775c62ffb58$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_BREAKPOINTS = void 0;
module.exports.computeBreakpointsBase = $648b6775c62ffb58$var$computeBreakpointsBase;
module.exports.createEmptyBreakpointObject = $648b6775c62ffb58$var$createEmptyBreakpointObject;
module.exports.default = void 0;
module.exports.handleBreakpoints = $648b6775c62ffb58$var$handleBreakpoints;
module.exports.hasBreakpoint = $648b6775c62ffb58$var$hasBreakpoint;
module.exports.iterateBreakpoints = $648b6775c62ffb58$var$iterateBreakpoints;
module.exports.mergeBreakpointsInOrder = $648b6775c62ffb58$var$mergeBreakpointsInOrder;
module.exports.removeUnusedBreakpoints = $648b6775c62ffb58$var$removeUnusedBreakpoints;
module.exports.resolveBreakpointValues = $648b6775c62ffb58$var$resolveBreakpointValues;
module.exports.values = void 0;

var $648b6775c62ffb58$var$_propTypes = $648b6775c62ffb58$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $648b6775c62ffb58$var$_isObjectEmpty = $648b6775c62ffb58$require$_interopRequireDefault((parcelRequire("pu076")));

var $648b6775c62ffb58$var$_fastDeepAssign = $648b6775c62ffb58$require$_interopRequireDefault((parcelRequire("hr2ba")));

var $648b6775c62ffb58$var$_deepmerge = $648b6775c62ffb58$require$_interopRequireDefault((parcelRequire("5nq0S")));

var $648b6775c62ffb58$var$_merge = $648b6775c62ffb58$require$_interopRequireDefault((parcelRequire("1iGut")));

var $doSJ6 = parcelRequire("doSJ6");

var $648b6775c62ffb58$var$_createBreakpoints = $648b6775c62ffb58$require$_interopRequireDefault((parcelRequire("3pIg9")));
const $648b6775c62ffb58$var$EMPTY_THEME = {};
// The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.
/** @internal */ const $648b6775c62ffb58$var$values = module.exports.values = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $648b6775c62ffb58$var$DEFAULT_BREAKPOINTS = module.exports.DEFAULT_BREAKPOINTS = (0, $648b6775c62ffb58$var$_createBreakpoints.default)({
    values: $648b6775c62ffb58$var$values
});
const $648b6775c62ffb58$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $648b6775c62ffb58$var$values[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $648b6775c62ffb58$var$handleBreakpoints(props, propValue, styleFromPropValue) {
    const result = {};
    return $648b6775c62ffb58$var$iterateBreakpoints(result, props.theme, propValue, (mediaKey, value, initialKey)=>{
        const finalValue = styleFromPropValue(value, initialKey);
        if (mediaKey) result[mediaKey] = finalValue;
        else (0, $648b6775c62ffb58$var$_fastDeepAssign.default)(result, finalValue);
    });
}
function $648b6775c62ffb58$var$iterateBreakpoints(target, theme, propValue, callback) {
    theme ?? (theme = $648b6775c62ffb58$var$EMPTY_THEME);
    if (Array.isArray(propValue)) {
        const breakpoints = theme.breakpoints ?? $648b6775c62ffb58$var$DEFAULT_BREAKPOINTS;
        for(let i = 0; i < propValue.length; i += 1)$648b6775c62ffb58$var$buildBreakpoint(target, breakpoints.up(breakpoints.keys[i]), propValue[i], undefined, callback);
        return target;
    }
    if (typeof propValue === 'object') {
        const breakpoints = theme.breakpoints ?? $648b6775c62ffb58$var$DEFAULT_BREAKPOINTS;
        const breakpointValues = breakpoints.values ?? $648b6775c62ffb58$var$values;
        for(const key in propValue){
            if ((0, $doSJ6.isCqShorthand)(breakpoints.keys, key)) {
                const containerKey = (0, $doSJ6.getContainerQuery)(theme.containerQueries ? theme : $648b6775c62ffb58$var$defaultContainerQueries, key);
                if (containerKey) $648b6775c62ffb58$var$buildBreakpoint(target, containerKey, propValue[key], key, callback);
            } else if (key in breakpointValues) {
                const mediaKey = breakpoints.up(key);
                $648b6775c62ffb58$var$buildBreakpoint(target, mediaKey, propValue[key], key, callback);
            } else {
                const cssKey = key;
                target[cssKey] = propValue[cssKey];
            }
        }
        return target;
    }
    callback(undefined, propValue);
    return target;
}
function $648b6775c62ffb58$var$buildBreakpoint(target, mediaKey, value, initialKey, callback) {
    target[mediaKey] ?? (target[mediaKey] = {});
    callback(mediaKey, value, initialKey);
}
function $648b6775c62ffb58$var$setupBreakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $648b6775c62ffb58$var$DEFAULT_BREAKPOINTS;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $648b6775c62ffb58$var$_merge.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
/** @internal */ function $648b6775c62ffb58$var$createEmptyBreakpointObject(breakpoints = $648b6775c62ffb58$var$DEFAULT_BREAKPOINTS) {
    const { internal_mediaKeys: mediaKeys } = breakpoints;
    const result = {};
    for(let i = 0; i < mediaKeys.length; i += 1)result[mediaKeys[i]] = {};
    return result;
}
/** @internal */ function $648b6775c62ffb58$var$removeUnusedBreakpoints(breakpoints, style) {
    const breakpointKeys = breakpoints.internal_mediaKeys;
    for(let i = 0; i < breakpointKeys.length; i += 1){
        const key = breakpointKeys[i];
        if ((0, $648b6775c62ffb58$var$_isObjectEmpty.default)(style[key])) delete style[key];
    }
    return style;
}
function $648b6775c62ffb58$var$mergeBreakpointsInOrder(breakpoints, ...styles) {
    const emptyBreakpoints = $648b6775c62ffb58$var$createEmptyBreakpointObject(breakpoints);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $648b6775c62ffb58$var$_deepmerge.default)(prev, next), {});
    return $648b6775c62ffb58$var$removeUnusedBreakpoints(breakpoints, mergedOutput);
}
/** @internal */ function $648b6775c62ffb58$var$computeBreakpointsBase(breakpointValues, themeBreakpoints) {
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $648b6775c62ffb58$var$resolveBreakpointValues(options) {
    const { values: breakpointValues, breakpoints: themeBreakpoints, base: customBase } = options;
    const base = customBase || $648b6775c62ffb58$var$computeBreakpointsBase(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object' && breakpointValues) {
            const bv = breakpointValues;
            acc[breakpoint] = bv[breakpoint] != null ? bv[breakpoint] : bv[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
function $648b6775c62ffb58$var$hasBreakpoint(breakpoints, value) {
    if (Array.isArray(value)) return true;
    if (typeof value === 'object' && value !== null) {
        for(let i = 0; i < breakpoints.keys.length; i += 1){
            if (breakpoints.keys[i] in value) return true;
        }
        const valueKeys = Object.keys(value);
        for(let i = 0; i < valueKeys.length; i += 1){
            if ((0, $doSJ6.isCqShorthand)(breakpoints.keys, valueKeys[i])) return true;
        }
    }
    return false;
}
var $648b6775c62ffb58$var$_default = module.exports.default = $648b6775c62ffb58$var$setupBreakpoints;

});
parcelRegister("pu076", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $04c99b746d310881$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $04c99b746d310881$var$_isObjectEmpty.default;
    }
});

var $04c99b746d310881$var$_isObjectEmpty = $04c99b746d310881$require$_interopRequireDefault((parcelRequire("9T1lQ")));

});
parcelRegister("9T1lQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $732a4c77d7f8572a$var$isObjectEmpty;
function $732a4c77d7f8572a$var$isObjectEmpty(object) {
    if (object == null) return true;
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}

});


parcelRegister("hr2ba", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $cb16a5fff678f335$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $cb16a5fff678f335$var$_fastDeepAssign.default;
    }
});

var $cb16a5fff678f335$var$_fastDeepAssign = $cb16a5fff678f335$require$_interopRequireDefault((parcelRequire("hGzN4")));

});
parcelRegister("hGzN4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ce021f22b93967d3$var$fastDeepAssign;
// Based on https://github.com/TehShrike/deepmerge
// Based on https://github.com/fastify/deepmerge
// MIT License
// Copyright (c) 2012 - 2022 James Halliday, Josh Duff, and other contributors of deepmerge
/* eslint-disable no-else-return */ /**
 * Assigns props from one object to another. Focused on performance, only normal objects with no
 * prototype are supported.
 */ function $ce021f22b93967d3$var$fastDeepAssign(target, source) {
    const sourceIsArray = Array.isArray(source);
    const targetIsArray = Array.isArray(target);
    if ($ce021f22b93967d3$var$isPrimitive(source)) return source;
    else if ($ce021f22b93967d3$var$isPrimitiveOrBuiltIn(target)) return $ce021f22b93967d3$var$clone(source);
    else if (sourceIsArray && targetIsArray) return $ce021f22b93967d3$var$mergeArray(target, source);
    else if (sourceIsArray !== targetIsArray) return $ce021f22b93967d3$var$clone(source);
    else return $ce021f22b93967d3$var$mergeObject(target, source);
}
function $ce021f22b93967d3$var$cloneArray(value) {
    let i = 0;
    const il = value.length;
    const result = new Array(il);
    for(i = 0; i < il; i += 1)result[i] = $ce021f22b93967d3$var$clone(value[i]);
    return result;
}
function $ce021f22b93967d3$var$cloneObject(target) {
    const result = {};
    for(const key in target){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        result[key] = $ce021f22b93967d3$var$clone(target[key]);
    }
    return result;
}
function $ce021f22b93967d3$var$mergeArray(target, source) {
    const tl = target.length;
    for(let i = 0; i < source.length; i += 1)target[tl + i] = $ce021f22b93967d3$var$clone(source[i]);
    return target;
}
function $ce021f22b93967d3$var$isMergeableObject(value) {
    return typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
}
function $ce021f22b93967d3$var$isPrimitive(value) {
    return typeof value !== 'object' || value === null;
}
function $ce021f22b93967d3$var$isPrimitiveOrBuiltIn(value) {
    return typeof value !== 'object' || value === null || value instanceof RegExp || value instanceof Date;
}
function $ce021f22b93967d3$var$clone(entry) {
    // eslint-disable-next-line no-nested-ternary
    return $ce021f22b93967d3$var$isMergeableObject(entry) ? Array.isArray(entry) ? $ce021f22b93967d3$var$cloneArray(entry) : $ce021f22b93967d3$var$cloneObject(entry) : entry;
}
function $ce021f22b93967d3$var$mergeObject(target, source) {
    for(const key in source){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        if (key in target) target[key] = $ce021f22b93967d3$var$fastDeepAssign(target[key], source[key]);
        else target[key] = $ce021f22b93967d3$var$clone(source[key]);
    }
    return target;
}

});


parcelRegister("1iGut", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $0f286ea2358827c1$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0f286ea2358827c1$var$_merge.default;
    }
});

var $0f286ea2358827c1$var$_merge = $0f286ea2358827c1$require$_interopRequireDefault((parcelRequire("lWmsG")));

});
parcelRegister("lWmsG", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $ff90702592b48556$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff90702592b48556$var$_deepmerge = $ff90702592b48556$require$_interopRequireDefault((parcelRequire("5nq0S")));
const $ff90702592b48556$var$options = {
    clone: false
};
function $ff90702592b48556$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $ff90702592b48556$var$_deepmerge.default)(acc, item, $ff90702592b48556$var$options);
}
var $ff90702592b48556$var$_default = module.exports.default = $ff90702592b48556$var$merge;

});




parcelRegister("1H8cF", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $13c02b9d6da39aec$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $13c02b9d6da39aec$var$_exportNames = {
    style: true
};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $13c02b9d6da39aec$var$_style.default;
    }
});
Object.defineProperty(module.exports, "style", {
    enumerable: true,
    get: function() {
        return $13c02b9d6da39aec$var$_style.default;
    }
});

var $13c02b9d6da39aec$var$_style = $13c02b9d6da39aec$require$_interopRequireWildcard((parcelRequire("eJvQq")));
Object.keys($13c02b9d6da39aec$var$_style).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($13c02b9d6da39aec$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $13c02b9d6da39aec$var$_style[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $13c02b9d6da39aec$var$_style[key];
        }
    });
});

});
parcelRegister("eJvQq", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $ab9df8568e45c870$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ab9df8568e45c870$var$style;
module.exports.getPath = $ab9df8568e45c870$var$getPath;
module.exports.getStyleValue = $ab9df8568e45c870$var$getStyleValue;
module.exports.getStyleValue2 = $ab9df8568e45c870$var$getStyleValue2;

var $ab9df8568e45c870$var$_capitalize = $ab9df8568e45c870$require$_interopRequireDefault((parcelRequire("iDnDg")));

var $ab9df8568e45c870$var$_responsivePropType = $ab9df8568e45c870$require$_interopRequireDefault((parcelRequire("e6HWG")));

var $3dqBt = parcelRequire("3dqBt");
/**
 * TODO(v7): Keep either this one or `getStyleValue2`
 */ function $ab9df8568e45c870$var$getStyleValue(themeMapping, transform, valueFinal, userValue = valueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(valueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[valueFinal] || userValue;
    else if (typeof valueFinal === 'string') value = $ab9df8568e45c870$var$getPath(themeMapping, valueFinal) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
/**
 * HACK: The `alternateProp` logic is there because our theme looks like this:
 * {
 *   typography: {
 *     fontFamily: 'comic sans',
 *     fontFamilyCode: 'courrier new',
 *   }
 * }
 * And we support targetting:
 * - `typography.fontFamily`     with `sx={{ fontFamily: 'default' }}`
 * - `typography.fontFamilyCode` with `sx={{ fontFamily: 'code' }}`
 *
 * TODO(v7): Refactor our theme to look like this and remove the horrendous logic:
 * {
 *   typography: {
 *     fontFamily: {
 *       default: 'comic sans',
 *       code: 'courrier new',
 *     }
 *   }
 * }
 */ function $ab9df8568e45c870$var$getStyleValue2(themeMapping, transform, userValue, alternateProp) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(userValue);
    else if (Array.isArray(themeMapping)) value = themeMapping[userValue] || userValue;
    else if (typeof userValue === 'string') value = $ab9df8568e45c870$var$getPath(themeMapping, userValue, true, alternateProp) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $ab9df8568e45c870$var$getPath(obj, pathInput, checkVars = true, alternateProp) {
    if (!obj || !pathInput) return null;
    const path = pathInput.split('.');
    // Check if CSS variables are used
    if (obj.vars && checkVars) {
        const val = $ab9df8568e45c870$var$getPathImpl(obj.vars, path, alternateProp);
        if (val != null) return val;
    }
    return $ab9df8568e45c870$var$getPathImpl(obj, path, alternateProp);
}
function $ab9df8568e45c870$var$getPathImpl(object, path, alternateProp) {
    let lastResult = undefined;
    let result = object;
    let index = 0;
    while(index < path.length){
        if (result === null || result === undefined) return result;
        lastResult = result;
        result = result[path[index]];
        index += 1;
    }
    if (alternateProp && result === undefined) {
        const lastKey = path[path.length - 1];
        const alternateKey = `${alternateProp}${lastKey === 'default' ? '' : (0, $ab9df8568e45c870$var$_capitalize.default)(lastKey)}`;
        return lastResult?.[alternateKey];
    }
    return result;
}
function $ab9df8568e45c870$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $ab9df8568e45c870$var$getPath(theme, themeKey) || {};
        const styleFromPropValue = (valueFinal)=>{
            const value = $ab9df8568e45c870$var$getStyleValue2(themeMapping, transform, valueFinal, prop);
            return cssProperty === false ? value : {
                [cssProperty]: value
            };
        };
        return (0, $3dqBt.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}

});
parcelRegister("iDnDg", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $d90e3366a9a4add9$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $d90e3366a9a4add9$var$_capitalize.default;
    }
});

var $d90e3366a9a4add9$var$_capitalize = $d90e3366a9a4add9$require$_interopRequireDefault((parcelRequire("li0zR")));

});
parcelRegister("li0zR", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $f7fbba0cc0a72813$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f7fbba0cc0a72813$var$capitalize;

var $f7fbba0cc0a72813$var$_formatMuiErrorMessage = $f7fbba0cc0a72813$require$_interopRequireDefault((parcelRequire("eq0W7")));
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function $f7fbba0cc0a72813$var$capitalize(string) {
    if (typeof string !== 'string') throw new Error((0, $f7fbba0cc0a72813$var$_formatMuiErrorMessage.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});







parcelRegister("4fSu5", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $3192d39708a19e20$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createStyleFunctionSx = $3192d39708a19e20$var$unstable_createStyleFunctionSx;

var $3192d39708a19e20$var$_fastDeepAssign = $3192d39708a19e20$require$_interopRequireDefault((parcelRequire("hr2ba")));

var $1H8cF = parcelRequire("1H8cF");

var $3dqBt = parcelRequire("3dqBt");

var $doSJ6 = parcelRequire("doSJ6");

var $3192d39708a19e20$var$_defaultSxConfig = $3192d39708a19e20$require$_interopRequireDefault((parcelRequire("lwvds")));
/**
 * The `css` function accepts arrays as values for mobile-first responsive styles.
 * Note that this extends to non-theme values also. For example `display=['none', 'block']`
 * will also works.
 */ /**
 * Map of all CSS pseudo selectors (`:hover`, `:focus`, ...).
 */ /**
 * Map all nested selectors.
 */ /**
 * Map all nested selectors and CSS variables.
 */ /**
 * Map of all available CSS properties (including aliases) and their raw value.
 * Only used internally to map CSS properties to input types (responsive value,
 * theme function or nested) in `SystemCssProperties`.
 */ /**
 * The `SystemStyleObject` defines custom properties that will be transformed to
 * their corresponding values from the `Theme`. Other valid CSS properties are also allowed.
 */ /**
 * The `SxProps` can be either object or function
 */ /* eslint-disable guard-for-in */ const $3192d39708a19e20$var$EMPTY_THEME = {};
// eslint-disable-next-line @typescript-eslint/naming-convention
function $3192d39708a19e20$var$unstable_createStyleFunctionSx() {
    function styleFunctionSx(props) {
        if (!props.sx) return null;
        const { sx: sx, theme: theme = $3192d39708a19e20$var$EMPTY_THEME, nested: nested } = props;
        const config = theme.unstable_sxConfig ?? $3192d39708a19e20$var$_defaultSxConfig.default;
        // Pass argument without loop allocations
        const wrapper = {
            sx: null,
            theme: theme,
            nested: true
        };
        function process(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const breakpoints = theme.breakpoints ?? $3dqBt.DEFAULT_BREAKPOINTS;
            const css = (0, $3dqBt.createEmptyBreakpointObject)(breakpoints);
            for(const styleKey in sxObject){
                const value = $3192d39708a19e20$var$callIfFn(sxObject[styleKey], theme);
                if (value === null || value === undefined) continue;
                if (typeof value !== 'object') {
                    $3192d39708a19e20$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if (config[styleKey]) {
                    $3192d39708a19e20$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if ((0, $3dqBt.hasBreakpoint)(breakpoints, value)) (0, $3dqBt.iterateBreakpoints)(css, props.theme, value, (mediaKey, finalValue)=>{
                    css[mediaKey][styleKey] = finalValue;
                });
                else {
                    wrapper.sx = value;
                    css[styleKey] = styleFunctionSx(wrapper);
                }
            }
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $doSJ6.sortContainerQueries)(theme, (0, $3dqBt.removeUnusedBreakpoints)(breakpoints, css))
            };
            return (0, $doSJ6.sortContainerQueries)(theme, (0, $3dqBt.removeUnusedBreakpoints)(breakpoints, css));
        }
        return Array.isArray(sx) ? sx.map(process) : process(sx);
    }
    styleFunctionSx.filterProps = [
        'sx'
    ];
    return styleFunctionSx;
}
var $3192d39708a19e20$var$_default = module.exports.default = $3192d39708a19e20$var$unstable_createStyleFunctionSx();
function $3192d39708a19e20$var$setThemeValue(css, prop, value, theme, config) {
    const options = config[prop];
    if (!options) {
        css[prop] = value;
        return;
    }
    if (value == null) return;
    const { themeKey: themeKey } = options;
    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && value === 'inherit') {
        css[prop] = value;
        return;
    }
    const { style: style } = options;
    if (style) {
        (0, $3192d39708a19e20$var$_fastDeepAssign.default)(css, style({
            [prop]: value,
            theme: theme
        }));
        return;
    }
    const { cssProperty: cssProperty = prop, transform: transform } = options;
    const themeMapping = (0, $1H8cF.getPath)(theme, themeKey);
    (0, $3dqBt.iterateBreakpoints)(css, theme, value, (mediaKey, valueFinal)=>{
        const finalValue = (0, $1H8cF.getStyleValue2)(themeMapping, transform, valueFinal, prop);
        if (cssProperty === false) {
            if (mediaKey) (0, $3192d39708a19e20$var$_fastDeepAssign.default)(css[mediaKey], finalValue);
            else (0, $3192d39708a19e20$var$_fastDeepAssign.default)(css, finalValue);
        } else // eslint-disable-next-line no-lonely-if
        if (mediaKey) css[mediaKey][cssProperty] = finalValue;
        else css[cssProperty] = finalValue;
    });
}
function $3192d39708a19e20$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

});
parcelRegister("lwvds", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7GqeV = parcelRequire("7GqeV");

var $6mdr0 = parcelRequire("6mdr0");

var $hmOdg = parcelRequire("hmOdg");

var $9JyGZ = parcelRequire("9JyGZ");

var $40fcn = parcelRequire("40fcn");
const $fab4ccf7eedcd1af$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: $6mdr0.borderTransform
    },
    borderTop: {
        themeKey: 'borders',
        transform: $6mdr0.borderTransform
    },
    borderRight: {
        themeKey: 'borders',
        transform: $6mdr0.borderTransform
    },
    borderBottom: {
        themeKey: 'borders',
        transform: $6mdr0.borderTransform
    },
    borderLeft: {
        themeKey: 'borders',
        transform: $6mdr0.borderTransform
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: $6mdr0.borderTransform
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: $6mdr0.borderRadius
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: $9JyGZ.paletteTransform
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: $9JyGZ.paletteTransform
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: $9JyGZ.paletteTransform
    },
    // spacing
    p: {
        style: $7GqeV.padding
    },
    pt: {
        style: $7GqeV.padding
    },
    pr: {
        style: $7GqeV.padding
    },
    pb: {
        style: $7GqeV.padding
    },
    pl: {
        style: $7GqeV.padding
    },
    px: {
        style: $7GqeV.padding
    },
    py: {
        style: $7GqeV.padding
    },
    padding: {
        style: $7GqeV.padding
    },
    paddingTop: {
        style: $7GqeV.padding
    },
    paddingRight: {
        style: $7GqeV.padding
    },
    paddingBottom: {
        style: $7GqeV.padding
    },
    paddingLeft: {
        style: $7GqeV.padding
    },
    paddingX: {
        style: $7GqeV.padding
    },
    paddingY: {
        style: $7GqeV.padding
    },
    paddingInline: {
        style: $7GqeV.padding
    },
    paddingInlineStart: {
        style: $7GqeV.padding
    },
    paddingInlineEnd: {
        style: $7GqeV.padding
    },
    paddingBlock: {
        style: $7GqeV.padding
    },
    paddingBlockStart: {
        style: $7GqeV.padding
    },
    paddingBlockEnd: {
        style: $7GqeV.padding
    },
    m: {
        style: $7GqeV.margin
    },
    mt: {
        style: $7GqeV.margin
    },
    mr: {
        style: $7GqeV.margin
    },
    mb: {
        style: $7GqeV.margin
    },
    ml: {
        style: $7GqeV.margin
    },
    mx: {
        style: $7GqeV.margin
    },
    my: {
        style: $7GqeV.margin
    },
    margin: {
        style: $7GqeV.margin
    },
    marginTop: {
        style: $7GqeV.margin
    },
    marginRight: {
        style: $7GqeV.margin
    },
    marginBottom: {
        style: $7GqeV.margin
    },
    marginLeft: {
        style: $7GqeV.margin
    },
    marginX: {
        style: $7GqeV.margin
    },
    marginY: {
        style: $7GqeV.margin
    },
    marginInline: {
        style: $7GqeV.margin
    },
    marginInlineStart: {
        style: $7GqeV.margin
    },
    marginInlineEnd: {
        style: $7GqeV.margin
    },
    marginBlock: {
        style: $7GqeV.margin
    },
    marginBlockStart: {
        style: $7GqeV.margin
    },
    marginBlockEnd: {
        style: $7GqeV.margin
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: $hmOdg.gap
    },
    rowGap: {
        style: $hmOdg.rowGap
    },
    columnGap: {
        style: $hmOdg.columnGap
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: $40fcn.sizingTransform
    },
    maxWidth: {
        style: $40fcn.maxWidth
    },
    minWidth: {
        transform: $40fcn.sizingTransform
    },
    height: {
        transform: $40fcn.sizingTransform
    },
    maxHeight: {
        transform: $40fcn.sizingTransform
    },
    minHeight: {
        transform: $40fcn.sizingTransform
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $fab4ccf7eedcd1af$var$_default = module.exports.default = $fab4ccf7eedcd1af$var$defaultSxConfig;

});
parcelRegister("6mdr0", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $4a0f38011127c6ab$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4a0f38011127c6ab$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4a0f38011127c6ab$var$_borders.default;
    }
});

var $4a0f38011127c6ab$var$_borders = $4a0f38011127c6ab$require$_interopRequireWildcard((parcelRequire("eOaiJ")));
Object.keys($4a0f38011127c6ab$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($4a0f38011127c6ab$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $4a0f38011127c6ab$var$_borders[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $4a0f38011127c6ab$var$_borders[key];
        }
    });
});

});
parcelRegister("eOaiJ", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $ac7db9cd12272eb4$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.borderTopColor = module.exports.borderTop = module.exports.borderRightColor = module.exports.borderRight = module.exports.borderRadius = module.exports.borderLeftColor = module.exports.borderLeft = module.exports.borderColor = module.exports.borderBottomColor = module.exports.borderBottom = module.exports.border = void 0;
module.exports.borderTransform = $ac7db9cd12272eb4$var$borderTransform;
module.exports.outlineColor = module.exports.outline = module.exports.default = void 0;

var $ac7db9cd12272eb4$var$_responsivePropType = $ac7db9cd12272eb4$require$_interopRequireDefault((parcelRequire("e6HWG")));

var $ac7db9cd12272eb4$var$_style = $ac7db9cd12272eb4$require$_interopRequireDefault((parcelRequire("1H8cF")));

var $ac7db9cd12272eb4$var$_compose = $ac7db9cd12272eb4$require$_interopRequireDefault((parcelRequire("lNg8l")));

var $7GqeV = parcelRequire("7GqeV");

var $3dqBt = parcelRequire("3dqBt");
/** @internal */ function $ac7db9cd12272eb4$var$borderTransform(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $ac7db9cd12272eb4$var$createBorderStyle(prop, transform) {
    return (0, $ac7db9cd12272eb4$var$_style.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $ac7db9cd12272eb4$var$border = module.exports.border = $ac7db9cd12272eb4$var$createBorderStyle('border', $ac7db9cd12272eb4$var$borderTransform);
const $ac7db9cd12272eb4$var$borderTop = module.exports.borderTop = $ac7db9cd12272eb4$var$createBorderStyle('borderTop', $ac7db9cd12272eb4$var$borderTransform);
const $ac7db9cd12272eb4$var$borderRight = module.exports.borderRight = $ac7db9cd12272eb4$var$createBorderStyle('borderRight', $ac7db9cd12272eb4$var$borderTransform);
const $ac7db9cd12272eb4$var$borderBottom = module.exports.borderBottom = $ac7db9cd12272eb4$var$createBorderStyle('borderBottom', $ac7db9cd12272eb4$var$borderTransform);
const $ac7db9cd12272eb4$var$borderLeft = module.exports.borderLeft = $ac7db9cd12272eb4$var$createBorderStyle('borderLeft', $ac7db9cd12272eb4$var$borderTransform);
const $ac7db9cd12272eb4$var$borderColor = module.exports.borderColor = $ac7db9cd12272eb4$var$createBorderStyle('borderColor');
const $ac7db9cd12272eb4$var$borderTopColor = module.exports.borderTopColor = $ac7db9cd12272eb4$var$createBorderStyle('borderTopColor');
const $ac7db9cd12272eb4$var$borderRightColor = module.exports.borderRightColor = $ac7db9cd12272eb4$var$createBorderStyle('borderRightColor');
const $ac7db9cd12272eb4$var$borderBottomColor = module.exports.borderBottomColor = $ac7db9cd12272eb4$var$createBorderStyle('borderBottomColor');
const $ac7db9cd12272eb4$var$borderLeftColor = module.exports.borderLeftColor = $ac7db9cd12272eb4$var$createBorderStyle('borderLeftColor');
const $ac7db9cd12272eb4$var$outline = module.exports.outline = $ac7db9cd12272eb4$var$createBorderStyle('outline', $ac7db9cd12272eb4$var$borderTransform);
const $ac7db9cd12272eb4$var$outlineColor = module.exports.outlineColor = $ac7db9cd12272eb4$var$createBorderStyle('outlineColor');
const $ac7db9cd12272eb4$var$borderRadius = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $7GqeV.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $7GqeV.getValue)(transformer, propValue)
            });
        return (0, $3dqBt.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
module.exports.borderRadius = $ac7db9cd12272eb4$var$borderRadius;
$ac7db9cd12272eb4$var$borderRadius.propTypes = {};
$ac7db9cd12272eb4$var$borderRadius.filterProps = [
    'borderRadius'
];
const $ac7db9cd12272eb4$var$borders = (0, $ac7db9cd12272eb4$var$_compose.default)($ac7db9cd12272eb4$var$border, $ac7db9cd12272eb4$var$borderTop, $ac7db9cd12272eb4$var$borderRight, $ac7db9cd12272eb4$var$borderBottom, $ac7db9cd12272eb4$var$borderLeft, $ac7db9cd12272eb4$var$borderColor, $ac7db9cd12272eb4$var$borderTopColor, $ac7db9cd12272eb4$var$borderRightColor, $ac7db9cd12272eb4$var$borderBottomColor, $ac7db9cd12272eb4$var$borderLeftColor, $ac7db9cd12272eb4$var$borderRadius, $ac7db9cd12272eb4$var$outline, $ac7db9cd12272eb4$var$outlineColor);
var $ac7db9cd12272eb4$var$_default = module.exports.default = $ac7db9cd12272eb4$var$borders;

});
parcelRegister("lNg8l", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $fddab05f89479441$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $fddab05f89479441$var$_compose.default;
    }
});

var $fddab05f89479441$var$_compose = $fddab05f89479441$require$_interopRequireDefault((parcelRequire("dj75Q")));

});
parcelRegister("dj75Q", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $9b028d440e0d0fdf$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b028d440e0d0fdf$var$_fastDeepAssign = $9b028d440e0d0fdf$require$_interopRequireDefault((parcelRequire("hr2ba")));
function $9b028d440e0d0fdf$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        const result = {};
        for(const prop in props)if (handlers[prop]) (0, $9b028d440e0d0fdf$var$_fastDeepAssign.default)(result, handlers[prop](props));
        return result;
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $9b028d440e0d0fdf$var$_default = module.exports.default = $9b028d440e0d0fdf$var$compose;

});




parcelRegister("hmOdg", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $ca4b70fb85b955aa$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ca4b70fb85b955aa$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ca4b70fb85b955aa$var$_cssGrid.default;
    }
});

var $ca4b70fb85b955aa$var$_cssGrid = $ca4b70fb85b955aa$require$_interopRequireWildcard((parcelRequire("btqGQ")));
Object.keys($ca4b70fb85b955aa$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($ca4b70fb85b955aa$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $ca4b70fb85b955aa$var$_cssGrid[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $ca4b70fb85b955aa$var$_cssGrid[key];
        }
    });
});

});
parcelRegister("btqGQ", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $85a71b352c13f13c$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rowGap = module.exports.gridTemplateRows = module.exports.gridTemplateColumns = module.exports.gridTemplateAreas = module.exports.gridRow = module.exports.gridColumn = module.exports.gridAutoRows = module.exports.gridAutoFlow = module.exports.gridAutoColumns = module.exports.gridArea = module.exports.gap = module.exports.default = module.exports.columnGap = void 0;

var $85a71b352c13f13c$var$_style = $85a71b352c13f13c$require$_interopRequireDefault((parcelRequire("1H8cF")));

var $85a71b352c13f13c$var$_compose = $85a71b352c13f13c$require$_interopRequireDefault((parcelRequire("lNg8l")));

var $7GqeV = parcelRequire("7GqeV");

var $3dqBt = parcelRequire("3dqBt");

var $85a71b352c13f13c$var$_responsivePropType = $85a71b352c13f13c$require$_interopRequireDefault((parcelRequire("e6HWG")));
const $85a71b352c13f13c$var$gap = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $7GqeV.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $7GqeV.getValue)(transformer, propValue)
            });
        return (0, $3dqBt.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
module.exports.gap = $85a71b352c13f13c$var$gap;
$85a71b352c13f13c$var$gap.propTypes = {};
$85a71b352c13f13c$var$gap.filterProps = [
    'gap'
];
const $85a71b352c13f13c$var$columnGap = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $7GqeV.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $7GqeV.getValue)(transformer, propValue)
            });
        return (0, $3dqBt.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
module.exports.columnGap = $85a71b352c13f13c$var$columnGap;
$85a71b352c13f13c$var$columnGap.propTypes = {};
$85a71b352c13f13c$var$columnGap.filterProps = [
    'columnGap'
];
const $85a71b352c13f13c$var$rowGap = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $7GqeV.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $7GqeV.getValue)(transformer, propValue)
            });
        return (0, $3dqBt.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
module.exports.rowGap = $85a71b352c13f13c$var$rowGap;
$85a71b352c13f13c$var$rowGap.propTypes = {};
$85a71b352c13f13c$var$rowGap.filterProps = [
    'rowGap'
];
const $85a71b352c13f13c$var$gridColumn = module.exports.gridColumn = (0, $85a71b352c13f13c$var$_style.default)({
    prop: 'gridColumn'
});
const $85a71b352c13f13c$var$gridRow = module.exports.gridRow = (0, $85a71b352c13f13c$var$_style.default)({
    prop: 'gridRow'
});
const $85a71b352c13f13c$var$gridAutoFlow = module.exports.gridAutoFlow = (0, $85a71b352c13f13c$var$_style.default)({
    prop: 'gridAutoFlow'
});
const $85a71b352c13f13c$var$gridAutoColumns = module.exports.gridAutoColumns = (0, $85a71b352c13f13c$var$_style.default)({
    prop: 'gridAutoColumns'
});
const $85a71b352c13f13c$var$gridAutoRows = module.exports.gridAutoRows = (0, $85a71b352c13f13c$var$_style.default)({
    prop: 'gridAutoRows'
});
const $85a71b352c13f13c$var$gridTemplateColumns = module.exports.gridTemplateColumns = (0, $85a71b352c13f13c$var$_style.default)({
    prop: 'gridTemplateColumns'
});
const $85a71b352c13f13c$var$gridTemplateRows = module.exports.gridTemplateRows = (0, $85a71b352c13f13c$var$_style.default)({
    prop: 'gridTemplateRows'
});
const $85a71b352c13f13c$var$gridTemplateAreas = module.exports.gridTemplateAreas = (0, $85a71b352c13f13c$var$_style.default)({
    prop: 'gridTemplateAreas'
});
const $85a71b352c13f13c$var$gridArea = module.exports.gridArea = (0, $85a71b352c13f13c$var$_style.default)({
    prop: 'gridArea'
});
const $85a71b352c13f13c$var$grid = (0, $85a71b352c13f13c$var$_compose.default)($85a71b352c13f13c$var$gap, $85a71b352c13f13c$var$columnGap, $85a71b352c13f13c$var$rowGap, $85a71b352c13f13c$var$gridColumn, $85a71b352c13f13c$var$gridRow, $85a71b352c13f13c$var$gridAutoFlow, $85a71b352c13f13c$var$gridAutoColumns, $85a71b352c13f13c$var$gridAutoRows, $85a71b352c13f13c$var$gridTemplateColumns, $85a71b352c13f13c$var$gridTemplateRows, $85a71b352c13f13c$var$gridTemplateAreas, $85a71b352c13f13c$var$gridArea);
var $85a71b352c13f13c$var$_default = module.exports.default = $85a71b352c13f13c$var$grid;

});


parcelRegister("9JyGZ", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $71633a359735a455$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $71633a359735a455$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $71633a359735a455$var$_palette.default;
    }
});

var $71633a359735a455$var$_palette = $71633a359735a455$require$_interopRequireWildcard((parcelRequire("7CrhA")));
Object.keys($71633a359735a455$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($71633a359735a455$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $71633a359735a455$var$_palette[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $71633a359735a455$var$_palette[key];
        }
    });
});

});
parcelRegister("7CrhA", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $58c13ec9184653f7$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.color = module.exports.bgcolor = module.exports.backgroundColor = void 0;
module.exports.paletteTransform = $58c13ec9184653f7$var$paletteTransform;

var $58c13ec9184653f7$var$_style = $58c13ec9184653f7$require$_interopRequireDefault((parcelRequire("1H8cF")));

var $58c13ec9184653f7$var$_compose = $58c13ec9184653f7$require$_interopRequireDefault((parcelRequire("lNg8l")));
/** @internal */ function $58c13ec9184653f7$var$paletteTransform(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $58c13ec9184653f7$var$color = module.exports.color = (0, $58c13ec9184653f7$var$_style.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $58c13ec9184653f7$var$paletteTransform
});
const $58c13ec9184653f7$var$bgcolor = module.exports.bgcolor = (0, $58c13ec9184653f7$var$_style.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $58c13ec9184653f7$var$paletteTransform
});
const $58c13ec9184653f7$var$backgroundColor = module.exports.backgroundColor = (0, $58c13ec9184653f7$var$_style.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $58c13ec9184653f7$var$paletteTransform
});
const $58c13ec9184653f7$var$palette = (0, $58c13ec9184653f7$var$_compose.default)($58c13ec9184653f7$var$color, $58c13ec9184653f7$var$bgcolor, $58c13ec9184653f7$var$backgroundColor);
var $58c13ec9184653f7$var$_default = module.exports.default = $58c13ec9184653f7$var$palette;

});


parcelRegister("40fcn", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $2ea2f3a3f49483d0$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2ea2f3a3f49483d0$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2ea2f3a3f49483d0$var$_sizing.default;
    }
});

var $2ea2f3a3f49483d0$var$_sizing = $2ea2f3a3f49483d0$require$_interopRequireWildcard((parcelRequire("j8o4J")));
Object.keys($2ea2f3a3f49483d0$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2ea2f3a3f49483d0$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2ea2f3a3f49483d0$var$_sizing[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2ea2f3a3f49483d0$var$_sizing[key];
        }
    });
});

});
parcelRegister("j8o4J", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $dee1708da7f55a1b$require$_interopRequireWildcard = $c5wSN.default;

var $5ULbo = parcelRequire("5ULbo");
var $dee1708da7f55a1b$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sizeWidth = module.exports.sizeHeight = module.exports.minWidth = module.exports.minHeight = module.exports.maxWidth = module.exports.maxHeight = module.exports.height = module.exports.default = module.exports.boxSizing = void 0;
module.exports.sizingTransform = $dee1708da7f55a1b$var$sizingTransform;
module.exports.width = void 0;

var $dee1708da7f55a1b$var$_style = $dee1708da7f55a1b$require$_interopRequireDefault((parcelRequire("1H8cF")));

var $dee1708da7f55a1b$var$_compose = $dee1708da7f55a1b$require$_interopRequireDefault((parcelRequire("lNg8l")));

var $dee1708da7f55a1b$var$_breakpoints = $dee1708da7f55a1b$require$_interopRequireWildcard((parcelRequire("3dqBt")));
var $dee1708da7f55a1b$var$breakpointsModule = $dee1708da7f55a1b$var$_breakpoints;
const $dee1708da7f55a1b$var$breakpointsValues = $dee1708da7f55a1b$var$breakpointsModule.values;
/** @internal */ function $dee1708da7f55a1b$var$sizingTransform(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $dee1708da7f55a1b$var$width = module.exports.width = (0, $dee1708da7f55a1b$var$_style.default)({
    prop: 'width',
    transform: $dee1708da7f55a1b$var$sizingTransform
});
const $dee1708da7f55a1b$var$maxWidth = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $dee1708da7f55a1b$var$breakpointsValues[propValue];
            if (!breakpoint) return {
                maxWidth: $dee1708da7f55a1b$var$sizingTransform(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $dee1708da7f55a1b$var$_breakpoints.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
module.exports.maxWidth = $dee1708da7f55a1b$var$maxWidth;
$dee1708da7f55a1b$var$maxWidth.filterProps = [
    'maxWidth'
];
const $dee1708da7f55a1b$var$minWidth = module.exports.minWidth = (0, $dee1708da7f55a1b$var$_style.default)({
    prop: 'minWidth',
    transform: $dee1708da7f55a1b$var$sizingTransform
});
const $dee1708da7f55a1b$var$height = module.exports.height = (0, $dee1708da7f55a1b$var$_style.default)({
    prop: 'height',
    transform: $dee1708da7f55a1b$var$sizingTransform
});
const $dee1708da7f55a1b$var$maxHeight = module.exports.maxHeight = (0, $dee1708da7f55a1b$var$_style.default)({
    prop: 'maxHeight',
    transform: $dee1708da7f55a1b$var$sizingTransform
});
const $dee1708da7f55a1b$var$minHeight = module.exports.minHeight = (0, $dee1708da7f55a1b$var$_style.default)({
    prop: 'minHeight',
    transform: $dee1708da7f55a1b$var$sizingTransform
});
const $dee1708da7f55a1b$var$sizeWidth = module.exports.sizeWidth = (0, $dee1708da7f55a1b$var$_style.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $dee1708da7f55a1b$var$sizingTransform
});
const $dee1708da7f55a1b$var$sizeHeight = module.exports.sizeHeight = (0, $dee1708da7f55a1b$var$_style.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $dee1708da7f55a1b$var$sizingTransform
});
const $dee1708da7f55a1b$var$boxSizing = module.exports.boxSizing = (0, $dee1708da7f55a1b$var$_style.default)({
    prop: 'boxSizing'
});
const $dee1708da7f55a1b$var$sizing = (0, $dee1708da7f55a1b$var$_compose.default)($dee1708da7f55a1b$var$width, $dee1708da7f55a1b$var$maxWidth, $dee1708da7f55a1b$var$minWidth, $dee1708da7f55a1b$var$height, $dee1708da7f55a1b$var$maxHeight, $dee1708da7f55a1b$var$minHeight, $dee1708da7f55a1b$var$boxSizing);
var $dee1708da7f55a1b$var$_default = module.exports.default = $dee1708da7f55a1b$var$sizing;

});




parcelRegister("ji50g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0b3944ed18ddb7d$var$applyStyles;
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $e0b3944ed18ddb7d$var$applyStyles(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("4P3l1", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $382e83b3a5219f65$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $382e83b3a5219f65$var$_useThemeWithoutDefault.default;
    }
});

var $382e83b3a5219f65$var$_useThemeWithoutDefault = $382e83b3a5219f65$require$_interopRequireDefault((parcelRequire("19b4X")));

});
parcelRegister("19b4X", function(module, exports) {
"use strict";
'use client';

var $c5wSN = parcelRequire("c5wSN");
var $0d5f39c8558f2851$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0d5f39c8558f2851$var$React = $0d5f39c8558f2851$require$_interopRequireWildcard((parcelRequire("acw62")));

var $keaWW = parcelRequire("keaWW");
function $0d5f39c8558f2851$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $0d5f39c8558f2851$var$useThemeWithoutDefault(defaultTheme = null) {
    const contextTheme = $0d5f39c8558f2851$var$React.useContext($keaWW.ThemeContext);
    return !contextTheme || $0d5f39c8558f2851$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $0d5f39c8558f2851$var$_default = module.exports.default = $0d5f39c8558f2851$var$useThemeWithoutDefault;

});






parcelRegister("jkROm", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $e139a05dc37e1ab2$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e139a05dc37e1ab2$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e139a05dc37e1ab2$var$_display.default;
    }
});

var $e139a05dc37e1ab2$var$_display = $e139a05dc37e1ab2$require$_interopRequireWildcard((parcelRequire("3voLH")));
Object.keys($e139a05dc37e1ab2$var$_display).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e139a05dc37e1ab2$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e139a05dc37e1ab2$var$_display[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e139a05dc37e1ab2$var$_display[key];
        }
    });
});

});
parcelRegister("3voLH", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $28d77ad23a860fab$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.whiteSpace = module.exports.visibility = module.exports.textOverflow = module.exports.overflow = module.exports.displayRaw = module.exports.displayPrint = module.exports.default = void 0;

var $28d77ad23a860fab$var$_style = $28d77ad23a860fab$require$_interopRequireDefault((parcelRequire("1H8cF")));

var $28d77ad23a860fab$var$_compose = $28d77ad23a860fab$require$_interopRequireDefault((parcelRequire("lNg8l")));
const $28d77ad23a860fab$var$displayPrint = module.exports.displayPrint = (0, $28d77ad23a860fab$var$_style.default)({
    prop: 'displayPrint',
    cssProperty: false,
    transform: (value)=>({
            '@media print': {
                display: value
            }
        })
});
const $28d77ad23a860fab$var$displayRaw = module.exports.displayRaw = (0, $28d77ad23a860fab$var$_style.default)({
    prop: 'display'
});
const $28d77ad23a860fab$var$overflow = module.exports.overflow = (0, $28d77ad23a860fab$var$_style.default)({
    prop: 'overflow'
});
const $28d77ad23a860fab$var$textOverflow = module.exports.textOverflow = (0, $28d77ad23a860fab$var$_style.default)({
    prop: 'textOverflow'
});
const $28d77ad23a860fab$var$visibility = module.exports.visibility = (0, $28d77ad23a860fab$var$_style.default)({
    prop: 'visibility'
});
const $28d77ad23a860fab$var$whiteSpace = module.exports.whiteSpace = (0, $28d77ad23a860fab$var$_style.default)({
    prop: 'whiteSpace'
});
const $28d77ad23a860fab$var$display = (0, $28d77ad23a860fab$var$_compose.default)($28d77ad23a860fab$var$displayPrint, $28d77ad23a860fab$var$displayRaw, $28d77ad23a860fab$var$overflow, $28d77ad23a860fab$var$textOverflow, $28d77ad23a860fab$var$visibility, $28d77ad23a860fab$var$whiteSpace);
var $28d77ad23a860fab$var$_default = module.exports.default = $28d77ad23a860fab$var$display;

});


parcelRegister("TDeQX", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $0a7393218c831619$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0a7393218c831619$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0a7393218c831619$var$_flexbox.default;
    }
});

var $0a7393218c831619$var$_flexbox = $0a7393218c831619$require$_interopRequireWildcard((parcelRequire("84Q25")));
Object.keys($0a7393218c831619$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0a7393218c831619$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0a7393218c831619$var$_flexbox[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0a7393218c831619$var$_flexbox[key];
        }
    });
});

});
parcelRegister("84Q25", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $5e170f073f352de7$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.order = module.exports.justifySelf = module.exports.justifyItems = module.exports.justifyContent = module.exports.flexWrap = module.exports.flexShrink = module.exports.flexGrow = module.exports.flexDirection = module.exports.flexBasis = module.exports.flex = module.exports.default = module.exports.alignSelf = module.exports.alignItems = module.exports.alignContent = void 0;

var $5e170f073f352de7$var$_style = $5e170f073f352de7$require$_interopRequireDefault((parcelRequire("1H8cF")));

var $5e170f073f352de7$var$_compose = $5e170f073f352de7$require$_interopRequireDefault((parcelRequire("lNg8l")));
const $5e170f073f352de7$var$flexBasis = module.exports.flexBasis = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'flexBasis'
});
const $5e170f073f352de7$var$flexDirection = module.exports.flexDirection = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'flexDirection'
});
const $5e170f073f352de7$var$flexWrap = module.exports.flexWrap = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'flexWrap'
});
const $5e170f073f352de7$var$justifyContent = module.exports.justifyContent = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'justifyContent'
});
const $5e170f073f352de7$var$alignItems = module.exports.alignItems = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'alignItems'
});
const $5e170f073f352de7$var$alignContent = module.exports.alignContent = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'alignContent'
});
const $5e170f073f352de7$var$order = module.exports.order = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'order'
});
const $5e170f073f352de7$var$flex = module.exports.flex = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'flex'
});
const $5e170f073f352de7$var$flexGrow = module.exports.flexGrow = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'flexGrow'
});
const $5e170f073f352de7$var$flexShrink = module.exports.flexShrink = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'flexShrink'
});
const $5e170f073f352de7$var$alignSelf = module.exports.alignSelf = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'alignSelf'
});
const $5e170f073f352de7$var$justifyItems = module.exports.justifyItems = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'justifyItems'
});
const $5e170f073f352de7$var$justifySelf = module.exports.justifySelf = (0, $5e170f073f352de7$var$_style.default)({
    prop: 'justifySelf'
});
const $5e170f073f352de7$var$flexbox = (0, $5e170f073f352de7$var$_compose.default)($5e170f073f352de7$var$flexBasis, $5e170f073f352de7$var$flexDirection, $5e170f073f352de7$var$flexWrap, $5e170f073f352de7$var$justifyContent, $5e170f073f352de7$var$alignItems, $5e170f073f352de7$var$alignContent, $5e170f073f352de7$var$order, $5e170f073f352de7$var$flex, $5e170f073f352de7$var$flexGrow, $5e170f073f352de7$var$flexShrink, $5e170f073f352de7$var$alignSelf, $5e170f073f352de7$var$justifyItems, $5e170f073f352de7$var$justifySelf);
var $5e170f073f352de7$var$_default = module.exports.default = $5e170f073f352de7$var$flexbox;

});


parcelRegister("funED", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $b46c01a6a9231141$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $b46c01a6a9231141$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $b46c01a6a9231141$var$_positions.default;
    }
});

var $b46c01a6a9231141$var$_positions = $b46c01a6a9231141$require$_interopRequireWildcard((parcelRequire("eD3jS")));
Object.keys($b46c01a6a9231141$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b46c01a6a9231141$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $b46c01a6a9231141$var$_positions[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $b46c01a6a9231141$var$_positions[key];
        }
    });
});

});
parcelRegister("eD3jS", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $aa674867cdc4bd39$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zIndex = module.exports.top = module.exports.right = module.exports.position = module.exports.left = module.exports.default = module.exports.bottom = void 0;

var $aa674867cdc4bd39$var$_style = $aa674867cdc4bd39$require$_interopRequireDefault((parcelRequire("1H8cF")));

var $aa674867cdc4bd39$var$_compose = $aa674867cdc4bd39$require$_interopRequireDefault((parcelRequire("lNg8l")));
const $aa674867cdc4bd39$var$position = module.exports.position = (0, $aa674867cdc4bd39$var$_style.default)({
    prop: 'position'
});
const $aa674867cdc4bd39$var$zIndex = module.exports.zIndex = (0, $aa674867cdc4bd39$var$_style.default)({
    prop: 'zIndex',
    themeKey: 'zIndex'
});
const $aa674867cdc4bd39$var$top = module.exports.top = (0, $aa674867cdc4bd39$var$_style.default)({
    prop: 'top'
});
const $aa674867cdc4bd39$var$right = module.exports.right = (0, $aa674867cdc4bd39$var$_style.default)({
    prop: 'right'
});
const $aa674867cdc4bd39$var$bottom = module.exports.bottom = (0, $aa674867cdc4bd39$var$_style.default)({
    prop: 'bottom'
});
const $aa674867cdc4bd39$var$left = module.exports.left = (0, $aa674867cdc4bd39$var$_style.default)({
    prop: 'left'
});
const $aa674867cdc4bd39$var$positions = (0, $aa674867cdc4bd39$var$_compose.default)($aa674867cdc4bd39$var$position, $aa674867cdc4bd39$var$zIndex, $aa674867cdc4bd39$var$top, $aa674867cdc4bd39$var$right, $aa674867cdc4bd39$var$bottom, $aa674867cdc4bd39$var$left);
var $aa674867cdc4bd39$var$_default = module.exports.default = $aa674867cdc4bd39$var$positions;

});


parcelRegister("7RHsi", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $5b9f30f5a5a741dc$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5b9f30f5a5a741dc$var$_shadows.default;
    }
});

var $5b9f30f5a5a741dc$var$_shadows = $5b9f30f5a5a741dc$require$_interopRequireDefault((parcelRequire("24k8L")));

});
parcelRegister("24k8L", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $181b93f2be73f5b3$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $181b93f2be73f5b3$var$_style = $181b93f2be73f5b3$require$_interopRequireDefault((parcelRequire("1H8cF")));
const $181b93f2be73f5b3$var$boxShadow = (0, $181b93f2be73f5b3$var$_style.default)({
    prop: 'boxShadow',
    themeKey: 'shadows'
});
var $181b93f2be73f5b3$var$_default = module.exports.default = $181b93f2be73f5b3$var$boxShadow;

});


parcelRegister("8GKEL", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $65366ffa53e8daad$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $65366ffa53e8daad$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $65366ffa53e8daad$var$_typography.default;
    }
});

var $65366ffa53e8daad$var$_typography = $65366ffa53e8daad$require$_interopRequireWildcard((parcelRequire("hBtT8")));
Object.keys($65366ffa53e8daad$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($65366ffa53e8daad$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $65366ffa53e8daad$var$_typography[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $65366ffa53e8daad$var$_typography[key];
        }
    });
});

});
parcelRegister("hBtT8", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $cd0d139319c4212c$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typographyVariant = module.exports.textTransform = module.exports.textAlign = module.exports.lineHeight = module.exports.letterSpacing = module.exports.fontWeight = module.exports.fontStyle = module.exports.fontSize = module.exports.fontFamily = module.exports.default = void 0;

var $cd0d139319c4212c$var$_style = $cd0d139319c4212c$require$_interopRequireDefault((parcelRequire("1H8cF")));

var $cd0d139319c4212c$var$_compose = $cd0d139319c4212c$require$_interopRequireDefault((parcelRequire("lNg8l")));
const $cd0d139319c4212c$var$fontFamily = module.exports.fontFamily = (0, $cd0d139319c4212c$var$_style.default)({
    prop: 'fontFamily',
    themeKey: 'typography'
});
const $cd0d139319c4212c$var$fontSize = module.exports.fontSize = (0, $cd0d139319c4212c$var$_style.default)({
    prop: 'fontSize',
    themeKey: 'typography'
});
const $cd0d139319c4212c$var$fontStyle = module.exports.fontStyle = (0, $cd0d139319c4212c$var$_style.default)({
    prop: 'fontStyle',
    themeKey: 'typography'
});
const $cd0d139319c4212c$var$fontWeight = module.exports.fontWeight = (0, $cd0d139319c4212c$var$_style.default)({
    prop: 'fontWeight',
    themeKey: 'typography'
});
const $cd0d139319c4212c$var$letterSpacing = module.exports.letterSpacing = (0, $cd0d139319c4212c$var$_style.default)({
    prop: 'letterSpacing'
});
const $cd0d139319c4212c$var$textTransform = module.exports.textTransform = (0, $cd0d139319c4212c$var$_style.default)({
    prop: 'textTransform'
});
const $cd0d139319c4212c$var$lineHeight = module.exports.lineHeight = (0, $cd0d139319c4212c$var$_style.default)({
    prop: 'lineHeight'
});
const $cd0d139319c4212c$var$textAlign = module.exports.textAlign = (0, $cd0d139319c4212c$var$_style.default)({
    prop: 'textAlign'
});
const $cd0d139319c4212c$var$typographyVariant = module.exports.typographyVariant = (0, $cd0d139319c4212c$var$_style.default)({
    prop: 'typography',
    cssProperty: false,
    themeKey: 'typography'
});
const $cd0d139319c4212c$var$typography = (0, $cd0d139319c4212c$var$_compose.default)($cd0d139319c4212c$var$typographyVariant, $cd0d139319c4212c$var$fontFamily, $cd0d139319c4212c$var$fontSize, $cd0d139319c4212c$var$fontStyle, $cd0d139319c4212c$var$fontWeight, $cd0d139319c4212c$var$letterSpacing, $cd0d139319c4212c$var$lineHeight, $cd0d139319c4212c$var$textAlign, $cd0d139319c4212c$var$textTransform);
var $cd0d139319c4212c$var$_default = module.exports.default = $cd0d139319c4212c$var$typography;

});


parcelRegister("k6yl9", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $ea2f01699c7a51a1$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $ea2f01699c7a51a1$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ea2f01699c7a51a1$var$_styleFunctionSx.default;
    }
});
Object.defineProperty(module.exports, "extendSxProp", {
    enumerable: true,
    get: function() {
        return $ea2f01699c7a51a1$var$_extendSxProp.default;
    }
});
Object.defineProperty(module.exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $ea2f01699c7a51a1$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty(module.exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $ea2f01699c7a51a1$var$_defaultSxConfig.default;
    }
});

var $ea2f01699c7a51a1$var$_styleFunctionSx = $ea2f01699c7a51a1$require$_interopRequireWildcard((parcelRequire("4fSu5")));

var $ea2f01699c7a51a1$var$_extendSxProp = $ea2f01699c7a51a1$require$_interopRequireDefault((parcelRequire("gIStI")));

var $ea2f01699c7a51a1$var$_defaultSxConfig = $ea2f01699c7a51a1$require$_interopRequireDefault((parcelRequire("lwvds")));

});
parcelRegister("gIStI", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $c2cb03a565de9a60$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c2cb03a565de9a60$var$extendSxProp;

var $5nq0S = parcelRequire("5nq0S");

var $c2cb03a565de9a60$var$_defaultSxConfig = $c2cb03a565de9a60$require$_interopRequireDefault((parcelRequire("lwvds")));
const $c2cb03a565de9a60$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? $c2cb03a565de9a60$var$_defaultSxConfig.default;
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c2cb03a565de9a60$var$extendSxProp(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $c2cb03a565de9a60$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $5nq0S.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});


parcelRegister("jF8P7", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $e508b0d74d3122a9$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e508b0d74d3122a9$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $e508b0d74d3122a9$var$_getThemeValue.default;
    }
});

var $e508b0d74d3122a9$var$_getThemeValue = $e508b0d74d3122a9$require$_interopRequireWildcard((parcelRequire("jirLC")));
Object.keys($e508b0d74d3122a9$var$_getThemeValue).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($e508b0d74d3122a9$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $e508b0d74d3122a9$var$_getThemeValue[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $e508b0d74d3122a9$var$_getThemeValue[key];
        }
    });
});

});
parcelRegister("jirLC", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $e0c53cbb6b1877f3$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.styleFunctionMapping = module.exports.propToStyleFunction = module.exports.default = void 0;

var $e0c53cbb6b1877f3$var$_borders = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("6mdr0")));

var $e0c53cbb6b1877f3$var$_display = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("jkROm")));

var $e0c53cbb6b1877f3$var$_flexbox = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("TDeQX")));

var $e0c53cbb6b1877f3$var$_cssGrid = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("hmOdg")));

var $e0c53cbb6b1877f3$var$_positions = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("funED")));

var $e0c53cbb6b1877f3$var$_palette = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("9JyGZ")));

var $e0c53cbb6b1877f3$var$_shadows = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("7RHsi")));

var $e0c53cbb6b1877f3$var$_sizing = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("40fcn")));

var $e0c53cbb6b1877f3$var$_spacing = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("7GqeV")));

var $e0c53cbb6b1877f3$var$_typography = $e0c53cbb6b1877f3$require$_interopRequireDefault((parcelRequire("8GKEL")));
/** @internal */ const $e0c53cbb6b1877f3$var$styleFunctionMapping = module.exports.styleFunctionMapping = {
    borders: $e0c53cbb6b1877f3$var$_borders.default,
    display: $e0c53cbb6b1877f3$var$_display.default,
    flexbox: $e0c53cbb6b1877f3$var$_flexbox.default,
    grid: $e0c53cbb6b1877f3$var$_cssGrid.default,
    positions: $e0c53cbb6b1877f3$var$_positions.default,
    palette: $e0c53cbb6b1877f3$var$_palette.default,
    shadows: $e0c53cbb6b1877f3$var$_shadows.default,
    sizing: $e0c53cbb6b1877f3$var$_sizing.default,
    spacing: $e0c53cbb6b1877f3$var$_spacing.default,
    typography: $e0c53cbb6b1877f3$var$_typography.default
};
/** @internal */ const $e0c53cbb6b1877f3$var$propToStyleFunction = module.exports.propToStyleFunction = Object.keys($e0c53cbb6b1877f3$var$styleFunctionMapping).reduce((acc, styleFnName)=>{
    const styleFunction = $e0c53cbb6b1877f3$var$styleFunctionMapping[styleFnName];
    for (const propName of styleFunction.filterProps)acc[propName] = styleFunction;
    return acc;
}, {});
function $e0c53cbb6b1877f3$var$getThemeValue(prop, value, theme) {
    const inputProps = {
        [prop]: value,
        theme: theme
    };
    const styleFunction = $e0c53cbb6b1877f3$var$propToStyleFunction[prop];
    return styleFunction ? styleFunction(inputProps) : {
        [prop]: value
    };
}
var $e0c53cbb6b1877f3$var$_default = module.exports.default = $e0c53cbb6b1877f3$var$getThemeValue;

});


parcelRegister("k9pPj", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $eab8ae8c8937219d$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $eab8ae8c8937219d$var$_exportNames = {
    boxClasses: true
};
Object.defineProperty(module.exports, "boxClasses", {
    enumerable: true,
    get: function() {
        return $eab8ae8c8937219d$var$_boxClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $eab8ae8c8937219d$var$_Box.default;
    }
});

var $eab8ae8c8937219d$var$_Box = $eab8ae8c8937219d$require$_interopRequireWildcard((parcelRequire("3qlTE")));
Object.keys($eab8ae8c8937219d$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($eab8ae8c8937219d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eab8ae8c8937219d$var$_Box[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eab8ae8c8937219d$var$_Box[key];
        }
    });
});

var $eab8ae8c8937219d$var$_boxClasses = $eab8ae8c8937219d$require$_interopRequireWildcard((parcelRequire("cDy95")));
Object.keys($eab8ae8c8937219d$var$_boxClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($eab8ae8c8937219d$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $eab8ae8c8937219d$var$_boxClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $eab8ae8c8937219d$var$_boxClasses[key];
        }
    });
});

});
parcelRegister("3qlTE", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $27e4c8fdc40904f7$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27e4c8fdc40904f7$var$_propTypes = $27e4c8fdc40904f7$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $27e4c8fdc40904f7$var$_ClassNameGenerator = $27e4c8fdc40904f7$require$_interopRequireDefault((parcelRequire("eXMbw")));

var $27e4c8fdc40904f7$var$_createBox = $27e4c8fdc40904f7$require$_interopRequireDefault((parcelRequire("7Pqd3")));

var $27e4c8fdc40904f7$var$_boxClasses = $27e4c8fdc40904f7$require$_interopRequireDefault((parcelRequire("cDy95")));
// The SimpleSystemKeys are subset of the AllSystemCSSProperties, so this should be ok
// This is needed as these are used as keys inside AllSystemCSSProperties
/**
 *
 * Demos:
 *
 * - [Box (Material UI)](https://mui.com/material-ui/react-box/)
 * - [Menubar (Material UI)](https://mui.com/material-ui/react-menubar/)
 * - [Box (MUI System)](https://mui.com/system/react-box/)
 *
 * API:
 *
 * - [Box API](https://mui.com/system/api/box/)
 */ const $27e4c8fdc40904f7$var$Box = (0, $27e4c8fdc40904f7$var$_createBox.default)({
    defaultClassName: $27e4c8fdc40904f7$var$_boxClasses.default.root,
    generateClassName: $27e4c8fdc40904f7$var$_ClassNameGenerator.default.generate
});
var $27e4c8fdc40904f7$var$_default = module.exports.default = $27e4c8fdc40904f7$var$Box;

});
parcelRegister("eXMbw", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $ae4bf3dd2e0fee65$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ae4bf3dd2e0fee65$var$_ClassNameGenerator.default;
    }
});

var $ae4bf3dd2e0fee65$var$_ClassNameGenerator = $ae4bf3dd2e0fee65$require$_interopRequireDefault((parcelRequire("d7NwT")));

});
parcelRegister("d7NwT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $98e25959edab07b7$var$defaultGenerator = (componentName)=>componentName;
const $98e25959edab07b7$var$createClassNameGenerator = ()=>{
    let generate = $98e25959edab07b7$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $98e25959edab07b7$var$defaultGenerator;
        }
    };
};
const $98e25959edab07b7$var$ClassNameGenerator = $98e25959edab07b7$var$createClassNameGenerator();
var $98e25959edab07b7$var$_default = module.exports.default = $98e25959edab07b7$var$ClassNameGenerator;

});


parcelRegister("7Pqd3", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $5b31a07c12dd08f0$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5b31a07c12dd08f0$var$_createBox.default;
    }
});

var $5b31a07c12dd08f0$var$_createBox = $5b31a07c12dd08f0$require$_interopRequireDefault((parcelRequire("2Igk8")));

});
parcelRegister("2Igk8", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $1f9c5a675142a04a$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $1f9c5a675142a04a$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1f9c5a675142a04a$var$createBox;

var $1f9c5a675142a04a$var$React = $1f9c5a675142a04a$require$_interopRequireWildcard((parcelRequire("acw62")));

var $1f9c5a675142a04a$var$_clsx = $1f9c5a675142a04a$require$_interopRequireDefault((parcelRequire("bbzhi")));

var $1f9c5a675142a04a$var$_styledEngine = $1f9c5a675142a04a$require$_interopRequireDefault((parcelRequire("keaWW")));

var $1f9c5a675142a04a$var$_styleFunctionSx = $1f9c5a675142a04a$require$_interopRequireDefault((parcelRequire("k6yl9")));

var $1f9c5a675142a04a$var$_useTheme = $1f9c5a675142a04a$require$_interopRequireDefault((parcelRequire("fZXUE")));

var $ayMG0 = parcelRequire("ayMG0");
function $1f9c5a675142a04a$var$createBox(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $1f9c5a675142a04a$var$_styledEngine.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })($1f9c5a675142a04a$var$_styleFunctionSx.default);
    const Box = /*#__PURE__*/ $1f9c5a675142a04a$var$React.forwardRef(function Box(inProps, ref) {
        const theme = (0, $1f9c5a675142a04a$var$_useTheme.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = inProps;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $1f9c5a675142a04a$var$_clsx.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}

});


parcelRegister("cDy95", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $93339d2a1e47fb1c$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $93339d2a1e47fb1c$var$_generateUtilityClasses = $93339d2a1e47fb1c$require$_interopRequireDefault((parcelRequire("5lr9L")));
const $93339d2a1e47fb1c$var$boxClasses = (0, $93339d2a1e47fb1c$var$_generateUtilityClasses.default)('MuiBox', [
    'root'
]);
var $93339d2a1e47fb1c$var$_default = module.exports.default = $93339d2a1e47fb1c$var$boxClasses;

});
parcelRegister("5lr9L", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $3e43fa9b984366c8$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3e43fa9b984366c8$var$_generateUtilityClasses.default;
    }
});

var $3e43fa9b984366c8$var$_generateUtilityClasses = $3e43fa9b984366c8$require$_interopRequireDefault((parcelRequire("jSh1G")));

});
parcelRegister("jSh1G", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $e780447b4aad86c2$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e780447b4aad86c2$var$generateUtilityClasses;

var $e780447b4aad86c2$var$_generateUtilityClass = $e780447b4aad86c2$require$_interopRequireDefault((parcelRequire("dUNRi")));
function $e780447b4aad86c2$var$generateUtilityClasses(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $e780447b4aad86c2$var$_generateUtilityClass.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("dUNRi", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $a2172e36e985423e$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a2172e36e985423e$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $a2172e36e985423e$var$_generateUtilityClass.default;
    }
});

var $a2172e36e985423e$var$_generateUtilityClass = $a2172e36e985423e$require$_interopRequireWildcard((parcelRequire("eNYdP")));
Object.keys($a2172e36e985423e$var$_generateUtilityClass).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($a2172e36e985423e$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $a2172e36e985423e$var$_generateUtilityClass[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $a2172e36e985423e$var$_generateUtilityClass[key];
        }
    });
});

});
parcelRegister("eNYdP", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $ac745b1e27ea573a$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ac745b1e27ea573a$var$generateUtilityClass;
module.exports.globalStateClasses = void 0;
module.exports.isGlobalState = $ac745b1e27ea573a$var$isGlobalState;

var $ac745b1e27ea573a$var$_ClassNameGenerator = $ac745b1e27ea573a$require$_interopRequireDefault((parcelRequire("eXMbw")));
const $ac745b1e27ea573a$var$globalStateClasses = module.exports.globalStateClasses = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $ac745b1e27ea573a$var$generateUtilityClass(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $ac745b1e27ea573a$var$globalStateClasses[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${$ac745b1e27ea573a$var$_ClassNameGenerator.default.generate(componentName)}-${slot}`;
}
function $ac745b1e27ea573a$var$isGlobalState(slot) {
    return $ac745b1e27ea573a$var$globalStateClasses[slot] !== undefined;
}

});







parcelRegister("3DwEm", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $2a5e573e11912dea$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2a5e573e11912dea$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2a5e573e11912dea$var$_createStyled.default;
    }
});

var $2a5e573e11912dea$var$_createStyled = $2a5e573e11912dea$require$_interopRequireWildcard((parcelRequire("h7Pct")));
Object.keys($2a5e573e11912dea$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2a5e573e11912dea$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $2a5e573e11912dea$var$_createStyled[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $2a5e573e11912dea$var$_createStyled[key];
        }
    });
});

});
parcelRegister("h7Pct", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $c77ace6b5afa6944$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $c77ace6b5afa6944$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c77ace6b5afa6944$var$createStyled;
module.exports.shouldForwardProp = $c77ace6b5afa6944$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $c77ace6b5afa6944$var$_styledEngine = $c77ace6b5afa6944$require$_interopRequireWildcard((parcelRequire("keaWW")));

var $c77ace6b5afa6944$var$_isObjectEmpty = $c77ace6b5afa6944$require$_interopRequireDefault((parcelRequire("pu076")));

var $5nq0S = parcelRequire("5nq0S");

var $c77ace6b5afa6944$var$_capitalize = $c77ace6b5afa6944$require$_interopRequireDefault((parcelRequire("iDnDg")));

var $c77ace6b5afa6944$var$_getDisplayName = $c77ace6b5afa6944$require$_interopRequireDefault((parcelRequire("4olkX")));

var $c77ace6b5afa6944$var$_createTheme = $c77ace6b5afa6944$require$_interopRequireDefault((parcelRequire("bFSYU")));

var $c77ace6b5afa6944$var$_styleFunctionSx = $c77ace6b5afa6944$require$_interopRequireDefault((parcelRequire("k6yl9")));

var $c77ace6b5afa6944$var$_preprocessStyles = $c77ace6b5afa6944$require$_interopRequireDefault((parcelRequire("izMq7")));
/* eslint-disable no-underscore-dangle */ /* eslint-disable no-labels */ /* eslint-disable no-lone-blocks */ const $c77ace6b5afa6944$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $c77ace6b5afa6944$var$_createTheme.default)();
// Update /system/styled/#api in case if this changes
function $c77ace6b5afa6944$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $c77ace6b5afa6944$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $c77ace6b5afa6944$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $c77ace6b5afa6944$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = (0, $c77ace6b5afa6944$var$_isObjectEmpty.default)(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $c77ace6b5afa6944$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$c77ace6b5afa6944$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $c77ace6b5afa6944$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $c77ace6b5afa6944$var$shallowLayer((0, $c77ace6b5afa6944$var$_styledEngine.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $c77ace6b5afa6944$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $c77ace6b5afa6944$var$shallowLayer((0, $c77ace6b5afa6944$var$_styledEngine.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $c77ace6b5afa6944$var$shallowLayer((0, $c77ace6b5afa6944$var$_styledEngine.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $c77ace6b5afa6944$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ?? (mergedState = {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            });
            results.push(layerName ? $c77ace6b5afa6944$var$shallowLayer((0, $c77ace6b5afa6944$var$_styledEngine.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $c77ace6b5afa6944$var$shallowLayer((0, $c77ace6b5afa6944$var$_styledEngine.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $c77ace6b5afa6944$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $c77ace6b5afa6944$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $c77ace6b5afa6944$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $c77ace6b5afa6944$var$shouldForwardProp } = input;
    function styleAttachTheme(props) {
        $c77ace6b5afa6944$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $c77ace6b5afa6944$var$_styledEngine.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== $c77ace6b5afa6944$var$_styleFunctionSx.default));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $c77ace6b5afa6944$var$defaultOverridesResolver($c77ace6b5afa6944$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $c77ace6b5afa6944$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($c77ace6b5afa6944$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $c77ace6b5afa6944$var$_styledEngine.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $c77ace6b5afa6944$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $c77ace6b5afa6944$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $5nq0S.isPlainObject)(style)) {
                const serialized = (0, $c77ace6b5afa6944$var$_preprocessStyles.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $c77ace6b5afa6944$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $c77ace6b5afa6944$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $c77ace6b5afa6944$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $c77ace6b5afa6944$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push($c77ace6b5afa6944$var$_styleFunctionSx.default);
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $c77ace6b5afa6944$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $c77ace6b5afa6944$var$_capitalize.default)(componentSlot || '')}`;
    return `Styled(${(0, $c77ace6b5afa6944$var$_getDisplayName.default)(tag)})`;
}
function $c77ace6b5afa6944$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $c77ace6b5afa6944$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $c77ace6b5afa6944$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("4olkX", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $3329f461d72483b9$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $3329f461d72483b9$var$_getDisplayName.default;
    }
});

var $3329f461d72483b9$var$_getDisplayName = $3329f461d72483b9$require$_interopRequireDefault((parcelRequire("hcUak")));

});
parcelRegister("hcUak", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c86f1ff6ebd1c898$var$getDisplayName;

var $iMVQd = parcelRequire("iMVQd");
function $c86f1ff6ebd1c898$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $c86f1ff6ebd1c898$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $c86f1ff6ebd1c898$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/react/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName
 */ function $c86f1ff6ebd1c898$var$getDisplayName(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $c86f1ff6ebd1c898$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case $iMVQd.ForwardRef:
            return $c86f1ff6ebd1c898$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case $iMVQd.Memo:
            return $c86f1ff6ebd1c898$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});


parcelRegister("izMq7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d8610e1cafeb6331$var$preprocessStyles;

var $keaWW = parcelRequire("keaWW");
function $d8610e1cafeb6331$var$preprocessStyles(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $keaWW.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $keaWW.internal_serializeStyles)(variant.style);
    });
    return result;
}

});



parcelRegister("38jtr", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $248139883930aff9$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $248139883930aff9$var$_styled.default;
    }
});

var $248139883930aff9$var$_styled = $248139883930aff9$require$_interopRequireDefault((parcelRequire("h5oUE")));

});
parcelRegister("h5oUE", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $c7063a6eccafa713$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c7063a6eccafa713$var$_createStyled = $c7063a6eccafa713$require$_interopRequireDefault((parcelRequire("3DwEm")));
const $c7063a6eccafa713$var$styled = (0, $c7063a6eccafa713$var$_createStyled.default)();
var $c7063a6eccafa713$var$_default = module.exports.default = $c7063a6eccafa713$var$styled;

});


parcelRegister("6rcYV", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $4aff5592e829768c$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $4aff5592e829768c$var$_useThemeProps.default;
    }
});
Object.defineProperty(module.exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $4aff5592e829768c$var$_getThemeProps.default;
    }
});

var $4aff5592e829768c$var$_useThemeProps = $4aff5592e829768c$require$_interopRequireDefault((parcelRequire("9hHBT")));

var $4aff5592e829768c$var$_getThemeProps = $4aff5592e829768c$require$_interopRequireDefault((parcelRequire("c5aGc")));

});
parcelRegister("9hHBT", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $6c2787aaad9f4ba2$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6c2787aaad9f4ba2$var$useThemeProps;

var $6c2787aaad9f4ba2$var$_getThemeProps = $6c2787aaad9f4ba2$require$_interopRequireDefault((parcelRequire("c5aGc")));

var $6c2787aaad9f4ba2$var$_useTheme = $6c2787aaad9f4ba2$require$_interopRequireDefault((parcelRequire("fZXUE")));
function $6c2787aaad9f4ba2$var$useThemeProps(params) {
    const { props: props, name: name, defaultTheme: defaultTheme, themeId: themeId } = params;
    let theme = (0, $6c2787aaad9f4ba2$var$_useTheme.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $6c2787aaad9f4ba2$var$_getThemeProps.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("c5aGc", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $8cbe3c65b88279b6$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8cbe3c65b88279b6$var$getThemeProps;

var $8cbe3c65b88279b6$var$_resolveProps = $8cbe3c65b88279b6$require$_interopRequireDefault((parcelRequire("9vPfk")));
function $8cbe3c65b88279b6$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $8cbe3c65b88279b6$var$_resolveProps.default)(theme.components[name].defaultProps, props);
}

});
parcelRegister("9vPfk", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $6ecec2c0f1ed0e46$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6ecec2c0f1ed0e46$var$_resolveProps.default;
    }
});

var $6ecec2c0f1ed0e46$var$_resolveProps = $6ecec2c0f1ed0e46$require$_interopRequireDefault((parcelRequire("5NAIm")));

});
parcelRegister("5NAIm", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $438e02106445a5b3$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $438e02106445a5b3$var$resolveProps;

var $438e02106445a5b3$var$_clsx = $438e02106445a5b3$require$_interopRequireDefault((parcelRequire("bbzhi")));
/**
 * Add keys, values of `defaultProps` that does not exist in `props`
 * @param defaultProps
 * @param props
 * @param mergeClassNameAndStyle If `true`, merges `className` and `style` props instead of overriding them.
 *   When `false` (default), props override defaultProps. When `true`, `className` values are concatenated
 *   and `style` objects are merged with props taking precedence.
 * @returns resolved props
 */ function $438e02106445a5b3$var$resolveProps(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    const defaultSlotPropValue = defaultSlotProps[slotPropName];
                    const slotPropValue = slotProps[slotPropName];
                    if (typeof defaultSlotPropValue === 'function' || typeof slotPropValue === 'function') // Function slot props are resolved later (with `ownerState`), so defer
                    // the merge until then to avoid dropping either side.
                    output[propName][slotPropName] = (...args)=>$438e02106445a5b3$var$resolveProps((typeof defaultSlotPropValue === 'function' ? defaultSlotPropValue(...args) : defaultSlotPropValue) ?? {}, (typeof slotPropValue === 'function' ? slotPropValue(...args) : slotPropValue) ?? {}, mergeClassNameAndStyle);
                    else output[propName][slotPropName] = $438e02106445a5b3$var$resolveProps(defaultSlotPropValue ?? {}, slotPropValue ?? {}, mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className !== undefined) output.className = (0, $438e02106445a5b3$var$_clsx.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});





parcelRegister("cJU3a", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $94652a5cc8d24811$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $94652a5cc8d24811$var$_exportNames = {};
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $94652a5cc8d24811$var$_useMediaQuery.default;
    }
});

var $94652a5cc8d24811$var$_useMediaQuery = $94652a5cc8d24811$require$_interopRequireWildcard((parcelRequire("ir9M3")));
Object.keys($94652a5cc8d24811$var$_useMediaQuery).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($94652a5cc8d24811$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $94652a5cc8d24811$var$_useMediaQuery[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $94652a5cc8d24811$var$_useMediaQuery[key];
        }
    });
});

});
parcelRegister("ir9M3", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $d6c2548d4bb2fbb1$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $d6c2548d4bb2fbb1$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.unstable_createUseMediaQuery = $d6c2548d4bb2fbb1$var$unstable_createUseMediaQuery;

var $d6c2548d4bb2fbb1$var$React = $d6c2548d4bb2fbb1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $d6c2548d4bb2fbb1$var$_useEnhancedEffect = $d6c2548d4bb2fbb1$require$_interopRequireDefault((parcelRequire("7U7LW")));

var $6rcYV = parcelRequire("6rcYV");

var $d6c2548d4bb2fbb1$var$_useThemeWithoutDefault = $d6c2548d4bb2fbb1$require$_interopRequireDefault((parcelRequire("4P3l1")));
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $d6c2548d4bb2fbb1$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $d6c2548d4bb2fbb1$var$React.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $d6c2548d4bb2fbb1$var$_useEnhancedEffect.default)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $d6c2548d4bb2fbb1$var$safeReact = {
    ...$d6c2548d4bb2fbb1$var$React
};
const $d6c2548d4bb2fbb1$var$maybeReactUseSyncExternalStore = $d6c2548d4bb2fbb1$var$safeReact.useSyncExternalStore;
function $d6c2548d4bb2fbb1$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $d6c2548d4bb2fbb1$var$React.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $d6c2548d4bb2fbb1$var$React.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $d6c2548d4bb2fbb1$var$React.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $d6c2548d4bb2fbb1$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
// eslint-disable-next-line @typescript-eslint/naming-convention
function $d6c2548d4bb2fbb1$var$unstable_createUseMediaQuery(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $d6c2548d4bb2fbb1$var$_useThemeWithoutDefault.default)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const fallbackMatchMedia = supportMatchMedia ? window.matchMedia : null;
        const { defaultMatches: defaultMatches = false, matchMedia: customMatchMedia, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $6rcYV.getThemeProps)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        const matchMedia = $d6c2548d4bb2fbb1$var$React.useMemo(()=>{
            if (customMatchMedia !== undefined) return customMatchMedia;
            if (fallbackMatchMedia === null) return null;
            return fallbackMatchMedia.bind(window);
        }, [
            customMatchMedia,
            fallbackMatchMedia
        ]);
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $d6c2548d4bb2fbb1$var$maybeReactUseSyncExternalStore !== undefined ? $d6c2548d4bb2fbb1$var$useMediaQueryNew : $d6c2548d4bb2fbb1$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $d6c2548d4bb2fbb1$var$useMediaQuery = $d6c2548d4bb2fbb1$var$unstable_createUseMediaQuery();
var $d6c2548d4bb2fbb1$var$_default = module.exports.default = $d6c2548d4bb2fbb1$var$useMediaQuery;

});
parcelRegister("7U7LW", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $5c13cac48a235db6$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $5c13cac48a235db6$var$_useEnhancedEffect.default;
    }
});

var $5c13cac48a235db6$var$_useEnhancedEffect = $5c13cac48a235db6$require$_interopRequireDefault((parcelRequire("l7Qw3")));

});
parcelRegister("l7Qw3", function(module, exports) {
"use strict";
'use client';

var $c5wSN = parcelRequire("c5wSN");
var $f612fd01febfbacc$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f612fd01febfbacc$var$React = $f612fd01febfbacc$require$_interopRequireWildcard((parcelRequire("acw62")));
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $f612fd01febfbacc$var$useEnhancedEffect = typeof window !== 'undefined' ? $f612fd01febfbacc$var$React.useLayoutEffect : $f612fd01febfbacc$var$React.useEffect;
var $f612fd01febfbacc$var$_default = module.exports.default = $f612fd01febfbacc$var$useEnhancedEffect;

});




parcelRegister("cqEHZ", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $90c77d9c1e8056a1$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $90c77d9c1e8056a1$var$_clamp.default;
    }
});

var $90c77d9c1e8056a1$var$_clamp = $90c77d9c1e8056a1$require$_interopRequireDefault((parcelRequire("59nDr")));

});
parcelRegister("59nDr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $3c002079c74c9a88$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3c002079c74c9a88$var$_default = module.exports.default = $3c002079c74c9a88$var$clamp;

});


parcelRegister("13HOl", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $0c580e3912dd5bc9$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0c580e3912dd5bc9$var$_ThemeProvider.default;
    }
});

var $0c580e3912dd5bc9$var$_ThemeProvider = $0c580e3912dd5bc9$require$_interopRequireDefault((parcelRequire("7zXKh")));

});
parcelRegister("7zXKh", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $584a2579ece51f04$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $584a2579ece51f04$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $584a2579ece51f04$var$React = $584a2579ece51f04$require$_interopRequireWildcard((parcelRequire("acw62")));

var $584a2579ece51f04$var$_propTypes = $584a2579ece51f04$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $hbJt7 = parcelRequire("hbJt7");

var $584a2579ece51f04$var$_exactProp = $584a2579ece51f04$require$_interopRequireDefault((parcelRequire("7nbpM")));

var $keaWW = parcelRequire("keaWW");

var $584a2579ece51f04$var$_useThemeWithoutDefault = $584a2579ece51f04$require$_interopRequireDefault((parcelRequire("4P3l1")));

var $584a2579ece51f04$var$_RtlProvider = $584a2579ece51f04$require$_interopRequireDefault((parcelRequire("d8THF")));

var $584a2579ece51f04$var$_DefaultPropsProvider = $584a2579ece51f04$require$_interopRequireDefault((parcelRequire("9Y3NC")));

var $584a2579ece51f04$var$_useLayerOrder = $584a2579ece51f04$require$_interopRequireDefault((parcelRequire("lnLAY")));

var $ayMG0 = parcelRequire("ayMG0");
const $584a2579ece51f04$var$EMPTY_THEME = {};
function $584a2579ece51f04$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $584a2579ece51f04$var$React.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $584a2579ece51f04$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $584a2579ece51f04$var$_useThemeWithoutDefault.default)($584a2579ece51f04$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $hbJt7.useTheme)() || $584a2579ece51f04$var$EMPTY_THEME;
    const engineTheme = $584a2579ece51f04$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $584a2579ece51f04$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $584a2579ece51f04$var$_useLayerOrder.default)(engineTheme);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($hbJt7.ThemeProvider, {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($keaWW.ThemeContext.Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)($584a2579ece51f04$var$_RtlProvider.default, {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)($584a2579ece51f04$var$_DefaultPropsProvider.default, {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $584a2579ece51f04$var$_default = module.exports.default = $584a2579ece51f04$var$ThemeProvider;

});
parcelRegister("hbJt7", function(module, exports) {
/**
 * @mui/private-theming v9.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $5ULbo = parcelRequire("5ULbo");
var $c836bbdfdfda00f8$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $c836bbdfdfda00f8$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c836bbdfdfda00f8$var$_exportNames = {
    ThemeProvider: true,
    useTheme: true
};
Object.defineProperty(module.exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $c836bbdfdfda00f8$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $c836bbdfdfda00f8$var$_useTheme.default;
    }
});

var $c836bbdfdfda00f8$var$_ThemeProvider = $c836bbdfdfda00f8$require$_interopRequireWildcard((parcelRequire("gmg1g")));
Object.keys($c836bbdfdfda00f8$var$_ThemeProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c836bbdfdfda00f8$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $c836bbdfdfda00f8$var$_ThemeProvider[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $c836bbdfdfda00f8$var$_ThemeProvider[key];
        }
    });
});

var $c836bbdfdfda00f8$var$_useTheme = $c836bbdfdfda00f8$require$_interopRequireDefault((parcelRequire("9Nyui")));

});
parcelRegister("gmg1g", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $be8b20828c746e6c$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $be8b20828c746e6c$var$_ThemeProvider.default;
    }
});
Object.defineProperty(module.exports, "unstable_nested", {
    enumerable: true,
    get: function() {
        return $be8b20828c746e6c$var$_nested.default;
    }
});

var $be8b20828c746e6c$var$_ThemeProvider = $be8b20828c746e6c$require$_interopRequireDefault((parcelRequire("7Tn5g")));

var $be8b20828c746e6c$var$_nested = $be8b20828c746e6c$require$_interopRequireDefault((parcelRequire("d5Qyc")));

});
parcelRegister("7Tn5g", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $5bef936d61b1b66b$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $5bef936d61b1b66b$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5bef936d61b1b66b$var$React = $5bef936d61b1b66b$require$_interopRequireWildcard((parcelRequire("acw62")));

var $5bef936d61b1b66b$var$_propTypes = $5bef936d61b1b66b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $5bef936d61b1b66b$var$_exactProp = $5bef936d61b1b66b$require$_interopRequireDefault((parcelRequire("7nbpM")));

var $5bef936d61b1b66b$var$_ThemeContext = $5bef936d61b1b66b$require$_interopRequireDefault((parcelRequire("2C1BN")));

var $5bef936d61b1b66b$var$_useTheme = $5bef936d61b1b66b$require$_interopRequireDefault((parcelRequire("9Nyui")));

var $5bef936d61b1b66b$var$_nested = $5bef936d61b1b66b$require$_interopRequireDefault((parcelRequire("d5Qyc")));

var $ayMG0 = parcelRequire("ayMG0");
// To support composition of theme.
function $5bef936d61b1b66b$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $5bef936d61b1b66b$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $5bef936d61b1b66b$var$_useTheme.default)();
    const theme = $5bef936d61b1b66b$var$React.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $5bef936d61b1b66b$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[$5bef936d61b1b66b$var$_nested.default] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($5bef936d61b1b66b$var$_ThemeContext.default.Provider, {
        value: theme,
        children: children
    });
}
var $5bef936d61b1b66b$var$_default = module.exports.default = $5bef936d61b1b66b$var$ThemeProvider;

});
parcelRegister("7nbpM", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $55e3891aea6dbbe2$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $55e3891aea6dbbe2$var$_exactProp.default;
    }
});

var $55e3891aea6dbbe2$var$_exactProp = $55e3891aea6dbbe2$require$_interopRequireDefault((parcelRequire("32TUx")));

});
parcelRegister("32TUx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $237cedbcea4a8b49$var$exactProp;
// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
const $237cedbcea4a8b49$var$specialProperty = 'exact-prop: \u200b';
function $237cedbcea4a8b49$var$exactProp(propTypes) {
    var props, prop;
    return propTypes;
}

});


parcelRegister("2C1BN", function(module, exports) {
"use strict";
'use client';

var $c5wSN = parcelRequire("c5wSN");
var $1e7060d386b88b80$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e7060d386b88b80$var$React = $1e7060d386b88b80$require$_interopRequireWildcard((parcelRequire("acw62")));
const $1e7060d386b88b80$var$ThemeContext = /*#__PURE__*/ $1e7060d386b88b80$var$React.createContext(null);
var $1e7060d386b88b80$var$_default = module.exports.default = $1e7060d386b88b80$var$ThemeContext;

});

parcelRegister("9Nyui", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $7223712ef434e40c$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $7223712ef434e40c$var$_useTheme.default;
    }
});

var $7223712ef434e40c$var$_useTheme = $7223712ef434e40c$require$_interopRequireDefault((parcelRequire("kUqhL")));

});
parcelRegister("kUqhL", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $f38d6d61099efe66$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $f38d6d61099efe66$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f38d6d61099efe66$var$useTheme;

var $f38d6d61099efe66$var$React = $f38d6d61099efe66$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f38d6d61099efe66$var$_ThemeContext = $f38d6d61099efe66$require$_interopRequireDefault((parcelRequire("2C1BN")));
function $f38d6d61099efe66$var$useTheme() {
    const theme = $f38d6d61099efe66$var$React.useContext($f38d6d61099efe66$var$_ThemeContext.default);
    return theme;
}

});


parcelRegister("d5Qyc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $9884816ca1a7fb1e$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $9884816ca1a7fb1e$var$_default = module.exports.default = $9884816ca1a7fb1e$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

});




parcelRegister("d8THF", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $99173b35fd0074ac$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $99173b35fd0074ac$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useRtl = module.exports.default = void 0;

var $99173b35fd0074ac$var$React = $99173b35fd0074ac$require$_interopRequireWildcard((parcelRequire("acw62")));

var $99173b35fd0074ac$var$_propTypes = $99173b35fd0074ac$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $ayMG0 = parcelRequire("ayMG0");
const $99173b35fd0074ac$var$RtlContext = /*#__PURE__*/ $99173b35fd0074ac$var$React.createContext(undefined);
function $99173b35fd0074ac$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($99173b35fd0074ac$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $99173b35fd0074ac$var$useRtl = ()=>{
    const value = $99173b35fd0074ac$var$React.useContext($99173b35fd0074ac$var$RtlContext);
    return value ?? false;
};
module.exports.useRtl = $99173b35fd0074ac$var$useRtl;
var $99173b35fd0074ac$var$_default = module.exports.default = $99173b35fd0074ac$var$RtlProvider;

});

parcelRegister("9Y3NC", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $741caa183ed249f9$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $741caa183ed249f9$var$_DefaultPropsProvider.default;
    }
});
Object.defineProperty(module.exports, "useDefaultProps", {
    enumerable: true,
    get: function() {
        return $741caa183ed249f9$var$_DefaultPropsProvider.useDefaultProps;
    }
});

var $741caa183ed249f9$var$_DefaultPropsProvider = $741caa183ed249f9$require$_interopRequireWildcard((parcelRequire("9dgaL")));

});
parcelRegister("9dgaL", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $6b51df7a56f7f586$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $6b51df7a56f7f586$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.useDefaultProps = $6b51df7a56f7f586$var$useDefaultProps;

var $6b51df7a56f7f586$var$React = $6b51df7a56f7f586$require$_interopRequireWildcard((parcelRequire("acw62")));

var $6b51df7a56f7f586$var$_propTypes = $6b51df7a56f7f586$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $6b51df7a56f7f586$var$_resolveProps = $6b51df7a56f7f586$require$_interopRequireDefault((parcelRequire("9vPfk")));

var $ayMG0 = parcelRequire("ayMG0");
const $6b51df7a56f7f586$var$PropsContext = /*#__PURE__*/ $6b51df7a56f7f586$var$React.createContext(undefined);
function $6b51df7a56f7f586$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6b51df7a56f7f586$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $6b51df7a56f7f586$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $6b51df7a56f7f586$var$_resolveProps.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $6b51df7a56f7f586$var$_resolveProps.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $6b51df7a56f7f586$var$useDefaultProps({ props: props, name: name }) {
    const ctx = $6b51df7a56f7f586$var$React.useContext($6b51df7a56f7f586$var$PropsContext);
    return $6b51df7a56f7f586$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $6b51df7a56f7f586$var$_default = module.exports.default = $6b51df7a56f7f586$var$DefaultPropsProvider;

});


parcelRegister("lnLAY", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $f910aa666321dc1d$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f910aa666321dc1d$var$useLayerOrder;

var $f910aa666321dc1d$var$_useEnhancedEffect = $f910aa666321dc1d$require$_interopRequireDefault((parcelRequire("7U7LW")));

var $f910aa666321dc1d$var$_useId = $f910aa666321dc1d$require$_interopRequireDefault((parcelRequire("gue1L")));

var $f910aa666321dc1d$var$_GlobalStyles = $f910aa666321dc1d$require$_interopRequireDefault((parcelRequire("joyms")));

var $f910aa666321dc1d$var$_useThemeWithoutDefault = $f910aa666321dc1d$require$_interopRequireDefault((parcelRequire("4P3l1")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * This hook returns a `GlobalStyles` component that sets the CSS layer order (for server-side rendering).
 * Then on client-side, it injects the CSS layer order into the document head to ensure that the layer order is always present first before other Emotion styles.
 */ function $f910aa666321dc1d$var$useLayerOrder(theme) {
    const upperTheme = (0, $f910aa666321dc1d$var$_useThemeWithoutDefault.default)();
    const id = (0, $f910aa666321dc1d$var$_useId.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $f910aa666321dc1d$var$_useEnhancedEffect.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f910aa666321dc1d$var$_GlobalStyles.default, {
        styles: layerOrder
    });
}

});
parcelRegister("gue1L", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $c00a543d8679e782$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $c00a543d8679e782$var$_useId.default;
    }
});

var $c00a543d8679e782$var$_useId = $c00a543d8679e782$require$_interopRequireDefault((parcelRequire("c0Kye")));

});
parcelRegister("c0Kye", function(module, exports) {
"use strict";
'use client';

var $c5wSN = parcelRequire("c5wSN");
var $8be99839fa72b1d2$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8be99839fa72b1d2$var$useId;

var $8be99839fa72b1d2$var$React = $8be99839fa72b1d2$require$_interopRequireWildcard((parcelRequire("acw62")));
let $8be99839fa72b1d2$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $8be99839fa72b1d2$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $8be99839fa72b1d2$var$React.useState(idOverride);
    const id = idOverride || defaultId;
    $8be99839fa72b1d2$var$React.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $8be99839fa72b1d2$var$globalId += 1;
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setDefaultId(`mui-${$8be99839fa72b1d2$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $8be99839fa72b1d2$var$safeReact = {
    ...$8be99839fa72b1d2$var$React
};
const $8be99839fa72b1d2$var$maybeReactUseId = $8be99839fa72b1d2$var$safeReact.useId;
/**
 *
 * @example <div id={useId()} />
 * @param idOverride
 * @returns {string}
 */ function $8be99839fa72b1d2$var$useId(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($8be99839fa72b1d2$var$maybeReactUseId !== undefined) {
        const reactId = $8be99839fa72b1d2$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $8be99839fa72b1d2$var$useGlobalId(idOverride);
}

});





parcelRegister("aGWkF", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $7c8b133463ac7027$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7c8b133463ac7027$var$unstable_memoTheme;

var $7c8b133463ac7027$var$_preprocessStyles = $7c8b133463ac7027$require$_interopRequireDefault((parcelRequire("izMq7")));
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $7c8b133463ac7027$var$arg = {
    theme: undefined
};
/**
 * Memoize style function on theme.
 * Intended to be used in styled() calls that only need access to the theme.
 */ function $7c8b133463ac7027$var$unstable_memoTheme(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $7c8b133463ac7027$var$arg.theme = props.theme;
            value = (0, $7c8b133463ac7027$var$_preprocessStyles.default)(styleFn($7c8b133463ac7027$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});

parcelRegister("7bdRN", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $53a451239a4aa4bb$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $53a451239a4aa4bb$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DISABLE_CSS_TRANSITION = void 0;
module.exports.default = $53a451239a4aa4bb$var$createCssVarsProvider;

var $53a451239a4aa4bb$var$React = $53a451239a4aa4bb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $53a451239a4aa4bb$var$_propTypes = $53a451239a4aa4bb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $keaWW = parcelRequire("keaWW");

var $hbJt7 = parcelRequire("hbJt7");

var $53a451239a4aa4bb$var$_useEnhancedEffect = $53a451239a4aa4bb$require$_interopRequireDefault((parcelRequire("7U7LW")));

var $53a451239a4aa4bb$var$_ThemeProvider = $53a451239a4aa4bb$require$_interopRequireDefault((parcelRequire("13HOl")));

var $2uIMb = parcelRequire("2uIMb");

var $53a451239a4aa4bb$var$_useCurrentColorScheme = $53a451239a4aa4bb$require$_interopRequireDefault((parcelRequire("l1iL0")));

var $ayMG0 = parcelRequire("ayMG0");
/**
 * @internal
 */ const $53a451239a4aa4bb$var$DISABLE_CSS_TRANSITION = module.exports.DISABLE_CSS_TRANSITION = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $53a451239a4aa4bb$var$createCssVarsProvider(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = $2uIMb.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: defaultColorSchemeStorageKey = $2uIMb.DEFAULT_COLOR_SCHEME_STORAGE_KEY, disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $53a451239a4aa4bb$var$React.createContext(undefined);
    const useColorScheme = ()=>$53a451239a4aa4bb$var$React.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $53a451239a4aa4bb$var$React.useRef(false);
        const upperTheme = (0, $hbJt7.useTheme)();
        const ctx = $53a451239a4aa4bb$var$React.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $53a451239a4aa4bb$var$React.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $53a451239a4aa4bb$var$React.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $53a451239a4aa4bb$var$_useCurrentColorScheme.default)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $53a451239a4aa4bb$var$React.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $53a451239a4aa4bb$var$_useEnhancedEffect.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $53a451239a4aa4bb$var$React.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($53a451239a4aa4bb$var$DISABLE_CSS_TRANSITION));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $53a451239a4aa4bb$var$React.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $53a451239a4aa4bb$var$React.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $ayMG0.jsxs)($53a451239a4aa4bb$var$React.Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)($53a451239a4aa4bb$var$_ThemeProvider.default, {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $ayMG0.jsx)($keaWW.GlobalStyles, {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $ayMG0.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $2uIMb.buildInitColorSchemeScript)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}

});
parcelRegister("2uIMb", function(module, exports) {
"use strict";
'use client';

var $c5wSN = parcelRequire("c5wSN");
var $1d111db69e40239f$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_ATTRIBUTE = void 0;
module.exports.buildInitColorSchemeScript = $1d111db69e40239f$var$buildInitColorSchemeScript;
module.exports.default = $1d111db69e40239f$var$InitColorSchemeScript;

var $1d111db69e40239f$var$React = $1d111db69e40239f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $ayMG0 = parcelRequire("ayMG0");
const $1d111db69e40239f$var$DEFAULT_MODE_STORAGE_KEY = module.exports.DEFAULT_MODE_STORAGE_KEY = 'mode';
const $1d111db69e40239f$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY = module.exports.DEFAULT_COLOR_SCHEME_STORAGE_KEY = 'color-scheme';
const $1d111db69e40239f$var$DEFAULT_ATTRIBUTE = module.exports.DEFAULT_ATTRIBUTE = 'data-color-scheme';
// React 17 has no `useSyncExternalStore`; spread into a plain object so reading the
// missing property returns `undefined` instead of throwing under strict ESM. See #41190 (comment).
const $1d111db69e40239f$var$safeReact = {
    ...$1d111db69e40239f$var$React
};
const $1d111db69e40239f$var$maybeReactUseSyncExternalStore = $1d111db69e40239f$var$safeReact.useSyncExternalStore;
const $1d111db69e40239f$var$subscribe = ()=>()=>{};
// Serialize a value into a JS string literal safe to embed in the inline script. JSON.stringify
// escapes quotes and backslashes; the extra replaces handle what it does not: `<` (so `</script>`
// can't close the element) and the U+2028/U+2029 line separators, invalid raw inside a JS string.
function $1d111db69e40239f$var$serializeScriptValue(value) {
    return JSON.stringify(value).replace(/</g, '\\u003c').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
}
// Insert a runtime scheme variable (`light`, `dark`, or `colorScheme`) into every `%s` placeholder
// of an attribute/selector template.
function $1d111db69e40239f$var$interpolateScheme(template, variable) {
    const segments = template.split('%s');
    const tokens = [];
    for(let index = 0; index < segments.length; index += 1){
        if (index > 0) tokens.push(variable);
        if (segments[index]) tokens.push($1d111db69e40239f$var$serializeScriptValue(segments[index]));
    }
    return tokens.join(' + ') || '""';
}
/**
 * `true` during the server render and the matching hydration render, `false`
 * on every client render afterwards. React warns when a `<script>` is
 * created during a client render (such scripts never execute), so the inline
 * script is only emitted on the server pass and dropped after hydration — the
 * attribute it already set on the document persists. React <18 has no
 * `useSyncExternalStore` and no such warning, so the script is always emitted.
 */ function $1d111db69e40239f$var$useIsServerRender() {
    if ($1d111db69e40239f$var$maybeReactUseSyncExternalStore === undefined) return true;
    return $1d111db69e40239f$var$maybeReactUseSyncExternalStore($1d111db69e40239f$var$subscribe, ()=>false, ()=>true);
}
function $1d111db69e40239f$var$buildInitColorSchemeScript(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $1d111db69e40239f$var$DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $1d111db69e40239f$var$DEFAULT_COLOR_SCHEME_STORAGE_KEY, attribute: initialAttribute = $1d111db69e40239f$var$DEFAULT_ATTRIBUTE, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove(${$1d111db69e40239f$var$interpolateScheme(selector, 'light')}, ${$1d111db69e40239f$var$interpolateScheme(selector, 'dark')});
      ${colorSchemeNode}.classList.add(${$1d111db69e40239f$var$interpolateScheme(selector, 'colorScheme')});`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const separator = matches[1].indexOf('=');
        const attr = separator === -1 ? matches[1] : matches[1].slice(0, separator);
        const value = separator === -1 ? undefined : matches[1].slice(separator + 1);
        if (!value) setter += `${colorSchemeNode}.removeAttribute(${$1d111db69e40239f$var$interpolateScheme(attr, 'light')});
      ${colorSchemeNode}.removeAttribute(${$1d111db69e40239f$var$interpolateScheme(attr, 'dark')});`;
        const attributeValue = value ? $1d111db69e40239f$var$interpolateScheme(value.replace(/^(['"])(.*)\1$/, '$2'), 'colorScheme') : '""';
        setter += `
      ${colorSchemeNode}.setAttribute(${$1d111db69e40239f$var$interpolateScheme(attr, 'colorScheme')}, ${attributeValue});`;
    } else if (!attribute.startsWith('.')) setter += `${colorSchemeNode}.setAttribute(${$1d111db69e40239f$var$serializeScriptValue(attribute)}, colorScheme);`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem(${$1d111db69e40239f$var$serializeScriptValue(modeStorageKey)}) || ${$1d111db69e40239f$var$serializeScriptValue(defaultMode)};
  const dark = localStorage.getItem(${$1d111db69e40239f$var$serializeScriptValue(`${colorSchemeStorageKey}-dark`)}) || ${$1d111db69e40239f$var$serializeScriptValue(defaultDarkColorScheme)};
  const light = localStorage.getItem(${$1d111db69e40239f$var$serializeScriptValue(`${colorSchemeStorageKey}-light`)}) || ${$1d111db69e40239f$var$serializeScriptValue(defaultLightColorScheme)};
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}
function $1d111db69e40239f$var$InitColorSchemeScript(options) {
    const isServerRender = $1d111db69e40239f$var$useIsServerRender();
    if (!isServerRender) return null;
    return $1d111db69e40239f$var$buildInitColorSchemeScript(options);
}

});

parcelRegister("l1iL0", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $f4d83dc3730f6a2f$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $f4d83dc3730f6a2f$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4d83dc3730f6a2f$var$useCurrentColorScheme;
module.exports.getColorScheme = $f4d83dc3730f6a2f$var$getColorScheme;
module.exports.getSystemMode = $f4d83dc3730f6a2f$var$getSystemMode;

var $f4d83dc3730f6a2f$var$React = $f4d83dc3730f6a2f$require$_interopRequireWildcard((parcelRequire("acw62")));

var $2uIMb = parcelRequire("2uIMb");

var $f4d83dc3730f6a2f$var$_localStorageManager = $f4d83dc3730f6a2f$require$_interopRequireDefault((parcelRequire("769Bf")));
function $f4d83dc3730f6a2f$var$noop() {}
function $f4d83dc3730f6a2f$var$getSystemMode(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $f4d83dc3730f6a2f$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $f4d83dc3730f6a2f$var$getColorScheme(state) {
    return $f4d83dc3730f6a2f$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $f4d83dc3730f6a2f$var$useCurrentColorScheme(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = $2uIMb.DEFAULT_MODE_STORAGE_KEY, colorSchemeStorageKey: colorSchemeStorageKey = $2uIMb.DEFAULT_COLOR_SCHEME_STORAGE_KEY, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = $f4d83dc3730f6a2f$var$_localStorageManager.default, noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $f4d83dc3730f6a2f$var$React.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $f4d83dc3730f6a2f$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $f4d83dc3730f6a2f$var$React.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $f4d83dc3730f6a2f$var$React.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $f4d83dc3730f6a2f$var$getSystemMode(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $f4d83dc3730f6a2f$var$React.useState(noSsr || !isMultiSchemes);
    $f4d83dc3730f6a2f$var$React.useEffect(()=>{
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $f4d83dc3730f6a2f$var$getColorScheme(state);
    const setMode = $f4d83dc3730f6a2f$var$React.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $f4d83dc3730f6a2f$var$getSystemMode(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $f4d83dc3730f6a2f$var$React.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $f4d83dc3730f6a2f$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $f4d83dc3730f6a2f$var$React.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $f4d83dc3730f6a2f$var$React.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $f4d83dc3730f6a2f$var$React.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $f4d83dc3730f6a2f$var$React.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $f4d83dc3730f6a2f$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $f4d83dc3730f6a2f$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $f4d83dc3730f6a2f$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}

});
parcelRegister("769Bf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $52b08a3dc2adbb9c$var$noop() {}
const $52b08a3dc2adbb9c$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $52b08a3dc2adbb9c$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $52b08a3dc2adbb9c$var$_default = module.exports.default = $52b08a3dc2adbb9c$var$localStorageManager;

});



parcelRegister("4xeKC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $34d5afb976087c89$var$createGetCssVar;
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $34d5afb976087c89$var$createGetCssVar(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("8i1Cv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignNestedKeys = void 0;
module.exports.default = $609142df2c1b4cce$var$cssVarsParser;
module.exports.walkObjectDeep = void 0;
const $609142df2c1b4cce$var$prototypePollutingKeys = new Set([
    '__proto__',
    'constructor',
    'prototype'
]);
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $609142df2c1b4cce$var$assignNestedKeys = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    for(let index = 0; index < keys.length; index += 1){
        const k = keys[index];
        // Prevent prototype pollution: never traverse or write through
        // `__proto__` / `constructor` / `prototype` (e.g. a theme parsed from untrusted JSON).
        if ($609142df2c1b4cce$var$prototypePollutingKeys.has(k)) break;
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    }
};
/**
 *
 * @param {Object} obj : source object
 * @param {Function} callback : a function that will be called when
 *                   - the deepest key in source object is reached
 *                   - the value of the deepest key is NOT `undefined` | `null`
 *
 * @example
 * walkObjectDeep({ palette: { primary: { main: '#000000' } } }, console.log)
 * // ['palette', 'primary', 'main'] '#000000'
 */ module.exports.assignNestedKeys = $609142df2c1b4cce$var$assignNestedKeys;
const $609142df2c1b4cce$var$walkObjectDeep = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
module.exports.walkObjectDeep = $609142df2c1b4cce$var$walkObjectDeep;
const $609142df2c1b4cce$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
/**
 * a function that parse theme and return { css, vars }
 *
 * @param {Object} theme
 * @param {{
 *  prefix?: string,
 *  shouldSkipGeneratingVar?: (objectPathKeys: Array<string>, value: string | number) => boolean
 * }} options.
 *  `prefix`: The prefix of the generated CSS variables. This function does not change the value.
 *
 * @returns {{ css: Object, vars: Object }} `css` is the stylesheet, `vars` is an object to get css variable (same structure as theme).
 *
 * @example
 * const { css, vars } = parser({
 *   fontSize: 12,
 *   lineHeight: 1.2,
 *   palette: { primary: { 500: 'var(--color)' } }
 * }, { prefix: 'foo' })
 *
 * console.log(css) // { '--foo-fontSize': '12px', '--foo-lineHeight': 1.2, '--foo-palette-primary-500': 'var(--color)' }
 * console.log(vars) // { fontSize: 'var(--foo-fontSize)', lineHeight: 'var(--foo-lineHeight)', palette: { primary: { 500: 'var(--foo-palette-primary-500)' } } }
 */ function $609142df2c1b4cce$var$cssVarsParser(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $609142df2c1b4cce$var$walkObjectDeep(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $609142df2c1b4cce$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $609142df2c1b4cce$var$assignNestedKeys(vars, keys, `var(${cssVar})`, arrayKeys);
                $609142df2c1b4cce$var$assignNestedKeys(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});

parcelRegister("j1tZV", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $dd95613e8a3234e2$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dd95613e8a3234e2$var$_deepmerge = $dd95613e8a3234e2$require$_interopRequireDefault((parcelRequire("5nq0S")));

var $dd95613e8a3234e2$var$_cssVarsParser = $dd95613e8a3234e2$require$_interopRequireDefault((parcelRequire("8i1Cv")));
function $dd95613e8a3234e2$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-expect-error - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $dd95613e8a3234e2$var$_cssVarsParser.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $dd95613e8a3234e2$var$_cssVarsParser.default)(scheme, parserConfig);
        themeVars = (0, $dd95613e8a3234e2$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $dd95613e8a3234e2$var$_cssVarsParser.default)(defaultScheme, parserConfig);
        themeVars = (0, $dd95613e8a3234e2$var$_deepmerge.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $dd95613e8a3234e2$var$_deepmerge.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $dd95613e8a3234e2$var$_default = module.exports.default = $dd95613e8a3234e2$var$prepareCssVars;

});

parcelRegister("5J216", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $42b2b83461361f97$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42b2b83461361f97$var$_prepareCssVars = $42b2b83461361f97$require$_interopRequireDefault((parcelRequire("j1tZV")));

var $ecDsP = parcelRequire("ecDsP");

var $2uIMb = parcelRequire("2uIMb");
function $42b2b83461361f97$var$createCssVarsTheme({ colorSchemeSelector: colorSchemeSelector = `[${$2uIMb.DEFAULT_ATTRIBUTE}="%s"]`, ...theme }) {
    const output = theme;
    const result = (0, $42b2b83461361f97$var$_prepareCssVars.default)(output, {
        ...theme,
        prefix: theme.cssVarPrefix,
        colorSchemeSelector: colorSchemeSelector
    });
    output.vars = result.vars;
    output.generateThemeVars = result.generateThemeVars;
    output.generateStyleSheets = result.generateStyleSheets;
    output.colorSchemeSelector = colorSchemeSelector;
    output.getColorSchemeSelector = (0, $ecDsP.createGetColorSchemeSelector)(colorSchemeSelector);
    output.internal_cache = {};
    return output;
}
var $42b2b83461361f97$var$_default = module.exports.default = $42b2b83461361f97$var$createCssVarsTheme;

});
parcelRegister("ecDsP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createGetColorSchemeSelector = $a570cc62d1ae7a46$var$createGetColorSchemeSelector;
/* eslint-disable import/prefer-default-export */ function $a570cc62d1ae7a46$var$createGetColorSchemeSelector(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});


parcelRegister("lIAT2", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $fcfa51f7eac3a094$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $fcfa51f7eac3a094$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fcfa51f7eac3a094$var$createContainer;

var $fcfa51f7eac3a094$var$React = $fcfa51f7eac3a094$require$_interopRequireWildcard((parcelRequire("acw62")));

var $fcfa51f7eac3a094$var$_propTypes = $fcfa51f7eac3a094$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $fcfa51f7eac3a094$var$_clsx = $fcfa51f7eac3a094$require$_interopRequireDefault((parcelRequire("bbzhi")));

var $fcfa51f7eac3a094$var$_generateUtilityClass = $fcfa51f7eac3a094$require$_interopRequireDefault((parcelRequire("dUNRi")));

var $fcfa51f7eac3a094$var$_composeClasses = $fcfa51f7eac3a094$require$_interopRequireDefault((parcelRequire("eXUB7")));

var $fcfa51f7eac3a094$var$_capitalize = $fcfa51f7eac3a094$require$_interopRequireDefault((parcelRequire("iDnDg")));

var $fcfa51f7eac3a094$var$_useThemeProps = $fcfa51f7eac3a094$require$_interopRequireDefault((parcelRequire("6rcYV")));

var $fcfa51f7eac3a094$var$_styled = $fcfa51f7eac3a094$require$_interopRequireDefault((parcelRequire("38jtr")));

var $fcfa51f7eac3a094$var$_createTheme = $fcfa51f7eac3a094$require$_interopRequireDefault((parcelRequire("bFSYU")));

var $ayMG0 = parcelRequire("ayMG0");
const $fcfa51f7eac3a094$var$defaultTheme = (0, $fcfa51f7eac3a094$var$_createTheme.default)();
const $fcfa51f7eac3a094$var$defaultCreateStyledComponent = (0, $fcfa51f7eac3a094$var$_styled.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $fcfa51f7eac3a094$var$_capitalize.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $fcfa51f7eac3a094$var$useThemePropsDefault = (inProps)=>(0, $fcfa51f7eac3a094$var$_useThemeProps.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $fcfa51f7eac3a094$var$defaultTheme
    });
const $fcfa51f7eac3a094$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $fcfa51f7eac3a094$var$_generateUtilityClass.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $fcfa51f7eac3a094$var$_capitalize.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $fcfa51f7eac3a094$var$_composeClasses.default)(slots, getContainerUtilityClass, classes);
};
function $fcfa51f7eac3a094$var$createContainer(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $fcfa51f7eac3a094$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $fcfa51f7eac3a094$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $fcfa51f7eac3a094$var$React.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $fcfa51f7eac3a094$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $ayMG0.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $fcfa51f7eac3a094$var$_clsx.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}

});
parcelRegister("eXUB7", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $ae527a845c7e341b$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $ae527a845c7e341b$var$_composeClasses.default;
    }
});

var $ae527a845c7e341b$var$_composeClasses = $ae527a845c7e341b$require$_interopRequireDefault((parcelRequire("hEphF")));

});
parcelRegister("hEphF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cd99c8f003d862a7$var$composeClasses;
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $cd99c8f003d862a7$var$composeClasses(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});



parcelRegister("14TAD", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $0c91492c732dbef7$require$_interopRequireWildcard = $c5wSN.default;

var $5ULbo = parcelRequire("5ULbo");
var $0c91492c732dbef7$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0c91492c732dbef7$var$_exportNames = {
    containerClasses: true
};
Object.defineProperty(module.exports, "containerClasses", {
    enumerable: true,
    get: function() {
        return $0c91492c732dbef7$var$_containerClasses.default;
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $0c91492c732dbef7$var$_Container.default;
    }
});

var $0c91492c732dbef7$var$_Container = $0c91492c732dbef7$require$_interopRequireDefault((parcelRequire("4PFpt")));

var $0c91492c732dbef7$var$_containerClasses = $0c91492c732dbef7$require$_interopRequireWildcard((parcelRequire("1hE5l")));
Object.keys($0c91492c732dbef7$var$_containerClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($0c91492c732dbef7$var$_exportNames, key)) return;
    if (key in module.exports && module.exports[key] === $0c91492c732dbef7$var$_containerClasses[key]) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function() {
            return $0c91492c732dbef7$var$_containerClasses[key];
        }
    });
});

});
parcelRegister("4PFpt", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $384c0bfe6a7415bd$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $384c0bfe6a7415bd$var$_propTypes = $384c0bfe6a7415bd$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $384c0bfe6a7415bd$var$_createContainer = $384c0bfe6a7415bd$require$_interopRequireDefault((parcelRequire("lIAT2")));
/**
 *
 * Demos:
 *
 * - [Container (Material UI)](https://mui.com/material-ui/react-container/)
 * - [Container (MUI System)](https://mui.com/system/react-container/)
 *
 * API:
 *
 * - [Container API](https://mui.com/system/api/container/)
 */ const $384c0bfe6a7415bd$var$Container = (0, $384c0bfe6a7415bd$var$_createContainer.default)();
var $384c0bfe6a7415bd$var$_default = module.exports.default = $384c0bfe6a7415bd$var$Container;

});

parcelRegister("1hE5l", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $0ef6790e8466f443$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getContainerUtilityClass = $0ef6790e8466f443$var$getContainerUtilityClass;

var $0ef6790e8466f443$var$_generateUtilityClasses = $0ef6790e8466f443$require$_interopRequireDefault((parcelRequire("5lr9L")));

var $0ef6790e8466f443$var$_generateUtilityClass = $0ef6790e8466f443$require$_interopRequireDefault((parcelRequire("dUNRi")));
function $0ef6790e8466f443$var$getContainerUtilityClass(slot) {
    return (0, $0ef6790e8466f443$var$_generateUtilityClass.default)('MuiContainer', slot);
}
const $0ef6790e8466f443$var$containerClasses = (0, $0ef6790e8466f443$var$_generateUtilityClasses.default)('MuiContainer', [
    'root',
    'disableGutters',
    'fixed',
    'maxWidthXs',
    'maxWidthSm',
    'maxWidthMd',
    'maxWidthLg',
    'maxWidthXl'
]);
var $0ef6790e8466f443$var$_default = module.exports.default = $0ef6790e8466f443$var$containerClasses;

});


parcelRegister("fMhQa", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $b7c92d6f46c816e9$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7c92d6f46c816e9$var$_propTypes = $b7c92d6f46c816e9$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b7c92d6f46c816e9$var$_createGrid = $b7c92d6f46c816e9$require$_interopRequireDefault((parcelRequire("dd6tk")));
/**
 *
 * Demos:
 *
 * - [Grid (Material UI)](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/system/api/grid/)
 */ const $b7c92d6f46c816e9$var$Grid = (0, $b7c92d6f46c816e9$var$_createGrid.default)();
var $b7c92d6f46c816e9$var$_default = module.exports.default = $b7c92d6f46c816e9$var$Grid;

});
parcelRegister("dd6tk", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $99e18274a55c78fb$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $99e18274a55c78fb$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $99e18274a55c78fb$var$createGrid;

var $99e18274a55c78fb$var$React = $99e18274a55c78fb$require$_interopRequireWildcard((parcelRequire("acw62")));

var $99e18274a55c78fb$var$_propTypes = $99e18274a55c78fb$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $99e18274a55c78fb$var$_clsx = $99e18274a55c78fb$require$_interopRequireDefault((parcelRequire("bbzhi")));

var $99e18274a55c78fb$var$_isMuiElement = $99e18274a55c78fb$require$_interopRequireDefault((parcelRequire("7IJsj")));

var $99e18274a55c78fb$var$_generateUtilityClass = $99e18274a55c78fb$require$_interopRequireDefault((parcelRequire("dUNRi")));

var $99e18274a55c78fb$var$_composeClasses = $99e18274a55c78fb$require$_interopRequireDefault((parcelRequire("eXUB7")));

var $99e18274a55c78fb$var$_styled = $99e18274a55c78fb$require$_interopRequireDefault((parcelRequire("38jtr")));

var $99e18274a55c78fb$var$_useThemeProps = $99e18274a55c78fb$require$_interopRequireDefault((parcelRequire("6rcYV")));

var $99e18274a55c78fb$var$_useTheme = $99e18274a55c78fb$require$_interopRequireDefault((parcelRequire("fZXUE")));

var $99e18274a55c78fb$var$_createTheme = $99e18274a55c78fb$require$_interopRequireDefault((parcelRequire("bFSYU")));

var $NIx3S = parcelRequire("NIx3S");

var $ayMG0 = parcelRequire("ayMG0");
const $99e18274a55c78fb$var$defaultTheme = (0, $99e18274a55c78fb$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $99e18274a55c78fb$var$defaultCreateStyledComponent = (0, $99e18274a55c78fb$var$_styled.default)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $99e18274a55c78fb$var$useThemePropsDefault(props) {
    return (0, $99e18274a55c78fb$var$_useThemeProps.default)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $99e18274a55c78fb$var$defaultTheme
    });
}
function $99e18274a55c78fb$var$createGrid(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $99e18274a55c78fb$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $99e18274a55c78fb$var$useThemePropsDefault, useTheme: useTheme = $99e18274a55c78fb$var$_useTheme.default, componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $NIx3S.generateDirectionClasses)(direction),
                ...(0, $NIx3S.generateSizeClassNames)(size),
                ...container ? (0, $NIx3S.generateSpacingClassNames)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $99e18274a55c78fb$var$_composeClasses.default)(slots, (slot)=>(0, $99e18274a55c78fb$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent($NIx3S.generateGridColumnsStyles, $NIx3S.generateGridColumnSpacingStyles, $NIx3S.generateGridRowSpacingStyles, $NIx3S.generateGridSizeStyles, $NIx3S.generateGridDirectionStyles, $NIx3S.generateGridStyles, $NIx3S.generateGridOffsetStyles);
    const Grid = /*#__PURE__*/ $99e18274a55c78fb$var$React.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = themeProps;
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $99e18274a55c78fb$var$_clsx.default)(classes.root, className),
            ...other,
            children: $99e18274a55c78fb$var$React.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $99e18274a55c78fb$var$React.isValidElement(child) && (0, $99e18274a55c78fb$var$_isMuiElement.default)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $99e18274a55c78fb$var$React.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-expect-error internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}

});
parcelRegister("7IJsj", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $59efe6fc0694469e$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $59efe6fc0694469e$var$_isMuiElement.default;
    }
});

var $59efe6fc0694469e$var$_isMuiElement = $59efe6fc0694469e$require$_interopRequireDefault((parcelRequire("jn8tg")));

});
parcelRegister("jn8tg", function(module, exports) {
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $e1a6bc7b80aa687e$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e1a6bc7b80aa687e$var$isMuiElement;

var $e1a6bc7b80aa687e$var$React = $e1a6bc7b80aa687e$require$_interopRequireWildcard((parcelRequire("acw62")));
function $e1a6bc7b80aa687e$var$isMuiElement(element, muiNames) {
    return /*#__PURE__*/ $e1a6bc7b80aa687e$var$React.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/react/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("NIx3S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.generateSpacingClassNames = module.exports.generateSizeClassNames = module.exports.generateGridStyles = module.exports.generateGridSizeStyles = module.exports.generateGridRowSpacingStyles = module.exports.generateGridOffsetStyles = module.exports.generateGridDirectionStyles = module.exports.generateGridColumnsStyles = module.exports.generateGridColumnSpacingStyles = module.exports.generateDirectionClasses = void 0;

var $7OLH8 = parcelRequire("7OLH8");
function $09571ee53cc5e376$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $09571ee53cc5e376$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $09571ee53cc5e376$var$selfColumnsVar = '--Grid-columns';
const $09571ee53cc5e376$var$parentColumnsVar = '--Grid-parent-columns';
const $09571ee53cc5e376$var$generateGridSizeStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $7OLH8.traverseBreakpoints)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$09571ee53cc5e376$var$parentColumnsVar}) - (var(${$09571ee53cc5e376$var$parentColumnsVar}) - ${value}) * (var(${$09571ee53cc5e376$var$getParentSpacingVar('column')}) / var(${$09571ee53cc5e376$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridSizeStyles = $09571ee53cc5e376$var$generateGridSizeStyles;
const $09571ee53cc5e376$var$generateGridOffsetStyles = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $7OLH8.traverseBreakpoints)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$09571ee53cc5e376$var$parentColumnsVar}) + var(${$09571ee53cc5e376$var$getParentSpacingVar('column')}) * ${value} / var(${$09571ee53cc5e376$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
module.exports.generateGridOffsetStyles = $09571ee53cc5e376$var$generateGridOffsetStyles;
const $09571ee53cc5e376$var$generateGridColumnsStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$09571ee53cc5e376$var$selfColumnsVar]: 12
    };
    (0, $7OLH8.traverseBreakpoints)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$09571ee53cc5e376$var$selfColumnsVar]: columns,
            '> *': {
                [$09571ee53cc5e376$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnsStyles = $09571ee53cc5e376$var$generateGridColumnsStyles;
const $09571ee53cc5e376$var$generateGridRowSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $7OLH8.traverseBreakpoints)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$09571ee53cc5e376$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$09571ee53cc5e376$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridRowSpacingStyles = $09571ee53cc5e376$var$generateGridRowSpacingStyles;
const $09571ee53cc5e376$var$generateGridColumnSpacingStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $7OLH8.traverseBreakpoints)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$09571ee53cc5e376$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$09571ee53cc5e376$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
module.exports.generateGridColumnSpacingStyles = $09571ee53cc5e376$var$generateGridColumnSpacingStyles;
const $09571ee53cc5e376$var$generateGridDirectionStyles = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $7OLH8.traverseBreakpoints)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
module.exports.generateGridDirectionStyles = $09571ee53cc5e376$var$generateGridDirectionStyles;
const $09571ee53cc5e376$var$generateGridStyles = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$09571ee53cc5e376$var$getSelfSpacingVar('row')}) var(${$09571ee53cc5e376$var$getSelfSpacingVar('column')})`
        }
    };
};
module.exports.generateGridStyles = $09571ee53cc5e376$var$generateGridStyles;
const $09571ee53cc5e376$var$generateSizeClassNames = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
module.exports.generateSizeClassNames = $09571ee53cc5e376$var$generateSizeClassNames;
const $09571ee53cc5e376$var$generateSpacingClassNames = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
module.exports.generateSpacingClassNames = $09571ee53cc5e376$var$generateSpacingClassNames;
const $09571ee53cc5e376$var$generateDirectionClasses = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};
module.exports.generateDirectionClasses = $09571ee53cc5e376$var$generateDirectionClasses;

});
parcelRegister("7OLH8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.traverseBreakpoints = module.exports.filterBreakpointKeys = void 0;
const $5b123313703039e9$var$filterBreakpointKeys = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
module.exports.filterBreakpointKeys = $5b123313703039e9$var$filterBreakpointKeys;
const $5b123313703039e9$var$traverseBreakpoints = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $5b123313703039e9$var$filterBreakpointKeys(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};
module.exports.traverseBreakpoints = $5b123313703039e9$var$traverseBreakpoints;

});




parcelRegister("eaYrD", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $a520e2e9a3048984$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getGridUtilityClass = $a520e2e9a3048984$var$getGridUtilityClass;

var $a520e2e9a3048984$var$_generateUtilityClasses = $a520e2e9a3048984$require$_interopRequireDefault((parcelRequire("5lr9L")));

var $a520e2e9a3048984$var$_generateUtilityClass = $a520e2e9a3048984$require$_interopRequireDefault((parcelRequire("dUNRi")));
function $a520e2e9a3048984$var$getGridUtilityClass(slot) {
    return (0, $a520e2e9a3048984$var$_generateUtilityClass.default)('MuiGrid', slot);
}
const $a520e2e9a3048984$var$SPACINGS = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
];
const $a520e2e9a3048984$var$DIRECTIONS = [
    'column-reverse',
    'column',
    'row-reverse',
    'row'
];
const $a520e2e9a3048984$var$WRAPS = [
    'nowrap',
    'wrap-reverse',
    'wrap'
];
const $a520e2e9a3048984$var$GRID_SIZES = [
    'auto',
    'grow',
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
const $a520e2e9a3048984$var$gridClasses = (0, $a520e2e9a3048984$var$_generateUtilityClasses.default)('MuiGrid', [
    'root',
    'container',
    'item',
    // spacings
    ...$a520e2e9a3048984$var$SPACINGS.map((spacing)=>`spacing-xs-${spacing}`),
    // direction values
    ...$a520e2e9a3048984$var$DIRECTIONS.map((direction)=>`direction-xs-${direction}`),
    // wrap values
    ...$a520e2e9a3048984$var$WRAPS.map((wrap)=>`wrap-xs-${wrap}`),
    // grid sizes for all breakpoints
    ...$a520e2e9a3048984$var$GRID_SIZES.map((size)=>`grid-xs-${size}`),
    ...$a520e2e9a3048984$var$GRID_SIZES.map((size)=>`grid-sm-${size}`),
    ...$a520e2e9a3048984$var$GRID_SIZES.map((size)=>`grid-md-${size}`),
    ...$a520e2e9a3048984$var$GRID_SIZES.map((size)=>`grid-lg-${size}`),
    ...$a520e2e9a3048984$var$GRID_SIZES.map((size)=>`grid-xl-${size}`)
]);
var $a520e2e9a3048984$var$_default = module.exports.default = $a520e2e9a3048984$var$gridClasses;

});

parcelRegister("Q1Lzh", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $09c63a2ddd1dfd9b$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $09c63a2ddd1dfd9b$var$_propTypes = $09c63a2ddd1dfd9b$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $09c63a2ddd1dfd9b$var$_createStack = $09c63a2ddd1dfd9b$require$_interopRequireDefault((parcelRequire("lmfHQ")));
/**
 *
 * Demos:
 *
 * - [Stack (Material UI)](https://mui.com/material-ui/react-stack/)
 * - [Stack (MUI System)](https://mui.com/system/react-stack/)
 *
 * API:
 *
 * - [Stack API](https://mui.com/system/api/stack/)
 */ const $09c63a2ddd1dfd9b$var$Stack = (0, $09c63a2ddd1dfd9b$var$_createStack.default)();
var $09c63a2ddd1dfd9b$var$_default = module.exports.default = $09c63a2ddd1dfd9b$var$Stack;

});
parcelRegister("lmfHQ", function(module, exports) {
"use strict";
'use client';

var $5ULbo = parcelRequire("5ULbo");
var $f8c7d5fb8424c8e4$require$_interopRequireDefault = $5ULbo.default;

var $c5wSN = parcelRequire("c5wSN");
var $f8c7d5fb8424c8e4$require$_interopRequireWildcard = $c5wSN.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f8c7d5fb8424c8e4$var$createStack;
module.exports.style = void 0;

var $f8c7d5fb8424c8e4$var$React = $f8c7d5fb8424c8e4$require$_interopRequireWildcard((parcelRequire("acw62")));

var $f8c7d5fb8424c8e4$var$_propTypes = $f8c7d5fb8424c8e4$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $f8c7d5fb8424c8e4$var$_clsx = $f8c7d5fb8424c8e4$require$_interopRequireDefault((parcelRequire("bbzhi")));

var $f8c7d5fb8424c8e4$var$_deepmerge = $f8c7d5fb8424c8e4$require$_interopRequireDefault((parcelRequire("5nq0S")));

var $f8c7d5fb8424c8e4$var$_generateUtilityClass = $f8c7d5fb8424c8e4$require$_interopRequireDefault((parcelRequire("dUNRi")));

var $f8c7d5fb8424c8e4$var$_composeClasses = $f8c7d5fb8424c8e4$require$_interopRequireDefault((parcelRequire("eXUB7")));

var $f8c7d5fb8424c8e4$var$_styled = $f8c7d5fb8424c8e4$require$_interopRequireDefault((parcelRequire("38jtr")));

var $f8c7d5fb8424c8e4$var$_useThemeProps = $f8c7d5fb8424c8e4$require$_interopRequireDefault((parcelRequire("6rcYV")));

var $f8c7d5fb8424c8e4$var$_createTheme = $f8c7d5fb8424c8e4$require$_interopRequireDefault((parcelRequire("bFSYU")));

var $3dqBt = parcelRequire("3dqBt");

var $7GqeV = parcelRequire("7GqeV");

var $ayMG0 = parcelRequire("ayMG0");
const $f8c7d5fb8424c8e4$var$defaultTheme = (0, $f8c7d5fb8424c8e4$var$_createTheme.default)();
// widening Theme to any so that the consumer can own the theme structure.
const $f8c7d5fb8424c8e4$var$defaultCreateStyledComponent = (0, $f8c7d5fb8424c8e4$var$_styled.default)('div', {
    name: 'MuiStack',
    slot: 'Root'
});
function $f8c7d5fb8424c8e4$var$useThemePropsDefault(props) {
    return (0, $f8c7d5fb8424c8e4$var$_useThemeProps.default)({
        props: props,
        name: 'MuiStack',
        defaultTheme: $f8c7d5fb8424c8e4$var$defaultTheme
    });
}
/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */ function $f8c7d5fb8424c8e4$var$joinChildren(children, separator) {
    const childrenArray = $f8c7d5fb8424c8e4$var$React.Children.toArray(children).filter(Boolean);
    return childrenArray.reduce((output, child, index)=>{
        output.push(child);
        if (index < childrenArray.length - 1) output.push(/*#__PURE__*/ $f8c7d5fb8424c8e4$var$React.cloneElement(separator, {
            key: `separator-${index}`
        }));
        return output;
    }, []);
}
const $f8c7d5fb8424c8e4$var$getSideFromDirection = (direction)=>{
    return ({
        row: 'Left',
        'row-reverse': 'Right',
        column: 'Top',
        'column-reverse': 'Bottom'
    })[direction];
};
const $f8c7d5fb8424c8e4$var$style = ({ ownerState: ownerState, theme: theme })=>{
    let styles = {
        display: 'flex',
        flexDirection: 'column',
        ...(0, $3dqBt.handleBreakpoints)({
            theme: theme
        }, (0, $3dqBt.resolveBreakpointValues)({
            values: ownerState.direction,
            breakpoints: theme.breakpoints.values
        }), (propValue)=>({
                flexDirection: propValue
            }))
    };
    if (ownerState.spacing) {
        const transformer = (0, $7GqeV.createUnarySpacing)(theme);
        const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint)=>{
            if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) acc[breakpoint] = true;
            return acc;
        }, {});
        const directionValues = (0, $3dqBt.resolveBreakpointValues)({
            values: ownerState.direction,
            base: base
        });
        const spacingValues = (0, $3dqBt.resolveBreakpointValues)({
            values: ownerState.spacing,
            base: base
        });
        if (typeof directionValues === 'object') Object.keys(directionValues).forEach((breakpoint, index, breakpoints)=>{
            const directionValue = directionValues[breakpoint];
            if (!directionValue) {
                const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
                directionValues[breakpoint] = previousDirectionValue;
            }
        });
        const styleFromPropValue = (propValue, breakpoint)=>{
            if (ownerState.useFlexGap) return {
                gap: (0, $7GqeV.getValue)(transformer, propValue)
            };
            return {
                // The useFlexGap={false} implement relies on each child to give up control of the margin.
                // We need to reset the margin to avoid double spacing.
                '& > :not(style):not(style)': {
                    margin: 0
                },
                '& > :not(style) ~ :not(style)': {
                    [`margin${$f8c7d5fb8424c8e4$var$getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0, $7GqeV.getValue)(transformer, propValue)
                }
            };
        };
        styles = (0, $f8c7d5fb8424c8e4$var$_deepmerge.default)(styles, (0, $3dqBt.handleBreakpoints)({
            theme: theme
        }, spacingValues, styleFromPropValue));
    }
    styles = (0, $3dqBt.mergeBreakpointsInOrder)(theme.breakpoints, styles);
    return styles;
};
module.exports.style = $f8c7d5fb8424c8e4$var$style;
function $f8c7d5fb8424c8e4$var$createStack(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $f8c7d5fb8424c8e4$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $f8c7d5fb8424c8e4$var$useThemePropsDefault, componentName: componentName = 'MuiStack' } = options;
    const useUtilityClasses = ()=>{
        const slots = {
            root: [
                'root'
            ]
        };
        return (0, $f8c7d5fb8424c8e4$var$_composeClasses.default)(slots, (slot)=>(0, $f8c7d5fb8424c8e4$var$_generateUtilityClass.default)(componentName, slot), {});
    };
    const StackRoot = createStyledComponent($f8c7d5fb8424c8e4$var$style);
    const Stack = /*#__PURE__*/ $f8c7d5fb8424c8e4$var$React.forwardRef(function Grid(inProps, ref) {
        const themeProps = useThemeProps(inProps);
        const { component: component = 'div', direction: direction = 'column', spacing: spacing = 0, divider: divider, children: children, className: className, useFlexGap: useFlexGap = false, ...other } = themeProps;
        const ownerState = {
            direction: direction,
            spacing: spacing,
            useFlexGap: useFlexGap
        };
        const classes = useUtilityClasses();
        return /*#__PURE__*/ (0, $ayMG0.jsx)(StackRoot, {
            as: component,
            ownerState: ownerState,
            ref: ref,
            className: (0, $f8c7d5fb8424c8e4$var$_clsx.default)(classes.root, className),
            ...other,
            children: divider ? $f8c7d5fb8424c8e4$var$joinChildren(children, divider) : children
        });
    });
    return Stack;
}

});


parcelRegister("7hUw4", function(module, exports) {
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $54e5f5e1b4bd9120$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.getStackUtilityClass = $54e5f5e1b4bd9120$var$getStackUtilityClass;

var $54e5f5e1b4bd9120$var$_generateUtilityClasses = $54e5f5e1b4bd9120$require$_interopRequireDefault((parcelRequire("5lr9L")));

var $54e5f5e1b4bd9120$var$_generateUtilityClass = $54e5f5e1b4bd9120$require$_interopRequireDefault((parcelRequire("dUNRi")));
function $54e5f5e1b4bd9120$var$getStackUtilityClass(slot) {
    return (0, $54e5f5e1b4bd9120$var$_generateUtilityClass.default)('MuiStack', slot);
}
const $54e5f5e1b4bd9120$var$stackClasses = (0, $54e5f5e1b4bd9120$var$_generateUtilityClasses.default)('MuiStack', [
    'root'
]);
var $54e5f5e1b4bd9120$var$_default = module.exports.default = $54e5f5e1b4bd9120$var$stackClasses;

});

parcelRegister("gODrq", function(module, exports) {
"use strict";
'use client';

var $1jnue = parcelRequire("1jnue");
var $c3dfe91526ac04a1$require$_interopRequireDefault = $1jnue.default;

var $3pEGv = parcelRequire("3pEGv");
var $c3dfe91526ac04a1$require$_interopRequireWildcard = $3pEGv.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.styles = module.exports.html = module.exports.default = module.exports.body = void 0;

var $c3dfe91526ac04a1$var$React = $c3dfe91526ac04a1$require$_interopRequireWildcard((parcelRequire("acw62")));

var $c3dfe91526ac04a1$var$_propTypes = $c3dfe91526ac04a1$require$_interopRequireDefault((parcelRequire("c9Z8w")));

var $aAbgT = parcelRequire("aAbgT");

var $hL1nr = parcelRequire("hL1nr");

var $ayMG0 = parcelRequire("ayMG0");
// to determine if the global styles are static or dynamic
const $c3dfe91526ac04a1$var$isDynamicSupport = typeof (0, $aAbgT.globalCss)({}) === 'function';
const $c3dfe91526ac04a1$var$html = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
module.exports.html = $c3dfe91526ac04a1$var$html;
const $c3dfe91526ac04a1$var$body = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
module.exports.body = $c3dfe91526ac04a1$var$body;
const $c3dfe91526ac04a1$var$styles = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $c3dfe91526ac04a1$var$html(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$c3dfe91526ac04a1$var$body(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
module.exports.styles = $c3dfe91526ac04a1$var$styles;
const $c3dfe91526ac04a1$var$SELECTOR = 'mui-ecs';
const $c3dfe91526ac04a1$var$staticStyles = (theme)=>{
    const result = $c3dfe91526ac04a1$var$styles(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$c3dfe91526ac04a1$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$c3dfe91526ac04a1$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $c3dfe91526ac04a1$var$GlobalStyles = (0, $aAbgT.globalCss)($c3dfe91526ac04a1$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$c3dfe91526ac04a1$var$styles(theme, enableColorScheme) : ({ theme: theme })=>$c3dfe91526ac04a1$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $c3dfe91526ac04a1$var$CssBaseline(inProps) {
    const props = (0, $hL1nr.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c3dfe91526ac04a1$var$React.Fragment, {
        children: [
            $c3dfe91526ac04a1$var$isDynamicSupport && /*#__PURE__*/ (0, $ayMG0.jsx)($c3dfe91526ac04a1$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$c3dfe91526ac04a1$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: $c3dfe91526ac04a1$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $c3dfe91526ac04a1$var$_default = module.exports.default = $c3dfe91526ac04a1$var$CssBaseline;

});


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));



var $acw62 = parcelRequire("acw62");
//#region packages/fast-memoize/index.ts
function $7bac09121bc9431c$export$fc10aeed3a532e2a(fn, options) {
    const cache = options && options.cache ? options.cache : $7bac09121bc9431c$var$cacheDefault;
    const serializer = options && options.serializer ? options.serializer : $7bac09121bc9431c$var$serializerDefault;
    return (options && options.strategy ? options.strategy : $7bac09121bc9431c$var$strategyDefault)(fn, {
        cache: cache,
        serializer: serializer
    });
}
function $7bac09121bc9431c$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean";
}
function $7bac09121bc9431c$var$monadic(fn, cache, serializer, arg) {
    const cacheKey = $7bac09121bc9431c$var$isPrimitive(arg) ? arg : serializer(arg);
    let computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7bac09121bc9431c$var$variadic(fn, cache, serializer) {
    const args = Array.prototype.slice.call(arguments, 3);
    const cacheKey = serializer(args);
    let computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $7bac09121bc9431c$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $7bac09121bc9431c$var$strategyDefault(fn, options) {
    const strategy = fn.length === 1 ? $7bac09121bc9431c$var$monadic : $7bac09121bc9431c$var$variadic;
    return $7bac09121bc9431c$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $7bac09121bc9431c$var$strategyVariadic(fn, options) {
    return $7bac09121bc9431c$var$assemble(fn, this, $7bac09121bc9431c$var$variadic, options.cache.create(), options.serializer);
}
function $7bac09121bc9431c$var$strategyMonadic(fn, options) {
    return $7bac09121bc9431c$var$assemble(fn, this, $7bac09121bc9431c$var$monadic, options.cache.create(), options.serializer);
}
const $7bac09121bc9431c$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
var $7bac09121bc9431c$var$ObjectWithoutPrototypeCache = class {
    constructor(){
        this.cache = Object.create(null);
    }
    get(key) {
        return this.cache[key];
    }
    set(key, value) {
        this.cache[key] = value;
    }
};
const $7bac09121bc9431c$var$cacheDefault = {
    create: function create() {
        return new $7bac09121bc9431c$var$ObjectWithoutPrototypeCache();
    }
};
const $7bac09121bc9431c$export$c5491a8691a23b9e = {
    variadic: $7bac09121bc9431c$var$strategyVariadic,
    monadic: $7bac09121bc9431c$var$strategyMonadic
};



//#region packages/icu-skeleton-parser/date-time.ts
/**
* https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
* Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
* with some tweaks
*/ const $d4d3fc9f6275a50a$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
* Parse Date time skeleton into Intl.DateTimeFormatOptions
* Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
* @public
* @param skeleton skeleton string
*/ function $d4d3fc9f6275a50a$export$f7b99fb377fe69fa(skeleton) {
    const result = {};
    skeleton.replace($d4d3fc9f6275a50a$var$DATE_TIME_REGEX, (match)=>{
        const len = match.length;
        switch(match[0]){
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 3];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 3];
                break;
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}
//#endregion
//#region node_modules/.aspect_rules_js/@formatjs_generated+unicode@0.0.0/node_modules/@formatjs_generated/unicode/icu-skeleton-parser-regex.js
const $d4d3fc9f6275a50a$var$WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;
//#endregion
//#region packages/icu-skeleton-parser/number.ts
function $d4d3fc9f6275a50a$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    const stringTokens = skeleton.split($d4d3fc9f6275a50a$var$WHITE_SPACE_REGEX).filter((x)=>x.length > 0);
    const tokens = [];
    for (const stringToken of stringTokens){
        let stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        const [stem, ...options] = stemAndOptions;
        for (const option of options)if (option.length === 0) throw new Error("Invalid number skeleton");
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $d4d3fc9f6275a50a$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
const $d4d3fc9f6275a50a$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
const $d4d3fc9f6275a50a$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
const $d4d3fc9f6275a50a$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
const $d4d3fc9f6275a50a$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $d4d3fc9f6275a50a$var$parseSignificantPrecision(str) {
    const result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($d4d3fc9f6275a50a$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $d4d3fc9f6275a50a$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $d4d3fc9f6275a50a$var$parseConciseScientificAndEngineeringStem(stem) {
    let result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        const signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$d4d3fc9f6275a50a$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $d4d3fc9f6275a50a$var$parseNotationOptions(opt) {
    const result = {};
    const signOpts = $d4d3fc9f6275a50a$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
/**
* https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
*/ function $d4d3fc9f6275a50a$export$47c6f8480bda3e11(tokens) {
    let result = {};
    for (const token of tokens){
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $d4d3fc9f6275a50a$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = {
                    ...result,
                    notation: "scientific",
                    ...token.options.reduce((all, opt)=>({
                            ...all,
                            ...$d4d3fc9f6275a50a$var$parseNotationOptions(opt)
                        }), {})
                };
                continue;
            case "engineering":
                result = {
                    ...result,
                    notation: "engineering",
                    ...token.options.reduce((all, opt)=>({
                            ...all,
                            ...$d4d3fc9f6275a50a$var$parseNotationOptions(opt)
                        }), {})
                };
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($d4d3fc9f6275a50a$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        if ($d4d3fc9f6275a50a$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($d4d3fc9f6275a50a$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($d4d3fc9f6275a50a$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            const opt = token.options[0];
            if (opt === "w") result = {
                ...result,
                trailingZeroDisplay: "stripIfInteger"
            };
            else if (opt) result = {
                ...result,
                ...$d4d3fc9f6275a50a$var$parseSignificantPrecision(opt)
            };
            continue;
        }
        if ($d4d3fc9f6275a50a$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = {
                ...result,
                ...$d4d3fc9f6275a50a$var$parseSignificantPrecision(token.stem)
            };
            continue;
        }
        const signOpts = $d4d3fc9f6275a50a$var$parseSign(token.stem);
        if (signOpts) result = {
            ...result,
            ...signOpts
        };
        const conciseScientificAndEngineeringOpts = $d4d3fc9f6275a50a$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = {
            ...result,
            ...conciseScientificAndEngineeringOpts
        };
    }
    return result;
}


//#region packages/icu-messageformat-parser/error.ts
let $2dc2f66d316cd8db$var$ErrorKind = /* @__PURE__ */ function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
	* Expecting a message fragment after the `plural` or `selectordinal` selector
	* (e.g. `{foo, plural, one}`)
	*/ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
	* Duplicate selectors in `plural` or `selectordinal` argument.
	* (e.g. {foo, plural, one {#} one {#}})
	*/ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
	* (e.g. {foo, select, apple {apple} apple {apple}})
	*/ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
    return ErrorKind;
}({});
//#endregion
//#region packages/icu-messageformat-parser/types.ts
let $2dc2f66d316cd8db$export$b87f371cbc396fcf = /* @__PURE__ */ function(TYPE) {
    /**
	* Raw text
	*/ TYPE[TYPE["literal"] = 0] = "literal";
    /**
	* Variable w/o any format, e.g `var` in `this is a {var}`
	*/ TYPE[TYPE["argument"] = 1] = "argument";
    /**
	* Variable w/ number format
	*/ TYPE[TYPE["number"] = 2] = "number";
    /**
	* Variable w/ date format
	*/ TYPE[TYPE["date"] = 3] = "date";
    /**
	* Variable w/ time format
	*/ TYPE[TYPE["time"] = 4] = "time";
    /**
	* Variable w/ select format
	*/ TYPE[TYPE["select"] = 5] = "select";
    /**
	* Variable w/ plural format
	*/ TYPE[TYPE["plural"] = 6] = "plural";
    /**
	* Only possible within plural argument.
	* This is the `#` symbol that will be substituted with the count.
	*/ TYPE[TYPE["pound"] = 7] = "pound";
    /**
	* XML-like tag
	*/ TYPE[TYPE["tag"] = 8] = "tag";
    return TYPE;
}({});
let $2dc2f66d316cd8db$export$906452485466fa53 = /* @__PURE__ */ function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
    return SKELETON_TYPE;
}({});
/**
* Type Guards
*/ function $2dc2f66d316cd8db$export$cfa10c5697238752(el) {
    return el.type === 0;
}
function $2dc2f66d316cd8db$export$4f55724281bdfaf9(el) {
    return el.type === 1;
}
function $2dc2f66d316cd8db$export$e11187b219e191e1(el) {
    return el.type === 2;
}
function $2dc2f66d316cd8db$export$32d811605da75f40(el) {
    return el.type === 3;
}
function $2dc2f66d316cd8db$export$34ec46f596b1702f(el) {
    return el.type === 4;
}
function $2dc2f66d316cd8db$export$dcfe1c11d168b5a1(el) {
    return el.type === 5;
}
function $2dc2f66d316cd8db$export$6c796d116f0a4fbc(el) {
    return el.type === 6;
}
function $2dc2f66d316cd8db$export$c0ece297bdd0c082(el) {
    return el.type === 7;
}
function $2dc2f66d316cd8db$export$5c83de34745812b(el) {
    return el.type === 8;
}
function $2dc2f66d316cd8db$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === 0);
}
function $2dc2f66d316cd8db$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === 1);
}
function $2dc2f66d316cd8db$export$f0ac572c1121c662(value) {
    return {
        type: 0,
        value: value
    };
}
function $2dc2f66d316cd8db$export$425e864b0ba114f1(value, style) {
    return {
        type: 2,
        value: value,
        style: style
    };
}
//#endregion
//#region node_modules/.aspect_rules_js/@formatjs_generated+unicode@0.0.0/node_modules/@formatjs_generated/unicode/icu-messageformat-parser-regex.js
const $2dc2f66d316cd8db$var$SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
const $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_REGEX = /([^\t-\r -\/:-@\[-\^`\{-~\x85\xA0-\xA7\xA9\xAB\xAC\xAE\xB0\xB1\xB6\xBB\xBF\xD7\xF7\u1680\u2000-\u200A\u2010-\u2029\u202F-\u203E\u2041-\u2053\u2055-\u205F\u2190-\u245F\u2500-\u2775\u2794-\u2BFF\u2E00-\u2E7F\u3000-\u3003\u3008-\u3020\u3030\uFD3E\uFD3F\uFE45\uFE46]*)/g;
//#endregion
//#region node_modules/.aspect_rules_js/@formatjs_generated+cldr.core@0.0.0/node_modules/@formatjs_generated/cldr.core/time-data.js
const $2dc2f66d316cd8db$var$timeData = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ku-SY": [
        "H",
        "hB"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};
//#endregion
//#region packages/icu-messageformat-parser/date-time-pattern-generator.ts
/**
* Returns the best matching date time pattern if a date time skeleton
* pattern is provided with a locale. Follows the Unicode specification:
* https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
* @param skeleton date time skeleton pattern that possibly includes j, J or C
* @param locale
*/ function $2dc2f66d316cd8db$var$getBestPattern(skeleton, locale) {
    let skeletonCopy = "";
    for(let patternPos = 0; patternPos < skeleton.length; patternPos++){
        const patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            let extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            let hourLen = 1 + (extraLength & 1);
            let dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            let dayPeriodChar = "a";
            let hourChar = $2dc2f66d316cd8db$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
* Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
* of the given `locale` to the corresponding time pattern.
* @param locale
*/ function $2dc2f66d316cd8db$var$getDefaultHourSymbolFromLocale(locale) {
    let hourCycle = locale.hourCycle;
    if (hourCycle === void 0) {
        const localeWithHourCycles = locale;
        hourCycle = localeWithHourCycles.getHourCycles?.()[0] ?? localeWithHourCycles.hourCycles?.[0];
    }
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    const languageTag = locale.language;
    let regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    return ($2dc2f66d316cd8db$var$timeData[`${languageTag}-${regionTag}`] || $2dc2f66d316cd8db$var$timeData[regionTag || ""] || $2dc2f66d316cd8db$var$timeData[languageTag || ""] || $2dc2f66d316cd8db$var$timeData[`${languageTag}-001`] || $2dc2f66d316cd8db$var$timeData["001"])[0].charAt(0);
}
//#endregion
//#region packages/icu-messageformat-parser/parser.ts
const $2dc2f66d316cd8db$var$SPACE_SEPARATOR_START_REGEX = new RegExp(`^${$2dc2f66d316cd8db$var$SPACE_SEPARATOR_REGEX.source}*`);
const $2dc2f66d316cd8db$var$SPACE_SEPARATOR_END_REGEX = new RegExp(`${$2dc2f66d316cd8db$var$SPACE_SEPARATOR_REGEX.source}*$`);
function $2dc2f66d316cd8db$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
const $2dc2f66d316cd8db$var$hasNativeFromEntries = !!Object.fromEntries;
const $2dc2f66d316cd8db$var$hasTrimStart = !!String.prototype.trimStart;
const $2dc2f66d316cd8db$var$hasTrimEnd = !!String.prototype.trimEnd;
const $2dc2f66d316cd8db$var$fromEntries = $2dc2f66d316cd8db$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    const obj = {};
    for (const [k, v] of entries)obj[k] = v;
    return obj;
};
const $2dc2f66d316cd8db$var$trimStart = $2dc2f66d316cd8db$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($2dc2f66d316cd8db$var$SPACE_SEPARATOR_START_REGEX, "");
};
const $2dc2f66d316cd8db$var$trimEnd = $2dc2f66d316cd8db$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($2dc2f66d316cd8db$var$SPACE_SEPARATOR_END_REGEX, "");
};
let $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_RE = $2dc2f66d316cd8db$var$createIdentifierPrefixRegex();
function $2dc2f66d316cd8db$var$createIdentifierPrefixRegex() {
    try {
        const regex = new RegExp("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
        if (regex.exec("a ")?.[1] === "a") return regex;
    } catch  {}
    return $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_REGEX;
}
function $2dc2f66d316cd8db$var$matchIdentifierAtIndex(s, index) {
    $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_RE.lastIndex = index;
    return $2dc2f66d316cd8db$var$IDENTIFIER_PREFIX_RE.exec(s)[1] ?? "";
}
function $2dc2f66d316cd8db$var$plainTopLevelEndPosition(message) {
    if (message.length === 0) return null;
    let line = 1;
    let column = 1;
    for(let offset = 0; offset < message.length;){
        const code = message.charCodeAt(offset);
        switch(code){
            case 35:
            case 39:
            case 60:
            case 123:
            case 125:
                return null;
        }
        if (code === 10) {
            line++;
            column = 1;
            offset++;
        } else {
            column++;
            if (code >= 55296 && code <= 56319 && offset + 1 < message.length) {
                const next = message.charCodeAt(offset + 1);
                offset += next >= 56320 && next <= 57343 ? 2 : 1;
            } else offset++;
        }
    }
    return {
        offset: message.length,
        line: line,
        column: column
    };
}
var $2dc2f66d316cd8db$var$Parser = class {
    constructor(message, options = {}){
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    parse() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        if (this.message.length > 0) {
            const firstCode = this.message.charCodeAt(0);
            if (firstCode !== 35 && firstCode !== 39 && firstCode !== 60 && firstCode !== 123 && firstCode !== 125) {
                const plainEndPosition = $2dc2f66d316cd8db$var$plainTopLevelEndPosition(this.message);
                if (plainEndPosition) {
                    const start = this.clonePosition();
                    this.position = plainEndPosition;
                    return {
                        val: [
                            {
                                type: 0,
                                value: this.message,
                                location: $2dc2f66d316cd8db$var$createLocation(start, this.clonePosition())
                            }
                        ],
                        err: null
                    };
                }
            }
        }
        return this.parseMessage(0, "", false);
    }
    parseMessage(nestingLevel, parentArgType, expectingCloseTag) {
        let elements = [];
        while(!this.isEOF()){
            const char = this.char();
            if (char === 123) {
                const result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 && nestingLevel > 0) break;
            else if (char === 35 && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                const position = this.clonePosition();
                this.bump();
                elements.push({
                    type: 7,
                    location: $2dc2f66d316cd8db$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 && !this.ignoreTag && this.peek() === 47) {
                if (expectingCloseTag) break;
                else return this.error(26, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 && !this.ignoreTag && $2dc2f66d316cd8db$var$_isAlpha(this.peek() || 0)) {
                const result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                const result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    }
    /**
	* A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
	* [custom element name][] except that a dash is NOT always mandatory and uppercase letters
	* are accepted:
	*
	* ```
	* tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
	* tagName ::= [a-z] (PENChar)*
	* PENChar ::=
	*     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
	*     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
	*     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
	* ```
	*
	* [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
	* NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
	* since other tag-based engines like React allow it
	*/ parseTag(nestingLevel, parentArgType) {
        const startPosition = this.clonePosition();
        this.bump();
        const tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) return {
            val: {
                type: 0,
                value: `<${tagName}/>`,
                location: $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            const childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            const children = childrenResult.val;
            const endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$2dc2f66d316cd8db$var$_isAlpha(this.char())) return this.error(23, $2dc2f66d316cd8db$var$createLocation(endTagStartPosition, this.clonePosition()));
                const closingTagNameStartPosition = this.clonePosition();
                if (tagName !== this.parseTagName()) return this.error(26, $2dc2f66d316cd8db$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error(23, $2dc2f66d316cd8db$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: 8,
                        value: tagName,
                        children: children,
                        location: $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error(27, $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error(23, $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition()));
    }
    /**
	* This method assumes that the caller has peeked ahead for the first tag character.
	*/ parseTagName() {
        const startOffset = this.offset();
        this.bump();
        while(!this.isEOF() && $2dc2f66d316cd8db$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    }
    parseLiteral(nestingLevel, parentArgType) {
        const start = this.clonePosition();
        let value = "";
        while(true){
            const parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            const parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            const parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        const location = $2dc2f66d316cd8db$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: 0,
                value: value,
                location: location
            },
            err: null
        };
    }
    tryParseLeftAngleBracket() {
        if (!this.isEOF() && this.char() === 60 && (this.ignoreTag || !$2dc2f66d316cd8db$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump();
            return "<";
        }
        return null;
    }
    /**
	* Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
	* a character that requires quoting (that is, "only where needed"), and works the same in
	* nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
	*/ tryParseQuote(parentArgType) {
        if (this.isEOF() || this.char() !== 39) return null;
        switch(this.peek()){
            case 39:
                this.bump();
                this.bump();
                return "'";
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump();
        const codePoints = [
            this.char()
        ];
        this.bump();
        while(!this.isEOF()){
            const ch = this.char();
            if (ch === 39) {
                if (this.peek() === 39) {
                    codePoints.push(39);
                    this.bump();
                } else {
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return String.fromCodePoint(...codePoints);
    }
    tryParseUnquoted(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        const ch = this.char();
        if (ch === 60 || ch === 123 || ch === 35 && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 && nestingLevel > 0) return null;
        else {
            this.bump();
            return String.fromCodePoint(ch);
        }
    }
    parseArgument(nestingLevel, expectingCloseTag) {
        const openingBracePosition = this.clonePosition();
        this.bump();
        this.bumpSpace();
        if (this.isEOF()) return this.error(1, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125) {
            this.bump();
            return this.error(2, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        let value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error(3, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error(1, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            case 125:
                this.bump();
                return {
                    val: {
                        type: 1,
                        value: value,
                        location: $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            case 44:
                this.bump();
                this.bumpSpace();
                if (this.isEOF()) return this.error(1, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error(3, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    }
    /**
	* Advance the parser until the end of the identifier, if it is currently on
	* an identifier character. Return an empty string otherwise.
	*/ parseIdentifierIfPossible() {
        const startingPosition = this.clonePosition();
        const startOffset = this.offset();
        const value = $2dc2f66d316cd8db$var$matchIdentifierAtIndex(this.message, startOffset);
        const endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        return {
            value: value,
            location: $2dc2f66d316cd8db$var$createLocation(startingPosition, this.clonePosition())
        };
    }
    parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        let typeStartPosition = this.clonePosition();
        let argType = this.parseIdentifierIfPossible().value;
        let typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                return this.error(4, $2dc2f66d316cd8db$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                {
                    this.bumpSpace();
                    let styleAndLocation = null;
                    if (this.bumpIf(",")) {
                        this.bumpSpace();
                        const styleStartPosition = this.clonePosition();
                        const result = this.parseSimpleArgStyleIfPossible();
                        if (result.err) return result;
                        const style = $2dc2f66d316cd8db$var$trimEnd(result.val);
                        if (style.length === 0) return this.error(6, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
                        styleAndLocation = {
                            style: style,
                            styleLocation: $2dc2f66d316cd8db$var$createLocation(styleStartPosition, this.clonePosition())
                        };
                    }
                    const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                    if (argCloseResult.err) return argCloseResult;
                    const location = $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition());
                    if (styleAndLocation && styleAndLocation.style.startsWith("::")) {
                        let skeleton = $2dc2f66d316cd8db$var$trimStart(styleAndLocation.style.slice(2));
                        if (argType === "number") {
                            const result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                            if (result.err) return result;
                            return {
                                val: {
                                    type: 2,
                                    value: value,
                                    location: location,
                                    style: result.val
                                },
                                err: null
                            };
                        } else {
                            if (skeleton.length === 0) return this.error(10, location);
                            let dateTimePattern = skeleton;
                            if (this.locale) dateTimePattern = $2dc2f66d316cd8db$var$getBestPattern(skeleton, this.locale);
                            const style = {
                                type: 1,
                                pattern: dateTimePattern,
                                location: styleAndLocation.styleLocation,
                                parsedOptions: this.shouldParseSkeletons ? (0, $d4d3fc9f6275a50a$export$f7b99fb377fe69fa)(dateTimePattern) : {}
                            };
                            return {
                                val: {
                                    type: argType === "date" ? 3 : 4,
                                    value: value,
                                    location: location,
                                    style: style
                                },
                                err: null
                            };
                        }
                    }
                    return {
                        val: {
                            type: argType === "number" ? 2 : argType === "date" ? 3 : 4,
                            value: value,
                            location: location,
                            style: styleAndLocation?.style ?? null
                        },
                        err: null
                    };
                }
            case "plural":
            case "selectordinal":
            case "select":
                {
                    const typeEndPosition = this.clonePosition();
                    this.bumpSpace();
                    if (!this.bumpIf(",")) return this.error(12, $2dc2f66d316cd8db$var$createLocation(typeEndPosition, {
                        ...typeEndPosition
                    }));
                    this.bumpSpace();
                    let identifierAndLocation = this.parseIdentifierIfPossible();
                    let pluralOffset = 0;
                    if (argType !== "select" && identifierAndLocation.value === "offset") {
                        if (!this.bumpIf(":")) return this.error(13, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
                        this.bumpSpace();
                        const result = this.tryParseDecimalInteger(13, 14);
                        if (result.err) return result;
                        this.bumpSpace();
                        identifierAndLocation = this.parseIdentifierIfPossible();
                        pluralOffset = result.val;
                    }
                    const optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                    if (optionsResult.err) return optionsResult;
                    const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                    if (argCloseResult.err) return argCloseResult;
                    const location = $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition());
                    if (argType === "select") return {
                        val: {
                            type: 5,
                            value: value,
                            options: $2dc2f66d316cd8db$var$fromEntries(optionsResult.val),
                            location: location
                        },
                        err: null
                    };
                    else return {
                        val: {
                            type: 6,
                            value: value,
                            options: $2dc2f66d316cd8db$var$fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === "plural" ? "cardinal" : "ordinal",
                            location: location
                        },
                        err: null
                    };
                }
            default:
                return this.error(5, $2dc2f66d316cd8db$var$createLocation(typeStartPosition, typeEndPosition));
        }
    }
    tryParseArgumentClose(openingBracePosition) {
        if (this.isEOF() || this.char() !== 125) return this.error(1, $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump();
        return {
            val: true,
            err: null
        };
    }
    /**
	* See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
	*/ parseSimpleArgStyleIfPossible() {
        let nestedBraces = 0;
        const startPosition = this.clonePosition();
        while(!this.isEOF())switch(this.char()){
            case 39:
                {
                    this.bump();
                    let apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error(11, $2dc2f66d316cd8db$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                }
            case 123:
                nestedBraces += 1;
                this.bump();
                break;
            case 125:
                if (nestedBraces > 0) nestedBraces -= 1;
                else return {
                    val: this.message.slice(startPosition.offset, this.offset()),
                    err: null
                };
                break;
            default:
                this.bump();
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    }
    parseNumberSkeletonFromString(skeleton, location) {
        let tokens = [];
        try {
            tokens = (0, $d4d3fc9f6275a50a$export$71cee2f16fba2480)(skeleton);
        } catch  {
            return this.error(7, location);
        }
        return {
            val: {
                type: 0,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $d4d3fc9f6275a50a$export$47c6f8480bda3e11)(tokens) : {}
            },
            err: null
        };
    }
    /**
	* @param nesting_level The current nesting level of messages.
	*     This can be positive when parsing message fragment in select or plural argument options.
	* @param parent_arg_type The parent argument's type.
	* @param parsed_first_identifier If provided, this is the first identifier-like selector of
	*     the argument. It is a by-product of a previous parsing attempt.
	* @param expecting_close_tag If true, this message is directly or indirectly nested inside
	*     between a pair of opening and closing tags. The nested message will not parse beyond
	*     the closing tag boundary.
	*/ tryParsePluralOrSelectOptions(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        let hasOtherClause = false;
        const options = [];
        const parsedSelectors = /* @__PURE__ */ new Set();
        let { value: selector, location: selectorLocation } = parsedFirstIdentifier;
        while(true){
            if (selector.length === 0) {
                const startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    const result = this.tryParseDecimalInteger(16, 19);
                    if (result.err) return result;
                    selectorLocation = $2dc2f66d316cd8db$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? 21 : 20, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            this.bumpSpace();
            const openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? 17 : 18, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
            const fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            const argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $2dc2f66d316cd8db$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            parsedSelectors.add(selector);
            this.bumpSpace();
            ({ value: selector, location: selectorLocation } = this.parseIdentifierIfPossible());
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? 15 : 16, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error(22, $2dc2f66d316cd8db$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    }
    tryParseDecimalInteger(expectNumberError, invalidNumberError) {
        let sign = 1;
        const startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        let hasDigits = false;
        let decimal = 0;
        while(!this.isEOF()){
            const ch = this.char();
            if (ch >= 48 && ch <= 57) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        const location = $2dc2f66d316cd8db$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!Number.isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    }
    offset() {
        return this.position.offset;
    }
    isEOF() {
        return this.offset() === this.message.length;
    }
    clonePosition() {
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    }
    /**
	* Return the code point at the current position of the parser.
	* Throws if the index is out of bound.
	*/ char() {
        const offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        const code = this.message.codePointAt(offset);
        if (code === void 0) throw Error(`Offset ${offset} is at invalid UTF-16 code unit boundary`);
        return code;
    }
    error(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    }
    /** Bump the parser to the next UTF-16 code unit. */ bump() {
        if (this.isEOF()) return;
        const code = this.char();
        if (code === 10) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            this.position.offset += code < 65536 ? 1 : 2;
        }
    }
    /**
	* If the substring starting at the current position of the parser has
	* the given prefix, then bump the parser to the character immediately
	* following the prefix and return true. Otherwise, don't bump the parser
	* and return false.
	*/ bumpIf(prefix) {
        const offset = this.offset();
        if (this.message.slice(offset, offset + prefix.length) === prefix) {
            for(let i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    }
    /**
	* Bump the parser until the pattern character is found and return `true`.
	* Otherwise bump to the end of the file and return `false`.
	*/ bumpUntil(pattern) {
        const currentOffset = this.offset();
        const index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    }
    /**
	* Bump the parser to the target offset.
	* If target offset is beyond the end of the input, bump the parser to the end of the input.
	*/ bumpTo(targetOffset) {
        if (this.offset() > targetOffset) throw Error(`targetOffset ${targetOffset} must be greater than or equal to the current offset ${this.offset()}`);
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            const offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error(`targetOffset ${targetOffset} is at invalid UTF-16 code unit boundary`);
            this.bump();
            if (this.isEOF()) break;
        }
    }
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ bumpSpace() {
        while(!this.isEOF() && $2dc2f66d316cd8db$var$_isWhiteSpace(this.char()))this.bump();
    }
    /**
	* Peek at the *next* Unicode codepoint in the input without advancing the parser.
	* If the input has been exhausted, then this returns null.
	*/ peek() {
        if (this.isEOF()) return null;
        const code = this.char();
        const offset = this.offset();
        return this.message.charCodeAt(offset + (code >= 65536 ? 2 : 1)) ?? null;
    }
};
/**
* This check if codepoint is alphabet (lower & uppercase)
* @param codepoint
* @returns
*/ function $2dc2f66d316cd8db$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $2dc2f66d316cd8db$var$_isAlphaOrSlash(codepoint) {
    return $2dc2f66d316cd8db$var$_isAlpha(codepoint) || codepoint === 47;
}
/** See `parseTag` function docs. */ function $2dc2f66d316cd8db$var$_isPotentialElementNameChar(c) {
    return c === 45 || c === 46 || c >= 48 && c <= 57 || c === 95 || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 183 || c >= 192 && c <= 214 || c >= 216 && c <= 246 || c >= 248 && c <= 893 || c >= 895 && c <= 8191 || c >= 8204 && c <= 8205 || c >= 8255 && c <= 8256 || c >= 8304 && c <= 8591 || c >= 11264 && c <= 12271 || c >= 12289 && c <= 55295 || c >= 63744 && c <= 64975 || c >= 65008 && c <= 65533 || c >= 65536 && c <= 983039;
}
/**
* Code point equivalent of regex `\p{White_Space}`.
* From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
*/ function $2dc2f66d316cd8db$var$_isWhiteSpace(c) {
    return c >= 9 && c <= 13 || c === 32 || c === 133 || c >= 8206 && c <= 8207 || c === 8232 || c === 8233;
}
//#endregion
//#region packages/icu-messageformat-parser/manipulator.ts
/**
* Collect variable types, allowing shared date/time arguments.
* @param ast AST to collect variables from
* @param vars Map of variable names to type sets
*/ function $2dc2f66d316cd8db$var$collectVariables(ast, vars = /* @__PURE__ */ new Map()) {
    ast.forEach((el)=>{
        if ($2dc2f66d316cd8db$export$4f55724281bdfaf9(el) || $2dc2f66d316cd8db$export$32d811605da75f40(el) || $2dc2f66d316cd8db$export$34ec46f596b1702f(el) || $2dc2f66d316cd8db$export$e11187b219e191e1(el)) {
            if (vars.has(el.value)) {
                const existingTypes = vars.get(el.value);
                if (!existingTypes.has(el.type) && !existingTypes.has(6) && !existingTypes.has(5)) {
                    if ((el.type === 3 || el.type === 4) && Array.from(existingTypes).every((type)=>type === 3 || type === 4)) existingTypes.add(el.type);
                    else throw new Error(`Variable ${el.value} has conflicting types`);
                }
            } else vars.set(el.value, /* @__PURE__ */ new Set([
                el.type
            ]));
        }
        if ($2dc2f66d316cd8db$export$6c796d116f0a4fbc(el) || $2dc2f66d316cd8db$export$dcfe1c11d168b5a1(el)) {
            vars.set(el.value, /* @__PURE__ */ new Set([
                el.type
            ]));
            Object.keys(el.options).forEach((k)=>{
                $2dc2f66d316cd8db$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ($2dc2f66d316cd8db$export$5c83de34745812b(el)) {
            vars.set(el.value, /* @__PURE__ */ new Set([
                el.type
            ]));
            $2dc2f66d316cd8db$var$collectVariables(el.children, vars);
        }
    });
}
/**
* Check if 2 ASTs are structurally the same. This primarily means that
* they have the same variables with the same type
* @param a
* @param b
* @returns
*/ function $2dc2f66d316cd8db$export$1edd9c892fdd9d27(a, b) {
    const aVars = /* @__PURE__ */ new Map();
    const bVars = /* @__PURE__ */ new Map();
    $2dc2f66d316cd8db$var$collectVariables(a, aVars);
    $2dc2f66d316cd8db$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: /* @__PURE__ */ new Error(`Different number of variables: [${Array.from(aVars.keys()).join(", ")}] vs [${Array.from(bVars.keys()).join(", ")}]`)
    };
    return Array.from(aVars.entries()).reduce((result, [key, type])=>{
        if (!result.success) return result;
        const bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: /* @__PURE__ */ new Error(`Missing variable ${key} in message`)
        };
        if (bType.size !== type.size || !Array.from(type).every((t)=>bType.has(t))) return {
            success: false,
            error: /* @__PURE__ */ new Error(`Variable ${key} has conflicting types: ${Array.from(type, (t)=>$2dc2f66d316cd8db$export$b87f371cbc396fcf[t]).join(", ")} vs ${Array.from(bType, (t)=>$2dc2f66d316cd8db$export$b87f371cbc396fcf[t]).join(", ")}`)
        };
        return result;
    }, {
        success: true
    });
}
//#endregion
//#region packages/icu-messageformat-parser/index.ts
function $2dc2f66d316cd8db$var$pruneLocation(els) {
    els.forEach((el)=>{
        delete el.location;
        if ($2dc2f66d316cd8db$export$dcfe1c11d168b5a1(el) || $2dc2f66d316cd8db$export$6c796d116f0a4fbc(el)) for(const k in el.options){
            delete el.options[k].location;
            $2dc2f66d316cd8db$var$pruneLocation(el.options[k].value);
        }
        else if ($2dc2f66d316cd8db$export$e11187b219e191e1(el) && $2dc2f66d316cd8db$export$3f9a19cd4152eda3(el.style)) delete el.style.location;
        else if (($2dc2f66d316cd8db$export$32d811605da75f40(el) || $2dc2f66d316cd8db$export$34ec46f596b1702f(el)) && $2dc2f66d316cd8db$export$7680c41f1a55f4cf(el.style)) delete el.style.location;
        else if ($2dc2f66d316cd8db$export$5c83de34745812b(el)) $2dc2f66d316cd8db$var$pruneLocation(el.children);
    });
}
function $2dc2f66d316cd8db$export$98e6a39c04603d36(message, opts = {}) {
    opts = {
        shouldParseSkeletons: true,
        requiresOtherClause: true,
        ...opts
    };
    const result = new $2dc2f66d316cd8db$var$Parser(message, opts).parse();
    if (result.err) {
        const error = SyntaxError($2dc2f66d316cd8db$var$ErrorKind[result.err.kind]);
        error.location = result.err.location;
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!opts?.captureLocation) $2dc2f66d316cd8db$var$pruneLocation(result.val);
    return result.val;
}
const $2dc2f66d316cd8db$export$d3c1bfa0f7d806e9 = $2dc2f66d316cd8db$var$Parser;


//#region packages/intl-messageformat/error.ts
let $cce7b597e4178fb0$export$d4e71bc0b80dc0fb = /* @__PURE__ */ function(ErrorCode) {
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
    return ErrorCode;
}({});
var $cce7b597e4178fb0$export$7369836851cc1329 = class extends Error {
    constructor(msg, code, originalMessage){
        super(msg);
        this.code = code;
        this.originalMessage = originalMessage;
    }
    toString() {
        return `[formatjs Error: ${this.code}] ${this.message}`;
    }
};
var $cce7b597e4178fb0$export$565c3afc07dfa382 = class extends $cce7b597e4178fb0$export$7369836851cc1329 {
    constructor(variableId, value, options, originalMessage){
        super(`Invalid values for "${variableId}": "${value}". Options are "${Object.keys(options).join("\", \"")}"`, "INVALID_VALUE", originalMessage);
    }
};
var $cce7b597e4178fb0$export$cbc0db47c750f7c9 = class extends $cce7b597e4178fb0$export$7369836851cc1329 {
    constructor(value, type, originalMessage){
        super(`Value for "${value}" must be of type ${type}`, "INVALID_VALUE", originalMessage);
    }
};
var $cce7b597e4178fb0$export$8bfc137e4d23fdf0 = class extends $cce7b597e4178fb0$export$7369836851cc1329 {
    constructor(variableId, originalMessage){
        super(`The intl string context variable "${variableId}" was not provided to the string "${originalMessage}"`, "MISSING_VALUE", originalMessage);
    }
};
//#endregion
//#region packages/intl-messageformat/formatters.ts
let $cce7b597e4178fb0$export$49694c2877b44c57 = /* @__PURE__ */ function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
    return PART_TYPE;
}({});
function $cce7b597e4178fb0$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce((all, part)=>{
        const lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== 0 || part.type !== 0) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $cce7b597e4178fb0$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $cce7b597e4178fb0$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, originalMessage) {
    if (els.length === 1 && (0, $2dc2f66d316cd8db$export$cfa10c5697238752)(els[0])) return [
        {
            type: 0,
            value: els[0].value
        }
    ];
    const result = [];
    for (const el of els){
        if ((0, $2dc2f66d316cd8db$export$cfa10c5697238752)(el)) {
            result.push({
                type: 0,
                value: el.value
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$c0ece297bdd0c082)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: 0,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        const { value: varName } = el;
        if (!(values && varName in values)) throw new $cce7b597e4178fb0$export$8bfc137e4d23fdf0(varName, originalMessage);
        let value = values[varName];
        if ((0, $2dc2f66d316cd8db$export$4f55724281bdfaf9)(el)) {
            if (!value || typeof value === "string" || typeof value === "number" || typeof value === "bigint") value = typeof value === "string" || typeof value === "number" || typeof value === "bigint" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? 0 : 1,
                value: value
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$32d811605da75f40)(el)) {
            const style = typeof el.style === "string" ? formats.date[el.style] : (0, $2dc2f66d316cd8db$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : void 0;
            result.push({
                type: 0,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$34ec46f596b1702f)(el)) {
            const style = typeof el.style === "string" ? formats.time[el.style] : (0, $2dc2f66d316cd8db$export$7680c41f1a55f4cf)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: 0,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$e11187b219e191e1)(el)) {
            const style = typeof el.style === "string" ? formats.number[el.style] : (0, $2dc2f66d316cd8db$export$3f9a19cd4152eda3)(el.style) ? el.style.parsedOptions : void 0;
            if (style && style.scale) {
                const scale = style.scale || 1;
                if (typeof value === "bigint") {
                    if (!Number.isInteger(scale)) throw new TypeError(`Cannot apply fractional scale ${scale} to bigint value. Scale must be an integer when formatting bigint.`);
                    value = value * BigInt(scale);
                } else value = value * scale;
            }
            result.push({
                type: 0,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$5c83de34745812b)(el)) {
            const { children: children, value: value } = el;
            const formatFn = values[value];
            if (!$cce7b597e4178fb0$export$df0c12a2d414a163(formatFn)) throw new $cce7b597e4178fb0$export$cbc0db47c750f7c9(value, "function", originalMessage);
            let chunks = formatFn($cce7b597e4178fb0$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue).map((p)=>p.value));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push(...chunks.map((c)=>{
                return {
                    type: typeof c === "string" ? 0 : 1,
                    value: c
                };
            }));
        }
        if ((0, $2dc2f66d316cd8db$export$dcfe1c11d168b5a1)(el)) {
            const key = value;
            const opt = (Object.prototype.hasOwnProperty.call(el.options, key) ? el.options[key] : void 0) || el.options.other;
            if (!opt) throw new $cce7b597e4178fb0$export$565c3afc07dfa382(el.value, value, Object.keys(el.options), originalMessage);
            result.push(...$cce7b597e4178fb0$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $2dc2f66d316cd8db$export$6c796d116f0a4fbc)(el)) {
            const exactKey = `=${value}`;
            let opt = Object.prototype.hasOwnProperty.call(el.options, exactKey) ? el.options[exactKey] : void 0;
            if (!opt) {
                if (!Intl.PluralRules) throw new $cce7b597e4178fb0$export$7369836851cc1329(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, "MISSING_INTL_API", originalMessage);
                const numericValue = typeof value === "bigint" ? Number(value) : value;
                const rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(numericValue - (el.offset || 0));
                opt = (Object.prototype.hasOwnProperty.call(el.options, rule) ? el.options[rule] : void 0) || el.options.other;
            }
            if (!opt) throw new $cce7b597e4178fb0$export$565c3afc07dfa382(el.value, value, Object.keys(el.options), originalMessage);
            const numericValue = typeof value === "bigint" ? Number(value) : value;
            result.push(...$cce7b597e4178fb0$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, numericValue - (el.offset || 0)));
            continue;
        }
    }
    return $cce7b597e4178fb0$var$mergeLiteral(result);
}
//#endregion
//#region packages/intl-messageformat/core.ts
function $cce7b597e4178fb0$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return {
        ...c1,
        ...c2,
        ...Object.keys(c1).reduce((all, k)=>{
            all[k] = {
                ...c1[k],
                ...c2[k]
            };
            return all;
        }, {})
    };
}
function $cce7b597e4178fb0$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce((all, k)=>{
        all[k] = $cce7b597e4178fb0$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, {
        ...defaultConfig
    });
}
function $cce7b597e4178fb0$var$createFastMemoizeCache(store) {
    return {
        create () {
            return {
                get (key) {
                    return store[key];
                },
                set (key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $cce7b597e4178fb0$var$createDefaultFormatters(cache = {
    number: {},
    dateTime: {},
    pluralRules: {}
}) {
    return {
        getNumberFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.NumberFormat(...args), {
            cache: $cce7b597e4178fb0$var$createFastMemoizeCache(cache.number),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getDateTimeFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.DateTimeFormat(...args), {
            cache: $cce7b597e4178fb0$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.PluralRules(...args), {
            cache: $cce7b597e4178fb0$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        })
    };
}
var $cce7b597e4178fb0$export$d342343268debc40 = class IntlMessageFormat {
    constructor(message, locales = IntlMessageFormat.defaultLocale, overrideFormats, opts){
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = (values)=>{
            const parts = this.formatToParts(values);
            if (parts.length === 1) return parts[0].value;
            const result = parts.reduce((all, part)=>{
                if (!all.length || part.type !== 0 || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = (values)=>$cce7b597e4178fb0$export$275d4a3bb5f66fda(this.ast, this.locales, this.formatters, this.formats, values, void 0, this.message);
        this.resolvedOptions = ()=>({
                locale: this.resolvedLocale?.toString() || Intl.NumberFormat.supportedLocalesOf(this.locales)[0]
            });
        this.getAst = ()=>this.ast;
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            const { ...parseOpts } = opts || {};
            this.ast = IntlMessageFormat.__parse(message, {
                ...parseOpts,
                locale: this.resolvedLocale
            });
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        this.formats = $cce7b597e4178fb0$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $cce7b597e4178fb0$var$createDefaultFormatters(this.formatterCache);
    }
    static{
        this.memoizedDefaultLocale = null;
    }
    static get defaultLocale() {
        if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
        return IntlMessageFormat.memoizedDefaultLocale;
    }
    static{
        this.resolveLocale = (locales)=>{
            if (typeof Intl.Locale === "undefined") return;
            const supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
            if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
            return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
        };
    }
    static{
        this.__parse = (0, $2dc2f66d316cd8db$export$98e6a39c04603d36);
    }
    static{
        this.formats = {
            number: {
                integer: {
                    maximumFractionDigits: 0
                },
                currency: {
                    style: "currency"
                },
                percent: {
                    style: "percent"
                }
            },
            date: {
                short: {
                    month: "numeric",
                    day: "numeric",
                    year: "2-digit"
                },
                medium: {
                    month: "short",
                    day: "numeric",
                    year: "numeric"
                },
                long: {
                    month: "long",
                    day: "numeric",
                    year: "numeric"
                },
                full: {
                    weekday: "long",
                    month: "long",
                    day: "numeric",
                    year: "numeric"
                }
            },
            time: {
                short: {
                    hour: "numeric",
                    minute: "numeric"
                },
                medium: {
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric"
                },
                long: {
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    timeZoneName: "short"
                },
                full: {
                    hour: "numeric",
                    minute: "numeric",
                    second: "numeric",
                    timeZoneName: "short"
                }
            }
        };
    }
};
//#endregion
//#region packages/intl-messageformat/index.ts
var $cce7b597e4178fb0$export$2e2bcd8739ae039 = $cce7b597e4178fb0$export$d342343268debc40;



//#region packages/intl/typed-message.ts
function $4bda6d15a99e1cac$export$747d244ee58120dd(message, _options) {
    return message;
}
function $4bda6d15a99e1cac$export$1adfeb024f5185b(messages, _options) {
    return messages;
}
//#endregion
//#region packages/intl/error.ts
let $4bda6d15a99e1cac$export$557d6acb76e8a244 = /* @__PURE__ */ function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
    return IntlErrorCode;
}({});
var $4bda6d15a99e1cac$export$c016d36112f6ddf8 = class IntlError extends Error {
    constructor(code, message, exception){
        const err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : void 0;
        super(`[@formatjs/intl Error ${code}] ${message}
${err ? `\n${err.message}\n${err.stack}` : ""}`);
        this.code = code;
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, IntlError);
    }
};
var $4bda6d15a99e1cac$export$549f97e137a05c90 = class extends $4bda6d15a99e1cac$export$c016d36112f6ddf8 {
    constructor(message, exception){
        super("UNSUPPORTED_FORMATTER", message, exception);
    }
};
var $4bda6d15a99e1cac$export$3ca04dd7fb305893 = class extends $4bda6d15a99e1cac$export$c016d36112f6ddf8 {
    constructor(message, exception){
        super("INVALID_CONFIG", message, exception);
    }
};
var $4bda6d15a99e1cac$export$c1eaf877d81384b6 = class extends $4bda6d15a99e1cac$export$c016d36112f6ddf8 {
    constructor(message, exception){
        super("MISSING_DATA", message, exception);
    }
};
var $4bda6d15a99e1cac$export$e3b7eee1dbc44895 = class extends $4bda6d15a99e1cac$export$c016d36112f6ddf8 {
    constructor(message, locale, exception){
        super("FORMAT_ERROR", `${message}
Locale: ${locale}
`, exception);
        this.locale = locale;
    }
};
var $4bda6d15a99e1cac$export$74a601a3d3f31621 = class extends $4bda6d15a99e1cac$export$e3b7eee1dbc44895 {
    constructor(message, locale, descriptor, exception){
        super(`${message}
MessageID: ${descriptor?.id}
Default Message: ${descriptor?.defaultMessage}
Description: ${descriptor?.description}
`, locale, exception);
        this.descriptor = descriptor;
        this.locale = locale;
    }
};
var $4bda6d15a99e1cac$export$2ddcb436d0aa3688 = class extends $4bda6d15a99e1cac$export$c016d36112f6ddf8 {
    constructor(descriptor, locale){
        super("MISSING_TRANSLATION", `Missing message: "${descriptor.id}" for locale "${locale}", using ${descriptor.defaultMessage ? `default message (${typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map((e)=>e.value ?? JSON.stringify(e)).join()})` : "id"} as fallback.`);
        this.descriptor = descriptor;
    }
};
//#endregion
//#region packages/intl/utils.ts
function $4bda6d15a99e1cac$var$invariant(condition, message, Err = Error) {
    if (!condition) throw new Err(message);
}
function $4bda6d15a99e1cac$export$d697c39a2985a4c(props, allowlist, defaults = {}) {
    return allowlist.reduce((filtered, name)=>{
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
const $4bda6d15a99e1cac$var$defaultErrorHandler = (error)=>{};
const $4bda6d15a99e1cac$var$defaultWarnHandler = (warning)=>{};
const $4bda6d15a99e1cac$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: void 0,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $4bda6d15a99e1cac$var$defaultErrorHandler,
    onWarn: $4bda6d15a99e1cac$var$defaultWarnHandler
};
function $4bda6d15a99e1cac$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        duration: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $4bda6d15a99e1cac$var$createFastMemoizeCache(store) {
    return {
        create () {
            return {
                get (key) {
                    return store[key];
                },
                set (key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
/**
* Create intl formatters and populate cache
* @param cache explicit cache to prevent leaking memory
*/ function $4bda6d15a99e1cac$export$c3f4cd5551df13fd(cache = $4bda6d15a99e1cac$export$51c4f4e973f2dc00()) {
    const RelativeTimeFormat = Intl.RelativeTimeFormat;
    const ListFormat = Intl.ListFormat;
    const DisplayNames = Intl.DisplayNames;
    const getDateTimeFormat = (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.DateTimeFormat(...args), {
        cache: $4bda6d15a99e1cac$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
    });
    const getNumberFormat = (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.NumberFormat(...args), {
        cache: $4bda6d15a99e1cac$var$createFastMemoizeCache(cache.number),
        strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
    });
    const getPluralRules = (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.PluralRules(...args), {
        cache: $4bda6d15a99e1cac$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((message, locales, overrideFormats, opts)=>new (0, $cce7b597e4178fb0$export$d342343268debc40)(message, locales, overrideFormats, {
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                },
                ...opts
            }), {
            cache: $4bda6d15a99e1cac$var$createFastMemoizeCache(cache.message),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getDurationFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new Intl.DurationFormat(...args), {
            cache: $4bda6d15a99e1cac$var$createFastMemoizeCache(cache.duration),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getRelativeTimeFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new RelativeTimeFormat(...args), {
            cache: $4bda6d15a99e1cac$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new ListFormat(...args), {
            cache: $4bda6d15a99e1cac$var$createFastMemoizeCache(cache.list),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        }),
        getDisplayNames: (0, $7bac09121bc9431c$export$fc10aeed3a532e2a)((...args)=>new DisplayNames(...args), {
            cache: $4bda6d15a99e1cac$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $7bac09121bc9431c$export$c5491a8691a23b9e).variadic
        })
    };
}
function $4bda6d15a99e1cac$export$4ee1db8ce44a209b(formats, type, name, onError) {
    const formatType = formats && formats[type];
    let format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new $4bda6d15a99e1cac$export$549f97e137a05c90(`No ${type} format named: ${name}`));
}
//#endregion
//#region packages/intl/message.ts
function $4bda6d15a99e1cac$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce((all, k)=>{
        all[k] = {
            timeZone: timeZone,
            ...opts[k]
        };
        return all;
    }, {});
}
function $4bda6d15a99e1cac$var$deepMergeOptions(opts1, opts2) {
    return Object.keys({
        ...opts1,
        ...opts2
    }).reduce((all, k)=>{
        all[k] = {
            ...opts1[k],
            ...opts2[k]
        };
        return all;
    }, {});
}
function $4bda6d15a99e1cac$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    const mfFormats = (0, $cce7b597e4178fb0$export$d342343268debc40).formats;
    return {
        ...mfFormats,
        ...f1,
        date: $4bda6d15a99e1cac$var$deepMergeOptions($4bda6d15a99e1cac$var$setTimeZoneInOptions(mfFormats.date, timeZone), $4bda6d15a99e1cac$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $4bda6d15a99e1cac$var$deepMergeOptions($4bda6d15a99e1cac$var$setTimeZoneInOptions(mfFormats.time, timeZone), $4bda6d15a99e1cac$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    };
}
function $4bda6d15a99e1cac$var$getMessageDescriptorContext(messageDescriptor) {
    const { defaultMessage: defaultMessage } = messageDescriptor;
    try {
        return defaultMessage !== void 0 ? `\nDefault Message: ${typeof defaultMessage === "string" ? defaultMessage : JSON.stringify(defaultMessage)}` : `\nMessage Descriptor: ${JSON.stringify(messageDescriptor)}`;
    } catch  {
        return "";
    }
}
const $4bda6d15a99e1cac$export$25868d1e8e76735f = ({ locale: locale, formats: formats, messages: messages, defaultLocale: defaultLocale, defaultFormats: defaultFormats, fallbackOnEmptyString: fallbackOnEmptyString, onError: onError, timeZone: timeZone, defaultRichTextElements: defaultRichTextElements }, state, messageDescriptor = {
    id: ""
}, values, opts)=>{
    const { id: msgId, defaultMessage: defaultMessage } = messageDescriptor;
    if (!msgId) $4bda6d15a99e1cac$var$invariant(false, `[@formatjs/intl] An \`id\` must be provided to format a message. You can either:
1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)
or [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR
2. Configure your \`eslint\` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)
to autofix this issue${$4bda6d15a99e1cac$var$getMessageDescriptorContext(messageDescriptor)}`);
    const id = String(msgId);
    const message = messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $2dc2f66d316cd8db$export$b87f371cbc396fcf).literal) return message[0].value;
    values = {
        ...defaultRichTextElements,
        ...values
    };
    formats = $4bda6d15a99e1cac$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $4bda6d15a99e1cac$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) onError(new $4bda6d15a99e1cac$export$2ddcb436d0aa3688(messageDescriptor, locale));
        if (defaultMessage) try {
            return state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts).format(values);
        } catch (e) {
            onError(new $4bda6d15a99e1cac$export$74a601a3d3f31621(`Error formatting default message for: "${id}", rendering default message verbatim`, locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    try {
        return state.getMessageFormat(message, locale, formats, {
            formatters: state,
            ...opts
        }).format(values);
    } catch (e) {
        onError(new $4bda6d15a99e1cac$export$74a601a3d3f31621(`Error formatting message: "${id}", using ${defaultMessage ? "default message" : "id"} as fallback.`, locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        return state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts).format(values);
    } catch (e) {
        onError(new $4bda6d15a99e1cac$export$74a601a3d3f31621(`Error formatting the default message for: "${id}", rendering message verbatim`, locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};
//#endregion
//#region packages/intl/dateTime.ts
const $4bda6d15a99e1cac$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    "numberingSystem",
    "fractionalSecondDigits"
];
function $4bda6d15a99e1cac$var$getFormatter$3({ locale: locale, formats: formats, onError: onError, timeZone: timeZone }, type, getDateTimeFormat, options = {}) {
    const { format: format } = options;
    const defaults = {
        ...timeZone && {
            timeZone: timeZone
        },
        ...format && $4bda6d15a99e1cac$export$4ee1db8ce44a209b(formats, type, format, onError)
    };
    let filteredOptions = $4bda6d15a99e1cac$export$d697c39a2985a4c(options, $4bda6d15a99e1cac$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) filteredOptions = {
        ...filteredOptions,
        hour: "numeric",
        minute: "numeric"
    };
    return getDateTimeFormat(locale, filteredOptions);
}
function $4bda6d15a99e1cac$export$3ae94a2503e890a1(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $4bda6d15a99e1cac$var$getFormatter$3(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $4bda6d15a99e1cac$export$3203edd9e5edd663(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $4bda6d15a99e1cac$var$getFormatter$3(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $4bda6d15a99e1cac$var$formatDateTimeRange(config, getDateTimeFormat, from, to, options = {}) {
    const fromDate = typeof from === "string" ? new Date(from || 0) : from;
    const toDate = typeof to === "string" ? new Date(to || 0) : to;
    try {
        return $4bda6d15a99e1cac$var$getFormatter$3(config, "dateTimeRange", getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting date time range.", config.locale, e));
    }
    return String(fromDate);
}
function $4bda6d15a99e1cac$export$dc1f059bce486b1(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $4bda6d15a99e1cac$var$getFormatter$3(config, "date", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting date.", config.locale, e));
    }
    return [];
}
function $4bda6d15a99e1cac$export$af6e5d7a5c73edeb(config, getDateTimeFormat, value, options = {}) {
    const date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $4bda6d15a99e1cac$var$getFormatter$3(config, "time", getDateTimeFormat, options).formatToParts(date);
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting time.", config.locale, e));
    }
    return [];
}
//#endregion
//#region packages/intl/duration.ts
const $4bda6d15a99e1cac$var$DURATION_FORMAT_OPTIONS = [
    "style",
    "numberingSystem",
    "years",
    "yearsDisplay",
    "months",
    "monthsDisplay",
    "weeks",
    "weeksDisplay",
    "days",
    "daysDisplay",
    "hours",
    "hoursDisplay",
    "minutes",
    "minutesDisplay",
    "seconds",
    "secondsDisplay",
    "milliseconds",
    "millisecondsDisplay",
    "microseconds",
    "microsecondsDisplay",
    "nanoseconds",
    "nanosecondsDisplay",
    "fractionalDigits"
];
function $4bda6d15a99e1cac$var$getFormatter$2({ locale: locale, formats: formats, onError: onError }, getDurationFormat, options) {
    if (!Intl.DurationFormat) {
        onError(new (0, $cce7b597e4178fb0$export$7369836851cc1329)("Intl.DurationFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-durationformat\"", (0, $cce7b597e4178fb0$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
        return;
    }
    const { format: format } = options;
    const defaults = format && $4bda6d15a99e1cac$export$4ee1db8ce44a209b(formats, "duration", format, onError) || {};
    return getDurationFormat(locale, $4bda6d15a99e1cac$export$d697c39a2985a4c(options, $4bda6d15a99e1cac$var$DURATION_FORMAT_OPTIONS, defaults));
}
function $4bda6d15a99e1cac$export$bc733b0c5cbb3e8a(config, getDurationFormat, value, options = {}) {
    try {
        return $4bda6d15a99e1cac$var$getFormatter$2(config, getDurationFormat, options)?.format(value) ?? "";
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting duration.", config.locale, e));
    }
    return "";
}
function $4bda6d15a99e1cac$export$5d6eb0ef61ecf0ba(config, getDurationFormat, value, options = {}) {
    try {
        return $4bda6d15a99e1cac$var$getFormatter$2(config, getDurationFormat, options)?.formatToParts(value) ?? [];
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting duration.", config.locale, e));
    }
    return [];
}
//#endregion
//#region packages/intl/displayName.ts
const $4bda6d15a99e1cac$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $4bda6d15a99e1cac$export$62fe1a4d9e891fa2({ locale: locale, onError: onError }, getDisplayNames, value, options) {
    if (!Intl.DisplayNames) onError(new (0, $cce7b597e4178fb0$export$7369836851cc1329)(`Intl.DisplayNames is not available in this environment.
Try polyfilling it using "@formatjs/intl-displaynames"
`, (0, $cce7b597e4178fb0$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    const filteredOptions = $4bda6d15a99e1cac$export$d697c39a2985a4c(options, $4bda6d15a99e1cac$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting display name.", locale, e));
    }
}
//#endregion
//#region packages/intl/list.ts
const $4bda6d15a99e1cac$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
const $4bda6d15a99e1cac$var$now = Date.now();
function $4bda6d15a99e1cac$var$generateToken(i) {
    return `${$4bda6d15a99e1cac$var$now}_${i}_${$4bda6d15a99e1cac$var$now}`;
}
function $4bda6d15a99e1cac$export$e8b8be48b45905bb(opts, getListFormat, values, options = {}) {
    const results = $4bda6d15a99e1cac$var$formatListToParts(opts, getListFormat, values, options).reduce((all, el)=>{
        const val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $4bda6d15a99e1cac$var$formatListToParts({ locale: locale, onError: onError }, getListFormat, values, options = {}) {
    if (!Intl.ListFormat) onError(new (0, $cce7b597e4178fb0$export$7369836851cc1329)(`Intl.ListFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-listformat"
`, (0, $cce7b597e4178fb0$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    const filteredOptions = $4bda6d15a99e1cac$export$d697c39a2985a4c(options, $4bda6d15a99e1cac$var$LIST_FORMAT_OPTIONS);
    try {
        const richValues = {};
        const serializedValues = Array.from(values).map((v, i)=>{
            if (typeof v === "object" && v !== null) {
                const id = $4bda6d15a99e1cac$var$generateToken(i);
                richValues[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map((part)=>part.type === "literal" ? part : {
                ...part,
                value: richValues[part.value] || part.value
            });
    } catch (e) {
        onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting list.", locale, e));
    }
    return values;
}
//#endregion
//#region packages/intl/plural.ts
const $4bda6d15a99e1cac$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $4bda6d15a99e1cac$export$bbbd05c900f3568d({ locale: locale, onError: onError }, getPluralRules, value, options = {}) {
    if (!Intl.PluralRules) onError(new (0, $cce7b597e4178fb0$export$7369836851cc1329)(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, (0, $cce7b597e4178fb0$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    const filteredOptions = $4bda6d15a99e1cac$export$d697c39a2985a4c(options, $4bda6d15a99e1cac$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting plural.", locale, e));
    }
    return "other";
}
//#endregion
//#region packages/intl/relativeTime.ts
const $4bda6d15a99e1cac$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $4bda6d15a99e1cac$var$getFormatter$1({ locale: locale, formats: formats, onError: onError }, getRelativeTimeFormat, options = {}) {
    const { format: format } = options;
    const defaults = !!format && $4bda6d15a99e1cac$export$4ee1db8ce44a209b(formats, "relative", format, onError) || {};
    return getRelativeTimeFormat(locale, $4bda6d15a99e1cac$export$d697c39a2985a4c(options, $4bda6d15a99e1cac$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults));
}
function $4bda6d15a99e1cac$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options = {}) {
    if (!unit) unit = "second";
    if (!Intl.RelativeTimeFormat) config.onError(new (0, $cce7b597e4178fb0$export$7369836851cc1329)(`Intl.RelativeTimeFormat is not available in this environment.
Try polyfilling it using "@formatjs/intl-relativetimeformat"
`, (0, $cce7b597e4178fb0$export$d4e71bc0b80dc0fb).MISSING_INTL_API));
    try {
        return $4bda6d15a99e1cac$var$getFormatter$1(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}
//#endregion
//#region packages/intl/number.ts
const $4bda6d15a99e1cac$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem",
    "trailingZeroDisplay",
    "roundingPriority",
    "roundingIncrement",
    "roundingMode"
];
function $4bda6d15a99e1cac$var$getFormatter({ locale: locale, formats: formats, onError: onError }, getNumberFormat, options = {}) {
    const { format: format } = options;
    const defaults = format && $4bda6d15a99e1cac$export$4ee1db8ce44a209b(formats, "number", format, onError) || {};
    return getNumberFormat(locale, $4bda6d15a99e1cac$export$d697c39a2985a4c(options, $4bda6d15a99e1cac$var$NUMBER_FORMAT_OPTIONS, defaults));
}
function $4bda6d15a99e1cac$export$f5dd818bff069720(config, getNumberFormat, value, options = {}) {
    try {
        return $4bda6d15a99e1cac$var$getFormatter(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $4bda6d15a99e1cac$export$6871080848f10b2f(config, getNumberFormat, value, options = {}) {
    try {
        return $4bda6d15a99e1cac$var$getFormatter(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new $4bda6d15a99e1cac$export$e3b7eee1dbc44895("Error formatting number.", config.locale, e));
    }
    return [];
}
//#endregion
//#region packages/intl/create-intl.ts
function $4bda6d15a99e1cac$var$messagesContainString(messages) {
    return typeof (messages ? messages[Object.keys(messages)[0]] : void 0) === "string";
}
function $4bda6d15a99e1cac$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $4bda6d15a99e1cac$var$messagesContainString(config.messages || {})) config.onWarn(`[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. 
Please consider using "@formatjs/cli" to pre-compile your messages for performance.
For more details see https://formatjs.github.io/docs/getting-started/message-distribution`);
}
/**
* Create intl object
* @param config intl config
* @param cache cache for formatter instances to prevent memory leak
*/ function $4bda6d15a99e1cac$export$7e4cbedfdd7b4c0d(config, cache) {
    const formatters = $4bda6d15a99e1cac$export$c3f4cd5551df13fd(cache);
    const resolvedConfig = {
        ...$4bda6d15a99e1cac$export$b52f8d6fc0d47415,
        ...config
    };
    const { locale: locale, defaultLocale: defaultLocale, onError: onError } = resolvedConfig;
    if (!locale) {
        if (onError) onError(new $4bda6d15a99e1cac$export$3ca04dd7fb305893(`"locale" was not configured, using "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details`));
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new $4bda6d15a99e1cac$export$c1eaf877d81384b6(`Missing locale data for locale: "${locale}" in Intl.NumberFormat. Using default locale: "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new $4bda6d15a99e1cac$export$c1eaf877d81384b6(`Missing locale data for locale: "${locale}" in Intl.DateTimeFormat. Using default locale: "${defaultLocale}" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details`));
    $4bda6d15a99e1cac$var$verifyConfigMessages(resolvedConfig);
    return {
        ...resolvedConfig,
        formatters: formatters,
        formatNumber: $4bda6d15a99e1cac$export$f5dd818bff069720.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: $4bda6d15a99e1cac$export$6871080848f10b2f.bind(null, resolvedConfig, formatters.getNumberFormat),
        formatDuration: $4bda6d15a99e1cac$export$bc733b0c5cbb3e8a.bind(null, resolvedConfig, formatters.getDurationFormat),
        formatDurationToParts: $4bda6d15a99e1cac$export$5d6eb0ef61ecf0ba.bind(null, resolvedConfig, formatters.getDurationFormat),
        formatRelativeTime: $4bda6d15a99e1cac$export$b4ea3b48dcf921f6.bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: $4bda6d15a99e1cac$export$3ae94a2503e890a1.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: $4bda6d15a99e1cac$export$dc1f059bce486b1.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: $4bda6d15a99e1cac$export$3203edd9e5edd663.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: $4bda6d15a99e1cac$var$formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: $4bda6d15a99e1cac$export$af6e5d7a5c73edeb.bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: $4bda6d15a99e1cac$export$bbbd05c900f3568d.bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: $4bda6d15a99e1cac$export$25868d1e8e76735f.bind(null, resolvedConfig, formatters),
        $t: $4bda6d15a99e1cac$export$25868d1e8e76735f.bind(null, resolvedConfig, formatters),
        formatList: $4bda6d15a99e1cac$export$e8b8be48b45905bb.bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: $4bda6d15a99e1cac$var$formatListToParts.bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: $4bda6d15a99e1cac$export$62fe1a4d9e891fa2.bind(null, resolvedConfig, formatters.getDisplayNames)
    };
}



var $ayMG0 = parcelRequire("ayMG0");

"use client";
//#region packages/react-intl/utils.tsx
function $5706f4e3d2f628b5$var$invariant(condition, message, Err = Error) {
    if (!condition) throw new Err(message);
}
function $5706f4e3d2f628b5$var$invariantIntlContext(intl) {
    $5706f4e3d2f628b5$var$invariant(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
const $5706f4e3d2f628b5$var$DEFAULT_INTL_CONFIG$1 = {
    ...(0, $4bda6d15a99e1cac$export$b52f8d6fc0d47415),
    textComponent: $acw62.Fragment
};
/**
* Builds an array of {@link React.ReactNode}s with index-based keys, similar to
* {@link React.Children.toArray}. However, this function tells React that it
* was intentional, so they won't produce a bunch of warnings about it.
*
* React doesn't recommend doing this because it makes reordering inefficient,
* but we mostly need this for message chunks, which don't tend to reorder to
* begin with.
*
*/ const $5706f4e3d2f628b5$var$toKeyedReactNodeArray = (children)=>{
    return $acw62.Children.toArray(children).map((child, index)=>{
        if ($acw62.isValidElement(child)) return /* @__PURE__ */ (0, $ayMG0.jsx)($acw62.Fragment, {
            children: child
        }, index);
        return child;
    });
};
/**
* Takes a `formatXMLElementFn`, and composes it in function, which passes
* argument `parts` through, assigning unique key to each part, to prevent
* "Each child in a list should have a unique "key"" React error.
* @param formatXMLElementFn
*/ function $5706f4e3d2f628b5$var$assignUniqueKeysToParts(formatXMLElementFn) {
    return function(parts) {
        return formatXMLElementFn($5706f4e3d2f628b5$var$toKeyedReactNodeArray(parts));
    };
}
function $5706f4e3d2f628b5$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
//#endregion
//#region packages/react-intl/components/context.ts
const $5706f4e3d2f628b5$export$9073ae457aa4b186 = $acw62.createContext(null);
const $5706f4e3d2f628b5$export$e0fdd9f62e9e65dd = $5706f4e3d2f628b5$export$9073ae457aa4b186.Provider;
//#endregion
//#region packages/react-intl/components/useIntl.ts
function $5706f4e3d2f628b5$export$5aebe9a147f4d146() {
    const intl = $acw62.useContext($5706f4e3d2f628b5$export$9073ae457aa4b186);
    $5706f4e3d2f628b5$var$invariantIntlContext(intl);
    return intl;
}
//#endregion
//#region packages/react-intl/components/createFormattedComponent.tsx
var $5706f4e3d2f628b5$var$DisplayName = /* @__PURE__ */ function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    DisplayName["formatDuration"] = "FormattedDuration";
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
    return DisplayName;
}($5706f4e3d2f628b5$var$DisplayName || {});
var $5706f4e3d2f628b5$var$DisplayNameParts = /* @__PURE__ */ function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
    return DisplayNameParts;
}($5706f4e3d2f628b5$var$DisplayNameParts || {});
const $5706f4e3d2f628b5$export$54d4989ed3eea1ea = (props)=>{
    const intl = $5706f4e3d2f628b5$export$5aebe9a147f4d146();
    const { value: value, children: children, ...formatProps } = props;
    return children(intl.formatNumberToParts(value, formatProps));
};
$5706f4e3d2f628b5$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
const $5706f4e3d2f628b5$export$65e3d22c1f876656 = (props)=>{
    const intl = $5706f4e3d2f628b5$export$5aebe9a147f4d146();
    const { value: value, children: children, ...formatProps } = props;
    return children(intl.formatDurationToParts(value, formatProps));
};
$5706f4e3d2f628b5$export$65e3d22c1f876656.displayName = "FormattedDurationParts";
const $5706f4e3d2f628b5$export$5ac259c7da6d2188 = (props)=>{
    const intl = $5706f4e3d2f628b5$export$5aebe9a147f4d146();
    const { value: value, children: children, ...formatProps } = props;
    return children(intl.formatListToParts(value, formatProps));
};
$5706f4e3d2f628b5$export$5ac259c7da6d2188.displayName = "FormattedListParts";
function $5706f4e3d2f628b5$var$createFormattedDateTimePartsComponent(name) {
    const ComponentParts = (props)=>{
        const intl = $5706f4e3d2f628b5$export$5aebe9a147f4d146();
        const { value: value, children: children, ...formatProps } = props;
        const date = typeof value === "string" ? new Date(value || 0) : value;
        return children(name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps));
    };
    ComponentParts.displayName = $5706f4e3d2f628b5$var$DisplayNameParts[name];
    return ComponentParts;
}
function $5706f4e3d2f628b5$var$createFormattedComponent(name) {
    const Component = (props)=>{
        const intl = $5706f4e3d2f628b5$export$5aebe9a147f4d146();
        const { value: value, children: children, ...formatProps } = props;
        const formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        const Text = intl.textComponent || $acw62.Fragment;
        return /* @__PURE__ */ (0, $ayMG0.jsx)(Text, {
            children: formattedValue
        });
    };
    Component.displayName = $5706f4e3d2f628b5$var$DisplayName[name];
    return Component;
}
//#endregion
//#region packages/react-intl/components/createIntl.ts
function $5706f4e3d2f628b5$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce((acc, k)=>{
        const v = values[k];
        acc[k] = (0, $cce7b597e4178fb0$export$df0c12a2d414a163)(v) ? $5706f4e3d2f628b5$var$assignUniqueKeysToParts(v) : v;
        return acc;
    }, {});
}
const $5706f4e3d2f628b5$var$formatMessage$1 = (config, formatters, descriptor, rawValues, ...rest)=>{
    const values = $5706f4e3d2f628b5$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    const chunks = (0, $4bda6d15a99e1cac$export$25868d1e8e76735f)(config, formatters, descriptor, values, ...rest);
    if (Array.isArray(chunks)) return $5706f4e3d2f628b5$var$toKeyedReactNodeArray(chunks);
    return chunks;
};
/**
* Create intl object
* @param config intl config
* @param cache cache for formatter instances to prevent memory leak
*/ const $5706f4e3d2f628b5$export$7e4cbedfdd7b4c0d = ({ defaultRichTextElements: rawDefaultRichTextElements, ...config }, cache)=>{
    const defaultRichTextElements = $5706f4e3d2f628b5$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    const coreIntl = (0, $4bda6d15a99e1cac$export$7e4cbedfdd7b4c0d)({
        ...$5706f4e3d2f628b5$var$DEFAULT_INTL_CONFIG$1,
        ...config,
        defaultRichTextElements: defaultRichTextElements
    }, cache);
    const resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return {
        ...coreIntl,
        formatMessage: $5706f4e3d2f628b5$var$formatMessage$1.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $5706f4e3d2f628b5$var$formatMessage$1.bind(null, resolvedConfig, coreIntl.formatters)
    };
};
//#endregion
//#region packages/react-intl/components/dateTimeRange.tsx
const $5706f4e3d2f628b5$export$92bc0c62461e366 = (props)=>{
    const intl = $5706f4e3d2f628b5$export$5aebe9a147f4d146();
    const { from: from, to: to, children: children, ...formatProps } = props;
    const formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === "function") return children(formattedValue);
    const Text = intl.textComponent || $acw62.Fragment;
    return /* @__PURE__ */ (0, $ayMG0.jsx)(Text, {
        children: formattedValue
    });
};
$5706f4e3d2f628b5$export$92bc0c62461e366.displayName = "FormattedDateTimeRange";
//#endregion
//#region packages/react-intl/components/message.tsx
function $5706f4e3d2f628b5$var$areEqual(prevProps, nextProps) {
    const { values: values, ...otherProps } = prevProps;
    const { values: nextValues, ...nextOtherProps } = nextProps;
    return $5706f4e3d2f628b5$var$shallowEqual(nextValues, values) && $5706f4e3d2f628b5$var$shallowEqual(otherProps, nextOtherProps);
}
function $5706f4e3d2f628b5$var$FormattedMessage(props) {
    const { formatMessage: formatMessage, textComponent: Text = $acw62.Fragment } = $5706f4e3d2f628b5$export$5aebe9a147f4d146();
    const { id: id, description: description, defaultMessage: defaultMessage, values: values, children: children, tagName: Component = Text, ignoreTag: ignoreTag } = props;
    const nodes = formatMessage({
        id: id,
        description: description,
        defaultMessage: defaultMessage
    }, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return /* @__PURE__ */ (0, $ayMG0.jsx)(Component, {
        children: nodes
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: nodes
    });
}
$5706f4e3d2f628b5$var$FormattedMessage.displayName = "FormattedMessage";
const $5706f4e3d2f628b5$export$561a3c611f78824a = $acw62.memo($5706f4e3d2f628b5$var$FormattedMessage, $5706f4e3d2f628b5$var$areEqual);
$5706f4e3d2f628b5$export$561a3c611f78824a.displayName = "MemoizedFormattedMessage";
//#endregion
//#region packages/react-intl/components/plural.tsx
const $5706f4e3d2f628b5$export$da755058eada5424 = (props)=>{
    const { formatPlural: formatPlural, textComponent: Text } = $5706f4e3d2f628b5$export$5aebe9a147f4d146();
    const { value: value, other: other, children: children } = props;
    const formattedPlural = props[formatPlural(value, props)] || other;
    if (typeof children === "function") return children(formattedPlural);
    if (Text) return /* @__PURE__ */ (0, $ayMG0.jsx)(Text, {
        children: formattedPlural
    });
    return formattedPlural;
};
$5706f4e3d2f628b5$export$da755058eada5424.displayName = "FormattedPlural";
//#endregion
//#region packages/react-intl/components/provider.tsx
function $5706f4e3d2f628b5$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
function $5706f4e3d2f628b5$var$IntlProviderImpl(props) {
    const cacheRef = $acw62.useRef((0, $4bda6d15a99e1cac$export$51c4f4e973f2dc00)());
    const prevConfigRef = $acw62.useRef(void 0);
    const intlRef = $acw62.useRef(void 0);
    const filteredProps = {};
    for(const key in props)if (props[key] !== void 0) filteredProps[key] = props[key];
    const config = $5706f4e3d2f628b5$var$processIntlConfig({
        ...$5706f4e3d2f628b5$var$DEFAULT_INTL_CONFIG$1,
        ...filteredProps
    });
    if (!prevConfigRef.current || !$5706f4e3d2f628b5$var$shallowEqual(prevConfigRef.current, config)) {
        prevConfigRef.current = config;
        intlRef.current = $5706f4e3d2f628b5$export$7e4cbedfdd7b4c0d(config, cacheRef.current);
    }
    $5706f4e3d2f628b5$var$invariantIntlContext(intlRef.current);
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5706f4e3d2f628b5$export$e0fdd9f62e9e65dd, {
        value: intlRef.current,
        children: props.children
    });
}
$5706f4e3d2f628b5$var$IntlProviderImpl.displayName = "IntlProvider";
const $5706f4e3d2f628b5$export$480518999dfc4151 = $5706f4e3d2f628b5$var$IntlProviderImpl;
//#endregion
//#region packages/react-intl/components/relative.tsx
const $5706f4e3d2f628b5$var$MINUTE = 60;
const $5706f4e3d2f628b5$var$HOUR = 3600;
const $5706f4e3d2f628b5$var$DAY = 86400;
function $5706f4e3d2f628b5$var$selectUnit(seconds) {
    const absValue = Math.abs(seconds);
    if (absValue < $5706f4e3d2f628b5$var$MINUTE) return "second";
    if (absValue < $5706f4e3d2f628b5$var$HOUR) return "minute";
    if (absValue < $5706f4e3d2f628b5$var$DAY) return "hour";
    return "day";
}
function $5706f4e3d2f628b5$var$getDurationInSeconds(unit) {
    switch(unit){
        case "second":
            return 1;
        case "minute":
            return $5706f4e3d2f628b5$var$MINUTE;
        case "hour":
            return $5706f4e3d2f628b5$var$HOUR;
        default:
            return $5706f4e3d2f628b5$var$DAY;
    }
}
function $5706f4e3d2f628b5$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case "second":
            return value;
        case "minute":
            return value * $5706f4e3d2f628b5$var$MINUTE;
        default:
            return value * $5706f4e3d2f628b5$var$HOUR;
    }
}
const $5706f4e3d2f628b5$var$INCREMENTABLE_UNITS = [
    "second",
    "minute",
    "hour"
];
function $5706f4e3d2f628b5$var$canIncrement(unit = "second") {
    return $5706f4e3d2f628b5$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
const $5706f4e3d2f628b5$var$SimpleFormattedRelativeTime = (props)=>{
    const { formatRelativeTime: formatRelativeTime, textComponent: Text } = $5706f4e3d2f628b5$export$5aebe9a147f4d146();
    const { children: children, value: value, unit: unit, ...otherProps } = props;
    const formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === "function") return children(formattedRelativeTime);
    if (Text) return /* @__PURE__ */ (0, $ayMG0.jsx)(Text, {
        children: formattedRelativeTime
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: formattedRelativeTime
    });
};
const $5706f4e3d2f628b5$export$ee6d26cbbad7949f = ({ value: value = 0, unit: unit = "second", updateIntervalInSeconds: updateIntervalInSeconds, ...otherProps })=>{
    $5706f4e3d2f628b5$var$invariant(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $5706f4e3d2f628b5$var$canIncrement(unit)), "Cannot schedule update with unit longer than hour");
    const [prevUnit, setPrevUnit] = $acw62.useState();
    const [prevValue, setPrevValue] = $acw62.useState(0);
    const [currentValueInSeconds, setCurrentValueInSeconds] = $acw62.useState(0);
    const updateTimer = $acw62.useRef(void 0);
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($5706f4e3d2f628b5$var$canIncrement(unit) ? $5706f4e3d2f628b5$var$valueToSeconds(value, unit) : 0);
    }
    $acw62.useEffect(()=>{
        function clearUpdateTimer() {
            clearTimeout(updateTimer.current);
        }
        clearUpdateTimer();
        if (!updateIntervalInSeconds || !$5706f4e3d2f628b5$var$canIncrement(unit)) return clearUpdateTimer;
        const nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        const nextUnit = $5706f4e3d2f628b5$var$selectUnit(nextValueInSeconds);
        if (nextUnit === "day") return clearUpdateTimer;
        const unitDuration = $5706f4e3d2f628b5$var$getDurationInSeconds(nextUnit);
        const prevInterestingValueInSeconds = nextValueInSeconds - nextValueInSeconds % unitDuration;
        const nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        const delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer.current = setTimeout(()=>setCurrentValueInSeconds(nextInterestingValueInSeconds), delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    let currentValue = value || 0;
    let currentUnit = unit;
    if ($5706f4e3d2f628b5$var$canIncrement(unit) && typeof currentValueInSeconds === "number" && updateIntervalInSeconds) {
        currentUnit = $5706f4e3d2f628b5$var$selectUnit(currentValueInSeconds);
        const unitDuration = $5706f4e3d2f628b5$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return /* @__PURE__ */ (0, $ayMG0.jsx)($5706f4e3d2f628b5$var$SimpleFormattedRelativeTime, {
        value: currentValue,
        unit: currentUnit,
        ...otherProps
    });
};
$5706f4e3d2f628b5$export$ee6d26cbbad7949f.displayName = "FormattedRelativeTime";
//#endregion
//#region packages/react-intl/define-message.ts
function $5706f4e3d2f628b5$export$747d244ee58120dd(message, _options) {
    return message;
}
//#endregion
//#region packages/react-intl/index.ts
const $5706f4e3d2f628b5$export$40ae3194919d16b = $5706f4e3d2f628b5$var$createFormattedComponent("formatDate");
const $5706f4e3d2f628b5$export$5b390a54f8a846f7 = $5706f4e3d2f628b5$var$createFormattedComponent("formatTime");
const $5706f4e3d2f628b5$export$db80edc1e6b2f63d = $5706f4e3d2f628b5$var$createFormattedComponent("formatNumber");
const $5706f4e3d2f628b5$export$38bc7425a057e4fe = $5706f4e3d2f628b5$var$createFormattedComponent("formatDuration");
const $5706f4e3d2f628b5$export$f52b44e459e6e71d = $5706f4e3d2f628b5$var$createFormattedComponent("formatList");
const $5706f4e3d2f628b5$export$c2336ea5aaab92fa = $5706f4e3d2f628b5$var$createFormattedComponent("formatDisplayName");
const $5706f4e3d2f628b5$export$7fdc7d2c91ce149b = $5706f4e3d2f628b5$var$createFormattedDateTimePartsComponent("formatDate");
const $5706f4e3d2f628b5$export$ec35873761676c2a = $5706f4e3d2f628b5$var$createFormattedDateTimePartsComponent("formatTime");


/**
 * @param {string|RegExp} input The route pattern
 * @param {boolean} [loose] Allow open-ended matching. Ignored with `RegExp` input.
 */ function $8102e53aa00ee50e$export$98e6a39c04603d36(input, loose) {
    if (input instanceof RegExp) return {
        keys: false,
        pattern: input
    };
    var c, o, tmp, ext, keys = [], pattern = '', arr = input.split('/');
    arr[0] || arr.shift();
    while(tmp = arr.shift()){
        c = tmp[0];
        if (c === '*') {
            keys.push(c);
            pattern += tmp[1] === '?' ? '(?:/(.*))?' : '/(.*)';
        } else if (c === ':') {
            o = tmp.indexOf('?', 1);
            ext = tmp.indexOf('.', 1);
            keys.push(tmp.substring(1, !!~o ? o : !!~ext ? ext : tmp.length));
            pattern += !!~o && !~ext ? '(?:/([^/]+?))?' : '/([^/]+?)';
            if (!!~ext) pattern += (!!~o ? '?' : '') + '\\' + tmp.substring(ext);
        } else pattern += '/' + tmp;
    }
    return {
        keys: keys,
        pattern: new RegExp('^' + pattern + (loose ? '(?=$|\/)' : '\/?$'), 'i')
    };
}
var $8102e53aa00ee50e$var$RGX = /(\/|^)([:*][^/]*?)(\?)?(?=[/.]|$)/g;
function $8102e53aa00ee50e$export$a976684a0efeb93f(route, values) {
    return route.replace($8102e53aa00ee50e$var$RGX, (x, lead, key, optional)=>{
        x = values[key == '*' ? key : key.substring(1)];
        return x ? '/' + x : optional || key == '*' ? '' : '/' + key;
    });
}



var $acw62 = parcelRequire("acw62");
var $c8e45c4daa4b95cb$exports = {};
'use strict';

$c8e45c4daa4b95cb$exports = (parcelRequire("hkKGc"));




// React.useInsertionEffect is not available in React <18
// This hack fixes a transpilation issue on some apps
const $815a033f88c08201$var$useBuiltinInsertionEffect = $acw62.useInsertionEffect;
// Copied from:
// https://github.com/facebook/react/blob/main/packages/shared/ExecutionEnvironment.js
const $815a033f88c08201$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $815a033f88c08201$export$700979bc83e7db82 = $815a033f88c08201$var$canUseDOM ? $acw62.useLayoutEffect : $acw62.useEffect;
const $815a033f88c08201$export$aaabe4eda9ed9969 = $815a033f88c08201$var$useBuiltinInsertionEffect || $815a033f88c08201$export$700979bc83e7db82;
const $815a033f88c08201$export$90fc3a17d93f704c = (fn)=>{
    const ref = $acw62.useRef([
        fn,
        (...args)=>ref[0](...args)
    ]).current;
    // Per Dan Abramov: useInsertionEffect executes marginally closer to the
    // correct timing for ref synchronization than useLayoutEffect on React 18.
    // See: https://github.com/facebook/react/pull/25881#issuecomment-1356244360
    $815a033f88c08201$export$aaabe4eda9ed9969(()=>{
        ref[0] = fn;
    });
    return ref[1];
};


/**
 * History API docs @see https://developer.mozilla.org/en-US/docs/Web/API/History
 */ const $b7942ce58dbdb471$var$eventPopstate = "popstate";
const $b7942ce58dbdb471$var$eventPushState = "pushState";
const $b7942ce58dbdb471$var$eventReplaceState = "replaceState";
const $b7942ce58dbdb471$var$eventHashchange = "hashchange";
const $b7942ce58dbdb471$var$events = [
    $b7942ce58dbdb471$var$eventPopstate,
    $b7942ce58dbdb471$var$eventPushState,
    $b7942ce58dbdb471$var$eventReplaceState,
    $b7942ce58dbdb471$var$eventHashchange
];
const $b7942ce58dbdb471$var$subscribeToLocationUpdates = (callback)=>{
    for (const event of $b7942ce58dbdb471$var$events)addEventListener(event, callback);
    return ()=>{
        for (const event of $b7942ce58dbdb471$var$events)removeEventListener(event, callback);
    };
};
const $b7942ce58dbdb471$export$3a1ff78c39f8a86 = (fn, ssrFn)=>(0, $c8e45c4daa4b95cb$exports.useSyncExternalStore)($b7942ce58dbdb471$var$subscribeToLocationUpdates, fn, ssrFn);
const $b7942ce58dbdb471$var$currentSearch = ()=>location.search;
const $b7942ce58dbdb471$export$bd221a7c56b93941 = ({ ssrSearch: ssrSearch } = {})=>$b7942ce58dbdb471$export$3a1ff78c39f8a86($b7942ce58dbdb471$var$currentSearch, // != null checks for both null and undefined, but allows empty string ""
    // This allows proper hydration: server renders with ssrSearch="?foo",
    // client hydrates with just <Router /> and reads from location.search
    ssrSearch != null ? ()=>ssrSearch : $b7942ce58dbdb471$var$currentSearch);
const $b7942ce58dbdb471$var$currentPathname = ()=>location.pathname;
const $b7942ce58dbdb471$export$2a28ef6a9fe822a4 = ({ ssrPath: ssrPath } = {})=>$b7942ce58dbdb471$export$3a1ff78c39f8a86($b7942ce58dbdb471$var$currentPathname, // != null checks for both null and undefined, but allows empty string ""
    // This allows proper hydration: server renders with ssrPath="/foo",
    // client hydrates with just <Router /> and reads from location.pathname
    ssrPath != null ? ()=>ssrPath : $b7942ce58dbdb471$var$currentPathname);
const $b7942ce58dbdb471$var$currentHistoryState = ()=>history.state;
const $b7942ce58dbdb471$export$3ba9310fb9209e7f = ()=>$b7942ce58dbdb471$export$3a1ff78c39f8a86($b7942ce58dbdb471$var$currentHistoryState, ()=>null);
const $b7942ce58dbdb471$export$ff7962acd6052c28 = (to, { replace: replace = false, state: state = null } = {})=>history[replace ? $b7942ce58dbdb471$var$eventReplaceState : $b7942ce58dbdb471$var$eventPushState](state, "", to);
const $b7942ce58dbdb471$export$29c60f5332583 = (opts = {})=>[
        $b7942ce58dbdb471$export$2a28ef6a9fe822a4(opts),
        $b7942ce58dbdb471$export$ff7962acd6052c28
    ];
const $b7942ce58dbdb471$var$patchKey = Symbol.for("wouter_v3");
// While History API does have `popstate` event, the only
// proper way to listen to changes via `push/replaceState`
// is to monkey-patch these methods.
//
// See https://stackoverflow.com/a/4585031
if (typeof history !== "undefined" && typeof window[$b7942ce58dbdb471$var$patchKey] === "undefined") {
    for (const type of [
        $b7942ce58dbdb471$var$eventPushState,
        $b7942ce58dbdb471$var$eventReplaceState
    ]){
        const original = history[type];
        // TODO: we should be using unstable_batchedUpdates to avoid multiple re-renders,
        // however that will require an additional peer dependency on react-dom.
        // See: https://github.com/reactwg/react-18/discussions/86#discussioncomment-1567149
        history[type] = function() {
            const result = original.apply(this, arguments);
            const event = new Event(type);
            event.arguments = arguments;
            dispatchEvent(event);
            return result;
        };
    }
    // patch history object only once
    // See: https://github.com/molefrog/wouter/issues/167
    Object.defineProperty(window, $b7942ce58dbdb471$var$patchKey, {
        value: true
    });
}



var $acw62 = parcelRequire("acw62");
/*
 * Transforms `path` into its relative `base` version
 * If base isn't part of the path provided returns absolute path e.g. `~/app`
 */ const $7e66f355470c13ad$var$_relativePath = (base, path)=>!path.toLowerCase().indexOf(base.toLowerCase()) ? path.slice(base.length) || "/" : "~" + path;
/**
 * When basepath is `undefined` or '/' it is ignored (we assume it's empty string)
 */ const $7e66f355470c13ad$var$baseDefaults = (base = "")=>base === "/" ? "" : base;
const $7e66f355470c13ad$export$f1dd14e03b54dad4 = (to, base)=>to[0] === "~" ? to.slice(1) : $7e66f355470c13ad$var$baseDefaults(base) + to;
const $7e66f355470c13ad$export$7413eea5ad243d4 = (base = "", path)=>$7e66f355470c13ad$var$_relativePath($7e66f355470c13ad$var$unescape($7e66f355470c13ad$var$baseDefaults(base)), $7e66f355470c13ad$var$unescape(path));
/*
 * Removes leading question mark
 */ const $7e66f355470c13ad$var$stripQm = (str)=>str[0] === "?" ? str.slice(1) : str;
/*
 * decodes escape sequences such as %20
 */ const $7e66f355470c13ad$var$unescape = (str)=>{
    try {
        return decodeURI(str);
    } catch (_e) {
        // fail-safe mode: if string can't be decoded do nothing
        return str;
    }
};
const $7e66f355470c13ad$export$79dec46ffa0fcc35 = (search)=>$7e66f355470c13ad$var$unescape($7e66f355470c13ad$var$stripQm(search));


/*
 * Router and router context. Router is a lightweight object that represents the current
 * routing options: how location is managed, base path etc.
 *
 * There is a default router present for most of the use cases, however it can be overridden
 * via the <Router /> component.
 */ const $9d251f10c54460c1$var$defaultRouter = {
    hook: (0, $b7942ce58dbdb471$export$29c60f5332583),
    searchHook: (0, $b7942ce58dbdb471$export$bd221a7c56b93941),
    parser: (0, $8102e53aa00ee50e$export$98e6a39c04603d36),
    base: "",
    // this option is used to override the current location during SSR
    ssrPath: undefined,
    ssrSearch: undefined,
    // optional context to track render state during SSR
    ssrContext: undefined,
    // customizes how `href` props are transformed for <Link />
    hrefs: (x)=>x,
    // wraps navigate calls, useful for view transitions
    aroundNav: (n, t, o)=>n(t, o)
};
const $9d251f10c54460c1$var$RouterCtx = (0, $acw62.createContext)($9d251f10c54460c1$var$defaultRouter);
const $9d251f10c54460c1$export$9a302a45f65d0572 = ()=>(0, $acw62.useContext)($9d251f10c54460c1$var$RouterCtx);
/**
 * Parameters context. Used by `useParams()` to get the
 * matched params from the innermost `Route` component.
 */ const $9d251f10c54460c1$var$Params0 = {}, $9d251f10c54460c1$var$ParamsCtx = (0, $acw62.createContext)($9d251f10c54460c1$var$Params0);
const $9d251f10c54460c1$export$99eaa27ddbbb95ef = ()=>(0, $acw62.useContext)($9d251f10c54460c1$var$ParamsCtx);
/*
 * Part 1, Hooks API: useRoute and useLocation
 */ // Internal version of useLocation to avoid redundant useRouter calls
const $9d251f10c54460c1$var$useLocationFromRouter = (router)=>{
    const [location, navigate] = router.hook(router);
    // the function reference should stay the same between re-renders, so that
    // it can be passed down as an element prop without any performance concerns.
    // (This is achieved via `useEvent`.)
    return [
        (0, $7e66f355470c13ad$export$7413eea5ad243d4)(router.base, location),
        (0, $815a033f88c08201$export$90fc3a17d93f704c)((to, opts)=>router.aroundNav(navigate, (0, $7e66f355470c13ad$export$f1dd14e03b54dad4)(to, router.base), opts))
    ];
};
const $9d251f10c54460c1$export$45d76561a5302f2b = ()=>$9d251f10c54460c1$var$useLocationFromRouter($9d251f10c54460c1$export$9a302a45f65d0572());
const $9d251f10c54460c1$export$bd221a7c56b93941 = ()=>{
    const router = $9d251f10c54460c1$export$9a302a45f65d0572();
    return (0, $7e66f355470c13ad$export$79dec46ffa0fcc35)(router.searchHook(router));
};
const $9d251f10c54460c1$export$b4ee0d6794375c82 = (parser, route, path, loose)=>{
    // if the input is a regexp, skip parsing
    const { pattern: pattern, keys: keys } = route instanceof RegExp ? {
        keys: false,
        pattern: route
    } : parser(route || "*", loose);
    // array destructuring loses keys, so this is done in two steps
    const result = pattern.exec(path) || [];
    // when parser is in "loose" mode, `$base` is equal to the
    // first part of the route that matches the pattern
    // (e.g. for pattern `/a/:b` and path `/a/1/2/3` the `$base` is `a/1`)
    // we use this for route nesting
    const [$base, ...matches] = result;
    return $base !== undefined ? [
        true,
        (()=>{
            // for regex paths, `keys` will always be false
            // an object with parameters matched, e.g. { foo: "bar" } for "/:foo"
            // we "zip" two arrays here to construct the object
            // ["foo"], ["bar"] → { foo: "bar" }
            const groups = keys !== false ? Object.fromEntries(keys.map((key, i)=>[
                    key,
                    matches[i]
                ])) : result.groups;
            // convert the array to an instance of object
            // this makes it easier to integrate with the existing param implementation
            let obj = {
                ...matches
            };
            // merge named capture groups with matches array
            groups && Object.assign(obj, groups);
            return obj;
        })(),
        // the third value if only present when parser is in "loose" mode,
        // so that we can extract the base path for nested routes
        ...loose ? [
            $base
        ] : []
    ] : [
        false,
        null
    ];
};
const $9d251f10c54460c1$export$3f79f0b98112cf57 = (pattern)=>$9d251f10c54460c1$export$b4ee0d6794375c82($9d251f10c54460c1$export$9a302a45f65d0572().parser, pattern, $9d251f10c54460c1$export$45d76561a5302f2b()[0]);
const $9d251f10c54460c1$export$55185c17a0fcbe46 = ({ children: children, ...props })=>{
    // the router we will inherit from - it is the closest router in the tree,
    // unless the custom `hook` is provided (in that case it's the default one)
    const parent_ = $9d251f10c54460c1$export$9a302a45f65d0572();
    const parent = props.hook ? $9d251f10c54460c1$var$defaultRouter : parent_;
    // holds to the context value: the router object
    let value = parent;
    // when `ssrPath` contains a `?` character, we can extract the search from it.
    // also, ensure ssrSearch is always defined when ssrPath is provided, so that
    // useSearch behavior matches usePathname (proper SSR hydration when client
    // renders <Router> without props after server rendered with ssrPath/ssrSearch)
    const [path, search = props.ssrSearch ?? ""] = props.ssrPath?.split("?") ?? [];
    if (path) props.ssrSearch = search, props.ssrPath = path;
    // hooks can define their own `href` formatter (e.g. for hash location)
    props.hrefs = props.hrefs ?? props.hook?.hrefs;
    // hooks can define their own search hook (e.g. for memory location)
    props.searchHook = props.searchHook ?? props.hook?.searchHook;
    // what is happening below: to avoid unnecessary rerenders in child components,
    // we ensure that the router object reference is stable, unless there are any
    // changes that require reload (e.g. `base` prop changes -> all components that
    // get the router from the context should rerender, even if the component is memoized).
    // the expected behaviour is:
    //
    //   1) when the resulted router is no different from the parent, use parent
    //   2) if the custom `hook` prop is provided, we always inherit from the
    //      default router instead. this resets all previously overridden options.
    //   3) when the router is customized here, it should stay stable between renders
    let ref = (0, $acw62.useRef)({}), prev = ref.current, next = prev;
    for(let k in parent){
        const option = k === "base" ? /* base is special case, it is appended to the parent's base */ parent[k] + (props[k] ?? "") : props[k] ?? parent[k];
        if (prev === next && option !== next[k]) ref.current = next = {
            ...next
        };
        next[k] = option;
        // the new router is no different from the parent or from the memoized value, use parent
        if (option !== parent[k] || option !== value[k]) value = next;
    }
    return (0, $acw62.createElement)($9d251f10c54460c1$var$RouterCtx.Provider, {
        value: value,
        children: children
    });
};
const $9d251f10c54460c1$var$h_route = ({ children: children, component: component }, params)=>{
    // React-Router style `component` prop
    if (component) return (0, $acw62.createElement)(component, {
        params: params
    });
    // support render prop or plain children
    return typeof children === "function" ? children(params) : children;
};
// Cache params object between renders if values are shallow equal
const $9d251f10c54460c1$var$useCachedParams = (value)=>{
    let prev = (0, $acw62.useRef)($9d251f10c54460c1$var$Params0);
    const curr = prev.current;
    return prev.current = // Update cache if number of params changed or any value changed
    Object.keys(value).length !== Object.keys(curr).length || Object.entries(value).some(([k, v])=>v !== curr[k]) ? value // Return new value if there are changes
     : curr; // Return cached value if nothing changed
};
function $9d251f10c54460c1$export$f1a78c17382fe22a() {
    const [location, navigate] = $9d251f10c54460c1$export$45d76561a5302f2b();
    const search = $9d251f10c54460c1$export$bd221a7c56b93941();
    const searchParams = (0, $acw62.useMemo)(()=>new URLSearchParams(search), [
        search
    ]);
    // cached value before next render, so you can call setSearchParams multiple times
    let tempSearchParams = searchParams;
    const setSearchParams = (0, $815a033f88c08201$export$90fc3a17d93f704c)((nextInit, options)=>{
        tempSearchParams = new URLSearchParams(typeof nextInit === "function" ? nextInit(tempSearchParams) : nextInit);
        navigate(location + (tempSearchParams.size ? "?" + tempSearchParams : ""), options);
    });
    return [
        searchParams,
        setSearchParams
    ];
}
const $9d251f10c54460c1$export$e7b0ac011bb776c6 = ({ path: path, nest: nest, match: match, ...renderProps })=>{
    const router = $9d251f10c54460c1$export$9a302a45f65d0572();
    const [location] = $9d251f10c54460c1$var$useLocationFromRouter(router);
    const [matches, routeParams, base] = // `match` is a special prop to give up control to the parent,
    // it is used by the `Switch` to avoid double matching
    match ?? $9d251f10c54460c1$export$b4ee0d6794375c82(router.parser, path, location, nest);
    // when `routeParams` is `null` (there was no match), the argument
    // below becomes {...null} = {}, see the Object Spread specs
    // https://tc39.es/proposal-object-rest-spread/#AbstractOperations-CopyDataProperties
    const params = $9d251f10c54460c1$var$useCachedParams({
        ...$9d251f10c54460c1$export$99eaa27ddbbb95ef(),
        ...routeParams
    });
    if (!matches) return null;
    const children = base ? (0, $acw62.createElement)($9d251f10c54460c1$export$55185c17a0fcbe46, {
        base: base
    }, $9d251f10c54460c1$var$h_route(renderProps, params)) : $9d251f10c54460c1$var$h_route(renderProps, params);
    return (0, $acw62.createElement)($9d251f10c54460c1$var$ParamsCtx.Provider, {
        value: params,
        children: children
    });
};
const $9d251f10c54460c1$export$a6c7ac8248d6e38a = (0, $acw62.forwardRef)((props, ref)=>{
    const router = $9d251f10c54460c1$export$9a302a45f65d0572();
    const [currentPath, navigate] = $9d251f10c54460c1$var$useLocationFromRouter(router);
    const { to: to = "", href: targetPath = to, onClick: _onClick, asChild: asChild, children: children, className: cls, replace: /* eslint-disable no-unused-vars */ replace /* ignore nav props */ , state: state /* ignore nav props */ , transition: transition /* ignore nav props */ , /* eslint-enable no-unused-vars */ ...restProps } = props;
    const onClick = (0, $815a033f88c08201$export$90fc3a17d93f704c)((event)=>{
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) return;
        _onClick?.(event);
        if (!event.defaultPrevented) {
            event.preventDefault();
            navigate(targetPath, props);
        }
    });
    // handle nested routers and absolute paths
    const href = router.hrefs(targetPath[0] === "~" ? targetPath.slice(1) : router.base + targetPath, router // pass router as a second argument for convinience
    );
    return asChild && (0, $acw62.isValidElement)(children) ? (0, $acw62.cloneElement)(children, {
        onClick: onClick,
        href: href
    }) : (0, $acw62.createElement)("a", {
        ...restProps,
        onClick: onClick,
        href: href,
        // `className` can be a function to apply the class if this link is active
        className: cls?.call ? cls(currentPath === targetPath) : cls,
        children: children,
        ref: ref
    });
});
const $9d251f10c54460c1$var$flattenChildren = (children)=>Array.isArray(children) ? children.flatMap((c)=>$9d251f10c54460c1$var$flattenChildren(c && c.type === (0, $acw62.Fragment) ? c.props.children : c)) : [
        children
    ];
const $9d251f10c54460c1$export$b5d5cf8927ab7262 = ({ children: children, location: location })=>{
    const router = $9d251f10c54460c1$export$9a302a45f65d0572();
    const [originalLocation] = $9d251f10c54460c1$var$useLocationFromRouter(router);
    for (const element of $9d251f10c54460c1$var$flattenChildren(children)){
        let match = 0;
        if ((0, $acw62.isValidElement)(element) && // we don't require an element to be of type Route,
        // but we do require it to contain a truthy `path` prop.
        // this allows to use different components that wrap Route
        // inside of a switch, for example <AnimatedRoute />.
        (match = $9d251f10c54460c1$export$b4ee0d6794375c82(router.parser, element.props.path, location || originalLocation, element.props.nest))[0]) return (0, $acw62.cloneElement)(element, {
            match: match
        });
    }
    return null;
};
const $9d251f10c54460c1$export$2d8d895a0a0f636e = (props)=>{
    const { to: to, href: href = to } = props;
    const router = $9d251f10c54460c1$export$9a302a45f65d0572();
    const [, navigate] = $9d251f10c54460c1$var$useLocationFromRouter(router);
    const redirect = (0, $815a033f88c08201$export$90fc3a17d93f704c)(()=>navigate(to || href, props));
    const { ssrContext: ssrContext } = router;
    // redirect is guaranteed to be stable since it is returned from useEvent
    (0, $815a033f88c08201$export$700979bc83e7db82)(()=>{
        redirect();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    if (ssrContext) ssrContext.redirectTo = to;
    return null;
};


var $019ad789c5f8c324$exports = {};
"use strict";

var $3pEGv = parcelRequire("3pEGv");
var $019ad789c5f8c324$require$_interopRequireWildcard = $3pEGv.default;

var $1jnue = parcelRequire("1jnue");
var $019ad789c5f8c324$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($019ad789c5f8c324$exports, "__esModule", {
    value: true
});
var $019ad789c5f8c324$var$_exportNames = {
    experimental_sx: true,
    THEME_ID: true,
    adaptV4Theme: true,
    hexToRgb: true,
    rgbToHex: true,
    hslToRgb: true,
    decomposeColor: true,
    recomposeColor: true,
    getContrastRatio: true,
    getLuminance: true,
    emphasize: true,
    alpha: true,
    darken: true,
    lighten: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    unstable_createBreakpoints: true,
    createTheme: true,
    enhanceHighContrast: true,
    unstable_createMuiStrictModeTheme: true,
    createStyles: true,
    unstable_getUnit: true,
    unstable_toUnitless: true,
    responsiveFontSizes: true,
    createTransitions: true,
    duration: true,
    easing: true,
    createColorScheme: true,
    useTheme: true,
    useThemeProps: true,
    styled: true,
    ThemeProvider: true,
    makeStyles: true,
    withStyles: true,
    withTheme: true,
    extendTheme: true,
    experimental_extendTheme: true,
    getOverlayAlpha: true,
    shouldSkipGeneratingVar: true,
    private_createTypography: true,
    private_createMixins: true,
    private_excludeVariablesFromRoot: true,
    private_applyInsetFocusVisible: true,
    private_applyChildrenFocusVisible: true,
    private_outsetFocusRing: true
};
Object.defineProperty($019ad789c5f8c324$exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $izOUK.StyledEngineProvider;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "THEME_ID", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_identifier.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_ThemeProvider.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "adaptV4Theme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_adaptV4Theme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "alpha", {
    enumerable: true,
    get: function() {
        return $izOUK.alpha;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "createColorScheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createColorScheme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "createStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createStyles.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTheme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "createTransitions", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "css", {
    enumerable: true,
    get: function() {
        return $izOUK.css;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "darken", {
    enumerable: true,
    get: function() {
        return $izOUK.darken;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "decomposeColor", {
    enumerable: true,
    get: function() {
        return $izOUK.decomposeColor;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "duration", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.duration;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "easing", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTransitions.easing;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "emphasize", {
    enumerable: true,
    get: function() {
        return $izOUK.emphasize;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "enhanceHighContrast", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_enhanceHighContrast.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "experimental_extendTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_experimental_extendTheme.default;
    }
});
$019ad789c5f8c324$exports.experimental_sx = $019ad789c5f8c324$var$experimental_sx;
Object.defineProperty($019ad789c5f8c324$exports, "extendTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createThemeWithVars.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "getContrastRatio", {
    enumerable: true,
    get: function() {
        return $izOUK.getContrastRatio;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "getLuminance", {
    enumerable: true,
    get: function() {
        return $izOUK.getLuminance;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "getOverlayAlpha", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_getOverlayAlpha.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "hexToRgb", {
    enumerable: true,
    get: function() {
        return $izOUK.hexToRgb;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "hslToRgb", {
    enumerable: true,
    get: function() {
        return $izOUK.hslToRgb;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $izOUK.keyframes;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "lighten", {
    enumerable: true,
    get: function() {
        return $izOUK.lighten;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "makeStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_makeStyles.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "private_applyChildrenFocusVisible", {
    enumerable: true,
    get: function() {
        return $5YF3H.applyChildrenFocusVisible;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "private_applyInsetFocusVisible", {
    enumerable: true,
    get: function() {
        return $5YF3H.applyInsetFocusVisible;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "private_createMixins", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createMixins.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "private_createTypography", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createTypography.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "private_excludeVariablesFromRoot", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_excludeVariablesFromRoot.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "private_outsetFocusRing", {
    enumerable: true,
    get: function() {
        return $5YF3H.outsetFocusRing;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "recomposeColor", {
    enumerable: true,
    get: function() {
        return $izOUK.recomposeColor;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "responsiveFontSizes", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_responsiveFontSizes.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "rgbToHex", {
    enumerable: true,
    get: function() {
        return $izOUK.rgbToHex;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "shouldSkipGeneratingVar", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_shouldSkipGeneratingVar.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "styled", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_styled.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $47898848065fef37$exports.unstable_createBreakpoints;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "unstable_createMuiStrictModeTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_createMuiStrictModeTheme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "unstable_getUnit", {
    enumerable: true,
    get: function() {
        return $18jQK.getUnit;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "unstable_toUnitless", {
    enumerable: true,
    get: function() {
        return $18jQK.toUnitless;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_useTheme.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_useThemeProps.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "withStyles", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_withStyles.default;
    }
});
Object.defineProperty($019ad789c5f8c324$exports, "withTheme", {
    enumerable: true,
    get: function() {
        return $019ad789c5f8c324$var$_withTheme.default;
    }
});

var $019ad789c5f8c324$var$_formatMuiErrorMessage = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("4Z6Nd")));

var $019ad789c5f8c324$var$_identifier = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("4jPsi")));

var $019ad789c5f8c324$var$_adaptV4Theme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("2baoW")));

var $izOUK = parcelRequire("izOUK");
var $47898848065fef37$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $47898848065fef37$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($47898848065fef37$exports, "__esModule", {
    value: true
});
Object.defineProperty($47898848065fef37$exports, "unstable_createBreakpoints", {
    enumerable: true,
    get: function() {
        return $47898848065fef37$var$_createBreakpoints.default;
    }
});

var $47898848065fef37$var$_createBreakpoints = $47898848065fef37$require$_interopRequireDefault((parcelRequire("hVW0x")));



var $019ad789c5f8c324$var$_createTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("ijOKP")));

var $019ad789c5f8c324$var$_enhanceHighContrast = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("5YvA3")));

var $019ad789c5f8c324$var$_createMuiStrictModeTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("5fr1m")));

var $019ad789c5f8c324$var$_createStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("22wy2")));

var $18jQK = parcelRequire("18jQK");

var $019ad789c5f8c324$var$_responsiveFontSizes = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("eoBMT")));

var $019ad789c5f8c324$var$_createTransitions = $019ad789c5f8c324$require$_interopRequireWildcard((parcelRequire("bmoVh")));

var $019ad789c5f8c324$var$_createColorScheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("2JzIB")));

var $019ad789c5f8c324$var$_useTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("14H9o")));

var $019ad789c5f8c324$var$_useThemeProps = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("6g9fa")));

var $019ad789c5f8c324$var$_styled = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("d8seH")));

var $019ad789c5f8c324$var$_ThemeProvider = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("gRp5N")));

var $019ad789c5f8c324$var$_makeStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("kLL7M")));

var $019ad789c5f8c324$var$_withStyles = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("7i0uy")));

var $019ad789c5f8c324$var$_withTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("lXubi")));

var $b0NgK = parcelRequire("b0NgK");
Object.keys($b0NgK).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($019ad789c5f8c324$var$_exportNames, key)) return;
    if (key in $019ad789c5f8c324$exports && $019ad789c5f8c324$exports[key] === $b0NgK[key]) return;
    Object.defineProperty($019ad789c5f8c324$exports, key, {
        enumerable: true,
        get: function() {
            return $b0NgK[key];
        }
    });
});

var $019ad789c5f8c324$var$_createThemeWithVars = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("eLI0w")));

var $019ad789c5f8c324$var$_experimental_extendTheme = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("dj1n2")));

var $019ad789c5f8c324$var$_getOverlayAlpha = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("35vyj")));

var $019ad789c5f8c324$var$_shouldSkipGeneratingVar = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("fPRn6")));

var $019ad789c5f8c324$var$_createTypography = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("d6q8u")));

var $019ad789c5f8c324$var$_createMixins = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("6plKN")));

var $019ad789c5f8c324$var$_excludeVariablesFromRoot = $019ad789c5f8c324$require$_interopRequireDefault((parcelRequire("kKEhy")));

var $5YF3H = parcelRequire("5YF3H");
// TODO: Remove this function in v6.
// eslint-disable-next-line @typescript-eslint/naming-convention
function $019ad789c5f8c324$var$experimental_sx() {
    throw new Error((0, $019ad789c5f8c324$var$_formatMuiErrorMessage.default)(19));
} // The legacy utilities from @mui/styles
 // These are just empty functions that throws when invoked
 // TODO: Remove in v7
 // Private methods for creating parts of the theme



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $a49246e4766729ca$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}



var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");



/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $5d0efb0e817a4762$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}



var $ivxDX = parcelRequire("ivxDX");
function $d5782db8dbe37409$export$2e2bcd8739ae039(object) {
    if (object == null) return true;
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}



var $acw62 = parcelRequire("acw62");

var $kD5jZ = parcelRequire("kD5jZ");
function $4fd70d36a8c127ef$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $4fd70d36a8c127ef$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || (0, $kD5jZ.isValidElementType)(source) || !$4fd70d36a8c127ef$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $4fd70d36a8c127ef$var$deepClone(source[key]);
    });
    return output;
}
function $4fd70d36a8c127ef$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($4fd70d36a8c127ef$export$53b83ca8eaab0383(target) && $4fd70d36a8c127ef$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key]) || (0, $kD5jZ.isValidElementType)(source[key])) output[key] = source[key];
        else if ($4fd70d36a8c127ef$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $4fd70d36a8c127ef$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $4fd70d36a8c127ef$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $4fd70d36a8c127ef$export$53b83ca8eaab0383(source[key]) ? $4fd70d36a8c127ef$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $4bb17f8aebf76219$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $9260d7f5fd8a7544$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $4bb17f8aebf76219$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}



var $kD5jZ = parcelRequire("kD5jZ");
function $52553b6c85fe9c55$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $52553b6c85fe9c55$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $52553b6c85fe9c55$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $52553b6c85fe9c55$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $52553b6c85fe9c55$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $kD5jZ.ForwardRef:
            return $52553b6c85fe9c55$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $kD5jZ.Memo:
            return $52553b6c85fe9c55$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}



// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $92b1e01ea7e8b25a$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
// Keep in sync with docs/src/pages/customization/breakpoints/breakpoints.md
// #host-reference
const $92b1e01ea7e8b25a$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $92b1e01ea7e8b25a$export$2e2bcd8739ae039(breakpoints) {
    const { values: values = {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $92b1e01ea7e8b25a$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    const mediaKeys = [];
    for(let i = 0; i < keys.length; i += 1)mediaKeys.push(up(keys[i]));
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        internal_mediaKeys: mediaKeys,
        ...other
    };
}


const $b0e3e687f8cb4e9e$var$MIN_WIDTH_PATTERN = /min-width:\s*([0-9.]+)/;
function $b0e3e687f8cb4e9e$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries || !$b0e3e687f8cb4e9e$var$hasContainerQuery(css)) return css;
    const keys = [];
    for(const key in css)if (key.startsWith('@container')) keys.push(key);
    keys.sort((a, b)=>{
        return +(a.match($b0e3e687f8cb4e9e$var$MIN_WIDTH_PATTERN)?.[1] || 0) - +(b.match($b0e3e687f8cb4e9e$var$MIN_WIDTH_PATTERN)?.[1] || 0);
    });
    const result = css;
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        const value = result[key];
        delete result[key];
        result[key] = value;
    }
    return result;
}
function $b0e3e687f8cb4e9e$var$hasContainerQuery(css) {
    for(const key in css){
        if (key.startsWith('@container')) return true;
    }
    return false;
}
function $b0e3e687f8cb4e9e$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $b0e3e687f8cb4e9e$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $b0e3e687f8cb4e9e$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $958e727134dbff12$var$shape = {
    borderRadius: 4
};
var $958e727134dbff12$export$2e2bcd8739ae039 = $958e727134dbff12$var$shape;





// Based on https://github.com/TehShrike/deepmerge
// Based on https://github.com/fastify/deepmerge
// MIT License
// Copyright (c) 2012 - 2022 James Halliday, Josh Duff, and other contributors of deepmerge
/* eslint-disable no-else-return */ /**
 * Assigns props from one object to another. Focused on performance, only normal objects with no
 * prototype are supported.
 */ function $8eb566a697282539$export$2e2bcd8739ae039(target, source) {
    const sourceIsArray = Array.isArray(source);
    const targetIsArray = Array.isArray(target);
    if ($8eb566a697282539$var$isPrimitive(source)) return source;
    else if ($8eb566a697282539$var$isPrimitiveOrBuiltIn(target)) return $8eb566a697282539$var$clone(source);
    else if (sourceIsArray && targetIsArray) return $8eb566a697282539$var$mergeArray(target, source);
    else if (sourceIsArray !== targetIsArray) return $8eb566a697282539$var$clone(source);
    else return $8eb566a697282539$var$mergeObject(target, source);
}
function $8eb566a697282539$var$cloneArray(value) {
    let i = 0;
    const il = value.length;
    const result = new Array(il);
    for(i = 0; i < il; i += 1)result[i] = $8eb566a697282539$var$clone(value[i]);
    return result;
}
function $8eb566a697282539$var$cloneObject(target) {
    const result = {};
    for(const key in target){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        result[key] = $8eb566a697282539$var$clone(target[key]);
    }
    return result;
}
function $8eb566a697282539$var$mergeArray(target, source) {
    const tl = target.length;
    for(let i = 0; i < source.length; i += 1)target[tl + i] = $8eb566a697282539$var$clone(source[i]);
    return target;
}
function $8eb566a697282539$var$isMergeableObject(value) {
    return typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
}
function $8eb566a697282539$var$isPrimitive(value) {
    return typeof value !== 'object' || value === null;
}
function $8eb566a697282539$var$isPrimitiveOrBuiltIn(value) {
    return typeof value !== 'object' || value === null || value instanceof RegExp || value instanceof Date;
}
function $8eb566a697282539$var$clone(entry) {
    // eslint-disable-next-line no-nested-ternary
    return $8eb566a697282539$var$isMergeableObject(entry) ? Array.isArray(entry) ? $8eb566a697282539$var$cloneArray(entry) : $8eb566a697282539$var$cloneObject(entry) : entry;
}
function $8eb566a697282539$var$mergeObject(target, source) {
    for(const key in source){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        if (key in target) target[key] = $8eb566a697282539$export$2e2bcd8739ae039(target[key], source[key]);
        else target[key] = $8eb566a697282539$var$clone(source[key]);
    }
    return target;
}




const $2ba4d33a1e70aeb2$var$options = {
    clone: false
};
function $2ba4d33a1e70aeb2$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(acc, item, $2ba4d33a1e70aeb2$var$options);
}
var $2ba4d33a1e70aeb2$export$2e2bcd8739ae039 = $2ba4d33a1e70aeb2$var$merge;




const $77f73e5275112b11$var$EMPTY_THEME = {};
const $77f73e5275112b11$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $77f73e5275112b11$export$666ad80b5007f835 = (0, $92b1e01ea7e8b25a$export$2e2bcd8739ae039)({
    values: $77f73e5275112b11$export$68c286be0e7e55b7
});
const $77f73e5275112b11$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $77f73e5275112b11$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $77f73e5275112b11$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const result = {};
    return $77f73e5275112b11$export$2aea645392b97e0b(result, props.theme, propValue, (mediaKey, value, initialKey)=>{
        const finalValue = styleFromPropValue(value, initialKey);
        if (mediaKey) result[mediaKey] = finalValue;
        else (0, $8eb566a697282539$export$2e2bcd8739ae039)(result, finalValue);
    });
}
function $77f73e5275112b11$export$2aea645392b97e0b(target, theme, propValue, callback) {
    theme ??= $77f73e5275112b11$var$EMPTY_THEME;
    if (Array.isArray(propValue)) {
        const breakpoints = theme.breakpoints ?? $77f73e5275112b11$export$666ad80b5007f835;
        for(let i = 0; i < propValue.length; i += 1)$77f73e5275112b11$var$buildBreakpoint(target, breakpoints.up(breakpoints.keys[i]), propValue[i], undefined, callback);
        return target;
    }
    if (typeof propValue === 'object') {
        const breakpoints = theme.breakpoints ?? $77f73e5275112b11$export$666ad80b5007f835;
        const breakpointValues = breakpoints.values ?? $77f73e5275112b11$export$68c286be0e7e55b7;
        for(const key in propValue){
            if ((0, $b0e3e687f8cb4e9e$export$77c7c3e357f440e7)(breakpoints.keys, key)) {
                const containerKey = (0, $b0e3e687f8cb4e9e$export$10a9745dfa00d15)(theme.containerQueries ? theme : $77f73e5275112b11$var$defaultContainerQueries, key);
                if (containerKey) $77f73e5275112b11$var$buildBreakpoint(target, containerKey, propValue[key], key, callback);
            } else if (key in breakpointValues) {
                const mediaKey = breakpoints.up(key);
                $77f73e5275112b11$var$buildBreakpoint(target, mediaKey, propValue[key], key, callback);
            } else {
                const cssKey = key;
                target[cssKey] = propValue[cssKey];
            }
        }
        return target;
    }
    callback(undefined, propValue);
    return target;
}
function $77f73e5275112b11$var$buildBreakpoint(target, mediaKey, value, initialKey, callback) {
    target[mediaKey] ??= {};
    callback(mediaKey, value, initialKey);
}
function $77f73e5275112b11$var$setupBreakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $77f73e5275112b11$export$666ad80b5007f835;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $2ba4d33a1e70aeb2$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $77f73e5275112b11$export$1f2600516e91381f(breakpoints = $77f73e5275112b11$export$666ad80b5007f835) {
    const { internal_mediaKeys: mediaKeys } = breakpoints;
    const result = {};
    for(let i = 0; i < mediaKeys.length; i += 1)result[mediaKeys[i]] = {};
    return result;
}
function $77f73e5275112b11$export$8922c90b6e020726(breakpoints, style) {
    const breakpointKeys = breakpoints.internal_mediaKeys;
    for(let i = 0; i < breakpointKeys.length; i += 1){
        const key = breakpointKeys[i];
        if ((0, $d5782db8dbe37409$export$2e2bcd8739ae039)(style[key])) delete style[key];
    }
    return style;
}
function $77f73e5275112b11$export$b89a003a1e05c0ee(breakpoints, ...styles) {
    const emptyBreakpoints = $77f73e5275112b11$export$1f2600516e91381f(breakpoints);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(prev, next), {});
    return $77f73e5275112b11$export$8922c90b6e020726(breakpoints, mergedOutput);
}
function $77f73e5275112b11$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $77f73e5275112b11$export$980e6a259d807490(options) {
    const { values: breakpointValues, breakpoints: themeBreakpoints, base: customBase } = options;
    const base = customBase || $77f73e5275112b11$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object' && breakpointValues) {
            const bv = breakpointValues;
            acc[breakpoint] = bv[breakpoint] != null ? bv[breakpoint] : bv[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
function $77f73e5275112b11$export$c29c12f694bb7a2f(breakpoints, value) {
    if (Array.isArray(value)) return true;
    if (typeof value === 'object' && value !== null) {
        for(let i = 0; i < breakpoints.keys.length; i += 1){
            if (breakpoints.keys[i] in value) return true;
        }
        const valueKeys = Object.keys(value);
        for(let i = 0; i < valueKeys.length; i += 1){
            if ((0, $b0e3e687f8cb4e9e$export$77c7c3e357f440e7)(breakpoints.keys, valueKeys[i])) return true;
        }
    }
    return false;
}
var $77f73e5275112b11$export$2e2bcd8739ae039 = $77f73e5275112b11$var$setupBreakpoints;





function $ad93e753bd4b4788$export$741ad47189a64aa0(themeMapping, transform, valueFinal, userValue = valueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(valueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[valueFinal] || userValue;
    else if (typeof valueFinal === 'string') value = $ad93e753bd4b4788$export$2aa3fd96c49a84a8(themeMapping, valueFinal) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $ad93e753bd4b4788$export$245e5a5849651da5(themeMapping, transform, userValue, alternateProp) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(userValue);
    else if (Array.isArray(themeMapping)) value = themeMapping[userValue] || userValue;
    else if (typeof userValue === 'string') value = $ad93e753bd4b4788$export$2aa3fd96c49a84a8(themeMapping, userValue, true, alternateProp) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $ad93e753bd4b4788$export$2aa3fd96c49a84a8(obj, pathInput, checkVars = true, alternateProp) {
    if (!obj || !pathInput) return null;
    const path = pathInput.split('.');
    // Check if CSS variables are used
    if (obj.vars && checkVars) {
        const val = $ad93e753bd4b4788$var$getPathImpl(obj.vars, path, alternateProp);
        if (val != null) return val;
    }
    return $ad93e753bd4b4788$var$getPathImpl(obj, path, alternateProp);
}
function $ad93e753bd4b4788$var$getPathImpl(object, path, alternateProp) {
    let lastResult = undefined;
    let result = object;
    let index = 0;
    while(index < path.length){
        if (result === null || result === undefined) return result;
        lastResult = result;
        result = result[path[index]];
        index += 1;
    }
    if (alternateProp && result === undefined) {
        const lastKey = path[path.length - 1];
        const alternateKey = `${alternateProp}${lastKey === 'default' ? '' : (0, $9260d7f5fd8a7544$export$2e2bcd8739ae039)(lastKey)}`;
        return lastResult?.[alternateKey];
    }
    return result;
}
function $ad93e753bd4b4788$export$2e2bcd8739ae039(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $ad93e753bd4b4788$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (valueFinal)=>{
            const value = $ad93e753bd4b4788$export$245e5a5849651da5(themeMapping, transform, valueFinal, prop);
            return cssProperty === false ? value : {
                [cssProperty]: value
            };
        };
        return (0, $77f73e5275112b11$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}


/* eslint-disable guard-for-in */ const $5029271411efa0d8$var$EMPTY_THEME = {
    internal_cache: {}
};
const $5029271411efa0d8$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $5029271411efa0d8$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $5029271411efa0d8$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
const $5029271411efa0d8$var$CSS_PROPERTIES = {};
for(const key in $5029271411efa0d8$var$properties)$5029271411efa0d8$var$CSS_PROPERTIES[key] = [
    $5029271411efa0d8$var$properties[key]
];
for(const keyProperty in $5029271411efa0d8$var$properties)for(const keyDirection in $5029271411efa0d8$var$directions){
    const property = $5029271411efa0d8$var$properties[keyProperty];
    const direction = $5029271411efa0d8$var$directions[keyDirection];
    const value = Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
    $5029271411efa0d8$var$CSS_PROPERTIES[keyProperty + keyDirection] = value;
}
for(const key in $5029271411efa0d8$var$aliases)$5029271411efa0d8$var$CSS_PROPERTIES[key] = $5029271411efa0d8$var$CSS_PROPERTIES[$5029271411efa0d8$var$aliases[key]];
const $5029271411efa0d8$export$aab52a0dde05ad8a = new Set([
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
]);
const $5029271411efa0d8$export$f8397d44f03ab6ad = new Set([
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
]);
const $5029271411efa0d8$var$spacingKeys = new Set([
    ...$5029271411efa0d8$export$aab52a0dde05ad8a,
    ...$5029271411efa0d8$export$f8397d44f03ab6ad
]);
function $5029271411efa0d8$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $ad93e753bd4b4788$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $5029271411efa0d8$export$1def6f833384e3d1(theme) {
    return $5029271411efa0d8$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $5029271411efa0d8$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
// Avoid allocations
const $5029271411efa0d8$var$container = [
    ''
];
function $5029271411efa0d8$var$style(props, keys) {
    const theme = props.theme ?? $5029271411efa0d8$var$EMPTY_THEME;
    const transformer = theme?.internal_cache?.unarySpacing ?? $5029271411efa0d8$export$1def6f833384e3d1(theme);
    const result = {};
    for(const prop in props){
        if (!keys.has(prop)) continue;
        const cssProperties = $5029271411efa0d8$var$CSS_PROPERTIES[prop] ?? ($5029271411efa0d8$var$container[0] = prop, $5029271411efa0d8$var$container);
        const propValue = props[prop];
        (0, $77f73e5275112b11$export$2aea645392b97e0b)(result, props.theme, propValue, (mediaKey, value)=>{
            const target = mediaKey ? result[mediaKey] : result;
            for(let i = 0; i < cssProperties.length; i += 1)target[cssProperties[i]] = $5029271411efa0d8$export$bf7199a9ebcb84a9(transformer, value);
        });
    }
    return result;
}
function $5029271411efa0d8$var$marginFn(props) {
    return $5029271411efa0d8$var$style(props, $5029271411efa0d8$export$aab52a0dde05ad8a);
}
$5029271411efa0d8$var$marginFn.propTypes = {};
$5029271411efa0d8$var$marginFn.filterProps = $5029271411efa0d8$export$aab52a0dde05ad8a;
const $5029271411efa0d8$export$7ede87f9b603dd3c = $5029271411efa0d8$var$marginFn;
function $5029271411efa0d8$var$paddingFn(props) {
    return $5029271411efa0d8$var$style(props, $5029271411efa0d8$export$f8397d44f03ab6ad);
}
$5029271411efa0d8$var$paddingFn.propTypes = {};
$5029271411efa0d8$var$paddingFn.filterProps = $5029271411efa0d8$export$f8397d44f03ab6ad;
const $5029271411efa0d8$export$6f98e8eaf0be1996 = $5029271411efa0d8$var$paddingFn;
function $5029271411efa0d8$var$spacingFn(props) {
    return $5029271411efa0d8$var$style(props, $5029271411efa0d8$var$spacingKeys);
}
$5029271411efa0d8$var$spacingFn.propTypes = {};
$5029271411efa0d8$var$spacingFn.filterProps = $5029271411efa0d8$var$spacingKeys;
const $5029271411efa0d8$var$spacing = $5029271411efa0d8$var$spacingFn;
var $5029271411efa0d8$export$2e2bcd8739ae039 = $5029271411efa0d8$var$spacing;


function $60ac6689598b7cf6$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $5029271411efa0d8$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}










function $0ad8325f496c3da5$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        const result = {};
        for(const prop in props)if (handlers[prop]) (0, $8eb566a697282539$export$2e2bcd8739ae039)(result, handlers[prop](props));
        return result;
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $0ad8325f496c3da5$export$2e2bcd8739ae039 = $0ad8325f496c3da5$var$compose;




function $47d0872025c96105$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $47d0872025c96105$var$createBorderStyle(prop, transform) {
    return (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $47d0872025c96105$export$1edee58a52776cd9 = $47d0872025c96105$var$createBorderStyle('border', $47d0872025c96105$export$34e2febe53ae29cc);
const $47d0872025c96105$export$f9a7b6bd24892946 = $47d0872025c96105$var$createBorderStyle('borderTop', $47d0872025c96105$export$34e2febe53ae29cc);
const $47d0872025c96105$export$5abca33e6be905d2 = $47d0872025c96105$var$createBorderStyle('borderRight', $47d0872025c96105$export$34e2febe53ae29cc);
const $47d0872025c96105$export$e2ce9f12a980a822 = $47d0872025c96105$var$createBorderStyle('borderBottom', $47d0872025c96105$export$34e2febe53ae29cc);
const $47d0872025c96105$export$47658cca1a909427 = $47d0872025c96105$var$createBorderStyle('borderLeft', $47d0872025c96105$export$34e2febe53ae29cc);
const $47d0872025c96105$export$e7fb0694ba2404fc = $47d0872025c96105$var$createBorderStyle('borderColor');
const $47d0872025c96105$export$126a92c968acdb85 = $47d0872025c96105$var$createBorderStyle('borderTopColor');
const $47d0872025c96105$export$85cc51cb8fbb8c0e = $47d0872025c96105$var$createBorderStyle('borderRightColor');
const $47d0872025c96105$export$340b0327727f6d1a = $47d0872025c96105$var$createBorderStyle('borderBottomColor');
const $47d0872025c96105$export$60beef91a985b4bf = $47d0872025c96105$var$createBorderStyle('borderLeftColor');
const $47d0872025c96105$export$f9258c55612cbed7 = $47d0872025c96105$var$createBorderStyle('outline', $47d0872025c96105$export$34e2febe53ae29cc);
const $47d0872025c96105$export$621fe586efeb64b9 = $47d0872025c96105$var$createBorderStyle('outlineColor');
const $47d0872025c96105$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $5029271411efa0d8$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $5029271411efa0d8$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $77f73e5275112b11$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$47d0872025c96105$export$7a57f79000377ca2.propTypes = {};
$47d0872025c96105$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $47d0872025c96105$var$borders = (0, $0ad8325f496c3da5$export$2e2bcd8739ae039)($47d0872025c96105$export$1edee58a52776cd9, $47d0872025c96105$export$f9a7b6bd24892946, $47d0872025c96105$export$5abca33e6be905d2, $47d0872025c96105$export$e2ce9f12a980a822, $47d0872025c96105$export$47658cca1a909427, $47d0872025c96105$export$e7fb0694ba2404fc, $47d0872025c96105$export$126a92c968acdb85, $47d0872025c96105$export$85cc51cb8fbb8c0e, $47d0872025c96105$export$340b0327727f6d1a, $47d0872025c96105$export$60beef91a985b4bf, $47d0872025c96105$export$7a57f79000377ca2, $47d0872025c96105$export$f9258c55612cbed7, $47d0872025c96105$export$621fe586efeb64b9);
var $47d0872025c96105$export$2e2bcd8739ae039 = $47d0872025c96105$var$borders;







const $8e44cc62e51f49c2$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $5029271411efa0d8$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $5029271411efa0d8$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $77f73e5275112b11$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$8e44cc62e51f49c2$export$5df9adcb0db95e1e.propTypes = {};
$8e44cc62e51f49c2$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $8e44cc62e51f49c2$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $5029271411efa0d8$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $5029271411efa0d8$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $77f73e5275112b11$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$8e44cc62e51f49c2$export$ec60d70ff941a580.propTypes = {};
$8e44cc62e51f49c2$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $8e44cc62e51f49c2$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $5029271411efa0d8$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $5029271411efa0d8$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $77f73e5275112b11$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$8e44cc62e51f49c2$export$8a833ffa5f5dbeda.propTypes = {};
$8e44cc62e51f49c2$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $8e44cc62e51f49c2$export$baf44164ca3a34e8 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $8e44cc62e51f49c2$export$8f7213a1cd01e832 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $8e44cc62e51f49c2$export$b0e0abbc49ba668 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $8e44cc62e51f49c2$export$bcd8b929d4b4142 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $8e44cc62e51f49c2$export$e5039a674e14c828 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $8e44cc62e51f49c2$export$42bd9088661ffb03 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $8e44cc62e51f49c2$export$920682ae05b999bc = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $8e44cc62e51f49c2$export$1b88fbdd482fd33a = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $8e44cc62e51f49c2$export$bdb486e40d52d26f = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $8e44cc62e51f49c2$var$grid = (0, $0ad8325f496c3da5$export$2e2bcd8739ae039)($8e44cc62e51f49c2$export$5df9adcb0db95e1e, $8e44cc62e51f49c2$export$ec60d70ff941a580, $8e44cc62e51f49c2$export$8a833ffa5f5dbeda, $8e44cc62e51f49c2$export$baf44164ca3a34e8, $8e44cc62e51f49c2$export$8f7213a1cd01e832, $8e44cc62e51f49c2$export$b0e0abbc49ba668, $8e44cc62e51f49c2$export$bcd8b929d4b4142, $8e44cc62e51f49c2$export$e5039a674e14c828, $8e44cc62e51f49c2$export$42bd9088661ffb03, $8e44cc62e51f49c2$export$920682ae05b999bc, $8e44cc62e51f49c2$export$1b88fbdd482fd33a, $8e44cc62e51f49c2$export$bdb486e40d52d26f);
var $8e44cc62e51f49c2$export$2e2bcd8739ae039 = $8e44cc62e51f49c2$var$grid;




function $b334b350bcac7cad$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $b334b350bcac7cad$export$35e9368ef982300f = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $b334b350bcac7cad$export$dbaffd4420ea0ac6
});
const $b334b350bcac7cad$export$2506f56c10355b33 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $b334b350bcac7cad$export$dbaffd4420ea0ac6
});
const $b334b350bcac7cad$export$8c5a050822fd698c = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $b334b350bcac7cad$export$dbaffd4420ea0ac6
});
const $b334b350bcac7cad$var$palette = (0, $0ad8325f496c3da5$export$2e2bcd8739ae039)($b334b350bcac7cad$export$35e9368ef982300f, $b334b350bcac7cad$export$2506f56c10355b33, $b334b350bcac7cad$export$8c5a050822fd698c);
var $b334b350bcac7cad$export$2e2bcd8739ae039 = $b334b350bcac7cad$var$palette;





const $ca533d511cd53a8d$var$breakpointsValues = $77f73e5275112b11$export$68c286be0e7e55b7;
function $ca533d511cd53a8d$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $ca533d511cd53a8d$export$7e3df82ee760448c = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $ca533d511cd53a8d$export$8afece71750ec241
});
const $ca533d511cd53a8d$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $ca533d511cd53a8d$var$breakpointsValues[propValue];
            if (!breakpoint) return {
                maxWidth: $ca533d511cd53a8d$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $77f73e5275112b11$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$ca533d511cd53a8d$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $ca533d511cd53a8d$export$ee148fbbe8357dd2 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $ca533d511cd53a8d$export$8afece71750ec241
});
const $ca533d511cd53a8d$export$ac607276a8fe9f0a = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $ca533d511cd53a8d$export$8afece71750ec241
});
const $ca533d511cd53a8d$export$dc0d8bd0b94f8570 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $ca533d511cd53a8d$export$8afece71750ec241
});
const $ca533d511cd53a8d$export$a43cf604e12f3b17 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $ca533d511cd53a8d$export$8afece71750ec241
});
const $ca533d511cd53a8d$export$ffed9f14fb65e276 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $ca533d511cd53a8d$export$8afece71750ec241
});
const $ca533d511cd53a8d$export$905076ed6620e671 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $ca533d511cd53a8d$export$8afece71750ec241
});
const $ca533d511cd53a8d$export$6ccc93f785106a58 = (0, $ad93e753bd4b4788$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $ca533d511cd53a8d$var$sizing = (0, $0ad8325f496c3da5$export$2e2bcd8739ae039)($ca533d511cd53a8d$export$7e3df82ee760448c, $ca533d511cd53a8d$export$488fda99655ff65a, $ca533d511cd53a8d$export$ee148fbbe8357dd2, $ca533d511cd53a8d$export$ac607276a8fe9f0a, $ca533d511cd53a8d$export$dc0d8bd0b94f8570, $ca533d511cd53a8d$export$a43cf604e12f3b17, $ca533d511cd53a8d$export$6ccc93f785106a58);
var $ca533d511cd53a8d$export$2e2bcd8739ae039 = $ca533d511cd53a8d$var$sizing;


const $6687bde540046118$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $47d0872025c96105$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $47d0872025c96105$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $47d0872025c96105$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $47d0872025c96105$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $47d0872025c96105$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $47d0872025c96105$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $47d0872025c96105$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $b334b350bcac7cad$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $b334b350bcac7cad$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $b334b350bcac7cad$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $5029271411efa0d8$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $5029271411efa0d8$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $8e44cc62e51f49c2$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $8e44cc62e51f49c2$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $8e44cc62e51f49c2$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $ca533d511cd53a8d$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $ca533d511cd53a8d$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $ca533d511cd53a8d$export$8afece71750ec241)
    },
    height: {
        transform: (0, $ca533d511cd53a8d$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $ca533d511cd53a8d$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $ca533d511cd53a8d$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $6687bde540046118$export$2e2bcd8739ae039 = $6687bde540046118$var$defaultSxConfig;


/**
 * The `css` function accepts arrays as values for mobile-first responsive styles.
 * Note that this extends to non-theme values also. For example `display=['none', 'block']`
 * will also works.
 */ /**
 * Map of all CSS pseudo selectors (`:hover`, `:focus`, ...).
 */ /**
 * Map all nested selectors.
 */ /**
 * Map all nested selectors and CSS variables.
 */ /**
 * Map of all available CSS properties (including aliases) and their raw value.
 * Only used internally to map CSS properties to input types (responsive value,
 * theme function or nested) in `SystemCssProperties`.
 */ /**
 * The `SystemStyleObject` defines custom properties that will be transformed to
 * their corresponding values from the `Theme`. Other valid CSS properties are also allowed.
 */ /**
 * The `SxProps` can be either object or function
 */ /* eslint-disable guard-for-in */ const $bf68d42d16534d7c$var$EMPTY_THEME = {};
function $bf68d42d16534d7c$export$7d53d8bf2911e013() {
    function styleFunctionSx(props) {
        if (!props.sx) return null;
        const { sx: sx, theme: theme = $bf68d42d16534d7c$var$EMPTY_THEME, nested: nested } = props;
        const config = theme.unstable_sxConfig ?? (0, $6687bde540046118$export$2e2bcd8739ae039);
        // Pass argument without loop allocations
        const wrapper = {
            sx: null,
            theme: theme,
            nested: true
        };
        function process(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const breakpoints = theme.breakpoints ?? (0, $77f73e5275112b11$export$666ad80b5007f835);
            const css = (0, $77f73e5275112b11$export$1f2600516e91381f)(breakpoints);
            for(const styleKey in sxObject){
                const value = $bf68d42d16534d7c$var$callIfFn(sxObject[styleKey], theme);
                if (value === null || value === undefined) continue;
                if (typeof value !== 'object') {
                    $bf68d42d16534d7c$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if (config[styleKey]) {
                    $bf68d42d16534d7c$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if ((0, $77f73e5275112b11$export$c29c12f694bb7a2f)(breakpoints, value)) (0, $77f73e5275112b11$export$2aea645392b97e0b)(css, props.theme, value, (mediaKey, finalValue)=>{
                    css[mediaKey][styleKey] = finalValue;
                });
                else {
                    wrapper.sx = value;
                    css[styleKey] = styleFunctionSx(wrapper);
                }
            }
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $b0e3e687f8cb4e9e$export$456f6c1142f990db)(theme, (0, $77f73e5275112b11$export$8922c90b6e020726)(breakpoints, css))
            };
            return (0, $b0e3e687f8cb4e9e$export$456f6c1142f990db)(theme, (0, $77f73e5275112b11$export$8922c90b6e020726)(breakpoints, css));
        }
        return Array.isArray(sx) ? sx.map(process) : process(sx);
    }
    styleFunctionSx.filterProps = [
        'sx'
    ];
    return styleFunctionSx;
}
var $bf68d42d16534d7c$export$2e2bcd8739ae039 = $bf68d42d16534d7c$export$7d53d8bf2911e013();
function $bf68d42d16534d7c$var$setThemeValue(css, prop, value, theme, config) {
    const options = config[prop];
    if (!options) {
        css[prop] = value;
        return;
    }
    if (value == null) return;
    const { themeKey: themeKey } = options;
    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && value === 'inherit') {
        css[prop] = value;
        return;
    }
    const { style: style } = options;
    if (style) {
        (0, $8eb566a697282539$export$2e2bcd8739ae039)(css, style({
            [prop]: value,
            theme: theme
        }));
        return;
    }
    const { cssProperty: cssProperty = prop, transform: transform } = options;
    const themeMapping = (0, $ad93e753bd4b4788$export$2aa3fd96c49a84a8)(theme, themeKey);
    (0, $77f73e5275112b11$export$2aea645392b97e0b)(css, theme, value, (mediaKey, valueFinal)=>{
        const finalValue = (0, $ad93e753bd4b4788$export$245e5a5849651da5)(themeMapping, transform, valueFinal, prop);
        if (cssProperty === false) {
            if (mediaKey) (0, $8eb566a697282539$export$2e2bcd8739ae039)(css[mediaKey], finalValue);
            else (0, $8eb566a697282539$export$2e2bcd8739ae039)(css, finalValue);
        } else // eslint-disable-next-line no-lonely-if
        if (mediaKey) css[mediaKey][cssProperty] = finalValue;
        else css[cssProperty] = finalValue;
    });
}
function $bf68d42d16534d7c$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $10e6f288a1251fee$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $26ee599f1d3ba50c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $92b1e01ea7e8b25a$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $60ac6689598b7cf6$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $958e727134dbff12$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $b0e3e687f8cb4e9e$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $10e6f288a1251fee$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $6687bde540046118$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $bf68d42d16534d7c$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.internal_cache = {};
    return muiTheme;
}
var $26ee599f1d3ba50c$export$2e2bcd8739ae039 = $26ee599f1d3ba50c$var$createTheme;




var $ivxDX = parcelRequire("ivxDX");
function $a538cd4c7a7ac172$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $ivxDX.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $ivxDX.internal_serializeStyles)(variant.style);
    });
    return result;
}


const $feef0a6b75fad08f$export$35e57303dbd8a66 = (0, $26ee599f1d3ba50c$export$2e2bcd8739ae039)();
function $feef0a6b75fad08f$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $feef0a6b75fad08f$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $feef0a6b75fad08f$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $feef0a6b75fad08f$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = (0, $d5782db8dbe37409$export$2e2bcd8739ae039)(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $feef0a6b75fad08f$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$feef0a6b75fad08f$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $feef0a6b75fad08f$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $feef0a6b75fad08f$var$shallowLayer((0, $ivxDX.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $feef0a6b75fad08f$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $feef0a6b75fad08f$var$shallowLayer((0, $ivxDX.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $feef0a6b75fad08f$var$shallowLayer((0, $ivxDX.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $feef0a6b75fad08f$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $feef0a6b75fad08f$var$shallowLayer((0, $ivxDX.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $feef0a6b75fad08f$var$shallowLayer((0, $ivxDX.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $feef0a6b75fad08f$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $feef0a6b75fad08f$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $feef0a6b75fad08f$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $feef0a6b75fad08f$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $feef0a6b75fad08f$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $ivxDX.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $bf68d42d16534d7c$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $feef0a6b75fad08f$var$defaultOverridesResolver($feef0a6b75fad08f$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $feef0a6b75fad08f$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($feef0a6b75fad08f$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, (/*@__PURE__*/$parcel$interopDefault($ivxDX)))(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $feef0a6b75fad08f$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $feef0a6b75fad08f$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $4fd70d36a8c127ef$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $a538cd4c7a7ac172$export$2e2bcd8739ae039)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $feef0a6b75fad08f$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $feef0a6b75fad08f$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $feef0a6b75fad08f$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $feef0a6b75fad08f$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $bf68d42d16534d7c$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $feef0a6b75fad08f$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $9260d7f5fd8a7544$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $52553b6c85fe9c55$export$2e2bcd8739ae039)(tag)})`;
}
function $feef0a6b75fad08f$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $feef0a6b75fad08f$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $feef0a6b75fad08f$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}





function $344985873bee2738$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $344985873bee2738$export$2e2bcd8739ae039 = $344985873bee2738$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $3cec7b0dca18ba73$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $344985873bee2738$export$2e2bcd8739ae039)(value, min, max);
}
function $3cec7b0dca18ba73$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $3cec7b0dca18ba73$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $3cec7b0dca18ba73$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $3cec7b0dca18ba73$export$677b39864803984e($3cec7b0dca18ba73$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $4bb17f8aebf76219$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $4bb17f8aebf76219$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $3cec7b0dca18ba73$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $3cec7b0dca18ba73$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $3cec7b0dca18ba73$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $3cec7b0dca18ba73$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $3cec7b0dca18ba73$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $3cec7b0dca18ba73$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $3cec7b0dca18ba73$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$3cec7b0dca18ba73$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $3cec7b0dca18ba73$export$29fb7152bd3f781a(color) {
    color = $3cec7b0dca18ba73$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $3cec7b0dca18ba73$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $3cec7b0dca18ba73$export$c852d90bf7403b62(color) {
    color = $3cec7b0dca18ba73$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $3cec7b0dca18ba73$export$677b39864803984e($3cec7b0dca18ba73$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $3cec7b0dca18ba73$export$d061e26956a60b0a(foreground, background) {
    const lumA = $3cec7b0dca18ba73$export$c852d90bf7403b62(foreground);
    const lumB = $3cec7b0dca18ba73$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $3cec7b0dca18ba73$export$58f0f39f63f3cf42(color, value) {
    color = $3cec7b0dca18ba73$export$677b39864803984e(color);
    value = $3cec7b0dca18ba73$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $3cec7b0dca18ba73$export$211a73f2b8c10ce4(color);
}
function $3cec7b0dca18ba73$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $3cec7b0dca18ba73$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $3cec7b0dca18ba73$export$4b073707ff63303(color, coefficient) {
    color = $3cec7b0dca18ba73$export$677b39864803984e(color);
    coefficient = $3cec7b0dca18ba73$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $3cec7b0dca18ba73$export$211a73f2b8c10ce4(color);
}
function $3cec7b0dca18ba73$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $3cec7b0dca18ba73$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $3cec7b0dca18ba73$export$c0816ed86df316af(color, coefficient) {
    color = $3cec7b0dca18ba73$export$677b39864803984e(color);
    coefficient = $3cec7b0dca18ba73$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $3cec7b0dca18ba73$export$211a73f2b8c10ce4(color);
}
function $3cec7b0dca18ba73$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $3cec7b0dca18ba73$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $3cec7b0dca18ba73$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $3cec7b0dca18ba73$export$c852d90bf7403b62(color) > 0.5 ? $3cec7b0dca18ba73$export$4b073707ff63303(color, coefficient) : $3cec7b0dca18ba73$export$c0816ed86df316af(color, coefficient);
}
function $3cec7b0dca18ba73$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $3cec7b0dca18ba73$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $3cec7b0dca18ba73$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $3cec7b0dca18ba73$export$677b39864803984e(background);
    const overlayColor = $3cec7b0dca18ba73$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $3cec7b0dca18ba73$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


/**
 * ![common black](https://mui.com/static/colors-preview/common-black-24x24.png) ![common white](https://mui.com/static/colors-preview/common-white-24x24.png)
 */ const $310fddb5fc4b00ff$var$common = {
    /**
   * Preview: ![common black](https://mui.com/static/colors-preview/common-black-24x24.png)
   */ black: '#000',
    /**
   * Preview: ![common white](https://mui.com/static/colors-preview/common-white-24x24.png)
   */ white: '#fff'
};
var $310fddb5fc4b00ff$export$2e2bcd8739ae039 = $310fddb5fc4b00ff$var$common;


/**
 * ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png) ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png) ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png) ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png) ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png) ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png) ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png) ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png) ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png) ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png) ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png) ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png) ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png) ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
 */ const $afdf4f32e122a677$var$grey = {
    /**
   * Preview: ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png)
   */ 50: '#fafafa',
    /**
   * Preview: ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png)
   */ 100: '#f5f5f5',
    /**
   * Preview: ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png)
   */ 200: '#eeeeee',
    /**
   * Preview: ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png)
   */ 300: '#e0e0e0',
    /**
   * Preview: ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png)
   */ 400: '#bdbdbd',
    /**
   * Preview: ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png)
   */ 500: '#9e9e9e',
    /**
   * Preview: ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png)
   */ 600: '#757575',
    /**
   * Preview: ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png)
   */ 700: '#616161',
    /**
   * Preview: ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png)
   */ 800: '#424242',
    /**
   * Preview: ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png)
   */ 900: '#212121',
    /**
   * Preview: ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png)
   */ A100: '#f5f5f5',
    /**
   * Preview: ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png)
   */ A200: '#eeeeee',
    /**
   * Preview: ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png)
   */ A400: '#bdbdbd',
    /**
   * Preview: ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
   */ A700: '#616161'
};
var $afdf4f32e122a677$export$2e2bcd8739ae039 = $afdf4f32e122a677$var$grey;


/**
 * ![purple 50](https://mui.com/static/colors-preview/purple-50-24x24.png) ![purple 100](https://mui.com/static/colors-preview/purple-100-24x24.png) ![purple 200](https://mui.com/static/colors-preview/purple-200-24x24.png) ![purple 300](https://mui.com/static/colors-preview/purple-300-24x24.png) ![purple 400](https://mui.com/static/colors-preview/purple-400-24x24.png) ![purple 500](https://mui.com/static/colors-preview/purple-500-24x24.png) ![purple 600](https://mui.com/static/colors-preview/purple-600-24x24.png) ![purple 700](https://mui.com/static/colors-preview/purple-700-24x24.png) ![purple 800](https://mui.com/static/colors-preview/purple-800-24x24.png) ![purple 900](https://mui.com/static/colors-preview/purple-900-24x24.png) ![purple A100](https://mui.com/static/colors-preview/purple-A100-24x24.png) ![purple A200](https://mui.com/static/colors-preview/purple-A200-24x24.png) ![purple A400](https://mui.com/static/colors-preview/purple-A400-24x24.png) ![purple A700](https://mui.com/static/colors-preview/purple-A700-24x24.png)
 */ const $b5fcbddcbd877faf$var$purple = {
    /**
   * Preview: ![purple 50](https://mui.com/static/colors-preview/purple-50-24x24.png)
   */ 50: '#f3e5f5',
    /**
   * Preview: ![purple 100](https://mui.com/static/colors-preview/purple-100-24x24.png)
   */ 100: '#e1bee7',
    /**
   * Preview: ![purple 200](https://mui.com/static/colors-preview/purple-200-24x24.png)
   */ 200: '#ce93d8',
    /**
   * Preview: ![purple 300](https://mui.com/static/colors-preview/purple-300-24x24.png)
   */ 300: '#ba68c8',
    /**
   * Preview: ![purple 400](https://mui.com/static/colors-preview/purple-400-24x24.png)
   */ 400: '#ab47bc',
    /**
   * Preview: ![purple 500](https://mui.com/static/colors-preview/purple-500-24x24.png)
   */ 500: '#9c27b0',
    /**
   * Preview: ![purple 600](https://mui.com/static/colors-preview/purple-600-24x24.png)
   */ 600: '#8e24aa',
    /**
   * Preview: ![purple 700](https://mui.com/static/colors-preview/purple-700-24x24.png)
   */ 700: '#7b1fa2',
    /**
   * Preview: ![purple 800](https://mui.com/static/colors-preview/purple-800-24x24.png)
   */ 800: '#6a1b9a',
    /**
   * Preview: ![purple 900](https://mui.com/static/colors-preview/purple-900-24x24.png)
   */ 900: '#4a148c',
    /**
   * Preview: ![purple A100](https://mui.com/static/colors-preview/purple-A100-24x24.png)
   */ A100: '#ea80fc',
    /**
   * Preview: ![purple A200](https://mui.com/static/colors-preview/purple-A200-24x24.png)
   */ A200: '#e040fb',
    /**
   * Preview: ![purple A400](https://mui.com/static/colors-preview/purple-A400-24x24.png)
   */ A400: '#d500f9',
    /**
   * Preview: ![purple A700](https://mui.com/static/colors-preview/purple-A700-24x24.png)
   */ A700: '#aa00ff'
};
var $b5fcbddcbd877faf$export$2e2bcd8739ae039 = $b5fcbddcbd877faf$var$purple;


/**
 * ![red 50](https://mui.com/static/colors-preview/red-50-24x24.png) ![red 100](https://mui.com/static/colors-preview/red-100-24x24.png) ![red 200](https://mui.com/static/colors-preview/red-200-24x24.png) ![red 300](https://mui.com/static/colors-preview/red-300-24x24.png) ![red 400](https://mui.com/static/colors-preview/red-400-24x24.png) ![red 500](https://mui.com/static/colors-preview/red-500-24x24.png) ![red 600](https://mui.com/static/colors-preview/red-600-24x24.png) ![red 700](https://mui.com/static/colors-preview/red-700-24x24.png) ![red 800](https://mui.com/static/colors-preview/red-800-24x24.png) ![red 900](https://mui.com/static/colors-preview/red-900-24x24.png) ![red A100](https://mui.com/static/colors-preview/red-A100-24x24.png) ![red A200](https://mui.com/static/colors-preview/red-A200-24x24.png) ![red A400](https://mui.com/static/colors-preview/red-A400-24x24.png) ![red A700](https://mui.com/static/colors-preview/red-A700-24x24.png)
 */ const $90fc3b51c994a494$var$red = {
    /**
   * Preview: ![red 50](https://mui.com/static/colors-preview/red-50-24x24.png)
   */ 50: '#ffebee',
    /**
   * Preview: ![red 100](https://mui.com/static/colors-preview/red-100-24x24.png)
   */ 100: '#ffcdd2',
    /**
   * Preview: ![red 200](https://mui.com/static/colors-preview/red-200-24x24.png)
   */ 200: '#ef9a9a',
    /**
   * Preview: ![red 300](https://mui.com/static/colors-preview/red-300-24x24.png)
   */ 300: '#e57373',
    /**
   * Preview: ![red 400](https://mui.com/static/colors-preview/red-400-24x24.png)
   */ 400: '#ef5350',
    /**
   * Preview: ![red 500](https://mui.com/static/colors-preview/red-500-24x24.png)
   */ 500: '#f44336',
    /**
   * Preview: ![red 600](https://mui.com/static/colors-preview/red-600-24x24.png)
   */ 600: '#e53935',
    /**
   * Preview: ![red 700](https://mui.com/static/colors-preview/red-700-24x24.png)
   */ 700: '#d32f2f',
    /**
   * Preview: ![red 800](https://mui.com/static/colors-preview/red-800-24x24.png)
   */ 800: '#c62828',
    /**
   * Preview: ![red 900](https://mui.com/static/colors-preview/red-900-24x24.png)
   */ 900: '#b71c1c',
    /**
   * Preview: ![red A100](https://mui.com/static/colors-preview/red-A100-24x24.png)
   */ A100: '#ff8a80',
    /**
   * Preview: ![red A200](https://mui.com/static/colors-preview/red-A200-24x24.png)
   */ A200: '#ff5252',
    /**
   * Preview: ![red A400](https://mui.com/static/colors-preview/red-A400-24x24.png)
   */ A400: '#ff1744',
    /**
   * Preview: ![red A700](https://mui.com/static/colors-preview/red-A700-24x24.png)
   */ A700: '#d50000'
};
var $90fc3b51c994a494$export$2e2bcd8739ae039 = $90fc3b51c994a494$var$red;


/**
 * ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png) ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png) ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png) ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png) ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png) ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png) ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png) ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png) ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png) ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png) ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png) ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png) ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png) ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
 */ const $16a665f88b3a8bcc$var$orange = {
    /**
   * Preview: ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png)
   */ 50: '#fff3e0',
    /**
   * Preview: ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png)
   */ 100: '#ffe0b2',
    /**
   * Preview: ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png)
   */ 200: '#ffcc80',
    /**
   * Preview: ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png)
   */ 300: '#ffb74d',
    /**
   * Preview: ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png)
   */ 400: '#ffa726',
    /**
   * Preview: ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png)
   */ 500: '#ff9800',
    /**
   * Preview: ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png)
   */ 600: '#fb8c00',
    /**
   * Preview: ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png)
   */ 700: '#f57c00',
    /**
   * Preview: ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png)
   */ 800: '#ef6c00',
    /**
   * Preview: ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png)
   */ 900: '#e65100',
    /**
   * Preview: ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png)
   */ A100: '#ffd180',
    /**
   * Preview: ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png)
   */ A200: '#ffab40',
    /**
   * Preview: ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png)
   */ A400: '#ff9100',
    /**
   * Preview: ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
   */ A700: '#ff6d00'
};
var $16a665f88b3a8bcc$export$2e2bcd8739ae039 = $16a665f88b3a8bcc$var$orange;


/**
 * ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png) ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png) ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png) ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png) ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png) ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png) ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png) ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png) ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png) ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png) ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png) ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png) ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png) ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
 */ const $03cd995a2b567a37$var$blue = {
    /**
   * Preview: ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png)
   */ 50: '#e3f2fd',
    /**
   * Preview: ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png)
   */ 100: '#bbdefb',
    /**
   * Preview: ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png)
   */ 200: '#90caf9',
    /**
   * Preview: ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png)
   */ 300: '#64b5f6',
    /**
   * Preview: ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png)
   */ 400: '#42a5f5',
    /**
   * Preview: ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png)
   */ 500: '#2196f3',
    /**
   * Preview: ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png)
   */ 600: '#1e88e5',
    /**
   * Preview: ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png)
   */ 700: '#1976d2',
    /**
   * Preview: ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png)
   */ 800: '#1565c0',
    /**
   * Preview: ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png)
   */ 900: '#0d47a1',
    /**
   * Preview: ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png)
   */ A100: '#82b1ff',
    /**
   * Preview: ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png)
   */ A200: '#448aff',
    /**
   * Preview: ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png)
   */ A400: '#2979ff',
    /**
   * Preview: ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
   */ A700: '#2962ff'
};
var $03cd995a2b567a37$export$2e2bcd8739ae039 = $03cd995a2b567a37$var$blue;


/**
 * ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png) ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png) ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png) ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png) ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png) ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png) ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png) ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png) ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png) ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png) ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png) ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png) ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png) ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
 */ const $19c5f349fb8964d3$var$lightBlue = {
    /**
   * Preview: ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png)
   */ 50: '#e1f5fe',
    /**
   * Preview: ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png)
   */ 100: '#b3e5fc',
    /**
   * Preview: ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png)
   */ 200: '#81d4fa',
    /**
   * Preview: ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png)
   */ 300: '#4fc3f7',
    /**
   * Preview: ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png)
   */ 400: '#29b6f6',
    /**
   * Preview: ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png)
   */ 500: '#03a9f4',
    /**
   * Preview: ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png)
   */ 600: '#039be5',
    /**
   * Preview: ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png)
   */ 700: '#0288d1',
    /**
   * Preview: ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png)
   */ 800: '#0277bd',
    /**
   * Preview: ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png)
   */ 900: '#01579b',
    /**
   * Preview: ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png)
   */ A100: '#80d8ff',
    /**
   * Preview: ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png)
   */ A200: '#40c4ff',
    /**
   * Preview: ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png)
   */ A400: '#00b0ff',
    /**
   * Preview: ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
   */ A700: '#0091ea'
};
var $19c5f349fb8964d3$export$2e2bcd8739ae039 = $19c5f349fb8964d3$var$lightBlue;


/**
 * ![green 50](https://mui.com/static/colors-preview/green-50-24x24.png) ![green 100](https://mui.com/static/colors-preview/green-100-24x24.png) ![green 200](https://mui.com/static/colors-preview/green-200-24x24.png) ![green 300](https://mui.com/static/colors-preview/green-300-24x24.png) ![green 400](https://mui.com/static/colors-preview/green-400-24x24.png) ![green 500](https://mui.com/static/colors-preview/green-500-24x24.png) ![green 600](https://mui.com/static/colors-preview/green-600-24x24.png) ![green 700](https://mui.com/static/colors-preview/green-700-24x24.png) ![green 800](https://mui.com/static/colors-preview/green-800-24x24.png) ![green 900](https://mui.com/static/colors-preview/green-900-24x24.png) ![green A100](https://mui.com/static/colors-preview/green-A100-24x24.png) ![green A200](https://mui.com/static/colors-preview/green-A200-24x24.png) ![green A400](https://mui.com/static/colors-preview/green-A400-24x24.png) ![green A700](https://mui.com/static/colors-preview/green-A700-24x24.png)
 */ const $82aa6d2f0dd0f06a$var$green = {
    /**
   * Preview: ![green 50](https://mui.com/static/colors-preview/green-50-24x24.png)
   */ 50: '#e8f5e9',
    /**
   * Preview: ![green 100](https://mui.com/static/colors-preview/green-100-24x24.png)
   */ 100: '#c8e6c9',
    /**
   * Preview: ![green 200](https://mui.com/static/colors-preview/green-200-24x24.png)
   */ 200: '#a5d6a7',
    /**
   * Preview: ![green 300](https://mui.com/static/colors-preview/green-300-24x24.png)
   */ 300: '#81c784',
    /**
   * Preview: ![green 400](https://mui.com/static/colors-preview/green-400-24x24.png)
   */ 400: '#66bb6a',
    /**
   * Preview: ![green 500](https://mui.com/static/colors-preview/green-500-24x24.png)
   */ 500: '#4caf50',
    /**
   * Preview: ![green 600](https://mui.com/static/colors-preview/green-600-24x24.png)
   */ 600: '#43a047',
    /**
   * Preview: ![green 700](https://mui.com/static/colors-preview/green-700-24x24.png)
   */ 700: '#388e3c',
    /**
   * Preview: ![green 800](https://mui.com/static/colors-preview/green-800-24x24.png)
   */ 800: '#2e7d32',
    /**
   * Preview: ![green 900](https://mui.com/static/colors-preview/green-900-24x24.png)
   */ 900: '#1b5e20',
    /**
   * Preview: ![green A100](https://mui.com/static/colors-preview/green-A100-24x24.png)
   */ A100: '#b9f6ca',
    /**
   * Preview: ![green A200](https://mui.com/static/colors-preview/green-A200-24x24.png)
   */ A200: '#69f0ae',
    /**
   * Preview: ![green A400](https://mui.com/static/colors-preview/green-A400-24x24.png)
   */ A400: '#00e676',
    /**
   * Preview: ![green A700](https://mui.com/static/colors-preview/green-A700-24x24.png)
   */ A700: '#00c853'
};
var $82aa6d2f0dd0f06a$export$2e2bcd8739ae039 = $82aa6d2f0dd0f06a$var$green;


function $5c2eba2e3b4b681b$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $310fddb5fc4b00ff$export$2e2bcd8739ae039).white,
            default: (0, $310fddb5fc4b00ff$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $5c2eba2e3b4b681b$export$a43af521ac8c3202 = $5c2eba2e3b4b681b$var$getLight();
function $5c2eba2e3b4b681b$var$getDark() {
    return {
        text: {
            primary: (0, $310fddb5fc4b00ff$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $310fddb5fc4b00ff$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $5c2eba2e3b4b681b$export$55ce6f3a06c59543 = $5c2eba2e3b4b681b$var$getDark();
function $5c2eba2e3b4b681b$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $3cec7b0dca18ba73$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $3cec7b0dca18ba73$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $5c2eba2e3b4b681b$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $5c2eba2e3b4b681b$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $03cd995a2b567a37$export$2e2bcd8739ae039)[200],
        light: (0, $03cd995a2b567a37$export$2e2bcd8739ae039)[50],
        dark: (0, $03cd995a2b567a37$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $03cd995a2b567a37$export$2e2bcd8739ae039)[700],
        light: (0, $03cd995a2b567a37$export$2e2bcd8739ae039)[400],
        dark: (0, $03cd995a2b567a37$export$2e2bcd8739ae039)[800]
    };
}
function $5c2eba2e3b4b681b$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $b5fcbddcbd877faf$export$2e2bcd8739ae039)[200],
        light: (0, $b5fcbddcbd877faf$export$2e2bcd8739ae039)[50],
        dark: (0, $b5fcbddcbd877faf$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $b5fcbddcbd877faf$export$2e2bcd8739ae039)[500],
        light: (0, $b5fcbddcbd877faf$export$2e2bcd8739ae039)[300],
        dark: (0, $b5fcbddcbd877faf$export$2e2bcd8739ae039)[700]
    };
}
function $5c2eba2e3b4b681b$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $90fc3b51c994a494$export$2e2bcd8739ae039)[500],
        light: (0, $90fc3b51c994a494$export$2e2bcd8739ae039)[300],
        dark: (0, $90fc3b51c994a494$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $90fc3b51c994a494$export$2e2bcd8739ae039)[700],
        light: (0, $90fc3b51c994a494$export$2e2bcd8739ae039)[400],
        dark: (0, $90fc3b51c994a494$export$2e2bcd8739ae039)[800]
    };
}
function $5c2eba2e3b4b681b$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $19c5f349fb8964d3$export$2e2bcd8739ae039)[400],
        light: (0, $19c5f349fb8964d3$export$2e2bcd8739ae039)[300],
        dark: (0, $19c5f349fb8964d3$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $19c5f349fb8964d3$export$2e2bcd8739ae039)[700],
        light: (0, $19c5f349fb8964d3$export$2e2bcd8739ae039)[500],
        dark: (0, $19c5f349fb8964d3$export$2e2bcd8739ae039)[900]
    };
}
function $5c2eba2e3b4b681b$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $82aa6d2f0dd0f06a$export$2e2bcd8739ae039)[400],
        light: (0, $82aa6d2f0dd0f06a$export$2e2bcd8739ae039)[300],
        dark: (0, $82aa6d2f0dd0f06a$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $82aa6d2f0dd0f06a$export$2e2bcd8739ae039)[800],
        light: (0, $82aa6d2f0dd0f06a$export$2e2bcd8739ae039)[500],
        dark: (0, $82aa6d2f0dd0f06a$export$2e2bcd8739ae039)[900]
    };
}
function $5c2eba2e3b4b681b$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $16a665f88b3a8bcc$export$2e2bcd8739ae039)[400],
        light: (0, $16a665f88b3a8bcc$export$2e2bcd8739ae039)[300],
        dark: (0, $16a665f88b3a8bcc$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $16a665f88b3a8bcc$export$2e2bcd8739ae039)[500],
        dark: (0, $16a665f88b3a8bcc$export$2e2bcd8739ae039)[900]
    };
}
function $5c2eba2e3b4b681b$export$b6e2ca4581a735cb(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $5c2eba2e3b4b681b$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $5c2eba2e3b4b681b$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $5c2eba2e3b4b681b$var$getDefaultSecondary(mode);
    const error = palette.error || $5c2eba2e3b4b681b$var$getDefaultError(mode);
    const info = palette.info || $5c2eba2e3b4b681b$var$getDefaultInfo(mode);
    const success = palette.success || $5c2eba2e3b4b681b$var$getDefaultSuccess(mode);
    const warning = palette.warning || $5c2eba2e3b4b681b$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $5c2eba2e3b4b681b$export$b6e2ca4581a735cb(background);
        const contrastText = (0, $3cec7b0dca18ba73$export$d061e26956a60b0a)(background, $5c2eba2e3b4b681b$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $5c2eba2e3b4b681b$export$55ce6f3a06c59543.text.primary : $5c2eba2e3b4b681b$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $4bb17f8aebf76219$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $4bb17f8aebf76219$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $5c2eba2e3b4b681b$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $5c2eba2e3b4b681b$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $5c2eba2e3b4b681b$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $5c2eba2e3b4b681b$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $5c2eba2e3b4b681b$var$getLight();
    else if (mode === 'dark') modeHydrated = $5c2eba2e3b4b681b$var$getDark();
    const paletteOutput = (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: {
            ...(0, $310fddb5fc4b00ff$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $afdf4f32e122a677$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}



const $6008f4971a0c21c7$var$focusVisibleOffsetVar = '--_focusVisible-offset';
const $6008f4971a0c21c7$var$focusVisibleBehaviorVar = '--_focusVisible-behavior';
const $6008f4971a0c21c7$var$focusVisibleShadowVar = '--_focusVisible-shadow';
const $6008f4971a0c21c7$var$offsetValue = `var(${$6008f4971a0c21c7$var$focusVisibleOffsetVar}, 1)`;
const $6008f4971a0c21c7$var$behaviorValue = `var(${$6008f4971a0c21c7$var$focusVisibleBehaviorVar}, )`;
const $6008f4971a0c21c7$export$2f2afcd9b20384c7 = {
    [$6008f4971a0c21c7$var$focusVisibleOffsetVar]: 1,
    [$6008f4971a0c21c7$var$focusVisibleBehaviorVar]: 'initial' // reverts the var to guaranteed-invalid so `var(--_focusVisible-behavior, )` falls back to empty — there is no explicit `outset` keyword.
};
function $6008f4971a0c21c7$export$ce219ac1eda241f1(color) {
    return {
        [$6008f4971a0c21c7$var$focusVisibleShadowVar]: color
    };
}
function $6008f4971a0c21c7$export$e388436c4b59b99d(offset) {
    return {
        [$6008f4971a0c21c7$var$focusVisibleOffsetVar]: -offset,
        [$6008f4971a0c21c7$var$focusVisibleBehaviorVar]: 'inset'
    };
}
function $6008f4971a0c21c7$export$5d0f425d284660f4(optionsFocusVisible, args) {
    return args.reduce((acc, arg)=>arg && 'focusVisible' in arg ? (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(acc, {
            focusVisible: arg.focusVisible
        }) : acc, {
        focusVisible: optionsFocusVisible
    }).focusVisible;
}
function $6008f4971a0c21c7$export$685950156577a061(input) {
    return input != null && typeof input === 'object' && typeof input.outlineOffset === 'string' && input.outlineOffset.includes($6008f4971a0c21c7$var$focusVisibleOffsetVar);
}
function $6008f4971a0c21c7$export$c06a3c79efe1b1cf(input, outlineColor) {
    return $6008f4971a0c21c7$export$a0f20964bcf591d5({
        outlineStyle: 'solid',
        outlineColor: outlineColor,
        outlineWidth: 2,
        outlineOffset: 2,
        // invisible shadow for parent component with solid background (AppBar, Snackbar, Alert) can control the ring color.
        boxShadow: `var(${$6008f4971a0c21c7$var$focusVisibleShadowVar}, 0 0)`,
        ...input === true ? null : input
    });
}
function $6008f4971a0c21c7$export$a0f20964bcf591d5(resolved) {
    // Multiply the offset by the sign var so it flips to inset on clip-prone components. Skip if
    // already wired: re-composing a resolved theme must not wrap the calc twice and invert the sign.
    const offset = resolved.outlineOffset ?? 0;
    if (typeof offset !== 'string' || !offset.includes($6008f4971a0c21c7$var$focusVisibleOffsetVar)) {
        const offsetPx = typeof offset === 'number' ? `${offset}px` : offset;
        resolved.outlineOffset = `calc(${$6008f4971a0c21c7$var$offsetValue} * ${offsetPx})`;
    }
    // Prefix a box-shadow with the behavior var so it insets there too, unless it already opts in.
    // Standalone keywords are complete values — prefixing would produce an invalid `inset none`.
    const standaloneBoxShadows = new Set([
        'none',
        'initial',
        'inherit',
        'unset',
        'revert',
        'revert-layer'
    ]);
    if (typeof resolved.boxShadow === 'string' && !standaloneBoxShadows.has(resolved.boxShadow.trim().toLowerCase()) && !/\binset\b/.test(resolved.boxShadow) && !resolved.boxShadow.includes($6008f4971a0c21c7$var$focusVisibleBehaviorVar)) resolved.boxShadow = `${$6008f4971a0c21c7$var$behaviorValue} ${resolved.boxShadow}`;
    return resolved;
}




var $7a381217d0a161e7$exports = {};
/**
 * @mui/system v9.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $PT5lT = parcelRequire("PT5lT");
var $7a381217d0a161e7$require$_interopRequireWildcard = $PT5lT.default;

var $k8pq4 = parcelRequire("k8pq4");
var $7a381217d0a161e7$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty($7a381217d0a161e7$exports, "__esModule", {
    value: true
});
var $7a381217d0a161e7$var$_exportNames = {
    experimental_sx: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    GlobalStyles: true,
    borders: true,
    breakpoints: true,
    handleBreakpoints: true,
    mergeBreakpointsInOrder: true,
    unstable_resolveBreakpointValues: true,
    cssContainerQueries: true,
    compose: true,
    display: true,
    flexbox: true,
    grid: true,
    palette: true,
    positions: true,
    shadows: true,
    sizing: true,
    spacing: true,
    style: true,
    getPath: true,
    getStyleValue: true,
    typography: true,
    unstable_styleFunctionSx: true,
    unstable_createStyleFunctionSx: true,
    unstable_extendSxProp: true,
    unstable_defaultSxConfig: true,
    unstable_getThemeValue: true,
    Box: true,
    createBox: true,
    createStyled: true,
    styled: true,
    createTheme: true,
    createBreakpoints: true,
    createSpacing: true,
    shape: true,
    useThemeProps: true,
    getThemeProps: true,
    useTheme: true,
    useThemeWithoutDefault: true,
    useMediaQuery: true,
    ThemeProvider: true,
    unstable_memoTheme: true,
    unstable_createCssVarsProvider: true,
    unstable_createGetCssVar: true,
    unstable_cssVarsParser: true,
    unstable_prepareCssVars: true,
    unstable_createCssVarsTheme: true,
    responsivePropType: true,
    RtlProvider: true,
    createContainer: true,
    Container: true,
    Grid: true,
    Stack: true
};
Object.defineProperty($7a381217d0a161e7$exports, "Box", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_Box.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "Container", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_Container.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_GlobalStyles.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "Grid", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_Grid.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "RtlProvider", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_RtlProvider.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "Stack", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_Stack.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $ivxDX.StyledEngineProvider;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_ThemeProvider.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "borders", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_borders.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "breakpoints", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_breakpoints.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "compose", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_compose.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "createBox", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_createBox.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "createBreakpoints", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_createBreakpoints.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "createContainer", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_createContainer.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "createSpacing", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_createSpacing.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "createStyled", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_createStyled.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_createTheme.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "css", {
    enumerable: true,
    get: function() {
        return $ivxDX.css;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "cssContainerQueries", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_cssContainerQueries.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "display", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_display.default;
    }
});
$7a381217d0a161e7$exports.experimental_sx = $7a381217d0a161e7$var$experimental_sx;
Object.defineProperty($7a381217d0a161e7$exports, "flexbox", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_flexbox.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "getPath", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_style.getPath;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "getStyleValue", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_style.getStyleValue;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_useThemeProps.getThemeProps;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "grid", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_cssGrid.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "handleBreakpoints", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_breakpoints.handleBreakpoints;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $ivxDX.keyframes;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "mergeBreakpointsInOrder", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_breakpoints.mergeBreakpointsInOrder;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "palette", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_palette.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "positions", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_positions.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "responsivePropType", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_responsivePropType.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "shadows", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_shadows.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "shape", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_shape.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "sizing", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_sizing.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "spacing", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_spacing.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "style", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_style.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "styled", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_styled.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "typography", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_typography.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_createCssVarsProvider", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_createGetCssVar", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_createGetCssVar.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_cssVarsParser", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_cssVarsParser.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_styleFunctionSx.unstable_defaultSxConfig;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_extendSxProp", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_styleFunctionSx.extendSxProp;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_getThemeValue", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_getThemeValue.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_memoTheme.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_prepareCssVars", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_prepareCssVars.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_resolveBreakpointValues", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_breakpoints.resolveBreakpointValues;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "unstable_styleFunctionSx", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_styleFunctionSx.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "useMediaQuery", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_useMediaQuery.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_useTheme.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_useThemeProps.default;
    }
});
Object.defineProperty($7a381217d0a161e7$exports, "useThemeWithoutDefault", {
    enumerable: true,
    get: function() {
        return $7a381217d0a161e7$var$_useThemeWithoutDefault.default;
    }
});

var $7a381217d0a161e7$var$_formatMuiErrorMessage = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("lVHP6")));

var $ivxDX = parcelRequire("ivxDX");

var $7a381217d0a161e7$var$_GlobalStyles = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("f47HC")));

var $7a381217d0a161e7$var$_borders = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("dwAab")));
Object.keys($7a381217d0a161e7$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_borders[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_borders[key];
        }
    });
});

var $7a381217d0a161e7$var$_breakpoints = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("69BMr")));

var $7a381217d0a161e7$var$_cssContainerQueries = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("45d6a")));

var $7a381217d0a161e7$var$_compose = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("8Apkm")));

var $7a381217d0a161e7$var$_display = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("hua2v")));

var $7a381217d0a161e7$var$_flexbox = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("e3ZyG")));
Object.keys($7a381217d0a161e7$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_flexbox[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_flexbox[key];
        }
    });
});

var $7a381217d0a161e7$var$_cssGrid = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("iXSgY")));
Object.keys($7a381217d0a161e7$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_cssGrid[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_cssGrid[key];
        }
    });
});

var $7a381217d0a161e7$var$_palette = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("6OuH1")));
Object.keys($7a381217d0a161e7$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_palette[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_palette[key];
        }
    });
});

var $7a381217d0a161e7$var$_positions = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("7FnpO")));
Object.keys($7a381217d0a161e7$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_positions[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_positions[key];
        }
    });
});

var $7a381217d0a161e7$var$_shadows = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("d1eMQ")));

var $7a381217d0a161e7$var$_sizing = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("hrmPC")));
Object.keys($7a381217d0a161e7$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_sizing[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_sizing[key];
        }
    });
});

var $7a381217d0a161e7$var$_spacing = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("4b2XU")));
Object.keys($7a381217d0a161e7$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_spacing[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_spacing[key];
        }
    });
});

var $7a381217d0a161e7$var$_style = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("bcPDg")));

var $7a381217d0a161e7$var$_typography = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("bO0MO")));
Object.keys($7a381217d0a161e7$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_typography[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_typography[key];
        }
    });
});

var $7a381217d0a161e7$var$_styleFunctionSx = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("4aNvf")));

var $7a381217d0a161e7$var$_getThemeValue = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("7uEz0")));

var $7a381217d0a161e7$var$_Box = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("5YgRw")));
Object.keys($7a381217d0a161e7$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_Box[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_Box[key];
        }
    });
});

var $7a381217d0a161e7$var$_createBox = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("hiswr")));

var $7a381217d0a161e7$var$_createStyled = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("76hie")));
Object.keys($7a381217d0a161e7$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_createStyled[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_createStyled[key];
        }
    });
});

var $7a381217d0a161e7$var$_styled = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("8e6g8")));

var $7a381217d0a161e7$var$_createTheme = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("hDEnZ")));

var $7a381217d0a161e7$var$_createBreakpoints = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("88q07")));

var $7a381217d0a161e7$var$_createSpacing = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("7BNIa")));

var $7a381217d0a161e7$var$_shape = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("9dv5b")));

var $7a381217d0a161e7$var$_useThemeProps = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("jmjKP")));

var $7a381217d0a161e7$var$_useTheme = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("dWz7R")));

var $7a381217d0a161e7$var$_useThemeWithoutDefault = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("3pEz9")));

var $7a381217d0a161e7$var$_useMediaQuery = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("jFDsv")));
var $ce8738418fb9fdcd$exports = {};
"use strict";
Object.defineProperty($ce8738418fb9fdcd$exports, "__esModule", {
    value: true
});
var $291c4c5b8f345c2b$exports = {};
"use strict";

var $k8pq4 = parcelRequire("k8pq4");
var $291c4c5b8f345c2b$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty($291c4c5b8f345c2b$exports, "__esModule", {
    value: true
});
$291c4c5b8f345c2b$exports.alpha = $291c4c5b8f345c2b$var$alpha;
$291c4c5b8f345c2b$exports.blend = $291c4c5b8f345c2b$var$blend;
$291c4c5b8f345c2b$exports.colorChannel = void 0;
$291c4c5b8f345c2b$exports.darken = $291c4c5b8f345c2b$var$darken;
$291c4c5b8f345c2b$exports.decomposeColor = $291c4c5b8f345c2b$var$decomposeColor;
$291c4c5b8f345c2b$exports.emphasize = $291c4c5b8f345c2b$var$emphasize;
$291c4c5b8f345c2b$exports.getContrastRatio = $291c4c5b8f345c2b$var$getContrastRatio;
$291c4c5b8f345c2b$exports.getLuminance = $291c4c5b8f345c2b$var$getLuminance;
$291c4c5b8f345c2b$exports.hexToRgb = $291c4c5b8f345c2b$var$hexToRgb;
$291c4c5b8f345c2b$exports.hslToRgb = $291c4c5b8f345c2b$var$hslToRgb;
$291c4c5b8f345c2b$exports.lighten = $291c4c5b8f345c2b$var$lighten;
$291c4c5b8f345c2b$exports.private_safeAlpha = $291c4c5b8f345c2b$var$private_safeAlpha;
$291c4c5b8f345c2b$exports.private_safeColorChannel = void 0;
$291c4c5b8f345c2b$exports.private_safeDarken = $291c4c5b8f345c2b$var$private_safeDarken;
$291c4c5b8f345c2b$exports.private_safeEmphasize = $291c4c5b8f345c2b$var$private_safeEmphasize;
$291c4c5b8f345c2b$exports.private_safeLighten = $291c4c5b8f345c2b$var$private_safeLighten;
$291c4c5b8f345c2b$exports.recomposeColor = $291c4c5b8f345c2b$var$recomposeColor;
$291c4c5b8f345c2b$exports.rgbToHex = $291c4c5b8f345c2b$var$rgbToHex;

var $291c4c5b8f345c2b$var$_formatMuiErrorMessage = $291c4c5b8f345c2b$require$_interopRequireDefault((parcelRequire("lVHP6")));

var $291c4c5b8f345c2b$var$_clamp = $291c4c5b8f345c2b$require$_interopRequireDefault((parcelRequire("bH02A")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $291c4c5b8f345c2b$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $291c4c5b8f345c2b$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $291c4c5b8f345c2b$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $291c4c5b8f345c2b$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $291c4c5b8f345c2b$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $291c4c5b8f345c2b$var$decomposeColor($291c4c5b8f345c2b$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $291c4c5b8f345c2b$var$_formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $291c4c5b8f345c2b$var$_formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $291c4c5b8f345c2b$var$colorChannel = (color)=>{
    const decomposedColor = $291c4c5b8f345c2b$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
$291c4c5b8f345c2b$exports.colorChannel = $291c4c5b8f345c2b$var$colorChannel;
const $291c4c5b8f345c2b$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $291c4c5b8f345c2b$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ $291c4c5b8f345c2b$exports.private_safeColorChannel = $291c4c5b8f345c2b$var$private_safeColorChannel;
function $291c4c5b8f345c2b$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $291c4c5b8f345c2b$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $291c4c5b8f345c2b$var$decomposeColor(color);
    return `#${values.map((n, i)=>$291c4c5b8f345c2b$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $291c4c5b8f345c2b$var$hslToRgb(color) {
    color = $291c4c5b8f345c2b$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $291c4c5b8f345c2b$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $291c4c5b8f345c2b$var$getLuminance(color) {
    color = $291c4c5b8f345c2b$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $291c4c5b8f345c2b$var$decomposeColor($291c4c5b8f345c2b$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $291c4c5b8f345c2b$var$getContrastRatio(foreground, background) {
    const lumA = $291c4c5b8f345c2b$var$getLuminance(foreground);
    const lumB = $291c4c5b8f345c2b$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $291c4c5b8f345c2b$var$alpha(color, value) {
    color = $291c4c5b8f345c2b$var$decomposeColor(color);
    value = $291c4c5b8f345c2b$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $291c4c5b8f345c2b$var$recomposeColor(color);
}
function $291c4c5b8f345c2b$var$private_safeAlpha(color, value, warning) {
    try {
        return $291c4c5b8f345c2b$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $291c4c5b8f345c2b$var$darken(color, coefficient) {
    color = $291c4c5b8f345c2b$var$decomposeColor(color);
    coefficient = $291c4c5b8f345c2b$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $291c4c5b8f345c2b$var$recomposeColor(color);
}
function $291c4c5b8f345c2b$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $291c4c5b8f345c2b$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $291c4c5b8f345c2b$var$lighten(color, coefficient) {
    color = $291c4c5b8f345c2b$var$decomposeColor(color);
    coefficient = $291c4c5b8f345c2b$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $291c4c5b8f345c2b$var$recomposeColor(color);
}
function $291c4c5b8f345c2b$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $291c4c5b8f345c2b$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $291c4c5b8f345c2b$var$emphasize(color, coefficient = 0.15) {
    return $291c4c5b8f345c2b$var$getLuminance(color) > 0.5 ? $291c4c5b8f345c2b$var$darken(color, coefficient) : $291c4c5b8f345c2b$var$lighten(color, coefficient);
}
function $291c4c5b8f345c2b$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $291c4c5b8f345c2b$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $291c4c5b8f345c2b$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $291c4c5b8f345c2b$var$decomposeColor(background);
    const overlayColor = $291c4c5b8f345c2b$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $291c4c5b8f345c2b$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}


Object.keys($291c4c5b8f345c2b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $ce8738418fb9fdcd$exports && $ce8738418fb9fdcd$exports[key] === $291c4c5b8f345c2b$exports[key]) return;
    Object.defineProperty($ce8738418fb9fdcd$exports, key, {
        enumerable: true,
        get: function() {
            return $291c4c5b8f345c2b$exports[key];
        }
    });
});


Object.keys($ce8738418fb9fdcd$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $ce8738418fb9fdcd$exports[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $ce8738418fb9fdcd$exports[key];
        }
    });
});

var $7a381217d0a161e7$var$_ThemeProvider = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("bingO")));

var $7a381217d0a161e7$var$_memoTheme = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("k9mt6")));

var $7a381217d0a161e7$var$_createCssVarsProvider = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("9AcZB")));

var $7a381217d0a161e7$var$_createGetCssVar = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("9ITdn")));

var $7a381217d0a161e7$var$_cssVarsParser = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("h8frB")));

var $7a381217d0a161e7$var$_prepareCssVars = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("1roNO")));

var $7a381217d0a161e7$var$_createCssVarsTheme = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("6kgR5")));

var $7a381217d0a161e7$var$_responsivePropType = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("b2nTm")));

var $7a381217d0a161e7$var$_RtlProvider = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("i9sFE")));
Object.keys($7a381217d0a161e7$var$_RtlProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_RtlProvider[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_RtlProvider[key];
        }
    });
});
var $ed1e1ba15927ac23$exports = {};
"use strict";
Object.defineProperty($ed1e1ba15927ac23$exports, "__esModule", {
    value: true
});
$ed1e1ba15927ac23$exports.version = $ed1e1ba15927ac23$exports.prerelease = $ed1e1ba15927ac23$exports.patch = $ed1e1ba15927ac23$exports.minor = $ed1e1ba15927ac23$exports.major = $ed1e1ba15927ac23$exports.default = void 0;
const $ed1e1ba15927ac23$var$version = $ed1e1ba15927ac23$exports.version = "9.5.0";
const $ed1e1ba15927ac23$var$major = $ed1e1ba15927ac23$exports.major = Number("9");
const $ed1e1ba15927ac23$var$minor = $ed1e1ba15927ac23$exports.minor = Number("5");
const $ed1e1ba15927ac23$var$patch = $ed1e1ba15927ac23$exports.patch = Number("0");
const $ed1e1ba15927ac23$var$prerelease = $ed1e1ba15927ac23$exports.prerelease = undefined;
var $ed1e1ba15927ac23$var$_default = $ed1e1ba15927ac23$exports.default = $ed1e1ba15927ac23$var$version;


Object.keys($ed1e1ba15927ac23$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $ed1e1ba15927ac23$exports[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $ed1e1ba15927ac23$exports[key];
        }
    });
});

var $7a381217d0a161e7$var$_createContainer = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("eWibW")));

var $7a381217d0a161e7$var$_Container = $7a381217d0a161e7$require$_interopRequireWildcard((parcelRequire("auKEA")));
Object.keys($7a381217d0a161e7$var$_Container).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $7a381217d0a161e7$var$_Container[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $7a381217d0a161e7$var$_Container[key];
        }
    });
});

var $7a381217d0a161e7$var$_Grid = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("3yksz")));
var $2311fd5ce5b232cc$exports = {};
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $2311fd5ce5b232cc$require$_interopRequireWildcard = $PT5lT.default;

var $k8pq4 = parcelRequire("k8pq4");
var $2311fd5ce5b232cc$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty($2311fd5ce5b232cc$exports, "__esModule", {
    value: true
});
var $2311fd5ce5b232cc$var$_exportNames = {
    createGrid: true,
    gridClasses: true,
    unstable_traverseBreakpoints: true,
    unstable_generateDirectionClasses: true,
    unstable_generateSizeClassNames: true,
    unstable_generateSpacingClassNames: true
};
Object.defineProperty($2311fd5ce5b232cc$exports, "createGrid", {
    enumerable: true,
    get: function() {
        return $2311fd5ce5b232cc$var$_createGrid.default;
    }
});
Object.defineProperty($2311fd5ce5b232cc$exports, "default", {
    enumerable: true,
    get: function() {
        return $2311fd5ce5b232cc$var$_Grid.default;
    }
});
Object.defineProperty($2311fd5ce5b232cc$exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return $2311fd5ce5b232cc$var$_gridClasses.default;
    }
});
Object.defineProperty($2311fd5ce5b232cc$exports, "unstable_generateDirectionClasses", {
    enumerable: true,
    get: function() {
        return $fCwaE.generateDirectionClasses;
    }
});
Object.defineProperty($2311fd5ce5b232cc$exports, "unstable_generateSizeClassNames", {
    enumerable: true,
    get: function() {
        return $fCwaE.generateSizeClassNames;
    }
});
Object.defineProperty($2311fd5ce5b232cc$exports, "unstable_generateSpacingClassNames", {
    enumerable: true,
    get: function() {
        return $fCwaE.generateSpacingClassNames;
    }
});
Object.defineProperty($2311fd5ce5b232cc$exports, "unstable_traverseBreakpoints", {
    enumerable: true,
    get: function() {
        return $51xd2.traverseBreakpoints;
    }
});

var $2311fd5ce5b232cc$var$_Grid = $2311fd5ce5b232cc$require$_interopRequireDefault((parcelRequire("3yksz")));

var $2311fd5ce5b232cc$var$_createGrid = $2311fd5ce5b232cc$require$_interopRequireDefault((parcelRequire("49AG8")));
var $ddef98a87082e59b$exports = {};
"use strict";
Object.defineProperty($ddef98a87082e59b$exports, "__esModule", {
    value: true
});


Object.keys($ddef98a87082e59b$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2311fd5ce5b232cc$var$_exportNames, key)) return;
    if (key in $2311fd5ce5b232cc$exports && $2311fd5ce5b232cc$exports[key] === $ddef98a87082e59b$exports[key]) return;
    Object.defineProperty($2311fd5ce5b232cc$exports, key, {
        enumerable: true,
        get: function() {
            return $ddef98a87082e59b$exports[key];
        }
    });
});

var $2311fd5ce5b232cc$var$_gridClasses = $2311fd5ce5b232cc$require$_interopRequireWildcard((parcelRequire("fLJqk")));
Object.keys($2311fd5ce5b232cc$var$_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($2311fd5ce5b232cc$var$_exportNames, key)) return;
    if (key in $2311fd5ce5b232cc$exports && $2311fd5ce5b232cc$exports[key] === $2311fd5ce5b232cc$var$_gridClasses[key]) return;
    Object.defineProperty($2311fd5ce5b232cc$exports, key, {
        enumerable: true,
        get: function() {
            return $2311fd5ce5b232cc$var$_gridClasses[key];
        }
    });
});

var $51xd2 = parcelRequire("51xd2");

var $fCwaE = parcelRequire("fCwaE");


Object.keys($2311fd5ce5b232cc$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $2311fd5ce5b232cc$exports[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $2311fd5ce5b232cc$exports[key];
        }
    });
});

var $7a381217d0a161e7$var$_Stack = $7a381217d0a161e7$require$_interopRequireDefault((parcelRequire("geOjO")));
var $b5e2c7df9a2a2eb7$exports = {};
"use strict";

var $PT5lT = parcelRequire("PT5lT");
var $b5e2c7df9a2a2eb7$require$_interopRequireWildcard = $PT5lT.default;

var $k8pq4 = parcelRequire("k8pq4");
var $b5e2c7df9a2a2eb7$require$_interopRequireDefault = $k8pq4.default;
Object.defineProperty($b5e2c7df9a2a2eb7$exports, "__esModule", {
    value: true
});
var $b5e2c7df9a2a2eb7$var$_exportNames = {
    createStack: true,
    stackClasses: true
};
Object.defineProperty($b5e2c7df9a2a2eb7$exports, "createStack", {
    enumerable: true,
    get: function() {
        return $b5e2c7df9a2a2eb7$var$_createStack.default;
    }
});
Object.defineProperty($b5e2c7df9a2a2eb7$exports, "default", {
    enumerable: true,
    get: function() {
        return $b5e2c7df9a2a2eb7$var$_Stack.default;
    }
});
Object.defineProperty($b5e2c7df9a2a2eb7$exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return $b5e2c7df9a2a2eb7$var$_stackClasses.default;
    }
});

var $b5e2c7df9a2a2eb7$var$_Stack = $b5e2c7df9a2a2eb7$require$_interopRequireDefault((parcelRequire("geOjO")));

var $b5e2c7df9a2a2eb7$var$_createStack = $b5e2c7df9a2a2eb7$require$_interopRequireDefault((parcelRequire("8yefD")));
var $eb92a9525cab9d27$exports = {};
"use strict";
Object.defineProperty($eb92a9525cab9d27$exports, "__esModule", {
    value: true
});


Object.keys($eb92a9525cab9d27$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b5e2c7df9a2a2eb7$var$_exportNames, key)) return;
    if (key in $b5e2c7df9a2a2eb7$exports && $b5e2c7df9a2a2eb7$exports[key] === $eb92a9525cab9d27$exports[key]) return;
    Object.defineProperty($b5e2c7df9a2a2eb7$exports, key, {
        enumerable: true,
        get: function() {
            return $eb92a9525cab9d27$exports[key];
        }
    });
});

var $b5e2c7df9a2a2eb7$var$_stackClasses = $b5e2c7df9a2a2eb7$require$_interopRequireWildcard((parcelRequire("2rN3g")));
Object.keys($b5e2c7df9a2a2eb7$var$_stackClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($b5e2c7df9a2a2eb7$var$_exportNames, key)) return;
    if (key in $b5e2c7df9a2a2eb7$exports && $b5e2c7df9a2a2eb7$exports[key] === $b5e2c7df9a2a2eb7$var$_stackClasses[key]) return;
    Object.defineProperty($b5e2c7df9a2a2eb7$exports, key, {
        enumerable: true,
        get: function() {
            return $b5e2c7df9a2a2eb7$var$_stackClasses[key];
        }
    });
});


Object.keys($b5e2c7df9a2a2eb7$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($7a381217d0a161e7$var$_exportNames, key)) return;
    if (key in $7a381217d0a161e7$exports && $7a381217d0a161e7$exports[key] === $b5e2c7df9a2a2eb7$exports[key]) return;
    Object.defineProperty($7a381217d0a161e7$exports, key, {
        enumerable: true,
        get: function() {
            return $b5e2c7df9a2a2eb7$exports[key];
        }
    });
});
/* eslint-disable import/export */ /**
 * The `css` function accepts arrays as values for mobile-first responsive styles.
 * Note that this extends to non-theme values also. For example `display=['none', 'block']`
 * will also work.
 */ // TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
function $7a381217d0a161e7$var$experimental_sx() {
    throw new Error((0, $7a381217d0a161e7$var$_formatMuiErrorMessage.default)(19));
} /** ----------------- */  /** Layout components */ 



/* eslint-disable import/prefer-default-export */ function $3fda1a73f9aa39fb$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}


const $c056575125f552d8$var$prototypePollutingKeys = new Set([
    '__proto__',
    'constructor',
    'prototype'
]);
const $c056575125f552d8$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    for(let index = 0; index < keys.length; index += 1){
        const k = keys[index];
        // Prevent prototype pollution: never traverse or write through
        // `__proto__` / `constructor` / `prototype` (e.g. a theme parsed from untrusted JSON).
        if ($c056575125f552d8$var$prototypePollutingKeys.has(k)) break;
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    }
};
const $c056575125f552d8$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $c056575125f552d8$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $c056575125f552d8$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $c056575125f552d8$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $c056575125f552d8$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $c056575125f552d8$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $c056575125f552d8$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


function $c230e75f8b4cffe8$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-expect-error - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $c056575125f552d8$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $c056575125f552d8$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $c056575125f552d8$export$2e2bcd8739ae039)(defaultScheme, parserConfig);
        themeVars = (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $c230e75f8b4cffe8$export$2e2bcd8739ae039 = $c230e75f8b4cffe8$var$prepareCssVars;

function $9983ca1e458adb79$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}










function $7e668da64b1a061e$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




function $3036ca6f85f9eff7$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $3036ca6f85f9eff7$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $3036ca6f85f9eff7$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $3036ca6f85f9eff7$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $3036ca6f85f9eff7$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $3036ca6f85f9eff7$var$defaultFontFamily ? {
                letterSpacing: `${$3036ca6f85f9eff7$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $3036ca6f85f9eff7$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $3036ca6f85f9eff7$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $1af552c663cdb802$var$shadowKeyUmbraOpacity = 0.2;
const $1af552c663cdb802$var$shadowKeyPenumbraOpacity = 0.14;
const $1af552c663cdb802$var$shadowAmbientShadowOpacity = 0.12;
function $1af552c663cdb802$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$1af552c663cdb802$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$1af552c663cdb802$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$1af552c663cdb802$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $1af552c663cdb802$var$shadows = [
    'none',
    $1af552c663cdb802$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $1af552c663cdb802$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $1af552c663cdb802$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $1af552c663cdb802$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $1af552c663cdb802$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $1af552c663cdb802$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $1af552c663cdb802$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $1af552c663cdb802$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $1af552c663cdb802$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $1af552c663cdb802$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $1af552c663cdb802$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $1af552c663cdb802$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $1af552c663cdb802$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $1af552c663cdb802$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $1af552c663cdb802$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $1af552c663cdb802$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $1af552c663cdb802$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $1af552c663cdb802$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $1af552c663cdb802$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $1af552c663cdb802$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $1af552c663cdb802$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $1af552c663cdb802$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $1af552c663cdb802$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $1af552c663cdb802$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $1af552c663cdb802$export$2e2bcd8739ae039 = $1af552c663cdb802$var$shadows;


const $009d61f99a58b06b$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $009d61f99a58b06b$var$EMPTY_OPTIONS = {};
const $009d61f99a58b06b$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $009d61f99a58b06b$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $009d61f99a58b06b$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $009d61f99a58b06b$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $009d61f99a58b06b$export$2e2bcd8739ae039(inputTransitions) {
    const transitions = {
        ...inputTransitions
    };
    delete transitions.reducedMotion;
    const mergedEasing = {
        ...$009d61f99a58b06b$export$24c5ac7c37452e7d,
        ...transitions.easing
    };
    const mergedDuration = {
        ...$009d61f99a58b06b$export$1f34108aa9eb96ab,
        ...transitions.duration
    };
    const createTransitionValue = (props = $009d61f99a58b06b$var$DEFAULT_TRANSITION_PROPS, options = $009d61f99a58b06b$var$EMPTY_OPTIONS)=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $009d61f99a58b06b$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $009d61f99a58b06b$var$formatMs(delay)}`).join(',');
    };
    const create = transitions.create ?? createTransitionValue;
    return {
        getAutoHeightDuration: $009d61f99a58b06b$var$getAutoHeightDuration,
        create: create,
        ...transitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


const $19ab7155bcc50916$var$EMPTY_MOTION = {};
function $19ab7155bcc50916$export$2e2bcd8739ae039(inputMotion = $19ab7155bcc50916$var$EMPTY_MOTION) {
    return {
        reducedMotion: 'never',
        ...inputMotion
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $c8c98acb96b2d75a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $c8c98acb96b2d75a$export$2e2bcd8739ae039 = $c8c98acb96b2d75a$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
function $cf65d72a2e809a1a$var$isSerializable(val) {
    return (0, $4fd70d36a8c127ef$export$53b83ca8eaab0383)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $cf65d72a2e809a1a$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$cf65d72a2e809a1a$var$isSerializable(value) || key.startsWith('unstable_') || key.startsWith('internal_')) delete object[key];
            else if ((0, $4fd70d36a8c127ef$export$53b83ca8eaab0383)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.motion = { reducedMotion: 'never', ...theme.motion };
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}



function $0bd31c645a6800a5$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $0bd31c645a6800a5$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
// `rgba()` takes rgb channels, so `hsl()` is converted like the theme's `*Channel` tokens.
function $0bd31c645a6800a5$var$toRgb(color) {
    return color.startsWith('hsl') ? (0, $3cec7b0dca18ba73$export$29fb7152bd3f781a)(color) : color;
}
// Replaces the `var()` matches in `alpha()`: `var(--x, #1976d2)` -> `var(--xChannel, 25 118 210)`.
// The fallback keeps the color valid when the CSS variables aren't defined (no `ThemeProvider`).
// It's dropped when it isn't a color `colorChannel()` parses, for example `currentColor` or a nested `var()`,
// or when it's a `color()`, whose channels aren't sRGB.
// More than one level of nested parentheses isn't supported: the match ends at the first run of `)`,
// so the rest of the fallback stays in the output.
function $0bd31c645a6800a5$var$toChannelVar(match, name, fallback = '') {
    const color = fallback.trim();
    if (color && !color.startsWith('color(')) try {
        const channel = (0, $3cec7b0dca18ba73$export$1b91fc959f7ee5a7)($0bd31c645a6800a5$var$toRgb(color));
        // Space-separated syntax like `rgb(0 0 0)` doesn't throw but gives a single value, or `NaN`s for `hsl()`.
        if (channel.split(' ').length === 3 && !channel.includes('NaN')) return `var(--${name}Channel, ${channel})`;
    } catch  {
    // Not a supported color.
    }
    return `var(--${name}Channel)`;
}
function $0bd31c645a6800a5$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) {
                // To preserve the behavior of the CSS theme variables
                // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
                // Raw colors (for example, `theme.palette.*`) have no channel tokens,
                // so they are converted to channels the same way the theme generates `*Channel` tokens,
                // which keeps a CSS coefficient (for example, `theme.vars.palette.action.hoverOpacity`) in `calc()`.
                const alphaValue = typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient;
                // `color()` channels are not sRGB, so only the alpha is replaced to keep any color space and unit.
                if (color.startsWith('color(')) return color.replace(/\s*(?:\/[^)]*)?\)$/, ` / ${alphaValue})`);
                const channels = color.includes('var(') ? color.replace(/var\(--([^,\s)]+)(?:,((?:[^()]|\([^()]*\))+)\)|(?:,[^)]+)?\)+)/g, $0bd31c645a6800a5$var$toChannelVar) : (0, $3cec7b0dca18ba73$export$427365fc3db6fc5e)($0bd31c645a6800a5$var$toRgb(color));
                return `rgba(${channels} / ${alphaValue})`;
            }
            return (0, $3cec7b0dca18ba73$export$58f0f39f63f3cf42)(color, $0bd31c645a6800a5$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$0bd31c645a6800a5$var$coefficientToPercentage(coefficient)})`;
            return (0, $3cec7b0dca18ba73$export$c0816ed86df316af)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$0bd31c645a6800a5$var$coefficientToPercentage(coefficient)})`;
            return (0, $3cec7b0dca18ba73$export$4b073707ff63303)(color, coefficient);
        }
    });
}
function $0bd31c645a6800a5$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, motion: motionInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $4bb17f8aebf76219$export$2e2bcd8739ae039)(22));
    const palette = (0, $5c2eba2e3b4b681b$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $26ee599f1d3ba50c$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $7e668da64b1a061e$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $1af552c663cdb802$export$2e2bcd8739ae039).slice(),
        typography: (0, $3036ca6f85f9eff7$export$2e2bcd8739ae039)(palette, typographyInput),
        motion: (0, $19ab7155bcc50916$export$2e2bcd8739ae039)(motionInput),
        transitions: (0, $009d61f99a58b06b$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $c8c98acb96b2d75a$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    // `reducedMotion` is owned by `theme.motion`; remove stale values preserved by systemCreateTheme.
    delete muiTheme.transitions.reducedMotion;
    // Normalize once so components read a resolved object, never the boolean. The color is a hex off
    // this (default) scheme; `createTheme` attaches a per-scheme copy so dark mode stays reactive.
    // Read the palette off `muiTheme` — a merge argument may have recolored it after `palette` was built.
    if (muiTheme.focusVisible != null && muiTheme.focusVisible !== false) muiTheme.focusVisible = (0, $6008f4971a0c21c7$export$c06a3c79efe1b1cf)(muiTheme.focusVisible, muiTheme.palette.primary.main);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $6687bde540046118$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $bf68d42d16534d7c$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $cf65d72a2e809a1a$export$32c2afa5f91892aa); // for Pigment CSS integration
    $0bd31c645a6800a5$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $0bd31c645a6800a5$export$2e2bcd8739ae039 = $0bd31c645a6800a5$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $f86e7318925bf4b2$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $037ffa36cf075a99$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $f86e7318925bf4b2$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $037ffa36cf075a99$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $037ffa36cf075a99$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $037ffa36cf075a99$var$defaultDarkOverlays : [];
}
function $037ffa36cf075a99$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $5c2eba2e3b4b681b$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$037ffa36cf075a99$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $037ffa36cf075a99$export$dd191566510330d3(palette.mode),
        ...other
    };
}


function $1dfec4146a4fcda6$export$2e2bcd8739ae039(keys) {
    return keys[0] === 'motion' || // Keep `focusVisible` inline: its values reference the per-component private vars
    // (`--_focusVisible-offset`/`-behavior`). Hoisted to a `:root` var they resolve where those
    // vars are unset, silently breaking the inner-ring inset.
    keys[0] === 'focusVisible' || !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $dc8000d63bb0f22d$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $dc8000d63bb0f22d$export$2e2bcd8739ae039 = $dc8000d63bb0f22d$var$excludeVariablesFromRoot;


var $8b881444a6bebb4b$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $dc8000d63bb0f22d$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };





function $a0a293c445d3ec2a$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $a0a293c445d3ec2a$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $a0a293c445d3ec2a$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $3cec7b0dca18ba73$export$29fb7152bd3f781a)(color);
}
function $a0a293c445d3ec2a$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $3cec7b0dca18ba73$export$427365fc3db6fc5e)($a0a293c445d3ec2a$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $a0a293c445d3ec2a$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $a0a293c445d3ec2a$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $a0a293c445d3ec2a$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $7a381217d0a161e7$exports.unstable_createGetCssVar)(cssVarPrefix);
function $a0a293c445d3ec2a$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $037ffa36cf075a99$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $0bd31c645a6800a5$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $037ffa36cf075a99$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $037ffa36cf075a99$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $a0a293c445d3ec2a$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $1dfec4146a4fcda6$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $a0a293c445d3ec2a$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $4bb17f8aebf76219$export$2e2bcd8739ae039)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $a0a293c445d3ec2a$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $a0a293c445d3ec2a$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $a0a293c445d3ec2a$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $9983ca1e458adb79$export$2e2bcd8739ae039)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $a0a293c445d3ec2a$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $a0a293c445d3ec2a$var$setColor(palette.common, 'background', '#fff');
            $a0a293c445d3ec2a$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $a0a293c445d3ec2a$var$setColor(palette.common, 'background', '#000');
            $a0a293c445d3ec2a$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // Generate `text.primaryChannel` before the component tokens:
        // `palette.Skeleton.bg` uses it as its CSS variable fallback.
        if (!nativeColor) $a0a293c445d3ec2a$var$setColorChannel(palette.text, 'primary');
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === (0, $3cec7b0dca18ba73$export$34109543fc7f43f8)) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === (0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512)) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === (0, $3cec7b0dca18ba73$export$aeeda94ef1d01275)) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $a0a293c445d3ec2a$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'Input',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorFilledColor', $a0a293c445d3ec2a$var$silent(()=>palette.getContrastText(palette.error.main)));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoFilledColor', $a0a293c445d3ec2a$var$silent(()=>palette.getContrastText(palette.info.main)));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successFilledColor', $a0a293c445d3ec2a$var$silent(()=>palette.getContrastText(palette.success.main)));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningFilledColor', $a0a293c445d3ec2a$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $a0a293c445d3ec2a$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $a0a293c445d3ec2a$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $a0a293c445d3ec2a$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $a0a293c445d3ec2a$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $a0a293c445d3ec2a$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $a0a293c445d3ec2a$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $a0a293c445d3ec2a$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $a0a293c445d3ec2a$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $a0a293c445d3ec2a$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $a0a293c445d3ec2a$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $a0a293c445d3ec2a$var$setColor(palette.Input, 'autofillWebkitBoxShadow', 'none');
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $3cec7b0dca18ba73$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'successTrack', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $3cec7b0dca18ba73$export$11bb74ba10c85505)(palette.background.default, 0.8);
            $a0a293c445d3ec2a$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $a0a293c445d3ec2a$var$setColor(palette.SnackbarContent, 'color', $a0a293c445d3ec2a$var$silent(()=>colorSpace ? (0, $5c2eba2e3b4b681b$export$55ce6f3a06c59543).text.primary : palette.getContrastText(snackbarContentBackground)));
            $a0a293c445d3ec2a$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $3cec7b0dca18ba73$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $a0a293c445d3ec2a$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $a0a293c445d3ec2a$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            $a0a293c445d3ec2a$var$setColor(palette.TableCell, 'border', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), (0, $3cec7b0dca18ba73$export$34109543fc7f43f8)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.88));
            $a0a293c445d3ec2a$var$setColor(palette.Tooltip, 'bg', colorMix((0, $3cec7b0dca18ba73$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningColor', colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorFilledColor', $a0a293c445d3ec2a$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoFilledColor', $a0a293c445d3ec2a$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successFilledColor', $a0a293c445d3ec2a$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningFilledColor', $a0a293c445d3ec2a$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $a0a293c445d3ec2a$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $a0a293c445d3ec2a$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $a0a293c445d3ec2a$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $a0a293c445d3ec2a$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $a0a293c445d3ec2a$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $a0a293c445d3ec2a$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $a0a293c445d3ec2a$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $a0a293c445d3ec2a$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $a0a293c445d3ec2a$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $a0a293c445d3ec2a$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $a0a293c445d3ec2a$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $a0a293c445d3ec2a$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $a0a293c445d3ec2a$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $a0a293c445d3ec2a$var$setColor(palette.Input, 'autofillWebkitBoxShadow', '0 0 0 100px #266798 inset');
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $3cec7b0dca18ba73$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'successTrack', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $a0a293c445d3ec2a$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix((0, $3cec7b0dca18ba73$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $3cec7b0dca18ba73$export$11bb74ba10c85505)(palette.background.default, 0.98);
            $a0a293c445d3ec2a$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $a0a293c445d3ec2a$var$setColor(palette.SnackbarContent, 'color', $a0a293c445d3ec2a$var$silent(()=>colorSpace ? (0, $5c2eba2e3b4b681b$export$a43af521ac8c3202).text.primary : palette.getContrastText(snackbarContentBackground)));
            $a0a293c445d3ec2a$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $3cec7b0dca18ba73$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $a0a293c445d3ec2a$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $a0a293c445d3ec2a$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.55));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.55));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.55));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.55));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.55));
            $a0a293c445d3ec2a$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.55));
            $a0a293c445d3ec2a$var$setColor(palette.TableCell, 'border', colorMix((0, $3cec7b0dca18ba73$export$eaaef2dca3e9e512), (0, $3cec7b0dca18ba73$export$34109543fc7f43f8)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.68));
            $a0a293c445d3ec2a$var$setColor(palette.Tooltip, 'bg', colorMix((0, $3cec7b0dca18ba73$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (!nativeColor) {
            $a0a293c445d3ec2a$var$setColorChannel(palette.background, 'default');
            // added for consistency with the `background.default` token
            $a0a293c445d3ec2a$var$setColorChannel(palette.background, 'paper');
            $a0a293c445d3ec2a$var$setColorChannel(palette.common, 'background');
            $a0a293c445d3ec2a$var$setColorChannel(palette.common, 'onBackground');
            $a0a293c445d3ec2a$var$setColorChannel(palette, 'divider');
        }
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && !nativeColor && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $a0a293c445d3ec2a$var$setColor(palette[color], 'mainChannel', (0, $3cec7b0dca18ba73$export$427365fc3db6fc5e)($a0a293c445d3ec2a$var$toRgb(colors.main)));
                if (colors.light) $a0a293c445d3ec2a$var$setColor(palette[color], 'lightChannel', (0, $3cec7b0dca18ba73$export$427365fc3db6fc5e)($a0a293c445d3ec2a$var$toRgb(colors.light)));
                if (colors.dark) $a0a293c445d3ec2a$var$setColor(palette[color], 'darkChannel', (0, $3cec7b0dca18ba73$export$427365fc3db6fc5e)($a0a293c445d3ec2a$var$toRgb(colors.dark)));
                if (colors.contrastText) $a0a293c445d3ec2a$var$setColor(palette[color], 'contrastTextChannel', (0, $3cec7b0dca18ba73$export$427365fc3db6fc5e)($a0a293c445d3ec2a$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $a0a293c445d3ec2a$var$setColorChannel(palette[color], 'primary');
                    $a0a293c445d3ec2a$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $a0a293c445d3ec2a$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $a0a293c445d3ec2a$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $4fd70d36a8c127ef$export$2e2bcd8739ae039)(acc, argument), theme);
    // Default color is the palette var, not a hex: `focusVisible` is spread inline (skipped from var
    // generation, see `shouldSkipGeneratingVar`), so the var adapts per scheme at the CSS level — no
    // per-scheme copy needed here, unlike the no-vars path in `createTheme`.
    const focusVisibleInput = (0, $6008f4971a0c21c7$export$5d0f425d284660f4)(options.focusVisible, args);
    if (focusVisibleInput != null && focusVisibleInput !== false) theme.focusVisible = (0, $6008f4971a0c21c7$export$c06a3c79efe1b1cf)(focusVisibleInput, getCssVar('palette-primary-main'));
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $8b881444a6bebb4b$export$2e2bcd8739ae039)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $c230e75f8b4cffe8$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $7a381217d0a161e7$exports.createSpacing)(input.spacing, (0, $5029271411efa0d8$export$1def6f833384e3d1)(this));
    };
    theme.getColorSchemeSelector = (0, $3fda1a73f9aa39fb$export$858538ff6c0d421d)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $6687bde540046118$export$2e2bcd8739ae039),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $bf68d42d16534d7c$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    theme.internal_cache = {};
    theme.toRuntimeSource = (0, $cf65d72a2e809a1a$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $65495f85012dc470$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $5c2eba2e3b4b681b$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $65495f85012dc470$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $0bd31c645a6800a5$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $0bd31c645a6800a5$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $65495f85012dc470$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $65495f85012dc470$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        if (theme.focusVisible != null && theme.focusVisible !== false) {
            let focusVisibleInput = theme.focusVisible;
            const rawFocusVisible = (0, $6008f4971a0c21c7$export$5d0f425d284660f4)(options.focusVisible, args);
            const authoredColor = rawFocusVisible && typeof rawFocusVisible === 'object' ? rawFocusVisible.outlineColor : undefined;
            // A re-composed theme carries a baked default that looks authored, so it falls back to value
            // equality — the one case where a pinned `primary.main` is indistinguishable and gets reset.
            if (!authoredColor || (0, $6008f4971a0c21c7$export$685950156577a061)(rawFocusVisible) && authoredColor === theme.palette.primary.main) {
                const { outlineColor: outlineColor, ...rest } = focusVisibleInput;
                focusVisibleInput = rest;
            }
            Object.keys(theme.colorSchemes).forEach((scheme)=>{
                const schemePalette = theme.colorSchemes?.[scheme]?.palette;
                if (schemePalette?.primary) theme.colorSchemes[scheme].focusVisible = (0, $6008f4971a0c21c7$export$c06a3c79efe1b1cf)(focusVisibleInput, schemePalette.primary.main);
            });
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $a0a293c445d3ec2a$export$2e2bcd8739ae039)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


'use client';
const $0f8cf60adfaec275$var$defaultTheme = (0, $65495f85012dc470$export$2e2bcd8739ae039)();
var $0f8cf60adfaec275$export$2e2bcd8739ae039 = $0f8cf60adfaec275$var$defaultTheme;


var $19d5729378c2b81d$export$2e2bcd8739ae039 = '$$material';


// copied from @mui/system/createStyled
function $90351edcddb68163$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $90351edcddb68163$export$2e2bcd8739ae039 = $90351edcddb68163$var$slotShouldForwardProp;


const $710b5e22b13b2b07$var$rootShouldForwardProp = (prop)=>(0, $90351edcddb68163$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $710b5e22b13b2b07$export$2e2bcd8739ae039 = $710b5e22b13b2b07$var$rootShouldForwardProp;



'use client';
const $8a4cdf55065ef950$var$styled = (0, $feef0a6b75fad08f$export$2e2bcd8739ae039)({
    themeId: (0, $19d5729378c2b81d$export$2e2bcd8739ae039),
    defaultTheme: $0f8cf60adfaec275$export$2e2bcd8739ae039,
    rootShouldForwardProp: $710b5e22b13b2b07$export$2e2bcd8739ae039
});
var $8a4cdf55065ef950$export$2e2bcd8739ae039 = $8a4cdf55065ef950$var$styled;



const $359bea9585b24b02$var$memoTheme = (0, $7a381217d0a161e7$exports.unstable_memoTheme);
var $359bea9585b24b02$export$2e2bcd8739ae039 = $359bea9585b24b02$var$memoTheme;


parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");
function $e7144867d0b2336e$export$2e2bcd8739ae039(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    const defaultSlotPropValue = defaultSlotProps[slotPropName];
                    const slotPropValue = slotProps[slotPropName];
                    if (typeof defaultSlotPropValue === 'function' || typeof slotPropValue === 'function') // Function slot props are resolved later (with `ownerState`), so defer
                    // the merge until then to avoid dropping either side.
                    output[propName][slotPropName] = (...args)=>$e7144867d0b2336e$export$2e2bcd8739ae039((typeof defaultSlotPropValue === 'function' ? defaultSlotPropValue(...args) : defaultSlotPropValue) ?? {}, (typeof slotPropValue === 'function' ? slotPropValue(...args) : slotPropValue) ?? {}, mergeClassNameAndStyle);
                    else output[propName][slotPropName] = $e7144867d0b2336e$export$2e2bcd8739ae039(defaultSlotPropValue ?? {}, slotPropValue ?? {}, mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className !== undefined) output.className = (0, $i6kju.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7220f548f8dec7e9$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $7220f548f8dec7e9$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7220f548f8dec7e9$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $7220f548f8dec7e9$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $e7144867d0b2336e$export$2e2bcd8739ae039)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $e7144867d0b2336e$export$2e2bcd8739ae039)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $7220f548f8dec7e9$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($7220f548f8dec7e9$var$PropsContext);
    return $7220f548f8dec7e9$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $7220f548f8dec7e9$export$2e2bcd8739ae039 = $7220f548f8dec7e9$var$DefaultPropsProvider;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $6a1de905cde5d0a2$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7220f548f8dec7e9$export$2e2bcd8739ae039), {
        ...props
    });
}
var $6a1de905cde5d0a2$export$2e2bcd8739ae039 = $6a1de905cde5d0a2$var$DefaultPropsProvider;
function $6a1de905cde5d0a2$export$2440da353cedad43(params) {
    return (0, $7220f548f8dec7e9$export$2440da353cedad43)(params);
}



var $acw62 = parcelRequire("acw62");
'use client';
function $afff313482a01a82$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $acw62.useRef(undefined);
    const refEffect = $acw62.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    }, refs);
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    }, refs);
}


'use client';
var $7fb1cf77ea0dd990$export$2e2bcd8739ae039 = (0, $afff313482a01a82$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $967a259de18467ad$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $967a259de18467ad$export$2e2bcd8739ae039 = $967a259de18467ad$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/react/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $3f322b58d5a98d7f$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $967a259de18467ad$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $3f322b58d5a98d7f$export$2e2bcd8739ae039 = $3f322b58d5a98d7f$var$useEventCallback;


'use client';
var $f0eae19b326afc52$export$2e2bcd8739ae039 = (0, $3f322b58d5a98d7f$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
function $d80c458d1c6f724c$export$2e2bcd8739ae039(parameters) {
    const { focusableWhenDisabled: focusableWhenDisabled, disabled: disabled, composite: composite = false, tabIndex: tabIndexProp = 0, isNativeButton: isNativeButton } = parameters;
    const isFocusableComposite = composite && focusableWhenDisabled !== false;
    const isNonFocusableComposite = composite && focusableWhenDisabled === false;
    // we can't explicitly assign `undefined` to any of these props because it
    // would otherwise prevent subsequently merged props from setting them
    const props = $acw62.useMemo(()=>{
        const additionalProps = {
            // allow Tabbing away from focusableWhenDisabled elements
            onKeyDown (event) {
                if (disabled && focusableWhenDisabled && event.key !== 'Tab') event.preventDefault();
            }
        };
        if (!composite) {
            additionalProps.tabIndex = tabIndexProp;
            if (!isNativeButton && disabled) additionalProps.tabIndex = focusableWhenDisabled ? tabIndexProp : -1;
        }
        if (isNativeButton && (focusableWhenDisabled || isFocusableComposite) || !isNativeButton && disabled) additionalProps['aria-disabled'] = disabled;
        if (isNativeButton && (!focusableWhenDisabled || isNonFocusableComposite)) additionalProps.disabled = disabled;
        return additionalProps;
    }, [
        composite,
        disabled,
        focusableWhenDisabled,
        isFocusableComposite,
        isNonFocusableComposite,
        isNativeButton,
        tabIndexProp
    ]);
    return props;
}


'use client';
const $a5a2de51637198b1$var$EMPTY = {};
function $a5a2de51637198b1$export$2e2bcd8739ae039(parameters) {
    const { nativeButton: nativeButton, nativeButtonProp: nativeButtonProp, internalNativeButton: internalNativeButton = nativeButton, allowInferredHostMismatch: allowInferredHostMismatch = false, disabled: disabled, type: type, hasFormAction: hasFormAction = false, tabIndex: tabIndex = 0, focusableWhenDisabled: focusableWhenDisabledParam, stopEventPropagation: stopEventPropagation = false, onBeforeKeyDown: onBeforeKeyDown, onBeforeKeyUp: onBeforeKeyUp } = parameters;
    const rootRef = $acw62.useRef(null);
    const focusableWhenDisabled = focusableWhenDisabledParam === true;
    const focusableWhenDisabledProps = (0, $d80c458d1c6f724c$export$2e2bcd8739ae039)({
        focusableWhenDisabled: focusableWhenDisabled,
        disabled: disabled,
        isNativeButton: nativeButton,
        tabIndex: tabIndex
    });
    // A helper for event handlers to determine whether to use browser-defined keyboard activation
    // for native elements like <button> and <a href>, or synthesize Enter/Space clicks for non-native
    // elements like `<div role="button">`.
    // This is UNSAFE TO USE outside of event handers, e.g. in render.
    const hasNativeKeyboardActivation = $acw62.useCallback(()=>{
        const root = rootRef.current;
        if (root == null) return nativeButton;
        if (root.tagName === 'BUTTON') return true;
        // Although this hook is not intended for links, this check is for
        // backward compatibility with `<ButtonBase href="#" />` since ButtonBase
        // uses the returned event handlers.
        return Boolean(root.tagName === 'A' && root.href);
    }, [
        nativeButton
    ]);
    const buttonProps = $acw62.useMemo(()=>{
        const resolvedButtonProps = focusableWhenDisabled ? {} : {
            tabIndex: disabled ? -1 : tabIndex
        };
        if (nativeButton) {
            resolvedButtonProps.type = type === undefined && !hasFormAction ? 'button' : type;
            if (!focusableWhenDisabled) resolvedButtonProps.disabled = disabled;
        } else {
            resolvedButtonProps.role = 'button';
            if (!focusableWhenDisabled && disabled) resolvedButtonProps['aria-disabled'] = disabled;
        }
        if (focusableWhenDisabled) return {
            ...resolvedButtonProps,
            ...focusableWhenDisabledProps
        };
        return resolvedButtonProps;
    }, [
        disabled,
        focusableWhenDisabled,
        focusableWhenDisabledProps,
        hasFormAction,
        nativeButton,
        tabIndex,
        type
    ]);
    const getButtonProps = $acw62.useCallback((externalProps = $a5a2de51637198b1$var$EMPTY)=>{
        const { onClick: externalOnClick, onKeyDown: externalOnKeyDown, onKeyUp: externalOnKeyUp, ...otherExternalProps } = externalProps;
        const handleClick = (event)=>{
            if (stopEventPropagation) event.stopPropagation();
            if (disabled) {
                event.preventDefault();
                return;
            }
            externalOnClick?.(event);
        };
        const handleKeyDown = (event)=>{
            if (focusableWhenDisabled) focusableWhenDisabledProps.onKeyDown(event);
            if (disabled) return;
            onBeforeKeyDown?.(event);
            externalOnKeyDown?.(event);
            if (event.target !== event.currentTarget || hasNativeKeyboardActivation()) return;
            if (event.key === ' ') {
                event.preventDefault();
                return;
            }
            if (event.key === 'Enter') {
                event.preventDefault();
                event.currentTarget.click();
            }
        };
        const handleKeyUp = (event)=>{
            if (disabled) return;
            onBeforeKeyUp?.(event);
            externalOnKeyUp?.(event);
            if (event.target === event.currentTarget && !hasNativeKeyboardActivation() && event.key === ' ' && !event.defaultPrevented) event.currentTarget.click();
        };
        return {
            ...buttonProps,
            ...otherExternalProps,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp
        };
    }, [
        buttonProps,
        disabled,
        focusableWhenDisabled,
        focusableWhenDisabledProps,
        hasNativeKeyboardActivation,
        onBeforeKeyDown,
        onBeforeKeyUp,
        stopEventPropagation
    ]);
    return {
        getButtonProps: getButtonProps,
        rootRef: rootRef
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $0abdae095c0ec07c$var$UNINITIALIZED = {};
function $0abdae095c0ec07c$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($0abdae095c0ec07c$var$UNINITIALIZED);
    if (ref.current === $0abdae095c0ec07c$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


'use client';
class $3ad8ad8d4bfb7dc7$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ ref = {
        current: null
    };
    /** If the ripple component should be mounted */ shouldMount = false;
    /** Promise that resolves when the ripple component is mounted */ mounted = null;
    /** If the ripple component has been mounted */ didMount = false;
    /** React state hook setter */ setShouldMount = null;
    static create() {
        return new $3ad8ad8d4bfb7dc7$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $0abdae095c0ec07c$export$2e2bcd8739ae039)($3ad8ad8d4bfb7dc7$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $acw62.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $acw62.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $3ad8ad8d4bfb7dc7$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) this.didMount = true;
            this.mounted.resolve();
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $3ad8ad8d4bfb7dc7$export$2e2bcd8739ae039() {
    return $3ad8ad8d4bfb7dc7$export$f5de0641c7db4154.use();
}
function $3ad8ad8d4bfb7dc7$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");

var $acw62 = parcelRequire("acw62");
'use client';
const $3e36a957f4089f0a$var$EMPTY = [];
function $3e36a957f4089f0a$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $3e36a957f4089f0a$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }




'use client';
class $c99c981e408250a5$export$786b4da70f00938b {
    static create() {
        return new $c99c981e408250a5$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $c99c981e408250a5$export$2e2bcd8739ae039() {
    const timeout = (0, $0abdae095c0ec07c$export$2e2bcd8739ae039)($c99c981e408250a5$export$786b4da70f00938b.create).current;
    (0, $3e36a957f4089f0a$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


parcelRequire("acw62");



'use client';
function $4aedf03183da9f32$export$2e2bcd8739ae039() {
    const theme = (0, $7a381217d0a161e7$exports.useTheme)((0, $0f8cf60adfaec275$export$2e2bcd8739ae039));
    return theme[0, $19d5729378c2b81d$export$2e2bcd8739ae039] || theme;
}




var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $d0a1433ac44abbf6$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const exitTimer = (0, $c99c981e408250a5$export$2e2bcd8739ae039)();
    const exitTimerStartedRef = $acw62.useRef(false);
    const onExitedRef = $acw62.useRef(onExited);
    onExitedRef.current = onExited;
    const hasExitedCallback = onExited != null;
    const rippleClassName = (0, $i6kju.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $i6kju.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && hasExitedCallback) {
            if (!exitTimerStartedRef.current) {
                exitTimerStartedRef.current = true;
                exitTimer.start(timeout, ()=>{
                    exitTimerStartedRef.current = false;
                    onExitedRef.current?.();
                });
            }
        } else {
            exitTimerStartedRef.current = false;
            exitTimer.clear();
        }
    }, [
        exitTimer,
        hasExitedCallback,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $d0a1433ac44abbf6$export$2e2bcd8739ae039 = $d0a1433ac44abbf6$var$Ripple;


const $28f74f9ac8531dca$var$defaultGenerator = (componentName)=>componentName;
const $28f74f9ac8531dca$var$createClassNameGenerator = ()=>{
    let generate = $28f74f9ac8531dca$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $28f74f9ac8531dca$var$defaultGenerator;
        }
    };
};
const $28f74f9ac8531dca$var$ClassNameGenerator = $28f74f9ac8531dca$var$createClassNameGenerator();
var $28f74f9ac8531dca$export$2e2bcd8739ae039 = $28f74f9ac8531dca$var$ClassNameGenerator;


const $93a6cb9d9dc4fcae$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $93a6cb9d9dc4fcae$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $93a6cb9d9dc4fcae$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $28f74f9ac8531dca$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $93a6cb9d9dc4fcae$export$34c0130b1f3e8ae3(slot) {
    return $93a6cb9d9dc4fcae$export$9d6b9120de57c54[slot] !== undefined;
}


function $606a27dd08e5ad31$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $a2944c3ae7fbb6d7$export$b464606f735ab902(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $a2944c3ae7fbb6d7$var$touchRippleClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $a2944c3ae7fbb6d7$export$2e2bcd8739ae039 = $a2944c3ae7fbb6d7$var$touchRippleClasses;




var $acw62 = parcelRequire("acw62");

'use client';
const $d2f0cec57b8373ec$var$MEDIA_QUERY = '(prefers-reduced-motion: reduce)';
const $d2f0cec57b8373ec$var$REDUCED_MOTION_DURATION = 0;
const $d2f0cec57b8373ec$var$REDUCED_MOTION_DELAY = '0ms';
const $d2f0cec57b8373ec$var$NOOP = ()=>{};
const $d2f0cec57b8373ec$var$getDefaultSnapshot = ()=>false;
const $d2f0cec57b8373ec$var$getReducedMotionSnapshot = ()=>true;
const $d2f0cec57b8373ec$var$subscribeNoop = ()=>$d2f0cec57b8373ec$var$NOOP;
/**
 * Subscribes to the OS reduced-motion media query only when the theme mode needs it.
 * React 17 reads the media query after mount, matching useMediaQuery's fallback path.
 */ function $d2f0cec57b8373ec$var$useReducedMotionMediaQueryOld(enabled) {
    const [queryState, setQueryState] = $acw62.useState(()=>({
            enabled: enabled,
            matches: enabled ? null : false
        }));
    let matches = queryState.matches;
    if (queryState.enabled !== enabled) {
        matches = null;
        if (!enabled) matches = false;
    }
    (0, $967a259de18467ad$export$2e2bcd8739ae039)(()=>{
        const setResolvedMatches = (nextMatches)=>{
            setQueryState((previousState)=>{
                if (previousState.enabled === enabled && previousState.matches === nextMatches) return previousState;
                return {
                    enabled: enabled,
                    matches: nextMatches
                };
            });
        };
        if (!enabled) {
            if (queryState.enabled) setResolvedMatches(false);
            return undefined;
        }
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            setResolvedMatches(false);
            return undefined;
        }
        const mediaQueryList = window.matchMedia($d2f0cec57b8373ec$var$MEDIA_QUERY);
        const update = ()=>{
            setResolvedMatches(mediaQueryList.matches);
        };
        update();
        mediaQueryList.addEventListener('change', update);
        return ()=>{
            mediaQueryList.removeEventListener('change', update);
        };
    }, [
        enabled,
        queryState.enabled
    ]);
    return matches;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $d2f0cec57b8373ec$var$safeReact = {
    ...$acw62
};
const $d2f0cec57b8373ec$var$maybeReactUseSyncExternalStore = $d2f0cec57b8373ec$var$safeReact.useSyncExternalStore;
/**
 * React 18+ can read the media query during client renders, so newly mounted
 * transitions do not start from the SSR-safe reduced-motion default.
 */ function $d2f0cec57b8373ec$var$useReducedMotionMediaQueryNew(enabled) {
    const getServerSnapshot = enabled ? $d2f0cec57b8373ec$var$getReducedMotionSnapshot : $d2f0cec57b8373ec$var$getDefaultSnapshot;
    const [getSnapshot, subscribe] = $acw62.useMemo(()=>{
        if (!enabled || typeof window === 'undefined' || typeof window.matchMedia !== 'function') return [
            $d2f0cec57b8373ec$var$getDefaultSnapshot,
            $d2f0cec57b8373ec$var$subscribeNoop
        ];
        const mediaQueryList = window.matchMedia($d2f0cec57b8373ec$var$MEDIA_QUERY);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        enabled
    ]);
    return $d2f0cec57b8373ec$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
const $d2f0cec57b8373ec$var$useReducedMotionMediaQuery = $d2f0cec57b8373ec$var$maybeReactUseSyncExternalStore !== undefined ? $d2f0cec57b8373ec$var$useReducedMotionMediaQueryNew : $d2f0cec57b8373ec$var$useReducedMotionMediaQueryOld;
function $d2f0cec57b8373ec$export$2e2bcd8739ae039(mode, disablePrefersReducedMotion) {
    const prefersReducedMotion = $d2f0cec57b8373ec$var$useReducedMotionMediaQuery(!disablePrefersReducedMotion && mode === 'system');
    const shouldReduceMotion = !disablePrefersReducedMotion && (mode === 'always' || mode === 'system' && prefersReducedMotion !== false);
    return $acw62.useMemo(()=>({
            shouldReduceMotion: shouldReduceMotion,
            getTransitionTiming (timing) {
                if (!shouldReduceMotion) return timing;
                return {
                    duration: $d2f0cec57b8373ec$var$REDUCED_MOTION_DURATION,
                    delay: $d2f0cec57b8373ec$var$REDUCED_MOTION_DELAY
                };
            }
        }), [
        shouldReduceMotion
    ]);
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0c7f413ef6ed7ded$var$DURATION = 550;
const $0c7f413ef6ed7ded$export$95d0c9356b2231a3 = 80;
const $0c7f413ef6ed7ded$var$EMPTY_OBJ = {};
const $0c7f413ef6ed7ded$var$EMPTY_ARRAY = [];
const $0c7f413ef6ed7ded$var$NOOP = ()=>{};
/**
 * Keep the same DOM order TouchRipple had when it used react-transition-group:
 * exiting ripples stay in place, and new ripples are inserted before the final
 * group of ripples that are waiting for their exit animation to finish.
 *
 * @param {number[]} prevOrder The previous DOM order, including ripples that may be exiting.
 * @param {number[]} nextActiveKeys The ripples that should still be treated as active.
 * @returns {number[]} The next DOM order, preserving the position of exiting ripples where possible.
 */ function $0c7f413ef6ed7ded$var$mergeRippleOrder(prevOrder, nextActiveKeys) {
    const nextKeySet = new Set(nextActiveKeys);
    const nextKeysPending = new Map();
    let pendingKeys = [];
    for (const prevKey of prevOrder){
        if (nextKeySet.has(prevKey)) {
            if (pendingKeys.length > 0) {
                nextKeysPending.set(prevKey, pendingKeys);
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    const nextOrder = [];
    for (const nextKey of nextActiveKeys){
        const pendingBefore = nextKeysPending.get(nextKey);
        if (pendingBefore) nextOrder.push(...pendingBefore);
        nextOrder.push(nextKey);
    }
    nextOrder.push(...pendingKeys);
    return nextOrder;
}
/**
 * Calculate where the ripple should start and how large it must be to cover the host element.
 *
 * @param {object} params
 * @param {object} params.event The mouse or touch event that started the ripple.
 * @param {HTMLElement | null} params.element The host element used for measurements. Tests pass `null`.
 * @param {boolean} params.center If `true`, start the ripple from the center of the host element.
 * @returns {{ rippleX: number, rippleY: number, rippleSize: number }} The ripple position and size.
 */ function $0c7f413ef6ed7ded$var$computeRippleState({ event: event, element: element, center: center }) {
    const rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
    };
    let rippleX;
    let rippleY;
    if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
    } else {
        const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
    }
    let rippleSize;
    if (center) {
        rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
        // Mobile Chrome can skip this animation for even pixel sizes.
        if (rippleSize % 2 === 0) rippleSize += 1;
    } else {
        const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }
    return {
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
    };
}
const $0c7f413ef6ed7ded$var$enterKeyframe = (0, $7a381217d0a161e7$exports.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $0c7f413ef6ed7ded$var$exitKeyframe = (0, $7a381217d0a161e7$exports.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $0c7f413ef6ed7ded$var$pulsateKeyframe = (0, $7a381217d0a161e7$exports.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
function $0c7f413ef6ed7ded$var$getAnimationStyles(theme) {
    if (theme.motion.reducedMotion === 'always') return null;
    const styles = (0, $7a381217d0a161e7$exports.css)`
    &.${(0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).rippleVisible} {
      animation-name: ${$0c7f413ef6ed7ded$var$enterKeyframe};
      animation-duration: ${$0c7f413ef6ed7ded$var$DURATION}ms;
      animation-timing-function: ${theme.transitions.easing.easeInOut};
    }

    &.${(0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).ripplePulsate} {
      animation-duration: ${theme.transitions.duration.shorter}ms;
    }

    & .${(0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).childLeaving} {
      animation-name: ${$0c7f413ef6ed7ded$var$exitKeyframe};
      animation-duration: ${$0c7f413ef6ed7ded$var$DURATION}ms;
      animation-timing-function: ${theme.transitions.easing.easeInOut};
    }

    & .${(0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).childPulsate} {
      animation-name: ${$0c7f413ef6ed7ded$var$pulsateKeyframe};
      animation-duration: 2500ms;
      animation-timing-function: ${theme.transitions.easing.easeInOut};
      animation-iteration-count: infinite;
      animation-delay: 200ms;
    }
  `;
    if (theme.motion.reducedMotion === 'system') return (0, $7a381217d0a161e7$exports.css)`
      @media (prefers-reduced-motion: no-preference) {
        ${styles}
      }
    `;
    return styles;
}
const $0c7f413ef6ed7ded$export$f6b7418508c72c25 = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $0c7f413ef6ed7ded$export$676cfe7b12693c4b = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)((0, $d0a1433ac44abbf6$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
  }

  /*
   * Order matters: 'child', 'childLeaving' and 'childPulsate' apply to the same
   * element with equal specificity, so the later rule wins. 'child' must come
   * before 'childLeaving' so the leaving 'opacity: 0' takes precedence. A focus
   * (pulsate) ripple keeps 'pulsateKeyframe' (no opacity animation) on exit, so
   * it relies on this static 'opacity: 0' to disappear on blur instead of
   * lingering until removal.
   */
  & .${(0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
  }

  & .${(0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
  }

  ${({ theme: theme })=>$0c7f413ef6ed7ded$var$getAnimationStyles(theme)}
`;
/**
 * @ignore - internal component.
 */ const $0c7f413ef6ed7ded$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const theme = (0, $4aedf03183da9f32$export$2e2bcd8739ae039)();
    const reducedMotion = (0, $d2f0cec57b8373ec$export$2e2bcd8739ae039)(theme.motion.reducedMotion, false);
    const { center: centerProp = false, classes: classes = $0c7f413ef6ed7ded$var$EMPTY_OBJ, className: className, ...other } = props;
    // Store ripples as data so we can keep exiting ripples mounted until their
    // exit animation ends. Ripple calls onExited when it is safe to remove one.
    const [rippleState, setRippleState] = $acw62.useState({
        items: $0c7f413ef6ed7ded$var$EMPTY_ARRAY,
        order: $0c7f413ef6ed7ded$var$EMPTY_ARRAY
    });
    const ripples = rippleState.items;
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    const mountedRef = $acw62.useRef(false);
    (0, $3e36a957f4089f0a$export$2e2bcd8739ae039)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    });
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $c99c981e408250a5$export$2e2bcd8739ae039)();
    // Holds delayed touch-start work until the delay expires or touchend forces it to run.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const handleExited = (0, $f0eae19b326afc52$export$2e2bcd8739ae039)((key)=>{
        if (!mountedRef.current) return;
        setRippleState((prevState)=>{
            const nextItems = prevState.items.filter((ripple)=>ripple.key !== key);
            const nextOrder = $0c7f413ef6ed7ded$var$mergeRippleOrder(prevState.order.filter((rippleKey)=>rippleKey !== key), nextItems.filter((ripple)=>!ripple.exiting).map((ripple)=>ripple.key));
            return {
                items: nextItems,
                order: nextOrder
            };
        });
    });
    const startCommit = (0, $f0eae19b326afc52$export$2e2bcd8739ae039)((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        const key = nextKey.current;
        nextKey.current += 1;
        setRippleState((prevState)=>{
            const nextItems = [
                ...prevState.items,
                {
                    key: key,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize,
                    exiting: false
                }
            ];
            return {
                items: nextItems,
                order: $0c7f413ef6ed7ded$var$mergeRippleOrder(prevState.order, nextItems.filter((ripple)=>!ripple.exiting).map((ripple)=>ripple.key))
            };
        });
        rippleCallback.current = cb;
    });
    const start = (0, $f0eae19b326afc52$export$2e2bcd8739ae039)((event = $0c7f413ef6ed7ded$var$EMPTY_OBJ, options = $0c7f413ef6ed7ded$var$EMPTY_OBJ, cb = $0c7f413ef6ed7ded$var$NOOP)=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // Used only by tests.
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const { rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize } = $0c7f413ef6ed7ded$var$computeRippleState({
            event: event,
            element: element,
            center: center
        });
        // Delay touch ripples so scroll gestures do not flash a ripple.
        if (event?.touches) // Ignore extra touchstart events from multi-touch. There is only one
        // delayed start callback to clear on unmount.
        {
            if (startTimerCommit.current === null) {
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                startTimer.start($0c7f413ef6ed7ded$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    });
    const pulsate = (0, $f0eae19b326afc52$export$2e2bcd8739ae039)(()=>{
        start($0c7f413ef6ed7ded$var$EMPTY_OBJ, {
            pulsate: true
        });
    });
    const stop = (0, $f0eae19b326afc52$export$2e2bcd8739ae039)((event, cb)=>{
        startTimer.clear();
        // If touch ends before the delay finishes, show the ripple now and stop it
        // on the next tick so the user still gets feedback.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRippleState((prevState)=>{
            const firstActiveIndex = prevState.items.findIndex((ripple)=>!ripple.exiting);
            if (firstActiveIndex === -1) return prevState;
            const nextItems = prevState.items.slice();
            nextItems[firstActiveIndex] = {
                ...nextItems[firstActiveIndex],
                exiting: true
            };
            return {
                items: nextItems,
                order: $0c7f413ef6ed7ded$var$mergeRippleOrder(prevState.order, nextItems.filter((ripple)=>!ripple.exiting).map((ripple)=>ripple.key))
            };
        });
        rippleCallback.current = cb;
    });
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    const rippleByKey = new Map(ripples.map((ripple)=>[
            ripple.key,
            ripple
        ]));
    const orderedRipples = rippleState.order.map((rippleKey)=>rippleByKey.get(rippleKey)).filter(Boolean);
    // Keep the old react-transition-group DOM order:
    // exiting ripples stay in place, and new ripples are inserted before the
    // final group waiting for its exit animation to finish.
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0c7f413ef6ed7ded$export$f6b7418508c72c25, {
        className: (0, $i6kju.default)((0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: orderedRipples.map((ripple)=>/*#__PURE__*/ (0, $ayMG0.jsx)($0c7f413ef6ed7ded$export$676cfe7b12693c4b, {
                classes: {
                    ripple: (0, $i6kju.default)(classes.ripple, (0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).ripple),
                    rippleVisible: (0, $i6kju.default)(classes.rippleVisible, (0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).rippleVisible),
                    ripplePulsate: (0, $i6kju.default)(classes.ripplePulsate, (0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).ripplePulsate),
                    child: (0, $i6kju.default)(classes.child, (0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).child),
                    childLeaving: (0, $i6kju.default)(classes.childLeaving, (0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).childLeaving),
                    childPulsate: (0, $i6kju.default)(classes.childPulsate, (0, $a2944c3ae7fbb6d7$export$2e2bcd8739ae039).childPulsate)
                },
                timeout: reducedMotion.shouldReduceMotion ? 0 : $0c7f413ef6ed7ded$var$DURATION,
                pulsate: ripple.pulsate,
                rippleX: ripple.rippleX,
                rippleY: ripple.rippleY,
                rippleSize: ripple.rippleSize,
                in: !ripple.exiting,
                onExited: ()=>handleExited(ripple.key)
            }, ripple.key))
    });
});
var $0c7f413ef6ed7ded$export$2e2bcd8739ae039 = $0c7f413ef6ed7ded$var$TouchRipple;




function $3b4238fa67449b77$export$fccb0498dcd99783(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $3b4238fa67449b77$var$buttonBaseClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $3b4238fa67449b77$export$2e2bcd8739ae039 = $3b4238fa67449b77$var$buttonBaseClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $c3b5036e07dbc2e6$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, suppressFocusVisible: suppressFocusVisible, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && !suppressFocusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (0, $3b4238fa67449b77$export$fccb0498dcd99783), classes);
    if (focusVisible && !suppressFocusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $c3b5036e07dbc2e6$export$7ec0dcc5e3cdcd36 = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        textDecoration: 'none',
        // So we take precedent over the style of a native <a /> element.
        color: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $3b4238fa67449b77$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            // Disable link interactions
            cursor: 'default'
        },
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            {
                props: {
                    internalDisabledThemeFocusVisible: false
                },
                style: theme.focusVisible && {
                    ...(0, $6008f4971a0c21c7$export$2f2afcd9b20384c7),
                    [`&.${(0, $3b4238fa67449b77$export$2e2bcd8739ae039).focusVisible}`]: theme.focusVisible
                }
            }
        ]
    })));
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $c3b5036e07dbc2e6$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, focusableWhenDisabled: /* eslint-disable react/prop-types */ // replaces internal handling in Chip, other components can opt-in individually to use this in the future
    focusableWhenDisabled, suppressFocusVisible: // escape hatch to suppress the focusVisible state and callback
    // used by anchored <Menu>s to to suppress focus visible styling when opened with a pointer
    suppressFocusVisible = false, // private prop to allow native vs non-native button props to be resolved before mount
    internalNativeButton: internalNativeButtonProp, internalDisabledThemeFocusVisible: // private prop to let a parent (like SwitchBase) control its own focus visible style
    internalDisabledThemeFocusVisible = false, LinkComponent: /* eslint-enable react/prop-types */ LinkComponent = 'a', nativeButton: nativeButtonProp, onBlur: onBlur, onClick: onClickProp, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDownProp, onKeyUp: onKeyUpProp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const isLink = Boolean(other.href || other.to);
    const hasFormAction = Boolean(other.formAction);
    let ComponentProp = component;
    if (ComponentProp === 'button' && isLink) ComponentProp = LinkComponent;
    const internalNativeButton = typeof ComponentProp === 'string' ? ComponentProp === 'button' : internalNativeButtonProp ?? false;
    const nativeButton = nativeButtonProp ?? internalNativeButton;
    const ripple = (0, $3ad8ad8d4bfb7dc7$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $7fb1cf77ea0dd990$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if ((disabled || suppressFocusVisible) && focusVisible) setFocusVisible(false);
    const handleBeforeKeyDown = (0, $f0eae19b326afc52$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
    });
    const handleBeforeKeyUp = (0, $f0eae19b326afc52$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
    });
    const { getButtonProps: getButtonProps, rootRef: buttonRef } = (0, $a5a2de51637198b1$export$2e2bcd8739ae039)({
        nativeButton: nativeButton,
        nativeButtonProp: nativeButtonProp,
        internalNativeButton: internalNativeButton,
        allowInferredHostMismatch: isLink || typeof ComponentProp === 'string',
        disabled: disabled,
        type: type,
        hasFormAction: hasFormAction,
        tabIndex: tabIndex,
        onBeforeKeyDown: handleBeforeKeyDown,
        onBeforeKeyUp: handleBeforeKeyUp
    });
    const { onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...buttonProps } = getButtonProps({
        onClick: onClickProp,
        onKeyDown: onKeyDownProp,
        onKeyUp: onKeyUpProp
    });
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), [
        buttonRef
    ]);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $c3b5036e07dbc2e6$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $c3b5036e07dbc2e6$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $c3b5036e07dbc2e6$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $c3b5036e07dbc2e6$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $c3b5036e07dbc2e6$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $c3b5036e07dbc2e6$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $c3b5036e07dbc2e6$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $c3b5036e07dbc2e6$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $c3b5036e07dbc2e6$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $5d0efb0e817a4762$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $f0eae19b326afc52$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/react/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (!suppressFocusVisible && (0, $5d0efb0e817a4762$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const linkProps = {};
    if (isLink) {
        linkProps.tabIndex = disabled ? -1 : tabIndex;
        if (disabled) linkProps['aria-disabled'] = disabled;
        linkProps.type = type;
    }
    const handleRef = (0, $7fb1cf77ea0dd990$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        suppressFocusVisible: suppressFocusVisible,
        tabIndex: tabIndex,
        focusVisible: focusVisible,
        internalDisabledThemeFocusVisible: internalDisabledThemeFocusVisible
    };
    const classes = $c3b5036e07dbc2e6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($c3b5036e07dbc2e6$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $i6kju.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        ...isLink ? linkProps : buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c7f413ef6ed7ded$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $c3b5036e07dbc2e6$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $f0eae19b326afc52$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $c3b5036e07dbc2e6$export$2e2bcd8739ae039 = $c3b5036e07dbc2e6$var$ButtonBase;



var $fe52caa321ac20cd$export$2e2bcd8739ae039 = (0, $9260d7f5fd8a7544$export$2e2bcd8739ae039);




function $6dd82590fc0678b5$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiFab', slot);
}
const $6dd82590fc0678b5$var$fabClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $6dd82590fc0678b5$export$2e2bcd8739ae039 = $6dd82590fc0678b5$var$fabClasses;





/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $43b8298ed30115c6$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $43b8298ed30115c6$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$43b8298ed30115c6$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $43b8298ed30115c6$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $43b8298ed30115c6$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}



const $12ed2c70c66ada14$export$214b055320e0bf32 = {
    transition: 'none'
};
function $12ed2c70c66ada14$export$3f1342cbd4bf84cc(reducedMotion, styles) {
    if (reducedMotion === 'always') return styles;
    if (reducedMotion === 'system') return {
        '@media (prefers-reduced-motion: reduce)': styles
    };
    return null;
}


const $2bd06673060f0f5d$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
const $2bd06673060f0f5d$var$DEFAULT_TRANSLATE_OFFSET = {
    offsetX: 0,
    offsetY: 0
};
const $2bd06673060f0f5d$var$EMPTY_STYLE = {};
const $2bd06673060f0f5d$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $2bd06673060f0f5d$var$EMPTY_OPTIONS = {};
const $2bd06673060f0f5d$var$transformOffsetIndexes = {
    matrix: [
        4,
        5
    ],
    matrix3d: [
        12,
        13
    ],
    translate: [
        0,
        1
    ],
    translate3d: [
        0,
        1
    ],
    translateX: [
        0,
        null
    ],
    translateY: [
        null,
        0
    ]
};
function $2bd06673060f0f5d$var$parseTranslateValue(value) {
    const parsedValue = parseFloat(value ?? '');
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
}
function $2bd06673060f0f5d$var$parseTransform(transform) {
    const match = transform.match(/^(matrix|matrix3d|translate|translate3d|translateX|translateY)\((.+)\)$/);
    if (!match) return null;
    return {
        type: match[1],
        values: match[2].split(',').map($2bd06673060f0f5d$var$parseTranslateValue)
    };
}
function $2bd06673060f0f5d$var$getTranslateOffsetValue(values, index) {
    return index === null ? 0 : values[index] || 0;
}
function $2bd06673060f0f5d$export$23d6f784a708ab33(transform) {
    if (!transform || transform === 'none') return $2bd06673060f0f5d$var$DEFAULT_TRANSLATE_OFFSET;
    const parsedTransform = $2bd06673060f0f5d$var$parseTransform(transform);
    if (!parsedTransform) return $2bd06673060f0f5d$var$DEFAULT_TRANSLATE_OFFSET;
    const { type: type, values: values } = parsedTransform;
    const offsetIndexes = $2bd06673060f0f5d$var$transformOffsetIndexes[type];
    if (!offsetIndexes) return $2bd06673060f0f5d$var$DEFAULT_TRANSLATE_OFFSET;
    return {
        offsetX: $2bd06673060f0f5d$var$getTranslateOffsetValue(values, offsetIndexes[0]),
        offsetY: $2bd06673060f0f5d$var$getTranslateOffsetValue(values, offsetIndexes[1])
    };
}
function $2bd06673060f0f5d$export$da8da2b45a650a33(nodeRef, callback) {
    return (maybeIsAppearing)=>{
        if (callback) {
            const node = nodeRef.current;
            // Enter callbacks receive isAppearing; exit callbacks do not.
            if (maybeIsAppearing === undefined) callback(node);
            else callback(node, maybeIsAppearing);
        }
    };
}
function $2bd06673060f0f5d$export$c1e03ca92f01ef32(state, inProp, baseStyles, hiddenStyles, styleProp, childStyle) {
    const base = state === 'exited' && !inProp ? hiddenStyles : baseStyles[state] || baseStyles.exited;
    return styleProp || childStyle ? {
        ...base,
        ...styleProp,
        ...childStyle
    } : base;
}
function $2bd06673060f0f5d$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = $2bd06673060f0f5d$var$EMPTY_STYLE } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}
function $2bd06673060f0f5d$export$4bc2c89b8b366948(theme, styles) {
    const resolvedStyles = styles ?? (0, $12ed2c70c66ada14$export$214b055320e0bf32);
    return (0, $12ed2c70c66ada14$export$3f1342cbd4bf84cc)(theme.motion?.reducedMotion, resolvedStyles);
}
function $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac(theme, props = $2bd06673060f0f5d$var$DEFAULT_TRANSITION_PROPS, options = $2bd06673060f0f5d$var$EMPTY_OPTIONS) {
    const transition = theme.transitions?.create?.(props, options);
    const reducedMotionStyles = $2bd06673060f0f5d$export$4bc2c89b8b366948(theme);
    if (transition === undefined) return reducedMotionStyles ?? $2bd06673060f0f5d$var$EMPTY_STYLE;
    const transitionStyles = {
        transition: transition
    };
    return reducedMotionStyles ? {
        ...transitionStyles,
        ...reducedMotionStyles
    } : transitionStyles;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $6802f6f7453275d2$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (0, $6dd82590fc0678b5$export$e2cfa0ca4bce1fc2), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $6802f6f7453275d2$var$FabRoot = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)((0, $c3b5036e07dbc2e6$export$2e2bcd8739ae039), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $710b5e22b13b2b07$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.button,
        minHeight: 36,
        ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, [
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.grey[900] : theme.palette.getContrastText?.(theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, $6dd82590fc0678b5$export$2e2bcd8739ae039).focusVisible}`]: {
            ...theme.focusVisible,
            boxShadow: theme.focusVisible?.boxShadow ? `${(theme.vars || theme).shadows[6]}, ${theme.focusVisible.boxShadow}` : (theme.vars || theme).shadows[6]
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 40,
                    height: 40
                }
            },
            {
                props: {
                    size: 'medium'
                },
                style: {
                    width: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended'
                },
                style: {
                    borderRadius: 24,
                    padding: '0 16px',
                    width: 'auto',
                    minHeight: 'auto',
                    minWidth: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'small'
                },
                style: {
                    width: 'auto',
                    padding: '0 8px',
                    borderRadius: 17,
                    minWidth: 34,
                    height: 34
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'medium'
                },
                style: {
                    width: 'auto',
                    padding: '0 16px',
                    borderRadius: 20,
                    minWidth: 40,
                    height: 40
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            }
        ]
    })), (0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)([
                'dark',
                'contrastText'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].contrastText,
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        '&:hover': {
                            backgroundColor: (theme.vars || theme).palette[color].dark,
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    })), (0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $6dd82590fc0678b5$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    })));
const $6802f6f7453275d2$var$Fab = /*#__PURE__*/ $acw62.forwardRef(function Fab(inProps, ref) {
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    };
    const classes = $6802f6f7453275d2$var$useUtilityClasses(ownerState);
    // Don't forward the 'root' class to the ButtonBase, as it will get duplicated with the one passed to the className prop.
    const { root: root, ...forwardedClasses } = classes;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($6802f6f7453275d2$var$FabRoot, {
        className: (0, $i6kju.default)(classes.root, className),
        component: component,
        internalNativeButton: true,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $i6kju.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref,
        ...other,
        classes: forwardedClasses,
        children: children
    });
});
var $6802f6f7453275d2$export$2e2bcd8739ae039 = $6802f6f7453275d2$var$Fab;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $525bb9d73249ebb0$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $27ae852c81980302$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $6ab986919c0eb283$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $27ae852c81980302$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}


var $6b1661cb34ace1ce$export$2e2bcd8739ae039 = (0, $6ab986919c0eb283$export$2e2bcd8739ae039);



var $bOOlK = parcelRequire("bOOlK");
function $61d8d55da45f6cf4$export$2e2bcd8739ae039(object) {
    if (object == null) return true;
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}



var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");
function $1c47f479e618a10c$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $1c47f479e618a10c$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || (0, $4jPKB.isValidElementType)(source) || !$1c47f479e618a10c$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $1c47f479e618a10c$var$deepClone(source[key]);
    });
    return output;
}
function $1c47f479e618a10c$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($1c47f479e618a10c$export$53b83ca8eaab0383(target) && $1c47f479e618a10c$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key]) || (0, $4jPKB.isValidElementType)(source[key])) output[key] = source[key];
        else if ($1c47f479e618a10c$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $1c47f479e618a10c$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $1c47f479e618a10c$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $1c47f479e618a10c$export$53b83ca8eaab0383(source[key]) ? $1c47f479e618a10c$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}




var $4jPKB = parcelRequire("4jPKB");
function $2a853ccaf493d520$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $2a853ccaf493d520$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $2a853ccaf493d520$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $2a853ccaf493d520$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $2a853ccaf493d520$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $4jPKB.ForwardRef:
            return $2a853ccaf493d520$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $4jPKB.Memo:
            return $2a853ccaf493d520$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}



// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $13f0df3b9ec36145$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
// Keep in sync with docs/src/pages/customization/breakpoints/breakpoints.md
// #host-reference
const $13f0df3b9ec36145$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $13f0df3b9ec36145$export$2e2bcd8739ae039(breakpoints) {
    const { values: values = {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $13f0df3b9ec36145$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    const mediaKeys = [];
    for(let i = 0; i < keys.length; i += 1)mediaKeys.push(up(keys[i]));
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        internal_mediaKeys: mediaKeys,
        ...other
    };
}


const $ede94d733536d525$var$MIN_WIDTH_PATTERN = /min-width:\s*([0-9.]+)/;
function $ede94d733536d525$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries || !$ede94d733536d525$var$hasContainerQuery(css)) return css;
    const keys = [];
    for(const key in css)if (key.startsWith('@container')) keys.push(key);
    keys.sort((a, b)=>{
        return +(a.match($ede94d733536d525$var$MIN_WIDTH_PATTERN)?.[1] || 0) - +(b.match($ede94d733536d525$var$MIN_WIDTH_PATTERN)?.[1] || 0);
    });
    const result = css;
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        const value = result[key];
        delete result[key];
        result[key] = value;
    }
    return result;
}
function $ede94d733536d525$var$hasContainerQuery(css) {
    for(const key in css){
        if (key.startsWith('@container')) return true;
    }
    return false;
}
function $ede94d733536d525$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $ede94d733536d525$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $ede94d733536d525$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $bc156c36fc104e02$var$shape = {
    borderRadius: 4
};
var $bc156c36fc104e02$export$2e2bcd8739ae039 = $bc156c36fc104e02$var$shape;





// Based on https://github.com/TehShrike/deepmerge
// Based on https://github.com/fastify/deepmerge
// MIT License
// Copyright (c) 2012 - 2022 James Halliday, Josh Duff, and other contributors of deepmerge
/* eslint-disable no-else-return */ /**
 * Assigns props from one object to another. Focused on performance, only normal objects with no
 * prototype are supported.
 */ function $3deb6a7841db5ad8$export$2e2bcd8739ae039(target, source) {
    const sourceIsArray = Array.isArray(source);
    const targetIsArray = Array.isArray(target);
    if ($3deb6a7841db5ad8$var$isPrimitive(source)) return source;
    else if ($3deb6a7841db5ad8$var$isPrimitiveOrBuiltIn(target)) return $3deb6a7841db5ad8$var$clone(source);
    else if (sourceIsArray && targetIsArray) return $3deb6a7841db5ad8$var$mergeArray(target, source);
    else if (sourceIsArray !== targetIsArray) return $3deb6a7841db5ad8$var$clone(source);
    else return $3deb6a7841db5ad8$var$mergeObject(target, source);
}
function $3deb6a7841db5ad8$var$cloneArray(value) {
    let i = 0;
    const il = value.length;
    const result = new Array(il);
    for(i = 0; i < il; i += 1)result[i] = $3deb6a7841db5ad8$var$clone(value[i]);
    return result;
}
function $3deb6a7841db5ad8$var$cloneObject(target) {
    const result = {};
    for(const key in target){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        result[key] = $3deb6a7841db5ad8$var$clone(target[key]);
    }
    return result;
}
function $3deb6a7841db5ad8$var$mergeArray(target, source) {
    const tl = target.length;
    for(let i = 0; i < source.length; i += 1)target[tl + i] = $3deb6a7841db5ad8$var$clone(source[i]);
    return target;
}
function $3deb6a7841db5ad8$var$isMergeableObject(value) {
    return typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
}
function $3deb6a7841db5ad8$var$isPrimitive(value) {
    return typeof value !== 'object' || value === null;
}
function $3deb6a7841db5ad8$var$isPrimitiveOrBuiltIn(value) {
    return typeof value !== 'object' || value === null || value instanceof RegExp || value instanceof Date;
}
function $3deb6a7841db5ad8$var$clone(entry) {
    // eslint-disable-next-line no-nested-ternary
    return $3deb6a7841db5ad8$var$isMergeableObject(entry) ? Array.isArray(entry) ? $3deb6a7841db5ad8$var$cloneArray(entry) : $3deb6a7841db5ad8$var$cloneObject(entry) : entry;
}
function $3deb6a7841db5ad8$var$mergeObject(target, source) {
    for(const key in source){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        if (key in target) target[key] = $3deb6a7841db5ad8$export$2e2bcd8739ae039(target[key], source[key]);
        else target[key] = $3deb6a7841db5ad8$var$clone(source[key]);
    }
    return target;
}




const $6f2b9c1e5f4be8e3$var$options = {
    clone: false
};
function $6f2b9c1e5f4be8e3$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $1c47f479e618a10c$export$2e2bcd8739ae039)(acc, item, $6f2b9c1e5f4be8e3$var$options);
}
var $6f2b9c1e5f4be8e3$export$2e2bcd8739ae039 = $6f2b9c1e5f4be8e3$var$merge;




const $1dbb8fd5da7364cf$var$EMPTY_THEME = {};
const $1dbb8fd5da7364cf$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $1dbb8fd5da7364cf$export$666ad80b5007f835 = (0, $13f0df3b9ec36145$export$2e2bcd8739ae039)({
    values: $1dbb8fd5da7364cf$export$68c286be0e7e55b7
});
const $1dbb8fd5da7364cf$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $1dbb8fd5da7364cf$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $1dbb8fd5da7364cf$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const result = {};
    return $1dbb8fd5da7364cf$export$2aea645392b97e0b(result, props.theme, propValue, (mediaKey, value, initialKey)=>{
        const finalValue = styleFromPropValue(value, initialKey);
        if (mediaKey) result[mediaKey] = finalValue;
        else (0, $3deb6a7841db5ad8$export$2e2bcd8739ae039)(result, finalValue);
    });
}
function $1dbb8fd5da7364cf$export$2aea645392b97e0b(target, theme, propValue, callback) {
    theme ??= $1dbb8fd5da7364cf$var$EMPTY_THEME;
    if (Array.isArray(propValue)) {
        const breakpoints = theme.breakpoints ?? $1dbb8fd5da7364cf$export$666ad80b5007f835;
        for(let i = 0; i < propValue.length; i += 1)$1dbb8fd5da7364cf$var$buildBreakpoint(target, breakpoints.up(breakpoints.keys[i]), propValue[i], undefined, callback);
        return target;
    }
    if (typeof propValue === 'object') {
        const breakpoints = theme.breakpoints ?? $1dbb8fd5da7364cf$export$666ad80b5007f835;
        const breakpointValues = breakpoints.values ?? $1dbb8fd5da7364cf$export$68c286be0e7e55b7;
        for(const key in propValue){
            if ((0, $ede94d733536d525$export$77c7c3e357f440e7)(breakpoints.keys, key)) {
                const containerKey = (0, $ede94d733536d525$export$10a9745dfa00d15)(theme.containerQueries ? theme : $1dbb8fd5da7364cf$var$defaultContainerQueries, key);
                if (containerKey) $1dbb8fd5da7364cf$var$buildBreakpoint(target, containerKey, propValue[key], key, callback);
            } else if (key in breakpointValues) {
                const mediaKey = breakpoints.up(key);
                $1dbb8fd5da7364cf$var$buildBreakpoint(target, mediaKey, propValue[key], key, callback);
            } else {
                const cssKey = key;
                target[cssKey] = propValue[cssKey];
            }
        }
        return target;
    }
    callback(undefined, propValue);
    return target;
}
function $1dbb8fd5da7364cf$var$buildBreakpoint(target, mediaKey, value, initialKey, callback) {
    target[mediaKey] ??= {};
    callback(mediaKey, value, initialKey);
}
function $1dbb8fd5da7364cf$var$setupBreakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $1dbb8fd5da7364cf$export$666ad80b5007f835;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $6f2b9c1e5f4be8e3$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $1dbb8fd5da7364cf$export$1f2600516e91381f(breakpoints = $1dbb8fd5da7364cf$export$666ad80b5007f835) {
    const { internal_mediaKeys: mediaKeys } = breakpoints;
    const result = {};
    for(let i = 0; i < mediaKeys.length; i += 1)result[mediaKeys[i]] = {};
    return result;
}
function $1dbb8fd5da7364cf$export$8922c90b6e020726(breakpoints, style) {
    const breakpointKeys = breakpoints.internal_mediaKeys;
    for(let i = 0; i < breakpointKeys.length; i += 1){
        const key = breakpointKeys[i];
        if ((0, $61d8d55da45f6cf4$export$2e2bcd8739ae039)(style[key])) delete style[key];
    }
    return style;
}
function $1dbb8fd5da7364cf$export$b89a003a1e05c0ee(breakpoints, ...styles) {
    const emptyBreakpoints = $1dbb8fd5da7364cf$export$1f2600516e91381f(breakpoints);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $1c47f479e618a10c$export$2e2bcd8739ae039)(prev, next), {});
    return $1dbb8fd5da7364cf$export$8922c90b6e020726(breakpoints, mergedOutput);
}
function $1dbb8fd5da7364cf$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $1dbb8fd5da7364cf$export$980e6a259d807490(options) {
    const { values: breakpointValues, breakpoints: themeBreakpoints, base: customBase } = options;
    const base = customBase || $1dbb8fd5da7364cf$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object' && breakpointValues) {
            const bv = breakpointValues;
            acc[breakpoint] = bv[breakpoint] != null ? bv[breakpoint] : bv[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
function $1dbb8fd5da7364cf$export$c29c12f694bb7a2f(breakpoints, value) {
    if (Array.isArray(value)) return true;
    if (typeof value === 'object' && value !== null) {
        for(let i = 0; i < breakpoints.keys.length; i += 1){
            if (breakpoints.keys[i] in value) return true;
        }
        const valueKeys = Object.keys(value);
        for(let i = 0; i < valueKeys.length; i += 1){
            if ((0, $ede94d733536d525$export$77c7c3e357f440e7)(breakpoints.keys, valueKeys[i])) return true;
        }
    }
    return false;
}
var $1dbb8fd5da7364cf$export$2e2bcd8739ae039 = $1dbb8fd5da7364cf$var$setupBreakpoints;





function $969717d1e0495ba2$export$741ad47189a64aa0(themeMapping, transform, valueFinal, userValue = valueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(valueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[valueFinal] || userValue;
    else if (typeof valueFinal === 'string') value = $969717d1e0495ba2$export$2aa3fd96c49a84a8(themeMapping, valueFinal) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $969717d1e0495ba2$export$245e5a5849651da5(themeMapping, transform, userValue, alternateProp) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(userValue);
    else if (Array.isArray(themeMapping)) value = themeMapping[userValue] || userValue;
    else if (typeof userValue === 'string') value = $969717d1e0495ba2$export$2aa3fd96c49a84a8(themeMapping, userValue, true, alternateProp) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $969717d1e0495ba2$export$2aa3fd96c49a84a8(obj, pathInput, checkVars = true, alternateProp) {
    if (!obj || !pathInput) return null;
    const path = pathInput.split('.');
    // Check if CSS variables are used
    if (obj.vars && checkVars) {
        const val = $969717d1e0495ba2$var$getPathImpl(obj.vars, path, alternateProp);
        if (val != null) return val;
    }
    return $969717d1e0495ba2$var$getPathImpl(obj, path, alternateProp);
}
function $969717d1e0495ba2$var$getPathImpl(object, path, alternateProp) {
    let lastResult = undefined;
    let result = object;
    let index = 0;
    while(index < path.length){
        if (result === null || result === undefined) return result;
        lastResult = result;
        result = result[path[index]];
        index += 1;
    }
    if (alternateProp && result === undefined) {
        const lastKey = path[path.length - 1];
        const alternateKey = `${alternateProp}${lastKey === 'default' ? '' : (0, $6ab986919c0eb283$export$2e2bcd8739ae039)(lastKey)}`;
        return lastResult?.[alternateKey];
    }
    return result;
}
function $969717d1e0495ba2$export$2e2bcd8739ae039(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $969717d1e0495ba2$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (valueFinal)=>{
            const value = $969717d1e0495ba2$export$245e5a5849651da5(themeMapping, transform, valueFinal, prop);
            return cssProperty === false ? value : {
                [cssProperty]: value
            };
        };
        return (0, $1dbb8fd5da7364cf$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}


/* eslint-disable guard-for-in */ const $b44c991153bb6355$var$EMPTY_THEME = {
    internal_cache: {}
};
const $b44c991153bb6355$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $b44c991153bb6355$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $b44c991153bb6355$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
const $b44c991153bb6355$var$CSS_PROPERTIES = {};
for(const key in $b44c991153bb6355$var$properties)$b44c991153bb6355$var$CSS_PROPERTIES[key] = [
    $b44c991153bb6355$var$properties[key]
];
for(const keyProperty in $b44c991153bb6355$var$properties)for(const keyDirection in $b44c991153bb6355$var$directions){
    const property = $b44c991153bb6355$var$properties[keyProperty];
    const direction = $b44c991153bb6355$var$directions[keyDirection];
    const value = Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
    $b44c991153bb6355$var$CSS_PROPERTIES[keyProperty + keyDirection] = value;
}
for(const key in $b44c991153bb6355$var$aliases)$b44c991153bb6355$var$CSS_PROPERTIES[key] = $b44c991153bb6355$var$CSS_PROPERTIES[$b44c991153bb6355$var$aliases[key]];
const $b44c991153bb6355$export$aab52a0dde05ad8a = new Set([
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
]);
const $b44c991153bb6355$export$f8397d44f03ab6ad = new Set([
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
]);
const $b44c991153bb6355$var$spacingKeys = new Set([
    ...$b44c991153bb6355$export$aab52a0dde05ad8a,
    ...$b44c991153bb6355$export$f8397d44f03ab6ad
]);
function $b44c991153bb6355$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $969717d1e0495ba2$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $b44c991153bb6355$export$1def6f833384e3d1(theme) {
    return $b44c991153bb6355$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $b44c991153bb6355$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
// Avoid allocations
const $b44c991153bb6355$var$container = [
    ''
];
function $b44c991153bb6355$var$style(props, keys) {
    const theme = props.theme ?? $b44c991153bb6355$var$EMPTY_THEME;
    const transformer = theme?.internal_cache?.unarySpacing ?? $b44c991153bb6355$export$1def6f833384e3d1(theme);
    const result = {};
    for(const prop in props){
        if (!keys.has(prop)) continue;
        const cssProperties = $b44c991153bb6355$var$CSS_PROPERTIES[prop] ?? ($b44c991153bb6355$var$container[0] = prop, $b44c991153bb6355$var$container);
        const propValue = props[prop];
        (0, $1dbb8fd5da7364cf$export$2aea645392b97e0b)(result, props.theme, propValue, (mediaKey, value)=>{
            const target = mediaKey ? result[mediaKey] : result;
            for(let i = 0; i < cssProperties.length; i += 1)target[cssProperties[i]] = $b44c991153bb6355$export$bf7199a9ebcb84a9(transformer, value);
        });
    }
    return result;
}
function $b44c991153bb6355$var$marginFn(props) {
    return $b44c991153bb6355$var$style(props, $b44c991153bb6355$export$aab52a0dde05ad8a);
}
$b44c991153bb6355$var$marginFn.propTypes = {};
$b44c991153bb6355$var$marginFn.filterProps = $b44c991153bb6355$export$aab52a0dde05ad8a;
const $b44c991153bb6355$export$7ede87f9b603dd3c = $b44c991153bb6355$var$marginFn;
function $b44c991153bb6355$var$paddingFn(props) {
    return $b44c991153bb6355$var$style(props, $b44c991153bb6355$export$f8397d44f03ab6ad);
}
$b44c991153bb6355$var$paddingFn.propTypes = {};
$b44c991153bb6355$var$paddingFn.filterProps = $b44c991153bb6355$export$f8397d44f03ab6ad;
const $b44c991153bb6355$export$6f98e8eaf0be1996 = $b44c991153bb6355$var$paddingFn;
function $b44c991153bb6355$var$spacingFn(props) {
    return $b44c991153bb6355$var$style(props, $b44c991153bb6355$var$spacingKeys);
}
$b44c991153bb6355$var$spacingFn.propTypes = {};
$b44c991153bb6355$var$spacingFn.filterProps = $b44c991153bb6355$var$spacingKeys;
const $b44c991153bb6355$var$spacing = $b44c991153bb6355$var$spacingFn;
var $b44c991153bb6355$export$2e2bcd8739ae039 = $b44c991153bb6355$var$spacing;


function $c21564385cdcabb8$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $b44c991153bb6355$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}










function $f534c04dd5c940be$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        const result = {};
        for(const prop in props)if (handlers[prop]) (0, $3deb6a7841db5ad8$export$2e2bcd8739ae039)(result, handlers[prop](props));
        return result;
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $f534c04dd5c940be$export$2e2bcd8739ae039 = $f534c04dd5c940be$var$compose;




function $8a4b5a3477cf659b$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $8a4b5a3477cf659b$var$createBorderStyle(prop, transform) {
    return (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $8a4b5a3477cf659b$export$1edee58a52776cd9 = $8a4b5a3477cf659b$var$createBorderStyle('border', $8a4b5a3477cf659b$export$34e2febe53ae29cc);
const $8a4b5a3477cf659b$export$f9a7b6bd24892946 = $8a4b5a3477cf659b$var$createBorderStyle('borderTop', $8a4b5a3477cf659b$export$34e2febe53ae29cc);
const $8a4b5a3477cf659b$export$5abca33e6be905d2 = $8a4b5a3477cf659b$var$createBorderStyle('borderRight', $8a4b5a3477cf659b$export$34e2febe53ae29cc);
const $8a4b5a3477cf659b$export$e2ce9f12a980a822 = $8a4b5a3477cf659b$var$createBorderStyle('borderBottom', $8a4b5a3477cf659b$export$34e2febe53ae29cc);
const $8a4b5a3477cf659b$export$47658cca1a909427 = $8a4b5a3477cf659b$var$createBorderStyle('borderLeft', $8a4b5a3477cf659b$export$34e2febe53ae29cc);
const $8a4b5a3477cf659b$export$e7fb0694ba2404fc = $8a4b5a3477cf659b$var$createBorderStyle('borderColor');
const $8a4b5a3477cf659b$export$126a92c968acdb85 = $8a4b5a3477cf659b$var$createBorderStyle('borderTopColor');
const $8a4b5a3477cf659b$export$85cc51cb8fbb8c0e = $8a4b5a3477cf659b$var$createBorderStyle('borderRightColor');
const $8a4b5a3477cf659b$export$340b0327727f6d1a = $8a4b5a3477cf659b$var$createBorderStyle('borderBottomColor');
const $8a4b5a3477cf659b$export$60beef91a985b4bf = $8a4b5a3477cf659b$var$createBorderStyle('borderLeftColor');
const $8a4b5a3477cf659b$export$f9258c55612cbed7 = $8a4b5a3477cf659b$var$createBorderStyle('outline', $8a4b5a3477cf659b$export$34e2febe53ae29cc);
const $8a4b5a3477cf659b$export$621fe586efeb64b9 = $8a4b5a3477cf659b$var$createBorderStyle('outlineColor');
const $8a4b5a3477cf659b$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $b44c991153bb6355$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $b44c991153bb6355$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $1dbb8fd5da7364cf$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$8a4b5a3477cf659b$export$7a57f79000377ca2.propTypes = {};
$8a4b5a3477cf659b$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $8a4b5a3477cf659b$var$borders = (0, $f534c04dd5c940be$export$2e2bcd8739ae039)($8a4b5a3477cf659b$export$1edee58a52776cd9, $8a4b5a3477cf659b$export$f9a7b6bd24892946, $8a4b5a3477cf659b$export$5abca33e6be905d2, $8a4b5a3477cf659b$export$e2ce9f12a980a822, $8a4b5a3477cf659b$export$47658cca1a909427, $8a4b5a3477cf659b$export$e7fb0694ba2404fc, $8a4b5a3477cf659b$export$126a92c968acdb85, $8a4b5a3477cf659b$export$85cc51cb8fbb8c0e, $8a4b5a3477cf659b$export$340b0327727f6d1a, $8a4b5a3477cf659b$export$60beef91a985b4bf, $8a4b5a3477cf659b$export$7a57f79000377ca2, $8a4b5a3477cf659b$export$f9258c55612cbed7, $8a4b5a3477cf659b$export$621fe586efeb64b9);
var $8a4b5a3477cf659b$export$2e2bcd8739ae039 = $8a4b5a3477cf659b$var$borders;







const $1aee6bd4bc7dd44e$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $b44c991153bb6355$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $b44c991153bb6355$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $1dbb8fd5da7364cf$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$1aee6bd4bc7dd44e$export$5df9adcb0db95e1e.propTypes = {};
$1aee6bd4bc7dd44e$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $1aee6bd4bc7dd44e$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $b44c991153bb6355$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $b44c991153bb6355$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $1dbb8fd5da7364cf$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$1aee6bd4bc7dd44e$export$ec60d70ff941a580.propTypes = {};
$1aee6bd4bc7dd44e$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $1aee6bd4bc7dd44e$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $b44c991153bb6355$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $b44c991153bb6355$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $1dbb8fd5da7364cf$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$1aee6bd4bc7dd44e$export$8a833ffa5f5dbeda.propTypes = {};
$1aee6bd4bc7dd44e$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $1aee6bd4bc7dd44e$export$baf44164ca3a34e8 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $1aee6bd4bc7dd44e$export$8f7213a1cd01e832 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $1aee6bd4bc7dd44e$export$b0e0abbc49ba668 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $1aee6bd4bc7dd44e$export$bcd8b929d4b4142 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $1aee6bd4bc7dd44e$export$e5039a674e14c828 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $1aee6bd4bc7dd44e$export$42bd9088661ffb03 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $1aee6bd4bc7dd44e$export$920682ae05b999bc = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $1aee6bd4bc7dd44e$export$1b88fbdd482fd33a = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $1aee6bd4bc7dd44e$export$bdb486e40d52d26f = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $1aee6bd4bc7dd44e$var$grid = (0, $f534c04dd5c940be$export$2e2bcd8739ae039)($1aee6bd4bc7dd44e$export$5df9adcb0db95e1e, $1aee6bd4bc7dd44e$export$ec60d70ff941a580, $1aee6bd4bc7dd44e$export$8a833ffa5f5dbeda, $1aee6bd4bc7dd44e$export$baf44164ca3a34e8, $1aee6bd4bc7dd44e$export$8f7213a1cd01e832, $1aee6bd4bc7dd44e$export$b0e0abbc49ba668, $1aee6bd4bc7dd44e$export$bcd8b929d4b4142, $1aee6bd4bc7dd44e$export$e5039a674e14c828, $1aee6bd4bc7dd44e$export$42bd9088661ffb03, $1aee6bd4bc7dd44e$export$920682ae05b999bc, $1aee6bd4bc7dd44e$export$1b88fbdd482fd33a, $1aee6bd4bc7dd44e$export$bdb486e40d52d26f);
var $1aee6bd4bc7dd44e$export$2e2bcd8739ae039 = $1aee6bd4bc7dd44e$var$grid;




function $6507211c4ce1eb50$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $6507211c4ce1eb50$export$35e9368ef982300f = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $6507211c4ce1eb50$export$dbaffd4420ea0ac6
});
const $6507211c4ce1eb50$export$2506f56c10355b33 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $6507211c4ce1eb50$export$dbaffd4420ea0ac6
});
const $6507211c4ce1eb50$export$8c5a050822fd698c = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $6507211c4ce1eb50$export$dbaffd4420ea0ac6
});
const $6507211c4ce1eb50$var$palette = (0, $f534c04dd5c940be$export$2e2bcd8739ae039)($6507211c4ce1eb50$export$35e9368ef982300f, $6507211c4ce1eb50$export$2506f56c10355b33, $6507211c4ce1eb50$export$8c5a050822fd698c);
var $6507211c4ce1eb50$export$2e2bcd8739ae039 = $6507211c4ce1eb50$var$palette;





const $af6870a119716403$var$breakpointsValues = $1dbb8fd5da7364cf$export$68c286be0e7e55b7;
function $af6870a119716403$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $af6870a119716403$export$7e3df82ee760448c = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $af6870a119716403$export$8afece71750ec241
});
const $af6870a119716403$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $af6870a119716403$var$breakpointsValues[propValue];
            if (!breakpoint) return {
                maxWidth: $af6870a119716403$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $1dbb8fd5da7364cf$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$af6870a119716403$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $af6870a119716403$export$ee148fbbe8357dd2 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $af6870a119716403$export$8afece71750ec241
});
const $af6870a119716403$export$ac607276a8fe9f0a = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $af6870a119716403$export$8afece71750ec241
});
const $af6870a119716403$export$dc0d8bd0b94f8570 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $af6870a119716403$export$8afece71750ec241
});
const $af6870a119716403$export$a43cf604e12f3b17 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $af6870a119716403$export$8afece71750ec241
});
const $af6870a119716403$export$ffed9f14fb65e276 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $af6870a119716403$export$8afece71750ec241
});
const $af6870a119716403$export$905076ed6620e671 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $af6870a119716403$export$8afece71750ec241
});
const $af6870a119716403$export$6ccc93f785106a58 = (0, $969717d1e0495ba2$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $af6870a119716403$var$sizing = (0, $f534c04dd5c940be$export$2e2bcd8739ae039)($af6870a119716403$export$7e3df82ee760448c, $af6870a119716403$export$488fda99655ff65a, $af6870a119716403$export$ee148fbbe8357dd2, $af6870a119716403$export$ac607276a8fe9f0a, $af6870a119716403$export$dc0d8bd0b94f8570, $af6870a119716403$export$a43cf604e12f3b17, $af6870a119716403$export$6ccc93f785106a58);
var $af6870a119716403$export$2e2bcd8739ae039 = $af6870a119716403$var$sizing;


const $9168152d2e928344$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $8a4b5a3477cf659b$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $8a4b5a3477cf659b$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $8a4b5a3477cf659b$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $8a4b5a3477cf659b$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $8a4b5a3477cf659b$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $8a4b5a3477cf659b$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $8a4b5a3477cf659b$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $6507211c4ce1eb50$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $6507211c4ce1eb50$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $6507211c4ce1eb50$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $b44c991153bb6355$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $b44c991153bb6355$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $1aee6bd4bc7dd44e$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $1aee6bd4bc7dd44e$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $1aee6bd4bc7dd44e$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $af6870a119716403$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $af6870a119716403$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $af6870a119716403$export$8afece71750ec241)
    },
    height: {
        transform: (0, $af6870a119716403$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $af6870a119716403$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $af6870a119716403$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $9168152d2e928344$export$2e2bcd8739ae039 = $9168152d2e928344$var$defaultSxConfig;


/**
 * The `css` function accepts arrays as values for mobile-first responsive styles.
 * Note that this extends to non-theme values also. For example `display=['none', 'block']`
 * will also works.
 */ /**
 * Map of all CSS pseudo selectors (`:hover`, `:focus`, ...).
 */ /**
 * Map all nested selectors.
 */ /**
 * Map all nested selectors and CSS variables.
 */ /**
 * Map of all available CSS properties (including aliases) and their raw value.
 * Only used internally to map CSS properties to input types (responsive value,
 * theme function or nested) in `SystemCssProperties`.
 */ /**
 * The `SystemStyleObject` defines custom properties that will be transformed to
 * their corresponding values from the `Theme`. Other valid CSS properties are also allowed.
 */ /**
 * The `SxProps` can be either object or function
 */ /* eslint-disable guard-for-in */ const $ac57c12d86c7c4ad$var$EMPTY_THEME = {};
function $ac57c12d86c7c4ad$export$7d53d8bf2911e013() {
    function styleFunctionSx(props) {
        if (!props.sx) return null;
        const { sx: sx, theme: theme = $ac57c12d86c7c4ad$var$EMPTY_THEME, nested: nested } = props;
        const config = theme.unstable_sxConfig ?? (0, $9168152d2e928344$export$2e2bcd8739ae039);
        // Pass argument without loop allocations
        const wrapper = {
            sx: null,
            theme: theme,
            nested: true
        };
        function process(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const breakpoints = theme.breakpoints ?? (0, $1dbb8fd5da7364cf$export$666ad80b5007f835);
            const css = (0, $1dbb8fd5da7364cf$export$1f2600516e91381f)(breakpoints);
            for(const styleKey in sxObject){
                const value = $ac57c12d86c7c4ad$var$callIfFn(sxObject[styleKey], theme);
                if (value === null || value === undefined) continue;
                if (typeof value !== 'object') {
                    $ac57c12d86c7c4ad$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if (config[styleKey]) {
                    $ac57c12d86c7c4ad$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if ((0, $1dbb8fd5da7364cf$export$c29c12f694bb7a2f)(breakpoints, value)) (0, $1dbb8fd5da7364cf$export$2aea645392b97e0b)(css, props.theme, value, (mediaKey, finalValue)=>{
                    css[mediaKey][styleKey] = finalValue;
                });
                else {
                    wrapper.sx = value;
                    css[styleKey] = styleFunctionSx(wrapper);
                }
            }
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $ede94d733536d525$export$456f6c1142f990db)(theme, (0, $1dbb8fd5da7364cf$export$8922c90b6e020726)(breakpoints, css))
            };
            return (0, $ede94d733536d525$export$456f6c1142f990db)(theme, (0, $1dbb8fd5da7364cf$export$8922c90b6e020726)(breakpoints, css));
        }
        return Array.isArray(sx) ? sx.map(process) : process(sx);
    }
    styleFunctionSx.filterProps = [
        'sx'
    ];
    return styleFunctionSx;
}
var $ac57c12d86c7c4ad$export$2e2bcd8739ae039 = $ac57c12d86c7c4ad$export$7d53d8bf2911e013();
function $ac57c12d86c7c4ad$var$setThemeValue(css, prop, value, theme, config) {
    const options = config[prop];
    if (!options) {
        css[prop] = value;
        return;
    }
    if (value == null) return;
    const { themeKey: themeKey } = options;
    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && value === 'inherit') {
        css[prop] = value;
        return;
    }
    const { style: style } = options;
    if (style) {
        (0, $3deb6a7841db5ad8$export$2e2bcd8739ae039)(css, style({
            [prop]: value,
            theme: theme
        }));
        return;
    }
    const { cssProperty: cssProperty = prop, transform: transform } = options;
    const themeMapping = (0, $969717d1e0495ba2$export$2aa3fd96c49a84a8)(theme, themeKey);
    (0, $1dbb8fd5da7364cf$export$2aea645392b97e0b)(css, theme, value, (mediaKey, valueFinal)=>{
        const finalValue = (0, $969717d1e0495ba2$export$245e5a5849651da5)(themeMapping, transform, valueFinal, prop);
        if (cssProperty === false) {
            if (mediaKey) (0, $3deb6a7841db5ad8$export$2e2bcd8739ae039)(css[mediaKey], finalValue);
            else (0, $3deb6a7841db5ad8$export$2e2bcd8739ae039)(css, finalValue);
        } else // eslint-disable-next-line no-lonely-if
        if (mediaKey) css[mediaKey][cssProperty] = finalValue;
        else css[cssProperty] = finalValue;
    });
}
function $ac57c12d86c7c4ad$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $454afee0ca5eeda3$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $34eb8751e050cd8c$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $13f0df3b9ec36145$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $c21564385cdcabb8$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $1c47f479e618a10c$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $bc156c36fc104e02$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $ede94d733536d525$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $454afee0ca5eeda3$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $1c47f479e618a10c$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $9168152d2e928344$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $ac57c12d86c7c4ad$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.internal_cache = {};
    return muiTheme;
}
var $34eb8751e050cd8c$export$2e2bcd8739ae039 = $34eb8751e050cd8c$var$createTheme;




var $bOOlK = parcelRequire("bOOlK");
function $75d7596330b4006c$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $bOOlK.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $bOOlK.internal_serializeStyles)(variant.style);
    });
    return result;
}


const $fec63625cc77ab41$export$35e57303dbd8a66 = (0, $34eb8751e050cd8c$export$2e2bcd8739ae039)();
function $fec63625cc77ab41$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $fec63625cc77ab41$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $fec63625cc77ab41$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $fec63625cc77ab41$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = (0, $61d8d55da45f6cf4$export$2e2bcd8739ae039)(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $fec63625cc77ab41$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$fec63625cc77ab41$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $fec63625cc77ab41$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $fec63625cc77ab41$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $fec63625cc77ab41$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $fec63625cc77ab41$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $fec63625cc77ab41$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $fec63625cc77ab41$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $fec63625cc77ab41$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $fec63625cc77ab41$var$shallowLayer((0, $bOOlK.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $fec63625cc77ab41$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $fec63625cc77ab41$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $fec63625cc77ab41$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $fec63625cc77ab41$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $fec63625cc77ab41$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $bOOlK.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $ac57c12d86c7c4ad$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $fec63625cc77ab41$var$defaultOverridesResolver($fec63625cc77ab41$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $fec63625cc77ab41$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($fec63625cc77ab41$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, (/*@__PURE__*/$parcel$interopDefault($bOOlK)))(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $fec63625cc77ab41$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $fec63625cc77ab41$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $1c47f479e618a10c$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $75d7596330b4006c$export$2e2bcd8739ae039)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $fec63625cc77ab41$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $fec63625cc77ab41$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $fec63625cc77ab41$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $fec63625cc77ab41$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $ac57c12d86c7c4ad$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $fec63625cc77ab41$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $6ab986919c0eb283$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $2a853ccaf493d520$export$2e2bcd8739ae039)(tag)})`;
}
function $fec63625cc77ab41$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $fec63625cc77ab41$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $fec63625cc77ab41$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}





function $c8644b3d7654f816$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $c8644b3d7654f816$export$2e2bcd8739ae039 = $c8644b3d7654f816$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $78232819f3270ebf$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $c8644b3d7654f816$export$2e2bcd8739ae039)(value, min, max);
}
function $78232819f3270ebf$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $78232819f3270ebf$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $78232819f3270ebf$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $78232819f3270ebf$export$677b39864803984e($78232819f3270ebf$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $27ae852c81980302$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $27ae852c81980302$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $78232819f3270ebf$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $78232819f3270ebf$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $78232819f3270ebf$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $78232819f3270ebf$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $78232819f3270ebf$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $78232819f3270ebf$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $78232819f3270ebf$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$78232819f3270ebf$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $78232819f3270ebf$export$29fb7152bd3f781a(color) {
    color = $78232819f3270ebf$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $78232819f3270ebf$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $78232819f3270ebf$export$c852d90bf7403b62(color) {
    color = $78232819f3270ebf$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $78232819f3270ebf$export$677b39864803984e($78232819f3270ebf$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $78232819f3270ebf$export$d061e26956a60b0a(foreground, background) {
    const lumA = $78232819f3270ebf$export$c852d90bf7403b62(foreground);
    const lumB = $78232819f3270ebf$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $78232819f3270ebf$export$58f0f39f63f3cf42(color, value) {
    color = $78232819f3270ebf$export$677b39864803984e(color);
    value = $78232819f3270ebf$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $78232819f3270ebf$export$211a73f2b8c10ce4(color);
}
function $78232819f3270ebf$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $78232819f3270ebf$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $78232819f3270ebf$export$4b073707ff63303(color, coefficient) {
    color = $78232819f3270ebf$export$677b39864803984e(color);
    coefficient = $78232819f3270ebf$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $78232819f3270ebf$export$211a73f2b8c10ce4(color);
}
function $78232819f3270ebf$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $78232819f3270ebf$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $78232819f3270ebf$export$c0816ed86df316af(color, coefficient) {
    color = $78232819f3270ebf$export$677b39864803984e(color);
    coefficient = $78232819f3270ebf$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $78232819f3270ebf$export$211a73f2b8c10ce4(color);
}
function $78232819f3270ebf$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $78232819f3270ebf$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $78232819f3270ebf$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $78232819f3270ebf$export$c852d90bf7403b62(color) > 0.5 ? $78232819f3270ebf$export$4b073707ff63303(color, coefficient) : $78232819f3270ebf$export$c0816ed86df316af(color, coefficient);
}
function $78232819f3270ebf$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $78232819f3270ebf$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $78232819f3270ebf$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $78232819f3270ebf$export$677b39864803984e(background);
    const overlayColor = $78232819f3270ebf$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $78232819f3270ebf$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


/**
 * ![common black](https://mui.com/static/colors-preview/common-black-24x24.png) ![common white](https://mui.com/static/colors-preview/common-white-24x24.png)
 */ const $7ab20a2a46a6af91$var$common = {
    /**
   * Preview: ![common black](https://mui.com/static/colors-preview/common-black-24x24.png)
   */ black: '#000',
    /**
   * Preview: ![common white](https://mui.com/static/colors-preview/common-white-24x24.png)
   */ white: '#fff'
};
var $7ab20a2a46a6af91$export$2e2bcd8739ae039 = $7ab20a2a46a6af91$var$common;


/**
 * ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png) ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png) ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png) ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png) ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png) ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png) ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png) ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png) ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png) ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png) ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png) ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png) ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png) ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
 */ const $22138689ec3e2567$var$grey = {
    /**
   * Preview: ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png)
   */ 50: '#fafafa',
    /**
   * Preview: ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png)
   */ 100: '#f5f5f5',
    /**
   * Preview: ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png)
   */ 200: '#eeeeee',
    /**
   * Preview: ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png)
   */ 300: '#e0e0e0',
    /**
   * Preview: ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png)
   */ 400: '#bdbdbd',
    /**
   * Preview: ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png)
   */ 500: '#9e9e9e',
    /**
   * Preview: ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png)
   */ 600: '#757575',
    /**
   * Preview: ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png)
   */ 700: '#616161',
    /**
   * Preview: ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png)
   */ 800: '#424242',
    /**
   * Preview: ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png)
   */ 900: '#212121',
    /**
   * Preview: ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png)
   */ A100: '#f5f5f5',
    /**
   * Preview: ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png)
   */ A200: '#eeeeee',
    /**
   * Preview: ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png)
   */ A400: '#bdbdbd',
    /**
   * Preview: ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
   */ A700: '#616161'
};
var $22138689ec3e2567$export$2e2bcd8739ae039 = $22138689ec3e2567$var$grey;


/**
 * ![purple 50](https://mui.com/static/colors-preview/purple-50-24x24.png) ![purple 100](https://mui.com/static/colors-preview/purple-100-24x24.png) ![purple 200](https://mui.com/static/colors-preview/purple-200-24x24.png) ![purple 300](https://mui.com/static/colors-preview/purple-300-24x24.png) ![purple 400](https://mui.com/static/colors-preview/purple-400-24x24.png) ![purple 500](https://mui.com/static/colors-preview/purple-500-24x24.png) ![purple 600](https://mui.com/static/colors-preview/purple-600-24x24.png) ![purple 700](https://mui.com/static/colors-preview/purple-700-24x24.png) ![purple 800](https://mui.com/static/colors-preview/purple-800-24x24.png) ![purple 900](https://mui.com/static/colors-preview/purple-900-24x24.png) ![purple A100](https://mui.com/static/colors-preview/purple-A100-24x24.png) ![purple A200](https://mui.com/static/colors-preview/purple-A200-24x24.png) ![purple A400](https://mui.com/static/colors-preview/purple-A400-24x24.png) ![purple A700](https://mui.com/static/colors-preview/purple-A700-24x24.png)
 */ const $e4583fd1aa3b4228$var$purple = {
    /**
   * Preview: ![purple 50](https://mui.com/static/colors-preview/purple-50-24x24.png)
   */ 50: '#f3e5f5',
    /**
   * Preview: ![purple 100](https://mui.com/static/colors-preview/purple-100-24x24.png)
   */ 100: '#e1bee7',
    /**
   * Preview: ![purple 200](https://mui.com/static/colors-preview/purple-200-24x24.png)
   */ 200: '#ce93d8',
    /**
   * Preview: ![purple 300](https://mui.com/static/colors-preview/purple-300-24x24.png)
   */ 300: '#ba68c8',
    /**
   * Preview: ![purple 400](https://mui.com/static/colors-preview/purple-400-24x24.png)
   */ 400: '#ab47bc',
    /**
   * Preview: ![purple 500](https://mui.com/static/colors-preview/purple-500-24x24.png)
   */ 500: '#9c27b0',
    /**
   * Preview: ![purple 600](https://mui.com/static/colors-preview/purple-600-24x24.png)
   */ 600: '#8e24aa',
    /**
   * Preview: ![purple 700](https://mui.com/static/colors-preview/purple-700-24x24.png)
   */ 700: '#7b1fa2',
    /**
   * Preview: ![purple 800](https://mui.com/static/colors-preview/purple-800-24x24.png)
   */ 800: '#6a1b9a',
    /**
   * Preview: ![purple 900](https://mui.com/static/colors-preview/purple-900-24x24.png)
   */ 900: '#4a148c',
    /**
   * Preview: ![purple A100](https://mui.com/static/colors-preview/purple-A100-24x24.png)
   */ A100: '#ea80fc',
    /**
   * Preview: ![purple A200](https://mui.com/static/colors-preview/purple-A200-24x24.png)
   */ A200: '#e040fb',
    /**
   * Preview: ![purple A400](https://mui.com/static/colors-preview/purple-A400-24x24.png)
   */ A400: '#d500f9',
    /**
   * Preview: ![purple A700](https://mui.com/static/colors-preview/purple-A700-24x24.png)
   */ A700: '#aa00ff'
};
var $e4583fd1aa3b4228$export$2e2bcd8739ae039 = $e4583fd1aa3b4228$var$purple;


/**
 * ![red 50](https://mui.com/static/colors-preview/red-50-24x24.png) ![red 100](https://mui.com/static/colors-preview/red-100-24x24.png) ![red 200](https://mui.com/static/colors-preview/red-200-24x24.png) ![red 300](https://mui.com/static/colors-preview/red-300-24x24.png) ![red 400](https://mui.com/static/colors-preview/red-400-24x24.png) ![red 500](https://mui.com/static/colors-preview/red-500-24x24.png) ![red 600](https://mui.com/static/colors-preview/red-600-24x24.png) ![red 700](https://mui.com/static/colors-preview/red-700-24x24.png) ![red 800](https://mui.com/static/colors-preview/red-800-24x24.png) ![red 900](https://mui.com/static/colors-preview/red-900-24x24.png) ![red A100](https://mui.com/static/colors-preview/red-A100-24x24.png) ![red A200](https://mui.com/static/colors-preview/red-A200-24x24.png) ![red A400](https://mui.com/static/colors-preview/red-A400-24x24.png) ![red A700](https://mui.com/static/colors-preview/red-A700-24x24.png)
 */ const $03d605bf8a844a36$var$red = {
    /**
   * Preview: ![red 50](https://mui.com/static/colors-preview/red-50-24x24.png)
   */ 50: '#ffebee',
    /**
   * Preview: ![red 100](https://mui.com/static/colors-preview/red-100-24x24.png)
   */ 100: '#ffcdd2',
    /**
   * Preview: ![red 200](https://mui.com/static/colors-preview/red-200-24x24.png)
   */ 200: '#ef9a9a',
    /**
   * Preview: ![red 300](https://mui.com/static/colors-preview/red-300-24x24.png)
   */ 300: '#e57373',
    /**
   * Preview: ![red 400](https://mui.com/static/colors-preview/red-400-24x24.png)
   */ 400: '#ef5350',
    /**
   * Preview: ![red 500](https://mui.com/static/colors-preview/red-500-24x24.png)
   */ 500: '#f44336',
    /**
   * Preview: ![red 600](https://mui.com/static/colors-preview/red-600-24x24.png)
   */ 600: '#e53935',
    /**
   * Preview: ![red 700](https://mui.com/static/colors-preview/red-700-24x24.png)
   */ 700: '#d32f2f',
    /**
   * Preview: ![red 800](https://mui.com/static/colors-preview/red-800-24x24.png)
   */ 800: '#c62828',
    /**
   * Preview: ![red 900](https://mui.com/static/colors-preview/red-900-24x24.png)
   */ 900: '#b71c1c',
    /**
   * Preview: ![red A100](https://mui.com/static/colors-preview/red-A100-24x24.png)
   */ A100: '#ff8a80',
    /**
   * Preview: ![red A200](https://mui.com/static/colors-preview/red-A200-24x24.png)
   */ A200: '#ff5252',
    /**
   * Preview: ![red A400](https://mui.com/static/colors-preview/red-A400-24x24.png)
   */ A400: '#ff1744',
    /**
   * Preview: ![red A700](https://mui.com/static/colors-preview/red-A700-24x24.png)
   */ A700: '#d50000'
};
var $03d605bf8a844a36$export$2e2bcd8739ae039 = $03d605bf8a844a36$var$red;


/**
 * ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png) ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png) ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png) ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png) ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png) ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png) ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png) ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png) ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png) ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png) ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png) ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png) ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png) ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
 */ const $f9ebb823a5e5187f$var$orange = {
    /**
   * Preview: ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png)
   */ 50: '#fff3e0',
    /**
   * Preview: ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png)
   */ 100: '#ffe0b2',
    /**
   * Preview: ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png)
   */ 200: '#ffcc80',
    /**
   * Preview: ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png)
   */ 300: '#ffb74d',
    /**
   * Preview: ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png)
   */ 400: '#ffa726',
    /**
   * Preview: ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png)
   */ 500: '#ff9800',
    /**
   * Preview: ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png)
   */ 600: '#fb8c00',
    /**
   * Preview: ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png)
   */ 700: '#f57c00',
    /**
   * Preview: ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png)
   */ 800: '#ef6c00',
    /**
   * Preview: ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png)
   */ 900: '#e65100',
    /**
   * Preview: ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png)
   */ A100: '#ffd180',
    /**
   * Preview: ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png)
   */ A200: '#ffab40',
    /**
   * Preview: ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png)
   */ A400: '#ff9100',
    /**
   * Preview: ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
   */ A700: '#ff6d00'
};
var $f9ebb823a5e5187f$export$2e2bcd8739ae039 = $f9ebb823a5e5187f$var$orange;


/**
 * ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png) ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png) ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png) ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png) ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png) ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png) ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png) ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png) ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png) ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png) ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png) ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png) ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png) ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
 */ const $4d3617b969e558b0$var$blue = {
    /**
   * Preview: ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png)
   */ 50: '#e3f2fd',
    /**
   * Preview: ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png)
   */ 100: '#bbdefb',
    /**
   * Preview: ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png)
   */ 200: '#90caf9',
    /**
   * Preview: ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png)
   */ 300: '#64b5f6',
    /**
   * Preview: ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png)
   */ 400: '#42a5f5',
    /**
   * Preview: ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png)
   */ 500: '#2196f3',
    /**
   * Preview: ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png)
   */ 600: '#1e88e5',
    /**
   * Preview: ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png)
   */ 700: '#1976d2',
    /**
   * Preview: ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png)
   */ 800: '#1565c0',
    /**
   * Preview: ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png)
   */ 900: '#0d47a1',
    /**
   * Preview: ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png)
   */ A100: '#82b1ff',
    /**
   * Preview: ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png)
   */ A200: '#448aff',
    /**
   * Preview: ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png)
   */ A400: '#2979ff',
    /**
   * Preview: ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
   */ A700: '#2962ff'
};
var $4d3617b969e558b0$export$2e2bcd8739ae039 = $4d3617b969e558b0$var$blue;


/**
 * ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png) ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png) ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png) ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png) ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png) ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png) ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png) ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png) ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png) ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png) ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png) ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png) ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png) ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
 */ const $53dd92182cf9f7a9$var$lightBlue = {
    /**
   * Preview: ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png)
   */ 50: '#e1f5fe',
    /**
   * Preview: ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png)
   */ 100: '#b3e5fc',
    /**
   * Preview: ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png)
   */ 200: '#81d4fa',
    /**
   * Preview: ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png)
   */ 300: '#4fc3f7',
    /**
   * Preview: ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png)
   */ 400: '#29b6f6',
    /**
   * Preview: ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png)
   */ 500: '#03a9f4',
    /**
   * Preview: ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png)
   */ 600: '#039be5',
    /**
   * Preview: ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png)
   */ 700: '#0288d1',
    /**
   * Preview: ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png)
   */ 800: '#0277bd',
    /**
   * Preview: ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png)
   */ 900: '#01579b',
    /**
   * Preview: ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png)
   */ A100: '#80d8ff',
    /**
   * Preview: ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png)
   */ A200: '#40c4ff',
    /**
   * Preview: ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png)
   */ A400: '#00b0ff',
    /**
   * Preview: ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
   */ A700: '#0091ea'
};
var $53dd92182cf9f7a9$export$2e2bcd8739ae039 = $53dd92182cf9f7a9$var$lightBlue;


/**
 * ![green 50](https://mui.com/static/colors-preview/green-50-24x24.png) ![green 100](https://mui.com/static/colors-preview/green-100-24x24.png) ![green 200](https://mui.com/static/colors-preview/green-200-24x24.png) ![green 300](https://mui.com/static/colors-preview/green-300-24x24.png) ![green 400](https://mui.com/static/colors-preview/green-400-24x24.png) ![green 500](https://mui.com/static/colors-preview/green-500-24x24.png) ![green 600](https://mui.com/static/colors-preview/green-600-24x24.png) ![green 700](https://mui.com/static/colors-preview/green-700-24x24.png) ![green 800](https://mui.com/static/colors-preview/green-800-24x24.png) ![green 900](https://mui.com/static/colors-preview/green-900-24x24.png) ![green A100](https://mui.com/static/colors-preview/green-A100-24x24.png) ![green A200](https://mui.com/static/colors-preview/green-A200-24x24.png) ![green A400](https://mui.com/static/colors-preview/green-A400-24x24.png) ![green A700](https://mui.com/static/colors-preview/green-A700-24x24.png)
 */ const $a6de1c4f28e77a34$var$green = {
    /**
   * Preview: ![green 50](https://mui.com/static/colors-preview/green-50-24x24.png)
   */ 50: '#e8f5e9',
    /**
   * Preview: ![green 100](https://mui.com/static/colors-preview/green-100-24x24.png)
   */ 100: '#c8e6c9',
    /**
   * Preview: ![green 200](https://mui.com/static/colors-preview/green-200-24x24.png)
   */ 200: '#a5d6a7',
    /**
   * Preview: ![green 300](https://mui.com/static/colors-preview/green-300-24x24.png)
   */ 300: '#81c784',
    /**
   * Preview: ![green 400](https://mui.com/static/colors-preview/green-400-24x24.png)
   */ 400: '#66bb6a',
    /**
   * Preview: ![green 500](https://mui.com/static/colors-preview/green-500-24x24.png)
   */ 500: '#4caf50',
    /**
   * Preview: ![green 600](https://mui.com/static/colors-preview/green-600-24x24.png)
   */ 600: '#43a047',
    /**
   * Preview: ![green 700](https://mui.com/static/colors-preview/green-700-24x24.png)
   */ 700: '#388e3c',
    /**
   * Preview: ![green 800](https://mui.com/static/colors-preview/green-800-24x24.png)
   */ 800: '#2e7d32',
    /**
   * Preview: ![green 900](https://mui.com/static/colors-preview/green-900-24x24.png)
   */ 900: '#1b5e20',
    /**
   * Preview: ![green A100](https://mui.com/static/colors-preview/green-A100-24x24.png)
   */ A100: '#b9f6ca',
    /**
   * Preview: ![green A200](https://mui.com/static/colors-preview/green-A200-24x24.png)
   */ A200: '#69f0ae',
    /**
   * Preview: ![green A400](https://mui.com/static/colors-preview/green-A400-24x24.png)
   */ A400: '#00e676',
    /**
   * Preview: ![green A700](https://mui.com/static/colors-preview/green-A700-24x24.png)
   */ A700: '#00c853'
};
var $a6de1c4f28e77a34$export$2e2bcd8739ae039 = $a6de1c4f28e77a34$var$green;


function $316ad872fadeaa61$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $7ab20a2a46a6af91$export$2e2bcd8739ae039).white,
            default: (0, $7ab20a2a46a6af91$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $316ad872fadeaa61$export$a43af521ac8c3202 = $316ad872fadeaa61$var$getLight();
function $316ad872fadeaa61$var$getDark() {
    return {
        text: {
            primary: (0, $7ab20a2a46a6af91$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $7ab20a2a46a6af91$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $316ad872fadeaa61$export$55ce6f3a06c59543 = $316ad872fadeaa61$var$getDark();
function $316ad872fadeaa61$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $78232819f3270ebf$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $78232819f3270ebf$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $316ad872fadeaa61$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $316ad872fadeaa61$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $4d3617b969e558b0$export$2e2bcd8739ae039)[200],
        light: (0, $4d3617b969e558b0$export$2e2bcd8739ae039)[50],
        dark: (0, $4d3617b969e558b0$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $4d3617b969e558b0$export$2e2bcd8739ae039)[700],
        light: (0, $4d3617b969e558b0$export$2e2bcd8739ae039)[400],
        dark: (0, $4d3617b969e558b0$export$2e2bcd8739ae039)[800]
    };
}
function $316ad872fadeaa61$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e4583fd1aa3b4228$export$2e2bcd8739ae039)[200],
        light: (0, $e4583fd1aa3b4228$export$2e2bcd8739ae039)[50],
        dark: (0, $e4583fd1aa3b4228$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $e4583fd1aa3b4228$export$2e2bcd8739ae039)[500],
        light: (0, $e4583fd1aa3b4228$export$2e2bcd8739ae039)[300],
        dark: (0, $e4583fd1aa3b4228$export$2e2bcd8739ae039)[700]
    };
}
function $316ad872fadeaa61$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $03d605bf8a844a36$export$2e2bcd8739ae039)[500],
        light: (0, $03d605bf8a844a36$export$2e2bcd8739ae039)[300],
        dark: (0, $03d605bf8a844a36$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $03d605bf8a844a36$export$2e2bcd8739ae039)[700],
        light: (0, $03d605bf8a844a36$export$2e2bcd8739ae039)[400],
        dark: (0, $03d605bf8a844a36$export$2e2bcd8739ae039)[800]
    };
}
function $316ad872fadeaa61$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $53dd92182cf9f7a9$export$2e2bcd8739ae039)[400],
        light: (0, $53dd92182cf9f7a9$export$2e2bcd8739ae039)[300],
        dark: (0, $53dd92182cf9f7a9$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $53dd92182cf9f7a9$export$2e2bcd8739ae039)[700],
        light: (0, $53dd92182cf9f7a9$export$2e2bcd8739ae039)[500],
        dark: (0, $53dd92182cf9f7a9$export$2e2bcd8739ae039)[900]
    };
}
function $316ad872fadeaa61$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $a6de1c4f28e77a34$export$2e2bcd8739ae039)[400],
        light: (0, $a6de1c4f28e77a34$export$2e2bcd8739ae039)[300],
        dark: (0, $a6de1c4f28e77a34$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $a6de1c4f28e77a34$export$2e2bcd8739ae039)[800],
        light: (0, $a6de1c4f28e77a34$export$2e2bcd8739ae039)[500],
        dark: (0, $a6de1c4f28e77a34$export$2e2bcd8739ae039)[900]
    };
}
function $316ad872fadeaa61$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $f9ebb823a5e5187f$export$2e2bcd8739ae039)[400],
        light: (0, $f9ebb823a5e5187f$export$2e2bcd8739ae039)[300],
        dark: (0, $f9ebb823a5e5187f$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $f9ebb823a5e5187f$export$2e2bcd8739ae039)[500],
        dark: (0, $f9ebb823a5e5187f$export$2e2bcd8739ae039)[900]
    };
}
function $316ad872fadeaa61$export$b6e2ca4581a735cb(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $316ad872fadeaa61$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $316ad872fadeaa61$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $316ad872fadeaa61$var$getDefaultSecondary(mode);
    const error = palette.error || $316ad872fadeaa61$var$getDefaultError(mode);
    const info = palette.info || $316ad872fadeaa61$var$getDefaultInfo(mode);
    const success = palette.success || $316ad872fadeaa61$var$getDefaultSuccess(mode);
    const warning = palette.warning || $316ad872fadeaa61$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $316ad872fadeaa61$export$b6e2ca4581a735cb(background);
        const contrastText = (0, $78232819f3270ebf$export$d061e26956a60b0a)(background, $316ad872fadeaa61$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $316ad872fadeaa61$export$55ce6f3a06c59543.text.primary : $316ad872fadeaa61$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $27ae852c81980302$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $27ae852c81980302$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $316ad872fadeaa61$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $316ad872fadeaa61$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $316ad872fadeaa61$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $316ad872fadeaa61$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $316ad872fadeaa61$var$getLight();
    else if (mode === 'dark') modeHydrated = $316ad872fadeaa61$var$getDark();
    const paletteOutput = (0, $1c47f479e618a10c$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: {
            ...(0, $7ab20a2a46a6af91$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $22138689ec3e2567$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}



const $80383a806f62e88e$var$focusVisibleOffsetVar = '--_focusVisible-offset';
const $80383a806f62e88e$var$focusVisibleBehaviorVar = '--_focusVisible-behavior';
const $80383a806f62e88e$var$focusVisibleShadowVar = '--_focusVisible-shadow';
const $80383a806f62e88e$var$offsetValue = `var(${$80383a806f62e88e$var$focusVisibleOffsetVar}, 1)`;
const $80383a806f62e88e$var$behaviorValue = `var(${$80383a806f62e88e$var$focusVisibleBehaviorVar}, )`;
const $80383a806f62e88e$export$2f2afcd9b20384c7 = {
    [$80383a806f62e88e$var$focusVisibleOffsetVar]: 1,
    [$80383a806f62e88e$var$focusVisibleBehaviorVar]: 'initial' // reverts the var to guaranteed-invalid so `var(--_focusVisible-behavior, )` falls back to empty — there is no explicit `outset` keyword.
};
function $80383a806f62e88e$export$ce219ac1eda241f1(color) {
    return {
        [$80383a806f62e88e$var$focusVisibleShadowVar]: color
    };
}
function $80383a806f62e88e$export$e388436c4b59b99d(offset) {
    return {
        [$80383a806f62e88e$var$focusVisibleOffsetVar]: -offset,
        [$80383a806f62e88e$var$focusVisibleBehaviorVar]: 'inset'
    };
}
function $80383a806f62e88e$export$5d0f425d284660f4(optionsFocusVisible, args) {
    return args.reduce((acc, arg)=>arg && 'focusVisible' in arg ? (0, $1c47f479e618a10c$export$2e2bcd8739ae039)(acc, {
            focusVisible: arg.focusVisible
        }) : acc, {
        focusVisible: optionsFocusVisible
    }).focusVisible;
}
function $80383a806f62e88e$export$685950156577a061(input) {
    return input != null && typeof input === 'object' && typeof input.outlineOffset === 'string' && input.outlineOffset.includes($80383a806f62e88e$var$focusVisibleOffsetVar);
}
function $80383a806f62e88e$export$c06a3c79efe1b1cf(input, outlineColor) {
    return $80383a806f62e88e$export$a0f20964bcf591d5({
        outlineStyle: 'solid',
        outlineColor: outlineColor,
        outlineWidth: 2,
        outlineOffset: 2,
        // invisible shadow for parent component with solid background (AppBar, Snackbar, Alert) can control the ring color.
        boxShadow: `var(${$80383a806f62e88e$var$focusVisibleShadowVar}, 0 0)`,
        ...input === true ? null : input
    });
}
function $80383a806f62e88e$export$a0f20964bcf591d5(resolved) {
    // Multiply the offset by the sign var so it flips to inset on clip-prone components. Skip if
    // already wired: re-composing a resolved theme must not wrap the calc twice and invert the sign.
    const offset = resolved.outlineOffset ?? 0;
    if (typeof offset !== 'string' || !offset.includes($80383a806f62e88e$var$focusVisibleOffsetVar)) {
        const offsetPx = typeof offset === 'number' ? `${offset}px` : offset;
        resolved.outlineOffset = `calc(${$80383a806f62e88e$var$offsetValue} * ${offsetPx})`;
    }
    // Prefix a box-shadow with the behavior var so it insets there too, unless it already opts in.
    // Standalone keywords are complete values — prefixing would produce an invalid `inset none`.
    const standaloneBoxShadows = new Set([
        'none',
        'initial',
        'inherit',
        'unset',
        'revert',
        'revert-layer'
    ]);
    if (typeof resolved.boxShadow === 'string' && !standaloneBoxShadows.has(resolved.boxShadow.trim().toLowerCase()) && !/\binset\b/.test(resolved.boxShadow) && !resolved.boxShadow.includes($80383a806f62e88e$var$focusVisibleBehaviorVar)) resolved.boxShadow = `${$80383a806f62e88e$var$behaviorValue} ${resolved.boxShadow}`;
    return resolved;
}





var $izOUK = parcelRequire("izOUK");

/* eslint-disable import/prefer-default-export */ function $e8f9bd6289ba5801$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}


const $4912011686b5c4c3$var$prototypePollutingKeys = new Set([
    '__proto__',
    'constructor',
    'prototype'
]);
const $4912011686b5c4c3$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    for(let index = 0; index < keys.length; index += 1){
        const k = keys[index];
        // Prevent prototype pollution: never traverse or write through
        // `__proto__` / `constructor` / `prototype` (e.g. a theme parsed from untrusted JSON).
        if ($4912011686b5c4c3$var$prototypePollutingKeys.has(k)) break;
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    }
};
const $4912011686b5c4c3$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $4912011686b5c4c3$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $4912011686b5c4c3$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $4912011686b5c4c3$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $4912011686b5c4c3$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $4912011686b5c4c3$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $4912011686b5c4c3$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


function $a7b731607dda0271$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-expect-error - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $4912011686b5c4c3$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $4912011686b5c4c3$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $1c47f479e618a10c$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $4912011686b5c4c3$export$2e2bcd8739ae039)(defaultScheme, parserConfig);
        themeVars = (0, $1c47f479e618a10c$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $1c47f479e618a10c$export$2e2bcd8739ae039)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $a7b731607dda0271$export$2e2bcd8739ae039 = $a7b731607dda0271$var$prepareCssVars;

function $edfe63fdd06f5650$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}










function $8726db9e592c4eee$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




function $dcbdf9a6d514a1da$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $dcbdf9a6d514a1da$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $dcbdf9a6d514a1da$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $dcbdf9a6d514a1da$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $dcbdf9a6d514a1da$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $dcbdf9a6d514a1da$var$defaultFontFamily ? {
                letterSpacing: `${$dcbdf9a6d514a1da$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $dcbdf9a6d514a1da$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $dcbdf9a6d514a1da$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $1c47f479e618a10c$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $c366d29994da949b$var$shadowKeyUmbraOpacity = 0.2;
const $c366d29994da949b$var$shadowKeyPenumbraOpacity = 0.14;
const $c366d29994da949b$var$shadowAmbientShadowOpacity = 0.12;
function $c366d29994da949b$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$c366d29994da949b$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$c366d29994da949b$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$c366d29994da949b$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $c366d29994da949b$var$shadows = [
    'none',
    $c366d29994da949b$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $c366d29994da949b$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $c366d29994da949b$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $c366d29994da949b$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $c366d29994da949b$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $c366d29994da949b$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $c366d29994da949b$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $c366d29994da949b$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $c366d29994da949b$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $c366d29994da949b$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $c366d29994da949b$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $c366d29994da949b$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $c366d29994da949b$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $c366d29994da949b$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $c366d29994da949b$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $c366d29994da949b$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $c366d29994da949b$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $c366d29994da949b$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $c366d29994da949b$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $c366d29994da949b$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $c366d29994da949b$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $c366d29994da949b$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $c366d29994da949b$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $c366d29994da949b$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $c366d29994da949b$export$2e2bcd8739ae039 = $c366d29994da949b$var$shadows;


const $933f6cede2ce24ac$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $933f6cede2ce24ac$var$EMPTY_OPTIONS = {};
const $933f6cede2ce24ac$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $933f6cede2ce24ac$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $933f6cede2ce24ac$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $933f6cede2ce24ac$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $933f6cede2ce24ac$export$2e2bcd8739ae039(inputTransitions) {
    const transitions = {
        ...inputTransitions
    };
    delete transitions.reducedMotion;
    const mergedEasing = {
        ...$933f6cede2ce24ac$export$24c5ac7c37452e7d,
        ...transitions.easing
    };
    const mergedDuration = {
        ...$933f6cede2ce24ac$export$1f34108aa9eb96ab,
        ...transitions.duration
    };
    const createTransitionValue = (props = $933f6cede2ce24ac$var$DEFAULT_TRANSITION_PROPS, options = $933f6cede2ce24ac$var$EMPTY_OPTIONS)=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $933f6cede2ce24ac$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $933f6cede2ce24ac$var$formatMs(delay)}`).join(',');
    };
    const create = transitions.create ?? createTransitionValue;
    return {
        getAutoHeightDuration: $933f6cede2ce24ac$var$getAutoHeightDuration,
        create: create,
        ...transitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


const $25089b31059f9314$var$EMPTY_MOTION = {};
function $25089b31059f9314$export$2e2bcd8739ae039(inputMotion = $25089b31059f9314$var$EMPTY_MOTION) {
    return {
        reducedMotion: 'never',
        ...inputMotion
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $f93e89d0c2d037b0$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $f93e89d0c2d037b0$export$2e2bcd8739ae039 = $f93e89d0c2d037b0$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
function $e859ca6239cf1eb7$var$isSerializable(val) {
    return (0, $1c47f479e618a10c$export$53b83ca8eaab0383)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $e859ca6239cf1eb7$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$e859ca6239cf1eb7$var$isSerializable(value) || key.startsWith('unstable_') || key.startsWith('internal_')) delete object[key];
            else if ((0, $1c47f479e618a10c$export$53b83ca8eaab0383)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.motion = { reducedMotion: 'never', ...theme.motion };
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}



function $ef52363d8154b2bf$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $ef52363d8154b2bf$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
// `rgba()` takes rgb channels, so `hsl()` is converted like the theme's `*Channel` tokens.
function $ef52363d8154b2bf$var$toRgb(color) {
    return color.startsWith('hsl') ? (0, $78232819f3270ebf$export$29fb7152bd3f781a)(color) : color;
}
// Replaces the `var()` matches in `alpha()`: `var(--x, #1976d2)` -> `var(--xChannel, 25 118 210)`.
// The fallback keeps the color valid when the CSS variables aren't defined (no `ThemeProvider`).
// It's dropped when it isn't a color `colorChannel()` parses, for example `currentColor` or a nested `var()`,
// or when it's a `color()`, whose channels aren't sRGB.
// More than one level of nested parentheses isn't supported: the match ends at the first run of `)`,
// so the rest of the fallback stays in the output.
function $ef52363d8154b2bf$var$toChannelVar(match, name, fallback = '') {
    const color = fallback.trim();
    if (color && !color.startsWith('color(')) try {
        const channel = (0, $78232819f3270ebf$export$1b91fc959f7ee5a7)($ef52363d8154b2bf$var$toRgb(color));
        // Space-separated syntax like `rgb(0 0 0)` doesn't throw but gives a single value, or `NaN`s for `hsl()`.
        if (channel.split(' ').length === 3 && !channel.includes('NaN')) return `var(--${name}Channel, ${channel})`;
    } catch  {
    // Not a supported color.
    }
    return `var(--${name}Channel)`;
}
function $ef52363d8154b2bf$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) {
                // To preserve the behavior of the CSS theme variables
                // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
                // Raw colors (for example, `theme.palette.*`) have no channel tokens,
                // so they are converted to channels the same way the theme generates `*Channel` tokens,
                // which keeps a CSS coefficient (for example, `theme.vars.palette.action.hoverOpacity`) in `calc()`.
                const alphaValue = typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient;
                // `color()` channels are not sRGB, so only the alpha is replaced to keep any color space and unit.
                if (color.startsWith('color(')) return color.replace(/\s*(?:\/[^)]*)?\)$/, ` / ${alphaValue})`);
                const channels = color.includes('var(') ? color.replace(/var\(--([^,\s)]+)(?:,((?:[^()]|\([^()]*\))+)\)|(?:,[^)]+)?\)+)/g, $ef52363d8154b2bf$var$toChannelVar) : (0, $78232819f3270ebf$export$427365fc3db6fc5e)($ef52363d8154b2bf$var$toRgb(color));
                return `rgba(${channels} / ${alphaValue})`;
            }
            return (0, $78232819f3270ebf$export$58f0f39f63f3cf42)(color, $ef52363d8154b2bf$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$ef52363d8154b2bf$var$coefficientToPercentage(coefficient)})`;
            return (0, $78232819f3270ebf$export$c0816ed86df316af)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$ef52363d8154b2bf$var$coefficientToPercentage(coefficient)})`;
            return (0, $78232819f3270ebf$export$4b073707ff63303)(color, coefficient);
        }
    });
}
function $ef52363d8154b2bf$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, motion: motionInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $27ae852c81980302$export$2e2bcd8739ae039)(22));
    const palette = (0, $316ad872fadeaa61$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $34eb8751e050cd8c$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $1c47f479e618a10c$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $8726db9e592c4eee$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $c366d29994da949b$export$2e2bcd8739ae039).slice(),
        typography: (0, $dcbdf9a6d514a1da$export$2e2bcd8739ae039)(palette, typographyInput),
        motion: (0, $25089b31059f9314$export$2e2bcd8739ae039)(motionInput),
        transitions: (0, $933f6cede2ce24ac$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $f93e89d0c2d037b0$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, $1c47f479e618a10c$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $1c47f479e618a10c$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    // `reducedMotion` is owned by `theme.motion`; remove stale values preserved by systemCreateTheme.
    delete muiTheme.transitions.reducedMotion;
    // Normalize once so components read a resolved object, never the boolean. The color is a hex off
    // this (default) scheme; `createTheme` attaches a per-scheme copy so dark mode stays reactive.
    // Read the palette off `muiTheme` — a merge argument may have recolored it after `palette` was built.
    if (muiTheme.focusVisible != null && muiTheme.focusVisible !== false) muiTheme.focusVisible = (0, $80383a806f62e88e$export$c06a3c79efe1b1cf)(muiTheme.focusVisible, muiTheme.palette.primary.main);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $9168152d2e928344$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $ac57c12d86c7c4ad$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $e859ca6239cf1eb7$export$32c2afa5f91892aa); // for Pigment CSS integration
    $ef52363d8154b2bf$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $ef52363d8154b2bf$export$2e2bcd8739ae039 = $ef52363d8154b2bf$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $edc0f8748b36f8ad$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $ceae9390d015831f$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $edc0f8748b36f8ad$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $ceae9390d015831f$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $ceae9390d015831f$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $ceae9390d015831f$var$defaultDarkOverlays : [];
}
function $ceae9390d015831f$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $316ad872fadeaa61$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$ceae9390d015831f$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $ceae9390d015831f$export$dd191566510330d3(palette.mode),
        ...other
    };
}


function $7b9372fd67206bfb$export$2e2bcd8739ae039(keys) {
    return keys[0] === 'motion' || // Keep `focusVisible` inline: its values reference the per-component private vars
    // (`--_focusVisible-offset`/`-behavior`). Hoisted to a `:root` var they resolve where those
    // vars are unset, silently breaking the inner-ring inset.
    keys[0] === 'focusVisible' || !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $5d2f4c93401705cb$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $5d2f4c93401705cb$export$2e2bcd8739ae039 = $5d2f4c93401705cb$var$excludeVariablesFromRoot;


var $7818e2d8d91e995e$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $5d2f4c93401705cb$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };





function $f5ac2423aa106325$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $f5ac2423aa106325$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $f5ac2423aa106325$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $78232819f3270ebf$export$29fb7152bd3f781a)(color);
}
function $f5ac2423aa106325$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $78232819f3270ebf$export$427365fc3db6fc5e)($f5ac2423aa106325$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $f5ac2423aa106325$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $f5ac2423aa106325$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $f5ac2423aa106325$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $izOUK.unstable_createGetCssVar)(cssVarPrefix);
function $f5ac2423aa106325$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $ceae9390d015831f$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $ef52363d8154b2bf$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $ceae9390d015831f$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $ceae9390d015831f$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $f5ac2423aa106325$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $7b9372fd67206bfb$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $f5ac2423aa106325$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $27ae852c81980302$export$2e2bcd8739ae039)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $f5ac2423aa106325$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $f5ac2423aa106325$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $f5ac2423aa106325$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $edfe63fdd06f5650$export$2e2bcd8739ae039)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $f5ac2423aa106325$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $f5ac2423aa106325$var$setColor(palette.common, 'background', '#fff');
            $f5ac2423aa106325$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $f5ac2423aa106325$var$setColor(palette.common, 'background', '#000');
            $f5ac2423aa106325$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // Generate `text.primaryChannel` before the component tokens:
        // `palette.Skeleton.bg` uses it as its CSS variable fallback.
        if (!nativeColor) $f5ac2423aa106325$var$setColorChannel(palette.text, 'primary');
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === (0, $78232819f3270ebf$export$34109543fc7f43f8)) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === (0, $78232819f3270ebf$export$eaaef2dca3e9e512)) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === (0, $78232819f3270ebf$export$aeeda94ef1d01275)) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $f5ac2423aa106325$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'Input',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorFilledColor', $f5ac2423aa106325$var$silent(()=>palette.getContrastText(palette.error.main)));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoFilledColor', $f5ac2423aa106325$var$silent(()=>palette.getContrastText(palette.info.main)));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successFilledColor', $f5ac2423aa106325$var$silent(()=>palette.getContrastText(palette.success.main)));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningFilledColor', $f5ac2423aa106325$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $f5ac2423aa106325$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $f5ac2423aa106325$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $f5ac2423aa106325$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $f5ac2423aa106325$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $f5ac2423aa106325$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $f5ac2423aa106325$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $f5ac2423aa106325$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $f5ac2423aa106325$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $f5ac2423aa106325$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $f5ac2423aa106325$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $f5ac2423aa106325$var$setColor(palette.Input, 'autofillWebkitBoxShadow', 'none');
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $78232819f3270ebf$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $f5ac2423aa106325$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'successTrack', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $78232819f3270ebf$export$11bb74ba10c85505)(palette.background.default, 0.8);
            $f5ac2423aa106325$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $f5ac2423aa106325$var$setColor(palette.SnackbarContent, 'color', $f5ac2423aa106325$var$silent(()=>colorSpace ? (0, $316ad872fadeaa61$export$55ce6f3a06c59543).text.primary : palette.getContrastText(snackbarContentBackground)));
            $f5ac2423aa106325$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $78232819f3270ebf$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $f5ac2423aa106325$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $f5ac2423aa106325$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            $f5ac2423aa106325$var$setColor(palette.TableCell, 'border', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), (0, $78232819f3270ebf$export$34109543fc7f43f8)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.88));
            $f5ac2423aa106325$var$setColor(palette.Tooltip, 'bg', colorMix((0, $78232819f3270ebf$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningColor', colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorFilledColor', $f5ac2423aa106325$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoFilledColor', $f5ac2423aa106325$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successFilledColor', $f5ac2423aa106325$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningFilledColor', $f5ac2423aa106325$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $f5ac2423aa106325$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $f5ac2423aa106325$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $f5ac2423aa106325$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $f5ac2423aa106325$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $f5ac2423aa106325$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $f5ac2423aa106325$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $f5ac2423aa106325$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $f5ac2423aa106325$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $f5ac2423aa106325$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $f5ac2423aa106325$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $f5ac2423aa106325$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $f5ac2423aa106325$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $f5ac2423aa106325$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $f5ac2423aa106325$var$setColor(palette.Input, 'autofillWebkitBoxShadow', '0 0 0 100px #266798 inset');
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $78232819f3270ebf$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $f5ac2423aa106325$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'successTrack', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $f5ac2423aa106325$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix((0, $78232819f3270ebf$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $78232819f3270ebf$export$11bb74ba10c85505)(palette.background.default, 0.98);
            $f5ac2423aa106325$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $f5ac2423aa106325$var$setColor(palette.SnackbarContent, 'color', $f5ac2423aa106325$var$silent(()=>colorSpace ? (0, $316ad872fadeaa61$export$a43af521ac8c3202).text.primary : palette.getContrastText(snackbarContentBackground)));
            $f5ac2423aa106325$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $78232819f3270ebf$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $f5ac2423aa106325$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $f5ac2423aa106325$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.55));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.55));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.55));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.55));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.55));
            $f5ac2423aa106325$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.55));
            $f5ac2423aa106325$var$setColor(palette.TableCell, 'border', colorMix((0, $78232819f3270ebf$export$eaaef2dca3e9e512), (0, $78232819f3270ebf$export$34109543fc7f43f8)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.68));
            $f5ac2423aa106325$var$setColor(palette.Tooltip, 'bg', colorMix((0, $78232819f3270ebf$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (!nativeColor) {
            $f5ac2423aa106325$var$setColorChannel(palette.background, 'default');
            // added for consistency with the `background.default` token
            $f5ac2423aa106325$var$setColorChannel(palette.background, 'paper');
            $f5ac2423aa106325$var$setColorChannel(palette.common, 'background');
            $f5ac2423aa106325$var$setColorChannel(palette.common, 'onBackground');
            $f5ac2423aa106325$var$setColorChannel(palette, 'divider');
        }
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && !nativeColor && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $f5ac2423aa106325$var$setColor(palette[color], 'mainChannel', (0, $78232819f3270ebf$export$427365fc3db6fc5e)($f5ac2423aa106325$var$toRgb(colors.main)));
                if (colors.light) $f5ac2423aa106325$var$setColor(palette[color], 'lightChannel', (0, $78232819f3270ebf$export$427365fc3db6fc5e)($f5ac2423aa106325$var$toRgb(colors.light)));
                if (colors.dark) $f5ac2423aa106325$var$setColor(palette[color], 'darkChannel', (0, $78232819f3270ebf$export$427365fc3db6fc5e)($f5ac2423aa106325$var$toRgb(colors.dark)));
                if (colors.contrastText) $f5ac2423aa106325$var$setColor(palette[color], 'contrastTextChannel', (0, $78232819f3270ebf$export$427365fc3db6fc5e)($f5ac2423aa106325$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $f5ac2423aa106325$var$setColorChannel(palette[color], 'primary');
                    $f5ac2423aa106325$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $f5ac2423aa106325$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $f5ac2423aa106325$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $1c47f479e618a10c$export$2e2bcd8739ae039)(acc, argument), theme);
    // Default color is the palette var, not a hex: `focusVisible` is spread inline (skipped from var
    // generation, see `shouldSkipGeneratingVar`), so the var adapts per scheme at the CSS level — no
    // per-scheme copy needed here, unlike the no-vars path in `createTheme`.
    const focusVisibleInput = (0, $80383a806f62e88e$export$5d0f425d284660f4)(options.focusVisible, args);
    if (focusVisibleInput != null && focusVisibleInput !== false) theme.focusVisible = (0, $80383a806f62e88e$export$c06a3c79efe1b1cf)(focusVisibleInput, getCssVar('palette-primary-main'));
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $7818e2d8d91e995e$export$2e2bcd8739ae039)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $a7b731607dda0271$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $izOUK.createSpacing)(input.spacing, (0, $b44c991153bb6355$export$1def6f833384e3d1)(this));
    };
    theme.getColorSchemeSelector = (0, $e8f9bd6289ba5801$export$858538ff6c0d421d)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $9168152d2e928344$export$2e2bcd8739ae039),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $ac57c12d86c7c4ad$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    theme.internal_cache = {};
    theme.toRuntimeSource = (0, $e859ca6239cf1eb7$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $43c94e4d66cc6ca7$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $316ad872fadeaa61$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $43c94e4d66cc6ca7$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $ef52363d8154b2bf$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $ef52363d8154b2bf$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $43c94e4d66cc6ca7$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $43c94e4d66cc6ca7$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        if (theme.focusVisible != null && theme.focusVisible !== false) {
            let focusVisibleInput = theme.focusVisible;
            const rawFocusVisible = (0, $80383a806f62e88e$export$5d0f425d284660f4)(options.focusVisible, args);
            const authoredColor = rawFocusVisible && typeof rawFocusVisible === 'object' ? rawFocusVisible.outlineColor : undefined;
            // A re-composed theme carries a baked default that looks authored, so it falls back to value
            // equality — the one case where a pinned `primary.main` is indistinguishable and gets reset.
            if (!authoredColor || (0, $80383a806f62e88e$export$685950156577a061)(rawFocusVisible) && authoredColor === theme.palette.primary.main) {
                const { outlineColor: outlineColor, ...rest } = focusVisibleInput;
                focusVisibleInput = rest;
            }
            Object.keys(theme.colorSchemes).forEach((scheme)=>{
                const schemePalette = theme.colorSchemes?.[scheme]?.palette;
                if (schemePalette?.primary) theme.colorSchemes[scheme].focusVisible = (0, $80383a806f62e88e$export$c06a3c79efe1b1cf)(focusVisibleInput, schemePalette.primary.main);
            });
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $f5ac2423aa106325$export$2e2bcd8739ae039)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


'use client';
const $67f38bcd4eefe6c0$var$defaultTheme = (0, $43c94e4d66cc6ca7$export$2e2bcd8739ae039)();
var $67f38bcd4eefe6c0$export$2e2bcd8739ae039 = $67f38bcd4eefe6c0$var$defaultTheme;


var $6fc57858e3c4b1ff$export$2e2bcd8739ae039 = '$$material';


// copied from @mui/system/createStyled
function $4b09f9224099192c$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $4b09f9224099192c$export$2e2bcd8739ae039 = $4b09f9224099192c$var$slotShouldForwardProp;


const $351cb32c42b1eed3$var$rootShouldForwardProp = (prop)=>(0, $4b09f9224099192c$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $351cb32c42b1eed3$export$2e2bcd8739ae039 = $351cb32c42b1eed3$var$rootShouldForwardProp;



'use client';
const $645b094ac36c3642$var$styled = (0, $fec63625cc77ab41$export$2e2bcd8739ae039)({
    themeId: (0, $6fc57858e3c4b1ff$export$2e2bcd8739ae039),
    defaultTheme: $67f38bcd4eefe6c0$export$2e2bcd8739ae039,
    rootShouldForwardProp: $351cb32c42b1eed3$export$2e2bcd8739ae039
});
var $645b094ac36c3642$export$2e2bcd8739ae039 = $645b094ac36c3642$var$styled;



var $izOUK = parcelRequire("izOUK");
const $5e1a1867d67aa166$var$memoTheme = (0, $izOUK.unstable_memoTheme);
var $5e1a1867d67aa166$export$2e2bcd8739ae039 = $5e1a1867d67aa166$var$memoTheme;


parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $9QePP = parcelRequire("9QePP");
function $062cc9b6eeaf4e2a$export$2e2bcd8739ae039(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    const defaultSlotPropValue = defaultSlotProps[slotPropName];
                    const slotPropValue = slotProps[slotPropName];
                    if (typeof defaultSlotPropValue === 'function' || typeof slotPropValue === 'function') // Function slot props are resolved later (with `ownerState`), so defer
                    // the merge until then to avoid dropping either side.
                    output[propName][slotPropName] = (...args)=>$062cc9b6eeaf4e2a$export$2e2bcd8739ae039((typeof defaultSlotPropValue === 'function' ? defaultSlotPropValue(...args) : defaultSlotPropValue) ?? {}, (typeof slotPropValue === 'function' ? slotPropValue(...args) : slotPropValue) ?? {}, mergeClassNameAndStyle);
                    else output[propName][slotPropName] = $062cc9b6eeaf4e2a$export$2e2bcd8739ae039(defaultSlotPropValue ?? {}, slotPropValue ?? {}, mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className !== undefined) output.className = (0, $9QePP.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $858600d8590b5399$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $858600d8590b5399$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($858600d8590b5399$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $858600d8590b5399$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $062cc9b6eeaf4e2a$export$2e2bcd8739ae039)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $062cc9b6eeaf4e2a$export$2e2bcd8739ae039)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $858600d8590b5399$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($858600d8590b5399$var$PropsContext);
    return $858600d8590b5399$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $858600d8590b5399$export$2e2bcd8739ae039 = $858600d8590b5399$var$DefaultPropsProvider;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $66bd921799aa2342$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $858600d8590b5399$export$2e2bcd8739ae039), {
        ...props
    });
}
var $66bd921799aa2342$export$2e2bcd8739ae039 = $66bd921799aa2342$var$DefaultPropsProvider;
function $66bd921799aa2342$export$2440da353cedad43(params) {
    return (0, $858600d8590b5399$export$2440da353cedad43)(params);
}


const $c7441129790637a1$var$defaultGenerator = (componentName)=>componentName;
const $c7441129790637a1$var$createClassNameGenerator = ()=>{
    let generate = $c7441129790637a1$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $c7441129790637a1$var$defaultGenerator;
        }
    };
};
const $c7441129790637a1$var$ClassNameGenerator = $c7441129790637a1$var$createClassNameGenerator();
var $c7441129790637a1$export$2e2bcd8739ae039 = $c7441129790637a1$var$ClassNameGenerator;


const $623cfdcd13f7fde7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $623cfdcd13f7fde7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $623cfdcd13f7fde7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $c7441129790637a1$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $623cfdcd13f7fde7$export$34c0130b1f3e8ae3(slot) {
    return $623cfdcd13f7fde7$export$9d6b9120de57c54[slot] !== undefined;
}


function $2e623b5a37a5b064$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $623cfdcd13f7fde7$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $eea7176674fca188$export$c7c50641356bdfa5(slot) {
    return (0, $623cfdcd13f7fde7$export$2e2bcd8739ae039)('MuiSvgIcon', slot);
}
const $eea7176674fca188$var$svgIconClasses = (0, $2e623b5a37a5b064$export$2e2bcd8739ae039)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $eea7176674fca188$export$2e2bcd8739ae039 = $eea7176674fca188$var$svgIconClasses;


const $999ec0daa4ba3411$export$214b055320e0bf32 = {
    transition: 'none'
};
function $999ec0daa4ba3411$export$3f1342cbd4bf84cc(reducedMotion, styles) {
    if (reducedMotion === 'always') return styles;
    if (reducedMotion === 'system') return {
        '@media (prefers-reduced-motion: reduce)': styles
    };
    return null;
}


const $7a87d67a049ab06d$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
const $7a87d67a049ab06d$var$DEFAULT_TRANSLATE_OFFSET = {
    offsetX: 0,
    offsetY: 0
};
const $7a87d67a049ab06d$var$EMPTY_STYLE = {};
const $7a87d67a049ab06d$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $7a87d67a049ab06d$var$EMPTY_OPTIONS = {};
const $7a87d67a049ab06d$var$transformOffsetIndexes = {
    matrix: [
        4,
        5
    ],
    matrix3d: [
        12,
        13
    ],
    translate: [
        0,
        1
    ],
    translate3d: [
        0,
        1
    ],
    translateX: [
        0,
        null
    ],
    translateY: [
        null,
        0
    ]
};
function $7a87d67a049ab06d$var$parseTranslateValue(value) {
    const parsedValue = parseFloat(value ?? '');
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
}
function $7a87d67a049ab06d$var$parseTransform(transform) {
    const match = transform.match(/^(matrix|matrix3d|translate|translate3d|translateX|translateY)\((.+)\)$/);
    if (!match) return null;
    return {
        type: match[1],
        values: match[2].split(',').map($7a87d67a049ab06d$var$parseTranslateValue)
    };
}
function $7a87d67a049ab06d$var$getTranslateOffsetValue(values, index) {
    return index === null ? 0 : values[index] || 0;
}
function $7a87d67a049ab06d$export$23d6f784a708ab33(transform) {
    if (!transform || transform === 'none') return $7a87d67a049ab06d$var$DEFAULT_TRANSLATE_OFFSET;
    const parsedTransform = $7a87d67a049ab06d$var$parseTransform(transform);
    if (!parsedTransform) return $7a87d67a049ab06d$var$DEFAULT_TRANSLATE_OFFSET;
    const { type: type, values: values } = parsedTransform;
    const offsetIndexes = $7a87d67a049ab06d$var$transformOffsetIndexes[type];
    if (!offsetIndexes) return $7a87d67a049ab06d$var$DEFAULT_TRANSLATE_OFFSET;
    return {
        offsetX: $7a87d67a049ab06d$var$getTranslateOffsetValue(values, offsetIndexes[0]),
        offsetY: $7a87d67a049ab06d$var$getTranslateOffsetValue(values, offsetIndexes[1])
    };
}
function $7a87d67a049ab06d$export$da8da2b45a650a33(nodeRef, callback) {
    return (maybeIsAppearing)=>{
        if (callback) {
            const node = nodeRef.current;
            // Enter callbacks receive isAppearing; exit callbacks do not.
            if (maybeIsAppearing === undefined) callback(node);
            else callback(node, maybeIsAppearing);
        }
    };
}
function $7a87d67a049ab06d$export$c1e03ca92f01ef32(state, inProp, baseStyles, hiddenStyles, styleProp, childStyle) {
    const base = state === 'exited' && !inProp ? hiddenStyles : baseStyles[state] || baseStyles.exited;
    return styleProp || childStyle ? {
        ...base,
        ...styleProp,
        ...childStyle
    } : base;
}
function $7a87d67a049ab06d$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = $7a87d67a049ab06d$var$EMPTY_STYLE } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}
function $7a87d67a049ab06d$export$4bc2c89b8b366948(theme, styles) {
    const resolvedStyles = styles ?? (0, $999ec0daa4ba3411$export$214b055320e0bf32);
    return (0, $999ec0daa4ba3411$export$3f1342cbd4bf84cc)(theme.motion?.reducedMotion, resolvedStyles);
}
function $7a87d67a049ab06d$export$cfbcd9a4c0ed32ac(theme, props = $7a87d67a049ab06d$var$DEFAULT_TRANSITION_PROPS, options = $7a87d67a049ab06d$var$EMPTY_OPTIONS) {
    const transition = theme.transitions?.create?.(props, options);
    const reducedMotionStyles = $7a87d67a049ab06d$export$4bc2c89b8b366948(theme);
    if (transition === undefined) return reducedMotionStyles ?? $7a87d67a049ab06d$var$EMPTY_STYLE;
    const transitionStyles = {
        transition: transition
    };
    return reducedMotionStyles ? {
        ...transitionStyles,
        ...reducedMotionStyles
    } : transitionStyles;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $52b0c20a34843cb4$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $6b1661cb34ace1ce$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $6b1661cb34ace1ce$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $525bb9d73249ebb0$export$2e2bcd8739ae039)(slots, (0, $eea7176674fca188$export$c7c50641356bdfa5), classes);
};
const $52b0c20a34843cb4$var$SvgIconRoot = (0, $645b094ac36c3642$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $6b1661cb34ace1ce$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $6b1661cb34ace1ce$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $5e1a1867d67aa166$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        ...(0, $7a87d67a049ab06d$export$cfbcd9a4c0ed32ac)(theme, 'fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $52b0c20a34843cb4$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $66bd921799aa2342$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $52b0c20a34843cb4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($52b0c20a34843cb4$var$SvgIconRoot, {
        as: component,
        className: (0, $9QePP.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $ayMG0.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$52b0c20a34843cb4$var$SvgIcon.muiName = 'SvgIcon';
var $52b0c20a34843cb4$export$2e2bcd8739ae039 = $52b0c20a34843cb4$var$SvgIcon;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $3a25e7c693be1153$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $52b0c20a34843cb4$export$2e2bcd8739ae039), {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $52b0c20a34843cb4$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}



var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $0a61069863ccac4a$export$2e2bcd8739ae039 = (0, $3a25e7c693be1153$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');



var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");



var $acw62 = parcelRequire("acw62");
'use client';
let $ec714a67dfc3195a$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $ec714a67dfc3195a$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $ec714a67dfc3195a$var$globalId += 1;
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setDefaultId(`mui-${$ec714a67dfc3195a$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $ec714a67dfc3195a$var$safeReact = {
    ...$acw62
};
const $ec714a67dfc3195a$var$maybeReactUseId = $ec714a67dfc3195a$var$safeReact.useId;
function $ec714a67dfc3195a$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($ec714a67dfc3195a$var$maybeReactUseId !== undefined) {
        const reactId = $ec714a67dfc3195a$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $ec714a67dfc3195a$var$useGlobalId(idOverride);
}


'use client';
var $b98aa0c985a50b87$export$2e2bcd8739ae039 = (0, $ec714a67dfc3195a$export$2e2bcd8739ae039);








var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");










function $32a876021b32e1bd$export$29cad1383b3f235d(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $32a876021b32e1bd$var$circularProgressClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDisableShrink'
]);
var $32a876021b32e1bd$export$2e2bcd8739ae039 = $32a876021b32e1bd$var$circularProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4c51549b81a771d3$var$SIZE = 44;
let $4c51549b81a771d3$var$warnedMinMaxWithoutVariant = false;
let $4c51549b81a771d3$var$warnedInvalidMinMaxValue = false;
function $4c51549b81a771d3$export$36f40a3150c2c3a2() {
    $4c51549b81a771d3$var$warnedMinMaxWithoutVariant = false;
    $4c51549b81a771d3$var$warnedInvalidMinMaxValue = false;
}
const $4c51549b81a771d3$var$circularRotateKeyframe = (0, $7a381217d0a161e7$exports.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $4c51549b81a771d3$var$circularDashKeyframe = (0, $7a381217d0a161e7$exports.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $4c51549b81a771d3$var$rotateAnimation = typeof $4c51549b81a771d3$var$circularRotateKeyframe !== 'string' ? (0, $7a381217d0a161e7$exports.css)`
        animation: ${$4c51549b81a771d3$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $4c51549b81a771d3$var$dashAnimation = typeof $4c51549b81a771d3$var$circularDashKeyframe !== 'string' ? (0, $7a381217d0a161e7$exports.css)`
        animation: ${$4c51549b81a771d3$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $4c51549b81a771d3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (0, $32a876021b32e1bd$export$29cad1383b3f235d), classes);
};
const $4c51549b81a771d3$var$CircularProgressRoot = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const reducedMotionAnimationStyles = (0, $2bd06673060f0f5d$export$4bc2c89b8b366948)(theme, {
        animation: 'none'
    });
    return {
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, 'transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $4c51549b81a771d3$var$rotateAnimation || {
                    animation: `${$4c51549b81a771d3$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...reducedMotionAnimationStyles ? [
                {
                    props: {
                        variant: 'indeterminate'
                    },
                    style: reducedMotionAnimationStyles
                }
            ] : [],
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    };
}));
const $4c51549b81a771d3$var$CircularProgressSVG = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $4c51549b81a771d3$var$CircularProgressCircle = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const reducedMotionAnimationStyles = (0, $2bd06673060f0f5d$export$4bc2c89b8b366948)(theme, {
        animation: 'none'
    });
    return {
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, 'stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine while waiting for the animation to kick in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $4c51549b81a771d3$var$dashAnimation || {
                    // At runtime for Pigment CSS, `dashAnimation` will be null and the generated keyframe will be used.
                    animation: `${$4c51549b81a771d3$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            },
            ...reducedMotionAnimationStyles ? [
                {
                    props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                    style: reducedMotionAnimationStyles
                }
            ] : []
        ]
    };
}));
const $4c51549b81a771d3$var$CircularProgressTrack = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $4c51549b81a771d3$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, min: minProp, max: maxProp, size: size = 40, style: style, thickness: thickness = 3.6, value: value = props.min ?? 0, variant: variant = 'indeterminate', ...other } = props;
    const min = minProp ?? 0;
    const max = maxProp ?? 100;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    };
    const classes = $4c51549b81a771d3$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($4c51549b81a771d3$var$SIZE - thickness) / 2);
        const range = max - min;
        circleStyle.strokeDasharray = circumference.toFixed(3);
        circleStyle.strokeDashoffset = range > 0 ? `${((max - value) / range * circumference).toFixed(3)}px` : `${circumference.toFixed(3)}px`; // empty-state fallback when range is invalid
        rootStyle.transform = 'rotate(-90deg)';
        rootProps['aria-valuenow'] = value;
        rootProps['aria-valuemin'] = min;
        rootProps['aria-valuemax'] = max;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($4c51549b81a771d3$var$CircularProgressRoot, {
        className: (0, $i6kju.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($4c51549b81a771d3$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$4c51549b81a771d3$var$SIZE / 2} ${$4c51549b81a771d3$var$SIZE / 2} ${$4c51549b81a771d3$var$SIZE} ${$4c51549b81a771d3$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $ayMG0.jsx)($4c51549b81a771d3$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $4c51549b81a771d3$var$SIZE,
                    cy: $4c51549b81a771d3$var$SIZE,
                    r: ($4c51549b81a771d3$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)($4c51549b81a771d3$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $4c51549b81a771d3$var$SIZE,
                    cy: $4c51549b81a771d3$var$SIZE,
                    r: ($4c51549b81a771d3$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    });
});
var $4c51549b81a771d3$export$2e2bcd8739ae039 = $4c51549b81a771d3$var$CircularProgress;






function $9f2781520c4821f2$export$5a6f9035944c8119(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $9f2781520c4821f2$var$buttonClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'outlined',
    'contained',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $9f2781520c4821f2$export$2e2bcd8739ae039 = $9f2781520c4821f2$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $2fbab2f8273d2029$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $2fbab2f8273d2029$export$2e2bcd8739ae039 = $2fbab2f8273d2029$var$ButtonGroupContext;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $9ead1992620b63d6$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $9ead1992620b63d6$export$2e2bcd8739ae039 = $9ead1992620b63d6$var$ButtonGroupButtonContext;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $56ded5750d61b4b0$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `size${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon'
        ],
        endIcon: [
            'icon',
            'endIcon'
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (0, $9f2781520c4821f2$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $56ded5750d61b4b0$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $56ded5750d61b4b0$var$ButtonRoot = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)((0, $c3b5036e07dbc2e6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $710b5e22b13b2b07$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, [
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $9f2781520c4821f2$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $9f2781520c4821f2$export$2e2bcd8739ae039).focusVisible}`]: {
                        ...theme.focusVisible,
                        boxShadow: theme.focusVisible?.boxShadow ? `${(theme.vars || theme).shadows[6]}, ${theme.focusVisible.boxShadow}` : (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $9f2781520c4821f2$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $9f2781520c4821f2$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $9f2781520c4821f2$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: theme.focusVisible?.boxShadow ?? 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $9f2781520c4821f2$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loading: true,
                    loadingPosition: 'center'
                },
                style: {
                    ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, [
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $9f2781520c4821f2$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $56ded5750d61b4b0$var$ButtonStartIcon = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        alignItems: 'center',
        marginRight: 8,
        marginLeft: -4,
        '&::before': {
            content: '"\\200b"',
            width: 0,
            overflow: 'hidden'
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, [
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$56ded5750d61b4b0$var$commonIconStyles
        ]
    }));
const $56ded5750d61b4b0$var$ButtonEndIcon = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, [
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$56ded5750d61b4b0$var$commonIconStyles
        ]
    }));
const $56ded5750d61b4b0$var$ButtonLoadingIndicator = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $56ded5750d61b4b0$var$ButtonLoadingIconPlaceholder = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $56ded5750d61b4b0$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $2fbab2f8273d2029$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $9ead1992620b63d6$export$2e2bcd8739ae039));
    const resolvedProps = (0, $e7144867d0b2336e$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $b98aa0c985a50b87$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c51549b81a771d3$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $56ded5750d61b4b0$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $ayMG0.jsx)($56ded5750d61b4b0$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($56ded5750d61b4b0$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $ayMG0.jsx)($56ded5750d61b4b0$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($56ded5750d61b4b0$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $ayMG0.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $ayMG0.jsx)($56ded5750d61b4b0$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    // Don't forward the 'root' classes to the ButtonBase, as they will get duplicated with the one passed to the className prop.
    const { root: root, ...forwardedClasses } = classes;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($56ded5750d61b4b0$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $i6kju.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $i6kju.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        internalNativeButton: true,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: forwardedClasses,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $56ded5750d61b4b0$export$2e2bcd8739ae039 = $56ded5750d61b4b0$var$Button;



var $acw62 = parcelRequire("acw62");

function $0bbd411182c954f2$export$369b6b2b30582e8e(Component) {
    const ComponentWithRouterProp = (props)=>{
        try {
            const [location, navigate] = (0, $9d251f10c54460c1$export$45d76561a5302f2b)();
            let params = (0, $9d251f10c54460c1$export$99eaa27ddbbb95ef)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
                ...props,
                router: {
                    location: location,
                    params: params
                }
            });
        } catch (error) {
            console.error("ERROR (withRouter) " + error);
        //console.error("Component " + Component)
        }
    };
    return ComponentWithRouterProp;
}



var $acw62 = parcelRequire("acw62");

const $7d75f43db6894a56$export$59d1b06f370beb91 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d251f10c54460c1$export$a6c7ac8248d6e38a), {
        ...props,
        ref: props.ref,
        to: props.to,
        onClick: props.linkAction,
        align: props.alignText || `inherit`
    }, props.children);
};


var $b979d7b793f3294f$export$2e2bcd8739ae039 = (0, $0bbd411182c954f2$export$369b6b2b30582e8e)((0, $7d75f43db6894a56$export$59d1b06f370beb91));




var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $1e6076bb1523d14f$export$2e2bcd8739ae039 = (0, $3a25e7c693be1153$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");












function $6faa13099992fc61$export$5e8702d71474f093(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $6faa13099992fc61$var$iconButtonClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $6faa13099992fc61$export$2e2bcd8739ae039 = $6faa13099992fc61$var$iconButtonClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $e7b07d6fe8322a0e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (0, $6faa13099992fc61$export$5e8702d71474f093), classes);
};
const $e7b07d6fe8322a0e$var$IconButtonRoot = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)((0, $c3b5036e07dbc2e6$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, 'background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $6faa13099992fc61$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $6faa13099992fc61$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $e7b07d6fe8322a0e$var$IconButtonLoadingIndicator = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $e7b07d6fe8322a0e$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $b98aa0c985a50b87$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c51549b81a771d3$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $e7b07d6fe8322a0e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($e7b07d6fe8322a0e$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $i6kju.default)(classes.root, className),
        centerRipple: true,
        internalNativeButton: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $ayMG0.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($e7b07d6fe8322a0e$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $e7b07d6fe8322a0e$export$2e2bcd8739ae039 = $e7b07d6fe8322a0e$var$IconButton;


const $245879af6017e1c1$export$e0d897ee21382f67 = (props)=>{
    const { classes: classes = {}, onHandleClose: onHandleClose, dialogContext: dialogContext, menuDrawerBackButton: menuDrawerBackButton } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($245879af6017e1c1$export$8cc203231d44dc6a, {
        "aria-label": "Close",
        positionRelative: true,
        onClick: onHandleClose,
        dialogContext: dialogContext ? dialogContext : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1e6076bb1523d14f$export$2e2bcd8739ae039), {
        fontSize: "small"
    }));
};
const $245879af6017e1c1$export$de65de8213222d10 = (props)=>{
    const { classes: classes = {}, onHandleClose: onHandleClose, dialogContext: dialogContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($245879af6017e1c1$export$8cc203231d44dc6a, {
        ariaLabel: "Close",
        positionRelative: true,
        onClick: onHandleClose,
        dialogContext: dialogContext ? dialogContext : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1e6076bb1523d14f$export$2e2bcd8739ae039), {
        fontSize: "small",
        className: classes.scale
    }));
};
const $245879af6017e1c1$export$bd36621ef7814117 = (props)=>{
    const { classes: classes = {}, size: size = "medium", buttonId: buttonId, buttonText: buttonText, buttonColor: buttonColor, buttonIcon: buttonIcon, iconPosition: iconPosition, linkType: linkType, toLocation: toLocation, fullWidth: fullWidth, ...rest } = props;
    if (linkType === 'Link') {
        debugger;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
            id: buttonId,
            size: size,
            component: (0, $b979d7b793f3294f$export$2e2bcd8739ae039),
            fullWidth: fullWidth,
            variant: "contained",
            color: buttonColor ? buttonColor : 'primary',
            to: toLocation,
            disableFocusRipple: true,
            disableRipple: true,
            style: style,
            disabled: rest.disabled,
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, buttonIcon && iconPosition === 'left' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                marginRight: '8px'
            }
        }, buttonIcon), buttonText, buttonIcon && iconPosition === 'right' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                marginLeft: '8px'
            }
        }, buttonIcon));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
        id: buttonId,
        size: size,
        variant: "contained",
        color: buttonColor ? buttonColor : 'primary',
        disableFocusRipple: true,
        disableRipple: true,
        ...rest
    }, buttonIcon && iconPosition === 'left' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, buttonIcon), buttonText, buttonIcon && iconPosition === 'right' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, buttonIcon));
};
const $245879af6017e1c1$export$b7c3a2f69225ecf = (props)=>{
    const { buttonText: buttonText, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
        size: "medium",
        ...rest
    }, buttonText);
};
const $245879af6017e1c1$export$8cc203231d44dc6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function DefaultIconButton(props, ref) {
    const { children: children, classes: classes = {}, className: className, ariaLabel: ariaLabel, color: color = 'default', Icon: Icon, disabled: disabled = false, onClick: onClick, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $e7b07d6fe8322a0e$export$2e2bcd8739ae039), {
        "aria-label": ariaLabel,
        color: color,
        disabled: disabled,
        onClick: onClick,
        ref: ref
    }, Icon, children);
});
const $245879af6017e1c1$export$f4355fbc0e4e5b09 = (props)=>{
    const { classes: classes = {}, theme: theme, buttonIcon: buttonIcon, buttonActive: buttonActive, buttonContext: buttonContext, NoPositionFixed: NoPositionFixed, Small: Small, ...rest } = props;
    return(//        <Zoom
    //            in={buttonActive}
    //            timeout={transitionDuration}
    //            style={{
    //                transitionDelay: buttonActive ? transitionDuration.exit : 0,
    //            }}
    //            unmountOnExit
    //        >
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6802f6f7453275d2$export$2e2bcd8739ae039), {
        color: "primary",
        "aria-label": "Add",
        disableRipple: true,
        size: Small ? "small" : "medium",
        ...buttonContext,
        ...rest
    }, buttonIcon ? buttonIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0a61069863ccac4a$export$2e2bcd8739ae039), null)));
};
const $245879af6017e1c1$export$f861551692d63a2e = (props)=>{
    const { classes: classes = {}, buttonText: buttonText, buttonColor: buttonColor, linkType: linkType, toLocation: toLocation, fullWidth: fullWidth, ActionBtnLight: ActionBtnLight, onClick: onClick, smallButton: smallButton, publicButton: publicButton, withMargin: withMargin, ...rest } = props;
    if (linkType === 'Link') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
        component: (0, $b979d7b793f3294f$export$2e2bcd8739ae039),
        fullWidth: fullWidth,
        variant: "outlined",
        color: "primary",
        to: toLocation ? toLocation : null,
        disableRipple: true,
        disableFocusRipple: true,
        ...rest,
        onClick: (e)=>{
            e.stopPropagation();
        }
    }, buttonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
        variant: "outlined",
        color: "primary",
        disableRipple: true,
        disableFocusRipple: true,
        onClick: onClick,
        ...rest
    }, buttonText);
};
const $245879af6017e1c1$export$8b7b7cdfb85d78c5 = (props)=>{
    const { buttonText: buttonText, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
        value: buttonText,
        type: "submit",
        variant: "contained",
        disableRipple: true,
        disableFocusRipple: true,
        ...rest
    }, buttonText);
};






'use client';
const $86a57fab7595a253$var$Stack = (0, $7a381217d0a161e7$exports.createStack)({
    createStyledComponent: (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('div', {
        name: 'MuiStack',
        slot: 'Root'
    }),
    useThemeProps: (inProps)=>(0, $6a1de905cde5d0a2$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $86a57fab7595a253$export$2e2bcd8739ae039 = $86a57fab7595a253$var$Stack;








const $e6b4a839c5bc390d$var$boxClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $e6b4a839c5bc390d$export$2e2bcd8739ae039 = $e6b4a839c5bc390d$var$boxClasses;


'use client';
const $88bb330b17b77b73$var$defaultTheme = (0, $65495f85012dc470$export$2e2bcd8739ae039)();
const $88bb330b17b77b73$var$Box = (0, $7a381217d0a161e7$exports.createBox)({
    themeId: (0, $19d5729378c2b81d$export$2e2bcd8739ae039),
    defaultTheme: $88bb330b17b77b73$var$defaultTheme,
    defaultClassName: (0, $e6b4a839c5bc390d$export$2e2bcd8739ae039).root,
    generateClassName: (0, $28f74f9ac8531dca$export$2e2bcd8739ae039).generate
});
var $88bb330b17b77b73$export$2e2bcd8739ae039 = $88bb330b17b77b73$var$Box;



var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");








function $afc0e747194b3da9$export$24c1f8f60cbac79e(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $afc0e747194b3da9$var$typographyClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom'
]);
var $afc0e747194b3da9$export$2e2bcd8739ae039 = $afc0e747194b3da9$var$typographyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9d85e9257157a3b9$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap'
        ]
    };
    return (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (0, $afc0e747194b3da9$export$24c1f8f60cbac79e), classes);
};
const $9d85e9257157a3b9$export$140e2f5526d3cad8 = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            }
        ]
    })));
const $9d85e9257157a3b9$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $9d85e9257157a3b9$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const { color: color, align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, variant: variant = 'body1', variantMapping: variantMapping = $9d85e9257157a3b9$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || variantMapping[variant] || $9d85e9257157a3b9$var$defaultVariantMapping[variant] || 'span';
    const classes = $9d85e9257157a3b9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9d85e9257157a3b9$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $i6kju.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $9d85e9257157a3b9$export$2e2bcd8739ae039 = $9d85e9257157a3b9$var$Typography;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $35c034932912ab1a$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}



var $keaWW = parcelRequire("keaWW");
function $0da4f53af9766e58$export$2e2bcd8739ae039(object) {
    if (object == null) return true;
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}



var $acw62 = parcelRequire("acw62");

var $iMVQd = parcelRequire("iMVQd");
function $6d1035fe886e2074$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $6d1035fe886e2074$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || (0, $iMVQd.isValidElementType)(source) || !$6d1035fe886e2074$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $6d1035fe886e2074$var$deepClone(source[key]);
    });
    return output;
}
function $6d1035fe886e2074$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($6d1035fe886e2074$export$53b83ca8eaab0383(target) && $6d1035fe886e2074$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key]) || (0, $iMVQd.isValidElementType)(source[key])) output[key] = source[key];
        else if ($6d1035fe886e2074$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $6d1035fe886e2074$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $6d1035fe886e2074$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $6d1035fe886e2074$export$53b83ca8eaab0383(source[key]) ? $6d1035fe886e2074$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $3bc64fddc9e3eed1$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $5c25258cb94860e5$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $3bc64fddc9e3eed1$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}



var $iMVQd = parcelRequire("iMVQd");
function $708900e23699691f$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $708900e23699691f$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $708900e23699691f$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $708900e23699691f$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $708900e23699691f$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $iMVQd.ForwardRef:
            return $708900e23699691f$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $iMVQd.Memo:
            return $708900e23699691f$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}



// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $fbb32c41e56bc238$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
// Keep in sync with docs/src/pages/customization/breakpoints/breakpoints.md
// #host-reference
const $fbb32c41e56bc238$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $fbb32c41e56bc238$export$2e2bcd8739ae039(breakpoints) {
    const { values: values = {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1536
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $fbb32c41e56bc238$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    const mediaKeys = [];
    for(let i = 0; i < keys.length; i += 1)mediaKeys.push(up(keys[i]));
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        internal_mediaKeys: mediaKeys,
        ...other
    };
}


const $1290ea02f209a728$var$MIN_WIDTH_PATTERN = /min-width:\s*([0-9.]+)/;
function $1290ea02f209a728$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries || !$1290ea02f209a728$var$hasContainerQuery(css)) return css;
    const keys = [];
    for(const key in css)if (key.startsWith('@container')) keys.push(key);
    keys.sort((a, b)=>{
        return +(a.match($1290ea02f209a728$var$MIN_WIDTH_PATTERN)?.[1] || 0) - +(b.match($1290ea02f209a728$var$MIN_WIDTH_PATTERN)?.[1] || 0);
    });
    const result = css;
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        const value = result[key];
        delete result[key];
        result[key] = value;
    }
    return result;
}
function $1290ea02f209a728$var$hasContainerQuery(css) {
    for(const key in css){
        if (key.startsWith('@container')) return true;
    }
    return false;
}
function $1290ea02f209a728$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $1290ea02f209a728$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $1290ea02f209a728$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $e3eaddbbb9e59cdf$var$shape = {
    borderRadius: 4
};
var $e3eaddbbb9e59cdf$export$2e2bcd8739ae039 = $e3eaddbbb9e59cdf$var$shape;





// Based on https://github.com/TehShrike/deepmerge
// Based on https://github.com/fastify/deepmerge
// MIT License
// Copyright (c) 2012 - 2022 James Halliday, Josh Duff, and other contributors of deepmerge
/* eslint-disable no-else-return */ /**
 * Assigns props from one object to another. Focused on performance, only normal objects with no
 * prototype are supported.
 */ function $b679311ebbb5aa39$export$2e2bcd8739ae039(target, source) {
    const sourceIsArray = Array.isArray(source);
    const targetIsArray = Array.isArray(target);
    if ($b679311ebbb5aa39$var$isPrimitive(source)) return source;
    else if ($b679311ebbb5aa39$var$isPrimitiveOrBuiltIn(target)) return $b679311ebbb5aa39$var$clone(source);
    else if (sourceIsArray && targetIsArray) return $b679311ebbb5aa39$var$mergeArray(target, source);
    else if (sourceIsArray !== targetIsArray) return $b679311ebbb5aa39$var$clone(source);
    else return $b679311ebbb5aa39$var$mergeObject(target, source);
}
function $b679311ebbb5aa39$var$cloneArray(value) {
    let i = 0;
    const il = value.length;
    const result = new Array(il);
    for(i = 0; i < il; i += 1)result[i] = $b679311ebbb5aa39$var$clone(value[i]);
    return result;
}
function $b679311ebbb5aa39$var$cloneObject(target) {
    const result = {};
    for(const key in target){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        result[key] = $b679311ebbb5aa39$var$clone(target[key]);
    }
    return result;
}
function $b679311ebbb5aa39$var$mergeArray(target, source) {
    const tl = target.length;
    for(let i = 0; i < source.length; i += 1)target[tl + i] = $b679311ebbb5aa39$var$clone(source[i]);
    return target;
}
function $b679311ebbb5aa39$var$isMergeableObject(value) {
    return typeof value === 'object' && value !== null && !(value instanceof RegExp) && !(value instanceof Date);
}
function $b679311ebbb5aa39$var$isPrimitive(value) {
    return typeof value !== 'object' || value === null;
}
function $b679311ebbb5aa39$var$isPrimitiveOrBuiltIn(value) {
    return typeof value !== 'object' || value === null || value instanceof RegExp || value instanceof Date;
}
function $b679311ebbb5aa39$var$clone(entry) {
    // eslint-disable-next-line no-nested-ternary
    return $b679311ebbb5aa39$var$isMergeableObject(entry) ? Array.isArray(entry) ? $b679311ebbb5aa39$var$cloneArray(entry) : $b679311ebbb5aa39$var$cloneObject(entry) : entry;
}
function $b679311ebbb5aa39$var$mergeObject(target, source) {
    for(const key in source){
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') continue;
        if (key in target) target[key] = $b679311ebbb5aa39$export$2e2bcd8739ae039(target[key], source[key]);
        else target[key] = $b679311ebbb5aa39$var$clone(source[key]);
    }
    return target;
}




const $a1c0ef156b7e001f$var$options = {
    clone: false
};
function $a1c0ef156b7e001f$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $6d1035fe886e2074$export$2e2bcd8739ae039)(acc, item, $a1c0ef156b7e001f$var$options);
}
var $a1c0ef156b7e001f$export$2e2bcd8739ae039 = $a1c0ef156b7e001f$var$merge;




const $84233c634f5f2c65$var$EMPTY_THEME = {};
const $84233c634f5f2c65$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $84233c634f5f2c65$export$666ad80b5007f835 = (0, $fbb32c41e56bc238$export$2e2bcd8739ae039)({
    values: $84233c634f5f2c65$export$68c286be0e7e55b7
});
const $84233c634f5f2c65$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $84233c634f5f2c65$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $84233c634f5f2c65$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const result = {};
    return $84233c634f5f2c65$export$2aea645392b97e0b(result, props.theme, propValue, (mediaKey, value, initialKey)=>{
        const finalValue = styleFromPropValue(value, initialKey);
        if (mediaKey) result[mediaKey] = finalValue;
        else (0, $b679311ebbb5aa39$export$2e2bcd8739ae039)(result, finalValue);
    });
}
function $84233c634f5f2c65$export$2aea645392b97e0b(target, theme, propValue, callback) {
    theme ??= $84233c634f5f2c65$var$EMPTY_THEME;
    if (Array.isArray(propValue)) {
        const breakpoints = theme.breakpoints ?? $84233c634f5f2c65$export$666ad80b5007f835;
        for(let i = 0; i < propValue.length; i += 1)$84233c634f5f2c65$var$buildBreakpoint(target, breakpoints.up(breakpoints.keys[i]), propValue[i], undefined, callback);
        return target;
    }
    if (typeof propValue === 'object') {
        const breakpoints = theme.breakpoints ?? $84233c634f5f2c65$export$666ad80b5007f835;
        const breakpointValues = breakpoints.values ?? $84233c634f5f2c65$export$68c286be0e7e55b7;
        for(const key in propValue){
            if ((0, $1290ea02f209a728$export$77c7c3e357f440e7)(breakpoints.keys, key)) {
                const containerKey = (0, $1290ea02f209a728$export$10a9745dfa00d15)(theme.containerQueries ? theme : $84233c634f5f2c65$var$defaultContainerQueries, key);
                if (containerKey) $84233c634f5f2c65$var$buildBreakpoint(target, containerKey, propValue[key], key, callback);
            } else if (key in breakpointValues) {
                const mediaKey = breakpoints.up(key);
                $84233c634f5f2c65$var$buildBreakpoint(target, mediaKey, propValue[key], key, callback);
            } else {
                const cssKey = key;
                target[cssKey] = propValue[cssKey];
            }
        }
        return target;
    }
    callback(undefined, propValue);
    return target;
}
function $84233c634f5f2c65$var$buildBreakpoint(target, mediaKey, value, initialKey, callback) {
    target[mediaKey] ??= {};
    callback(mediaKey, value, initialKey);
}
function $84233c634f5f2c65$var$setupBreakpoints(styleFunction) {
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $84233c634f5f2c65$export$666ad80b5007f835;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $a1c0ef156b7e001f$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $84233c634f5f2c65$export$1f2600516e91381f(breakpoints = $84233c634f5f2c65$export$666ad80b5007f835) {
    const { internal_mediaKeys: mediaKeys } = breakpoints;
    const result = {};
    for(let i = 0; i < mediaKeys.length; i += 1)result[mediaKeys[i]] = {};
    return result;
}
function $84233c634f5f2c65$export$8922c90b6e020726(breakpoints, style) {
    const breakpointKeys = breakpoints.internal_mediaKeys;
    for(let i = 0; i < breakpointKeys.length; i += 1){
        const key = breakpointKeys[i];
        if ((0, $0da4f53af9766e58$export$2e2bcd8739ae039)(style[key])) delete style[key];
    }
    return style;
}
function $84233c634f5f2c65$export$b89a003a1e05c0ee(breakpoints, ...styles) {
    const emptyBreakpoints = $84233c634f5f2c65$export$1f2600516e91381f(breakpoints);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $6d1035fe886e2074$export$2e2bcd8739ae039)(prev, next), {});
    return $84233c634f5f2c65$export$8922c90b6e020726(breakpoints, mergedOutput);
}
function $84233c634f5f2c65$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $84233c634f5f2c65$export$980e6a259d807490(options) {
    const { values: breakpointValues, breakpoints: themeBreakpoints, base: customBase } = options;
    const base = customBase || $84233c634f5f2c65$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object' && breakpointValues) {
            const bv = breakpointValues;
            acc[breakpoint] = bv[breakpoint] != null ? bv[breakpoint] : bv[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
function $84233c634f5f2c65$export$c29c12f694bb7a2f(breakpoints, value) {
    if (Array.isArray(value)) return true;
    if (typeof value === 'object' && value !== null) {
        for(let i = 0; i < breakpoints.keys.length; i += 1){
            if (breakpoints.keys[i] in value) return true;
        }
        const valueKeys = Object.keys(value);
        for(let i = 0; i < valueKeys.length; i += 1){
            if ((0, $1290ea02f209a728$export$77c7c3e357f440e7)(breakpoints.keys, valueKeys[i])) return true;
        }
    }
    return false;
}
var $84233c634f5f2c65$export$2e2bcd8739ae039 = $84233c634f5f2c65$var$setupBreakpoints;





function $14320da9d0de2b77$export$741ad47189a64aa0(themeMapping, transform, valueFinal, userValue = valueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(valueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[valueFinal] || userValue;
    else if (typeof valueFinal === 'string') value = $14320da9d0de2b77$export$2aa3fd96c49a84a8(themeMapping, valueFinal) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $14320da9d0de2b77$export$245e5a5849651da5(themeMapping, transform, userValue, alternateProp) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(userValue);
    else if (Array.isArray(themeMapping)) value = themeMapping[userValue] || userValue;
    else if (typeof userValue === 'string') value = $14320da9d0de2b77$export$2aa3fd96c49a84a8(themeMapping, userValue, true, alternateProp) || userValue;
    else value = userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $14320da9d0de2b77$export$2aa3fd96c49a84a8(obj, pathInput, checkVars = true, alternateProp) {
    if (!obj || !pathInput) return null;
    const path = pathInput.split('.');
    // Check if CSS variables are used
    if (obj.vars && checkVars) {
        const val = $14320da9d0de2b77$var$getPathImpl(obj.vars, path, alternateProp);
        if (val != null) return val;
    }
    return $14320da9d0de2b77$var$getPathImpl(obj, path, alternateProp);
}
function $14320da9d0de2b77$var$getPathImpl(object, path, alternateProp) {
    let lastResult = undefined;
    let result = object;
    let index = 0;
    while(index < path.length){
        if (result === null || result === undefined) return result;
        lastResult = result;
        result = result[path[index]];
        index += 1;
    }
    if (alternateProp && result === undefined) {
        const lastKey = path[path.length - 1];
        const alternateKey = `${alternateProp}${lastKey === 'default' ? '' : (0, $5c25258cb94860e5$export$2e2bcd8739ae039)(lastKey)}`;
        return lastResult?.[alternateKey];
    }
    return result;
}
function $14320da9d0de2b77$export$2e2bcd8739ae039(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $14320da9d0de2b77$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (valueFinal)=>{
            const value = $14320da9d0de2b77$export$245e5a5849651da5(themeMapping, transform, valueFinal, prop);
            return cssProperty === false ? value : {
                [cssProperty]: value
            };
        };
        return (0, $84233c634f5f2c65$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}


/* eslint-disable guard-for-in */ const $90cb42e89a0e7057$var$EMPTY_THEME = {
    internal_cache: {}
};
const $90cb42e89a0e7057$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $90cb42e89a0e7057$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $90cb42e89a0e7057$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
const $90cb42e89a0e7057$var$CSS_PROPERTIES = {};
for(const key in $90cb42e89a0e7057$var$properties)$90cb42e89a0e7057$var$CSS_PROPERTIES[key] = [
    $90cb42e89a0e7057$var$properties[key]
];
for(const keyProperty in $90cb42e89a0e7057$var$properties)for(const keyDirection in $90cb42e89a0e7057$var$directions){
    const property = $90cb42e89a0e7057$var$properties[keyProperty];
    const direction = $90cb42e89a0e7057$var$directions[keyDirection];
    const value = Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
    $90cb42e89a0e7057$var$CSS_PROPERTIES[keyProperty + keyDirection] = value;
}
for(const key in $90cb42e89a0e7057$var$aliases)$90cb42e89a0e7057$var$CSS_PROPERTIES[key] = $90cb42e89a0e7057$var$CSS_PROPERTIES[$90cb42e89a0e7057$var$aliases[key]];
const $90cb42e89a0e7057$export$aab52a0dde05ad8a = new Set([
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
]);
const $90cb42e89a0e7057$export$f8397d44f03ab6ad = new Set([
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
]);
const $90cb42e89a0e7057$var$spacingKeys = new Set([
    ...$90cb42e89a0e7057$export$aab52a0dde05ad8a,
    ...$90cb42e89a0e7057$export$f8397d44f03ab6ad
]);
function $90cb42e89a0e7057$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $14320da9d0de2b77$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $90cb42e89a0e7057$export$1def6f833384e3d1(theme) {
    return $90cb42e89a0e7057$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $90cb42e89a0e7057$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
// Avoid allocations
const $90cb42e89a0e7057$var$container = [
    ''
];
function $90cb42e89a0e7057$var$style(props, keys) {
    const theme = props.theme ?? $90cb42e89a0e7057$var$EMPTY_THEME;
    const transformer = theme?.internal_cache?.unarySpacing ?? $90cb42e89a0e7057$export$1def6f833384e3d1(theme);
    const result = {};
    for(const prop in props){
        if (!keys.has(prop)) continue;
        const cssProperties = $90cb42e89a0e7057$var$CSS_PROPERTIES[prop] ?? ($90cb42e89a0e7057$var$container[0] = prop, $90cb42e89a0e7057$var$container);
        const propValue = props[prop];
        (0, $84233c634f5f2c65$export$2aea645392b97e0b)(result, props.theme, propValue, (mediaKey, value)=>{
            const target = mediaKey ? result[mediaKey] : result;
            for(let i = 0; i < cssProperties.length; i += 1)target[cssProperties[i]] = $90cb42e89a0e7057$export$bf7199a9ebcb84a9(transformer, value);
        });
    }
    return result;
}
function $90cb42e89a0e7057$var$marginFn(props) {
    return $90cb42e89a0e7057$var$style(props, $90cb42e89a0e7057$export$aab52a0dde05ad8a);
}
$90cb42e89a0e7057$var$marginFn.propTypes = {};
$90cb42e89a0e7057$var$marginFn.filterProps = $90cb42e89a0e7057$export$aab52a0dde05ad8a;
const $90cb42e89a0e7057$export$7ede87f9b603dd3c = $90cb42e89a0e7057$var$marginFn;
function $90cb42e89a0e7057$var$paddingFn(props) {
    return $90cb42e89a0e7057$var$style(props, $90cb42e89a0e7057$export$f8397d44f03ab6ad);
}
$90cb42e89a0e7057$var$paddingFn.propTypes = {};
$90cb42e89a0e7057$var$paddingFn.filterProps = $90cb42e89a0e7057$export$f8397d44f03ab6ad;
const $90cb42e89a0e7057$export$6f98e8eaf0be1996 = $90cb42e89a0e7057$var$paddingFn;
function $90cb42e89a0e7057$var$spacingFn(props) {
    return $90cb42e89a0e7057$var$style(props, $90cb42e89a0e7057$var$spacingKeys);
}
$90cb42e89a0e7057$var$spacingFn.propTypes = {};
$90cb42e89a0e7057$var$spacingFn.filterProps = $90cb42e89a0e7057$var$spacingKeys;
const $90cb42e89a0e7057$var$spacing = $90cb42e89a0e7057$var$spacingFn;
var $90cb42e89a0e7057$export$2e2bcd8739ae039 = $90cb42e89a0e7057$var$spacing;


function $0026cc1701e88c86$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $90cb42e89a0e7057$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}










function $b19be56f03d55dc3$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    const fn = (props)=>{
        const result = {};
        for(const prop in props)if (handlers[prop]) (0, $b679311ebbb5aa39$export$2e2bcd8739ae039)(result, handlers[prop](props));
        return result;
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $b19be56f03d55dc3$export$2e2bcd8739ae039 = $b19be56f03d55dc3$var$compose;




function $efc100796d5794cb$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $efc100796d5794cb$var$createBorderStyle(prop, transform) {
    return (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $efc100796d5794cb$export$1edee58a52776cd9 = $efc100796d5794cb$var$createBorderStyle('border', $efc100796d5794cb$export$34e2febe53ae29cc);
const $efc100796d5794cb$export$f9a7b6bd24892946 = $efc100796d5794cb$var$createBorderStyle('borderTop', $efc100796d5794cb$export$34e2febe53ae29cc);
const $efc100796d5794cb$export$5abca33e6be905d2 = $efc100796d5794cb$var$createBorderStyle('borderRight', $efc100796d5794cb$export$34e2febe53ae29cc);
const $efc100796d5794cb$export$e2ce9f12a980a822 = $efc100796d5794cb$var$createBorderStyle('borderBottom', $efc100796d5794cb$export$34e2febe53ae29cc);
const $efc100796d5794cb$export$47658cca1a909427 = $efc100796d5794cb$var$createBorderStyle('borderLeft', $efc100796d5794cb$export$34e2febe53ae29cc);
const $efc100796d5794cb$export$e7fb0694ba2404fc = $efc100796d5794cb$var$createBorderStyle('borderColor');
const $efc100796d5794cb$export$126a92c968acdb85 = $efc100796d5794cb$var$createBorderStyle('borderTopColor');
const $efc100796d5794cb$export$85cc51cb8fbb8c0e = $efc100796d5794cb$var$createBorderStyle('borderRightColor');
const $efc100796d5794cb$export$340b0327727f6d1a = $efc100796d5794cb$var$createBorderStyle('borderBottomColor');
const $efc100796d5794cb$export$60beef91a985b4bf = $efc100796d5794cb$var$createBorderStyle('borderLeftColor');
const $efc100796d5794cb$export$f9258c55612cbed7 = $efc100796d5794cb$var$createBorderStyle('outline', $efc100796d5794cb$export$34e2febe53ae29cc);
const $efc100796d5794cb$export$621fe586efeb64b9 = $efc100796d5794cb$var$createBorderStyle('outlineColor');
const $efc100796d5794cb$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $90cb42e89a0e7057$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $90cb42e89a0e7057$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $84233c634f5f2c65$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$efc100796d5794cb$export$7a57f79000377ca2.propTypes = {};
$efc100796d5794cb$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $efc100796d5794cb$var$borders = (0, $b19be56f03d55dc3$export$2e2bcd8739ae039)($efc100796d5794cb$export$1edee58a52776cd9, $efc100796d5794cb$export$f9a7b6bd24892946, $efc100796d5794cb$export$5abca33e6be905d2, $efc100796d5794cb$export$e2ce9f12a980a822, $efc100796d5794cb$export$47658cca1a909427, $efc100796d5794cb$export$e7fb0694ba2404fc, $efc100796d5794cb$export$126a92c968acdb85, $efc100796d5794cb$export$85cc51cb8fbb8c0e, $efc100796d5794cb$export$340b0327727f6d1a, $efc100796d5794cb$export$60beef91a985b4bf, $efc100796d5794cb$export$7a57f79000377ca2, $efc100796d5794cb$export$f9258c55612cbed7, $efc100796d5794cb$export$621fe586efeb64b9);
var $efc100796d5794cb$export$2e2bcd8739ae039 = $efc100796d5794cb$var$borders;







const $acc3b898d276d7d2$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $90cb42e89a0e7057$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $90cb42e89a0e7057$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $84233c634f5f2c65$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$acc3b898d276d7d2$export$5df9adcb0db95e1e.propTypes = {};
$acc3b898d276d7d2$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $acc3b898d276d7d2$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $90cb42e89a0e7057$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $90cb42e89a0e7057$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $84233c634f5f2c65$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$acc3b898d276d7d2$export$ec60d70ff941a580.propTypes = {};
$acc3b898d276d7d2$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $acc3b898d276d7d2$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $90cb42e89a0e7057$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $90cb42e89a0e7057$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $84233c634f5f2c65$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$acc3b898d276d7d2$export$8a833ffa5f5dbeda.propTypes = {};
$acc3b898d276d7d2$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $acc3b898d276d7d2$export$baf44164ca3a34e8 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $acc3b898d276d7d2$export$8f7213a1cd01e832 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $acc3b898d276d7d2$export$b0e0abbc49ba668 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $acc3b898d276d7d2$export$bcd8b929d4b4142 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $acc3b898d276d7d2$export$e5039a674e14c828 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $acc3b898d276d7d2$export$42bd9088661ffb03 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $acc3b898d276d7d2$export$920682ae05b999bc = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $acc3b898d276d7d2$export$1b88fbdd482fd33a = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $acc3b898d276d7d2$export$bdb486e40d52d26f = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $acc3b898d276d7d2$var$grid = (0, $b19be56f03d55dc3$export$2e2bcd8739ae039)($acc3b898d276d7d2$export$5df9adcb0db95e1e, $acc3b898d276d7d2$export$ec60d70ff941a580, $acc3b898d276d7d2$export$8a833ffa5f5dbeda, $acc3b898d276d7d2$export$baf44164ca3a34e8, $acc3b898d276d7d2$export$8f7213a1cd01e832, $acc3b898d276d7d2$export$b0e0abbc49ba668, $acc3b898d276d7d2$export$bcd8b929d4b4142, $acc3b898d276d7d2$export$e5039a674e14c828, $acc3b898d276d7d2$export$42bd9088661ffb03, $acc3b898d276d7d2$export$920682ae05b999bc, $acc3b898d276d7d2$export$1b88fbdd482fd33a, $acc3b898d276d7d2$export$bdb486e40d52d26f);
var $acc3b898d276d7d2$export$2e2bcd8739ae039 = $acc3b898d276d7d2$var$grid;




function $c6a2440c12a89c17$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $c6a2440c12a89c17$export$35e9368ef982300f = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $c6a2440c12a89c17$export$dbaffd4420ea0ac6
});
const $c6a2440c12a89c17$export$2506f56c10355b33 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $c6a2440c12a89c17$export$dbaffd4420ea0ac6
});
const $c6a2440c12a89c17$export$8c5a050822fd698c = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $c6a2440c12a89c17$export$dbaffd4420ea0ac6
});
const $c6a2440c12a89c17$var$palette = (0, $b19be56f03d55dc3$export$2e2bcd8739ae039)($c6a2440c12a89c17$export$35e9368ef982300f, $c6a2440c12a89c17$export$2506f56c10355b33, $c6a2440c12a89c17$export$8c5a050822fd698c);
var $c6a2440c12a89c17$export$2e2bcd8739ae039 = $c6a2440c12a89c17$var$palette;





const $c2a40f1721a1d788$var$breakpointsValues = $84233c634f5f2c65$export$68c286be0e7e55b7;
function $c2a40f1721a1d788$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $c2a40f1721a1d788$export$7e3df82ee760448c = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $c2a40f1721a1d788$export$8afece71750ec241
});
const $c2a40f1721a1d788$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || $c2a40f1721a1d788$var$breakpointsValues[propValue];
            if (!breakpoint) return {
                maxWidth: $c2a40f1721a1d788$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $84233c634f5f2c65$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$c2a40f1721a1d788$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $c2a40f1721a1d788$export$ee148fbbe8357dd2 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $c2a40f1721a1d788$export$8afece71750ec241
});
const $c2a40f1721a1d788$export$ac607276a8fe9f0a = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $c2a40f1721a1d788$export$8afece71750ec241
});
const $c2a40f1721a1d788$export$dc0d8bd0b94f8570 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $c2a40f1721a1d788$export$8afece71750ec241
});
const $c2a40f1721a1d788$export$a43cf604e12f3b17 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $c2a40f1721a1d788$export$8afece71750ec241
});
const $c2a40f1721a1d788$export$ffed9f14fb65e276 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $c2a40f1721a1d788$export$8afece71750ec241
});
const $c2a40f1721a1d788$export$905076ed6620e671 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $c2a40f1721a1d788$export$8afece71750ec241
});
const $c2a40f1721a1d788$export$6ccc93f785106a58 = (0, $14320da9d0de2b77$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $c2a40f1721a1d788$var$sizing = (0, $b19be56f03d55dc3$export$2e2bcd8739ae039)($c2a40f1721a1d788$export$7e3df82ee760448c, $c2a40f1721a1d788$export$488fda99655ff65a, $c2a40f1721a1d788$export$ee148fbbe8357dd2, $c2a40f1721a1d788$export$ac607276a8fe9f0a, $c2a40f1721a1d788$export$dc0d8bd0b94f8570, $c2a40f1721a1d788$export$a43cf604e12f3b17, $c2a40f1721a1d788$export$6ccc93f785106a58);
var $c2a40f1721a1d788$export$2e2bcd8739ae039 = $c2a40f1721a1d788$var$sizing;


const $d39c8cc6675768b1$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $efc100796d5794cb$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $efc100796d5794cb$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $efc100796d5794cb$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $efc100796d5794cb$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $efc100796d5794cb$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $efc100796d5794cb$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $efc100796d5794cb$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $c6a2440c12a89c17$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $c6a2440c12a89c17$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $c6a2440c12a89c17$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $90cb42e89a0e7057$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $90cb42e89a0e7057$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $acc3b898d276d7d2$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $acc3b898d276d7d2$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $acc3b898d276d7d2$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $c2a40f1721a1d788$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $c2a40f1721a1d788$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $c2a40f1721a1d788$export$8afece71750ec241)
    },
    height: {
        transform: (0, $c2a40f1721a1d788$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $c2a40f1721a1d788$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $c2a40f1721a1d788$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $d39c8cc6675768b1$export$2e2bcd8739ae039 = $d39c8cc6675768b1$var$defaultSxConfig;


/**
 * The `css` function accepts arrays as values for mobile-first responsive styles.
 * Note that this extends to non-theme values also. For example `display=['none', 'block']`
 * will also works.
 */ /**
 * Map of all CSS pseudo selectors (`:hover`, `:focus`, ...).
 */ /**
 * Map all nested selectors.
 */ /**
 * Map all nested selectors and CSS variables.
 */ /**
 * Map of all available CSS properties (including aliases) and their raw value.
 * Only used internally to map CSS properties to input types (responsive value,
 * theme function or nested) in `SystemCssProperties`.
 */ /**
 * The `SystemStyleObject` defines custom properties that will be transformed to
 * their corresponding values from the `Theme`. Other valid CSS properties are also allowed.
 */ /**
 * The `SxProps` can be either object or function
 */ /* eslint-disable guard-for-in */ const $1fa770ef53be4d21$var$EMPTY_THEME = {};
function $1fa770ef53be4d21$export$7d53d8bf2911e013() {
    function styleFunctionSx(props) {
        if (!props.sx) return null;
        const { sx: sx, theme: theme = $1fa770ef53be4d21$var$EMPTY_THEME, nested: nested } = props;
        const config = theme.unstable_sxConfig ?? (0, $d39c8cc6675768b1$export$2e2bcd8739ae039);
        // Pass argument without loop allocations
        const wrapper = {
            sx: null,
            theme: theme,
            nested: true
        };
        function process(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const breakpoints = theme.breakpoints ?? (0, $84233c634f5f2c65$export$666ad80b5007f835);
            const css = (0, $84233c634f5f2c65$export$1f2600516e91381f)(breakpoints);
            for(const styleKey in sxObject){
                const value = $1fa770ef53be4d21$var$callIfFn(sxObject[styleKey], theme);
                if (value === null || value === undefined) continue;
                if (typeof value !== 'object') {
                    $1fa770ef53be4d21$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if (config[styleKey]) {
                    $1fa770ef53be4d21$var$setThemeValue(css, styleKey, value, theme, config);
                    continue;
                }
                if ((0, $84233c634f5f2c65$export$c29c12f694bb7a2f)(breakpoints, value)) (0, $84233c634f5f2c65$export$2aea645392b97e0b)(css, props.theme, value, (mediaKey, finalValue)=>{
                    css[mediaKey][styleKey] = finalValue;
                });
                else {
                    wrapper.sx = value;
                    css[styleKey] = styleFunctionSx(wrapper);
                }
            }
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $1290ea02f209a728$export$456f6c1142f990db)(theme, (0, $84233c634f5f2c65$export$8922c90b6e020726)(breakpoints, css))
            };
            return (0, $1290ea02f209a728$export$456f6c1142f990db)(theme, (0, $84233c634f5f2c65$export$8922c90b6e020726)(breakpoints, css));
        }
        return Array.isArray(sx) ? sx.map(process) : process(sx);
    }
    styleFunctionSx.filterProps = [
        'sx'
    ];
    return styleFunctionSx;
}
var $1fa770ef53be4d21$export$2e2bcd8739ae039 = $1fa770ef53be4d21$export$7d53d8bf2911e013();
function $1fa770ef53be4d21$var$setThemeValue(css, prop, value, theme, config) {
    const options = config[prop];
    if (!options) {
        css[prop] = value;
        return;
    }
    if (value == null) return;
    const { themeKey: themeKey } = options;
    // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
    if (themeKey === 'typography' && value === 'inherit') {
        css[prop] = value;
        return;
    }
    const { style: style } = options;
    if (style) {
        (0, $b679311ebbb5aa39$export$2e2bcd8739ae039)(css, style({
            [prop]: value,
            theme: theme
        }));
        return;
    }
    const { cssProperty: cssProperty = prop, transform: transform } = options;
    const themeMapping = (0, $14320da9d0de2b77$export$2aa3fd96c49a84a8)(theme, themeKey);
    (0, $84233c634f5f2c65$export$2aea645392b97e0b)(css, theme, value, (mediaKey, valueFinal)=>{
        const finalValue = (0, $14320da9d0de2b77$export$245e5a5849651da5)(themeMapping, transform, valueFinal, prop);
        if (cssProperty === false) {
            if (mediaKey) (0, $b679311ebbb5aa39$export$2e2bcd8739ae039)(css[mediaKey], finalValue);
            else (0, $b679311ebbb5aa39$export$2e2bcd8739ae039)(css, finalValue);
        } else // eslint-disable-next-line no-lonely-if
        if (mediaKey) css[mediaKey][cssProperty] = finalValue;
        else css[cssProperty] = finalValue;
    });
}
function $1fa770ef53be4d21$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $bea779c6d8f52de7$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


/**
 * Generate a theme base on the options received.
 * @param options Takes an incomplete theme object and adds the missing parts.
 * @param args Deep merge the arguments with the about to be returned theme.
 * @returns A complete, ready-to-use theme object.
 */ function $771c3de9a70a57c0$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $fbb32c41e56bc238$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $0026cc1701e88c86$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $6d1035fe886e2074$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $e3eaddbbb9e59cdf$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $1290ea02f209a728$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $bea779c6d8f52de7$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $6d1035fe886e2074$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $d39c8cc6675768b1$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $1fa770ef53be4d21$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.internal_cache = {};
    return muiTheme;
}
var $771c3de9a70a57c0$export$2e2bcd8739ae039 = $771c3de9a70a57c0$var$createTheme;




var $keaWW = parcelRequire("keaWW");
function $c3dc4eb61392a225$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $keaWW.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $keaWW.internal_serializeStyles)(variant.style);
    });
    return result;
}


const $2d9f7f7ae5f23e9d$export$35e57303dbd8a66 = (0, $771c3de9a70a57c0$export$2e2bcd8739ae039)();
function $2d9f7f7ae5f23e9d$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $2d9f7f7ae5f23e9d$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $2d9f7f7ae5f23e9d$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $2d9f7f7ae5f23e9d$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = (0, $0da4f53af9766e58$export$2e2bcd8739ae039)(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $2d9f7f7ae5f23e9d$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$2d9f7f7ae5f23e9d$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $2d9f7f7ae5f23e9d$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $2d9f7f7ae5f23e9d$var$shallowLayer((0, $keaWW.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $2d9f7f7ae5f23e9d$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $2d9f7f7ae5f23e9d$var$shallowLayer((0, $keaWW.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $2d9f7f7ae5f23e9d$var$shallowLayer((0, $keaWW.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $2d9f7f7ae5f23e9d$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $2d9f7f7ae5f23e9d$var$shallowLayer((0, $keaWW.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $2d9f7f7ae5f23e9d$var$shallowLayer((0, $keaWW.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $2d9f7f7ae5f23e9d$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $2d9f7f7ae5f23e9d$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $2d9f7f7ae5f23e9d$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $2d9f7f7ae5f23e9d$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $2d9f7f7ae5f23e9d$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $keaWW.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $1fa770ef53be4d21$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $2d9f7f7ae5f23e9d$var$defaultOverridesResolver($2d9f7f7ae5f23e9d$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $2d9f7f7ae5f23e9d$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($2d9f7f7ae5f23e9d$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, (/*@__PURE__*/$parcel$interopDefault($keaWW)))(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $2d9f7f7ae5f23e9d$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $2d9f7f7ae5f23e9d$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $6d1035fe886e2074$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $c3dc4eb61392a225$export$2e2bcd8739ae039)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $2d9f7f7ae5f23e9d$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $2d9f7f7ae5f23e9d$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $2d9f7f7ae5f23e9d$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $2d9f7f7ae5f23e9d$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $1fa770ef53be4d21$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $2d9f7f7ae5f23e9d$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $5c25258cb94860e5$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $708900e23699691f$export$2e2bcd8739ae039)(tag)})`;
}
function $2d9f7f7ae5f23e9d$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $2d9f7f7ae5f23e9d$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $2d9f7f7ae5f23e9d$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}





function $906446081663e7e1$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $906446081663e7e1$export$2e2bcd8739ae039 = $906446081663e7e1$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $0371815994dff8e4$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $906446081663e7e1$export$2e2bcd8739ae039)(value, min, max);
}
function $0371815994dff8e4$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $0371815994dff8e4$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $0371815994dff8e4$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $0371815994dff8e4$export$677b39864803984e($0371815994dff8e4$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $3bc64fddc9e3eed1$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $3bc64fddc9e3eed1$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $0371815994dff8e4$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $0371815994dff8e4$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $0371815994dff8e4$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $0371815994dff8e4$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $0371815994dff8e4$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $0371815994dff8e4$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $0371815994dff8e4$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$0371815994dff8e4$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $0371815994dff8e4$export$29fb7152bd3f781a(color) {
    color = $0371815994dff8e4$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $0371815994dff8e4$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $0371815994dff8e4$export$c852d90bf7403b62(color) {
    color = $0371815994dff8e4$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $0371815994dff8e4$export$677b39864803984e($0371815994dff8e4$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $0371815994dff8e4$export$d061e26956a60b0a(foreground, background) {
    const lumA = $0371815994dff8e4$export$c852d90bf7403b62(foreground);
    const lumB = $0371815994dff8e4$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $0371815994dff8e4$export$58f0f39f63f3cf42(color, value) {
    color = $0371815994dff8e4$export$677b39864803984e(color);
    value = $0371815994dff8e4$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $0371815994dff8e4$export$211a73f2b8c10ce4(color);
}
function $0371815994dff8e4$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $0371815994dff8e4$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $0371815994dff8e4$export$4b073707ff63303(color, coefficient) {
    color = $0371815994dff8e4$export$677b39864803984e(color);
    coefficient = $0371815994dff8e4$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $0371815994dff8e4$export$211a73f2b8c10ce4(color);
}
function $0371815994dff8e4$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $0371815994dff8e4$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $0371815994dff8e4$export$c0816ed86df316af(color, coefficient) {
    color = $0371815994dff8e4$export$677b39864803984e(color);
    coefficient = $0371815994dff8e4$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $0371815994dff8e4$export$211a73f2b8c10ce4(color);
}
function $0371815994dff8e4$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $0371815994dff8e4$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $0371815994dff8e4$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $0371815994dff8e4$export$c852d90bf7403b62(color) > 0.5 ? $0371815994dff8e4$export$4b073707ff63303(color, coefficient) : $0371815994dff8e4$export$c0816ed86df316af(color, coefficient);
}
function $0371815994dff8e4$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $0371815994dff8e4$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $0371815994dff8e4$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $0371815994dff8e4$export$677b39864803984e(background);
    const overlayColor = $0371815994dff8e4$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $0371815994dff8e4$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


/**
 * ![common black](https://mui.com/static/colors-preview/common-black-24x24.png) ![common white](https://mui.com/static/colors-preview/common-white-24x24.png)
 */ const $c4301609708a8494$var$common = {
    /**
   * Preview: ![common black](https://mui.com/static/colors-preview/common-black-24x24.png)
   */ black: '#000',
    /**
   * Preview: ![common white](https://mui.com/static/colors-preview/common-white-24x24.png)
   */ white: '#fff'
};
var $c4301609708a8494$export$2e2bcd8739ae039 = $c4301609708a8494$var$common;


/**
 * ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png) ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png) ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png) ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png) ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png) ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png) ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png) ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png) ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png) ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png) ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png) ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png) ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png) ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
 */ const $38a786124807f4d8$var$grey = {
    /**
   * Preview: ![grey 50](https://mui.com/static/colors-preview/grey-50-24x24.png)
   */ 50: '#fafafa',
    /**
   * Preview: ![grey 100](https://mui.com/static/colors-preview/grey-100-24x24.png)
   */ 100: '#f5f5f5',
    /**
   * Preview: ![grey 200](https://mui.com/static/colors-preview/grey-200-24x24.png)
   */ 200: '#eeeeee',
    /**
   * Preview: ![grey 300](https://mui.com/static/colors-preview/grey-300-24x24.png)
   */ 300: '#e0e0e0',
    /**
   * Preview: ![grey 400](https://mui.com/static/colors-preview/grey-400-24x24.png)
   */ 400: '#bdbdbd',
    /**
   * Preview: ![grey 500](https://mui.com/static/colors-preview/grey-500-24x24.png)
   */ 500: '#9e9e9e',
    /**
   * Preview: ![grey 600](https://mui.com/static/colors-preview/grey-600-24x24.png)
   */ 600: '#757575',
    /**
   * Preview: ![grey 700](https://mui.com/static/colors-preview/grey-700-24x24.png)
   */ 700: '#616161',
    /**
   * Preview: ![grey 800](https://mui.com/static/colors-preview/grey-800-24x24.png)
   */ 800: '#424242',
    /**
   * Preview: ![grey 900](https://mui.com/static/colors-preview/grey-900-24x24.png)
   */ 900: '#212121',
    /**
   * Preview: ![grey A100](https://mui.com/static/colors-preview/grey-A100-24x24.png)
   */ A100: '#f5f5f5',
    /**
   * Preview: ![grey A200](https://mui.com/static/colors-preview/grey-A200-24x24.png)
   */ A200: '#eeeeee',
    /**
   * Preview: ![grey A400](https://mui.com/static/colors-preview/grey-A400-24x24.png)
   */ A400: '#bdbdbd',
    /**
   * Preview: ![grey A700](https://mui.com/static/colors-preview/grey-A700-24x24.png)
   */ A700: '#616161'
};
var $38a786124807f4d8$export$2e2bcd8739ae039 = $38a786124807f4d8$var$grey;


/**
 * ![purple 50](https://mui.com/static/colors-preview/purple-50-24x24.png) ![purple 100](https://mui.com/static/colors-preview/purple-100-24x24.png) ![purple 200](https://mui.com/static/colors-preview/purple-200-24x24.png) ![purple 300](https://mui.com/static/colors-preview/purple-300-24x24.png) ![purple 400](https://mui.com/static/colors-preview/purple-400-24x24.png) ![purple 500](https://mui.com/static/colors-preview/purple-500-24x24.png) ![purple 600](https://mui.com/static/colors-preview/purple-600-24x24.png) ![purple 700](https://mui.com/static/colors-preview/purple-700-24x24.png) ![purple 800](https://mui.com/static/colors-preview/purple-800-24x24.png) ![purple 900](https://mui.com/static/colors-preview/purple-900-24x24.png) ![purple A100](https://mui.com/static/colors-preview/purple-A100-24x24.png) ![purple A200](https://mui.com/static/colors-preview/purple-A200-24x24.png) ![purple A400](https://mui.com/static/colors-preview/purple-A400-24x24.png) ![purple A700](https://mui.com/static/colors-preview/purple-A700-24x24.png)
 */ const $1ada2235bc3ae7c5$var$purple = {
    /**
   * Preview: ![purple 50](https://mui.com/static/colors-preview/purple-50-24x24.png)
   */ 50: '#f3e5f5',
    /**
   * Preview: ![purple 100](https://mui.com/static/colors-preview/purple-100-24x24.png)
   */ 100: '#e1bee7',
    /**
   * Preview: ![purple 200](https://mui.com/static/colors-preview/purple-200-24x24.png)
   */ 200: '#ce93d8',
    /**
   * Preview: ![purple 300](https://mui.com/static/colors-preview/purple-300-24x24.png)
   */ 300: '#ba68c8',
    /**
   * Preview: ![purple 400](https://mui.com/static/colors-preview/purple-400-24x24.png)
   */ 400: '#ab47bc',
    /**
   * Preview: ![purple 500](https://mui.com/static/colors-preview/purple-500-24x24.png)
   */ 500: '#9c27b0',
    /**
   * Preview: ![purple 600](https://mui.com/static/colors-preview/purple-600-24x24.png)
   */ 600: '#8e24aa',
    /**
   * Preview: ![purple 700](https://mui.com/static/colors-preview/purple-700-24x24.png)
   */ 700: '#7b1fa2',
    /**
   * Preview: ![purple 800](https://mui.com/static/colors-preview/purple-800-24x24.png)
   */ 800: '#6a1b9a',
    /**
   * Preview: ![purple 900](https://mui.com/static/colors-preview/purple-900-24x24.png)
   */ 900: '#4a148c',
    /**
   * Preview: ![purple A100](https://mui.com/static/colors-preview/purple-A100-24x24.png)
   */ A100: '#ea80fc',
    /**
   * Preview: ![purple A200](https://mui.com/static/colors-preview/purple-A200-24x24.png)
   */ A200: '#e040fb',
    /**
   * Preview: ![purple A400](https://mui.com/static/colors-preview/purple-A400-24x24.png)
   */ A400: '#d500f9',
    /**
   * Preview: ![purple A700](https://mui.com/static/colors-preview/purple-A700-24x24.png)
   */ A700: '#aa00ff'
};
var $1ada2235bc3ae7c5$export$2e2bcd8739ae039 = $1ada2235bc3ae7c5$var$purple;


/**
 * ![red 50](https://mui.com/static/colors-preview/red-50-24x24.png) ![red 100](https://mui.com/static/colors-preview/red-100-24x24.png) ![red 200](https://mui.com/static/colors-preview/red-200-24x24.png) ![red 300](https://mui.com/static/colors-preview/red-300-24x24.png) ![red 400](https://mui.com/static/colors-preview/red-400-24x24.png) ![red 500](https://mui.com/static/colors-preview/red-500-24x24.png) ![red 600](https://mui.com/static/colors-preview/red-600-24x24.png) ![red 700](https://mui.com/static/colors-preview/red-700-24x24.png) ![red 800](https://mui.com/static/colors-preview/red-800-24x24.png) ![red 900](https://mui.com/static/colors-preview/red-900-24x24.png) ![red A100](https://mui.com/static/colors-preview/red-A100-24x24.png) ![red A200](https://mui.com/static/colors-preview/red-A200-24x24.png) ![red A400](https://mui.com/static/colors-preview/red-A400-24x24.png) ![red A700](https://mui.com/static/colors-preview/red-A700-24x24.png)
 */ const $f1ac2d29dd8daf17$var$red = {
    /**
   * Preview: ![red 50](https://mui.com/static/colors-preview/red-50-24x24.png)
   */ 50: '#ffebee',
    /**
   * Preview: ![red 100](https://mui.com/static/colors-preview/red-100-24x24.png)
   */ 100: '#ffcdd2',
    /**
   * Preview: ![red 200](https://mui.com/static/colors-preview/red-200-24x24.png)
   */ 200: '#ef9a9a',
    /**
   * Preview: ![red 300](https://mui.com/static/colors-preview/red-300-24x24.png)
   */ 300: '#e57373',
    /**
   * Preview: ![red 400](https://mui.com/static/colors-preview/red-400-24x24.png)
   */ 400: '#ef5350',
    /**
   * Preview: ![red 500](https://mui.com/static/colors-preview/red-500-24x24.png)
   */ 500: '#f44336',
    /**
   * Preview: ![red 600](https://mui.com/static/colors-preview/red-600-24x24.png)
   */ 600: '#e53935',
    /**
   * Preview: ![red 700](https://mui.com/static/colors-preview/red-700-24x24.png)
   */ 700: '#d32f2f',
    /**
   * Preview: ![red 800](https://mui.com/static/colors-preview/red-800-24x24.png)
   */ 800: '#c62828',
    /**
   * Preview: ![red 900](https://mui.com/static/colors-preview/red-900-24x24.png)
   */ 900: '#b71c1c',
    /**
   * Preview: ![red A100](https://mui.com/static/colors-preview/red-A100-24x24.png)
   */ A100: '#ff8a80',
    /**
   * Preview: ![red A200](https://mui.com/static/colors-preview/red-A200-24x24.png)
   */ A200: '#ff5252',
    /**
   * Preview: ![red A400](https://mui.com/static/colors-preview/red-A400-24x24.png)
   */ A400: '#ff1744',
    /**
   * Preview: ![red A700](https://mui.com/static/colors-preview/red-A700-24x24.png)
   */ A700: '#d50000'
};
var $f1ac2d29dd8daf17$export$2e2bcd8739ae039 = $f1ac2d29dd8daf17$var$red;


/**
 * ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png) ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png) ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png) ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png) ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png) ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png) ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png) ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png) ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png) ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png) ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png) ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png) ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png) ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
 */ const $849e01f6cc178749$var$orange = {
    /**
   * Preview: ![orange 50](https://mui.com/static/colors-preview/orange-50-24x24.png)
   */ 50: '#fff3e0',
    /**
   * Preview: ![orange 100](https://mui.com/static/colors-preview/orange-100-24x24.png)
   */ 100: '#ffe0b2',
    /**
   * Preview: ![orange 200](https://mui.com/static/colors-preview/orange-200-24x24.png)
   */ 200: '#ffcc80',
    /**
   * Preview: ![orange 300](https://mui.com/static/colors-preview/orange-300-24x24.png)
   */ 300: '#ffb74d',
    /**
   * Preview: ![orange 400](https://mui.com/static/colors-preview/orange-400-24x24.png)
   */ 400: '#ffa726',
    /**
   * Preview: ![orange 500](https://mui.com/static/colors-preview/orange-500-24x24.png)
   */ 500: '#ff9800',
    /**
   * Preview: ![orange 600](https://mui.com/static/colors-preview/orange-600-24x24.png)
   */ 600: '#fb8c00',
    /**
   * Preview: ![orange 700](https://mui.com/static/colors-preview/orange-700-24x24.png)
   */ 700: '#f57c00',
    /**
   * Preview: ![orange 800](https://mui.com/static/colors-preview/orange-800-24x24.png)
   */ 800: '#ef6c00',
    /**
   * Preview: ![orange 900](https://mui.com/static/colors-preview/orange-900-24x24.png)
   */ 900: '#e65100',
    /**
   * Preview: ![orange A100](https://mui.com/static/colors-preview/orange-A100-24x24.png)
   */ A100: '#ffd180',
    /**
   * Preview: ![orange A200](https://mui.com/static/colors-preview/orange-A200-24x24.png)
   */ A200: '#ffab40',
    /**
   * Preview: ![orange A400](https://mui.com/static/colors-preview/orange-A400-24x24.png)
   */ A400: '#ff9100',
    /**
   * Preview: ![orange A700](https://mui.com/static/colors-preview/orange-A700-24x24.png)
   */ A700: '#ff6d00'
};
var $849e01f6cc178749$export$2e2bcd8739ae039 = $849e01f6cc178749$var$orange;


/**
 * ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png) ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png) ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png) ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png) ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png) ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png) ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png) ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png) ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png) ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png) ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png) ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png) ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png) ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
 */ const $303f9431783346ac$var$blue = {
    /**
   * Preview: ![blue 50](https://mui.com/static/colors-preview/blue-50-24x24.png)
   */ 50: '#e3f2fd',
    /**
   * Preview: ![blue 100](https://mui.com/static/colors-preview/blue-100-24x24.png)
   */ 100: '#bbdefb',
    /**
   * Preview: ![blue 200](https://mui.com/static/colors-preview/blue-200-24x24.png)
   */ 200: '#90caf9',
    /**
   * Preview: ![blue 300](https://mui.com/static/colors-preview/blue-300-24x24.png)
   */ 300: '#64b5f6',
    /**
   * Preview: ![blue 400](https://mui.com/static/colors-preview/blue-400-24x24.png)
   */ 400: '#42a5f5',
    /**
   * Preview: ![blue 500](https://mui.com/static/colors-preview/blue-500-24x24.png)
   */ 500: '#2196f3',
    /**
   * Preview: ![blue 600](https://mui.com/static/colors-preview/blue-600-24x24.png)
   */ 600: '#1e88e5',
    /**
   * Preview: ![blue 700](https://mui.com/static/colors-preview/blue-700-24x24.png)
   */ 700: '#1976d2',
    /**
   * Preview: ![blue 800](https://mui.com/static/colors-preview/blue-800-24x24.png)
   */ 800: '#1565c0',
    /**
   * Preview: ![blue 900](https://mui.com/static/colors-preview/blue-900-24x24.png)
   */ 900: '#0d47a1',
    /**
   * Preview: ![blue A100](https://mui.com/static/colors-preview/blue-A100-24x24.png)
   */ A100: '#82b1ff',
    /**
   * Preview: ![blue A200](https://mui.com/static/colors-preview/blue-A200-24x24.png)
   */ A200: '#448aff',
    /**
   * Preview: ![blue A400](https://mui.com/static/colors-preview/blue-A400-24x24.png)
   */ A400: '#2979ff',
    /**
   * Preview: ![blue A700](https://mui.com/static/colors-preview/blue-A700-24x24.png)
   */ A700: '#2962ff'
};
var $303f9431783346ac$export$2e2bcd8739ae039 = $303f9431783346ac$var$blue;


/**
 * ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png) ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png) ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png) ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png) ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png) ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png) ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png) ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png) ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png) ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png) ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png) ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png) ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png) ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
 */ const $49782c3fed108f16$var$lightBlue = {
    /**
   * Preview: ![lightBlue 50](https://mui.com/static/colors-preview/lightBlue-50-24x24.png)
   */ 50: '#e1f5fe',
    /**
   * Preview: ![lightBlue 100](https://mui.com/static/colors-preview/lightBlue-100-24x24.png)
   */ 100: '#b3e5fc',
    /**
   * Preview: ![lightBlue 200](https://mui.com/static/colors-preview/lightBlue-200-24x24.png)
   */ 200: '#81d4fa',
    /**
   * Preview: ![lightBlue 300](https://mui.com/static/colors-preview/lightBlue-300-24x24.png)
   */ 300: '#4fc3f7',
    /**
   * Preview: ![lightBlue 400](https://mui.com/static/colors-preview/lightBlue-400-24x24.png)
   */ 400: '#29b6f6',
    /**
   * Preview: ![lightBlue 500](https://mui.com/static/colors-preview/lightBlue-500-24x24.png)
   */ 500: '#03a9f4',
    /**
   * Preview: ![lightBlue 600](https://mui.com/static/colors-preview/lightBlue-600-24x24.png)
   */ 600: '#039be5',
    /**
   * Preview: ![lightBlue 700](https://mui.com/static/colors-preview/lightBlue-700-24x24.png)
   */ 700: '#0288d1',
    /**
   * Preview: ![lightBlue 800](https://mui.com/static/colors-preview/lightBlue-800-24x24.png)
   */ 800: '#0277bd',
    /**
   * Preview: ![lightBlue 900](https://mui.com/static/colors-preview/lightBlue-900-24x24.png)
   */ 900: '#01579b',
    /**
   * Preview: ![lightBlue A100](https://mui.com/static/colors-preview/lightBlue-A100-24x24.png)
   */ A100: '#80d8ff',
    /**
   * Preview: ![lightBlue A200](https://mui.com/static/colors-preview/lightBlue-A200-24x24.png)
   */ A200: '#40c4ff',
    /**
   * Preview: ![lightBlue A400](https://mui.com/static/colors-preview/lightBlue-A400-24x24.png)
   */ A400: '#00b0ff',
    /**
   * Preview: ![lightBlue A700](https://mui.com/static/colors-preview/lightBlue-A700-24x24.png)
   */ A700: '#0091ea'
};
var $49782c3fed108f16$export$2e2bcd8739ae039 = $49782c3fed108f16$var$lightBlue;


/**
 * ![green 50](https://mui.com/static/colors-preview/green-50-24x24.png) ![green 100](https://mui.com/static/colors-preview/green-100-24x24.png) ![green 200](https://mui.com/static/colors-preview/green-200-24x24.png) ![green 300](https://mui.com/static/colors-preview/green-300-24x24.png) ![green 400](https://mui.com/static/colors-preview/green-400-24x24.png) ![green 500](https://mui.com/static/colors-preview/green-500-24x24.png) ![green 600](https://mui.com/static/colors-preview/green-600-24x24.png) ![green 700](https://mui.com/static/colors-preview/green-700-24x24.png) ![green 800](https://mui.com/static/colors-preview/green-800-24x24.png) ![green 900](https://mui.com/static/colors-preview/green-900-24x24.png) ![green A100](https://mui.com/static/colors-preview/green-A100-24x24.png) ![green A200](https://mui.com/static/colors-preview/green-A200-24x24.png) ![green A400](https://mui.com/static/colors-preview/green-A400-24x24.png) ![green A700](https://mui.com/static/colors-preview/green-A700-24x24.png)
 */ const $e563275354f42edd$var$green = {
    /**
   * Preview: ![green 50](https://mui.com/static/colors-preview/green-50-24x24.png)
   */ 50: '#e8f5e9',
    /**
   * Preview: ![green 100](https://mui.com/static/colors-preview/green-100-24x24.png)
   */ 100: '#c8e6c9',
    /**
   * Preview: ![green 200](https://mui.com/static/colors-preview/green-200-24x24.png)
   */ 200: '#a5d6a7',
    /**
   * Preview: ![green 300](https://mui.com/static/colors-preview/green-300-24x24.png)
   */ 300: '#81c784',
    /**
   * Preview: ![green 400](https://mui.com/static/colors-preview/green-400-24x24.png)
   */ 400: '#66bb6a',
    /**
   * Preview: ![green 500](https://mui.com/static/colors-preview/green-500-24x24.png)
   */ 500: '#4caf50',
    /**
   * Preview: ![green 600](https://mui.com/static/colors-preview/green-600-24x24.png)
   */ 600: '#43a047',
    /**
   * Preview: ![green 700](https://mui.com/static/colors-preview/green-700-24x24.png)
   */ 700: '#388e3c',
    /**
   * Preview: ![green 800](https://mui.com/static/colors-preview/green-800-24x24.png)
   */ 800: '#2e7d32',
    /**
   * Preview: ![green 900](https://mui.com/static/colors-preview/green-900-24x24.png)
   */ 900: '#1b5e20',
    /**
   * Preview: ![green A100](https://mui.com/static/colors-preview/green-A100-24x24.png)
   */ A100: '#b9f6ca',
    /**
   * Preview: ![green A200](https://mui.com/static/colors-preview/green-A200-24x24.png)
   */ A200: '#69f0ae',
    /**
   * Preview: ![green A400](https://mui.com/static/colors-preview/green-A400-24x24.png)
   */ A400: '#00e676',
    /**
   * Preview: ![green A700](https://mui.com/static/colors-preview/green-A700-24x24.png)
   */ A700: '#00c853'
};
var $e563275354f42edd$export$2e2bcd8739ae039 = $e563275354f42edd$var$green;


function $4bbefd3eceeba184$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $c4301609708a8494$export$2e2bcd8739ae039).white,
            default: (0, $c4301609708a8494$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $4bbefd3eceeba184$export$a43af521ac8c3202 = $4bbefd3eceeba184$var$getLight();
function $4bbefd3eceeba184$var$getDark() {
    return {
        text: {
            primary: (0, $c4301609708a8494$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $c4301609708a8494$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $4bbefd3eceeba184$export$55ce6f3a06c59543 = $4bbefd3eceeba184$var$getDark();
function $4bbefd3eceeba184$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $0371815994dff8e4$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $0371815994dff8e4$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $4bbefd3eceeba184$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $4bbefd3eceeba184$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $303f9431783346ac$export$2e2bcd8739ae039)[200],
        light: (0, $303f9431783346ac$export$2e2bcd8739ae039)[50],
        dark: (0, $303f9431783346ac$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $303f9431783346ac$export$2e2bcd8739ae039)[700],
        light: (0, $303f9431783346ac$export$2e2bcd8739ae039)[400],
        dark: (0, $303f9431783346ac$export$2e2bcd8739ae039)[800]
    };
}
function $4bbefd3eceeba184$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $1ada2235bc3ae7c5$export$2e2bcd8739ae039)[200],
        light: (0, $1ada2235bc3ae7c5$export$2e2bcd8739ae039)[50],
        dark: (0, $1ada2235bc3ae7c5$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $1ada2235bc3ae7c5$export$2e2bcd8739ae039)[500],
        light: (0, $1ada2235bc3ae7c5$export$2e2bcd8739ae039)[300],
        dark: (0, $1ada2235bc3ae7c5$export$2e2bcd8739ae039)[700]
    };
}
function $4bbefd3eceeba184$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $f1ac2d29dd8daf17$export$2e2bcd8739ae039)[500],
        light: (0, $f1ac2d29dd8daf17$export$2e2bcd8739ae039)[300],
        dark: (0, $f1ac2d29dd8daf17$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $f1ac2d29dd8daf17$export$2e2bcd8739ae039)[700],
        light: (0, $f1ac2d29dd8daf17$export$2e2bcd8739ae039)[400],
        dark: (0, $f1ac2d29dd8daf17$export$2e2bcd8739ae039)[800]
    };
}
function $4bbefd3eceeba184$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $49782c3fed108f16$export$2e2bcd8739ae039)[400],
        light: (0, $49782c3fed108f16$export$2e2bcd8739ae039)[300],
        dark: (0, $49782c3fed108f16$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $49782c3fed108f16$export$2e2bcd8739ae039)[700],
        light: (0, $49782c3fed108f16$export$2e2bcd8739ae039)[500],
        dark: (0, $49782c3fed108f16$export$2e2bcd8739ae039)[900]
    };
}
function $4bbefd3eceeba184$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e563275354f42edd$export$2e2bcd8739ae039)[400],
        light: (0, $e563275354f42edd$export$2e2bcd8739ae039)[300],
        dark: (0, $e563275354f42edd$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $e563275354f42edd$export$2e2bcd8739ae039)[800],
        light: (0, $e563275354f42edd$export$2e2bcd8739ae039)[500],
        dark: (0, $e563275354f42edd$export$2e2bcd8739ae039)[900]
    };
}
function $4bbefd3eceeba184$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $849e01f6cc178749$export$2e2bcd8739ae039)[400],
        light: (0, $849e01f6cc178749$export$2e2bcd8739ae039)[300],
        dark: (0, $849e01f6cc178749$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $849e01f6cc178749$export$2e2bcd8739ae039)[500],
        dark: (0, $849e01f6cc178749$export$2e2bcd8739ae039)[900]
    };
}
function $4bbefd3eceeba184$export$b6e2ca4581a735cb(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $4bbefd3eceeba184$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $4bbefd3eceeba184$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $4bbefd3eceeba184$var$getDefaultSecondary(mode);
    const error = palette.error || $4bbefd3eceeba184$var$getDefaultError(mode);
    const info = palette.info || $4bbefd3eceeba184$var$getDefaultInfo(mode);
    const success = palette.success || $4bbefd3eceeba184$var$getDefaultSuccess(mode);
    const warning = palette.warning || $4bbefd3eceeba184$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $4bbefd3eceeba184$export$b6e2ca4581a735cb(background);
        const contrastText = (0, $0371815994dff8e4$export$d061e26956a60b0a)(background, $4bbefd3eceeba184$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $4bbefd3eceeba184$export$55ce6f3a06c59543.text.primary : $4bbefd3eceeba184$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $3bc64fddc9e3eed1$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $3bc64fddc9e3eed1$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $4bbefd3eceeba184$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $4bbefd3eceeba184$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $4bbefd3eceeba184$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $4bbefd3eceeba184$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $4bbefd3eceeba184$var$getLight();
    else if (mode === 'dark') modeHydrated = $4bbefd3eceeba184$var$getDark();
    const paletteOutput = (0, $6d1035fe886e2074$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: {
            ...(0, $c4301609708a8494$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $38a786124807f4d8$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}



const $f04e4215bb760f30$var$focusVisibleOffsetVar = '--_focusVisible-offset';
const $f04e4215bb760f30$var$focusVisibleBehaviorVar = '--_focusVisible-behavior';
const $f04e4215bb760f30$var$focusVisibleShadowVar = '--_focusVisible-shadow';
const $f04e4215bb760f30$var$offsetValue = `var(${$f04e4215bb760f30$var$focusVisibleOffsetVar}, 1)`;
const $f04e4215bb760f30$var$behaviorValue = `var(${$f04e4215bb760f30$var$focusVisibleBehaviorVar}, )`;
const $f04e4215bb760f30$export$2f2afcd9b20384c7 = {
    [$f04e4215bb760f30$var$focusVisibleOffsetVar]: 1,
    [$f04e4215bb760f30$var$focusVisibleBehaviorVar]: 'initial' // reverts the var to guaranteed-invalid so `var(--_focusVisible-behavior, )` falls back to empty — there is no explicit `outset` keyword.
};
function $f04e4215bb760f30$export$ce219ac1eda241f1(color) {
    return {
        [$f04e4215bb760f30$var$focusVisibleShadowVar]: color
    };
}
function $f04e4215bb760f30$export$e388436c4b59b99d(offset) {
    return {
        [$f04e4215bb760f30$var$focusVisibleOffsetVar]: -offset,
        [$f04e4215bb760f30$var$focusVisibleBehaviorVar]: 'inset'
    };
}
function $f04e4215bb760f30$export$5d0f425d284660f4(optionsFocusVisible, args) {
    return args.reduce((acc, arg)=>arg && 'focusVisible' in arg ? (0, $6d1035fe886e2074$export$2e2bcd8739ae039)(acc, {
            focusVisible: arg.focusVisible
        }) : acc, {
        focusVisible: optionsFocusVisible
    }).focusVisible;
}
function $f04e4215bb760f30$export$685950156577a061(input) {
    return input != null && typeof input === 'object' && typeof input.outlineOffset === 'string' && input.outlineOffset.includes($f04e4215bb760f30$var$focusVisibleOffsetVar);
}
function $f04e4215bb760f30$export$c06a3c79efe1b1cf(input, outlineColor) {
    return $f04e4215bb760f30$export$a0f20964bcf591d5({
        outlineStyle: 'solid',
        outlineColor: outlineColor,
        outlineWidth: 2,
        outlineOffset: 2,
        // invisible shadow for parent component with solid background (AppBar, Snackbar, Alert) can control the ring color.
        boxShadow: `var(${$f04e4215bb760f30$var$focusVisibleShadowVar}, 0 0)`,
        ...input === true ? null : input
    });
}
function $f04e4215bb760f30$export$a0f20964bcf591d5(resolved) {
    // Multiply the offset by the sign var so it flips to inset on clip-prone components. Skip if
    // already wired: re-composing a resolved theme must not wrap the calc twice and invert the sign.
    const offset = resolved.outlineOffset ?? 0;
    if (typeof offset !== 'string' || !offset.includes($f04e4215bb760f30$var$focusVisibleOffsetVar)) {
        const offsetPx = typeof offset === 'number' ? `${offset}px` : offset;
        resolved.outlineOffset = `calc(${$f04e4215bb760f30$var$offsetValue} * ${offsetPx})`;
    }
    // Prefix a box-shadow with the behavior var so it insets there too, unless it already opts in.
    // Standalone keywords are complete values — prefixing would produce an invalid `inset none`.
    const standaloneBoxShadows = new Set([
        'none',
        'initial',
        'inherit',
        'unset',
        'revert',
        'revert-layer'
    ]);
    if (typeof resolved.boxShadow === 'string' && !standaloneBoxShadows.has(resolved.boxShadow.trim().toLowerCase()) && !/\binset\b/.test(resolved.boxShadow) && !resolved.boxShadow.includes($f04e4215bb760f30$var$focusVisibleBehaviorVar)) resolved.boxShadow = `${$f04e4215bb760f30$var$behaviorValue} ${resolved.boxShadow}`;
    return resolved;
}




var $c4732f3462dc01c7$exports = {};
/**
 * @mui/system v9.5.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $c5wSN = parcelRequire("c5wSN");
var $c4732f3462dc01c7$require$_interopRequireWildcard = $c5wSN.default;

var $5ULbo = parcelRequire("5ULbo");
var $c4732f3462dc01c7$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty($c4732f3462dc01c7$exports, "__esModule", {
    value: true
});
var $c4732f3462dc01c7$var$_exportNames = {
    experimental_sx: true,
    css: true,
    keyframes: true,
    StyledEngineProvider: true,
    GlobalStyles: true,
    borders: true,
    breakpoints: true,
    handleBreakpoints: true,
    mergeBreakpointsInOrder: true,
    unstable_resolveBreakpointValues: true,
    cssContainerQueries: true,
    compose: true,
    display: true,
    flexbox: true,
    grid: true,
    palette: true,
    positions: true,
    shadows: true,
    sizing: true,
    spacing: true,
    style: true,
    getPath: true,
    getStyleValue: true,
    typography: true,
    unstable_styleFunctionSx: true,
    unstable_createStyleFunctionSx: true,
    unstable_extendSxProp: true,
    unstable_defaultSxConfig: true,
    unstable_getThemeValue: true,
    Box: true,
    createBox: true,
    createStyled: true,
    styled: true,
    createTheme: true,
    createBreakpoints: true,
    createSpacing: true,
    shape: true,
    useThemeProps: true,
    getThemeProps: true,
    useTheme: true,
    useThemeWithoutDefault: true,
    useMediaQuery: true,
    ThemeProvider: true,
    unstable_memoTheme: true,
    unstable_createCssVarsProvider: true,
    unstable_createGetCssVar: true,
    unstable_cssVarsParser: true,
    unstable_prepareCssVars: true,
    unstable_createCssVarsTheme: true,
    responsivePropType: true,
    RtlProvider: true,
    createContainer: true,
    Container: true,
    Grid: true,
    Stack: true
};
Object.defineProperty($c4732f3462dc01c7$exports, "Box", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_Box.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "Container", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_Container.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "GlobalStyles", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_GlobalStyles.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "Grid", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_Grid.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "RtlProvider", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_RtlProvider.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "Stack", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_Stack.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "StyledEngineProvider", {
    enumerable: true,
    get: function() {
        return $keaWW.StyledEngineProvider;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "ThemeProvider", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_ThemeProvider.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "borders", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_borders.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "breakpoints", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_breakpoints.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "compose", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_compose.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "createBox", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_createBox.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "createBreakpoints", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_createBreakpoints.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "createContainer", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_createContainer.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "createSpacing", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_createSpacing.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "createStyled", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_createStyled.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "createTheme", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_createTheme.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "css", {
    enumerable: true,
    get: function() {
        return $keaWW.css;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "cssContainerQueries", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_cssContainerQueries.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "display", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_display.default;
    }
});
$c4732f3462dc01c7$exports.experimental_sx = $c4732f3462dc01c7$var$experimental_sx;
Object.defineProperty($c4732f3462dc01c7$exports, "flexbox", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_flexbox.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "getPath", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_style.getPath;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "getStyleValue", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_style.getStyleValue;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "getThemeProps", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_useThemeProps.getThemeProps;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "grid", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_cssGrid.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "handleBreakpoints", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_breakpoints.handleBreakpoints;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "keyframes", {
    enumerable: true,
    get: function() {
        return $keaWW.keyframes;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "mergeBreakpointsInOrder", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_breakpoints.mergeBreakpointsInOrder;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "palette", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_palette.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "positions", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_positions.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "responsivePropType", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_responsivePropType.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "shadows", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_shadows.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "shape", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_shape.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "sizing", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_sizing.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "spacing", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_spacing.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "style", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_style.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "styled", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_styled.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "typography", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_typography.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_createCssVarsProvider", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_createCssVarsProvider.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_createCssVarsTheme", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_createCssVarsTheme.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_createGetCssVar", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_createGetCssVar.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_createStyleFunctionSx", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_styleFunctionSx.unstable_createStyleFunctionSx;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_cssVarsParser", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_cssVarsParser.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_defaultSxConfig", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_styleFunctionSx.unstable_defaultSxConfig;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_extendSxProp", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_styleFunctionSx.extendSxProp;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_getThemeValue", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_getThemeValue.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_memoTheme", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_memoTheme.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_prepareCssVars", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_prepareCssVars.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_resolveBreakpointValues", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_breakpoints.resolveBreakpointValues;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "unstable_styleFunctionSx", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_styleFunctionSx.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "useMediaQuery", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_useMediaQuery.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "useTheme", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_useTheme.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "useThemeProps", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_useThemeProps.default;
    }
});
Object.defineProperty($c4732f3462dc01c7$exports, "useThemeWithoutDefault", {
    enumerable: true,
    get: function() {
        return $c4732f3462dc01c7$var$_useThemeWithoutDefault.default;
    }
});

var $c4732f3462dc01c7$var$_formatMuiErrorMessage = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("eq0W7")));

var $keaWW = parcelRequire("keaWW");

var $c4732f3462dc01c7$var$_GlobalStyles = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("joyms")));

var $c4732f3462dc01c7$var$_borders = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("6mdr0")));
Object.keys($c4732f3462dc01c7$var$_borders).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_borders[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_borders[key];
        }
    });
});

var $c4732f3462dc01c7$var$_breakpoints = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("3dqBt")));

var $c4732f3462dc01c7$var$_cssContainerQueries = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("doSJ6")));

var $c4732f3462dc01c7$var$_compose = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("lNg8l")));

var $c4732f3462dc01c7$var$_display = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("jkROm")));

var $c4732f3462dc01c7$var$_flexbox = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("TDeQX")));
Object.keys($c4732f3462dc01c7$var$_flexbox).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_flexbox[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_flexbox[key];
        }
    });
});

var $c4732f3462dc01c7$var$_cssGrid = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("hmOdg")));
Object.keys($c4732f3462dc01c7$var$_cssGrid).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_cssGrid[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_cssGrid[key];
        }
    });
});

var $c4732f3462dc01c7$var$_palette = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("9JyGZ")));
Object.keys($c4732f3462dc01c7$var$_palette).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_palette[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_palette[key];
        }
    });
});

var $c4732f3462dc01c7$var$_positions = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("funED")));
Object.keys($c4732f3462dc01c7$var$_positions).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_positions[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_positions[key];
        }
    });
});

var $c4732f3462dc01c7$var$_shadows = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("7RHsi")));

var $c4732f3462dc01c7$var$_sizing = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("40fcn")));
Object.keys($c4732f3462dc01c7$var$_sizing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_sizing[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_sizing[key];
        }
    });
});

var $c4732f3462dc01c7$var$_spacing = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("7GqeV")));
Object.keys($c4732f3462dc01c7$var$_spacing).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_spacing[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_spacing[key];
        }
    });
});

var $c4732f3462dc01c7$var$_style = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("1H8cF")));

var $c4732f3462dc01c7$var$_typography = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("8GKEL")));
Object.keys($c4732f3462dc01c7$var$_typography).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_typography[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_typography[key];
        }
    });
});

var $c4732f3462dc01c7$var$_styleFunctionSx = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("k6yl9")));

var $c4732f3462dc01c7$var$_getThemeValue = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("jF8P7")));

var $c4732f3462dc01c7$var$_Box = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("k9pPj")));
Object.keys($c4732f3462dc01c7$var$_Box).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_Box[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_Box[key];
        }
    });
});

var $c4732f3462dc01c7$var$_createBox = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("7Pqd3")));

var $c4732f3462dc01c7$var$_createStyled = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("3DwEm")));
Object.keys($c4732f3462dc01c7$var$_createStyled).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_createStyled[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_createStyled[key];
        }
    });
});

var $c4732f3462dc01c7$var$_styled = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("38jtr")));

var $c4732f3462dc01c7$var$_createTheme = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("bFSYU")));

var $c4732f3462dc01c7$var$_createBreakpoints = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("3pIg9")));

var $c4732f3462dc01c7$var$_createSpacing = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("gzAbx")));

var $c4732f3462dc01c7$var$_shape = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("48rpI")));

var $c4732f3462dc01c7$var$_useThemeProps = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("6rcYV")));

var $c4732f3462dc01c7$var$_useTheme = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("fZXUE")));

var $c4732f3462dc01c7$var$_useThemeWithoutDefault = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("4P3l1")));

var $c4732f3462dc01c7$var$_useMediaQuery = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("cJU3a")));
var $3187d176e1e894d9$exports = {};
"use strict";
Object.defineProperty($3187d176e1e894d9$exports, "__esModule", {
    value: true
});
var $86c848c010b46a16$exports = {};
"use strict";

var $5ULbo = parcelRequire("5ULbo");
var $86c848c010b46a16$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty($86c848c010b46a16$exports, "__esModule", {
    value: true
});
$86c848c010b46a16$exports.alpha = $86c848c010b46a16$var$alpha;
$86c848c010b46a16$exports.blend = $86c848c010b46a16$var$blend;
$86c848c010b46a16$exports.colorChannel = void 0;
$86c848c010b46a16$exports.darken = $86c848c010b46a16$var$darken;
$86c848c010b46a16$exports.decomposeColor = $86c848c010b46a16$var$decomposeColor;
$86c848c010b46a16$exports.emphasize = $86c848c010b46a16$var$emphasize;
$86c848c010b46a16$exports.getContrastRatio = $86c848c010b46a16$var$getContrastRatio;
$86c848c010b46a16$exports.getLuminance = $86c848c010b46a16$var$getLuminance;
$86c848c010b46a16$exports.hexToRgb = $86c848c010b46a16$var$hexToRgb;
$86c848c010b46a16$exports.hslToRgb = $86c848c010b46a16$var$hslToRgb;
$86c848c010b46a16$exports.lighten = $86c848c010b46a16$var$lighten;
$86c848c010b46a16$exports.private_safeAlpha = $86c848c010b46a16$var$private_safeAlpha;
$86c848c010b46a16$exports.private_safeColorChannel = void 0;
$86c848c010b46a16$exports.private_safeDarken = $86c848c010b46a16$var$private_safeDarken;
$86c848c010b46a16$exports.private_safeEmphasize = $86c848c010b46a16$var$private_safeEmphasize;
$86c848c010b46a16$exports.private_safeLighten = $86c848c010b46a16$var$private_safeLighten;
$86c848c010b46a16$exports.recomposeColor = $86c848c010b46a16$var$recomposeColor;
$86c848c010b46a16$exports.rgbToHex = $86c848c010b46a16$var$rgbToHex;

var $86c848c010b46a16$var$_formatMuiErrorMessage = $86c848c010b46a16$require$_interopRequireDefault((parcelRequire("eq0W7")));

var $86c848c010b46a16$var$_clamp = $86c848c010b46a16$require$_interopRequireDefault((parcelRequire("cqEHZ")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $86c848c010b46a16$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $86c848c010b46a16$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $86c848c010b46a16$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $86c848c010b46a16$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $86c848c010b46a16$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $86c848c010b46a16$var$decomposeColor($86c848c010b46a16$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $86c848c010b46a16$var$_formatMuiErrorMessage.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $86c848c010b46a16$var$_formatMuiErrorMessage.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $86c848c010b46a16$var$colorChannel = (color)=>{
    const decomposedColor = $86c848c010b46a16$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
$86c848c010b46a16$exports.colorChannel = $86c848c010b46a16$var$colorChannel;
const $86c848c010b46a16$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $86c848c010b46a16$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ $86c848c010b46a16$exports.private_safeColorChannel = $86c848c010b46a16$var$private_safeColorChannel;
function $86c848c010b46a16$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $86c848c010b46a16$var$rgbToHex(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $86c848c010b46a16$var$decomposeColor(color);
    return `#${values.map((n, i)=>$86c848c010b46a16$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $86c848c010b46a16$var$hslToRgb(color) {
    color = $86c848c010b46a16$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $86c848c010b46a16$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $86c848c010b46a16$var$getLuminance(color) {
    color = $86c848c010b46a16$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $86c848c010b46a16$var$decomposeColor($86c848c010b46a16$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $86c848c010b46a16$var$getContrastRatio(foreground, background) {
    const lumA = $86c848c010b46a16$var$getLuminance(foreground);
    const lumB = $86c848c010b46a16$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $86c848c010b46a16$var$alpha(color, value) {
    color = $86c848c010b46a16$var$decomposeColor(color);
    value = $86c848c010b46a16$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $86c848c010b46a16$var$recomposeColor(color);
}
function $86c848c010b46a16$var$private_safeAlpha(color, value, warning) {
    try {
        return $86c848c010b46a16$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $86c848c010b46a16$var$darken(color, coefficient) {
    color = $86c848c010b46a16$var$decomposeColor(color);
    coefficient = $86c848c010b46a16$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $86c848c010b46a16$var$recomposeColor(color);
}
function $86c848c010b46a16$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $86c848c010b46a16$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $86c848c010b46a16$var$lighten(color, coefficient) {
    color = $86c848c010b46a16$var$decomposeColor(color);
    coefficient = $86c848c010b46a16$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $86c848c010b46a16$var$recomposeColor(color);
}
function $86c848c010b46a16$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $86c848c010b46a16$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $86c848c010b46a16$var$emphasize(color, coefficient = 0.15) {
    return $86c848c010b46a16$var$getLuminance(color) > 0.5 ? $86c848c010b46a16$var$darken(color, coefficient) : $86c848c010b46a16$var$lighten(color, coefficient);
}
function $86c848c010b46a16$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $86c848c010b46a16$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $86c848c010b46a16$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $86c848c010b46a16$var$decomposeColor(background);
    const overlayColor = $86c848c010b46a16$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $86c848c010b46a16$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}


Object.keys($86c848c010b46a16$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (key in $3187d176e1e894d9$exports && $3187d176e1e894d9$exports[key] === $86c848c010b46a16$exports[key]) return;
    Object.defineProperty($3187d176e1e894d9$exports, key, {
        enumerable: true,
        get: function() {
            return $86c848c010b46a16$exports[key];
        }
    });
});


Object.keys($3187d176e1e894d9$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $3187d176e1e894d9$exports[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $3187d176e1e894d9$exports[key];
        }
    });
});

var $c4732f3462dc01c7$var$_ThemeProvider = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("13HOl")));

var $c4732f3462dc01c7$var$_memoTheme = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("aGWkF")));

var $c4732f3462dc01c7$var$_createCssVarsProvider = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("7bdRN")));

var $c4732f3462dc01c7$var$_createGetCssVar = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("4xeKC")));

var $c4732f3462dc01c7$var$_cssVarsParser = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("8i1Cv")));

var $c4732f3462dc01c7$var$_prepareCssVars = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("j1tZV")));

var $c4732f3462dc01c7$var$_createCssVarsTheme = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("5J216")));

var $c4732f3462dc01c7$var$_responsivePropType = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("e6HWG")));

var $c4732f3462dc01c7$var$_RtlProvider = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("d8THF")));
Object.keys($c4732f3462dc01c7$var$_RtlProvider).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_RtlProvider[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_RtlProvider[key];
        }
    });
});
var $adc8837e5e1cc542$exports = {};
"use strict";
Object.defineProperty($adc8837e5e1cc542$exports, "__esModule", {
    value: true
});
$adc8837e5e1cc542$exports.version = $adc8837e5e1cc542$exports.prerelease = $adc8837e5e1cc542$exports.patch = $adc8837e5e1cc542$exports.minor = $adc8837e5e1cc542$exports.major = $adc8837e5e1cc542$exports.default = void 0;
const $adc8837e5e1cc542$var$version = $adc8837e5e1cc542$exports.version = "9.5.0";
const $adc8837e5e1cc542$var$major = $adc8837e5e1cc542$exports.major = Number("9");
const $adc8837e5e1cc542$var$minor = $adc8837e5e1cc542$exports.minor = Number("5");
const $adc8837e5e1cc542$var$patch = $adc8837e5e1cc542$exports.patch = Number("0");
const $adc8837e5e1cc542$var$prerelease = $adc8837e5e1cc542$exports.prerelease = undefined;
var $adc8837e5e1cc542$var$_default = $adc8837e5e1cc542$exports.default = $adc8837e5e1cc542$var$version;


Object.keys($adc8837e5e1cc542$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $adc8837e5e1cc542$exports[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $adc8837e5e1cc542$exports[key];
        }
    });
});

var $c4732f3462dc01c7$var$_createContainer = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("lIAT2")));

var $c4732f3462dc01c7$var$_Container = $c4732f3462dc01c7$require$_interopRequireWildcard((parcelRequire("14TAD")));
Object.keys($c4732f3462dc01c7$var$_Container).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $c4732f3462dc01c7$var$_Container[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $c4732f3462dc01c7$var$_Container[key];
        }
    });
});

var $c4732f3462dc01c7$var$_Grid = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("fMhQa")));
var $73dfbbfcfd876805$exports = {};
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $73dfbbfcfd876805$require$_interopRequireWildcard = $c5wSN.default;

var $5ULbo = parcelRequire("5ULbo");
var $73dfbbfcfd876805$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty($73dfbbfcfd876805$exports, "__esModule", {
    value: true
});
var $73dfbbfcfd876805$var$_exportNames = {
    createGrid: true,
    gridClasses: true,
    unstable_traverseBreakpoints: true,
    unstable_generateDirectionClasses: true,
    unstable_generateSizeClassNames: true,
    unstable_generateSpacingClassNames: true
};
Object.defineProperty($73dfbbfcfd876805$exports, "createGrid", {
    enumerable: true,
    get: function() {
        return $73dfbbfcfd876805$var$_createGrid.default;
    }
});
Object.defineProperty($73dfbbfcfd876805$exports, "default", {
    enumerable: true,
    get: function() {
        return $73dfbbfcfd876805$var$_Grid.default;
    }
});
Object.defineProperty($73dfbbfcfd876805$exports, "gridClasses", {
    enumerable: true,
    get: function() {
        return $73dfbbfcfd876805$var$_gridClasses.default;
    }
});
Object.defineProperty($73dfbbfcfd876805$exports, "unstable_generateDirectionClasses", {
    enumerable: true,
    get: function() {
        return $NIx3S.generateDirectionClasses;
    }
});
Object.defineProperty($73dfbbfcfd876805$exports, "unstable_generateSizeClassNames", {
    enumerable: true,
    get: function() {
        return $NIx3S.generateSizeClassNames;
    }
});
Object.defineProperty($73dfbbfcfd876805$exports, "unstable_generateSpacingClassNames", {
    enumerable: true,
    get: function() {
        return $NIx3S.generateSpacingClassNames;
    }
});
Object.defineProperty($73dfbbfcfd876805$exports, "unstable_traverseBreakpoints", {
    enumerable: true,
    get: function() {
        return $7OLH8.traverseBreakpoints;
    }
});

var $73dfbbfcfd876805$var$_Grid = $73dfbbfcfd876805$require$_interopRequireDefault((parcelRequire("fMhQa")));

var $73dfbbfcfd876805$var$_createGrid = $73dfbbfcfd876805$require$_interopRequireDefault((parcelRequire("dd6tk")));
var $0398e858897f5202$exports = {};
"use strict";
Object.defineProperty($0398e858897f5202$exports, "__esModule", {
    value: true
});


Object.keys($0398e858897f5202$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($73dfbbfcfd876805$var$_exportNames, key)) return;
    if (key in $73dfbbfcfd876805$exports && $73dfbbfcfd876805$exports[key] === $0398e858897f5202$exports[key]) return;
    Object.defineProperty($73dfbbfcfd876805$exports, key, {
        enumerable: true,
        get: function() {
            return $0398e858897f5202$exports[key];
        }
    });
});

var $73dfbbfcfd876805$var$_gridClasses = $73dfbbfcfd876805$require$_interopRequireWildcard((parcelRequire("eaYrD")));
Object.keys($73dfbbfcfd876805$var$_gridClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($73dfbbfcfd876805$var$_exportNames, key)) return;
    if (key in $73dfbbfcfd876805$exports && $73dfbbfcfd876805$exports[key] === $73dfbbfcfd876805$var$_gridClasses[key]) return;
    Object.defineProperty($73dfbbfcfd876805$exports, key, {
        enumerable: true,
        get: function() {
            return $73dfbbfcfd876805$var$_gridClasses[key];
        }
    });
});

var $7OLH8 = parcelRequire("7OLH8");

var $NIx3S = parcelRequire("NIx3S");


Object.keys($73dfbbfcfd876805$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $73dfbbfcfd876805$exports[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $73dfbbfcfd876805$exports[key];
        }
    });
});

var $c4732f3462dc01c7$var$_Stack = $c4732f3462dc01c7$require$_interopRequireDefault((parcelRequire("Q1Lzh")));
var $27dd315d2cc7f06d$exports = {};
"use strict";

var $c5wSN = parcelRequire("c5wSN");
var $27dd315d2cc7f06d$require$_interopRequireWildcard = $c5wSN.default;

var $5ULbo = parcelRequire("5ULbo");
var $27dd315d2cc7f06d$require$_interopRequireDefault = $5ULbo.default;
Object.defineProperty($27dd315d2cc7f06d$exports, "__esModule", {
    value: true
});
var $27dd315d2cc7f06d$var$_exportNames = {
    createStack: true,
    stackClasses: true
};
Object.defineProperty($27dd315d2cc7f06d$exports, "createStack", {
    enumerable: true,
    get: function() {
        return $27dd315d2cc7f06d$var$_createStack.default;
    }
});
Object.defineProperty($27dd315d2cc7f06d$exports, "default", {
    enumerable: true,
    get: function() {
        return $27dd315d2cc7f06d$var$_Stack.default;
    }
});
Object.defineProperty($27dd315d2cc7f06d$exports, "stackClasses", {
    enumerable: true,
    get: function() {
        return $27dd315d2cc7f06d$var$_stackClasses.default;
    }
});

var $27dd315d2cc7f06d$var$_Stack = $27dd315d2cc7f06d$require$_interopRequireDefault((parcelRequire("Q1Lzh")));

var $27dd315d2cc7f06d$var$_createStack = $27dd315d2cc7f06d$require$_interopRequireDefault((parcelRequire("lmfHQ")));
var $4fa9799ceed16d5a$exports = {};
"use strict";
Object.defineProperty($4fa9799ceed16d5a$exports, "__esModule", {
    value: true
});


Object.keys($4fa9799ceed16d5a$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($27dd315d2cc7f06d$var$_exportNames, key)) return;
    if (key in $27dd315d2cc7f06d$exports && $27dd315d2cc7f06d$exports[key] === $4fa9799ceed16d5a$exports[key]) return;
    Object.defineProperty($27dd315d2cc7f06d$exports, key, {
        enumerable: true,
        get: function() {
            return $4fa9799ceed16d5a$exports[key];
        }
    });
});

var $27dd315d2cc7f06d$var$_stackClasses = $27dd315d2cc7f06d$require$_interopRequireWildcard((parcelRequire("7hUw4")));
Object.keys($27dd315d2cc7f06d$var$_stackClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($27dd315d2cc7f06d$var$_exportNames, key)) return;
    if (key in $27dd315d2cc7f06d$exports && $27dd315d2cc7f06d$exports[key] === $27dd315d2cc7f06d$var$_stackClasses[key]) return;
    Object.defineProperty($27dd315d2cc7f06d$exports, key, {
        enumerable: true,
        get: function() {
            return $27dd315d2cc7f06d$var$_stackClasses[key];
        }
    });
});


Object.keys($27dd315d2cc7f06d$exports).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($c4732f3462dc01c7$var$_exportNames, key)) return;
    if (key in $c4732f3462dc01c7$exports && $c4732f3462dc01c7$exports[key] === $27dd315d2cc7f06d$exports[key]) return;
    Object.defineProperty($c4732f3462dc01c7$exports, key, {
        enumerable: true,
        get: function() {
            return $27dd315d2cc7f06d$exports[key];
        }
    });
});
/* eslint-disable import/export */ /**
 * The `css` function accepts arrays as values for mobile-first responsive styles.
 * Note that this extends to non-theme values also. For example `display=['none', 'block']`
 * will also work.
 */ // TODO: Remove this function in v6
// eslint-disable-next-line @typescript-eslint/naming-convention
function $c4732f3462dc01c7$var$experimental_sx() {
    throw new Error((0, $c4732f3462dc01c7$var$_formatMuiErrorMessage.default)(19));
} /** ----------------- */  /** Layout components */ 



/* eslint-disable import/prefer-default-export */ function $e336f2efad325a1d$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}


const $c959a3e61ca28f90$var$prototypePollutingKeys = new Set([
    '__proto__',
    'constructor',
    'prototype'
]);
const $c959a3e61ca28f90$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    for(let index = 0; index < keys.length; index += 1){
        const k = keys[index];
        // Prevent prototype pollution: never traverse or write through
        // `__proto__` / `constructor` / `prototype` (e.g. a theme parsed from untrusted JSON).
        if ($c959a3e61ca28f90$var$prototypePollutingKeys.has(k)) break;
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    }
};
const $c959a3e61ca28f90$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $c959a3e61ca28f90$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $c959a3e61ca28f90$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $c959a3e61ca28f90$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $c959a3e61ca28f90$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $c959a3e61ca28f90$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $c959a3e61ca28f90$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


function $bfbc84febe5da8a4$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-expect-error - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $c959a3e61ca28f90$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $c959a3e61ca28f90$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $6d1035fe886e2074$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $c959a3e61ca28f90$export$2e2bcd8739ae039)(defaultScheme, parserConfig);
        themeVars = (0, $6d1035fe886e2074$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $6d1035fe886e2074$export$2e2bcd8739ae039)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $bfbc84febe5da8a4$export$2e2bcd8739ae039 = $bfbc84febe5da8a4$var$prepareCssVars;

function $3542c7eb00313066$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}










function $3ee4ab455b9f3b1a$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




function $e0677bcdc4a62f80$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $e0677bcdc4a62f80$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $e0677bcdc4a62f80$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $e0677bcdc4a62f80$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $e0677bcdc4a62f80$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $e0677bcdc4a62f80$var$defaultFontFamily ? {
                letterSpacing: `${$e0677bcdc4a62f80$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $e0677bcdc4a62f80$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $e0677bcdc4a62f80$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $6d1035fe886e2074$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $a2ac6219c6bbcb9a$var$shadowKeyUmbraOpacity = 0.2;
const $a2ac6219c6bbcb9a$var$shadowKeyPenumbraOpacity = 0.14;
const $a2ac6219c6bbcb9a$var$shadowAmbientShadowOpacity = 0.12;
function $a2ac6219c6bbcb9a$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$a2ac6219c6bbcb9a$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$a2ac6219c6bbcb9a$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$a2ac6219c6bbcb9a$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $a2ac6219c6bbcb9a$var$shadows = [
    'none',
    $a2ac6219c6bbcb9a$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $a2ac6219c6bbcb9a$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $a2ac6219c6bbcb9a$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $a2ac6219c6bbcb9a$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $a2ac6219c6bbcb9a$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $a2ac6219c6bbcb9a$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $a2ac6219c6bbcb9a$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $a2ac6219c6bbcb9a$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $a2ac6219c6bbcb9a$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $a2ac6219c6bbcb9a$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $a2ac6219c6bbcb9a$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $a2ac6219c6bbcb9a$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $a2ac6219c6bbcb9a$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $a2ac6219c6bbcb9a$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $a2ac6219c6bbcb9a$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $a2ac6219c6bbcb9a$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $a2ac6219c6bbcb9a$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $a2ac6219c6bbcb9a$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $a2ac6219c6bbcb9a$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $a2ac6219c6bbcb9a$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $a2ac6219c6bbcb9a$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $a2ac6219c6bbcb9a$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $a2ac6219c6bbcb9a$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $a2ac6219c6bbcb9a$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $a2ac6219c6bbcb9a$export$2e2bcd8739ae039 = $a2ac6219c6bbcb9a$var$shadows;


const $62583def89e7732c$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $62583def89e7732c$var$EMPTY_OPTIONS = {};
const $62583def89e7732c$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $62583def89e7732c$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $62583def89e7732c$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $62583def89e7732c$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $62583def89e7732c$export$2e2bcd8739ae039(inputTransitions) {
    const transitions = {
        ...inputTransitions
    };
    delete transitions.reducedMotion;
    const mergedEasing = {
        ...$62583def89e7732c$export$24c5ac7c37452e7d,
        ...transitions.easing
    };
    const mergedDuration = {
        ...$62583def89e7732c$export$1f34108aa9eb96ab,
        ...transitions.duration
    };
    const createTransitionValue = (props = $62583def89e7732c$var$DEFAULT_TRANSITION_PROPS, options = $62583def89e7732c$var$EMPTY_OPTIONS)=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $62583def89e7732c$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $62583def89e7732c$var$formatMs(delay)}`).join(',');
    };
    const create = transitions.create ?? createTransitionValue;
    return {
        getAutoHeightDuration: $62583def89e7732c$var$getAutoHeightDuration,
        create: create,
        ...transitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


const $90a6530e7b8a2775$var$EMPTY_MOTION = {};
function $90a6530e7b8a2775$export$2e2bcd8739ae039(inputMotion = $90a6530e7b8a2775$var$EMPTY_MOTION) {
    return {
        reducedMotion: 'never',
        ...inputMotion
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $4ad7f9f7810fc641$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $4ad7f9f7810fc641$export$2e2bcd8739ae039 = $4ad7f9f7810fc641$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
function $172af8ae0bc314bd$var$isSerializable(val) {
    return (0, $6d1035fe886e2074$export$53b83ca8eaab0383)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $172af8ae0bc314bd$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$172af8ae0bc314bd$var$isSerializable(value) || key.startsWith('unstable_') || key.startsWith('internal_')) delete object[key];
            else if ((0, $6d1035fe886e2074$export$53b83ca8eaab0383)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.motion = { reducedMotion: 'never', ...theme.motion };
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}



function $8c2344ec6c8ba42e$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $8c2344ec6c8ba42e$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
// `rgba()` takes rgb channels, so `hsl()` is converted like the theme's `*Channel` tokens.
function $8c2344ec6c8ba42e$var$toRgb(color) {
    return color.startsWith('hsl') ? (0, $0371815994dff8e4$export$29fb7152bd3f781a)(color) : color;
}
// Replaces the `var()` matches in `alpha()`: `var(--x, #1976d2)` -> `var(--xChannel, 25 118 210)`.
// The fallback keeps the color valid when the CSS variables aren't defined (no `ThemeProvider`).
// It's dropped when it isn't a color `colorChannel()` parses, for example `currentColor` or a nested `var()`,
// or when it's a `color()`, whose channels aren't sRGB.
// More than one level of nested parentheses isn't supported: the match ends at the first run of `)`,
// so the rest of the fallback stays in the output.
function $8c2344ec6c8ba42e$var$toChannelVar(match, name, fallback = '') {
    const color = fallback.trim();
    if (color && !color.startsWith('color(')) try {
        const channel = (0, $0371815994dff8e4$export$1b91fc959f7ee5a7)($8c2344ec6c8ba42e$var$toRgb(color));
        // Space-separated syntax like `rgb(0 0 0)` doesn't throw but gives a single value, or `NaN`s for `hsl()`.
        if (channel.split(' ').length === 3 && !channel.includes('NaN')) return `var(--${name}Channel, ${channel})`;
    } catch  {
    // Not a supported color.
    }
    return `var(--${name}Channel)`;
}
function $8c2344ec6c8ba42e$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) {
                // To preserve the behavior of the CSS theme variables
                // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
                // Raw colors (for example, `theme.palette.*`) have no channel tokens,
                // so they are converted to channels the same way the theme generates `*Channel` tokens,
                // which keeps a CSS coefficient (for example, `theme.vars.palette.action.hoverOpacity`) in `calc()`.
                const alphaValue = typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient;
                // `color()` channels are not sRGB, so only the alpha is replaced to keep any color space and unit.
                if (color.startsWith('color(')) return color.replace(/\s*(?:\/[^)]*)?\)$/, ` / ${alphaValue})`);
                const channels = color.includes('var(') ? color.replace(/var\(--([^,\s)]+)(?:,((?:[^()]|\([^()]*\))+)\)|(?:,[^)]+)?\)+)/g, $8c2344ec6c8ba42e$var$toChannelVar) : (0, $0371815994dff8e4$export$427365fc3db6fc5e)($8c2344ec6c8ba42e$var$toRgb(color));
                return `rgba(${channels} / ${alphaValue})`;
            }
            return (0, $0371815994dff8e4$export$58f0f39f63f3cf42)(color, $8c2344ec6c8ba42e$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$8c2344ec6c8ba42e$var$coefficientToPercentage(coefficient)})`;
            return (0, $0371815994dff8e4$export$c0816ed86df316af)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$8c2344ec6c8ba42e$var$coefficientToPercentage(coefficient)})`;
            return (0, $0371815994dff8e4$export$4b073707ff63303)(color, coefficient);
        }
    });
}
function $8c2344ec6c8ba42e$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, motion: motionInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $3bc64fddc9e3eed1$export$2e2bcd8739ae039)(22));
    const palette = (0, $4bbefd3eceeba184$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $771c3de9a70a57c0$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $6d1035fe886e2074$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $3ee4ab455b9f3b1a$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $a2ac6219c6bbcb9a$export$2e2bcd8739ae039).slice(),
        typography: (0, $e0677bcdc4a62f80$export$2e2bcd8739ae039)(palette, typographyInput),
        motion: (0, $90a6530e7b8a2775$export$2e2bcd8739ae039)(motionInput),
        transitions: (0, $62583def89e7732c$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $4ad7f9f7810fc641$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, $6d1035fe886e2074$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $6d1035fe886e2074$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    // `reducedMotion` is owned by `theme.motion`; remove stale values preserved by systemCreateTheme.
    delete muiTheme.transitions.reducedMotion;
    // Normalize once so components read a resolved object, never the boolean. The color is a hex off
    // this (default) scheme; `createTheme` attaches a per-scheme copy so dark mode stays reactive.
    // Read the palette off `muiTheme` — a merge argument may have recolored it after `palette` was built.
    if (muiTheme.focusVisible != null && muiTheme.focusVisible !== false) muiTheme.focusVisible = (0, $f04e4215bb760f30$export$c06a3c79efe1b1cf)(muiTheme.focusVisible, muiTheme.palette.primary.main);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $d39c8cc6675768b1$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $1fa770ef53be4d21$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $172af8ae0bc314bd$export$32c2afa5f91892aa); // for Pigment CSS integration
    $8c2344ec6c8ba42e$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $8c2344ec6c8ba42e$export$2e2bcd8739ae039 = $8c2344ec6c8ba42e$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $66acdd467db63c63$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $97ab3b124552578d$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $66acdd467db63c63$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $97ab3b124552578d$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $97ab3b124552578d$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $97ab3b124552578d$var$defaultDarkOverlays : [];
}
function $97ab3b124552578d$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $4bbefd3eceeba184$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$97ab3b124552578d$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $97ab3b124552578d$export$dd191566510330d3(palette.mode),
        ...other
    };
}


function $c76c93d395a54518$export$2e2bcd8739ae039(keys) {
    return keys[0] === 'motion' || // Keep `focusVisible` inline: its values reference the per-component private vars
    // (`--_focusVisible-offset`/`-behavior`). Hoisted to a `:root` var they resolve where those
    // vars are unset, silently breaking the inner-ring inset.
    keys[0] === 'focusVisible' || !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $c6558b50c8eceb9a$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $c6558b50c8eceb9a$export$2e2bcd8739ae039 = $c6558b50c8eceb9a$var$excludeVariablesFromRoot;


var $f727da5723ddea61$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $c6558b50c8eceb9a$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };





function $25fbd48003e1cd45$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $25fbd48003e1cd45$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $25fbd48003e1cd45$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $0371815994dff8e4$export$29fb7152bd3f781a)(color);
}
function $25fbd48003e1cd45$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $0371815994dff8e4$export$427365fc3db6fc5e)($25fbd48003e1cd45$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $25fbd48003e1cd45$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $25fbd48003e1cd45$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $25fbd48003e1cd45$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $c4732f3462dc01c7$exports.unstable_createGetCssVar)(cssVarPrefix);
function $25fbd48003e1cd45$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $97ab3b124552578d$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $8c2344ec6c8ba42e$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $97ab3b124552578d$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $97ab3b124552578d$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $25fbd48003e1cd45$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $c76c93d395a54518$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $25fbd48003e1cd45$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $3bc64fddc9e3eed1$export$2e2bcd8739ae039)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $25fbd48003e1cd45$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $25fbd48003e1cd45$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $25fbd48003e1cd45$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $3542c7eb00313066$export$2e2bcd8739ae039)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $25fbd48003e1cd45$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $25fbd48003e1cd45$var$setColor(palette.common, 'background', '#fff');
            $25fbd48003e1cd45$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $25fbd48003e1cd45$var$setColor(palette.common, 'background', '#000');
            $25fbd48003e1cd45$var$setColor(palette.common, 'onBackground', '#fff');
        }
        // Generate `text.primaryChannel` before the component tokens:
        // `palette.Skeleton.bg` uses it as its CSS variable fallback.
        if (!nativeColor) $25fbd48003e1cd45$var$setColorChannel(palette.text, 'primary');
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === (0, $0371815994dff8e4$export$34109543fc7f43f8)) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === (0, $0371815994dff8e4$export$eaaef2dca3e9e512)) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === (0, $0371815994dff8e4$export$aeeda94ef1d01275)) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $25fbd48003e1cd45$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'Input',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorFilledColor', $25fbd48003e1cd45$var$silent(()=>palette.getContrastText(palette.error.main)));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoFilledColor', $25fbd48003e1cd45$var$silent(()=>palette.getContrastText(palette.info.main)));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successFilledColor', $25fbd48003e1cd45$var$silent(()=>palette.getContrastText(palette.success.main)));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningFilledColor', $25fbd48003e1cd45$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $25fbd48003e1cd45$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $25fbd48003e1cd45$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $25fbd48003e1cd45$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $25fbd48003e1cd45$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $25fbd48003e1cd45$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $25fbd48003e1cd45$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $25fbd48003e1cd45$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $25fbd48003e1cd45$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $25fbd48003e1cd45$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $25fbd48003e1cd45$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $25fbd48003e1cd45$var$setColor(palette.Input, 'autofillWebkitBoxShadow', 'none');
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $0371815994dff8e4$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'successTrack', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $0371815994dff8e4$export$11bb74ba10c85505)(palette.background.default, 0.8);
            $25fbd48003e1cd45$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $25fbd48003e1cd45$var$setColor(palette.SnackbarContent, 'color', $25fbd48003e1cd45$var$silent(()=>colorSpace ? (0, $4bbefd3eceeba184$export$55ce6f3a06c59543).text.primary : palette.getContrastText(snackbarContentBackground)));
            $25fbd48003e1cd45$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $0371815994dff8e4$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $25fbd48003e1cd45$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $25fbd48003e1cd45$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            $25fbd48003e1cd45$var$setColor(palette.TableCell, 'border', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), (0, $0371815994dff8e4$export$34109543fc7f43f8)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.88));
            $25fbd48003e1cd45$var$setColor(palette.Tooltip, 'bg', colorMix((0, $0371815994dff8e4$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningColor', colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorFilledColor', $25fbd48003e1cd45$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoFilledColor', $25fbd48003e1cd45$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successFilledColor', $25fbd48003e1cd45$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningFilledColor', $25fbd48003e1cd45$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $25fbd48003e1cd45$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $25fbd48003e1cd45$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $25fbd48003e1cd45$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $25fbd48003e1cd45$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $25fbd48003e1cd45$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $25fbd48003e1cd45$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $25fbd48003e1cd45$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $25fbd48003e1cd45$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $25fbd48003e1cd45$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $25fbd48003e1cd45$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $25fbd48003e1cd45$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $25fbd48003e1cd45$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $25fbd48003e1cd45$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $25fbd48003e1cd45$var$setColor(palette.Input, 'autofillWebkitBoxShadow', '0 0 0 100px #266798 inset');
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $0371815994dff8e4$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'successTrack', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $25fbd48003e1cd45$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix((0, $0371815994dff8e4$export$aeeda94ef1d01275), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $0371815994dff8e4$export$11bb74ba10c85505)(palette.background.default, 0.98);
            $25fbd48003e1cd45$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $25fbd48003e1cd45$var$setColor(palette.SnackbarContent, 'color', $25fbd48003e1cd45$var$silent(()=>colorSpace ? (0, $4bbefd3eceeba184$export$a43af521ac8c3202).text.primary : palette.getContrastText(snackbarContentBackground)));
            $25fbd48003e1cd45$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $0371815994dff8e4$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $25fbd48003e1cd45$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $25fbd48003e1cd45$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.55));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.55));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.55));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.55));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.55));
            $25fbd48003e1cd45$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.55));
            $25fbd48003e1cd45$var$setColor(palette.TableCell, 'border', colorMix((0, $0371815994dff8e4$export$eaaef2dca3e9e512), (0, $0371815994dff8e4$export$34109543fc7f43f8)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.68));
            $25fbd48003e1cd45$var$setColor(palette.Tooltip, 'bg', colorMix((0, $0371815994dff8e4$export$34109543fc7f43f8), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (!nativeColor) {
            $25fbd48003e1cd45$var$setColorChannel(palette.background, 'default');
            // added for consistency with the `background.default` token
            $25fbd48003e1cd45$var$setColorChannel(palette.background, 'paper');
            $25fbd48003e1cd45$var$setColorChannel(palette.common, 'background');
            $25fbd48003e1cd45$var$setColorChannel(palette.common, 'onBackground');
            $25fbd48003e1cd45$var$setColorChannel(palette, 'divider');
        }
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && !nativeColor && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $25fbd48003e1cd45$var$setColor(palette[color], 'mainChannel', (0, $0371815994dff8e4$export$427365fc3db6fc5e)($25fbd48003e1cd45$var$toRgb(colors.main)));
                if (colors.light) $25fbd48003e1cd45$var$setColor(palette[color], 'lightChannel', (0, $0371815994dff8e4$export$427365fc3db6fc5e)($25fbd48003e1cd45$var$toRgb(colors.light)));
                if (colors.dark) $25fbd48003e1cd45$var$setColor(palette[color], 'darkChannel', (0, $0371815994dff8e4$export$427365fc3db6fc5e)($25fbd48003e1cd45$var$toRgb(colors.dark)));
                if (colors.contrastText) $25fbd48003e1cd45$var$setColor(palette[color], 'contrastTextChannel', (0, $0371815994dff8e4$export$427365fc3db6fc5e)($25fbd48003e1cd45$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $25fbd48003e1cd45$var$setColorChannel(palette[color], 'primary');
                    $25fbd48003e1cd45$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $25fbd48003e1cd45$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $25fbd48003e1cd45$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $6d1035fe886e2074$export$2e2bcd8739ae039)(acc, argument), theme);
    // Default color is the palette var, not a hex: `focusVisible` is spread inline (skipped from var
    // generation, see `shouldSkipGeneratingVar`), so the var adapts per scheme at the CSS level — no
    // per-scheme copy needed here, unlike the no-vars path in `createTheme`.
    const focusVisibleInput = (0, $f04e4215bb760f30$export$5d0f425d284660f4)(options.focusVisible, args);
    if (focusVisibleInput != null && focusVisibleInput !== false) theme.focusVisible = (0, $f04e4215bb760f30$export$c06a3c79efe1b1cf)(focusVisibleInput, getCssVar('palette-primary-main'));
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $f727da5723ddea61$export$2e2bcd8739ae039)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $bfbc84febe5da8a4$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $c4732f3462dc01c7$exports.createSpacing)(input.spacing, (0, $90cb42e89a0e7057$export$1def6f833384e3d1)(this));
    };
    theme.getColorSchemeSelector = (0, $e336f2efad325a1d$export$858538ff6c0d421d)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $d39c8cc6675768b1$export$2e2bcd8739ae039),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $1fa770ef53be4d21$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    theme.internal_cache = {};
    theme.toRuntimeSource = (0, $172af8ae0bc314bd$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $33e617a46a9805a1$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $4bbefd3eceeba184$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $33e617a46a9805a1$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $8c2344ec6c8ba42e$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $8c2344ec6c8ba42e$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $33e617a46a9805a1$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $33e617a46a9805a1$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        if (theme.focusVisible != null && theme.focusVisible !== false) {
            let focusVisibleInput = theme.focusVisible;
            const rawFocusVisible = (0, $f04e4215bb760f30$export$5d0f425d284660f4)(options.focusVisible, args);
            const authoredColor = rawFocusVisible && typeof rawFocusVisible === 'object' ? rawFocusVisible.outlineColor : undefined;
            // A re-composed theme carries a baked default that looks authored, so it falls back to value
            // equality — the one case where a pinned `primary.main` is indistinguishable and gets reset.
            if (!authoredColor || (0, $f04e4215bb760f30$export$685950156577a061)(rawFocusVisible) && authoredColor === theme.palette.primary.main) {
                const { outlineColor: outlineColor, ...rest } = focusVisibleInput;
                focusVisibleInput = rest;
            }
            Object.keys(theme.colorSchemes).forEach((scheme)=>{
                const schemePalette = theme.colorSchemes?.[scheme]?.palette;
                if (schemePalette?.primary) theme.colorSchemes[scheme].focusVisible = (0, $f04e4215bb760f30$export$c06a3c79efe1b1cf)(focusVisibleInput, schemePalette.primary.main);
            });
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $25fbd48003e1cd45$export$2e2bcd8739ae039)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


'use client';
const $794b8f9dccb38ab5$var$defaultTheme = (0, $33e617a46a9805a1$export$2e2bcd8739ae039)();
var $794b8f9dccb38ab5$export$2e2bcd8739ae039 = $794b8f9dccb38ab5$var$defaultTheme;


var $c34023d0b81c23bc$export$2e2bcd8739ae039 = '$$material';


// copied from @mui/system/createStyled
function $ec2b13121e2c53c4$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $ec2b13121e2c53c4$export$2e2bcd8739ae039 = $ec2b13121e2c53c4$var$slotShouldForwardProp;


const $7a1c3fb4f5a2134c$var$rootShouldForwardProp = (prop)=>(0, $ec2b13121e2c53c4$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $7a1c3fb4f5a2134c$export$2e2bcd8739ae039 = $7a1c3fb4f5a2134c$var$rootShouldForwardProp;



'use client';
const $8db793a053de590e$var$styled = (0, $2d9f7f7ae5f23e9d$export$2e2bcd8739ae039)({
    themeId: (0, $c34023d0b81c23bc$export$2e2bcd8739ae039),
    defaultTheme: $794b8f9dccb38ab5$export$2e2bcd8739ae039,
    rootShouldForwardProp: $7a1c3fb4f5a2134c$export$2e2bcd8739ae039
});
var $8db793a053de590e$export$2e2bcd8739ae039 = $8db793a053de590e$var$styled;



const $aa36852ee1337b36$var$memoTheme = (0, $c4732f3462dc01c7$exports.unstable_memoTheme);
var $aa36852ee1337b36$export$2e2bcd8739ae039 = $aa36852ee1337b36$var$memoTheme;


parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");
function $cf2644927cba071a$export$2e2bcd8739ae039(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    const defaultSlotPropValue = defaultSlotProps[slotPropName];
                    const slotPropValue = slotProps[slotPropName];
                    if (typeof defaultSlotPropValue === 'function' || typeof slotPropValue === 'function') // Function slot props are resolved later (with `ownerState`), so defer
                    // the merge until then to avoid dropping either side.
                    output[propName][slotPropName] = (...args)=>$cf2644927cba071a$export$2e2bcd8739ae039((typeof defaultSlotPropValue === 'function' ? defaultSlotPropValue(...args) : defaultSlotPropValue) ?? {}, (typeof slotPropValue === 'function' ? slotPropValue(...args) : slotPropValue) ?? {}, mergeClassNameAndStyle);
                    else output[propName][slotPropName] = $cf2644927cba071a$export$2e2bcd8739ae039(defaultSlotPropValue ?? {}, slotPropValue ?? {}, mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className !== undefined) output.className = (0, $bbzhi.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $0cb2616ad6bb66b1$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $0cb2616ad6bb66b1$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($0cb2616ad6bb66b1$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $0cb2616ad6bb66b1$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $cf2644927cba071a$export$2e2bcd8739ae039)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $cf2644927cba071a$export$2e2bcd8739ae039)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $0cb2616ad6bb66b1$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($0cb2616ad6bb66b1$var$PropsContext);
    return $0cb2616ad6bb66b1$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $0cb2616ad6bb66b1$export$2e2bcd8739ae039 = $0cb2616ad6bb66b1$var$DefaultPropsProvider;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $dea052643d4c0260$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0cb2616ad6bb66b1$export$2e2bcd8739ae039), {
        ...props
    });
}
var $dea052643d4c0260$export$2e2bcd8739ae039 = $dea052643d4c0260$var$DefaultPropsProvider;
function $dea052643d4c0260$export$2440da353cedad43(params) {
    return (0, $0cb2616ad6bb66b1$export$2440da353cedad43)(params);
}



var $beb7a3ce4e2ae599$export$2e2bcd8739ae039 = (0, $5c25258cb94860e5$export$2e2bcd8739ae039);


/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $7ca0839ce26bd7d8$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $7ca0839ce26bd7d8$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$7ca0839ce26bd7d8$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $7ca0839ce26bd7d8$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $7ca0839ce26bd7d8$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}


const $0bba252fe592dc86$var$defaultGenerator = (componentName)=>componentName;
const $0bba252fe592dc86$var$createClassNameGenerator = ()=>{
    let generate = $0bba252fe592dc86$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $0bba252fe592dc86$var$defaultGenerator;
        }
    };
};
const $0bba252fe592dc86$var$ClassNameGenerator = $0bba252fe592dc86$var$createClassNameGenerator();
var $0bba252fe592dc86$export$2e2bcd8739ae039 = $0bba252fe592dc86$var$ClassNameGenerator;


const $cd58bcc8013d55b5$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $cd58bcc8013d55b5$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $cd58bcc8013d55b5$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $0bba252fe592dc86$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $cd58bcc8013d55b5$export$34c0130b1f3e8ae3(slot) {
    return $cd58bcc8013d55b5$export$9d6b9120de57c54[slot] !== undefined;
}


function $c358ff50bb9d0713$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $90080149894ad9be$export$24c1f8f60cbac79e(slot) {
    return (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $90080149894ad9be$var$typographyClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom'
]);
var $90080149894ad9be$export$2e2bcd8739ae039 = $90080149894ad9be$var$typographyClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $abce12fca512444b$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap'
        ]
    };
    return (0, $35c034932912ab1a$export$2e2bcd8739ae039)(slots, (0, $90080149894ad9be$export$24c1f8f60cbac79e), classes);
};
const $abce12fca512444b$export$140e2f5526d3cad8 = (0, $8db793a053de590e$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom
        ];
    }
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $7ca0839ce26bd7d8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            }
        ]
    })));
const $abce12fca512444b$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $abce12fca512444b$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const props = (0, $dea052643d4c0260$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const { color: color, align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, variant: variant = 'body1', variantMapping: variantMapping = $abce12fca512444b$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || variantMapping[variant] || $abce12fca512444b$var$defaultVariantMapping[variant] || 'span';
    const classes = $abce12fca512444b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($abce12fca512444b$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $bbzhi.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $abce12fca512444b$export$2e2bcd8739ae039 = $abce12fca512444b$var$Typography;




var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");

var $acw62 = parcelRequire("acw62");
function $e4a73532629d17a3$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/react/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}





const $aaefe97824d08c3f$var$styled = (0, $2d9f7f7ae5f23e9d$export$2e2bcd8739ae039)();
var $aaefe97824d08c3f$export$2e2bcd8739ae039 = $aaefe97824d08c3f$var$styled;



function $e3daed2d5e8b5b13$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $cf2644927cba071a$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}




var $acw62 = parcelRequire("acw62");

var $keaWW = parcelRequire("keaWW");
'use client';
function $58e09454631a379e$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $58e09454631a379e$var$useThemeWithoutDefault(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $keaWW.ThemeContext));
    return !contextTheme || $58e09454631a379e$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $58e09454631a379e$export$2e2bcd8739ae039 = $58e09454631a379e$var$useThemeWithoutDefault;


'use client';
const $9498510d7b9ff342$export$35e57303dbd8a66 = (0, $771c3de9a70a57c0$export$2e2bcd8739ae039)();
function $9498510d7b9ff342$var$useTheme(defaultTheme = $9498510d7b9ff342$export$35e57303dbd8a66) {
    return (0, $58e09454631a379e$export$2e2bcd8739ae039)(defaultTheme);
}
var $9498510d7b9ff342$export$2e2bcd8739ae039 = $9498510d7b9ff342$var$useTheme;


'use client';
function $240ef16fe5ad0c69$export$2e2bcd8739ae039(params) {
    const { props: props, name: name, defaultTheme: defaultTheme, themeId: themeId } = params;
    let theme = (0, $9498510d7b9ff342$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $e3daed2d5e8b5b13$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}




const $82ffe2859714d877$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $82ffe2859714d877$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $82ffe2859714d877$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $8e59af1390256e46$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $8e59af1390256e46$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $8e59af1390256e46$var$selfColumnsVar = '--Grid-columns';
const $8e59af1390256e46$var$parentColumnsVar = '--Grid-parent-columns';
const $8e59af1390256e46$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $82ffe2859714d877$export$e04173f1577f18b7)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$8e59af1390256e46$var$parentColumnsVar}) - (var(${$8e59af1390256e46$var$parentColumnsVar}) - ${value}) * (var(${$8e59af1390256e46$var$getParentSpacingVar('column')}) / var(${$8e59af1390256e46$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $8e59af1390256e46$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $82ffe2859714d877$export$e04173f1577f18b7)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$8e59af1390256e46$var$parentColumnsVar}) + var(${$8e59af1390256e46$var$getParentSpacingVar('column')}) * ${value} / var(${$8e59af1390256e46$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $8e59af1390256e46$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$8e59af1390256e46$var$selfColumnsVar]: 12
    };
    (0, $82ffe2859714d877$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$8e59af1390256e46$var$selfColumnsVar]: columns,
            '> *': {
                [$8e59af1390256e46$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $8e59af1390256e46$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $82ffe2859714d877$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$8e59af1390256e46$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$8e59af1390256e46$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $8e59af1390256e46$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $82ffe2859714d877$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$8e59af1390256e46$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$8e59af1390256e46$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $8e59af1390256e46$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $82ffe2859714d877$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $8e59af1390256e46$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$8e59af1390256e46$var$getSelfSpacingVar('row')}) var(${$8e59af1390256e46$var$getSelfSpacingVar('column')})`
        }
    };
};
const $8e59af1390256e46$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $8e59af1390256e46$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $8e59af1390256e46$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $4d5f5b131b11d793$var$defaultTheme = (0, $771c3de9a70a57c0$export$2e2bcd8739ae039)();
// widening Theme to any so that the consumer can own the theme structure.
const $4d5f5b131b11d793$var$defaultCreateStyledComponent = (0, $aaefe97824d08c3f$export$2e2bcd8739ae039)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $4d5f5b131b11d793$var$useThemePropsDefault(props) {
    return (0, $240ef16fe5ad0c69$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $4d5f5b131b11d793$var$defaultTheme
    });
}
function $4d5f5b131b11d793$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $4d5f5b131b11d793$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $4d5f5b131b11d793$var$useThemePropsDefault, useTheme: useTheme = (0, $9498510d7b9ff342$export$2e2bcd8739ae039), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $8e59af1390256e46$export$a7c8efbe2b138a60)(direction),
                ...(0, $8e59af1390256e46$export$e2d1175061442d38)(size),
                ...container ? (0, $8e59af1390256e46$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $35c034932912ab1a$export$2e2bcd8739ae039)(slots, (slot)=>(0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $8e59af1390256e46$export$ccc4d4a4923f1b06), (0, $8e59af1390256e46$export$a89c28919b8e3bb5), (0, $8e59af1390256e46$export$68c4dad72dd49c74), (0, $8e59af1390256e46$export$84053369756c53db), (0, $8e59af1390256e46$export$2a0a3c01032b3f4), (0, $8e59af1390256e46$export$810b8c3ab5d46bf), (0, $8e59af1390256e46$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = themeProps;
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $bbzhi.default)(classes.root, className),
            ...other,
            children: $acw62.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $acw62.isValidElement(child) && (0, $e4a73532629d17a3$export$2e2bcd8739ae039)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $acw62.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-expect-error internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}





parcelRequire("acw62");



'use client';
function $36764a1b32aece01$export$2e2bcd8739ae039() {
    const theme = (0, $c4732f3462dc01c7$exports.useTheme)((0, $794b8f9dccb38ab5$export$2e2bcd8739ae039));
    return theme[0, $c34023d0b81c23bc$export$2e2bcd8739ae039] || theme;
}


'use client';
/**
 *
 * Demos:
 *
 * - [Grid](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/material-ui/api/grid/)
 */ const $416354f8df00ef09$var$Grid = (0, $4d5f5b131b11d793$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $8db793a053de590e$export$2e2bcd8739ae039)('div', {
        name: 'MuiGrid',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid',
    useThemeProps: (inProps)=>(0, $dea052643d4c0260$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiGrid'
        }),
    useTheme: $36764a1b32aece01$export$2e2bcd8739ae039
});
var $416354f8df00ef09$export$2e2bcd8739ae039 = $416354f8df00ef09$var$Grid;



var $acw62 = parcelRequire("acw62");






const $e1eb44860af7d640$var$boxClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $e1eb44860af7d640$export$2e2bcd8739ae039 = $e1eb44860af7d640$var$boxClasses;


'use client';
const $70069ac1d764d0d8$var$defaultTheme = (0, $33e617a46a9805a1$export$2e2bcd8739ae039)();
const $70069ac1d764d0d8$var$Box = (0, $c4732f3462dc01c7$exports.createBox)({
    themeId: (0, $c34023d0b81c23bc$export$2e2bcd8739ae039),
    defaultTheme: $70069ac1d764d0d8$var$defaultTheme,
    defaultClassName: (0, $e1eb44860af7d640$export$2e2bcd8739ae039).root,
    generateClassName: (0, $0bba252fe592dc86$export$2e2bcd8739ae039).generate
});
var $70069ac1d764d0d8$export$2e2bcd8739ae039 = $70069ac1d764d0d8$var$Box;


const $77df55c54bbe1a84$export$eb38b3b9c7f5f31b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function ContentBlock(props, ref) {
    const { classes: classes = {}, className: className, elevation: elevation = 2, padding: padding = 'none', overrideClasses: overrideClasses, square: square = true, variant: variant = 'none', displayVariant: displayVariant = 'none', SurfaceProps: SurfaceProps = {}, classNameObj: classNameObj = {}, ...rest } = props;
    if (elevation === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70069ac1d764d0d8$export$2e2bcd8739ae039), {
        elevation: 0,
        ref: ref,
        ...SurfaceProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $70069ac1d764d0d8$export$2e2bcd8739ae039), {
        elevation: elevation,
        ref: ref,
        ...SurfaceProps,
        ...classNameObj.props
    });
});



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");


/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $3365c1d14c19e0cb$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}










function $0a62b4b8fe96c6cc$export$d6efab9620b78fec(slot) {
    return (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)('MuiLink', slot);
}
const $0a62b4b8fe96c6cc$var$linkClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $0a62b4b8fe96c6cc$export$2e2bcd8739ae039 = $0a62b4b8fe96c6cc$var$linkClasses;




const $2ed379fb4dea3da4$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    if ('colorSpace' in theme && theme.colorSpace) {
        const color = (0, $14320da9d0de2b77$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.main`) || (0, $14320da9d0de2b77$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}`) || ownerState.color;
        return theme.alpha(color, 0.4);
    }
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $14320da9d0de2b77$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.main`, false) || (0, $14320da9d0de2b77$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $14320da9d0de2b77$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.mainChannel`) || (0, $14320da9d0de2b77$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    try {
        return (0, $0371815994dff8e4$export$58f0f39f63f3cf42)(color, 0.4);
    } catch  {
        return `color-mix(in srgb, ${color} 40%, transparent)`;
    }
};
var $2ed379fb4dea3da4$export$2e2bcd8739ae039 = $2ed379fb4dea3da4$var$getTextDecoration;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $65f55e6ff8849acd$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $65f55e6ff8849acd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $35c034932912ab1a$export$2e2bcd8739ae039)(slots, (0, $0a62b4b8fe96c6cc$export$d6efab9620b78fec), classes);
};
const $65f55e6ff8849acd$var$LinkRoot = (0, $8db793a053de590e$export$2e2bcd8739ae039)((0, $abce12fca512444b$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>{
    return {
        ...theme.focusVisible && {
            [`&.${(0, $0a62b4b8fe96c6cc$export$2e2bcd8739ae039).focusVisible}`]: {
                ...(0, $f04e4215bb760f30$export$2f2afcd9b20384c7),
                ...theme.focusVisible
            }
        },
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color === 'inherit',
                style: theme.colorSpace ? {
                    textDecorationColor: theme.alpha('currentColor', 0.4)
                } : null
            },
            ...Object.entries(theme.palette).filter((0, $7ca0839ce26bd7d8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.alpha((theme.vars || theme).palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    // Browser default focus ring, unless the curated ring is opted in (spread at the root).
                    ...!theme.focusVisible && {
                        [`&.${(0, $0a62b4b8fe96c6cc$export$2e2bcd8739ae039).focusVisible}`]: {
                            outline: 'auto'
                        }
                    }
                }
            }
        ]
    };
}));
const $65f55e6ff8849acd$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const props = (0, $dea052643d4c0260$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $36764a1b32aece01$export$2e2bcd8739ae039)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $3365c1d14c19e0cb$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $3365c1d14c19e0cb$export$2e2bcd8739ae039)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $65f55e6ff8849acd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($65f55e6ff8849acd$var$LinkRoot, {
        color: color,
        className: (0, $bbzhi.default)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$65f55e6ff8849acd$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$65f55e6ff8849acd$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $2ed379fb4dea3da4$export$2e2bcd8739ae039)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $65f55e6ff8849acd$export$2e2bcd8739ae039 = $65f55e6ff8849acd$var$Link;


const $db804c155843de2a$export$5f1af8db9871e1d6 = (props)=>{
    const { href: href, toRoute: toRoute, onClick: onClick, linkClassName: linkClassName, LinkProps: LinkProps = {}, ...other } = props;
    if (onClick) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $65f55e6ff8849acd$export$2e2bcd8739ae039), {
        component: "button",
        onClick: onClick,
        className: linkClassName,
        ...LinkProps,
        ...other
    });
    if (href) {
        const { children: children, ...rest } = other;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abce12fca512444b$export$2e2bcd8739ae039), rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $65f55e6ff8849acd$export$2e2bcd8739ae039), {
            href: href,
            ...LinkProps
        }, children));
    }
    if (toRoute) {
        const { children: children, ...rest } = other;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abce12fca512444b$export$2e2bcd8739ae039), rest);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $abce12fca512444b$export$2e2bcd8739ae039), other);
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");


var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");








var $acw62 = parcelRequire("acw62");
'use client';
function $b04b8db943702285$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $acw62.useRef(undefined);
    const refEffect = $acw62.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    }, refs);
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps, react-hooks/use-memo
    }, refs);
}


'use client';
var $a4c63a8573c104c9$export$2e2bcd8739ae039 = (0, $b04b8db943702285$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $4bfd612c4ff992b0$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $4bfd612c4ff992b0$export$2e2bcd8739ae039 = $4bfd612c4ff992b0$var$useEnhancedEffect;


'use client';
/**
 * Inspired by https://github.com/react/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $c29f88befb28da18$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $4bfd612c4ff992b0$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $c29f88befb28da18$export$2e2bcd8739ae039 = $c29f88befb28da18$var$useEventCallback;


'use client';
var $8f6d6d1b1fb64725$export$2e2bcd8739ae039 = (0, $c29f88befb28da18$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
function $10554b26be738f9b$export$2e2bcd8739ae039(parameters) {
    const { focusableWhenDisabled: focusableWhenDisabled, disabled: disabled, composite: composite = false, tabIndex: tabIndexProp = 0, isNativeButton: isNativeButton } = parameters;
    const isFocusableComposite = composite && focusableWhenDisabled !== false;
    const isNonFocusableComposite = composite && focusableWhenDisabled === false;
    // we can't explicitly assign `undefined` to any of these props because it
    // would otherwise prevent subsequently merged props from setting them
    const props = $acw62.useMemo(()=>{
        const additionalProps = {
            // allow Tabbing away from focusableWhenDisabled elements
            onKeyDown (event) {
                if (disabled && focusableWhenDisabled && event.key !== 'Tab') event.preventDefault();
            }
        };
        if (!composite) {
            additionalProps.tabIndex = tabIndexProp;
            if (!isNativeButton && disabled) additionalProps.tabIndex = focusableWhenDisabled ? tabIndexProp : -1;
        }
        if (isNativeButton && (focusableWhenDisabled || isFocusableComposite) || !isNativeButton && disabled) additionalProps['aria-disabled'] = disabled;
        if (isNativeButton && (!focusableWhenDisabled || isNonFocusableComposite)) additionalProps.disabled = disabled;
        return additionalProps;
    }, [
        composite,
        disabled,
        focusableWhenDisabled,
        isFocusableComposite,
        isNonFocusableComposite,
        isNativeButton,
        tabIndexProp
    ]);
    return props;
}


'use client';
const $1d9d08178069f598$var$EMPTY = {};
function $1d9d08178069f598$export$2e2bcd8739ae039(parameters) {
    const { nativeButton: nativeButton, nativeButtonProp: nativeButtonProp, internalNativeButton: internalNativeButton = nativeButton, allowInferredHostMismatch: allowInferredHostMismatch = false, disabled: disabled, type: type, hasFormAction: hasFormAction = false, tabIndex: tabIndex = 0, focusableWhenDisabled: focusableWhenDisabledParam, stopEventPropagation: stopEventPropagation = false, onBeforeKeyDown: onBeforeKeyDown, onBeforeKeyUp: onBeforeKeyUp } = parameters;
    const rootRef = $acw62.useRef(null);
    const focusableWhenDisabled = focusableWhenDisabledParam === true;
    const focusableWhenDisabledProps = (0, $10554b26be738f9b$export$2e2bcd8739ae039)({
        focusableWhenDisabled: focusableWhenDisabled,
        disabled: disabled,
        isNativeButton: nativeButton,
        tabIndex: tabIndex
    });
    // A helper for event handlers to determine whether to use browser-defined keyboard activation
    // for native elements like <button> and <a href>, or synthesize Enter/Space clicks for non-native
    // elements like `<div role="button">`.
    // This is UNSAFE TO USE outside of event handers, e.g. in render.
    const hasNativeKeyboardActivation = $acw62.useCallback(()=>{
        const root = rootRef.current;
        if (root == null) return nativeButton;
        if (root.tagName === 'BUTTON') return true;
        // Although this hook is not intended for links, this check is for
        // backward compatibility with `<ButtonBase href="#" />` since ButtonBase
        // uses the returned event handlers.
        return Boolean(root.tagName === 'A' && root.href);
    }, [
        nativeButton
    ]);
    const buttonProps = $acw62.useMemo(()=>{
        const resolvedButtonProps = focusableWhenDisabled ? {} : {
            tabIndex: disabled ? -1 : tabIndex
        };
        if (nativeButton) {
            resolvedButtonProps.type = type === undefined && !hasFormAction ? 'button' : type;
            if (!focusableWhenDisabled) resolvedButtonProps.disabled = disabled;
        } else {
            resolvedButtonProps.role = 'button';
            if (!focusableWhenDisabled && disabled) resolvedButtonProps['aria-disabled'] = disabled;
        }
        if (focusableWhenDisabled) return {
            ...resolvedButtonProps,
            ...focusableWhenDisabledProps
        };
        return resolvedButtonProps;
    }, [
        disabled,
        focusableWhenDisabled,
        focusableWhenDisabledProps,
        hasFormAction,
        nativeButton,
        tabIndex,
        type
    ]);
    const getButtonProps = $acw62.useCallback((externalProps = $1d9d08178069f598$var$EMPTY)=>{
        const { onClick: externalOnClick, onKeyDown: externalOnKeyDown, onKeyUp: externalOnKeyUp, ...otherExternalProps } = externalProps;
        const handleClick = (event)=>{
            if (stopEventPropagation) event.stopPropagation();
            if (disabled) {
                event.preventDefault();
                return;
            }
            externalOnClick?.(event);
        };
        const handleKeyDown = (event)=>{
            if (focusableWhenDisabled) focusableWhenDisabledProps.onKeyDown(event);
            if (disabled) return;
            onBeforeKeyDown?.(event);
            externalOnKeyDown?.(event);
            if (event.target !== event.currentTarget || hasNativeKeyboardActivation()) return;
            if (event.key === ' ') {
                event.preventDefault();
                return;
            }
            if (event.key === 'Enter') {
                event.preventDefault();
                event.currentTarget.click();
            }
        };
        const handleKeyUp = (event)=>{
            if (disabled) return;
            onBeforeKeyUp?.(event);
            externalOnKeyUp?.(event);
            if (event.target === event.currentTarget && !hasNativeKeyboardActivation() && event.key === ' ' && !event.defaultPrevented) event.currentTarget.click();
        };
        return {
            ...buttonProps,
            ...otherExternalProps,
            onClick: handleClick,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp
        };
    }, [
        buttonProps,
        disabled,
        focusableWhenDisabled,
        focusableWhenDisabledProps,
        hasNativeKeyboardActivation,
        onBeforeKeyDown,
        onBeforeKeyUp,
        stopEventPropagation
    ]);
    return {
        getButtonProps: getButtonProps,
        rootRef: rootRef
    };
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $440accdfc99b3896$var$UNINITIALIZED = {};
function $440accdfc99b3896$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($440accdfc99b3896$var$UNINITIALIZED);
    if (ref.current === $440accdfc99b3896$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


'use client';
class $0f53385e86c81037$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ ref = {
        current: null
    };
    /** If the ripple component should be mounted */ shouldMount = false;
    /** Promise that resolves when the ripple component is mounted */ mounted = null;
    /** If the ripple component has been mounted */ didMount = false;
    /** React state hook setter */ setShouldMount = null;
    static create() {
        return new $0f53385e86c81037$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $440accdfc99b3896$export$2e2bcd8739ae039)($0f53385e86c81037$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $acw62.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $acw62.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $0f53385e86c81037$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) this.didMount = true;
            this.mounted.resolve();
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $0f53385e86c81037$export$2e2bcd8739ae039() {
    return $0f53385e86c81037$export$f5de0641c7db4154.use();
}
function $0f53385e86c81037$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");

var $acw62 = parcelRequire("acw62");
'use client';
const $c7290d3883406124$var$EMPTY = [];
function $c7290d3883406124$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $c7290d3883406124$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }




'use client';
class $943ee333ac0b0d39$export$786b4da70f00938b {
    static create() {
        return new $943ee333ac0b0d39$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $943ee333ac0b0d39$export$2e2bcd8739ae039() {
    const timeout = (0, $440accdfc99b3896$export$2e2bcd8739ae039)($943ee333ac0b0d39$export$786b4da70f00938b.create).current;
    (0, $c7290d3883406124$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}





var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
function $3b46a2bad2c4423d$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const exitTimer = (0, $943ee333ac0b0d39$export$2e2bcd8739ae039)();
    const exitTimerStartedRef = $acw62.useRef(false);
    const onExitedRef = $acw62.useRef(onExited);
    onExitedRef.current = onExited;
    const hasExitedCallback = onExited != null;
    const rippleClassName = (0, $bbzhi.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $bbzhi.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && hasExitedCallback) {
            if (!exitTimerStartedRef.current) {
                exitTimerStartedRef.current = true;
                exitTimer.start(timeout, ()=>{
                    exitTimerStartedRef.current = false;
                    onExitedRef.current?.();
                });
            }
        } else {
            exitTimerStartedRef.current = false;
            exitTimer.clear();
        }
    }, [
        exitTimer,
        hasExitedCallback,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            className: childClassName
        })
    });
}
var $3b46a2bad2c4423d$export$2e2bcd8739ae039 = $3b46a2bad2c4423d$var$Ripple;




function $50b75803a315b395$export$b464606f735ab902(slot) {
    return (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $50b75803a315b395$var$touchRippleClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $50b75803a315b395$export$2e2bcd8739ae039 = $50b75803a315b395$var$touchRippleClasses;




var $acw62 = parcelRequire("acw62");

'use client';
const $690ea4adad3d4419$var$MEDIA_QUERY = '(prefers-reduced-motion: reduce)';
const $690ea4adad3d4419$var$REDUCED_MOTION_DURATION = 0;
const $690ea4adad3d4419$var$REDUCED_MOTION_DELAY = '0ms';
const $690ea4adad3d4419$var$NOOP = ()=>{};
const $690ea4adad3d4419$var$getDefaultSnapshot = ()=>false;
const $690ea4adad3d4419$var$getReducedMotionSnapshot = ()=>true;
const $690ea4adad3d4419$var$subscribeNoop = ()=>$690ea4adad3d4419$var$NOOP;
/**
 * Subscribes to the OS reduced-motion media query only when the theme mode needs it.
 * React 17 reads the media query after mount, matching useMediaQuery's fallback path.
 */ function $690ea4adad3d4419$var$useReducedMotionMediaQueryOld(enabled) {
    const [queryState, setQueryState] = $acw62.useState(()=>({
            enabled: enabled,
            matches: enabled ? null : false
        }));
    let matches = queryState.matches;
    if (queryState.enabled !== enabled) {
        matches = null;
        if (!enabled) matches = false;
    }
    (0, $4bfd612c4ff992b0$export$2e2bcd8739ae039)(()=>{
        const setResolvedMatches = (nextMatches)=>{
            setQueryState((previousState)=>{
                if (previousState.enabled === enabled && previousState.matches === nextMatches) return previousState;
                return {
                    enabled: enabled,
                    matches: nextMatches
                };
            });
        };
        if (!enabled) {
            if (queryState.enabled) setResolvedMatches(false);
            return undefined;
        }
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            setResolvedMatches(false);
            return undefined;
        }
        const mediaQueryList = window.matchMedia($690ea4adad3d4419$var$MEDIA_QUERY);
        const update = ()=>{
            setResolvedMatches(mediaQueryList.matches);
        };
        update();
        mediaQueryList.addEventListener('change', update);
        return ()=>{
            mediaQueryList.removeEventListener('change', update);
        };
    }, [
        enabled,
        queryState.enabled
    ]);
    return matches;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $690ea4adad3d4419$var$safeReact = {
    ...$acw62
};
const $690ea4adad3d4419$var$maybeReactUseSyncExternalStore = $690ea4adad3d4419$var$safeReact.useSyncExternalStore;
/**
 * React 18+ can read the media query during client renders, so newly mounted
 * transitions do not start from the SSR-safe reduced-motion default.
 */ function $690ea4adad3d4419$var$useReducedMotionMediaQueryNew(enabled) {
    const getServerSnapshot = enabled ? $690ea4adad3d4419$var$getReducedMotionSnapshot : $690ea4adad3d4419$var$getDefaultSnapshot;
    const [getSnapshot, subscribe] = $acw62.useMemo(()=>{
        if (!enabled || typeof window === 'undefined' || typeof window.matchMedia !== 'function') return [
            $690ea4adad3d4419$var$getDefaultSnapshot,
            $690ea4adad3d4419$var$subscribeNoop
        ];
        const mediaQueryList = window.matchMedia($690ea4adad3d4419$var$MEDIA_QUERY);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        enabled
    ]);
    return $690ea4adad3d4419$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
const $690ea4adad3d4419$var$useReducedMotionMediaQuery = $690ea4adad3d4419$var$maybeReactUseSyncExternalStore !== undefined ? $690ea4adad3d4419$var$useReducedMotionMediaQueryNew : $690ea4adad3d4419$var$useReducedMotionMediaQueryOld;
function $690ea4adad3d4419$export$2e2bcd8739ae039(mode, disablePrefersReducedMotion) {
    const prefersReducedMotion = $690ea4adad3d4419$var$useReducedMotionMediaQuery(!disablePrefersReducedMotion && mode === 'system');
    const shouldReduceMotion = !disablePrefersReducedMotion && (mode === 'always' || mode === 'system' && prefersReducedMotion !== false);
    return $acw62.useMemo(()=>({
            shouldReduceMotion: shouldReduceMotion,
            getTransitionTiming (timing) {
                if (!shouldReduceMotion) return timing;
                return {
                    duration: $690ea4adad3d4419$var$REDUCED_MOTION_DURATION,
                    delay: $690ea4adad3d4419$var$REDUCED_MOTION_DELAY
                };
            }
        }), [
        shouldReduceMotion
    ]);
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9666667bf3905aaf$var$DURATION = 550;
const $9666667bf3905aaf$export$95d0c9356b2231a3 = 80;
const $9666667bf3905aaf$var$EMPTY_OBJ = {};
const $9666667bf3905aaf$var$EMPTY_ARRAY = [];
const $9666667bf3905aaf$var$NOOP = ()=>{};
/**
 * Keep the same DOM order TouchRipple had when it used react-transition-group:
 * exiting ripples stay in place, and new ripples are inserted before the final
 * group of ripples that are waiting for their exit animation to finish.
 *
 * @param {number[]} prevOrder The previous DOM order, including ripples that may be exiting.
 * @param {number[]} nextActiveKeys The ripples that should still be treated as active.
 * @returns {number[]} The next DOM order, preserving the position of exiting ripples where possible.
 */ function $9666667bf3905aaf$var$mergeRippleOrder(prevOrder, nextActiveKeys) {
    const nextKeySet = new Set(nextActiveKeys);
    const nextKeysPending = new Map();
    let pendingKeys = [];
    for (const prevKey of prevOrder){
        if (nextKeySet.has(prevKey)) {
            if (pendingKeys.length > 0) {
                nextKeysPending.set(prevKey, pendingKeys);
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    const nextOrder = [];
    for (const nextKey of nextActiveKeys){
        const pendingBefore = nextKeysPending.get(nextKey);
        if (pendingBefore) nextOrder.push(...pendingBefore);
        nextOrder.push(nextKey);
    }
    nextOrder.push(...pendingKeys);
    return nextOrder;
}
/**
 * Calculate where the ripple should start and how large it must be to cover the host element.
 *
 * @param {object} params
 * @param {object} params.event The mouse or touch event that started the ripple.
 * @param {HTMLElement | null} params.element The host element used for measurements. Tests pass `null`.
 * @param {boolean} params.center If `true`, start the ripple from the center of the host element.
 * @returns {{ rippleX: number, rippleY: number, rippleSize: number }} The ripple position and size.
 */ function $9666667bf3905aaf$var$computeRippleState({ event: event, element: element, center: center }) {
    const rect = element ? element.getBoundingClientRect() : {
        width: 0,
        height: 0,
        left: 0,
        top: 0
    };
    let rippleX;
    let rippleY;
    if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
        rippleX = Math.round(rect.width / 2);
        rippleY = Math.round(rect.height / 2);
    } else {
        const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
        rippleX = Math.round(clientX - rect.left);
        rippleY = Math.round(clientY - rect.top);
    }
    let rippleSize;
    if (center) {
        rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
        // Mobile Chrome can skip this animation for even pixel sizes.
        if (rippleSize % 2 === 0) rippleSize += 1;
    } else {
        const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
        const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
        rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    }
    return {
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
    };
}
const $9666667bf3905aaf$var$enterKeyframe = (0, $c4732f3462dc01c7$exports.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $9666667bf3905aaf$var$exitKeyframe = (0, $c4732f3462dc01c7$exports.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $9666667bf3905aaf$var$pulsateKeyframe = (0, $c4732f3462dc01c7$exports.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
function $9666667bf3905aaf$var$getAnimationStyles(theme) {
    if (theme.motion.reducedMotion === 'always') return null;
    const styles = (0, $c4732f3462dc01c7$exports.css)`
    &.${(0, $50b75803a315b395$export$2e2bcd8739ae039).rippleVisible} {
      animation-name: ${$9666667bf3905aaf$var$enterKeyframe};
      animation-duration: ${$9666667bf3905aaf$var$DURATION}ms;
      animation-timing-function: ${theme.transitions.easing.easeInOut};
    }

    &.${(0, $50b75803a315b395$export$2e2bcd8739ae039).ripplePulsate} {
      animation-duration: ${theme.transitions.duration.shorter}ms;
    }

    & .${(0, $50b75803a315b395$export$2e2bcd8739ae039).childLeaving} {
      animation-name: ${$9666667bf3905aaf$var$exitKeyframe};
      animation-duration: ${$9666667bf3905aaf$var$DURATION}ms;
      animation-timing-function: ${theme.transitions.easing.easeInOut};
    }

    & .${(0, $50b75803a315b395$export$2e2bcd8739ae039).childPulsate} {
      animation-name: ${$9666667bf3905aaf$var$pulsateKeyframe};
      animation-duration: 2500ms;
      animation-timing-function: ${theme.transitions.easing.easeInOut};
      animation-iteration-count: infinite;
      animation-delay: 200ms;
    }
  `;
    if (theme.motion.reducedMotion === 'system') return (0, $c4732f3462dc01c7$exports.css)`
      @media (prefers-reduced-motion: no-preference) {
        ${styles}
      }
    `;
    return styles;
}
const $9666667bf3905aaf$export$f6b7418508c72c25 = (0, $8db793a053de590e$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $9666667bf3905aaf$export$676cfe7b12693c4b = (0, $8db793a053de590e$export$2e2bcd8739ae039)((0, $3b46a2bad2c4423d$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $50b75803a315b395$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
  }

  /*
   * Order matters: 'child', 'childLeaving' and 'childPulsate' apply to the same
   * element with equal specificity, so the later rule wins. 'child' must come
   * before 'childLeaving' so the leaving 'opacity: 0' takes precedence. A focus
   * (pulsate) ripple keeps 'pulsateKeyframe' (no opacity animation) on exit, so
   * it relies on this static 'opacity: 0' to disappear on blur instead of
   * lingering until removal.
   */
  & .${(0, $50b75803a315b395$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $50b75803a315b395$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
  }

  & .${(0, $50b75803a315b395$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
  }

  ${({ theme: theme })=>$9666667bf3905aaf$var$getAnimationStyles(theme)}
`;
/**
 * @ignore - internal component.
 */ const $9666667bf3905aaf$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $dea052643d4c0260$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const theme = (0, $36764a1b32aece01$export$2e2bcd8739ae039)();
    const reducedMotion = (0, $690ea4adad3d4419$export$2e2bcd8739ae039)(theme.motion.reducedMotion, false);
    const { center: centerProp = false, classes: classes = $9666667bf3905aaf$var$EMPTY_OBJ, className: className, ...other } = props;
    // Store ripples as data so we can keep exiting ripples mounted until their
    // exit animation ends. Ripple calls onExited when it is safe to remove one.
    const [rippleState, setRippleState] = $acw62.useState({
        items: $9666667bf3905aaf$var$EMPTY_ARRAY,
        order: $9666667bf3905aaf$var$EMPTY_ARRAY
    });
    const ripples = rippleState.items;
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    const mountedRef = $acw62.useRef(false);
    (0, $c7290d3883406124$export$2e2bcd8739ae039)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    });
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $943ee333ac0b0d39$export$2e2bcd8739ae039)();
    // Holds delayed touch-start work until the delay expires or touchend forces it to run.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const handleExited = (0, $8f6d6d1b1fb64725$export$2e2bcd8739ae039)((key)=>{
        if (!mountedRef.current) return;
        setRippleState((prevState)=>{
            const nextItems = prevState.items.filter((ripple)=>ripple.key !== key);
            const nextOrder = $9666667bf3905aaf$var$mergeRippleOrder(prevState.order.filter((rippleKey)=>rippleKey !== key), nextItems.filter((ripple)=>!ripple.exiting).map((ripple)=>ripple.key));
            return {
                items: nextItems,
                order: nextOrder
            };
        });
    });
    const startCommit = (0, $8f6d6d1b1fb64725$export$2e2bcd8739ae039)((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        const key = nextKey.current;
        nextKey.current += 1;
        setRippleState((prevState)=>{
            const nextItems = [
                ...prevState.items,
                {
                    key: key,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize,
                    exiting: false
                }
            ];
            return {
                items: nextItems,
                order: $9666667bf3905aaf$var$mergeRippleOrder(prevState.order, nextItems.filter((ripple)=>!ripple.exiting).map((ripple)=>ripple.key))
            };
        });
        rippleCallback.current = cb;
    });
    const start = (0, $8f6d6d1b1fb64725$export$2e2bcd8739ae039)((event = $9666667bf3905aaf$var$EMPTY_OBJ, options = $9666667bf3905aaf$var$EMPTY_OBJ, cb = $9666667bf3905aaf$var$NOOP)=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // Used only by tests.
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const { rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize } = $9666667bf3905aaf$var$computeRippleState({
            event: event,
            element: element,
            center: center
        });
        // Delay touch ripples so scroll gestures do not flash a ripple.
        if (event?.touches) // Ignore extra touchstart events from multi-touch. There is only one
        // delayed start callback to clear on unmount.
        {
            if (startTimerCommit.current === null) {
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                startTimer.start($9666667bf3905aaf$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    });
    const pulsate = (0, $8f6d6d1b1fb64725$export$2e2bcd8739ae039)(()=>{
        start($9666667bf3905aaf$var$EMPTY_OBJ, {
            pulsate: true
        });
    });
    const stop = (0, $8f6d6d1b1fb64725$export$2e2bcd8739ae039)((event, cb)=>{
        startTimer.clear();
        // If touch ends before the delay finishes, show the ripple now and stop it
        // on the next tick so the user still gets feedback.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRippleState((prevState)=>{
            const firstActiveIndex = prevState.items.findIndex((ripple)=>!ripple.exiting);
            if (firstActiveIndex === -1) return prevState;
            const nextItems = prevState.items.slice();
            nextItems[firstActiveIndex] = {
                ...nextItems[firstActiveIndex],
                exiting: true
            };
            return {
                items: nextItems,
                order: $9666667bf3905aaf$var$mergeRippleOrder(prevState.order, nextItems.filter((ripple)=>!ripple.exiting).map((ripple)=>ripple.key))
            };
        });
        rippleCallback.current = cb;
    });
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    const rippleByKey = new Map(ripples.map((ripple)=>[
            ripple.key,
            ripple
        ]));
    const orderedRipples = rippleState.order.map((rippleKey)=>rippleByKey.get(rippleKey)).filter(Boolean);
    // Keep the old react-transition-group DOM order:
    // exiting ripples stay in place, and new ripples are inserted before the
    // final group waiting for its exit animation to finish.
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9666667bf3905aaf$export$f6b7418508c72c25, {
        className: (0, $bbzhi.default)((0, $50b75803a315b395$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: orderedRipples.map((ripple)=>/*#__PURE__*/ (0, $ayMG0.jsx)($9666667bf3905aaf$export$676cfe7b12693c4b, {
                classes: {
                    ripple: (0, $bbzhi.default)(classes.ripple, (0, $50b75803a315b395$export$2e2bcd8739ae039).ripple),
                    rippleVisible: (0, $bbzhi.default)(classes.rippleVisible, (0, $50b75803a315b395$export$2e2bcd8739ae039).rippleVisible),
                    ripplePulsate: (0, $bbzhi.default)(classes.ripplePulsate, (0, $50b75803a315b395$export$2e2bcd8739ae039).ripplePulsate),
                    child: (0, $bbzhi.default)(classes.child, (0, $50b75803a315b395$export$2e2bcd8739ae039).child),
                    childLeaving: (0, $bbzhi.default)(classes.childLeaving, (0, $50b75803a315b395$export$2e2bcd8739ae039).childLeaving),
                    childPulsate: (0, $bbzhi.default)(classes.childPulsate, (0, $50b75803a315b395$export$2e2bcd8739ae039).childPulsate)
                },
                timeout: reducedMotion.shouldReduceMotion ? 0 : $9666667bf3905aaf$var$DURATION,
                pulsate: ripple.pulsate,
                rippleX: ripple.rippleX,
                rippleY: ripple.rippleY,
                rippleSize: ripple.rippleSize,
                in: !ripple.exiting,
                onExited: ()=>handleExited(ripple.key)
            }, ripple.key))
    });
});
var $9666667bf3905aaf$export$2e2bcd8739ae039 = $9666667bf3905aaf$var$TouchRipple;




function $91e8728ecad24cd6$export$fccb0498dcd99783(slot) {
    return (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $91e8728ecad24cd6$var$buttonBaseClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $91e8728ecad24cd6$export$2e2bcd8739ae039 = $91e8728ecad24cd6$var$buttonBaseClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $38933340941a37bd$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, suppressFocusVisible: suppressFocusVisible, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && !suppressFocusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $35c034932912ab1a$export$2e2bcd8739ae039)(slots, (0, $91e8728ecad24cd6$export$fccb0498dcd99783), classes);
    if (focusVisible && !suppressFocusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $38933340941a37bd$export$7ec0dcc5e3cdcd36 = (0, $8db793a053de590e$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        WebkitTapHighlightColor: 'transparent',
        backgroundColor: 'transparent',
        // Reset default value
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        border: 0,
        margin: 0,
        // Remove the margin in Safari
        borderRadius: 0,
        padding: 0,
        // Remove the padding in Firefox
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        textDecoration: 'none',
        // So we take precedent over the style of a native <a /> element.
        color: 'inherit',
        '&::-moz-focus-inner': {
            borderStyle: 'none' // Remove Firefox dotted outline.
        },
        [`&.${(0, $91e8728ecad24cd6$export$2e2bcd8739ae039).disabled}`]: {
            pointerEvents: 'none',
            // Disable link interactions
            cursor: 'default'
        },
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            {
                props: {
                    internalDisabledThemeFocusVisible: false
                },
                style: theme.focusVisible && {
                    ...(0, $f04e4215bb760f30$export$2f2afcd9b20384c7),
                    [`&.${(0, $91e8728ecad24cd6$export$2e2bcd8739ae039).focusVisible}`]: theme.focusVisible
                }
            }
        ]
    })));
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $38933340941a37bd$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $dea052643d4c0260$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, focusableWhenDisabled: /* eslint-disable react/prop-types */ // replaces internal handling in Chip, other components can opt-in individually to use this in the future
    focusableWhenDisabled, suppressFocusVisible: // escape hatch to suppress the focusVisible state and callback
    // used by anchored <Menu>s to to suppress focus visible styling when opened with a pointer
    suppressFocusVisible = false, // private prop to allow native vs non-native button props to be resolved before mount
    internalNativeButton: internalNativeButtonProp, internalDisabledThemeFocusVisible: // private prop to let a parent (like SwitchBase) control its own focus visible style
    internalDisabledThemeFocusVisible = false, LinkComponent: /* eslint-enable react/prop-types */ LinkComponent = 'a', nativeButton: nativeButtonProp, onBlur: onBlur, onClick: onClickProp, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDownProp, onKeyUp: onKeyUpProp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const isLink = Boolean(other.href || other.to);
    const hasFormAction = Boolean(other.formAction);
    let ComponentProp = component;
    if (ComponentProp === 'button' && isLink) ComponentProp = LinkComponent;
    const internalNativeButton = typeof ComponentProp === 'string' ? ComponentProp === 'button' : internalNativeButtonProp ?? false;
    const nativeButton = nativeButtonProp ?? internalNativeButton;
    const ripple = (0, $0f53385e86c81037$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $a4c63a8573c104c9$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if ((disabled || suppressFocusVisible) && focusVisible) setFocusVisible(false);
    const handleBeforeKeyDown = (0, $8f6d6d1b1fb64725$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
    });
    const handleBeforeKeyUp = (0, $8f6d6d1b1fb64725$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
    });
    const { getButtonProps: getButtonProps, rootRef: buttonRef } = (0, $1d9d08178069f598$export$2e2bcd8739ae039)({
        nativeButton: nativeButton,
        nativeButtonProp: nativeButtonProp,
        internalNativeButton: internalNativeButton,
        allowInferredHostMismatch: isLink || typeof ComponentProp === 'string',
        disabled: disabled,
        type: type,
        hasFormAction: hasFormAction,
        tabIndex: tabIndex,
        onBeforeKeyDown: handleBeforeKeyDown,
        onBeforeKeyUp: handleBeforeKeyUp
    });
    const { onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, ...buttonProps } = getButtonProps({
        onClick: onClickProp,
        onKeyDown: onKeyDownProp,
        onKeyUp: onKeyUpProp
    });
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), [
        buttonRef
    ]);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $38933340941a37bd$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $38933340941a37bd$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $38933340941a37bd$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $38933340941a37bd$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $38933340941a37bd$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $38933340941a37bd$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $38933340941a37bd$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $38933340941a37bd$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $38933340941a37bd$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $3365c1d14c19e0cb$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $8f6d6d1b1fb64725$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/react/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if (!suppressFocusVisible && (0, $3365c1d14c19e0cb$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const linkProps = {};
    if (isLink) {
        linkProps.tabIndex = disabled ? -1 : tabIndex;
        if (disabled) linkProps['aria-disabled'] = disabled;
        linkProps.type = type;
    }
    const handleRef = (0, $a4c63a8573c104c9$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        suppressFocusVisible: suppressFocusVisible,
        tabIndex: tabIndex,
        focusVisible: focusVisible,
        internalDisabledThemeFocusVisible: internalDisabledThemeFocusVisible
    };
    const classes = $38933340941a37bd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($38933340941a37bd$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $bbzhi.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        ...isLink ? linkProps : buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9666667bf3905aaf$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $38933340941a37bd$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $8f6d6d1b1fb64725$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $38933340941a37bd$export$2e2bcd8739ae039 = $38933340941a37bd$var$ButtonBase;





function $dce02d62fd0229da$export$e2cfa0ca4bce1fc2(slot) {
    return (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)('MuiFab', slot);
}
const $dce02d62fd0229da$var$fabClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiFab', [
    'root',
    'primary',
    'secondary',
    'extended',
    'circular',
    'focusVisible',
    'disabled',
    'colorInherit',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'info',
    'error',
    'warning',
    'success'
]);
var $dce02d62fd0229da$export$2e2bcd8739ae039 = $dce02d62fd0229da$var$fabClasses;







const $f970d0842aa7970f$export$214b055320e0bf32 = {
    transition: 'none'
};
function $f970d0842aa7970f$export$3f1342cbd4bf84cc(reducedMotion, styles) {
    if (reducedMotion === 'always') return styles;
    if (reducedMotion === 'system') return {
        '@media (prefers-reduced-motion: reduce)': styles
    };
    return null;
}


const $15daad8b5d50a21c$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
const $15daad8b5d50a21c$var$DEFAULT_TRANSLATE_OFFSET = {
    offsetX: 0,
    offsetY: 0
};
const $15daad8b5d50a21c$var$EMPTY_STYLE = {};
const $15daad8b5d50a21c$var$DEFAULT_TRANSITION_PROPS = [
    'all'
];
const $15daad8b5d50a21c$var$EMPTY_OPTIONS = {};
const $15daad8b5d50a21c$var$transformOffsetIndexes = {
    matrix: [
        4,
        5
    ],
    matrix3d: [
        12,
        13
    ],
    translate: [
        0,
        1
    ],
    translate3d: [
        0,
        1
    ],
    translateX: [
        0,
        null
    ],
    translateY: [
        null,
        0
    ]
};
function $15daad8b5d50a21c$var$parseTranslateValue(value) {
    const parsedValue = parseFloat(value ?? '');
    return Number.isNaN(parsedValue) ? 0 : parsedValue;
}
function $15daad8b5d50a21c$var$parseTransform(transform) {
    const match = transform.match(/^(matrix|matrix3d|translate|translate3d|translateX|translateY)\((.+)\)$/);
    if (!match) return null;
    return {
        type: match[1],
        values: match[2].split(',').map($15daad8b5d50a21c$var$parseTranslateValue)
    };
}
function $15daad8b5d50a21c$var$getTranslateOffsetValue(values, index) {
    return index === null ? 0 : values[index] || 0;
}
function $15daad8b5d50a21c$export$23d6f784a708ab33(transform) {
    if (!transform || transform === 'none') return $15daad8b5d50a21c$var$DEFAULT_TRANSLATE_OFFSET;
    const parsedTransform = $15daad8b5d50a21c$var$parseTransform(transform);
    if (!parsedTransform) return $15daad8b5d50a21c$var$DEFAULT_TRANSLATE_OFFSET;
    const { type: type, values: values } = parsedTransform;
    const offsetIndexes = $15daad8b5d50a21c$var$transformOffsetIndexes[type];
    if (!offsetIndexes) return $15daad8b5d50a21c$var$DEFAULT_TRANSLATE_OFFSET;
    return {
        offsetX: $15daad8b5d50a21c$var$getTranslateOffsetValue(values, offsetIndexes[0]),
        offsetY: $15daad8b5d50a21c$var$getTranslateOffsetValue(values, offsetIndexes[1])
    };
}
function $15daad8b5d50a21c$export$da8da2b45a650a33(nodeRef, callback) {
    return (maybeIsAppearing)=>{
        if (callback) {
            const node = nodeRef.current;
            // Enter callbacks receive isAppearing; exit callbacks do not.
            if (maybeIsAppearing === undefined) callback(node);
            else callback(node, maybeIsAppearing);
        }
    };
}
function $15daad8b5d50a21c$export$c1e03ca92f01ef32(state, inProp, baseStyles, hiddenStyles, styleProp, childStyle) {
    const base = state === 'exited' && !inProp ? hiddenStyles : baseStyles[state] || baseStyles.exited;
    return styleProp || childStyle ? {
        ...base,
        ...styleProp,
        ...childStyle
    } : base;
}
function $15daad8b5d50a21c$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = $15daad8b5d50a21c$var$EMPTY_STYLE } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}
function $15daad8b5d50a21c$export$4bc2c89b8b366948(theme, styles) {
    const resolvedStyles = styles ?? (0, $f970d0842aa7970f$export$214b055320e0bf32);
    return (0, $f970d0842aa7970f$export$3f1342cbd4bf84cc)(theme.motion?.reducedMotion, resolvedStyles);
}
function $15daad8b5d50a21c$export$cfbcd9a4c0ed32ac(theme, props = $15daad8b5d50a21c$var$DEFAULT_TRANSITION_PROPS, options = $15daad8b5d50a21c$var$EMPTY_OPTIONS) {
    const transition = theme.transitions?.create?.(props, options);
    const reducedMotionStyles = $15daad8b5d50a21c$export$4bc2c89b8b366948(theme);
    if (transition === undefined) return reducedMotionStyles ?? $15daad8b5d50a21c$var$EMPTY_STYLE;
    const transitionStyles = {
        transition: transition
    };
    return reducedMotionStyles ? {
        ...transitionStyles,
        ...reducedMotionStyles
    } : transitionStyles;
}



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $59555d5116bb5817$var$useUtilityClasses = (ownerState)=>{
    const { color: color, variant: variant, classes: classes, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `size${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(size)}`,
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    const composedClasses = (0, $35c034932912ab1a$export$2e2bcd8739ae039)(slots, (0, $dce02d62fd0229da$export$e2cfa0ca4bce1fc2), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $59555d5116bb5817$var$FabRoot = (0, $8db793a053de590e$export$2e2bcd8739ae039)((0, $38933340941a37bd$export$2e2bcd8739ae039), {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $7a1c3fb4f5a2134c$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.button,
        minHeight: 36,
        ...(0, $15daad8b5d50a21c$export$cfbcd9a4c0ed32ac)(theme, [
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.grey[900] : theme.palette.getContrastText?.(theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        },
        [`&.${(0, $dce02d62fd0229da$export$2e2bcd8739ae039).focusVisible}`]: {
            ...theme.focusVisible,
            boxShadow: theme.focusVisible?.boxShadow ? `${(theme.vars || theme).shadows[6]}, ${theme.focusVisible.boxShadow}` : (theme.vars || theme).shadows[6]
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    width: 40,
                    height: 40
                }
            },
            {
                props: {
                    size: 'medium'
                },
                style: {
                    width: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended'
                },
                style: {
                    borderRadius: 24,
                    padding: '0 16px',
                    width: 'auto',
                    minHeight: 'auto',
                    minWidth: 48,
                    height: 48
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'small'
                },
                style: {
                    width: 'auto',
                    padding: '0 8px',
                    borderRadius: 17,
                    minWidth: 34,
                    height: 34
                }
            },
            {
                props: {
                    variant: 'extended',
                    size: 'medium'
                },
                style: {
                    width: 'auto',
                    padding: '0 16px',
                    borderRadius: 20,
                    minWidth: 40,
                    height: 40
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            }
        ]
    })), (0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            ...Object.entries(theme.palette).filter((0, $7ca0839ce26bd7d8$export$2e2bcd8739ae039)([
                'dark',
                'contrastText'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].contrastText,
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        '&:hover': {
                            backgroundColor: (theme.vars || theme).palette[color].dark,
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    })), (0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $dce02d62fd0229da$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    })));
const $59555d5116bb5817$var$Fab = /*#__PURE__*/ $acw62.forwardRef(function Fab(inProps, ref) {
    const props = (0, $dea052643d4c0260$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFab'
    });
    const { children: children, className: className, color: color = 'default', component: component = 'button', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, focusVisibleClassName: focusVisibleClassName, size: size = 'large', variant: variant = 'circular', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    };
    const classes = $59555d5116bb5817$var$useUtilityClasses(ownerState);
    // Don't forward the 'root' class to the ButtonBase, as it will get duplicated with the one passed to the className prop.
    const { root: root, ...forwardedClasses } = classes;
    return /*#__PURE__*/ (0, $ayMG0.jsx)($59555d5116bb5817$var$FabRoot, {
        className: (0, $bbzhi.default)(classes.root, className),
        component: component,
        internalNativeButton: true,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $bbzhi.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref,
        ...other,
        classes: forwardedClasses,
        children: children
    });
});
var $59555d5116bb5817$export$2e2bcd8739ae039 = $59555d5116bb5817$var$Fab;




var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");



var $acw62 = parcelRequire("acw62");
'use client';
let $b036ad62e71ad11e$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $b036ad62e71ad11e$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $b036ad62e71ad11e$var$globalId += 1;
            // eslint-disable-next-line react-hooks/set-state-in-effect
            setDefaultId(`mui-${$b036ad62e71ad11e$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $b036ad62e71ad11e$var$safeReact = {
    ...$acw62
};
const $b036ad62e71ad11e$var$maybeReactUseId = $b036ad62e71ad11e$var$safeReact.useId;
function $b036ad62e71ad11e$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($b036ad62e71ad11e$var$maybeReactUseId !== undefined) {
        const reactId = $b036ad62e71ad11e$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $b036ad62e71ad11e$var$useGlobalId(idOverride);
}


'use client';
var $ad13bc6cb8c7b79b$export$2e2bcd8739ae039 = (0, $b036ad62e71ad11e$export$2e2bcd8739ae039);








var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");










function $c701c1311056938c$export$29cad1383b3f235d(slot) {
    return (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $c701c1311056938c$var$circularProgressClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDisableShrink'
]);
var $c701c1311056938c$export$2e2bcd8739ae039 = $c701c1311056938c$var$circularProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f08b65503be1914c$var$SIZE = 44;
let $f08b65503be1914c$var$warnedMinMaxWithoutVariant = false;
let $f08b65503be1914c$var$warnedInvalidMinMaxValue = false;
function $f08b65503be1914c$export$36f40a3150c2c3a2() {
    $f08b65503be1914c$var$warnedMinMaxWithoutVariant = false;
    $f08b65503be1914c$var$warnedInvalidMinMaxValue = false;
}
const $f08b65503be1914c$var$circularRotateKeyframe = (0, $c4732f3462dc01c7$exports.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $f08b65503be1914c$var$circularDashKeyframe = (0, $c4732f3462dc01c7$exports.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $f08b65503be1914c$var$rotateAnimation = typeof $f08b65503be1914c$var$circularRotateKeyframe !== 'string' ? (0, $c4732f3462dc01c7$exports.css)`
        animation: ${$f08b65503be1914c$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $f08b65503be1914c$var$dashAnimation = typeof $f08b65503be1914c$var$circularDashKeyframe !== 'string' ? (0, $c4732f3462dc01c7$exports.css)`
        animation: ${$f08b65503be1914c$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $f08b65503be1914c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $35c034932912ab1a$export$2e2bcd8739ae039)(slots, (0, $c701c1311056938c$export$29cad1383b3f235d), classes);
};
const $f08b65503be1914c$var$CircularProgressRoot = (0, $8db793a053de590e$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const reducedMotionAnimationStyles = (0, $15daad8b5d50a21c$export$4bc2c89b8b366948)(theme, {
        animation: 'none'
    });
    return {
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    ...(0, $15daad8b5d50a21c$export$cfbcd9a4c0ed32ac)(theme, 'transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $f08b65503be1914c$var$rotateAnimation || {
                    animation: `${$f08b65503be1914c$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...reducedMotionAnimationStyles ? [
                {
                    props: {
                        variant: 'indeterminate'
                    },
                    style: reducedMotionAnimationStyles
                }
            ] : [],
            ...Object.entries(theme.palette).filter((0, $7ca0839ce26bd7d8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    };
}));
const $f08b65503be1914c$var$CircularProgressSVG = (0, $8db793a053de590e$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $f08b65503be1914c$var$CircularProgressCircle = (0, $8db793a053de590e$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const reducedMotionAnimationStyles = (0, $15daad8b5d50a21c$export$4bc2c89b8b366948)(theme, {
        animation: 'none'
    });
    return {
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    ...(0, $15daad8b5d50a21c$export$cfbcd9a4c0ed32ac)(theme, 'stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine while waiting for the animation to kick in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $f08b65503be1914c$var$dashAnimation || {
                    // At runtime for Pigment CSS, `dashAnimation` will be null and the generated keyframe will be used.
                    animation: `${$f08b65503be1914c$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            },
            ...reducedMotionAnimationStyles ? [
                {
                    props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                    style: reducedMotionAnimationStyles
                }
            ] : []
        ]
    };
}));
const $f08b65503be1914c$var$CircularProgressTrack = (0, $8db793a053de590e$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $f08b65503be1914c$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $dea052643d4c0260$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, min: minProp, max: maxProp, size: size = 40, style: style, thickness: thickness = 3.6, value: value = props.min ?? 0, variant: variant = 'indeterminate', ...other } = props;
    const min = minProp ?? 0;
    const max = maxProp ?? 100;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    };
    const classes = $f08b65503be1914c$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($f08b65503be1914c$var$SIZE - thickness) / 2);
        const range = max - min;
        circleStyle.strokeDasharray = circumference.toFixed(3);
        circleStyle.strokeDashoffset = range > 0 ? `${((max - value) / range * circumference).toFixed(3)}px` : `${circumference.toFixed(3)}px`; // empty-state fallback when range is invalid
        rootStyle.transform = 'rotate(-90deg)';
        rootProps['aria-valuenow'] = value;
        rootProps['aria-valuemin'] = min;
        rootProps['aria-valuemax'] = max;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)($f08b65503be1914c$var$CircularProgressRoot, {
        className: (0, $bbzhi.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)($f08b65503be1914c$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$f08b65503be1914c$var$SIZE / 2} ${$f08b65503be1914c$var$SIZE / 2} ${$f08b65503be1914c$var$SIZE} ${$f08b65503be1914c$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $ayMG0.jsx)($f08b65503be1914c$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $f08b65503be1914c$var$SIZE,
                    cy: $f08b65503be1914c$var$SIZE,
                    r: ($f08b65503be1914c$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $ayMG0.jsx)($f08b65503be1914c$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $f08b65503be1914c$var$SIZE,
                    cy: $f08b65503be1914c$var$SIZE,
                    r: ($f08b65503be1914c$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    });
});
var $f08b65503be1914c$export$2e2bcd8739ae039 = $f08b65503be1914c$var$CircularProgress;






function $1b8c21b9dd18b4a4$export$5a6f9035944c8119(slot) {
    return (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $1b8c21b9dd18b4a4$var$buttonClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'outlined',
    'contained',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $1b8c21b9dd18b4a4$export$2e2bcd8739ae039 = $1b8c21b9dd18b4a4$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $cbfac45d16885511$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $cbfac45d16885511$export$2e2bcd8739ae039 = $cbfac45d16885511$var$ButtonGroupContext;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $605c7af98b3ea417$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $605c7af98b3ea417$export$2e2bcd8739ae039 = $605c7af98b3ea417$var$ButtonGroupButtonContext;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $74f46a6b1cd0d699$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `size${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon'
        ],
        endIcon: [
            'icon',
            'endIcon'
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $35c034932912ab1a$export$2e2bcd8739ae039)(slots, (0, $1b8c21b9dd18b4a4$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $74f46a6b1cd0d699$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $74f46a6b1cd0d699$var$ButtonRoot = (0, $8db793a053de590e$export$2e2bcd8739ae039)((0, $38933340941a37bd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7a1c3fb4f5a2134c$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        ...(0, $15daad8b5d50a21c$export$cfbcd9a4c0ed32ac)(theme, [
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $1b8c21b9dd18b4a4$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $1b8c21b9dd18b4a4$export$2e2bcd8739ae039).focusVisible}`]: {
                        ...theme.focusVisible,
                        boxShadow: theme.focusVisible?.boxShadow ? `${(theme.vars || theme).shadows[6]}, ${theme.focusVisible.boxShadow}` : (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $1b8c21b9dd18b4a4$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $1b8c21b9dd18b4a4$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $7ca0839ce26bd7d8$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1b8c21b9dd18b4a4$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: theme.focusVisible?.boxShadow ?? 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1b8c21b9dd18b4a4$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loading: true,
                    loadingPosition: 'center'
                },
                style: {
                    ...(0, $15daad8b5d50a21c$export$cfbcd9a4c0ed32ac)(theme, [
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $1b8c21b9dd18b4a4$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $74f46a6b1cd0d699$var$ButtonStartIcon = (0, $8db793a053de590e$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        alignItems: 'center',
        marginRight: 8,
        marginLeft: -4,
        '&::before': {
            content: '"\\200b"',
            width: 0,
            overflow: 'hidden'
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    ...(0, $15daad8b5d50a21c$export$cfbcd9a4c0ed32ac)(theme, [
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$74f46a6b1cd0d699$var$commonIconStyles
        ]
    }));
const $74f46a6b1cd0d699$var$ButtonEndIcon = (0, $8db793a053de590e$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    ...(0, $15daad8b5d50a21c$export$cfbcd9a4c0ed32ac)(theme, [
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$74f46a6b1cd0d699$var$commonIconStyles
        ]
    }));
const $74f46a6b1cd0d699$var$ButtonLoadingIndicator = (0, $8db793a053de590e$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $74f46a6b1cd0d699$var$ButtonLoadingIconPlaceholder = (0, $8db793a053de590e$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $74f46a6b1cd0d699$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $cbfac45d16885511$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $605c7af98b3ea417$export$2e2bcd8739ae039));
    const resolvedProps = (0, $cf2644927cba071a$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $dea052643d4c0260$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $ad13bc6cb8c7b79b$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f08b65503be1914c$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $74f46a6b1cd0d699$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $ayMG0.jsx)($74f46a6b1cd0d699$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($74f46a6b1cd0d699$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $ayMG0.jsx)($74f46a6b1cd0d699$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $ayMG0.jsx)($74f46a6b1cd0d699$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $ayMG0.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $ayMG0.jsx)($74f46a6b1cd0d699$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    // Don't forward the 'root' classes to the ButtonBase, as they will get duplicated with the one passed to the className prop.
    const { root: root, ...forwardedClasses } = classes;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($74f46a6b1cd0d699$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $bbzhi.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $bbzhi.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        internalNativeButton: true,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: forwardedClasses,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $74f46a6b1cd0d699$export$2e2bcd8739ae039 = $74f46a6b1cd0d699$var$Button;



var $acw62 = parcelRequire("acw62");

function $b1c6221dc5ca03a3$export$369b6b2b30582e8e(Component) {
    const ComponentWithRouterProp = (props)=>{
        try {
            const [location, navigate] = (0, $9d251f10c54460c1$export$45d76561a5302f2b)();
            let params = (0, $9d251f10c54460c1$export$99eaa27ddbbb95ef)();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, {
                ...props,
                router: {
                    location: location,
                    params: params
                }
            });
        } catch (error) {
            console.error("ERROR (withRouter) " + error);
        //console.error("Component " + Component)
        }
    };
    return ComponentWithRouterProp;
}



var $acw62 = parcelRequire("acw62");

const $60d1f9fc3c259072$export$59d1b06f370beb91 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d251f10c54460c1$export$a6c7ac8248d6e38a), {
        ...props,
        ref: props.ref,
        to: props.to,
        onClick: props.linkAction,
        align: props.alignText || `inherit`
    }, props.children);
};


var $7b0c3699bd9f3c75$export$2e2bcd8739ae039 = (0, $b1c6221dc5ca03a3$export$369b6b2b30582e8e)((0, $60d1f9fc3c259072$export$59d1b06f370beb91));




var $acw62 = parcelRequire("acw62");


var $bbzhi = parcelRequire("bbzhi");












function $d5fd195d31ccd0e8$export$5e8702d71474f093(slot) {
    return (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $d5fd195d31ccd0e8$var$iconButtonClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $d5fd195d31ccd0e8$export$2e2bcd8739ae039 = $d5fd195d31ccd0e8$var$iconButtonClasses;




var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7fd82cc3764507bf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $35c034932912ab1a$export$2e2bcd8739ae039)(slots, (0, $d5fd195d31ccd0e8$export$5e8702d71474f093), classes);
};
const $7fd82cc3764507bf$var$IconButtonRoot = (0, $8db793a053de590e$export$2e2bcd8739ae039)((0, $38933340941a37bd$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $beb7a3ce4e2ae599$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        ...(0, $15daad8b5d50a21c$export$cfbcd9a4c0ed32ac)(theme, 'background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $7ca0839ce26bd7d8$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $d5fd195d31ccd0e8$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $d5fd195d31ccd0e8$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $7fd82cc3764507bf$var$IconButtonLoadingIndicator = (0, $8db793a053de590e$export$2e2bcd8739ae039)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $7fd82cc3764507bf$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $dea052643d4c0260$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $ad13bc6cb8c7b79b$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f08b65503be1914c$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $7fd82cc3764507bf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($7fd82cc3764507bf$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $bbzhi.default)(classes.root, className),
        centerRipple: true,
        internalNativeButton: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $ayMG0.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($7fd82cc3764507bf$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $7fd82cc3764507bf$export$2e2bcd8739ae039 = $7fd82cc3764507bf$var$IconButton;


const $f5ad4a2534b055b5$export$e0d897ee21382f67 = (props)=>{
    const { classes: classes = {}, onHandleClose: onHandleClose, dialogContext: dialogContext, menuDrawerBackButton: menuDrawerBackButton } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f5ad4a2534b055b5$export$8cc203231d44dc6a, {
        "aria-label": "Close",
        positionRelative: true,
        onClick: onHandleClose,
        dialogContext: dialogContext ? dialogContext : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1e6076bb1523d14f$export$2e2bcd8739ae039), {
        fontSize: "small"
    }));
};
const $f5ad4a2534b055b5$export$de65de8213222d10 = (props)=>{
    const { classes: classes = {}, onHandleClose: onHandleClose, dialogContext: dialogContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f5ad4a2534b055b5$export$8cc203231d44dc6a, {
        ariaLabel: "Close",
        positionRelative: true,
        onClick: onHandleClose,
        dialogContext: dialogContext ? dialogContext : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1e6076bb1523d14f$export$2e2bcd8739ae039), {
        fontSize: "small",
        className: classes.scale
    }));
};
const $f5ad4a2534b055b5$export$bd36621ef7814117 = (props)=>{
    const { classes: classes = {}, size: size = "medium", buttonId: buttonId, buttonText: buttonText, buttonColor: buttonColor, buttonIcon: buttonIcon, iconPosition: iconPosition, linkType: linkType, toLocation: toLocation, fullWidth: fullWidth, ...rest } = props;
    if (linkType === 'Link') {
        debugger;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74f46a6b1cd0d699$export$2e2bcd8739ae039), {
            id: buttonId,
            size: size,
            component: (0, $7b0c3699bd9f3c75$export$2e2bcd8739ae039),
            fullWidth: fullWidth,
            variant: "contained",
            color: buttonColor ? buttonColor : 'primary',
            to: toLocation,
            disableFocusRipple: true,
            disableRipple: true,
            style: style,
            disabled: rest.disabled,
            onClick: (e)=>{
                e.stopPropagation();
            }
        }, buttonIcon && iconPosition === 'left' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                marginRight: '8px'
            }
        }, buttonIcon), buttonText, buttonIcon && iconPosition === 'right' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            style: {
                marginLeft: '8px'
            }
        }, buttonIcon));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74f46a6b1cd0d699$export$2e2bcd8739ae039), {
        id: buttonId,
        size: size,
        variant: "contained",
        color: buttonColor ? buttonColor : 'primary',
        disableFocusRipple: true,
        disableRipple: true,
        ...rest
    }, buttonIcon && iconPosition === 'left' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, buttonIcon), buttonText, buttonIcon && iconPosition === 'right' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, buttonIcon));
};
const $f5ad4a2534b055b5$export$b7c3a2f69225ecf = (props)=>{
    const { buttonText: buttonText, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74f46a6b1cd0d699$export$2e2bcd8739ae039), {
        size: "medium",
        ...rest
    }, buttonText);
};
const $f5ad4a2534b055b5$export$8cc203231d44dc6a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function DefaultIconButton(props, ref) {
    const { children: children, classes: classes = {}, className: className, ariaLabel: ariaLabel, color: color = 'default', Icon: Icon, disabled: disabled = false, onClick: onClick, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $7fd82cc3764507bf$export$2e2bcd8739ae039), {
        "aria-label": ariaLabel,
        color: color,
        disabled: disabled,
        onClick: onClick,
        ref: ref
    }, Icon, children);
});
const $f5ad4a2534b055b5$export$f4355fbc0e4e5b09 = (props)=>{
    const { classes: classes = {}, theme: theme, buttonIcon: buttonIcon, buttonActive: buttonActive, buttonContext: buttonContext, NoPositionFixed: NoPositionFixed, Small: Small, ...rest } = props;
    return(//        <Zoom
    //            in={buttonActive}
    //            timeout={transitionDuration}
    //            style={{
    //                transitionDelay: buttonActive ? transitionDuration.exit : 0,
    //            }}
    //            unmountOnExit
    //        >
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $59555d5116bb5817$export$2e2bcd8739ae039), {
        color: "primary",
        "aria-label": "Add",
        disableRipple: true,
        size: Small ? "small" : "medium",
        ...buttonContext,
        ...rest
    }, buttonIcon ? buttonIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0a61069863ccac4a$export$2e2bcd8739ae039), null)));
};
const $f5ad4a2534b055b5$export$f861551692d63a2e = (props)=>{
    const { classes: classes = {}, buttonText: buttonText, buttonColor: buttonColor, linkType: linkType, toLocation: toLocation, fullWidth: fullWidth, ActionBtnLight: ActionBtnLight, onClick: onClick, smallButton: smallButton, publicButton: publicButton, withMargin: withMargin, ...rest } = props;
    if (linkType === 'Link') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74f46a6b1cd0d699$export$2e2bcd8739ae039), {
        component: (0, $7b0c3699bd9f3c75$export$2e2bcd8739ae039),
        fullWidth: fullWidth,
        variant: "outlined",
        color: "primary",
        to: toLocation ? toLocation : null,
        disableRipple: true,
        disableFocusRipple: true,
        ...rest,
        onClick: (e)=>{
            e.stopPropagation();
        }
    }, buttonText);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74f46a6b1cd0d699$export$2e2bcd8739ae039), {
        variant: "outlined",
        color: "primary",
        disableRipple: true,
        disableFocusRipple: true,
        onClick: onClick,
        ...rest
    }, buttonText);
};
const $f5ad4a2534b055b5$export$8b7b7cdfb85d78c5 = (props)=>{
    const { buttonText: buttonText, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $74f46a6b1cd0d699$export$2e2bcd8739ae039), {
        value: buttonText,
        type: "submit",
        variant: "contained",
        disableRipple: true,
        disableFocusRipple: true,
        ...rest
    }, buttonText);
};




var $ayMG0 = parcelRequire("ayMG0");
"use client";
var $ce6d037a019f746e$export$2e2bcd8739ae039 = (0, $3a25e7c693be1153$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $ayMG0.jsx)("path", {
    d: "M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');






'use client';
const $b4c02b4ad9e6ac1d$var$Stack = (0, $c4732f3462dc01c7$exports.createStack)({
    createStyledComponent: (0, $8db793a053de590e$export$2e2bcd8739ae039)('div', {
        name: 'MuiStack',
        slot: 'Root'
    }),
    useThemeProps: (inProps)=>(0, $dea052643d4c0260$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiStack'
        })
});
var $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039 = $b4c02b4ad9e6ac1d$var$Stack;


let $abf1bd3d30df503c$var$now = new Date().getTime();
const $abf1bd3d30df503c$export$79a1817568da084b = ()=>{
    return ++$abf1bd3d30df503c$var$now;
};


const $c9ebfed5efd1ca69$export$c4b8bfc316bde018 = (justifyContent = 'left', alignItems = 'top', proto = {})=>{
    return {
        width: '100%',
        justifyContent: justifyContent,
        alignItems: alignItems,
        ...proto
    };
};


const $c8306bda4a3fa63f$export$ed759d95987e262a = (proto = {
    margin: 1,
    padding: 2
}, horizontal = 'left', vertical = 'center')=>{
    return (0, $c9ebfed5efd1ca69$export$c4b8bfc316bde018)(horizontal, vertical, proto);
};
const $c8306bda4a3fa63f$export$71e0dd387ebc2bb9 = (proto = {
    margin: 1,
    padding: 1
}, horizontal = 'left', vertical = 'center')=>{
    return (0, $c9ebfed5efd1ca69$export$c4b8bfc316bde018)(horizontal, vertical, proto);
};



var $acw62 = parcelRequire("acw62");

var $bbzhi = parcelRequire("bbzhi");


function $1356b4595ed118cb$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $1356b4595ed118cb$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $1356b4595ed118cb$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $1356b4595ed118cb$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $1356b4595ed118cb$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $1356b4595ed118cb$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $1356b4595ed118cb$export$8af1d214c6c2f0f1(length) * $1356b4595ed118cb$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $1356b4595ed118cb$export$8af1d214c6c2f0f1(length) * $1356b4595ed118cb$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $1356b4595ed118cb$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $1356b4595ed118cb$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $1356b4595ed118cb$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $1356b4595ed118cb$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $1356b4595ed118cb$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}








function $c9301a061ee73632$export$c987db9fc844f86(slot) {
    return (0, $cd58bcc8013d55b5$export$2e2bcd8739ae039)('MuiSkeleton', slot);
}
const $c9301a061ee73632$var$skeletonClasses = (0, $c358ff50bb9d0713$export$2e2bcd8739ae039)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $c9301a061ee73632$export$2e2bcd8739ae039 = $c9301a061ee73632$var$skeletonClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $99f6691b26af16b2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $35c034932912ab1a$export$2e2bcd8739ae039)(slots, (0, $c9301a061ee73632$export$c987db9fc844f86), classes);
};
const $99f6691b26af16b2$var$pulseKeyframe = (0, $c4732f3462dc01c7$exports.keyframes)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $99f6691b26af16b2$var$waveKeyframe = (0, $c4732f3462dc01c7$exports.keyframes)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $99f6691b26af16b2$var$pulseAnimation = typeof $99f6691b26af16b2$var$pulseKeyframe !== 'string' ? (0, $c4732f3462dc01c7$exports.css)`
        animation: ${$99f6691b26af16b2$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $99f6691b26af16b2$var$waveAnimation = typeof $99f6691b26af16b2$var$waveKeyframe !== 'string' ? (0, $c4732f3462dc01c7$exports.css)`
        &::after {
          animation: ${$99f6691b26af16b2$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $99f6691b26af16b2$var$SkeletonRoot = (0, $8db793a053de590e$export$2e2bcd8739ae039)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $aa36852ee1337b36$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const radiusUnit = (0, $1356b4595ed118cb$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $1356b4595ed118cb$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    const reducedMotionPulseStyles = (0, $15daad8b5d50a21c$export$4bc2c89b8b366948)(theme, {
        animation: 'none'
    });
    const reducedMotionWaveStyles = (0, $15daad8b5d50a21c$export$4bc2c89b8b366948)(theme, {
        '&::after': {
            animation: 'none',
            display: 'none'
        }
    });
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : theme.alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $99f6691b26af16b2$var$pulseAnimation || {
                    animation: `${$99f6691b26af16b2$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            ...reducedMotionPulseStyles ? [
                {
                    props: {
                        animation: 'pulse'
                    },
                    style: reducedMotionPulseStyles
                }
            ] : [],
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $99f6691b26af16b2$var$waveAnimation || {
                    '&::after': {
                        animation: `${$99f6691b26af16b2$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            },
            ...reducedMotionWaveStyles ? [
                {
                    props: {
                        animation: 'wave'
                    },
                    style: reducedMotionWaveStyles
                }
            ] : []
        ]
    };
}));
const $99f6691b26af16b2$var$Skeleton = /*#__PURE__*/ $acw62.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $dea052643d4c0260$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $99f6691b26af16b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($99f6691b26af16b2$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $bbzhi.default)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $99f6691b26af16b2$export$2e2bcd8739ae039 = $99f6691b26af16b2$var$Skeleton;


const $a44e1c415735d9e7$export$d386e09b4915bbad = ({ heroItemData: heroItemData, options: options })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
        direction: 'column',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abce12fca512444b$export$2e2bcd8739ae039), {
                variant: options.headerVariant,
                color: "textSecondary",
                children: heroItemData["pageTitle"] || heroItemData["label"]
            }),
            $a44e1c415735d9e7$export$570aa515132ce5ca(heroItemData, options)
        ]
    });
};
const $a44e1c415735d9e7$export$b2bf97138f6c7782 = ({ featureData: featureData })=>{
    const options = {
        headerVariant: 'h4',
        itemVariant: 'body2'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
        direction: 'column',
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abce12fca512444b$export$2e2bcd8739ae039), {
                variant: options.headerVariant,
                color: "textSecondary",
                children: featureData["label"]
            }),
            featureData.items && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
                direction: 'column',
                children: $a44e1c415735d9e7$export$dad47fc83ed457fd(featureData.items, options)
            }),
            featureData.links && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
                direction: 'column',
                children: $a44e1c415735d9e7$export$207187e5a9fddade(featureData.links, options)
            })
        ]
    });
};
const $a44e1c415735d9e7$export$dad47fc83ed457fd = (items, options)=>{
    let itemsArray = [];
    for (let item of items){
        const panelId = (0, $abf1bd3d30df503c$export$79a1817568da084b)();
        itemsArray.push(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
            direction: 'row',
            sx: (0, $c8306bda4a3fa63f$export$71e0dd387ebc2bb9)(),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce6d037a019f746e$export$2e2bcd8739ae039), {
                    style: {
                        color: 'gold'
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abce12fca512444b$export$2e2bcd8739ae039), {
                    variant: options.itemVariant,
                    color: "textSecondary",
                    children: item.label
                })
            ]
        }, panelId));
    }
    return itemsArray;
};
const $a44e1c415735d9e7$export$564e40e32a25fb31 = ({ heroItemData: heroItemData })=>{
    const options = {
        headerVariant: 'h3',
        itemVariant: 'h4'
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($a44e1c415735d9e7$export$d386e09b4915bbad, {
        heroItemData: heroItemData,
        options: options
    });
};
const $a44e1c415735d9e7$export$82e11875e9ab9c96 = ({ classes: classes = {}, imageOnLeftData: imageOnLeftData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $77df55c54bbe1a84$export$eb38b3b9c7f5f31b), {
        elevation: 0,
        backgroundColor: "none",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $416354f8df00ef09$export$2e2bcd8739ae039), {
            container: true,
            spacing: 4,
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            children: [
                imageOnLeftData["imgSrc"] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $416354f8df00ef09$export$2e2bcd8739ae039), {
                    xs: 12,
                    md: 6,
                    lg: 5,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: classes.img,
                        src: imageOnLeftData["imgSrc"],
                        alt: imageOnLeftData["imgAlt"]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $416354f8df00ef09$export$2e2bcd8739ae039), {
                    xs: 12,
                    md: 6,
                    lg: 7,
                    style: {},
                    children: $a44e1c415735d9e7$export$570aa515132ce5ca(imageOnLeftData)
                })
            ]
        })
    });
};
const $a44e1c415735d9e7$export$574a2847393be91a = ({ classes: classes = {}, imageOnRightData: imageOnRightData })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $77df55c54bbe1a84$export$eb38b3b9c7f5f31b), {
        elevation: 0,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $416354f8df00ef09$export$2e2bcd8739ae039), {
            container: true,
            spacing: 4,
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $416354f8df00ef09$export$2e2bcd8739ae039), {
                    xs: 12,
                    md: 6,
                    lg: 7,
                    children: $a44e1c415735d9e7$export$570aa515132ce5ca(imageOnRightData)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $416354f8df00ef09$export$2e2bcd8739ae039), {
                    container: true,
                    item: true,
                    xs: 12,
                    md: 6,
                    lg: 5,
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        className: classes.img,
                        src: imageOnRightData["imgSrc"],
                        alt: imageOnRightData["imgAlt"]
                    })
                })
            ]
        })
    });
const $a44e1c415735d9e7$export$95fe23ecedc48a34 = ({ classes: classes = {}, chartOnRightData: chartOnRightData, colorForNode: colorForNode, colorForEdge: colorForEdge, colorScheme: colorScheme })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $77df55c54bbe1a84$export$eb38b3b9c7f5f31b), {
        elevation: 0,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $416354f8df00ef09$export$2e2bcd8739ae039), {
            container: true,
            spacing: 4,
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $416354f8df00ef09$export$2e2bcd8739ae039), {
                    xs: 12,
                    md: 6,
                    lg: 7,
                    children: [
                        chartOnRightData["subHeader"] && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
                            direction: 'column',
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $db804c155843de2a$export$5f1af8db9871e1d6), {
                                component: "p",
                                className: classes.largeMargin,
                                children: chartOnRightData["subHeader"]
                            })
                        }),
                        $a44e1c415735d9e7$export$570aa515132ce5ca(chartOnRightData)
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $416354f8df00ef09$export$2e2bcd8739ae039), {
                    container: true,
                    item: true,
                    xs: 12,
                    md: 6,
                    lg: 5,
                    justifyContent: "center",
                    children: !chartOnRightData.chartSlug ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        width: 480,
                        height: 360,
                        svgElementStyles: {
                            backgroundColor: 'whitesmoke'
                        },
                        colorScheme: colorScheme,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99f6691b26af16b2$export$2e2bcd8739ae039), {
                            variant: "rectangular"
                        })
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        slug: chartOnRightData.chartSlug,
                        colorForNode: colorForNode,
                        colorForEdge: colorForEdge,
                        width: 400,
                        height: 400,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $99f6691b26af16b2$export$2e2bcd8739ae039), {
                            variant: "rectangular"
                        })
                    })
                })
            ]
        })
    });
const $a44e1c415735d9e7$export$570aa515132ce5ca = (itemData, options)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            itemData.items && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
                direction: 'column',
                children: $a44e1c415735d9e7$export$c1f1fc7a5593d7f1(itemData.items, options)
            }),
            itemData.links && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
                direction: 'column',
                children: $a44e1c415735d9e7$export$207187e5a9fddade(itemData.links, options)
            })
        ]
    });
};
const $a44e1c415735d9e7$export$c1f1fc7a5593d7f1 = (items, options)=>{
    let itemsArray = [];
    for (let item of items)itemsArray.push(/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
        direction: 'row',
        sx: (0, $c8306bda4a3fa63f$export$71e0dd387ebc2bb9)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce6d037a019f746e$export$2e2bcd8739ae039), {
                style: {
                    color: 'gold'
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abce12fca512444b$export$2e2bcd8739ae039), {
                variant: options.itemVariant,
                color: "textSecondary",
                children: item.label
            })
        ]
    }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()));
    return itemsArray;
};
// const RenderAccordion = ({item,expanded,content,onClick,options}) => {
//   return (
//     <Accordion expanded={expanded}>
//       <AccordionSummary
//         expandIcon={(
//           <ExpandMoreIcon onClick={onClick} color={'primary'}/>
//         )}
//       ><>
//         <StarIcon style={{color:'gold'}}/>
//         <Typography variant={options.itemVariant} color="textSecondary">{item.label}</Typography>
//       </>
//       </AccordionSummary>
//       <AccordionDetails>
//         {content}
//       </AccordionDetails>
//     </Accordion>
//   )
// }
const $a44e1c415735d9e7$var$makeContent = (item)=>{
    debugger;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
        direction: 'column',
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: "TODO"
        })
    });
};
const $a44e1c415735d9e7$export$207187e5a9fddade = (links, options)=>{
    let itemsArray = [];
    if (links) links.forEach((link)=>{
        itemsArray.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5ad4a2534b055b5$export$bd36621ef7814117), {
            buttonColor: "primary",
            buttonText: `MORE INFO: ${link.label}`,
            onClick: ()=>{
                window.location.href = `${link.to}`;
            }
        }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()));
    });
    return itemsArray;
};


const $a2ced1963f2020ac$var$getFeatureInfo = (featuresData, header, feature)=>{
    for (let featureData of featuresData)if (header === featureData.label) {
        if (featureData.items[feature]) return featureData.items[feature];
    }
    return null;
};
const $a2ced1963f2020ac$export$59a1868353817d77 = ()=>{
    const featuresData = $a2ced1963f2020ac$export$3970600e50b6f58f();
    return {
        "PlanYourProduction": {
            "pageTitle": "PLAN YOUR PRODUCTION",
            "items": [
                {
                    ...$a2ced1963f2020ac$var$getFeatureInfo(featuresData, 'PLANNING AND FORECASTING', 0)
                },
                {
                    ...$a2ced1963f2020ac$var$getFeatureInfo(featuresData, 'PLANNING AND FORECASTING', 1)
                },
                {
                    ...$a2ced1963f2020ac$var$getFeatureInfo(featuresData, 'PLANNING AND FORECASTING', 2)
                }
            ],
            "links": [
                {
                    to: '/how-it-works',
                    label: 'How it works'
                }
            ]
        },
        "MonitorYourProduction": {
            "pageTitle": "MONITOR YOUR PRODUCTION",
            "items": [
                {
                    ...$a2ced1963f2020ac$var$getFeatureInfo(featuresData, 'OPERATIONAL VISIBILITY', 0)
                },
                {
                    ...$a2ced1963f2020ac$var$getFeatureInfo(featuresData, 'OPERATIONAL VISIBILITY', 1)
                },
                {
                    ...$a2ced1963f2020ac$var$getFeatureInfo(featuresData, 'OPERATIONAL VISIBILITY', 2)
                }
            ],
            "links": [
                {
                    to: '/how-it-works',
                    label: 'How it works'
                }
            ]
        }
    };
};
const $a2ced1963f2020ac$export$2c7ff28544e3d1d7 = {
    "Api": {
        "pageTitle": "API",
        "pageTitleSubStr": "",
        "subHeader": "",
        "imgSrc": "/placeholder-min.png",
        "imgAlt": "hero image alt"
    }
};
const $a2ced1963f2020ac$export$4030b2403ee95e0a = {
    "Edge": {
        "pageTitle": "EDGE",
        "pageTitleSubStr": "",
        "subHeader": "",
        "imgSrc": "/placeholder-min.png",
        "imgAlt": "hero image alt"
    }
};
const $a2ced1963f2020ac$export$23b487c0ab1b5bbf = ()=>{
    return [
        {
            label: "PROFESSIONAL",
            items: [
                {
                    label: "ORGANIC PRODUCE",
                    slug: 'case-study-organic-produce'
                },
                {
                    label: "FLOWER GARDEN",
                    slug: 'case-study-flower-garden'
                }
            ]
        },
        {
            label: "RESEARCH AND INDUSTRY",
            items: [
                {
                    label: "SURVEILLANCE",
                    slug: 'case-study-surveillance'
                },
                {
                    label: "BREEDING PROGRAM",
                    slug: 'case-study-breeding-program'
                }
            ]
        },
        {
            label: "CERTIFICATION",
            items: [
                {
                    label: "CERTIFIED ORGANIC",
                    slug: 'case-study-certified-organic'
                },
                {
                    label: "FSSC AND ISO",
                    slug: 'case-study-fssc-and-iso'
                }
            ]
        }
    ];
};
const $a2ced1963f2020ac$export$3970600e50b6f58f = ()=>{
    return [
        {
            label: "INFRASTRUCTURE AND APPLICATION ARCHITECTURE",
            links: [
                {
                    to: '/how-it-works',
                    label: 'HOW IT WORKS'
                }
            ],
            items: [
                {
                    label: "Stateless, event-driven, asynchronous and near-realtime system design"
                },
                {
                    label: "Multi, whitelisted and single tenant support"
                }
            ]
        },
        {
            label: "SECURITY AND IDENTITY",
            links: [
                {
                    to: '/policy/ace-policy-security',
                    label: 'SECURITY POLICY'
                }
            ],
            items: [
                {
                    label: "Passwordless Authentication (MFA, Gmail, Microsoft, Apple)"
                },
                {
                    label: "Multi-tenant isolation (Individual data partitions/layers)"
                }
            ]
        },
        {
            label: "SCALE AND DEPLOYMENT",
            links: [],
            items: [
                {
                    label: "Apex scale-unit density"
                },
                {
                    label: "Planetary-scale delivery strategies"
                },
                {
                    label: "On-prem/Cloud hybrid flexibility"
                }
            ]
        },
        {
            label: "PLANNING AND FORECASTING",
            links: [
                {
                    to: '/resource/ace-guide-forecasting',
                    label: 'AUTO: Forecasting'
                },
                {
                    to: '/resource/ace-guide-successions-and-lots',
                    label: 'AUTO: Successions and Lots'
                }
            ],
            items: [
                {
                    label: "Multi-site Production Planning Tools"
                },
                {
                    label: "Dynamic Production Calendars"
                },
                {
                    label: "Production and Consumption forecast tools"
                },
                {
                    label: "KPI forecasting"
                }
            ]
        },
        {
            label: "OPERATIONAL VISIBILITY",
            links: [
                {
                    to: '/resource/ace-guide-reporting',
                    label: 'AUTO: Reporting'
                },
                {
                    to: '/resource/vendors-guide-reporting',
                    label: 'VENDORS: Reporting'
                }
            ],
            items: [
                {
                    label: "Live KPI indicators"
                },
                {
                    label: "Traceability and Compliance"
                },
                {
                    label: "Comprehensive Reporting"
                }
            ]
        },
        {
            label: "CONNECTIVITY",
            links: [],
            items: [
                {
                    label: "IOT Integration"
                },
                {
                    label: "On-prem Edge Services"
                }
            ]
        },
        {
            label: "INTEGRATION AND EDGE",
            links: [],
            items: [
                {
                    label: "Site-specific agents (Germination, Propagation, Cultivation)"
                },
                {
                    label: "Real-time data-point collection for sensor readings"
                }
            ]
        },
        {
            label: "AI INTEROPERABILITY",
            links: [
                {
                    to: '/policy/ace-policy-ai',
                    label: 'AI POLICY'
                }
            ],
            items: [
                {
                    label: "AI Agent friendly APIs "
                },
                {
                    label: "Structured metadata and semantics"
                }
            ]
        },
        {
            label: "APIs AND SYSTEM DESIGN",
            links: [
                {
                    to: '/api',
                    label: 'API'
                },
                {
                    to: '/resource/ace-guide-adoption',
                    label: 'Adoption'
                }
            ],
            items: [
                {
                    label: "Open and platform-agnostic APIs"
                },
                {
                    label: "Decouple your technology selections from unified production planning"
                },
                {
                    label: "Formal and straightforward specifications for system integration"
                }
            ]
        },
        {
            label: "COMPLIANCE AND CERTIFICATION SUPPORT",
            links: [
                {
                    to: '/case-study/case-study-certified-organic',
                    label: 'CASE STUDY: Certified Organic'
                },
                {
                    to: '/case-study/case-study-fssc-and-iso',
                    label: 'CASE STUDY: FSSC and ISO'
                }
            ],
            items: [
                {
                    label: "Data collection for certifications (Organic, FoodSafety, Pharmaceutical)"
                }
            ]
        },
        {
            label: "DOCUMENTATION AND RESOURCES",
            links: [
                {
                    to: '/resources',
                    label: 'RESOURCES'
                }
            ],
            items: [
                {
                    label: "Formal specifications and usage resources"
                }
            ]
        },
        {
            label: "STARTER KITS",
            links: [],
            items: [
                {
                    label: "Pre-configured hardware/software bundles for quick adoption"
                }
            ]
        }
    ];
};
const $a2ced1963f2020ac$export$9b13459b7e2ecabb = ()=>{
    return [
        {
            label: "GETTING STARTED",
            type: 'GUIDE',
            product: 'AUTO',
            slug: 'ace-guide-getting-started'
        },
        {
            label: "ADOPTION",
            type: 'GUIDE',
            product: 'AUTO',
            slug: 'ace-guide-adoption'
        },
        {
            label: "SITES AND CONFIGURATIONS",
            type: 'GUIDE',
            product: 'AUTO',
            slug: 'ace-guide-sites-and-configurations'
        },
        {
            label: "DISPENSARY",
            type: 'GUIDE',
            product: 'AUTO',
            slug: 'ace-guide-dispensary'
        },
        {
            label: "SUCCESSIONS AND LOTS",
            type: 'GUIDE',
            product: 'AUTO',
            slug: 'ace-guide-successions-and-lots'
        },
        {
            label: "FORECASTING",
            type: 'GUIDE',
            product: 'AUTO',
            slug: 'ace-guide-forecasting'
        },
        {
            label: "REPORTING",
            type: 'GUIDE',
            product: 'AUTO',
            slug: 'ace-guide-reporting'
        },
        {
            label: "VENDORS",
            type: 'GUIDE',
            product: 'AUTO',
            slug: 'ace-guide-vendors'
        },
        {
            label: "PROGRAMS",
            type: 'GUIDE',
            product: 'VENDORS',
            slug: 'vendors-guide-programs'
        },
        {
            label: "PLACEMENTS",
            type: 'GUIDE',
            product: 'VENDORS',
            slug: 'vendors-guide-placements'
        },
        {
            label: "FORECASTING",
            type: 'GUIDE',
            product: 'VENDORS',
            slug: 'vendors-guide-forecasting'
        },
        {
            label: "REPORTING",
            type: 'GUIDE',
            product: 'VENDORS',
            slug: 'vendors-guide-reporting'
        }
    ];
};



const $c510ec29b95de388$export$c4b8bfc316bde018 = (justifyContent = 'left', alignItems = 'top', proto = {})=>{
    return {
        width: '100%',
        justifyContent: justifyContent,
        alignItems: alignItems,
        ...proto
    };
};


const $9e9fedce756d888e$var$frontPageData = (0, $a2ced1963f2020ac$export$59a1868353817d77)();
const $9e9fedce756d888e$export$b5f68eb8cbd40cd5 = ({})=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: "column",
                sx: (0, $c510ec29b95de388$export$c4b8bfc316bde018)('center', 'center'),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                            variant: "h6",
                            children: "BETA PROGRAM"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $245879af6017e1c1$export$bd36621ef7814117), {
                            buttonColor: "primary",
                            buttonText: 'ENQUIRE',
                            onClick: ()=>{
                                window.location.href = `/enquiry`;
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'column',
                sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a44e1c415735d9e7$export$564e40e32a25fb31), {
                    heroItemData: $9e9fedce756d888e$var$frontPageData["PlanYourProduction"]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'column',
                sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a44e1c415735d9e7$export$564e40e32a25fb31), {
                    heroItemData: $9e9fedce756d888e$var$frontPageData["MonitorYourProduction"]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'column',
                sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "SELECTED CASE STUDIES"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $245879af6017e1c1$export$bd36621ef7814117), {
                        buttonColor: "primary",
                        buttonText: 'VIEW ALL CASE STUDIES',
                        onClick: ()=>{
                            window.location.href = `/resources#caseStudies`;
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'column',
                sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: "SELECTED GUIDES"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $245879af6017e1c1$export$bd36621ef7814117), {
                        buttonColor: "primary",
                        buttonText: 'VIEW ALL GUIDES',
                        onClick: ()=>{
                            window.location.href = `/resources#guides`;
                        }
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $da943955a1ce66e1$export$d691fcbf87f401db = ({ label: label, name: name })=>// <TextField
    //   label={label}
    //   name={name}
    // />
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, "TODO TextField not JSX");



var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $acw62 = parcelRequire("acw62");

var $8nd05 = parcelRequire("8nd05");

var $7f17f1906b9f3211$var$charCodeOfDot = ".".charCodeAt(0);
var $7f17f1906b9f3211$var$reEscapeChar = /\\(\\)?/g;
var $7f17f1906b9f3211$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $7f17f1906b9f3211$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $7f17f1906b9f3211$var$charCodeOfDot) result.push("");
    string.replace($7f17f1906b9f3211$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($7f17f1906b9f3211$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
        return "";
    });
    return result;
};
var $7f17f1906b9f3211$var$keysCache = Object.create(null);
var $7f17f1906b9f3211$var$keysRegex = /[.[\]]+/;
var $7f17f1906b9f3211$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($7f17f1906b9f3211$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $7f17f1906b9f3211$var$keysCache[key] = key.split($7f17f1906b9f3211$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $7f17f1906b9f3211$var$keysCache[key] = $7f17f1906b9f3211$var$stringToPath(key);
    }
    return $7f17f1906b9f3211$var$keysCache[key];
};
var $7f17f1906b9f3211$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $7f17f1906b9f3211$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(Number(key))) return undefined;
        current = current[key];
    }
    return current;
};
function $7f17f1906b9f3211$var$_toPropertyKey(t) {
    var i = $7f17f1906b9f3211$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $7f17f1906b9f3211$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(t);
}
/**
 * Check if a key is a valid array index (non-negative integer)
 * Valid: "0", "1", "42"
 * Invalid: "5.1.1", "01", "-1", "foo", "3.14"
 */ var $7f17f1906b9f3211$var$isValidArrayIndex = function isValidArrayIndex(key) {
    var num = Number(key);
    // Check if:
    // 1. It's not NaN
    // 2. It's a non-negative integer
    // 3. The string representation matches (prevents "01" from being treated as 1)
    return !isNaN(num) && Number.isInteger(num) && num >= 0 && String(num) === key;
};
var $7f17f1906b9f3211$var$_setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (!$7f17f1906b9f3211$var$isValidArrayIndex(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = $7f17f1906b9f3211$var$_setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = $7f17f1906b9f3211$var$_setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if ($7f17f1906b9f3211$var$isValidArrayIndex(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            // Strings cannot have custom properties, and destructuring converts them to objects
            // with numeric keys. Return the string as-is to preserve field-level error messages.
            if (typeof current === 'string') return current;
            var _current = current;
            _current[key];
            var _final = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_current, [
                key
            ].map($7f17f1906b9f3211$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $8nd05.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = $7f17f1906b9f3211$var$_setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) {
        // FIX #482: If we have an object but need to set a numeric property,
        // convert it to an array. This can happen when validating both the array
        // as a whole and individual array items (e.g., with ARRAY_ERROR).
        if (typeof current === 'object' && current !== null) {
            // Convert object to array, preserving any existing properties like ARRAY_ERROR
            var _array2 = [];
            Object.keys(current).forEach(function(k) {
                var idx = Number(k);
                if (!isNaN(idx)) // Transfer numeric keys as array indices
                _array2[idx] = current[k];
                else // Preserve non-numeric keys (like ARRAY_ERROR) on the array
                _array2[k] = current[k];
            });
            current = _array2;
        } else throw new Error("Cannot set a numeric property on an object");
    }
    // recurse
    var existingValue = current[numericKey];
    var result = $7f17f1906b9f3211$var$_setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    // FIX #482: Preserve custom properties (like ARRAY_ERROR) from the original array
    Object.keys(current).forEach(function(k) {
        if (isNaN(Number(k))) array[k] = current[k];
    });
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $7f17f1906b9f3211$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $7f17f1906b9f3211$var$_setInRecursor(state, 0, $7f17f1906b9f3211$var$toPath(key), value1, destroyArrays);
};
var $7f17f1906b9f3211$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $7f17f1906b9f3211$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
/**
 * Converts internal field state to published field state
 */ function $7f17f1906b9f3211$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $7f17f1906b9f3211$export$c52e5867d5879e24(values, name);
    var error = errors ? $7f17f1906b9f3211$export$c52e5867d5879e24(errors, name) : undefined;
    if (error && error[$7f17f1906b9f3211$export$735bebc8ffabf28a]) error = error[$7f17f1906b9f3211$export$735bebc8ffabf28a];
    var submitError = submitErrors && $7f17f1906b9f3211$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $7f17f1906b9f3211$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
var $7f17f1906b9f3211$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
var $7f17f1906b9f3211$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
function $7f17f1906b9f3211$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$7f17f1906b9f3211$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
var $7f17f1906b9f3211$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $7f17f1906b9f3211$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $7f17f1906b9f3211$var$subscriptionFilter(result, state, previousState, subscription, $7f17f1906b9f3211$export$41e855cb628c1b55, $7f17f1906b9f3211$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
var $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
var $7f17f1906b9f3211$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $7f17f1906b9f3211$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $7f17f1906b9f3211$var$subscriptionFilter(result, state, previousState, subscription, $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3, $7f17f1906b9f3211$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
var $7f17f1906b9f3211$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$7f17f1906b9f3211$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $7f17f1906b9f3211$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $7f17f1906b9f3211$export$83d89fbfd8236492 = "5.0.0-1";
function $7f17f1906b9f3211$var$_createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = $7f17f1906b9f3211$var$_unsupportedIterableToArray(r)) || e) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: true
            } : {
                done: false,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7f17f1906b9f3211$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $7f17f1906b9f3211$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $7f17f1906b9f3211$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $7f17f1906b9f3211$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $7f17f1906b9f3211$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur",
    "callbackScheduler",
    "ignoreUnregister"
];
var $7f17f1906b9f3211$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $7f17f1906b9f3211$var$_hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return $7f17f1906b9f3211$var$_hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $7f17f1906b9f3211$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $7f17f1906b9f3211$var$_hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || errors && $7f17f1906b9f3211$var$_hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $7f17f1906b9f3211$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $7f17f1906b9f3211$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($7f17f1906b9f3211$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $7f17f1906b9f3211$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur, callbackScheduler = config.callbackScheduler, ignoreUnregister = config.ignoreUnregister;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: Object.create(null),
        fields: Object.create(null),
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $8nd05.default)({}, initialValues),
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $8nd05.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var nextFieldInstanceId = 0;
    var asyncValidationPromises = {};
    var pendingAsyncCallbacks = [];
    var asyncCallbacksScheduled = false;
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var scheduleAsyncCallbacks = function scheduleAsyncCallbacks() {
        if (!asyncCallbacksScheduled && pendingAsyncCallbacks.length > 0) {
            asyncCallbacksScheduled = true;
            var scheduler = callbackScheduler || function(callback) {
                return setTimeout(callback, 0);
            };
            scheduler(function() {
                var callbacks = [].concat(pendingAsyncCallbacks);
                pendingAsyncCallbacks.length = 0;
                asyncCallbacksScheduled = false;
                callbacks.forEach(function(callback) {
                    return callback();
                });
            });
        }
    };
    var executeCallback = function executeCallback(callback, isAsync) {
        if (isAsync) {
            pendingAsyncCallbacks.push(callback);
            scheduleAsyncCallbacks();
        } else callback();
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _Object$assign, _Object$assign2;
            state.fields = Object.assign(Object.create(null), state.fields, (_Object$assign = {}, _Object$assign[to] = (0, $8nd05.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _Object$assign));
            delete state.fields[from];
            state.fieldSubscribers = Object.assign(Object.create(null), state.fieldSubscribers, (_Object$assign2 = {}, _Object$assign2[to] = state.fieldSubscribers[from], _Object$assign2));
            delete state.fieldSubscribers[from];
            var value1 = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, to, value1) || {};
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $7f17f1906b9f3211$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $7f17f1906b9f3211$export$e6bdf135a54e021b,
                    shallowEqual: $7f17f1906b9f3211$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners(undefined);
                    _notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $8nd05.default)({}, state.formState.values)); // clone to avoid writing
            if ($7f17f1906b9f3211$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        if (!field || !field.validators) return [];
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            // Bump validation key once per validation run (all validators share same key)
            field.asyncValidationKey++;
            var fieldValidationKey = field.asyncValidationKey;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $7f17f1906b9f3211$var$publishFieldState(state.formState, field) : undefined);
                if (errorOrPromise && $7f17f1906b9f3211$var$isPromise(errorOrPromise)) {
                    // Track async validation with per-field counter
                    field.asyncValidationCount++;
                    field.validating = true;
                    var fieldInstanceId = field.instanceId; // Capture stable instance ID
                    var promise = errorOrPromise.then(function(error) {
                        var currentField = state.fields[field.name];
                        // Only mutate if the field instance is still the same (check stable instanceId)
                        if (currentField && currentField.instanceId === fieldInstanceId) {
                            // Decrement async validation counter (guard against underflow)
                            if (currentField.asyncValidationCount > 0) currentField.asyncValidationCount--;
                            // Only set validating=false if all async validations for this field are complete
                            if (currentField.asyncValidationCount === 0) currentField.validating = false;
                            // Only apply error if this validation hasn't been superseded by a newer one
                            if (fieldValidationKey === currentField.asyncValidationKey) setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $8nd05.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey))["catch"](function(error) {
            // Clear the promise even on rejection to prevent infinite loop (#166)
            clearAsyncValidationPromise(asyncValidationPromiseKey)(undefined);
            throw error;
        });
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $8nd05.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $7f17f1906b9f3211$export$c52e5867d5879e24(recordLevelErrors, name);
                        var asyncRecordLevelError = afterAsync ? $7f17f1906b9f3211$export$c52e5867d5879e24(asyncRecordLevelErrors, name) : undefined;
                        var errorFromParent = $7f17f1906b9f3211$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && (asyncRecordLevelError || recordLevelError) || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $7f17f1906b9f3211$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$7f17f1906b9f3211$export$735bebc8ffabf28a]) {
                    var existing = $7f17f1906b9f3211$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$7f17f1906b9f3211$export$735bebc8ffabf28a] = error[$7f17f1906b9f3211$export$735bebc8ffabf28a];
                    merged = $7f17f1906b9f3211$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$7f17f1906b9f3211$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$7f17f1906b9f3211$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) _notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $8nd05.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $7f17f1906b9f3211$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $7f17f1906b9f3211$var$notify(fieldSubscriber, fieldState, lastFieldState, $7f17f1906b9f3211$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $7f17f1906b9f3211$var$_hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var _a, _b;
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $8nd05.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        // FIX #487: For unregistered fields, check if their values differ from initialValues
        // This handles cases like FieldArray where the array itself isn't registered
        if (!foundDirty) {
            // Dedupe keys using Set to avoid duplicate checks
            var allKeys = new Set([].concat(Object.keys(formState.values || {}), Object.keys(formState.initialValues || {})));
            for(var _iterator = $7f17f1906b9f3211$var$_createForOfIteratorHelperLoose(allKeys), _step; !(_step = _iterator()).done;){
                var key = _step.value;
                if (!safeFields[key]) {
                    var currentValue = (_a = formState.values) === null || _a === void 0 ? void 0 : _a[key];
                    var initialValue = (_b = formState.initialValues) === null || _b === void 0 ? void 0 : _b[key];
                    if (!$7f17f1906b9f3211$var$shallowEqual(currentValue, initialValue)) {
                        foundDirty = true;
                        break;
                    }
                }
            }
        }
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$7f17f1906b9f3211$var$_hasAnyError(formState.errors) && !(formState.submitErrors && $7f17f1906b9f3211$var$_hasAnyError(formState.submitErrors));
        var nextFormState = $7f17f1906b9f3211$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $7f17f1906b9f3211$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var _notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $7f17f1906b9f3211$var$notify(state.subscribers, nextFormState, lastFormState, $7f17f1906b9f3211$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                _notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        _notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners(undefined);
            _notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $8nd05.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners(undefined);
                    _notifyFormListeners();
                });
                else {
                    notifyFieldListeners(undefined);
                    _notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $8nd05.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners(undefined);
                    _notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners(undefined);
                    _notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        get ignoreUnregister () {
            return !!ignoreUnregister;
        },
        set ignoreUnregister (value){
            ignoreUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners(undefined);
                _notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $8nd05.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key), $7f17f1906b9f3211$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) {
                    // Check if any other registered field is a child of this field
                    // e.g., if key is "customers" and "customers[0].firstName" exists, skip "customers"
                    var hasChildFields = Object.keys(safeFields).some(function(otherKey) {
                        return otherKey !== key && (otherKey.startsWith(key + '[') || otherKey.startsWith(key + '.'));
                    });
                    if (!hasChildFields) result[key] = $7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key);
                }
                return result;
            }, {}) : {};
            // update initialValues and values
            formState.initialValues = values;
            formState.values = values;
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            // Recalculate modified flag for all fields based on new initialValues
            Object.keys(safeFields).forEach(function(key) {
                var field = safeFields[key];
                var currentValue = $7f17f1906b9f3211$export$c52e5867d5879e24(formState.values, key);
                var initialValue = $7f17f1906b9f3211$export$c52e5867d5879e24(formState.initialValues || {}, key);
                var pristine = field.isEqual(currentValue, initialValue);
                field.modified = !pristine;
            });
            runValidation(undefined, function() {
                notifyFieldListeners(undefined);
                _notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            var _a, _b, _c;
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $7f17f1906b9f3211$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: $7f17f1906b9f3211$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                asyncValidationCount: 0,
                asyncValidationKey: 0,
                instanceId: undefined,
                visited: false,
                blur: function blur() {
                    return api.blur(name);
                },
                change: function change(value1) {
                    return api.change(name, value1);
                },
                focus: function focus() {
                    return api.focus(name);
                }
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            if (typeof field.blur !== 'function') field.blur = function() {
                return api.blur(name);
            };
            if (typeof field.change !== 'function') field.change = function(value1) {
                return api.change(name, value1);
            };
            if (typeof field.focus !== 'function') field.focus = function() {
                return api.focus(name);
            };
            field.isEqual = fieldConfig && fieldConfig.isEqual || state.fields[name] && state.fields[name].isEqual || $7f17f1906b9f3211$var$tripleEquals;
            // Ensure instanceId and async validation counters exist (for fields created by mutators)
            field.instanceId = (_a = field.instanceId) !== null && _a !== void 0 ? _a : ++nextFieldInstanceId;
            field.asyncValidationCount = (_b = field.asyncValidationCount) !== null && _b !== void 0 ? _b : 0;
            field.asyncValidationKey = (_c = field.asyncValidationKey) !== null && _c !== void 0 ? _c : 0;
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var isAsync = fieldConfig && fieldConfig.async;
            var notify = function notify() {
                var callback = function callback() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        _notifyFormListeners();
                        notifyFieldListeners(undefined);
                    }
                };
                executeCallback(callback, !!isAsync);
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                var currentValue = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.values, name);
                var currentInitialValue = $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.initialValues, name);
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || currentValue === currentInitialValue)) {
                    state.formState.initialValues = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values || {}, name, fieldConfig.initialValue) || {};
                    runValidation(undefined, notify);
                } else if (// Fix #988: Update initialValue when field's initialValue prop changes
                // (e.g., after submit when the "saved" value changes)
                // but don't overwrite user's current value
                fieldConfig.initialValue !== undefined && fieldConfig.initialValue !== currentInitialValue && currentValue !== undefined) {
                    state.formState.initialValues = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    // Re-run validation since dirty state may have changed
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $7f17f1906b9f3211$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values || {}, name, fieldConfig.defaultValue) || {};
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name] && state.fields[name].validators) {
                    // state.fields[name] may have been removed by a mutator (e.g., renameField #191)
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers && state.fieldSubscribers[name].entries) // state.fieldSubscribers[name] may have been removed by a mutator (e.g., renameField #191)
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && state.fieldSubscribers[name] && state.fieldSubscribers[name].entries && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister && !ignoreUnregister) state.formState.values = $7f17f1906b9f3211$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        _notifyFormListeners();
                        notifyFieldListeners(undefined);
                    });
                    else if (lastOne) // values or errors may have changed
                    _notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            var _a, _b, _c;
            var field = state.fields[name];
            state.fields[name] = (0, $8nd05.default)({}, field, {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                // Preserve instanceId, asyncValidationCount but bump key to invalidate in-flight validations
                instanceId: (_a = field.instanceId) !== null && _a !== void 0 ? _a : ++nextFieldInstanceId,
                asyncValidationCount: (_b = field.asyncValidationCount) !== null && _b !== void 0 ? _b : 0,
                asyncValidationKey: ((_c = field.asyncValidationKey) !== null && _c !== void 0 ? _c : 0) + 1,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners(undefined);
                _notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                var _a, _b, _c;
                for(var name in state.fields){
                    var field = state.fields[name];
                    state.fields[name] = (0, $8nd05.default)({}, field, {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        // Preserve instanceId, asyncValidationCount but bump key to invalidate in-flight validations
                        instanceId: (_a = field.instanceId) !== null && _a !== void 0 ? _a : ++nextFieldInstanceId,
                        asyncValidationCount: (_b = field.asyncValidationCount) !== null && _b !== void 0 ? _b : 0,
                        asyncValidationKey: ((_c = field.asyncValidationKey) !== null && _c !== void 0 ? _c : 0) + 1,
                        visited: false
                    });
                }
                api.reset(initialValues || {});
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners(undefined);
                _notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = typeof value1 === "function" ? value1 : undefined;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "ignoreUnregister":
                    ignoreUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners(undefined);
                        _notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                case "callbackScheduler":
                    callbackScheduler = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        setCallbackScheduler: function setCallbackScheduler(scheduler) {
            callbackScheduler = scheduler;
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return Promise.resolve(undefined);
            formState.lastSubmittedValues = (0, $8nd05.default)({}, formState.values);
            // Call beforeSubmit first to allow fields to format values (e.g., formatOnBlur)
            // before validation runs. This ensures that when submitting via Enter key,
            // the formatOnBlur logic runs before checking for sync errors.
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return Promise.resolve(undefined);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                _notifyFormListeners();
                notifyFieldListeners(undefined);
                return Promise.resolve(undefined);
            }
            // Only clear submit errors if we're actually proceeding with submission
            delete formState.submitErrors;
            delete formState.submitError;
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) // still waiting on async validation to complete...
            return Promise.all(asyncValidationPromisesKeys.map(function(key) {
                return asyncValidationPromises[Number(key)];
            })).then(function() {
                return api.submit();
            }, function(err) {
                console.error(err);
                return undefined;
            });
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $7f17f1906b9f3211$var$_hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$7f17f1906b9f3211$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                _notifyFormListeners();
                notifyFieldListeners(undefined);
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $8nd05.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $7f17f1906b9f3211$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    _notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(undefined); // notify fields also
                    return result.then(function(value1) {
                        complete(value1);
                        return value1;
                    }, function(error) {
                        complete(undefined);
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    _notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(undefined); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
            return Promise.resolve(undefined);
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $7f17f1906b9f3211$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $7f17f1906b9f3211$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $7f17f1906b9f3211$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        },
        // useSyncExternalStore compatible APIs
        subscribeFieldState: function subscribeFieldState(name, onChange, subscription) {
            // Subscribe to field changes using the existing registerField mechanism
            return api.registerField(name, onChange, subscription);
        },
        getFieldSnapshot: function getFieldSnapshot(name) {
            var field = state.fields[name];
            if (!field) return undefined;
            return $7f17f1906b9f3211$var$publishFieldState(state.formState, field);
        },
        subscribeFormState: function subscribeFormState(onChange, subscription) {
            // Subscribe to form changes using the existing subscribe mechanism
            return api.subscribe(onChange, subscription);
        },
        getFormSnapshot: function getFormSnapshot() {
            return calculateNextFormState();
        }
    };
    return api;
}


function $1347c42f18a0fcf0$export$2e2bcd8739ae039(r) {
    throw new TypeError('"' + r + '" is read-only');
}


var $a22611c327162735$var$_excluded$3 = [
    "render",
    "children",
    "component"
];
// shared logic between components that use either render prop,
// children render function, or component prop
function $a22611c327162735$var$renderComponent(props, lazyProps, name) {
    var render = props.render, children = props.children, component = props.component, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a22611c327162735$var$_excluded$3);
    if (component) {
        // FIX: Don't use Object.assign which tries to overwrite getters
        // Instead, create a new object with lazyProps descriptors first,
        // then add non-conflicting properties from rest
        var _result = {};
        Object.defineProperties(_result, Object.getOwnPropertyDescriptors(lazyProps));
        var _restDescriptors = Object.getOwnPropertyDescriptors(rest);
        for(var key in _restDescriptors)if (!(key in _result)) Object.defineProperty(_result, key, _restDescriptors[key]);
        _result.children = children;
        _result.render = render;
        return /*#__PURE__*/ $acw62.createElement(component, _result);
    }
    if (render) {
        var _result2 = {};
        Object.defineProperties(_result2, Object.getOwnPropertyDescriptors(lazyProps));
        // Only add properties from rest that don't already exist
        var _restDescriptors2 = Object.getOwnPropertyDescriptors(rest);
        for(var _key in _restDescriptors2)if (!(_key in _result2)) Object.defineProperty(_result2, _key, _restDescriptors2[_key]);
        if (children !== undefined) _result2.children = children;
        return render(_result2);
    }
    if (typeof children !== "function") throw new Error("Must specify either a render prop, a render function as children, or a component prop to " + name);
    var result = {};
    Object.defineProperties(result, Object.getOwnPropertyDescriptors(lazyProps));
    // Only add properties from rest that don't already exist
    var restDescriptors = Object.getOwnPropertyDescriptors(rest);
    for(var _key2 in restDescriptors)if (!(_key2 in result)) Object.defineProperty(result, _key2, restDescriptors[_key2]);
    return children(result);
}
function $a22611c327162735$var$useWhenValueChanges(value, callback, isEqual) {
    if (isEqual === void 0) isEqual = function isEqual(a, b) {
        return a === b;
    };
    var previous = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        if (!isEqual(value, previous.current)) {
            callback();
            previous.current = value;
        }
    });
}
/**
 * A simple hook to create a constant value that lives for
 * the lifetime of the component.
 *
 * Plagiarized from https://github.com/Andarist/use-constant
 *
 * Do NOT reuse this code unless you know what you're doing.
 * Use Andarist's hook; it's more fault tolerant to things like
 * falsy values.
 *
 * @param init - A function to generate the value
 */ function $a22611c327162735$var$useConstant(init) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    if (!ref.current) ref.current = init();
    return ref.current;
}
var $a22611c327162735$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
var $a22611c327162735$var$isSyntheticEvent = function isSyntheticEvent(candidate) {
    return !!(candidate && typeof candidate.stopPropagation === "function");
};
var $a22611c327162735$var$ReactFinalFormContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $a22611c327162735$var$addLazyState = function addLazyState(dest, state, keys) {
    keys.forEach(function(key) {
        Object.defineProperty(dest, key, {
            get: function get() {
                return state[key];
            },
            enumerable: true
        });
    });
};
var $a22611c327162735$var$addLazyFormState = function addLazyFormState(dest, state) {
    return $a22611c327162735$var$addLazyState(dest, state, [
        "active",
        "dirty",
        "dirtyFields",
        "dirtySinceLastSubmit",
        "dirtyFieldsSinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ]);
};
var $a22611c327162735$var$addLazyFieldMetaState = function addLazyFieldMetaState(dest, state) {
    return $a22611c327162735$var$addLazyState(dest, state, [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "validating",
        "visited"
    ]);
};
var $a22611c327162735$export$83d89fbfd8236492 = "7.0.1";
var $a22611c327162735$var$_excluded$2 = [
    "debug",
    "decorators",
    "destroyOnUnregister",
    "form",
    "initialValues",
    "initialValuesEqual",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "subscription",
    "validate",
    "validateOnBlur"
];
var $a22611c327162735$var$versions = {
    "final-form": (0, $7f17f1906b9f3211$export$83d89fbfd8236492),
    "react-final-form": $a22611c327162735$export$83d89fbfd8236492
};
var $a22611c327162735$var$all$1 = (0, $7f17f1906b9f3211$export$f1ff97b9d1c7a3c3).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
function $a22611c327162735$export$a7fed597f4b8afd8(_ref) {
    var debug = _ref.debug, _ref$decorators = _ref.decorators, decorators = _ref$decorators === void 0 ? [] : _ref$decorators, destroyOnUnregister = _ref.destroyOnUnregister, alternateFormApi = _ref.form, initialValues = _ref.initialValues, initialValuesEqual = _ref.initialValuesEqual, keepDirtyOnReinitialize = _ref.keepDirtyOnReinitialize, mutators = _ref.mutators, onSubmit = _ref.onSubmit, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $a22611c327162735$var$all$1 : _ref$subscription, validate = _ref.validate, validateOnBlur = _ref.validateOnBlur, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a22611c327162735$var$_excluded$2);
    var config = {
        debug: debug,
        destroyOnUnregister: destroyOnUnregister,
        initialValues: initialValues,
        keepDirtyOnReinitialize: keepDirtyOnReinitialize,
        mutators: mutators,
        onSubmit: onSubmit,
        validate: validate,
        validateOnBlur: validateOnBlur
    };
    var form = $a22611c327162735$var$useConstant(function() {
        var f = alternateFormApi || (0, $7f17f1906b9f3211$export$f681a8129d2e9d28)(config);
        // pause validation until children register all fields on first render (unpaused in useEffect() below)
        f.pauseValidation();
        return f;
    });
    // Get initial state without triggering callbacks during render
    var _React$useState = $acw62.useState(function() {
        // Get initial state synchronously but without callbacks
        return form.getState();
    }), state = _React$useState[0], setState = _React$useState[1];
    // save a copy of state that can break through the closure
    // on the shallowEqual() line below.
    var stateRef = $acw62.useRef(state);
    stateRef.current = state;
    $acw62.useEffect(function() {
        // We have rendered, so all fields are now registered, so we can unpause validation
        form.isValidationPaused() && form.resumeValidation();
        var unsubscriptions = [
            form.subscribe(function(s) {
                setState(function(prevState) {
                    if (!$a22611c327162735$var$shallowEqual(s, prevState)) return s;
                    return prevState;
                });
            }, subscription)
        ].concat(decorators ? decorators.map(function(decorator) {
            return decorator(form);
        }) : []);
        return function() {
            form.pauseValidation(); // pause validation so we don't revalidate on every field deregistration
            unsubscriptions.reverse().forEach(function(unsubscribe) {
                return unsubscribe();
            });
        // don't need to resume validation here; either unmounting, or will re-run this hook with new deps
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // allow updatable config
    $a22611c327162735$var$useWhenValueChanges(debug, function() {
        form.setConfig("debug", debug);
    });
    $a22611c327162735$var$useWhenValueChanges(destroyOnUnregister, function() {
        form.destroyOnUnregister = !!destroyOnUnregister;
    });
    $a22611c327162735$var$useWhenValueChanges(keepDirtyOnReinitialize, function() {
        form.setConfig("keepDirtyOnReinitialize", keepDirtyOnReinitialize);
    });
    $a22611c327162735$var$useWhenValueChanges(initialValues, function() {
        form.setConfig("initialValues", initialValues);
    }, initialValuesEqual || $a22611c327162735$var$shallowEqual);
    $a22611c327162735$var$useWhenValueChanges(mutators, function() {
        form.setConfig("mutators", mutators);
    });
    $a22611c327162735$var$useWhenValueChanges(onSubmit, function() {
        form.setConfig("onSubmit", onSubmit);
    });
    $a22611c327162735$var$useWhenValueChanges(validate, function() {
        form.setConfig("validate", validate);
    });
    $a22611c327162735$var$useWhenValueChanges(validateOnBlur, function() {
        form.setConfig("validateOnBlur", validateOnBlur);
    });
    var handleSubmit = function handleSubmit(event) {
        if (event) {
            // sometimes not true, e.g. React Native
            if (typeof event.preventDefault === "function") event.preventDefault();
            if (typeof event.stopPropagation === "function") // prevent any outer forms from receiving the event too
            event.stopPropagation();
        }
        return form.submit();
    };
    var renderProps = {
        form: (0, $8nd05.default)({}, form, {
            reset: function reset(eventOrValues) {
                if ($a22611c327162735$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                form.reset();
                else form.reset(eventOrValues);
            }
        }),
        handleSubmit: handleSubmit
    };
    $a22611c327162735$var$addLazyFormState(renderProps, state);
    return /*#__PURE__*/ $acw62.createElement($a22611c327162735$var$ReactFinalFormContext.Provider, {
        value: form
    }, $a22611c327162735$var$renderComponent((0, $8nd05.default)({}, rest, {
        __versions: $a22611c327162735$var$versions
    }), renderProps, "ReactFinalForm"));
}
function $a22611c327162735$export$87c0cf8eb5a167e0(componentName) {
    var form = $acw62.useContext($a22611c327162735$var$ReactFinalFormContext);
    if (!form) throw new Error((componentName || "useForm") + " must be used inside of a <Form> component");
    return form;
}
function $a22611c327162735$export$606f11b2eb45ecc6(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, onChange = _ref.onChange, _ref$subscription = _ref.subscription, subscription = _ref$subscription === void 0 ? $a22611c327162735$var$all$1 : _ref$subscription;
    var form = $a22611c327162735$export$87c0cf8eb5a167e0("useFormState");
    var onChangeRef = $acw62.useRef(onChange);
    onChangeRef.current = onChange;
    // Initialize with current form state WITHOUT triggering callbacks during render.
    // We intentionally use getState() here so render-prop consumers (e.g. <FormSpy>{...})
    // can read a fully-populated initial state on first render.
    var _React$useState = $acw62.useState(function() {
        return form.getState();
    }), state = _React$useState[0], setState = _React$useState[1];
    // We want `onChange` to be called AFTER render (fixes #809) and only with the
    // subscription-filtered state.
    var firstSubscriptionRef = $acw62.useRef(true);
    var pendingOnChangeRef = $acw62.useRef(null);
    var lastOnChangeRef = $acw62.useRef(null);
    $acw62.useEffect(function() {
        var unsubscribe = form.subscribe(function(newState) {
            // Ensure we set state at least once from the subscription, even if equal,
            // so that `onChange` can be fired from an effect after the first render.
            var isFirst = firstSubscriptionRef.current;
            if (isFirst) firstSubscriptionRef.current = false;
            pendingOnChangeRef.current = newState;
            setState(function(prevState) {
                if (isFirst || !$a22611c327162735$var$shallowEqual(newState, prevState)) return newState;
                return prevState;
            });
        }, subscription);
        return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $acw62.useEffect(function() {
        var pending = pendingOnChangeRef.current;
        if (!pending || !onChangeRef.current) return;
        // Only fire when the subscription has produced a new state and it differs
        // from what we've already emitted.
        if (lastOnChangeRef.current === null || !$a22611c327162735$var$shallowEqual(pending, lastOnChangeRef.current)) {
            onChangeRef.current(pending);
            lastOnChangeRef.current = pending;
        }
        // Clear pending once we've handled it.
        pendingOnChangeRef.current = null;
    }, [
        state
    ]);
    var lazyState = {};
    $a22611c327162735$var$addLazyFormState(lazyState, state);
    return lazyState;
}
var $a22611c327162735$var$_excluded$1 = [
    "onChange",
    "subscription"
];
function $a22611c327162735$export$d2e89184086487cb(_ref) {
    var onChange = _ref.onChange, subscription = _ref.subscription, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a22611c327162735$var$_excluded$1);
    var reactFinalForm = $a22611c327162735$export$87c0cf8eb5a167e0("FormSpy");
    var state = $a22611c327162735$export$606f11b2eb45ecc6({
        onChange: onChange,
        subscription: subscription
    });
    if (onChange) return null;
    var renderProps = {
        form: (0, $8nd05.default)({}, reactFinalForm, {
            reset: function reset(eventOrValues) {
                if ($a22611c327162735$var$isSyntheticEvent(eventOrValues)) // it's a React SyntheticEvent, call reset with no arguments
                reactFinalForm.reset();
                else reactFinalForm.reset(eventOrValues);
            }
        })
    };
    return $a22611c327162735$var$renderComponent((0, $8nd05.default)({}, rest, renderProps), state, "FormSpy");
}
var $a22611c327162735$var$isReactNative = !!(typeof window !== "undefined" && window.navigator && window.navigator.product && window.navigator.product === "ReactNative");
var $a22611c327162735$var$getSelectedValues = function getSelectedValues(options) {
    var result = [];
    if (options) for(var index = 0; index < options.length; index++){
        var option = options[index];
        if (option.selected) result.push(option.value);
    }
    return result;
};
var $a22611c327162735$var$getValue = function getValue(event, currentValue, valueProp, isReactNative) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) return event.nativeEvent.text;
    if (isReactNative && event.nativeEvent) return event.nativeEvent.text;
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target, type = _detypedEvent$target.type, value = _detypedEvent$target.value, checked = _detypedEvent$target.checked;
    switch(type){
        case "checkbox":
            if (valueProp !== undefined) {
                // we are maintaining an array, not just a boolean
                if (checked) // add value to current array value
                return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [
                    valueProp
                ];
                else {
                    // remove value from current array value
                    if (!Array.isArray(currentValue)) return currentValue;
                    var index = currentValue.indexOf(valueProp);
                    if (index < 0) return currentValue;
                    else return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
                }
            } else // it's just a boolean
            return !!checked;
        case "select-multiple":
            return $a22611c327162735$var$getSelectedValues(event.target.options);
        default:
            return value;
    }
};
function $a22611c327162735$var$useLatest(value) {
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(value);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        ref.current = value;
    });
    return ref;
}
/**
 * Creates a callback, even with closures, that will be
 * instance === for the lifetime of the component, always
 * calling the most recent version of the function and its
 * closures.
 */ function $a22611c327162735$var$useConstantCallback(callback) {
    var ref = $acw62.useRef(callback);
    $acw62.useEffect(function() {
        ref.current = callback;
    });
    return $acw62.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current.apply(null, args);
    }, []);
}
var $a22611c327162735$var$all = (0, $7f17f1906b9f3211$export$41e855cb628c1b55).reduce(function(result, key) {
    result[key] = true;
    return result;
}, {});
var $a22611c327162735$var$defaultFormat = function defaultFormat(value, _name) {
    return value === undefined ? "" : value;
};
var $a22611c327162735$var$defaultParse = function defaultParse(value, _name) {
    return value === "" ? undefined : value;
};
function $a22611c327162735$export$294aa081a6c6f55d(name, config) {
    if (config === void 0) config = {};
    var _config = config, afterSubmit = _config.afterSubmit, allowNull = _config.allowNull, component = _config.component, data = _config.data, defaultValue = _config.defaultValue, _config$format = _config.format, format = _config$format === void 0 ? $a22611c327162735$var$defaultFormat : _config$format, formatOnBlur = _config.formatOnBlur, initialValue = _config.initialValue, multiple = _config.multiple, _config$parse = _config.parse, parse = _config$parse === void 0 ? $a22611c327162735$var$defaultParse : _config$parse, _config$subscription = _config.subscription, subscription = _config$subscription === void 0 ? $a22611c327162735$var$all : _config$subscription, type = _config.type, validateFields = _config.validateFields, _value = _config.value;
    var form = $a22611c327162735$export$87c0cf8eb5a167e0("useField");
    var configRef = $a22611c327162735$var$useLatest(config);
    var register = function register(callback, silent) {
        return(// avoid using `state` const in any closures created inside `register`
        // because they would refer `state` from current execution context
        // whereas actual `state` would defined in the subsequent `useField` hook
        // execution
        // (that would be caused by `setState` call performed in `register` callback)
        form.registerField(name, callback, subscription, {
            afterSubmit: afterSubmit,
            beforeSubmit: function beforeSubmit() {
                var _configRef$current = configRef.current, beforeSubmit = _configRef$current.beforeSubmit, formatOnBlur = _configRef$current.formatOnBlur, _configRef$current$fo = _configRef$current.format, format = _configRef$current$fo === void 0 ? $a22611c327162735$var$defaultFormat : _configRef$current$fo;
                if (formatOnBlur) {
                    var fieldState = form.getFieldState(name);
                    if (fieldState) {
                        var value = fieldState.value;
                        var formatted = format(value, name);
                        if (formatted !== value) form.change(name, formatted);
                    }
                }
                return beforeSubmit && beforeSubmit();
            },
            data: data,
            defaultValue: defaultValue,
            getValidator: function getValidator() {
                return configRef.current.validate;
            },
            initialValue: initialValue,
            isEqual: configRef.current.isEqual,
            silent: silent,
            validateFields: validateFields
        }));
    };
    // Initialize state with proper field state from Final Form without callbacks
    var _React$useState = $acw62.useState(function() {
        // Get the current field state from Final Form without registering callbacks
        var existingFieldState = form.getFieldState(name);
        if (existingFieldState) {
            // If allowNull is true and the initial value was null, preserve it
            // (and its formatted version is not null, meaning it was formatted away)
            if (allowNull && existingFieldState.initial === null && existingFieldState.value !== null) return (0, $8nd05.default)({}, existingFieldState, {
                value: null,
                // Force value back to null
                initial: null // Ensure our local state's 'initial' also reflects this
            });
            return existingFieldState;
        }
        // FIX #1050: Check Form initialValues before falling back to field initialValue
        // If no existing state, create a proper initial state
        var formState = form.getState();
        // Use getIn to support nested field paths like "user.name" or "items[0].id"
        var formInitialValue = formState.initialValues ? (0, $7f17f1906b9f3211$export$c52e5867d5879e24)(formState.initialValues, name) : undefined;
        // Use Form initialValues if available, otherwise use field initialValue
        var initialStateValue = formInitialValue !== undefined ? formInitialValue : initialValue;
        if ((component === "select" || type === "select") && multiple && initialStateValue === undefined) initialStateValue = [];
        return {
            active: false,
            blur: function blur() {
                form.blur(name);
            },
            change: function change(value) {
                form.change(name, value);
            },
            data: data || {},
            dirty: false,
            dirtySinceLastSubmit: false,
            error: undefined,
            focus: function focus() {
                form.focus(name);
            },
            initial: initialStateValue,
            invalid: false,
            length: undefined,
            modified: false,
            modifiedSinceLastSubmit: false,
            name: name,
            pristine: true,
            submitError: undefined,
            submitFailed: false,
            submitSucceeded: false,
            submitting: false,
            touched: false,
            valid: true,
            validating: false,
            value: initialStateValue,
            visited: false
        };
    }), state = _React$useState[0], setState = _React$useState[1];
    $acw62.useEffect(function() {
        // Check if field state exists in the form before registering
        var existingFieldState = form.getFieldState(name);
        // If field doesn't exist in form state, it means the field was destroyed 
        // (e.g., by destroyOnUnregister in StrictMode). In this case, we need to 
        // explicitly set the value before registering to ensure the initial value 
        // is applied, even if form thinks initialValues haven't changed.
        if (!existingFieldState) {
            var formState = form.getState();
            var formInitialValue = formState.initialValues ? (0, $7f17f1906b9f3211$export$c52e5867d5879e24)(formState.initialValues, name) : undefined;
            var valueToSet = formInitialValue !== undefined ? formInitialValue : initialValue;
            if (valueToSet !== undefined) form.change(name, valueToSet);
        }
        // Register field after the initial render to avoid setState during render
        var unregister = register(function(newState) {
            setState(function(prevState) {
                // Only update if the state actually changed
                if (!$a22611c327162735$var$shallowEqual(newState, prevState)) return newState;
                return prevState;
            });
        }, false);
        return unregister;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        name,
        data,
        defaultValue,
        initialValue
    ]);
    // FIX #988: When initialValue prop changes, update the form's initialValues
    // for this field. This ensures that when a parent component updates initialValues
    // after a save operation, the field becomes pristine if the value matches.
    var prevInitialValueRef = $acw62.useRef(initialValue);
    $acw62.useEffect(function() {
        // Use the configured isEqual function (respects custom equality for objects/arrays)
        var isEqual = configRef.current.isEqual || function(a, b) {
            return a === b;
        };
        var prevInitialValue = prevInitialValueRef.current;
        // Always advance the ref so transitions through `undefined` are tracked
        // correctly (e.g. "foo" → undefined → "foo" must re-trigger the block).
        prevInitialValueRef.current = initialValue;
        // Only run when initialValue actually changes (not on mount) and is defined
        if (!isEqual(prevInitialValue, initialValue) && initialValue !== undefined) {
            // Get current form state
            var formState = form.getState();
            var currentFormInitial = formState.initialValues ? (0, $7f17f1906b9f3211$export$c52e5867d5879e24)(formState.initialValues, name) : undefined;
            // Only update if the new initialValue differs from current form initial
            if (!isEqual(initialValue, currentFormInitial)) {
                var currentValue = formState.values ? (0, $7f17f1906b9f3211$export$c52e5867d5879e24)(formState.values, name) : undefined;
                // If the current value matches the new initial value, update the form's
                // initialValues to reflect this. This is needed for radio buttons where
                // the user changes the value, then the parent saves and passes back the
                // new initial value that matches what the user selected.
                // 
                // We need to manually update formState.initialValues and notify listeners.
                // Final Form doesn't expose a public API for this, so we use internal state.
                var fieldState = form.getFieldState(name);
                if (fieldState) // Force an update through the field subscriber by triggering a change
                // to the same value, which will recalculate dirty state with new initial
                {
                    if (isEqual(currentValue, initialValue)) {
                        // The value matches the new initial, so field should become pristine.
                        // Re-register with new initialValue to update formState.initialValues.
                        // Final Form's registerField will update initialValues when:
                        // - value === old initial (meaning pristine before)
                        // We need to handle the case where value === new initial but value !== old initial
                        // 
                        // Workaround: We need to update formState.initialValues directly.
                        // The only public API is form.setConfig('initialValues', ...) but that
                        // resets ALL values. Instead, we use a workaround:
                        // Trigger a re-registration which will update initialValues for this field.
                        var wasValidationPaused = form.isValidationPaused();
                        if (!wasValidationPaused) form.pauseValidation();
                        try {
                            // Manually update initialValues via registerField with silent: false
                            // to force notification
                            var unsubscribe = form.registerField(name, function() {}, {}, {
                                initialValue: initialValue,
                                isEqual: configRef.current.isEqual
                            });
                            // Immediately unsubscribe to avoid orphan subscriber
                            unsubscribe();
                        } finally{
                            if (!wasValidationPaused) form.resumeValidation();
                        }
                    }
                }
            }
        }
    }, [
        initialValue,
        name,
        form
    ]);
    var meta = {};
    $a22611c327162735$var$addLazyFieldMetaState(meta, state);
    var getInputValue = function getInputValue() {
        var _form$getState$values;
        // Fix #869: If name changed but state hasn't updated yet (effect hasn't run),
        // get the value directly from form values to avoid returning stale value
        var value = state.name !== name ? (0, $7f17f1906b9f3211$export$c52e5867d5879e24)((_form$getState$values = form.getState().values) != null ? _form$getState$values : {}, name) : state.value;
        // Handle null values first
        if (value === null && !allowNull) value = "";
        if (formatOnBlur) {
            if (component === "input") value = $a22611c327162735$var$defaultFormat(value);
        } else // Only format if value is not null when allowNull is true
        if (!(allowNull && value === null)) value = format(value, name);
        if ((component === "select" || type === "select") && multiple) return Array.isArray(value) ? value : [];
        // For checkboxes and radios, the `value` prop on the input element itself
        // is not the array of selected values or the single selected radio value,
        // but rather the specific value this input represents if selected.
        // The `checked` prop handles the actual selection state.
        // So, for `input.value`, we should return `_value` if provided (for individual inputs in a group)
        // or the formatted field value otherwise (for standalone inputs).
        if ((type === "checkbox" || type === "radio") && _value !== undefined) return _value;
        return value;
    };
    var getInputChecked = function getInputChecked() {
        var _form$getState$values2;
        // Fix #869: Same as getInputValue - sync with current name
        var value = state.name !== name ? (0, $7f17f1906b9f3211$export$c52e5867d5879e24)((_form$getState$values2 = form.getState().values) != null ? _form$getState$values2 : {}, name) : state.value;
        if (type === "checkbox") {
            value = parse(value, name);
            if (_value === undefined) return !!value;
            else return !!(Array.isArray(value) && ~value.indexOf(_value));
        } else if (type === "radio") return parse(value, name) === _value;
        return undefined;
    };
    var input = {
        name: name,
        onBlur: $a22611c327162735$var$useConstantCallback(function(_event) {
            form.blur(name);
            if (formatOnBlur) {
                /**
         * Here we must fetch the value directly from Final Form because we cannot
         * trust that our `state` closure has the most recent value. This is a problem
         * if-and-only-if the library consumer has called `onChange()` immediately
         * before calling `onBlur()`, but before the field has had a chance to receive
         * the value update from Final Form.
         */ var fieldState = form.getFieldState(name);
                if (fieldState) form.change(name, format(fieldState.value, name));
            }
        }),
        onChange: $a22611c327162735$var$useConstantCallback(function(event) {
            var _form$getFieldState$v, _form$getFieldState;
            var targetType, unknown, _value2;
            var currentValue = (_form$getFieldState$v = (_form$getFieldState = form.getFieldState(name)) == null ? void 0 : _form$getFieldState.value) != null ? _form$getFieldState$v : state.value;
            var value = event && event.target ? $a22611c327162735$var$getValue(event, currentValue, _value, $a22611c327162735$var$isReactNative) : event;
            form.change(name, parse(value, name));
        }),
        onFocus: $a22611c327162735$var$useConstantCallback(function(_event) {
            return form.focus(name);
        }),
        get value () {
            return getInputValue();
        },
        get checked () {
            return getInputChecked();
        }
    };
    if (multiple) input.multiple = multiple;
    if (type !== undefined) input.type = type;
    var renderProps = {
        input: input,
        meta: meta
    }; // assign to force type check
    return renderProps;
}
var $a22611c327162735$var$_excluded = [
    "afterSubmit",
    "allowNull",
    "beforeSubmit",
    "children",
    "component",
    "data",
    "defaultValue",
    "format",
    "formatOnBlur",
    "initialValue",
    "input",
    "isEqual",
    "multiple",
    "name",
    "parse",
    "subscription",
    "type",
    "validate",
    "validateFields",
    "value"
], $a22611c327162735$var$_excluded2 = [
    "name"
];
function $a22611c327162735$var$FieldComponent(_ref, ref) {
    var afterSubmit = _ref.afterSubmit, allowNull = _ref.allowNull, beforeSubmit = _ref.beforeSubmit, children = _ref.children, component = _ref.component, data = _ref.data, defaultValue = _ref.defaultValue, format = _ref.format, formatOnBlur = _ref.formatOnBlur, initialValue = _ref.initialValue, input = _ref.input, isEqual = _ref.isEqual, multiple = _ref.multiple, name = _ref.name, parse = _ref.parse, subscription = _ref.subscription, type = _ref.type, validate = _ref.validate, validateFields = _ref.validateFields, value = _ref.value, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a22611c327162735$var$_excluded);
    var field = $a22611c327162735$export$294aa081a6c6f55d(name, {
        afterSubmit: afterSubmit,
        allowNull: allowNull,
        beforeSubmit: beforeSubmit,
        component: component,
        data: data,
        defaultValue: defaultValue,
        format: format,
        formatOnBlur: formatOnBlur,
        initialValue: initialValue,
        isEqual: isEqual,
        multiple: multiple,
        parse: parse,
        subscription: subscription,
        type: type,
        validate: validate,
        validateFields: validateFields,
        value: value
    });
    // Merge provided input prop with field.input
    var mergedField = input ? (0, $8nd05.default)({}, field, {
        input: (0, $8nd05.default)({}, field.input, input)
    }) : field;
    if (typeof children === "function") return children((0, $8nd05.default)({}, mergedField, rest));
    if (typeof component === "string") {
        // ignore meta, combine input with any other props
        var _mergedField$input = mergedField.input, inputName = _mergedField$input.name, restInputProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_mergedField$input, $a22611c327162735$var$_excluded2);
        // Ensure multiple select has array value
        if (component === "select" && multiple && !Array.isArray(restInputProps.value)) restInputProps.value = [];
        return /*#__PURE__*/ $acw62.createElement(component, (0, $8nd05.default)({
            name: inputName
        }, restInputProps, {
            children: children,
            ref: ref
        }, rest));
    }
    if (!name) throw new Error("prop name cannot be undefined in <Field> component");
    return $a22611c327162735$var$renderComponent((0, $8nd05.default)({
        children: children,
        component: component
    }, rest, mergedField), {}, "Field(" + name + ")");
}
// Create a properly typed forwardRef component that preserves generics
var $a22611c327162735$export$a455218a85c89869 = /*#__PURE__*/ $acw62.forwardRef($a22611c327162735$var$FieldComponent);
function $a22611c327162735$export$38f9b05178901e14() {
    return {
        Form: $a22611c327162735$export$a7fed597f4b8afd8,
        FormSpy: $a22611c327162735$export$d2e89184086487cb
    };
}


function $e28ca79fc75b43e9$var$copyField(oldFields, oldKey, newFields, newKey) {
    newFields[newKey] = {
        ...oldFields[oldKey],
        name: newKey,
        // prevent functions from being overwritten
        // if the newFields[newKey] does not exist, it will be created
        // when that field gets registered, with its own change/blur/focus callbacks
        change: oldFields[newKey] && oldFields[newKey].change,
        blur: oldFields[newKey] && oldFields[newKey].blur,
        focus: oldFields[newKey] && oldFields[newKey].focus,
        lastFieldState: undefined // clearing lastFieldState forces renotification
    };
    if (!newFields[newKey].change) delete newFields[newKey].change;
    if (!newFields[newKey].blur) delete newFields[newKey].blur;
    if (!newFields[newKey].focus) delete newFields[newKey].focus;
}
// From MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#Escaping
const $e28ca79fc75b43e9$var$escapeRegexTokens = (string)=>string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
const $e28ca79fc75b43e9$export$21a5ca8aa77d35ff = ([name, index, value], state, { changeValue: changeValue })=>{
    changeValue(state, name, (array)=>{
        const copy = [
            ...array || []
        ];
        copy.splice(index, 0, value);
        return copy;
    });
    // now increment any higher indices
    const pattern = new RegExp(`^${$e28ca79fc75b43e9$var$escapeRegexTokens(name)}\\[(\\d+)\\](.*)`);
    const newFields = {};
    Object.keys(state.fields).forEach((key)=>{
        const tokens = pattern.exec(key);
        if (tokens) {
            const fieldIndex = Number(tokens[1]);
            if (fieldIndex >= index) {
                // Shift all higher indices up
                const incrementedKey = `${name}[${fieldIndex + 1}]${tokens[2]}`;
                $e28ca79fc75b43e9$var$copyField(state.fields, key, newFields, incrementedKey);
                return;
            }
        }
        // Keep this field that does not match the name,
        // or has index smaller than what is being inserted
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
};
const $e28ca79fc75b43e9$export$ee1b3e54f0441b22 = ([name, value], state, { changeValue: changeValue })=>{
    changeValue(state, name, (array)=>array ? [
            ...array,
            ...value
        ] : value);
};
const $e28ca79fc75b43e9$export$d947e5f4f4c48d48 = ([name, from, to], state, { changeValue: changeValue })=>{
    if (from === to) return;
    changeValue(state, name, (array)=>{
        const copy = [
            ...array || []
        ];
        const value = copy[from];
        copy.splice(from, 1);
        copy.splice(to, 0, value);
        return copy;
    });
    const newFields = {};
    const pattern = new RegExp(`^${$e28ca79fc75b43e9$var$escapeRegexTokens(name)}\\[(\\d+)\\](.*)`);
    let lowest;
    let highest;
    let increment;
    if (from > to) {
        lowest = to;
        highest = from;
        increment = 1;
    } else {
        lowest = from;
        highest = to;
        increment = -1;
    }
    Object.keys(state.fields).forEach((key)=>{
        const tokens = pattern.exec(key);
        if (tokens) {
            const fieldIndex = Number(tokens[1]);
            if (fieldIndex === from) {
                const newKey = `${name}[${to}]${tokens[2]}`;
                $e28ca79fc75b43e9$var$copyField(state.fields, key, newFields, newKey);
                return;
            }
            if (lowest <= fieldIndex && fieldIndex <= highest) {
                // Shift all indices
                const newKey = `${name}[${fieldIndex + increment}]${tokens[2]}`;
                $e28ca79fc75b43e9$var$copyField(state.fields, key, newFields, newKey);
                return;
            }
        }
        // Keep this field that does not match the name,
        // or has index smaller or larger than affected range
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
};
const $e28ca79fc75b43e9$export$cd7f480d6b8286c3 = ([name, index], state, { changeValue: changeValue, getIn: getIn, setIn: setIn })=>{
    let returnValue;
    changeValue(state, name, (array)=>{
        if (!array) return array;
        const copy = [
            ...array
        ];
        returnValue = copy[index];
        copy.splice(index, 1);
        return copy.length > 0 ? copy : undefined;
    });
    // now we have to remove any subfields for our index,
    // and decrement all higher indexes.
    const pattern = new RegExp(`^${$e28ca79fc75b43e9$var$escapeRegexTokens(name)}\\[(\\d+)\\](.*)`);
    const newFields = {};
    Object.keys(state.fields).forEach((key)=>{
        const tokens = pattern.exec(key);
        if (tokens) {
            const fieldIndex = Number(tokens[1]);
            if (fieldIndex === index) {
                // delete any submitErrors for this array item
                // if the root key of the delete index
                if (key === `${name}[${index}]`) {
                    const path = `formState.submitErrors.${name}`;
                    const submitErrors = getIn(state, path);
                    // if has submitErrors for array
                    if (Array.isArray(submitErrors)) {
                        submitErrors.splice(index, 1);
                        setIn(state, path, submitErrors);
                    }
                }
                return;
            }
            if (fieldIndex > index) {
                // Shift all higher indices down
                const decrementedKey = `${name}[${fieldIndex - 1}]${tokens[2]}`;
                $e28ca79fc75b43e9$var$copyField(state.fields, key, newFields, decrementedKey);
                return;
            }
        }
        // Keep this field that does not match the name,
        // or has index smaller than what is being removed
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
    return returnValue;
};
const $e28ca79fc75b43e9$export$3e41007ebfff0e64 = ([name], state, tools)=>{
    const { getIn: getIn } = tools;
    const array = getIn(state.formState.values, name);
    return array && array.length > 0 ? $e28ca79fc75b43e9$export$cd7f480d6b8286c3([
        name,
        array.length - 1
    ], state, tools) : undefined;
};
const $e28ca79fc75b43e9$export$4cbf152802aa238 = ([name, value], state, { changeValue: changeValue })=>{
    changeValue(state, name, (array)=>array ? [
            ...array,
            value
        ] : [
            value
        ]);
};
const $e28ca79fc75b43e9$var$binarySearch = (list, value)=>{
    // This algorithm assumes the items in list is unique
    let first = 0;
    let last = list.length - 1;
    let middle = 0;
    while(first <= last){
        middle = Math.floor((first + last) / 2);
        if (list[middle] === value) return middle;
        if (list[middle] > value) last = middle - 1;
        else first = middle + 1;
    }
    return ~first;
};
const $e28ca79fc75b43e9$export$5436cc3b70b2a957 = ([name, indexes], state, { changeValue: changeValue })=>{
    if (indexes.length === 0) return [];
    const sortedIndexes = [
        ...indexes
    ];
    sortedIndexes.sort();
    // Remove duplicates
    for(let i = sortedIndexes.length - 1; i > 0; i -= 1)if (sortedIndexes[i] === sortedIndexes[i - 1]) sortedIndexes.splice(i, 1);
    let returnValue = [];
    changeValue(state, name, (array)=>{
        // use original order of indexes for return value
        returnValue = indexes.map((index)=>array && array[index]);
        if (!array) return array;
        const copy = [
            ...array
        ];
        for(let i = sortedIndexes.length - 1; i >= 0; i -= 1){
            const index = sortedIndexes[i];
            copy.splice(index, 1);
        }
        return copy.length > 0 ? copy : undefined;
    });
    // now we have to remove any subfields for our indexes,
    // and decrement all higher indexes.
    const pattern = new RegExp(`^${$e28ca79fc75b43e9$var$escapeRegexTokens(name)}\\[(\\d+)\\](.*)`);
    const newFields = {};
    Object.keys(state.fields).forEach((key)=>{
        const tokens = pattern.exec(key);
        if (tokens) {
            const fieldIndex = Number(tokens[1]);
            const indexOfFieldIndex = $e28ca79fc75b43e9$var$binarySearch(sortedIndexes, fieldIndex);
            if (indexOfFieldIndex >= 0) // One of the removed indices
            return;
            if (fieldIndex > sortedIndexes[0]) {
                // Shift all higher indices down
                const decrementedKey = `${name}[${fieldIndex - ~indexOfFieldIndex}]${tokens[2]}`;
                $e28ca79fc75b43e9$var$copyField(state.fields, key, newFields, decrementedKey);
                return;
            }
        }
        // Keep this field that does not match the name,
        // or has index smaller than what is being removed
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
    return returnValue;
};
const $e28ca79fc75b43e9$export$fba63a578e423eb = ([name], state, tools)=>$e28ca79fc75b43e9$export$cd7f480d6b8286c3([
        name,
        0
    ], state, tools);
const $e28ca79fc75b43e9$export$b0e76d9850c64156 = ([name, indexA, indexB], state, { changeValue: changeValue })=>{
    if (indexA === indexB) return;
    changeValue(state, name, (array)=>{
        const copy = [
            ...array || []
        ];
        const a = copy[indexA];
        copy[indexA] = copy[indexB];
        copy[indexB] = a;
        return copy;
    });
    // swap all field state that begin with "name[indexA]" with that under "name[indexB]"
    const aPrefix = `${name}[${indexA}]`;
    const bPrefix = `${name}[${indexB}]`;
    const newFields = {};
    Object.keys(state.fields).forEach((key)=>{
        if (key.substring(0, aPrefix.length) === aPrefix) {
            const suffix = key.substring(aPrefix.length);
            const newKey = bPrefix + suffix;
            $e28ca79fc75b43e9$var$copyField(state.fields, key, newFields, newKey);
        } else if (key.substring(0, bPrefix.length) === bPrefix) {
            const suffix = key.substring(bPrefix.length);
            const newKey = aPrefix + suffix;
            $e28ca79fc75b43e9$var$copyField(state.fields, key, newFields, newKey);
        } else // Keep this field that does not match the name
        newFields[key] = state.fields[key];
    });
    state.fields = newFields;
};
const $e28ca79fc75b43e9$export$37cdb546b806ae87 = ([name, value], state, tools)=>$e28ca79fc75b43e9$export$21a5ca8aa77d35ff([
        name,
        0,
        value
    ], state, tools);
const $e28ca79fc75b43e9$export$722fbec263ad908a = ([name, index, value], state, { changeValue: changeValue })=>{
    changeValue(state, name, (array)=>{
        const copy = [
            ...array || []
        ];
        copy.splice(index, 1, value);
        return copy;
    });
};
const $e28ca79fc75b43e9$export$2e2bcd8739ae039 = {
    insert: $e28ca79fc75b43e9$export$21a5ca8aa77d35ff,
    concat: $e28ca79fc75b43e9$export$ee1b3e54f0441b22,
    move: $e28ca79fc75b43e9$export$d947e5f4f4c48d48,
    pop: $e28ca79fc75b43e9$export$3e41007ebfff0e64,
    push: $e28ca79fc75b43e9$export$4cbf152802aa238,
    remove: $e28ca79fc75b43e9$export$cd7f480d6b8286c3,
    removeBatch: $e28ca79fc75b43e9$export$5436cc3b70b2a957,
    shift: $e28ca79fc75b43e9$export$fba63a578e423eb,
    swap: $e28ca79fc75b43e9$export$b0e76d9850c64156,
    unshift: $e28ca79fc75b43e9$export$37cdb546b806ae87,
    update: $e28ca79fc75b43e9$export$722fbec263ad908a
};


const $0276ec08cc56ec7a$export$b469541fb2fc05ac = ({ onSubmit: onSubmit, formKey: formKey, renderAction: renderAction })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $a22611c327162735$export$a7fed597f4b8afd8), {
        key: formKey,
        onSubmit: onSubmit,
        destroyOnUnmount: false,
        enableReinitialize: true,
        keepDirtyOnReinitialize: true,
        updateUnregisteredFields: true,
        // mutators={...arrayMutators}
        render: renderAction
    });
};



var $acw62 = parcelRequire("acw62");


const $845240b70dd84aaf$export$ce9c28c189976c9e = (pack, name, defaultMessage)=>{
    return {
        id: `${pack}_${name}`,
        defaultMessage: defaultMessage
    };
};


const $111b4e88cd733e22$export$9abc43a57b1d16e9 = (name, message)=>{
    return (0, $845240b70dd84aaf$export$ce9c28c189976c9e)('validationErrorMessages', name, message);
};
const $111b4e88cd733e22$export$af1e14e964849c8c = (0, $4bda6d15a99e1cac$export$1adfeb024f5185b)({
    requiredMessage: $111b4e88cd733e22$export$9abc43a57b1d16e9('requiredMessage', 'Required'),
    unmatchedPasswordMessage: $111b4e88cd733e22$export$9abc43a57b1d16e9('unmatchedPasswordMessage', 'Passwords do not match'),
    invalidPasswordMessage: $111b4e88cd733e22$export$9abc43a57b1d16e9('invalidPasswordMessage', 'Password must be minimum of 6 characters and contain capital & lowercase letters and a number.'),
    invalidEmailAddressMessage: $111b4e88cd733e22$export$9abc43a57b1d16e9('invalidEmailAddressMessage', 'Invalid email address'),
    invalidInternationalPhoneNumberMessage: $111b4e88cd733e22$export$9abc43a57b1d16e9('invalidInternationalPhoneNumberMessage', 'Invalid international phone number'),
    invalidSlugMessage: $111b4e88cd733e22$export$9abc43a57b1d16e9('invalidSlugMessage', 'Invalid slug - slug must be between 6 and 12 characters allowing for dashes, underscores and all alphanumerics')
});


const $d661dc0b3fc1cda3$export$22be11368b300b4f = (values, keyValueProcessor)=>{
    const errors = {};
    Object.keys(values).forEach((key)=>{
        let errorMessage = null;
        let notNullRequiredValidationMessage = $d661dc0b3fc1cda3$var$hasNotNullRequiredValidationMessage(values[key]);
        if (notNullRequiredValidationMessage) errorMessage = notNullRequiredValidationMessage;
        else {
            const value = values[key];
            const isString = typeof value === 'string';
            if (isString) {
                const stringValue = value.trim();
                let charactersRequiredValidationMessage = $d661dc0b3fc1cda3$var$hasCharactersRequiredValidationMessage(stringValue);
                if (charactersRequiredValidationMessage) errorMessage = charactersRequiredValidationMessage;
                else errorMessage = keyValueProcessor(key, stringValue);
            } else errorMessage = keyValueProcessor(key, value);
        }
        if (errorMessage) errors[key] = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5706f4e3d2f628b5$export$561a3c611f78824a), errorMessage);
    });
    if (0 < Object.keys(errors).length) console.log("VALIDATION ERRORS ", errors);
    return errors;
};
const $d661dc0b3fc1cda3$export$42cf6b2044f49079 = (value)=>{
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,24}$/i.test(value)) return (0, $111b4e88cd733e22$export$af1e14e964849c8c).invalidEmailAddressMessage;
    return false;
};
const $d661dc0b3fc1cda3$export$5517d2ed42971b31 = (value)=>{
    if (!/^[0-9]+$/i.test(value)) return (0, $111b4e88cd733e22$export$af1e14e964849c8c).invalidInternationalPhoneNumberMessage;
    return false;
};
const $d661dc0b3fc1cda3$export$d5ad3c159ac80c1d = (value)=>{
    if (!/(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/i.test(value)) return (0, $111b4e88cd733e22$export$af1e14e964849c8c).invalidPasswordMessage;
    return false;
};
const $d661dc0b3fc1cda3$export$264179b84cdef2bf = (value)=>{
    if (!/^[A-Za-z0-9._-]{6,12}$/i.test(value)) return (0, $111b4e88cd733e22$export$af1e14e964849c8c).invalidSlugMessage;
    return false;
};
const $d661dc0b3fc1cda3$var$hasNotNullRequiredValidationMessage = (value)=>{
    if (typeof value === 'undefined') return (0, $111b4e88cd733e22$export$af1e14e964849c8c).requiredMessage;
    if (typeof value === 'number' || typeof value === 'boolean') return false;
    if (!value) return (0, $111b4e88cd733e22$export$af1e14e964849c8c).requiredMessage;
    return false;
};
const $d661dc0b3fc1cda3$var$hasCharactersRequiredValidationMessage = (value)=>{
    if ('' === value) return (0, $111b4e88cd733e22$export$af1e14e964849c8c).requiredMessage;
    return false;
};



var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");


var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $9c5ccd26194e7dc6$var$RtlContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $9c5ccd26194e7dc6$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)($9c5ccd26194e7dc6$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $9c5ccd26194e7dc6$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($9c5ccd26194e7dc6$var$RtlContext);
    return value ?? false;
};
var $9c5ccd26194e7dc6$export$2e2bcd8739ae039 = $9c5ccd26194e7dc6$var$RtlProvider;










function $272a5e25f492bceb$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiLinearProgress', slot);
}
const $272a5e25f492bceb$var$linearProgressClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'bar',
    'bar1',
    'bar2'
]);
var $272a5e25f492bceb$export$2e2bcd8739ae039 = $272a5e25f492bceb$var$linearProgressClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $2bd4a85074278929$var$TRANSITION_DURATION = 4; // seconds
const $2bd4a85074278929$var$EMPTY_STYLE = {};
let $2bd4a85074278929$var$warnedMinMaxWithoutVariant = false;
let $2bd4a85074278929$var$warnedInvalidMinMaxValue = false;
let $2bd4a85074278929$var$warnedValueRequired = false;
let $2bd4a85074278929$var$warnedInvalidMinMaxValueBuffer = false;
let $2bd4a85074278929$var$warnedValueBufferRequired = false;
function $2bd4a85074278929$export$36f40a3150c2c3a2() {
    $2bd4a85074278929$var$warnedMinMaxWithoutVariant = false;
    $2bd4a85074278929$var$warnedInvalidMinMaxValue = false;
    $2bd4a85074278929$var$warnedValueRequired = false;
    $2bd4a85074278929$var$warnedInvalidMinMaxValueBuffer = false;
    $2bd4a85074278929$var$warnedValueBufferRequired = false;
}
const $2bd4a85074278929$var$indeterminate1Keyframe = (0, $7a381217d0a161e7$exports.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $2bd4a85074278929$var$indeterminate1Animation = typeof $2bd4a85074278929$var$indeterminate1Keyframe !== 'string' ? (0, $7a381217d0a161e7$exports.css)`
        animation: ${$2bd4a85074278929$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $2bd4a85074278929$var$indeterminate2Keyframe = (0, $7a381217d0a161e7$exports.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $2bd4a85074278929$var$indeterminate2Animation = typeof $2bd4a85074278929$var$indeterminate2Keyframe !== 'string' ? (0, $7a381217d0a161e7$exports.css)`
        animation: ${$2bd4a85074278929$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $2bd4a85074278929$var$bufferKeyframe = (0, $7a381217d0a161e7$exports.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $2bd4a85074278929$var$bufferAnimation = typeof $2bd4a85074278929$var$bufferKeyframe !== 'string' ? (0, $7a381217d0a161e7$exports.css)`
        animation: ${$2bd4a85074278929$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $2bd4a85074278929$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(color)}`,
            variant
        ],
        dashed: [
            'dashed'
        ],
        bar1: [
            'bar',
            'bar1'
        ],
        bar2: [
            'bar',
            'bar2',
            variant === 'buffer' && `color${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (0, $272a5e25f492bceb$export$bc8a6ea1eb17d7c6), classes);
};
const $2bd4a85074278929$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.5);
};
const $2bd4a85074278929$var$LinearProgressRoot = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $2bd4a85074278929$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $2bd4a85074278929$var$LinearProgressDashed = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed'
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()).map(([color])=>{
                const backgroundColor = $2bd4a85074278929$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $2bd4a85074278929$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$2bd4a85074278929$var$bufferKeyframe} 3s infinite linear`
}, (0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>(0, $2bd06673060f0f5d$export$4bc2c89b8b366948)(theme, {
        animation: 'none'
    }) || $2bd4a85074278929$var$EMPTY_STYLE));
const $2bd4a85074278929$var$LinearProgressBar1 = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        return [
            styles.bar,
            styles.bar1
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const reducedMotionIndeterminateStyles = (0, $2bd06673060f0f5d$export$4bc2c89b8b366948)(theme, {
        animation: 'none',
        left: '30%',
        right: 'auto',
        width: '40%'
    });
    return {
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
            duration: '0.2s',
            easing: 'linear'
        }),
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
                        duration: `.${$2bd4a85074278929$var$TRANSITION_DURATION}s`,
                        easing: 'linear'
                    })
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
                        duration: `.${$2bd4a85074278929$var$TRANSITION_DURATION}s`,
                        easing: 'linear'
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $2bd4a85074278929$var$indeterminate1Animation || {
                    animation: `${$2bd4a85074278929$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            },
            ...reducedMotionIndeterminateStyles ? [
                {
                    props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                    style: reducedMotionIndeterminateStyles
                }
            ] : []
        ]
    };
}));
const $2bd4a85074278929$var$LinearProgressBar2 = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        return [
            styles.bar,
            styles.bar2
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const reducedMotionIndeterminateStyles = (0, $2bd06673060f0f5d$export$4bc2c89b8b366948)(theme, {
        animation: 'none',
        display: 'none'
    });
    return {
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
            duration: '0.2s',
            easing: 'linear'
        }),
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $2bd4a85074278929$var$getColorShade(theme, color),
                        ...(0, $2bd06673060f0f5d$export$cfbcd9a4c0ed32ac)(theme, 'transform', {
                            duration: `.${$2bd4a85074278929$var$TRANSITION_DURATION}s`,
                            easing: 'linear'
                        })
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $2bd4a85074278929$var$indeterminate2Animation || {
                    animation: `${$2bd4a85074278929$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            },
            ...reducedMotionIndeterminateStyles ? [
                {
                    props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                    style: reducedMotionIndeterminateStyles
                }
            ] : []
        ]
    };
}));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $2bd4a85074278929$var$LinearProgress = /*#__PURE__*/ $acw62.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', max: maxProp, min: minProp, value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const min = minProp ?? 0;
    const max = maxProp ?? 100;
    const classes = $2bd4a85074278929$var$useUtilityClasses(ownerState);
    const isRtl = (0, $9c5ccd26194e7dc6$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            const range = max - min;
            let transform = (value - min) / range * 100 - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = range > 0 ? `translateX(${transform}%)` : 'translateX(-100%)'; // empty-state fallback when range is invalid
            rootProps['aria-valuenow'] = value;
            rootProps['aria-valuemin'] = min;
            rootProps['aria-valuemax'] = max;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            const range = max - min;
            let transform = (valueBuffer - min) / range * 100 - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = range > 0 ? `translateX(${transform}%)` : 'translateX(-100%)'; // empty-state fallback when range is invalid
        }
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)($2bd4a85074278929$var$LinearProgressRoot, {
        className: (0, $i6kju.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $ayMG0.jsx)($2bd4a85074278929$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $ayMG0.jsx)($2bd4a85074278929$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $ayMG0.jsx)($2bd4a85074278929$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $2bd4a85074278929$export$2e2bcd8739ae039 = $2bd4a85074278929$var$LinearProgress;


const $4d1c205d21ae284f$var$styles = {
    root: {
        flexGrow: 1
    }
};
const $4d1c205d21ae284f$var$LoadingProgress = ({ classes: classes = {} })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classes.root
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $2bd4a85074278929$export$2e2bcd8739ae039), null));
};
$4d1c205d21ae284f$var$LoadingProgress.propTypes = {
    classes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired
};
var $4d1c205d21ae284f$export$2e2bcd8739ae039 = $4d1c205d21ae284f$var$LoadingProgress;


const $9164e243b49b1f60$var$validateEnquiryFields = (values)=>{
    const errors = (0, $d661dc0b3fc1cda3$export$22be11368b300b4f)(values, (key, value)=>{
        let errorMessage = null;
        switch(key){
            case 'mbox':
                if (!value) errorMessage = 'Required';
                else errorMessage = (0, $d661dc0b3fc1cda3$export$42cf6b2044f49079)(value);
                break;
            default:
                break;
        }
        return errorMessage;
    });
    debugger;
    return errors;
};
const $9164e243b49b1f60$export$2297eb3c52fa27fe = ({ onSubmit: onSubmit, enquiryMessage: enquiryMessage, isActive: isActive, mbox: mbox = "", name: name = "" })=>{
    let formObject = {
        mbox: mbox,
        name: name
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0276ec08cc56ec7a$export$b469541fb2fc05ac), {
        formKey: 'enquiry',
        noValidate: true,
        onSubmit: ()=>{
            onSubmit(formObject);
        },
        validate: $9164e243b49b1f60$var$validateEnquiryFields,
        initialValues: {},
        renderAction: ({ values: values })=>{
            formObject = {
                ...values
            };
            return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
                children: [
                    enquiryMessage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                        sx: {
                            margin: 1
                        },
                        children: enquiryMessage
                    }),
                    isActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                        sx: {
                            margin: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4d1c205d21ae284f$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                        sx: {
                            margin: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da943955a1ce66e1$export$d691fcbf87f401db), {
                            label: "Mailbox",
                            name: "mbox",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                        sx: {
                            margin: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da943955a1ce66e1$export$d691fcbf87f401db), {
                            label: "Name",
                            name: "name",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                        sx: {
                            margin: 1
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $245879af6017e1c1$export$bd36621ef7814117), {
                            buttonText: 'SUBMIT',
                            disabled: isActive,
                            onClick: ()=>{
                                onSubmit(formObject);
                            }
                        })
                    })
                ]
            });
        }
    });
};



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $0a1028487aeaf648$var$extendStatics = function(d, b) {
    $0a1028487aeaf648$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $0a1028487aeaf648$var$extendStatics(d, b);
};
function $0a1028487aeaf648$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $0a1028487aeaf648$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $0a1028487aeaf648$export$18ce0697a983be9b = function() {
    $0a1028487aeaf648$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0a1028487aeaf648$export$18ce0697a983be9b.apply(this, arguments);
};
function $0a1028487aeaf648$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $0a1028487aeaf648$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $0a1028487aeaf648$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $0a1028487aeaf648$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $0a1028487aeaf648$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $0a1028487aeaf648$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $0a1028487aeaf648$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $0a1028487aeaf648$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $0a1028487aeaf648$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $0a1028487aeaf648$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $0a1028487aeaf648$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $0a1028487aeaf648$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $0a1028487aeaf648$export$45d3717a4c69092e(o, m, p);
}
function $0a1028487aeaf648$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $0a1028487aeaf648$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $0a1028487aeaf648$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($0a1028487aeaf648$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $0a1028487aeaf648$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $0a1028487aeaf648$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $0a1028487aeaf648$export$10c90e4f7922046c(v) {
    return this instanceof $0a1028487aeaf648$export$10c90e4f7922046c ? (this.v = v, this) : new $0a1028487aeaf648$export$10c90e4f7922046c(v);
}
function $0a1028487aeaf648$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $0a1028487aeaf648$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $0a1028487aeaf648$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $0a1028487aeaf648$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $0a1028487aeaf648$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $0a1028487aeaf648$export$19a8beecd37a4c45 === "function" ? $0a1028487aeaf648$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $0a1028487aeaf648$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $0a1028487aeaf648$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $0a1028487aeaf648$var$ownKeys = function(o) {
    $0a1028487aeaf648$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $0a1028487aeaf648$var$ownKeys(o);
};
function $0a1028487aeaf648$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $0a1028487aeaf648$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $0a1028487aeaf648$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $0a1028487aeaf648$var$__setModuleDefault(result, mod);
    return result;
}
function $0a1028487aeaf648$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $0a1028487aeaf648$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $0a1028487aeaf648$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $0a1028487aeaf648$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $0a1028487aeaf648$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $0a1028487aeaf648$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $0a1028487aeaf648$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $0a1028487aeaf648$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $0a1028487aeaf648$export$889dfb5d17574b0b(path, preserveJsx, extraExtensions, ignoreCase) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) {
        if (extraExtensions) for(var extension in extraExtensions){
            var suffix = path.slice(-extension.length);
            if (suffix === extension || ignoreCase && suffix.toLowerCase() === extension.toLowerCase()) {
                var output = extraExtensions[extension];
                return output === extension ? path : path.slice(0, -extension.length) + output;
            }
        }
        return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
            return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
        });
    }
    return path;
}
var $0a1028487aeaf648$export$2e2bcd8739ae039 = {
    __extends: $0a1028487aeaf648$export$a8ba968b8961cb8a,
    __assign: $0a1028487aeaf648$export$18ce0697a983be9b,
    __rest: $0a1028487aeaf648$export$3c9a16f847548506,
    __decorate: $0a1028487aeaf648$export$29e00dfd3077644b,
    __param: $0a1028487aeaf648$export$d5ad3fd78186038f,
    __esDecorate: $0a1028487aeaf648$export$3a84e1ae4e97e9b0,
    __runInitializers: $0a1028487aeaf648$export$d831c04e792af3d,
    __propKey: $0a1028487aeaf648$export$6a2a36740a146cb8,
    __setFunctionName: $0a1028487aeaf648$export$d1a06452d3489bc7,
    __metadata: $0a1028487aeaf648$export$f1db080c865becb9,
    __awaiter: $0a1028487aeaf648$export$1050f835b63b671e,
    __generator: $0a1028487aeaf648$export$67ebef60e6f28a6,
    __createBinding: $0a1028487aeaf648$export$45d3717a4c69092e,
    __exportStar: $0a1028487aeaf648$export$f33643c0debef087,
    __values: $0a1028487aeaf648$export$19a8beecd37a4c45,
    __read: $0a1028487aeaf648$export$8d051b38c9118094,
    __spread: $0a1028487aeaf648$export$afc72e2116322959,
    __spreadArrays: $0a1028487aeaf648$export$6388937ca91ccae8,
    __spreadArray: $0a1028487aeaf648$export$1216008129fb82ed,
    __await: $0a1028487aeaf648$export$10c90e4f7922046c,
    __asyncGenerator: $0a1028487aeaf648$export$e427f37a30a4de9b,
    __asyncDelegator: $0a1028487aeaf648$export$bbd80228419bb833,
    __asyncValues: $0a1028487aeaf648$export$e3b29a3d6162315f,
    __makeTemplateObject: $0a1028487aeaf648$export$4fb47efe1390b86f,
    __importStar: $0a1028487aeaf648$export$c21735bcef00d192,
    __importDefault: $0a1028487aeaf648$export$da59b14a69baef04,
    __classPrivateFieldGet: $0a1028487aeaf648$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $0a1028487aeaf648$export$d40a35129aaff81f,
    __classPrivateFieldIn: $0a1028487aeaf648$export$81fdc39f203e4e04,
    __addDisposableResource: $0a1028487aeaf648$export$88ac25d8e944e405,
    __disposeResources: $0a1028487aeaf648$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $0a1028487aeaf648$export$889dfb5d17574b0b
};


function $22a990e5c1c1874d$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}


function $21b07b18132f6843$export$ebec8610810318c5(source) {
    return (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $21b07b18132f6843$export$871731df685d7753(init) {
    return function(source) {
        if ($21b07b18132f6843$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}







function $c1c1651bd2af38eb$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $e9fc30e79659829c$export$c9648b76fd580c34 = (0, $c1c1651bd2af38eb$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});


function $32c3d1c439007563$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $4724536a5a34d79a$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $0a1028487aeaf648$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $e9fc30e79659829c$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $0a1028487aeaf648$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $4724536a5a34d79a$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $e9fc30e79659829c$export$c9648b76fd580c34)) errors = (0, $0a1028487aeaf648$export$1216008129fb82ed)((0, $0a1028487aeaf648$export$1216008129fb82ed)([], (0, $0a1028487aeaf648$export$8d051b38c9118094)(errors)), (0, $0a1028487aeaf648$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $e9fc30e79659829c$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $4724536a5a34d79a$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $32c3d1c439007563$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $32c3d1c439007563$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $4724536a5a34d79a$export$610f9c3ca1a38dd8 = $4724536a5a34d79a$export$f55210826850c514.EMPTY;
function $4724536a5a34d79a$export$4f9221cbada3c4fc(value) {
    return value instanceof $4724536a5a34d79a$export$f55210826850c514 || value && 'closed' in value && (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(value.remove) && (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(value.add) && (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $4724536a5a34d79a$var$execFinalizer(finalizer) {
    if ((0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $62490bdc86c24042$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $05ba5c1868302234$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $05ba5c1868302234$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $0a1028487aeaf648$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $0a1028487aeaf648$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $0a1028487aeaf648$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $0a1028487aeaf648$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $05ba5c1868302234$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $13e97c50aff41092$export$ebf645db02d3e99f(err) {
    (0, $05ba5c1868302234$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $62490bdc86c24042$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $c80d6787f6d65607$export$8793edee2d425525() {}


var $495e62bf519d464c$export$b7f97edb34bc1f87 = function() {
    return $495e62bf519d464c$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $495e62bf519d464c$export$dd472c3d8fe5a85a(error) {
    return $495e62bf519d464c$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $495e62bf519d464c$export$ff9346b0d1d30313(value) {
    return $495e62bf519d464c$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $495e62bf519d464c$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $12d49f55724b4e66$var$context = null;
function $12d49f55724b4e66$export$d974811edc77eafa(cb) {
    if ((0, $62490bdc86c24042$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$12d49f55724b4e66$var$context;
        if (isRoot) $12d49f55724b4e66$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $12d49f55724b4e66$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $12d49f55724b4e66$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $12d49f55724b4e66$export$3e205fbb5df021e0(err) {
    if ((0, $62490bdc86c24042$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $12d49f55724b4e66$var$context) {
        $12d49f55724b4e66$var$context.errorThrown = true;
        $12d49f55724b4e66$var$context.error = err;
    }
}


var $69f0bd88dfd09320$export$60959659b2c22881 = function(_super) {
    (0, $0a1028487aeaf648$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $4724536a5a34d79a$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $69f0bd88dfd09320$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $69f0bd88dfd09320$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $69f0bd88dfd09320$var$handleStoppedNotification((0, $495e62bf519d464c$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $69f0bd88dfd09320$var$handleStoppedNotification((0, $495e62bf519d464c$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $69f0bd88dfd09320$var$handleStoppedNotification((0, $495e62bf519d464c$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $4724536a5a34d79a$export$f55210826850c514));
var $69f0bd88dfd09320$var$_bind = Function.prototype.bind;
function $69f0bd88dfd09320$var$bind(fn, thisArg) {
    return $69f0bd88dfd09320$var$_bind.call(fn, thisArg);
}
var $69f0bd88dfd09320$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $69f0bd88dfd09320$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $69f0bd88dfd09320$var$handleUnhandledError(error);
        }
        else $69f0bd88dfd09320$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $69f0bd88dfd09320$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $69f0bd88dfd09320$export$94eeb6a328cab6c7 = function(_super) {
    (0, $0a1028487aeaf648$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $62490bdc86c24042$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $69f0bd88dfd09320$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $69f0bd88dfd09320$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $69f0bd88dfd09320$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $69f0bd88dfd09320$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($69f0bd88dfd09320$export$60959659b2c22881);
function $69f0bd88dfd09320$var$handleUnhandledError(error) {
    if ((0, $62490bdc86c24042$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $12d49f55724b4e66$export$3e205fbb5df021e0)(error);
    else (0, $13e97c50aff41092$export$ebf645db02d3e99f)(error);
}
function $69f0bd88dfd09320$var$defaultErrorHandler(err) {
    throw err;
}
function $69f0bd88dfd09320$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $62490bdc86c24042$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $05ba5c1868302234$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $69f0bd88dfd09320$export$88d395d20619a0af = {
    closed: true,
    next: (0, $c80d6787f6d65607$export$8793edee2d425525),
    error: $69f0bd88dfd09320$var$defaultErrorHandler,
    complete: (0, $c80d6787f6d65607$export$8793edee2d425525)
};


function $8febb15b9386dd49$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $8febb15b9386dd49$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $8febb15b9386dd49$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $0a1028487aeaf648$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $69f0bd88dfd09320$export$60959659b2c22881));


function $f14fe9f7d11a851c$export$871de8747c9eaa88(project, thisArg) {
    return (0, $21b07b18132f6843$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $8febb15b9386dd49$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}




var $498e303932b309b8$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();


function $8ef572585e4bb26e$export$f0954fd7d5368655(x) {
    return x;
}


function $81d213254ef0cc3e$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $81d213254ef0cc3e$export$71f88a61afaa14d7(fns);
}
function $81d213254ef0cc3e$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $8ef572585e4bb26e$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $740e586f832a8cc1$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $740e586f832a8cc1$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $69f0bd88dfd09320$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $12d49f55724b4e66$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $740e586f832a8cc1$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $69f0bd88dfd09320$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $498e303932b309b8$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $81d213254ef0cc3e$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $740e586f832a8cc1$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $740e586f832a8cc1$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $62490bdc86c24042$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $740e586f832a8cc1$var$isObserver(value) {
    return value && (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(value.next) && (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(value.error) && (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(value.complete);
}
function $740e586f832a8cc1$var$isSubscriber(value) {
    return value && value instanceof (0, $69f0bd88dfd09320$export$60959659b2c22881) || $740e586f832a8cc1$var$isObserver(value) && (0, $4724536a5a34d79a$export$4f9221cbada3c4fc)(value);
}


function $8a5a7782f2c9bef7$export$1c81c7d11cd80a90(xhr) {
    switch(xhr.responseType){
        case 'json':
            if ('response' in xhr) return xhr.response;
            else {
                var ieXHR = xhr;
                return JSON.parse(ieXHR.responseText);
            }
        case 'document':
            return xhr.responseXML;
        case 'text':
        default:
            if ('response' in xhr) return xhr.response;
            else {
                var ieXHR = xhr;
                return ieXHR.responseText;
            }
    }
}


var $1d36ff0dda277442$export$ae07db09d6fbd01b = function() {
    function AjaxResponse(originalEvent, xhr, request, type) {
        if (type === void 0) type = 'download_load';
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.type = type;
        var status = xhr.status, responseType = xhr.responseType;
        this.status = status !== null && status !== void 0 ? status : 0;
        this.responseType = responseType !== null && responseType !== void 0 ? responseType : '';
        var allHeaders = xhr.getAllResponseHeaders();
        this.responseHeaders = allHeaders ? allHeaders.split('\n').reduce(function(headers, line) {
            var index = line.indexOf(': ');
            headers[line.slice(0, index)] = line.slice(index + 2);
            return headers;
        }, {}) : {};
        this.response = (0, $8a5a7782f2c9bef7$export$1c81c7d11cd80a90)(xhr);
        var loaded = originalEvent.loaded, total = originalEvent.total;
        this.loaded = loaded;
        this.total = total;
    }
    return AjaxResponse;
}();




var $c0264afe82ac8e8f$export$9b8f4d0b97ba3d22 = (0, $c1c1651bd2af38eb$export$128a15b65d1b6041)(function(_super) {
    return function AjaxErrorImpl(message, xhr, request) {
        this.message = message;
        this.name = 'AjaxError';
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType;
        var response;
        try {
            response = (0, $8a5a7782f2c9bef7$export$1c81c7d11cd80a90)(xhr);
        } catch (err) {
            response = xhr.responseText;
        }
        this.response = response;
    };
});
var $c0264afe82ac8e8f$export$fcf72a1ab36e1e65 = function() {
    function AjaxTimeoutErrorImpl(xhr, request) {
        $c0264afe82ac8e8f$export$9b8f4d0b97ba3d22.call(this, 'ajax timeout', xhr, request);
        this.name = 'AjaxTimeoutError';
        return this;
    }
    AjaxTimeoutErrorImpl.prototype = Object.create($c0264afe82ac8e8f$export$9b8f4d0b97ba3d22.prototype);
    return AjaxTimeoutErrorImpl;
}();


function $7b33db13334c5267$var$ajaxGet(url, headers) {
    return $7b33db13334c5267$export$e68fce4c5f453854({
        method: 'GET',
        url: url,
        headers: headers
    });
}
function $7b33db13334c5267$var$ajaxPost(url, body, headers) {
    return $7b33db13334c5267$export$e68fce4c5f453854({
        method: 'POST',
        url: url,
        body: body,
        headers: headers
    });
}
function $7b33db13334c5267$var$ajaxDelete(url, headers) {
    return $7b33db13334c5267$export$e68fce4c5f453854({
        method: 'DELETE',
        url: url,
        headers: headers
    });
}
function $7b33db13334c5267$var$ajaxPut(url, body, headers) {
    return $7b33db13334c5267$export$e68fce4c5f453854({
        method: 'PUT',
        url: url,
        body: body,
        headers: headers
    });
}
function $7b33db13334c5267$var$ajaxPatch(url, body, headers) {
    return $7b33db13334c5267$export$e68fce4c5f453854({
        method: 'PATCH',
        url: url,
        body: body,
        headers: headers
    });
}
var $7b33db13334c5267$var$mapResponse = (0, $f14fe9f7d11a851c$export$871de8747c9eaa88)(function(x) {
    return x.response;
});
function $7b33db13334c5267$var$ajaxGetJSON(url, headers) {
    return $7b33db13334c5267$var$mapResponse($7b33db13334c5267$export$e68fce4c5f453854({
        method: 'GET',
        url: url,
        headers: headers
    }));
}
var $7b33db13334c5267$export$e68fce4c5f453854 = function() {
    var create = function(urlOrConfig) {
        var config = typeof urlOrConfig === 'string' ? {
            url: urlOrConfig
        } : urlOrConfig;
        return $7b33db13334c5267$export$2dba02aa2ec4c647(config);
    };
    create.get = $7b33db13334c5267$var$ajaxGet;
    create.post = $7b33db13334c5267$var$ajaxPost;
    create.delete = $7b33db13334c5267$var$ajaxDelete;
    create.put = $7b33db13334c5267$var$ajaxPut;
    create.patch = $7b33db13334c5267$var$ajaxPatch;
    create.getJSON = $7b33db13334c5267$var$ajaxGetJSON;
    return create;
}();
var $7b33db13334c5267$var$UPLOAD = 'upload';
var $7b33db13334c5267$var$DOWNLOAD = 'download';
var $7b33db13334c5267$var$LOADSTART = 'loadstart';
var $7b33db13334c5267$var$PROGRESS = 'progress';
var $7b33db13334c5267$var$LOAD = 'load';
function $7b33db13334c5267$export$2dba02aa2ec4c647(init) {
    return new (0, $740e586f832a8cc1$export$77cea355fa80b5f4)(function(destination) {
        var _a, _b;
        var config = (0, $0a1028487aeaf648$export$18ce0697a983be9b)({
            async: true,
            crossDomain: false,
            withCredentials: false,
            method: 'GET',
            timeout: 0,
            responseType: 'json'
        }, init);
        var queryParams = config.queryParams, configuredBody = config.body, configuredHeaders = config.headers;
        var url = config.url;
        if (!url) throw new TypeError('url is required');
        if (queryParams) {
            var searchParams_1;
            if (url.includes('?')) {
                var parts = url.split('?');
                if (2 < parts.length) throw new TypeError('invalid url');
                searchParams_1 = new URLSearchParams(parts[1]);
                new URLSearchParams(queryParams).forEach(function(value, key) {
                    return searchParams_1.set(key, value);
                });
                url = parts[0] + '?' + searchParams_1;
            } else {
                searchParams_1 = new URLSearchParams(queryParams);
                url = url + '?' + searchParams_1;
            }
        }
        var headers = {};
        if (configuredHeaders) {
            for(var key in configuredHeaders)if (configuredHeaders.hasOwnProperty(key)) headers[key.toLowerCase()] = configuredHeaders[key];
        }
        var crossDomain = config.crossDomain;
        if (!crossDomain && !('x-requested-with' in headers)) headers['x-requested-with'] = 'XMLHttpRequest';
        var withCredentials = config.withCredentials, xsrfCookieName = config.xsrfCookieName, xsrfHeaderName = config.xsrfHeaderName;
        if ((withCredentials || !crossDomain) && xsrfCookieName && xsrfHeaderName) {
            var xsrfCookie = (_b = (_a = document === null || document === void 0 ? void 0 : document.cookie.match(new RegExp("(^|;\\s*)(" + xsrfCookieName + ")=([^;]*)"))) === null || _a === void 0 ? void 0 : _a.pop()) !== null && _b !== void 0 ? _b : '';
            if (xsrfCookie) headers[xsrfHeaderName] = xsrfCookie;
        }
        var body = $7b33db13334c5267$var$extractContentTypeAndMaybeSerializeBody(configuredBody, headers);
        var _request = (0, $0a1028487aeaf648$export$18ce0697a983be9b)((0, $0a1028487aeaf648$export$18ce0697a983be9b)({}, config), {
            url: url,
            headers: headers,
            body: body
        });
        var xhr;
        xhr = init.createXHR ? init.createXHR() : new XMLHttpRequest();
        var progressSubscriber_1 = init.progressSubscriber, _c = init.includeDownloadProgress, includeDownloadProgress = _c === void 0 ? false : _c, _d = init.includeUploadProgress, includeUploadProgress = _d === void 0 ? false : _d;
        var addErrorEvent = function(type, errorFactory) {
            xhr.addEventListener(type, function() {
                var _a;
                var error = errorFactory();
                (_a = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.error) === null || _a === void 0 || _a.call(progressSubscriber_1, error);
                destination.error(error);
            });
        };
        addErrorEvent('timeout', function() {
            return new (0, $c0264afe82ac8e8f$export$fcf72a1ab36e1e65)(xhr, _request);
        });
        addErrorEvent('abort', function() {
            return new (0, $c0264afe82ac8e8f$export$9b8f4d0b97ba3d22)('aborted', xhr, _request);
        });
        var createResponse_1 = function(direction, event) {
            return new (0, $1d36ff0dda277442$export$ae07db09d6fbd01b)(event, xhr, _request, direction + "_" + event.type);
        };
        var addProgressEvent_1 = function(target, type, direction) {
            target.addEventListener(type, function(event) {
                destination.next(createResponse_1(direction, event));
            });
        };
        if (includeUploadProgress) [
            $7b33db13334c5267$var$LOADSTART,
            $7b33db13334c5267$var$PROGRESS,
            $7b33db13334c5267$var$LOAD
        ].forEach(function(type) {
            return addProgressEvent_1(xhr.upload, type, $7b33db13334c5267$var$UPLOAD);
        });
        if (progressSubscriber_1) [
            $7b33db13334c5267$var$LOADSTART,
            $7b33db13334c5267$var$PROGRESS
        ].forEach(function(type) {
            return xhr.upload.addEventListener(type, function(e) {
                var _a;
                return (_a = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.next) === null || _a === void 0 ? void 0 : _a.call(progressSubscriber_1, e);
            });
        });
        if (includeDownloadProgress) [
            $7b33db13334c5267$var$LOADSTART,
            $7b33db13334c5267$var$PROGRESS
        ].forEach(function(type) {
            return addProgressEvent_1(xhr, type, $7b33db13334c5267$var$DOWNLOAD);
        });
        var emitError_1 = function(status) {
            var msg = 'ajax error' + (status ? ' ' + status : '');
            destination.error(new (0, $c0264afe82ac8e8f$export$9b8f4d0b97ba3d22)(msg, xhr, _request));
        };
        xhr.addEventListener('error', function(e) {
            var _a;
            (_a = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.error) === null || _a === void 0 || _a.call(progressSubscriber_1, e);
            emitError_1();
        });
        xhr.addEventListener($7b33db13334c5267$var$LOAD, function(event) {
            var _a, _b;
            var status = xhr.status;
            if (status < 400) {
                (_a = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.complete) === null || _a === void 0 || _a.call(progressSubscriber_1);
                var response = void 0;
                try {
                    response = createResponse_1($7b33db13334c5267$var$DOWNLOAD, event);
                } catch (err) {
                    destination.error(err);
                    return;
                }
                destination.next(response);
                destination.complete();
            } else {
                (_b = progressSubscriber_1 === null || progressSubscriber_1 === void 0 ? void 0 : progressSubscriber_1.error) === null || _b === void 0 || _b.call(progressSubscriber_1, event);
                emitError_1(status);
            }
        });
        var user = _request.user, method = _request.method, async = _request.async;
        if (user) xhr.open(method, url, async, user, _request.password);
        else xhr.open(method, url, async);
        if (async) {
            xhr.timeout = _request.timeout;
            xhr.responseType = _request.responseType;
        }
        if ('withCredentials' in xhr) xhr.withCredentials = _request.withCredentials;
        for(var key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
        if (body) xhr.send(body);
        else xhr.send();
        return function() {
            if (xhr && xhr.readyState !== 4) xhr.abort();
        };
    });
}
function $7b33db13334c5267$var$extractContentTypeAndMaybeSerializeBody(body, headers) {
    var _a;
    if (!body || typeof body === 'string' || $7b33db13334c5267$var$isFormData(body) || $7b33db13334c5267$var$isURLSearchParams(body) || $7b33db13334c5267$var$isArrayBuffer(body) || $7b33db13334c5267$var$isFile(body) || $7b33db13334c5267$var$isBlob(body) || $7b33db13334c5267$var$isReadableStream(body)) return body;
    if ($7b33db13334c5267$var$isArrayBufferView(body)) return body.buffer;
    if (typeof body === 'object') {
        headers['content-type'] = (_a = headers['content-type']) !== null && _a !== void 0 ? _a : 'application/json;charset=utf-8';
        return JSON.stringify(body);
    }
    throw new TypeError('Unknown body type');
}
var $7b33db13334c5267$var$_toString = Object.prototype.toString;
function $7b33db13334c5267$var$toStringCheck(obj, name) {
    return $7b33db13334c5267$var$_toString.call(obj) === "[object " + name + "]";
}
function $7b33db13334c5267$var$isArrayBuffer(body) {
    return $7b33db13334c5267$var$toStringCheck(body, 'ArrayBuffer');
}
function $7b33db13334c5267$var$isFile(body) {
    return $7b33db13334c5267$var$toStringCheck(body, 'File');
}
function $7b33db13334c5267$var$isBlob(body) {
    return $7b33db13334c5267$var$toStringCheck(body, 'Blob');
}
function $7b33db13334c5267$var$isArrayBufferView(body) {
    return typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView(body);
}
function $7b33db13334c5267$var$isFormData(body) {
    return typeof FormData !== 'undefined' && body instanceof FormData;
}
function $7b33db13334c5267$var$isURLSearchParams(body) {
    return typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams;
}
function $7b33db13334c5267$var$isReadableStream(body) {
    return typeof ReadableStream !== 'undefined' && body instanceof ReadableStream;
}



var $03772b57bf8fdb3b$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};



function $4f60165fcef00ba6$export$4369c812aac99591(value) {
    return (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $96f7773b783c9f21$export$48c0cddbc99c45c2(input) {
    return (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(input[0, $498e303932b309b8$export$5ab46cbf6120b33a]);
}



function $82a7c70334b7c77c$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $99b176c784fbda4d$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $98b93c93b5db8914$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $98b93c93b5db8914$export$6f58e2338da23f4d = $98b93c93b5db8914$export$aa9956be4ae4fe8();



function $70a6fdb2be501aaa$export$9652023d9040757(input) {
    return (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $98b93c93b5db8914$export$6f58e2338da23f4d]);
}




function $b997519b6b3549b5$export$cf4785e597badab3(readableStream) {
    return (0, $0a1028487aeaf648$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $0a1028487aeaf648$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $0a1028487aeaf648$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $0a1028487aeaf648$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $0a1028487aeaf648$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $b997519b6b3549b5$export$c088ffafdba7405f(obj) {
    return (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $131f7cd4fa02ebf2$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $740e586f832a8cc1$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $96f7773b783c9f21$export$48c0cddbc99c45c2)(input)) return $131f7cd4fa02ebf2$export$aa3d41784b3267fa(input);
        if ((0, $03772b57bf8fdb3b$export$1e2f57719e155213)(input)) return $131f7cd4fa02ebf2$export$4cb2acdbcda2c253(input);
        if ((0, $4f60165fcef00ba6$export$4369c812aac99591)(input)) return $131f7cd4fa02ebf2$export$60f45028237c39d1(input);
        if ((0, $82a7c70334b7c77c$export$edb10ab8dd75a915)(input)) return $131f7cd4fa02ebf2$export$e073fccf36d78cc1(input);
        if ((0, $70a6fdb2be501aaa$export$9652023d9040757)(input)) return $131f7cd4fa02ebf2$export$dcccc29c315dd646(input);
        if ((0, $b997519b6b3549b5$export$c088ffafdba7405f)(input)) return $131f7cd4fa02ebf2$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $99b176c784fbda4d$export$7cbe71b9fa263484)(input);
}
function $131f7cd4fa02ebf2$export$aa3d41784b3267fa(obj) {
    return new (0, $740e586f832a8cc1$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $498e303932b309b8$export$5ab46cbf6120b33a]();
        if ((0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $131f7cd4fa02ebf2$export$4cb2acdbcda2c253(array) {
    return new (0, $740e586f832a8cc1$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $131f7cd4fa02ebf2$export$60f45028237c39d1(promise) {
    return new (0, $740e586f832a8cc1$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $13e97c50aff41092$export$ebf645db02d3e99f));
    });
}
function $131f7cd4fa02ebf2$export$dcccc29c315dd646(iterable) {
    return new (0, $740e586f832a8cc1$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $0a1028487aeaf648$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $131f7cd4fa02ebf2$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $740e586f832a8cc1$export$77cea355fa80b5f4)(function(subscriber) {
        $131f7cd4fa02ebf2$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $131f7cd4fa02ebf2$export$b2dcb11d46e7a4ad(readableStream) {
    return $131f7cd4fa02ebf2$export$e073fccf36d78cc1((0, $b997519b6b3549b5$export$cf4785e597badab3)(readableStream));
}
function $131f7cd4fa02ebf2$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $0a1028487aeaf648$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $0a1028487aeaf648$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $0a1028487aeaf648$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}




function $c0453aca714b961e$export$3dede90624df3ba9(selector) {
    return (0, $21b07b18132f6843$export$871731df685d7753)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $8febb15b9386dd49$export$b9e075132cc6937f)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $131f7cd4fa02ebf2$export$6a9cfa3ebc765910)(selector(err, $c0453aca714b961e$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}



function $6e358b6d321aa71f$export$187e35932e88c15c(value) {
    return value && (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(value.schedule);
}


function $cb19296d9182d2f8$var$last(arr) {
    return arr[arr.length - 1];
}
function $cb19296d9182d2f8$export$9ae19b645239a61b(args) {
    return (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)($cb19296d9182d2f8$var$last(args)) ? args.pop() : undefined;
}
function $cb19296d9182d2f8$export$29534b2f653ae592(args) {
    return (0, $6e358b6d321aa71f$export$187e35932e88c15c)($cb19296d9182d2f8$var$last(args)) ? args.pop() : undefined;
}
function $cb19296d9182d2f8$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $cb19296d9182d2f8$var$last(args) === 'number' ? args.pop() : defaultValue;
}



function $ab76b6091d47a664$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}




function $7ce4dfaef96265a6$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $21b07b18132f6843$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $8febb15b9386dd49$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $ab76b6091d47a664$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $ab76b6091d47a664$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $ab76b6091d47a664$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $c0033f2a2644e16a$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $21b07b18132f6843$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $9b9655cb8ec9612b$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $131f7cd4fa02ebf2$export$6a9cfa3ebc765910)(input).pipe((0, $c0033f2a2644e16a$export$1eb44d8f5f64733b)(scheduler), (0, $7ce4dfaef96265a6$export$9007f49c319d1ac7)(scheduler));
}





function $3b48d39304c32269$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $131f7cd4fa02ebf2$export$6a9cfa3ebc765910)(input).pipe((0, $c0033f2a2644e16a$export$1eb44d8f5f64733b)(scheduler), (0, $7ce4dfaef96265a6$export$9007f49c319d1ac7)(scheduler));
}



function $273eb5c0fc104015$export$b34673931371729a(input, scheduler) {
    return new (0, $740e586f832a8cc1$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $29ef6f2dfe1c909d$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $740e586f832a8cc1$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $ab76b6091d47a664$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $98b93c93b5db8914$export$6f58e2338da23f4d]();
            (0, $ab76b6091d47a664$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $22a990e5c1c1874d$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $982ff06769fedd36$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $740e586f832a8cc1$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $ab76b6091d47a664$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $ab76b6091d47a664$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $afc96af280117f9e$export$3385251aeecad28a(input, scheduler) {
    return (0, $982ff06769fedd36$export$7c7f0979b56a32f3)((0, $b997519b6b3549b5$export$cf4785e597badab3)(input), scheduler);
}


function $2a8718073b5a9209$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $96f7773b783c9f21$export$48c0cddbc99c45c2)(input)) return (0, $9b9655cb8ec9612b$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $03772b57bf8fdb3b$export$1e2f57719e155213)(input)) return (0, $273eb5c0fc104015$export$b34673931371729a)(input, scheduler);
        if ((0, $4f60165fcef00ba6$export$4369c812aac99591)(input)) return (0, $3b48d39304c32269$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $82a7c70334b7c77c$export$edb10ab8dd75a915)(input)) return (0, $982ff06769fedd36$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $70a6fdb2be501aaa$export$9652023d9040757)(input)) return (0, $29ef6f2dfe1c909d$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $b997519b6b3549b5$export$c088ffafdba7405f)(input)) return (0, $afc96af280117f9e$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $99b176c784fbda4d$export$7cbe71b9fa263484)(input);
}



function $f51a6e794adcbcb2$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $2a8718073b5a9209$export$49c44dfc2bb21d70)(input, scheduler) : (0, $131f7cd4fa02ebf2$export$6a9cfa3ebc765910)(input);
}


function $4d0783ed64cf8e2e$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $cb19296d9182d2f8$export$29534b2f653ae592)(args);
    return (0, $f51a6e794adcbcb2$export$6788812c4e6611e6)(args, scheduler);
}


const $9d2f4b6cee8552d1$var$method = 'POST';
const $9d2f4b6cee8552d1$var$submitEnquiryData = (setShowForm, body)=>{
    let url = `https://beta-gcio-server.growcloud.io/enquiry`;
    return (0, $7b33db13334c5267$export$e68fce4c5f453854)({
        url: url,
        body: body,
        method: $9d2f4b6cee8552d1$var$method
    }).pipe((0, $f14fe9f7d11a851c$export$871de8747c9eaa88)((data)=>data.response), (0, $c0453aca714b961e$export$3dede90624df3ba9)((error)=>{
        console.error('Error occurred:', error);
        return (0, $4d0783ed64cf8e2e$export$ba255e9e49e00608)({
            error: true,
            message: error.message
        });
    })).subscribe({
        next: (data)=>{
            console.log('Success:', data);
            setShowForm(false);
        },
        error: (err)=>{
            setShowForm(false);
        }
    });
};
const $9d2f4b6cee8552d1$export$4587ee39172d8fd8 = ({})=>{
    const [showForm, setShowForm] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(true);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
            direction: "column",
            sx: (0, $c510ec29b95de388$export$c4b8bfc316bde018)('center', 'center'),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                    variant: "h3",
                    children: "BETA PROGRAM"
                }),
                showForm ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                            variant: "h6",
                            children: "APPLY"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9164e243b49b1f60$export$2297eb3c52fa27fe), {
                            onSubmit: (data)=>{
                                $9d2f4b6cee8552d1$var$submitEnquiryData(setShowForm, data);
                            }
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                        variant: "h6",
                        children: "APPLICATION SUBMITTED."
                    })
                })
            ]
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




const $f8f32296ffbb9607$export$355f3d6a1f8b250c = ({})=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
            direction: "column",
            sx: (0, $c510ec29b95de388$export$c4b8bfc316bde018)('center', 'center'),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                    variant: "h4",
                    children: "COMING SOON Q4 2026"
                })
            })
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");

var $acw62 = parcelRequire("acw62");
function $0b1bbe1f030bca5a$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/react/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}





const $cdf0c2f14a677e05$var$styled = (0, $feef0a6b75fad08f$export$2e2bcd8739ae039)();
var $cdf0c2f14a677e05$export$2e2bcd8739ae039 = $cdf0c2f14a677e05$var$styled;



function $c5854e13ca0540db$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $e7144867d0b2336e$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}




var $acw62 = parcelRequire("acw62");

var $ivxDX = parcelRequire("ivxDX");
'use client';
function $9af3737653185c65$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $9af3737653185c65$var$useThemeWithoutDefault(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $ivxDX.ThemeContext));
    return !contextTheme || $9af3737653185c65$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $9af3737653185c65$export$2e2bcd8739ae039 = $9af3737653185c65$var$useThemeWithoutDefault;


'use client';
const $f01961c5ea058a3f$export$35e57303dbd8a66 = (0, $26ee599f1d3ba50c$export$2e2bcd8739ae039)();
function $f01961c5ea058a3f$var$useTheme(defaultTheme = $f01961c5ea058a3f$export$35e57303dbd8a66) {
    return (0, $9af3737653185c65$export$2e2bcd8739ae039)(defaultTheme);
}
var $f01961c5ea058a3f$export$2e2bcd8739ae039 = $f01961c5ea058a3f$var$useTheme;


'use client';
function $28287a8a1b654061$export$2e2bcd8739ae039(params) {
    const { props: props, name: name, defaultTheme: defaultTheme, themeId: themeId } = params;
    let theme = (0, $f01961c5ea058a3f$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $c5854e13ca0540db$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}




const $5310003fb8957dd8$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $5310003fb8957dd8$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $5310003fb8957dd8$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $041075fc956eb9d7$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $041075fc956eb9d7$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $041075fc956eb9d7$var$selfColumnsVar = '--Grid-columns';
const $041075fc956eb9d7$var$parentColumnsVar = '--Grid-parent-columns';
const $041075fc956eb9d7$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $5310003fb8957dd8$export$e04173f1577f18b7)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$041075fc956eb9d7$var$parentColumnsVar}) - (var(${$041075fc956eb9d7$var$parentColumnsVar}) - ${value}) * (var(${$041075fc956eb9d7$var$getParentSpacingVar('column')}) / var(${$041075fc956eb9d7$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $041075fc956eb9d7$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $5310003fb8957dd8$export$e04173f1577f18b7)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$041075fc956eb9d7$var$parentColumnsVar}) + var(${$041075fc956eb9d7$var$getParentSpacingVar('column')}) * ${value} / var(${$041075fc956eb9d7$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $041075fc956eb9d7$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$041075fc956eb9d7$var$selfColumnsVar]: 12
    };
    (0, $5310003fb8957dd8$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$041075fc956eb9d7$var$selfColumnsVar]: columns,
            '> *': {
                [$041075fc956eb9d7$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $041075fc956eb9d7$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $5310003fb8957dd8$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$041075fc956eb9d7$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$041075fc956eb9d7$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $041075fc956eb9d7$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $5310003fb8957dd8$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$041075fc956eb9d7$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$041075fc956eb9d7$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $041075fc956eb9d7$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $5310003fb8957dd8$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $041075fc956eb9d7$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$041075fc956eb9d7$var$getSelfSpacingVar('row')}) var(${$041075fc956eb9d7$var$getSelfSpacingVar('column')})`
        }
    };
};
const $041075fc956eb9d7$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $041075fc956eb9d7$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $041075fc956eb9d7$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $f906f0630c95a0e9$var$defaultTheme = (0, $26ee599f1d3ba50c$export$2e2bcd8739ae039)();
// widening Theme to any so that the consumer can own the theme structure.
const $f906f0630c95a0e9$var$defaultCreateStyledComponent = (0, $cdf0c2f14a677e05$export$2e2bcd8739ae039)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $f906f0630c95a0e9$var$useThemePropsDefault(props) {
    return (0, $28287a8a1b654061$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $f906f0630c95a0e9$var$defaultTheme
    });
}
function $f906f0630c95a0e9$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $f906f0630c95a0e9$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $f906f0630c95a0e9$var$useThemePropsDefault, useTheme: useTheme = (0, $f01961c5ea058a3f$export$2e2bcd8739ae039), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $041075fc956eb9d7$export$a7c8efbe2b138a60)(direction),
                ...(0, $041075fc956eb9d7$export$e2d1175061442d38)(size),
                ...container ? (0, $041075fc956eb9d7$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (slot)=>(0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $041075fc956eb9d7$export$ccc4d4a4923f1b06), (0, $041075fc956eb9d7$export$a89c28919b8e3bb5), (0, $041075fc956eb9d7$export$68c4dad72dd49c74), (0, $041075fc956eb9d7$export$84053369756c53db), (0, $041075fc956eb9d7$export$2a0a3c01032b3f4), (0, $041075fc956eb9d7$export$810b8c3ab5d46bf), (0, $041075fc956eb9d7$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = themeProps;
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $i6kju.default)(classes.root, className),
            ...other,
            children: $acw62.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $acw62.isValidElement(child) && (0, $0b1bbe1f030bca5a$export$2e2bcd8739ae039)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $acw62.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-expect-error internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}






'use client';
/**
 *
 * Demos:
 *
 * - [Grid](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/material-ui/api/grid/)
 */ const $cf344b876c417b98$var$Grid = (0, $f906f0630c95a0e9$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('div', {
        name: 'MuiGrid',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid',
    useThemeProps: (inProps)=>(0, $6a1de905cde5d0a2$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiGrid'
        }),
    useTheme: $4aedf03183da9f32$export$2e2bcd8739ae039
});
var $cf344b876c417b98$export$2e2bcd8739ae039 = $cf344b876c417b98$var$Grid;



var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");






function $24b29e1f6c853c9e$export$46f01d01378ec5a2(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiDivider', slot);
}
const $24b29e1f6c853c9e$var$dividerClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'vertical',
    'withChildren',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $24b29e1f6c853c9e$export$2e2bcd8739ae039 = $24b29e1f6c853c9e$var$dividerClasses;



var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $31b2908bb422c88a$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (0, $24b29e1f6c853c9e$export$46f01d01378ec5a2), classes);
};
const $31b2908bb422c88a$var$DividerRoot = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $31b2908bb422c88a$var$DividerWrapper = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $31b2908bb422c88a$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $31b2908bb422c88a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $ayMG0.jsx)($31b2908bb422c88a$var$DividerRoot, {
        as: component,
        className: (0, $i6kju.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $ayMG0.jsx)($31b2908bb422c88a$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
var $31b2908bb422c88a$export$2e2bcd8739ae039 = $31b2908bb422c88a$var$Divider;


const $e9fc554386f9949d$var$styles = (theme)=>({
        root: {
            paddingTop: 16,
            paddingBottom: 16,
            marginTop: theme.spacing(3)
        },
        heroMargin: {
            marginBottom: theme.spacing(3),
            [theme.breakpoints.up('sm')]: {
                marginBottom: theme.spacing(7)
            }
        },
        gutterBottom: {
            marginBottom: '0.35em'
        },
        gutterBottomExtra: {
            marginBottom: theme.spacing(3)
        },
        pageHeader: {
            transition: 'padding 0.2s ease',
            paddingTop: '1em',
            [theme.breakpoints.up('md')]: {
                paddingTop: '3em'
            }
        }
    });
class $e9fc554386f9949d$export$597fb9c89e6eff97 extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    render() {
        const { classes: classes = {}, Alignment: Alignment, heroTitle: heroTitle, PageIcon: PageIcon = null, PageTitle: PageTitle, TitleColor: TitleColor, TitleVariant: TitleVariant, TitleComponent: TitleComponent, SubHeader: SubHeader, heroMargin: heroMargin, hasDivider: hasDivider, PageHeader: PageHeader, width: width } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf344b876c417b98$export$2e2bcd8739ae039), {
            container: true,
            spacing: 0,
            className: PageHeader ? classes.pageHeader : null
        }, typeof PageTitle === "string" ? width === 'xs' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf344b876c417b98$export$2e2bcd8739ae039), {
            size: {
                xs: 12
            }
        }, PageIcon && PageIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
            color: TitleColor || `inherit`,
            variant: TitleVariant ? TitleVariant : `h3`,
            component: TitleComponent ? TitleComponent : `h3`,
            align: Alignment || 'center',
            classes: {
                gutterBottom: heroTitle ? classes.heroMargin : classes.gutterBottom
            }
        }, PageTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf344b876c417b98$export$2e2bcd8739ae039), {
            size: {
                xs: 12
            }
        }, PageIcon && PageIcon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
            color: TitleColor || `inherit`,
            variant: TitleVariant ? TitleVariant : `h2`,
            component: TitleComponent ? TitleComponent : `h2`,
            align: Alignment || 'center',
            gutterBottom: SubHeader ? true : true,
            classes: {
                gutterBottom: heroTitle ? classes.heroMargin : classes.gutterBottom
            }
        }, PageTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf344b876c417b98$export$2e2bcd8739ae039), null, PageTitle), SubHeader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $cf344b876c417b98$export$2e2bcd8739ae039), {
            size: {
                xs: 12
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
            color: "textPrimary",
            classes: {
                gutterBottom: classes.gutterBottomExtra
            },
            variant: 'h6',
            component: "p",
            align: Alignment || 'center',
            gutterBottom: true
        }, SubHeader)), hasDivider && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $31b2908bb422c88a$export$2e2bcd8739ae039), {
            light: true,
            variant: "fullWidth",
            className: heroMargin ? classes.heroMargin : null
        }));
    }
}



const $2c0387b5cd1be7f6$var$measureValuesObject = `
message MeasureValue {
  string uuid = 1;
  ace.id.Urn activity = 2;
  ace.id.Urn measurement = 3;
  float value = 4;
  uint64 timestamp = 5;
  string subject = 6;
}`;
const $2c0387b5cd1be7f6$var$measureValuesService = `
service MeasureValuesApiService {
  rpc connect(stream gc.ace.v1.api.MeasureValue) 
    returns (MeasureValuesSubmitResponse) {}
  rpc currentMeasureValues(CurrentMeasureValuesRequest) 
    returns (stream gc.ace.v1.api.MeasureValue) {}
  rpc currentMeasureValue(CurrentMeasureValueRequest) 
    returns (gc.ace.v1.api.MeasureValue) {}
}
`;
const $2c0387b5cd1be7f6$var$ApiTemplate = ({ objects: objects, services: services })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "OBJECTS"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                children: objects[0]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "SERVICES"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("pre", {
                children: services[0]
            })
        ]
    });
};
const $2c0387b5cd1be7f6$export$899561a4757d638 = ({})=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9fc554386f9949d$export$597fb9c89e6eff97), {
                PageTitle: 'API',
                SubHeader: '',
                Alignment: "left"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "AlarmsV1"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($2c0387b5cd1be7f6$var$ApiTemplate, {
                objects: [
                    $2c0387b5cd1be7f6$var$measureValuesObject
                ],
                services: [
                    $2c0387b5cd1be7f6$var$measureValuesService
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "CalculatedValuesV1 [beta]"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: "CalculationsV1 [beta]"
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $dadbf373a348bffa$export$a70f33076c1d4cb1 = ({})=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9fc554386f9949d$export$597fb9c89e6eff97), {
            PageTitle: 'FAQ',
            SubHeader: '',
            Alignment: "left"
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");




const $7a785b8ecb0b8563$var$renderFeaturesData = (featuresData)=>{
    let itemsArray = [];
    for (let featureData of featuresData)itemsArray.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a44e1c415735d9e7$export$b2bf97138f6c7782), {
            featureData: featureData
        })
    }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()));
    return itemsArray;
};
const $7a785b8ecb0b8563$export$e2b8eb038115bae6 = ({ featuresData: featuresData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: $7a785b8ecb0b8563$var$renderFeaturesData(featuresData)
    });
};



const $5afc0da00e3c99de$export$380fe8d73daa55ae = ({})=>{
    const featuresData = (0, $a2ced1963f2020ac$export$3970600e50b6f58f)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9fc554386f9949d$export$597fb9c89e6eff97), {
                PageTitle: 'FEATURES',
                SubHeader: '',
                Alignment: "left"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7a785b8ecb0b8563$export$e2b8eb038115bae6), {
                featuresData: featuresData
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");



const $5257e734597501af$var$markdown = '# Hi, *Pluto*!';
const $5257e734597501af$export$20deecc858a672b4 = ({})=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9fc554386f9949d$export$597fb9c89e6eff97), {
            PageTitle: 'HOW IT WORKS',
            SubHeader: '',
            Alignment: "left"
        })
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");









var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");






const $0a77145e617a08a3$export$808699e39cb6e5d7 = ({ caseStudyData: caseStudyData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
                direction: 'row',
                sx: (0, $c8306bda4a3fa63f$export$71e0dd387ebc2bb9)(),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce6d037a019f746e$export$2e2bcd8739ae039), {
                        style: {
                            color: 'gold'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abce12fca512444b$export$2e2bcd8739ae039), {
                        variant: 'h4',
                        color: "textSecondary",
                        children: caseStudyData.label
                    })
                ]
            }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
                direction: 'row',
                sx: (0, $c8306bda4a3fa63f$export$71e0dd387ebc2bb9)(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5ad4a2534b055b5$export$bd36621ef7814117), {
                    buttonColor: "primary",
                    buttonText: 'OPEN',
                    onClick: ()=>{
                        window.location.href = `/case-study/${caseStudyData.slug}`;
                    }
                })
            }, (0, $abf1bd3d30df503c$export$79a1817568da084b)())
        ]
    }, (0, $abf1bd3d30df503c$export$79a1817568da084b)());
};
const $0a77145e617a08a3$var$renderItems = (items)=>{
    let itemsArray = [];
    for (let item of items)itemsArray.push(/*#__PURE__*/ (0, $ayMG0.jsx)($0a77145e617a08a3$export$808699e39cb6e5d7, {
        caseStudyData: item
    }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()));
    return itemsArray;
};
const $0a77145e617a08a3$var$CaseStudiesGroup = ({ caseStudyData: caseStudyData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
                direction: 'row',
                sx: (0, $c8306bda4a3fa63f$export$71e0dd387ebc2bb9)(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $abce12fca512444b$export$2e2bcd8739ae039), {
                    variant: 'h3',
                    color: "textSecondary",
                    children: caseStudyData.label
                })
            }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()),
            caseStudyData.items && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: $0a77145e617a08a3$var$renderItems(caseStudyData.items)
            })
        ]
    }, (0, $abf1bd3d30df503c$export$79a1817568da084b)());
};
const $0a77145e617a08a3$var$renderCaseStudies = (caseStudiesData)=>{
    let itemsArray = [];
    for (let caseStudyData of caseStudiesData)itemsArray.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b4c02b4ad9e6ac1d$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)($0a77145e617a08a3$var$CaseStudiesGroup, {
            caseStudyData: caseStudyData
        })
    }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()));
    return itemsArray;
};
const $0a77145e617a08a3$export$e51a725f0174775 = ({ caseStudiesData: caseStudiesData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: $0a77145e617a08a3$var$renderCaseStudies(caseStudiesData)
    });
};


const $3e7bb3a8f4b444c6$var$caseStudiesData = (0, $a2ced1963f2020ac$export$23b487c0ab1b5bbf)();
const $3e7bb3a8f4b444c6$var$resourcesData = (0, $a2ced1963f2020ac$export$9b13459b7e2ecabb)();
const $3e7bb3a8f4b444c6$var$extractResources = (product, type)=>{
    let resourcesArray = [];
    for (let resourceData of $3e7bb3a8f4b444c6$var$resourcesData)if (resourceData.product === product && resourceData.type === type) resourcesArray.push(resourceData);
    return resourcesArray;
};
const $3e7bb3a8f4b444c6$export$d2b7ba0752976eb2 = ({ resourceData: resourceData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'row',
                sx: (0, $c8306bda4a3fa63f$export$71e0dd387ebc2bb9)(),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ce6d037a019f746e$export$2e2bcd8739ae039), {
                        style: {
                            color: 'gold'
                        }
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                        variant: 'h4',
                        color: "textSecondary",
                        children: resourceData.label
                    })
                ]
            }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'row',
                sx: (0, $c8306bda4a3fa63f$export$71e0dd387ebc2bb9)(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $245879af6017e1c1$export$bd36621ef7814117), {
                    buttonColor: "primary",
                    buttonText: 'OPEN',
                    onClick: ()=>{
                        window.location.href = `/resource/${resourceData.slug}`;
                    }
                })
            }, (0, $abf1bd3d30df503c$export$79a1817568da084b)())
        ]
    }, (0, $abf1bd3d30df503c$export$79a1817568da084b)());
};
const $3e7bb3a8f4b444c6$var$renderItems = (items)=>{
    let itemsArray = [];
    for (let item of items)itemsArray.push(/*#__PURE__*/ (0, $ayMG0.jsx)($3e7bb3a8f4b444c6$export$d2b7ba0752976eb2, {
        resourceData: item
    }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()));
    return itemsArray;
};
const $3e7bb3a8f4b444c6$var$ResourcesGroup = ({ header: header, resourcesGroupData: resourcesGroupData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'row',
                sx: (0, $c8306bda4a3fa63f$export$71e0dd387ebc2bb9)(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                    variant: 'h3',
                    color: "textSecondary",
                    children: header
                })
            }, (0, $abf1bd3d30df503c$export$79a1817568da084b)()),
            resourcesGroupData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: $3e7bb3a8f4b444c6$var$renderItems(resourcesGroupData)
            })
        ]
    }, (0, $abf1bd3d30df503c$export$79a1817568da084b)());
};
const $3e7bb3a8f4b444c6$export$e270668981af0dbc = ({})=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9fc554386f9949d$export$597fb9c89e6eff97), {
                PageTitle: 'RESOURCES',
                SubHeader: '',
                Alignment: "left"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'column',
                sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($3e7bb3a8f4b444c6$var$ResourcesGroup, {
                    header: 'GC GUIDES',
                    resourcesGroupData: $3e7bb3a8f4b444c6$var$extractResources('AUTO', 'GUIDE')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'column',
                sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($3e7bb3a8f4b444c6$var$ResourcesGroup, {
                    header: 'VENDORS GUIDES',
                    resourcesGroupData: $3e7bb3a8f4b444c6$var$extractResources('VENDORS', 'GUIDE')
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                direction: 'column',
                sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0a77145e617a08a3$export$e51a725f0174775), {
                    caseStudiesData: $3e7bb3a8f4b444c6$var$caseStudiesData
                })
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $2d1502f8edad7993$export$5c7782886f34fe27 = (props)=>{
    const { fillColor: fillColor, classes: classes, ...other } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("svg", {
        width: "74",
        height: "88",
        viewBox: "0 0 74 88",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("rect", {
                width: "74",
                height: "88",
                fill: "#0DFFC5"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("path", {
                d: "M30.6133 29.4434H18.2383V37.8223H32.7617V43H11.793V11.7188H32.7188V16.9395H18.2383V24.3945H30.6133V29.4434ZM11.793 74V42.7188H21.418C24.168 42.7188 26.6243 43.3418 28.7871 44.5879C30.9642 45.8197 32.6615 47.5814 33.8789 49.873C35.0964 52.1504 35.7051 54.7428 35.7051 57.6504V59.0898C35.7051 61.9974 35.1035 64.5827 33.9004 66.8457C32.7116 69.1087 31.0286 70.8633 28.8516 72.1094C26.6745 73.3555 24.2181 73.9857 21.4824 74H11.793ZM18.2383 47.9395V68.8223H21.3535C23.8743 68.8223 25.8008 67.9987 27.1328 66.3516C28.4648 64.7044 29.1452 62.3483 29.1738 59.2832V57.6289C29.1738 54.4492 28.515 52.043 27.1973 50.4102C25.8796 48.763 23.9531 47.9395 21.418 47.9395H18.2383ZM49.6309 65.793C49.6309 64.5755 49.2012 63.6445 48.3418 63C47.4824 62.3411 45.9355 61.6536 43.7012 60.9375C41.4668 60.207 39.6979 59.4909 38.3945 58.7891C34.8424 56.8698 33.0664 54.2845 33.0664 51.0332C33.0664 49.3431 33.5391 47.8392 34.4844 46.5215C35.444 45.1895 36.8118 44.151 38.5879 43.4062C40.3783 42.6615 42.3835 42.2891 44.6035 42.2891C46.8379 42.2891 48.8288 42.6973 50.5762 43.5137C52.3236 44.3158 53.6771 45.4544 54.6367 46.9297C55.6107 48.4049 56.0977 50.0807 56.0977 51.957H49.6523C49.6523 50.5247 49.2012 49.4147 48.2988 48.627C47.3965 47.8249 46.1289 47.4238 44.4961 47.4238C42.9206 47.4238 41.696 47.7604 40.8223 48.4336C39.9486 49.0924 39.5117 49.9661 39.5117 51.0547C39.5117 52.0716 40.0202 52.9238 41.0371 53.6113C42.0684 54.2988 43.5794 54.9434 45.5703 55.5449C49.237 56.6478 51.9082 58.0156 53.584 59.6484C55.2598 61.2812 56.0977 63.3151 56.0977 65.75C56.0977 68.457 55.0736 70.584 53.0254 72.1309C50.9772 73.6634 48.2201 74.4297 44.7539 74.4297C42.3477 74.4297 40.1562 73.9928 38.1797 73.1191C36.2031 72.2311 34.6921 71.0208 33.6465 69.4883C32.6152 67.9557 32.0996 66.1797 32.0996 64.1602H38.5664C38.5664 67.612 40.6289 69.3379 44.7539 69.3379C46.2865 69.3379 47.4824 69.0299 48.3418 68.4141C49.2012 67.7839 49.6309 66.9102 49.6309 65.793ZM53.3945 70.9492C53.3945 69.9609 53.724 69.1589 54.3828 68.543C55.056 67.9271 55.8939 67.6191 56.8965 67.6191C57.9134 67.6191 58.7513 67.9271 59.4102 68.543C60.0833 69.1589 60.4199 69.9609 60.4199 70.9492C60.4199 71.9232 60.0905 72.7181 59.4316 73.334C58.7728 73.9355 57.9277 74.2363 56.8965 74.2363C55.8796 74.2363 55.0417 73.9355 54.3828 73.334C53.724 72.7181 53.3945 71.9232 53.3945 70.9492Z",
                fill: "black"
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");


var $i6kju = parcelRequire("i6kju");


var $acw62 = parcelRequire("acw62");
function $bfa5fe0396ce4ff7$export$2e2bcd8739ae039(children) {
    return $acw62.Children.toArray(children).filter((child)=>/*#__PURE__*/ $acw62.isValidElement(child));
}









function $53bb4e1af8b5fdc4$export$b85c003f960b1f3a(slot) {
    return (0, $93a6cb9d9dc4fcae$export$2e2bcd8739ae039)('MuiButtonGroup', slot);
}
const $53bb4e1af8b5fdc4$var$buttonGroupClasses = (0, $606a27dd08e5ad31$export$2e2bcd8739ae039)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'lastButton',
    'middleButton'
]);
var $53bb4e1af8b5fdc4$export$2e2bcd8739ae039 = $53bb4e1af8b5fdc4$var$buttonGroupClasses;






var $ayMG0 = parcelRequire("ayMG0");
'use client';
const $7bf29618d54a9d8c$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $7bf29618d54a9d8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $fe52caa321ac20cd$export$2e2bcd8739ae039)(color)}`
        ],
        grouped: [
            'grouped',
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $a49246e4766729ca$export$2e2bcd8739ae039)(slots, (0, $53bb4e1af8b5fdc4$export$b85c003f960b1f3a), classes);
};
const $7bf29618d54a9d8c$var$ButtonGroupRoot = (0, $8a4cdf55065ef950$export$2e2bcd8739ae039)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $7bf29618d54a9d8c$var$overridesResolver
})((0, $359bea9585b24b02$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        ...theme.focusVisible && {
            // paint the focused item above its siblings so they cannot cover the ring edges
            [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).grouped}.${(0, $9f2781520c4821f2$export$2e2bcd8739ae039).focusVisible}`]: {
                zIndex: 1
            }
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2],
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).grouped}`]: {
                        boxShadow: 'none',
                        '&:hover': {
                            boxShadow: 'none'
                        }
                    },
                    ...theme.focusVisible && {
                        [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).grouped}.${(0, $9f2781520c4821f2$export$2e2bcd8739ae039).focusVisible}`]: {
                            boxShadow: theme.focusVisible.boxShadow
                        }
                    }
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).lastButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).lastButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                                borderColor: theme.alpha((theme.vars || theme).palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRightColor: 'transparent',
                        '@media (hover: hover)': {
                            '&:hover': {
                                borderRightColor: 'currentColor'
                            }
                        }
                    },
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).lastButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '@media (hover: hover)': {
                            '&:hover': {
                                borderBottomColor: 'currentColor'
                            }
                        }
                    },
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).lastButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $43b8298ed30115c6$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).firstButton},& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $53bb4e1af8b5fdc4$export$2e2bcd8739ae039).grouped}`]: {
            minWidth: 40
        }
    })));
const $7bf29618d54a9d8c$var$ButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $6a1de905cde5d0a2$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $7bf29618d54a9d8c$var$useUtilityClasses(ownerState);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: props.disableFocusRipple,
            disableRipple: props.disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        props.disableFocusRipple,
        props.disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $bfa5fe0396ce4ff7$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)($7bf29618d54a9d8c$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $i6kju.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2fbab2f8273d2029$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9ead1992620b63d6$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $7bf29618d54a9d8c$export$2e2bcd8739ae039 = $7bf29618d54a9d8c$var$ButtonGroup;




const $a31679a40b638f7e$export$23951d3cc1b7e0b = (WrappedComponent)=>{
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
        constructor(props){
            super(props);
        }
        render() {
            const { cards: cards = [] } = this.props;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)(WrappedComponent, {
                    ...this.props
                })
            });
        }
    };
};
const $a31679a40b638f7e$export$2fe555cd35024d39 = (WrappedComponent)=>{
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
        constructor(props){
            super(props);
        }
        render() {
            const { cards: cards = [] } = this.props;
            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                        direction: 'row',
                        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(null, 'center', 'center'),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d1502f8edad7993$export$5c7782886f34fe27), {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7bf29618d54a9d8c$export$2e2bcd8739ae039), {
                                size: "large",
                                "aria-label": "Large button group",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            window.location.href = '/';
                                        },
                                        children: "HOME"
                                    }, "home"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            window.location.href = '/how-it-works';
                                        },
                                        children: "HOW IT WORKS"
                                    }, "intgration"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            window.location.href = '/features';
                                        },
                                        children: "FEATURES"
                                    }, "features"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            window.location.href = '/api';
                                        },
                                        children: "API"
                                    }, "api"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            window.location.href = '/faq';
                                        },
                                        children: "FAQ"
                                    }, "faq"),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $56ded5750d61b4b0$export$2e2bcd8739ae039), {
                                        onClick: ()=>{
                                            window.location.href = '/resources';
                                        },
                                        children: "RESOURCES"
                                    }, "resources")
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
                        direction: 'row',
                        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(null, 'right', 'center'),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $245879af6017e1c1$export$bd36621ef7814117), {
                            buttonColor: "primary",
                            buttonText: 'LOGIN',
                            onClick: ()=>{
                                window.location.href = `https://beta-id.growcloud.io/signup`;
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(WrappedComponent, {
                        ...this.props
                    })
                ]
            });
        }
    };
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");






const $24ee7f85bcb03b4b$var$CaseStudyTemplate = ({ problem: problem, strategy: strategy })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                    variant: 'h4',
                    color: "textSecondary",
                    children: 'PROBLEM'
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                    variant: 'subtitle1',
                    color: "textSecondary",
                    children: problem
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                    variant: 'h4',
                    color: "textSecondary",
                    children: 'STRATEGY'
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                    variant: 'subtitle1',
                    color: "textSecondary",
                    children: strategy
                })
            })
        ]
    });
};
const $24ee7f85bcb03b4b$var$getCaseStudyData = (caseStudiesData, slug)=>{
    for (let caseStudyData of caseStudiesData)for (let caseStudyItem of caseStudyData.items){
        if (caseStudyItem.slug === slug) return caseStudyItem;
    }
    return null;
};
const $24ee7f85bcb03b4b$export$edc0f16064b2428f = ({})=>{
    const urlComponents = window.location.href.split('/');
    const slug = urlComponents[urlComponents.length - 1];
    const caseStudiesData = (0, $a2ced1963f2020ac$export$23b487c0ab1b5bbf)();
    const caseStudyData = $24ee7f85bcb03b4b$var$getCaseStudyData(caseStudiesData, slug);
    const caseStudy = {
        problem: 'Problem statement',
        strategy: 'Strategy statement',
        ...caseStudyData
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9fc554386f9949d$export$597fb9c89e6eff97), {
                PageTitle: caseStudyData.label,
                SubHeader: '',
                Alignment: "left"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($24ee7f85bcb03b4b$var$CaseStudyTemplate, {
                problem: caseStudy.problem,
                strategy: caseStudy.strategy
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");






const $d738e3ed87384c59$var$ResourceTemplate = ({ resourceData: resourceData })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                    variant: 'h4',
                    color: "textSecondary",
                    children: resourceData.type
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88bb330b17b77b73$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d85e9257157a3b9$export$2e2bcd8739ae039), {
                    variant: 'h4',
                    color: "textSecondary",
                    children: resourceData.product
                })
            })
        ]
    });
};
const $d738e3ed87384c59$var$getResourceData = (resourcesData, slug)=>{
    for (let resourceData of resourcesData){
        if (resourceData.slug === slug) return resourceData;
    }
    return null;
};
const $d738e3ed87384c59$export$4fcdb0e4857755b7 = ({})=>{
    const urlComponents = window.location.href.split('/');
    const slug = urlComponents[urlComponents.length - 1];
    const resourcesData = (0, $a2ced1963f2020ac$export$9b13459b7e2ecabb)();
    const resourceData = $d738e3ed87384c59$var$getResourceData(resourcesData, slug);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $86a57fab7595a253$export$2e2bcd8739ae039), {
        direction: 'column',
        sx: (0, $c8306bda4a3fa63f$export$ed759d95987e262a)(),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9fc554386f9949d$export$597fb9c89e6eff97), {
                PageTitle: resourceData.label,
                SubHeader: '',
                Alignment: "left"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)($d738e3ed87384c59$var$ResourceTemplate, {
                resourceData: resourceData
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");
"use client";
const $38e2e4dba3e7e5d8$export$b16d9fb1a22de840 = (0, $acw62.createContext)(null), $38e2e4dba3e7e5d8$var$c = {
    didCatch: !1,
    error: null
};
class $38e2e4dba3e7e5d8$export$e926676385687eaf extends (0, $acw62.Component) {
    constructor(e){
        super(e), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = $38e2e4dba3e7e5d8$var$c;
    }
    static getDerivedStateFromError(e) {
        return {
            didCatch: !0,
            error: e
        };
    }
    resetErrorBoundary(...e) {
        const { error: t } = this.state;
        t !== null && (this.props.onReset?.({
            args: e,
            reason: "imperative-api"
        }), this.setState($38e2e4dba3e7e5d8$var$c));
    }
    componentDidCatch(e, t) {
        this.props.onError?.(e, t);
    }
    componentDidUpdate(e, t) {
        const { didCatch: o } = this.state, { resetKeys: s } = this.props;
        o && t.error !== null && $38e2e4dba3e7e5d8$var$C(e.resetKeys, s) && (this.props.onReset?.({
            next: s,
            prev: e.resetKeys,
            reason: "keys"
        }), this.setState($38e2e4dba3e7e5d8$var$c));
    }
    render() {
        const { children: e, fallbackRender: t, FallbackComponent: o, fallback: s } = this.props, { didCatch: n, error: a } = this.state;
        let i = e;
        if (n) {
            const u = {
                error: a,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof t == "function") i = t(u);
            else if (o) i = (0, $acw62.createElement)(o, u);
            else if (s !== void 0) i = s;
            else throw a;
        }
        return (0, $acw62.createElement)($38e2e4dba3e7e5d8$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: n,
                error: a,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, i);
    }
}
function $38e2e4dba3e7e5d8$var$C(r = [], e = []) {
    return r.length !== e.length || r.some((t, o)=>!Object.is(t, e[o]));
}
function $38e2e4dba3e7e5d8$var$g(r) {
    return r !== null && typeof r == "object" && "didCatch" in r && typeof r.didCatch == "boolean" && "error" in r && "resetErrorBoundary" in r && typeof r.resetErrorBoundary == "function";
}
function $38e2e4dba3e7e5d8$var$x(r) {
    if (!$38e2e4dba3e7e5d8$var$g(r)) throw new Error("ErrorBoundaryContext not found");
}
function $38e2e4dba3e7e5d8$export$c052f6604b7d51fe() {
    const r = (0, $acw62.useContext)($38e2e4dba3e7e5d8$export$b16d9fb1a22de840);
    $38e2e4dba3e7e5d8$var$x(r);
    const { error: e, resetErrorBoundary: t } = r, [o, s] = (0, $acw62.useState)({
        error: null,
        hasError: !1
    }), n = (0, $acw62.useMemo)(()=>({
            error: e,
            resetBoundary: ()=>{
                t(), s({
                    error: null,
                    hasError: !1
                });
            },
            showBoundary: (a)=>s({
                    error: a,
                    hasError: !0
                })
        }), [
        e,
        t
    ]);
    if (o.hasError) throw o.error;
    return n;
}
function $38e2e4dba3e7e5d8$export$82f46aa4e6535a45(r) {
    switch(typeof r){
        case "object":
            if (r !== null && "message" in r && typeof r.message == "string") return r.message;
            break;
        case "string":
            return r;
    }
}
function $38e2e4dba3e7e5d8$export$f0c7a449e0cfaec7(r, e) {
    const t = (0, $acw62.forwardRef)((s, n)=>(0, $acw62.createElement)($38e2e4dba3e7e5d8$export$e926676385687eaf, e, (0, $acw62.createElement)(r, {
            ...s,
            ref: n
        }))), o = r.displayName || r.name || "Unknown";
    return t.displayName = `withErrorBoundary(${o})`, t;
}


var $84130c31a3f49bb6$exports = {};
"use strict";

var $1jnue = parcelRequire("1jnue");
var $84130c31a3f49bb6$require$_interopRequireDefault = $1jnue.default;
Object.defineProperty($84130c31a3f49bb6$exports, "__esModule", {
    value: true
});
Object.defineProperty($84130c31a3f49bb6$exports, "default", {
    enumerable: true,
    get: function() {
        return $84130c31a3f49bb6$var$_CssBaseline.default;
    }
});

var $84130c31a3f49bb6$var$_CssBaseline = $84130c31a3f49bb6$require$_interopRequireDefault((parcelRequire("gODrq")));


const $ea911e121052aee2$var$WithedLandingPage = (0, $a31679a40b638f7e$export$23951d3cc1b7e0b)((0, $f8f32296ffbb9607$export$355f3d6a1f8b250c));
const $ea911e121052aee2$var$WithedEnquiryPage = (0, $a31679a40b638f7e$export$23951d3cc1b7e0b)((0, $9d2f4b6cee8552d1$export$4587ee39172d8fd8));
const $ea911e121052aee2$var$WithedFrontPage = (0, $a31679a40b638f7e$export$2fe555cd35024d39)((0, $9e9fedce756d888e$export$b5f68eb8cbd40cd5));
const $ea911e121052aee2$var$WithedApiPage = (0, $a31679a40b638f7e$export$2fe555cd35024d39)((0, $2c0387b5cd1be7f6$export$899561a4757d638));
const $ea911e121052aee2$var$WithedFaqPage = (0, $a31679a40b638f7e$export$2fe555cd35024d39)((0, $dadbf373a348bffa$export$a70f33076c1d4cb1));
const $ea911e121052aee2$var$WithedFeaturesPage = (0, $a31679a40b638f7e$export$2fe555cd35024d39)((0, $5afc0da00e3c99de$export$380fe8d73daa55ae));
const $ea911e121052aee2$var$WithedHowItWorksPage = (0, $a31679a40b638f7e$export$2fe555cd35024d39)((0, $5257e734597501af$export$20deecc858a672b4));
const $ea911e121052aee2$var$WithedResourcesPage = (0, $a31679a40b638f7e$export$2fe555cd35024d39)((0, $3e7bb3a8f4b444c6$export$e270668981af0dbc));
const $ea911e121052aee2$var$WithedCaseStudyPage = (0, $a31679a40b638f7e$export$2fe555cd35024d39)((0, $24ee7f85bcb03b4b$export$edc0f16064b2428f));
const $ea911e121052aee2$var$WithedResourcePage = (0, $a31679a40b638f7e$export$2fe555cd35024d39)((0, $d738e3ed87384c59$export$4fcdb0e4857755b7));
const $ea911e121052aee2$var$theme = (0, $019ad789c5f8c324$exports.createTheme)({
    drawerWidth: {
        width: 240
    },
    typography: {
        fontFamily: 'Roboto,Arial'
    }
});
const $ea911e121052aee2$var$GlobalError = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: "OOPS"
    });
const $ea911e121052aee2$var$ErrorBoundaryLayout = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
        FallbackComponent: $ea911e121052aee2$var$GlobalError
    });
const $ea911e121052aee2$var$GcSite = ({ theme: theme, store: store })=>{
    if (!theme) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: "no theme"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $019ad789c5f8c324$exports.ThemeProvider), {
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($84130c31a3f49bb6$exports))), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5706f4e3d2f628b5$export$480518999dfc4151), {
                locale: 'en',
                messages: {},
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$Site, {})
            })
        ]
    });
};
const $ea911e121052aee2$var$Site = ({ theme: theme, store: store })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9d251f10c54460c1$export$b5d5cf8927ab7262), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedLandingPage, {})
                }, "/"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/beta",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedFrontPage, {})
                }, "/beta"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/enquiry",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedEnquiryPage, {})
                }, "/enquiry"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/features",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedFeaturesPage, {})
                }, "/features"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/api",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedApiPage, {})
                }, "/api"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/faq",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedFaqPage, {})
                }, "/faq"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/how-it-works",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedHowItWorksPage, {})
                }, "/how-it-works"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/resources",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedResourcesPage, {})
                }, "/resources"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/case-study/:caseStudySlug",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedCaseStudyPage, {})
                }, "/case-study"),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9d251f10c54460c1$export$e7b0ac011bb776c6), {
                    path: "/resource/:resourceSlug",
                    children: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$WithedResourcePage, {})
                }, "/resource")
            ]
        })
    });
};
(0, $7e96a608cb33bf79$exports.createRoot)(document.getElementById('root')).render(/*#__PURE__*/ (0, $ayMG0.jsx)($ea911e121052aee2$var$GcSite, {
    theme: $ea911e121052aee2$var$theme
}));


//# sourceMappingURL=gcio-site.6a572519.js.map
